var Gh = Object.defineProperty;
var qh = (e, n, t) => n in e ? Gh(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var se = (e, n, t) => (qh(e, typeof n != "symbol" ? n + "" : n, t), t);
import * as b from "react";
import A, { createElement as le, isValidElement as Kn, Fragment as Us, cloneElement as Ws, Children as $n, createContext as Rt, useContext as ze, useState as K, useRef as ie, useEffect as W, useCallback as cn, useMemo as Et, useReducer as e0, useLayoutEffect as Wo, useInsertionEffect as t0, forwardRef as xe, useId as p1, Component as Qh, createRef as Xh, useImperativeHandle as Jh } from "react";
import { createRoot as e5 } from "react-dom/client";
import { jsx as g, jsxs as P, Fragment as Zo } from "react/jsx-runtime";
import * as t5 from "react-dom";
import n0, { flushSync as r0, findDOMNode as n5 } from "react-dom";
var ll = function(e, n) {
  return ll = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
  }, ll(e, n);
};
function Oi(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  ll(e, n);
  function t() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (t.prototype = n.prototype, new t());
}
var gn = function() {
  return gn = Object.assign || function(n) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, gn.apply(this, arguments);
};
function o0(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
}
function ul(e) {
  var n = typeof Symbol == "function" && Symbol.iterator, t = n && e[n], r = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function dl(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var r = t.call(e), o, s = [], a;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = r.next()).done; )
      s.push(o.value);
  } catch (i) {
    a = { error: i };
  } finally {
    try {
      o && !o.done && (t = r.return) && t.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return s;
}
function qa(e, n, t) {
  if (t || arguments.length === 2)
    for (var r = 0, o = n.length, s; r < o; r++)
      (s || !(r in n)) && (s || (s = Array.prototype.slice.call(n, 0, r)), s[r] = n[r]);
  return e.concat(s || Array.prototype.slice.call(n));
}
function Bn(e) {
  return typeof e == "function";
}
function s0(e) {
  var n = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, t = e(n);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var mc = s0(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(r, o) {
      return o + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function fl(e, n) {
  if (e) {
    var t = e.indexOf(n);
    0 <= t && e.splice(t, 1);
  }
}
var Ri = function() {
  function e(n) {
    this.initialTeardown = n, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var n, t, r, o, s;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var i = ul(a), c = i.next(); !c.done; c = i.next()) {
              var l = c.value;
              l.remove(this);
            }
          } catch (h) {
            n = { error: h };
          } finally {
            try {
              c && !c.done && (t = i.return) && t.call(i);
            } finally {
              if (n)
                throw n.error;
            }
          }
        else
          a.remove(this);
      var u = this.initialTeardown;
      if (Bn(u))
        try {
          u();
        } catch (h) {
          s = h instanceof mc ? h.errors : [h];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var f = ul(d), p = f.next(); !p.done; p = f.next()) {
            var m = p.value;
            try {
              Pu(m);
            } catch (h) {
              s = s ?? [], h instanceof mc ? s = qa(qa([], dl(s)), dl(h.errors)) : s.push(h);
            }
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            p && !p.done && (o = f.return) && o.call(f);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (s)
        throw new mc(s);
    }
  }, e.prototype.add = function(n) {
    var t;
    if (n && n !== this)
      if (this.closed)
        Pu(n);
      else {
        if (n instanceof e) {
          if (n.closed || n._hasParent(this))
            return;
          n._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(n);
      }
  }, e.prototype._hasParent = function(n) {
    var t = this._parentage;
    return t === n || Array.isArray(t) && t.includes(n);
  }, e.prototype._addParent = function(n) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(n), t) : t ? [t, n] : n;
  }, e.prototype._removeParent = function(n) {
    var t = this._parentage;
    t === n ? this._parentage = null : Array.isArray(t) && fl(t, n);
  }, e.prototype.remove = function(n) {
    var t = this._finalizers;
    t && fl(t, n), n instanceof e && n._removeParent(this);
  }, e.EMPTY = function() {
    var n = new e();
    return n.closed = !0, n;
  }(), e;
}(), a0 = Ri.EMPTY;
function i0(e) {
  return e instanceof Ri || e && "closed" in e && Bn(e.remove) && Bn(e.add) && Bn(e.unsubscribe);
}
function Pu(e) {
  Bn(e) ? e() : e.unsubscribe();
}
var c0 = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, l0 = {
  setTimeout: function(e, n) {
    for (var t = [], r = 2; r < arguments.length; r++)
      t[r - 2] = arguments[r];
    return setTimeout.apply(void 0, qa([e, n], dl(t)));
  },
  clearTimeout: function(e) {
    var n = l0.delegate;
    return ((n == null ? void 0 : n.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function r5(e) {
  l0.setTimeout(function() {
    throw e;
  });
}
function Ou() {
}
function Ta(e) {
  e();
}
var u0 = function(e) {
  Oi(n, e);
  function n(t) {
    var r = e.call(this) || this;
    return r.isStopped = !1, t ? (r.destination = t, i0(t) && t.add(r)) : r.destination = i5, r;
  }
  return n.create = function(t, r, o) {
    return new pl(t, r, o);
  }, n.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, n.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, n.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, n.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, n.prototype._next = function(t) {
    this.destination.next(t);
  }, n.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, n.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, n;
}(Ri), o5 = Function.prototype.bind;
function gc(e, n) {
  return o5.call(e, n);
}
var s5 = function() {
  function e(n) {
    this.partialObserver = n;
  }
  return e.prototype.next = function(n) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(n);
      } catch (r) {
        la(r);
      }
  }, e.prototype.error = function(n) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(n);
      } catch (r) {
        la(r);
      }
    else
      la(n);
  }, e.prototype.complete = function() {
    var n = this.partialObserver;
    if (n.complete)
      try {
        n.complete();
      } catch (t) {
        la(t);
      }
  }, e;
}(), pl = function(e) {
  Oi(n, e);
  function n(t, r, o) {
    var s = e.call(this) || this, a;
    if (Bn(t) || !t)
      a = {
        next: t ?? void 0,
        error: r ?? void 0,
        complete: o ?? void 0
      };
    else {
      var i;
      s && c0.useDeprecatedNextContext ? (i = Object.create(t), i.unsubscribe = function() {
        return s.unsubscribe();
      }, a = {
        next: t.next && gc(t.next, i),
        error: t.error && gc(t.error, i),
        complete: t.complete && gc(t.complete, i)
      }) : a = t;
    }
    return s.destination = new s5(a), s;
  }
  return n;
}(u0);
function la(e) {
  r5(e);
}
function a5(e) {
  throw e;
}
var i5 = {
  closed: !0,
  next: Ou,
  error: a5,
  complete: Ou
}, c5 = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function l5(e) {
  return e;
}
function u5(e) {
  return e.length === 0 ? l5 : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(r, o) {
      return o(r);
    }, t);
  };
}
var Ru = function() {
  function e(n) {
    n && (this._subscribe = n);
  }
  return e.prototype.lift = function(n) {
    var t = new e();
    return t.source = this, t.operator = n, t;
  }, e.prototype.subscribe = function(n, t, r) {
    var o = this, s = f5(n) ? n : new pl(n, t, r);
    return Ta(function() {
      var a = o, i = a.operator, c = a.source;
      s.add(i ? i.call(s, c) : c ? o._subscribe(s) : o._trySubscribe(s));
    }), s;
  }, e.prototype._trySubscribe = function(n) {
    try {
      return this._subscribe(n);
    } catch (t) {
      n.error(t);
    }
  }, e.prototype.forEach = function(n, t) {
    var r = this;
    return t = Iu(t), new t(function(o, s) {
      var a = new pl({
        next: function(i) {
          try {
            n(i);
          } catch (c) {
            s(c), a.unsubscribe();
          }
        },
        error: s,
        complete: o
      });
      r.subscribe(a);
    });
  }, e.prototype._subscribe = function(n) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(n);
  }, e.prototype[c5] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var n = [], t = 0; t < arguments.length; t++)
      n[t] = arguments[t];
    return u5(n)(this);
  }, e.prototype.toPromise = function(n) {
    var t = this;
    return n = Iu(n), new n(function(r, o) {
      var s;
      t.subscribe(function(a) {
        return s = a;
      }, function(a) {
        return o(a);
      }, function() {
        return r(s);
      });
    });
  }, e.create = function(n) {
    return new e(n);
  }, e;
}();
function Iu(e) {
  var n;
  return (n = e ?? c0.Promise) !== null && n !== void 0 ? n : Promise;
}
function d5(e) {
  return e && Bn(e.next) && Bn(e.error) && Bn(e.complete);
}
function f5(e) {
  return e && e instanceof u0 || d5(e) && i0(e);
}
var p5 = s0(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), h1 = function(e) {
  Oi(n, e);
  function n() {
    var t = e.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return n.prototype.lift = function(t) {
    var r = new Fu(this, this);
    return r.operator = t, r;
  }, n.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new p5();
  }, n.prototype.next = function(t) {
    var r = this;
    Ta(function() {
      var o, s;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var a = ul(r.currentObservers), i = a.next(); !i.done; i = a.next()) {
            var c = i.value;
            c.next(t);
          }
        } catch (l) {
          o = { error: l };
        } finally {
          try {
            i && !i.done && (s = a.return) && s.call(a);
          } finally {
            if (o)
              throw o.error;
          }
        }
      }
    });
  }, n.prototype.error = function(t) {
    var r = this;
    Ta(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = t;
        for (var o = r.observers; o.length; )
          o.shift().error(t);
      }
    });
  }, n.prototype.complete = function() {
    var t = this;
    Ta(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var r = t.observers; r.length; )
          r.shift().complete();
      }
    });
  }, n.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(n.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), n.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, t);
  }, n.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, n.prototype._innerSubscribe = function(t) {
    var r = this, o = this, s = o.hasError, a = o.isStopped, i = o.observers;
    return s || a ? a0 : (this.currentObservers = null, i.push(t), new Ri(function() {
      r.currentObservers = null, fl(i, t);
    }));
  }, n.prototype._checkFinalizedStatuses = function(t) {
    var r = this, o = r.hasError, s = r.thrownError, a = r.isStopped;
    o ? t.error(s) : a && t.complete();
  }, n.prototype.asObservable = function() {
    var t = new Ru();
    return t.source = this, t;
  }, n.create = function(t, r) {
    return new Fu(t, r);
  }, n;
}(Ru), Fu = function(e) {
  Oi(n, e);
  function n(t, r) {
    var o = e.call(this) || this;
    return o.destination = t, o.source = r, o;
  }
  return n.prototype.next = function(t) {
    var r, o;
    (o = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || o === void 0 || o.call(r, t);
  }, n.prototype.error = function(t) {
    var r, o;
    (o = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || o === void 0 || o.call(r, t);
  }, n.prototype.complete = function() {
    var t, r;
    (r = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || r === void 0 || r.call(t);
  }, n.prototype._subscribe = function(t) {
    var r, o;
    return (o = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t)) !== null && o !== void 0 ? o : a0;
  }, n;
}(h1);
let hl, ml = !1;
function h5(e) {
  hl = e;
}
function m5(e) {
  ml = e;
}
let Fn;
function _s(e, n) {
  if (!hl) {
    console.error("partnerId or caseId is missing");
    return;
  }
  Fn ?? (Fn = new h1()), Fn.next({
    caseId: hl,
    event: e,
    reason: n
  });
}
function jA(e) {
  return Fn ?? (Fn = new h1()), Fn == null ? void 0 : Fn.subscribe(e);
}
function YA() {
  Fn && (Fn.unsubscribe(), Fn = void 0);
}
function ht(e) {
  ml || (e || _s("abandon"), ml = !0, _s("exit"));
}
let d0, kn;
function g5(e) {
  d0 = e;
}
function y5(e) {
  kn = e;
}
var v5 = Object.defineProperty, b5 = (e, n, t) => n in e ? v5(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, ua = (e, n, t) => (b5(e, typeof n != "symbol" ? n + "" : n, t), t);
const C5 = {
  stringify: (e) => e,
  parse: (e) => e
}, w5 = {
  stringify: (e) => `${e}`,
  parse: (e) => parseFloat(e)
}, x5 = {
  stringify: (e) => e ? "true" : "false",
  parse: (e) => /^[ty1-9]/i.test(e)
}, D5 = {
  stringify: (e) => e.name,
  parse: (e, n) => {
    const t = (() => {
      if (typeof window < "u" && e in window)
        return window[e];
      if (typeof global < "u" && e in global)
        return global[e];
    })();
    return typeof t == "function" ? t.bind(n) : void 0;
  }
}, S5 = {
  stringify: (e) => JSON.stringify(e),
  parse: (e) => JSON.parse(e)
}, yc = {
  string: C5,
  number: w5,
  boolean: x5,
  function: D5,
  json: S5
}, vc = Symbol.for("r2wc.render"), da = Symbol.for("r2wc.connected"), Nr = Symbol.for("r2wc.context"), Jn = Symbol.for("r2wc.props");
function E5(e, n, t) {
  var r, o, s;
  n.props || (n.props = e.propTypes ? Object.keys(e.propTypes) : []);
  const a = (Array.isArray(n.props) ? n.props.slice() : Object.keys(n.props)).filter((d) => d !== "container"), i = {}, c = {}, l = {};
  for (const d of a) {
    i[d] = Array.isArray(n.props) ? "string" : n.props[d];
    const f = _5(d);
    c[d] = f, l[f] = d;
  }
  class u extends HTMLElement {
    constructor() {
      super(), ua(this, r, !0), ua(this, o), ua(this, s, {}), ua(this, "container"), n.shadow ? this.container = this.attachShadow({
        mode: n.shadow
      }) : this.container = this, this[Jn].container = this.container;
      for (const f of a) {
        const p = c[f], m = this.getAttribute(p), h = i[f], y = yc[h];
        m && y != null && y.parse && (this[Jn][f] = y.parse(m, this));
      }
    }
    static get observedAttributes() {
      return Object.keys(l);
    }
    connectedCallback() {
      this[da] = !0, this[vc]();
    }
    disconnectedCallback() {
      this[da] = !1, this[Nr] && t.unmount(this[Nr]), delete this[Nr];
    }
    attributeChangedCallback(f, p, m) {
      const h = l[f], y = i[h], C = yc[y];
      h in i && C != null && C.parse && (this[Jn][h] = C.parse(m, this), this[vc]());
    }
    [(r = da, o = Nr, s = Jn, vc)]() {
      this[da] && (this[Nr] ? t.update(this[Nr], this[Jn]) : this[Nr] = t.mount(
        this.container,
        e,
        this[Jn]
      ));
    }
  }
  for (const d of a) {
    const f = c[d], p = i[d];
    Object.defineProperty(u.prototype, d, {
      enumerable: !0,
      configurable: !0,
      get() {
        return this[Jn][d];
      },
      set(m) {
        this[Jn][d] = m;
        const h = yc[p];
        if (h != null && h.stringify) {
          const y = h.stringify(m);
          this.getAttribute(f) !== y && this.setAttribute(f, y);
        }
      }
    });
  }
  return u;
}
function _5(e = "") {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function M5(e, n, t) {
  const r = e5(e), o = A.createElement(n, t);
  return r.render(o), {
    root: r,
    ReactComponent: n
  };
}
function k5({ root: e, ReactComponent: n }, t) {
  const r = A.createElement(n, t);
  e.render(r);
}
function A5({ root: e }) {
  e.unmount();
}
function N5(e, n = {}) {
  return E5(e, n, { mount: M5, update: k5, unmount: A5 });
}
function f0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var L5 = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const T5 = /* @__PURE__ */ f0(L5);
var P5 = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Vu(e) {
  var n = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, t = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (t && (n.name = t[1], (T5[t[1]] || e.charAt(e.length - 2) === "/") && (n.voidElement = !0), n.name.startsWith("!--"))) {
    var r = e.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? e.slice(4, r) : "" };
  }
  for (var o = new RegExp(P5), s = null; (s = o.exec(e)) !== null; )
    if (s[0].trim())
      if (s[1]) {
        var a = s[1].trim(), i = [a, ""];
        a.indexOf("=") > -1 && (i = a.split("=")), n.attrs[i[0]] = i[1], o.lastIndex--;
      } else
        s[2] && (n.attrs[s[2]] = s[3].trim().substring(1, s[3].length - 1));
  return n;
}
var O5 = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, R5 = /^\s*$/, I5 = /* @__PURE__ */ Object.create(null);
function p0(e, n) {
  switch (n.type) {
    case "text":
      return e + n.content;
    case "tag":
      return e += "<" + n.name + (n.attrs ? function(t) {
        var r = [];
        for (var o in t)
          r.push(o + '="' + t[o] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(n.attrs) : "") + (n.voidElement ? "/>" : ">"), n.voidElement ? e : e + n.children.reduce(p0, "") + "</" + n.name + ">";
    case "comment":
      return e + "<!--" + n.comment + "-->";
  }
}
var F5 = { parse: function(e, n) {
  n || (n = {}), n.components || (n.components = I5);
  var t, r = [], o = [], s = -1, a = !1;
  if (e.indexOf("<") !== 0) {
    var i = e.indexOf("<");
    r.push({ type: "text", content: i === -1 ? e : e.substring(0, i) });
  }
  return e.replace(O5, function(c, l) {
    if (a) {
      if (c !== "</" + t.name + ">")
        return;
      a = !1;
    }
    var u, d = c.charAt(1) !== "/", f = c.startsWith("<!--"), p = l + c.length, m = e.charAt(p);
    if (f) {
      var h = Vu(c);
      return s < 0 ? (r.push(h), r) : ((u = o[s]).children.push(h), r);
    }
    if (d && (s++, (t = Vu(c)).type === "tag" && n.components[t.name] && (t.type = "component", a = !0), t.voidElement || a || !m || m === "<" || t.children.push({ type: "text", content: e.slice(p, e.indexOf("<", p)) }), s === 0 && r.push(t), (u = o[s - 1]) && u.children.push(t), o[s] = t), (!d || t.voidElement) && (s > -1 && (t.voidElement || t.name === c.slice(2, -1)) && (s--, t = s === -1 ? r : o[s]), !a && m !== "<" && m)) {
      u = s === -1 ? r : o[s].children;
      var y = e.indexOf("<", p), C = e.slice(p, y === -1 ? void 0 : y);
      R5.test(C) && (C = " "), (y > -1 && s + u.length >= 0 || C !== " ") && u.push({ type: "text", content: C });
    }
  }), r;
}, stringify: function(e) {
  return e.reduce(function(n, t) {
    return n + p0("", t);
  }, "");
} };
function Pa() {
  if (console && console.warn) {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    typeof n[0] == "string" && (n[0] = `react-i18next:: ${n[0]}`), console.warn(...n);
  }
}
const $u = {};
function Qa() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  typeof n[0] == "string" && $u[n[0]] || (typeof n[0] == "string" && ($u[n[0]] = /* @__PURE__ */ new Date()), Pa(...n));
}
const h0 = (e, n) => () => {
  if (e.isInitialized)
    n();
  else {
    const t = () => {
      setTimeout(() => {
        e.off("initialized", t);
      }, 0), n();
    };
    e.on("initialized", t);
  }
};
function Bu(e, n, t) {
  e.loadNamespaces(n, h0(e, t));
}
function ju(e, n, t, r) {
  typeof t == "string" && (t = [t]), t.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(n, h0(e, r));
}
function V5(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = n.languages[0], o = n.options ? n.options.fallbackLng : !1, s = n.languages[n.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const a = (i, c) => {
    const l = n.services.backendConnector.state[`${i}|${c}`];
    return l === -1 || l === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !a(n.isLanguageChangingTo, e) ? !1 : !!(n.hasResourceBundle(r, e) || !n.services.backendConnector.backend || n.options.resources && !n.options.partialBundledLanguages || a(r, e) && (!o || a(s, e)));
}
function $5(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !n.languages || !n.languages.length ? (Qa("i18n.languages were undefined or empty", n.languages), !0) : n.options.ignoreJSONStructure !== void 0 ? n.hasLoadedNamespace(e, {
    lng: t.lng,
    precheck: (o, s) => {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !s(o.isLanguageChangingTo, e))
        return !1;
    }
  }) : V5(e, n, t);
}
const B5 = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, j5 = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Y5 = (e) => j5[e], H5 = (e) => e.replace(B5, Y5);
let gl = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: H5
};
function U5() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  gl = {
    ...gl,
    ...e
  };
}
function m0() {
  return gl;
}
let g0;
function W5(e) {
  g0 = e;
}
function m1() {
  return g0;
}
function bc(e, n) {
  if (!e)
    return !1;
  const t = e.props ? e.props.children : e.children;
  return n ? t.length > 0 : !!t;
}
function Cc(e) {
  if (!e)
    return [];
  const n = e.props ? e.props.children : e.children;
  return e.props && e.props.i18nIsDynamicList ? Do(n) : n;
}
function Z5(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every((n) => Kn(n));
}
function Do(e) {
  return Array.isArray(e) ? e : [e];
}
function K5(e, n) {
  const t = {
    ...n
  };
  return t.props = Object.assign(e.props, n.props), t;
}
function y0(e, n) {
  if (!e)
    return "";
  let t = "";
  const r = Do(e), o = n.transSupportBasicHtmlNodes && n.transKeepBasicHtmlNodesFor ? n.transKeepBasicHtmlNodesFor : [];
  return r.forEach((s, a) => {
    if (typeof s == "string")
      t += `${s}`;
    else if (Kn(s)) {
      const i = Object.keys(s.props).length, c = o.indexOf(s.type) > -1, l = s.props.children;
      if (!l && c && i === 0)
        t += `<${s.type}/>`;
      else if (!l && (!c || i !== 0))
        t += `<${a}></${a}>`;
      else if (s.props.i18nIsDynamicList)
        t += `<${a}></${a}>`;
      else if (c && i === 1 && typeof l == "string")
        t += `<${s.type}>${l}</${s.type}>`;
      else {
        const u = y0(l, n);
        t += `<${a}>${u}</${a}>`;
      }
    } else if (s === null)
      Pa("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (typeof s == "object") {
      const {
        format: i,
        ...c
      } = s, l = Object.keys(c);
      if (l.length === 1) {
        const u = i ? `${l[0]}, ${i}` : l[0];
        t += `{{${u}}}`;
      } else
        Pa("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", s);
    } else
      Pa("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", s);
  }), t;
}
function z5(e, n, t, r, o, s) {
  if (n === "")
    return [];
  const a = r.transKeepBasicHtmlNodesFor || [], i = n && new RegExp(a.map((y) => `<${y}`).join("|")).test(n);
  if (!e && !i && !s)
    return [n];
  const c = {};
  function l(y) {
    Do(y).forEach((v) => {
      typeof v != "string" && (bc(v) ? l(Cc(v)) : typeof v == "object" && !Kn(v) && Object.assign(c, v));
    });
  }
  l(e);
  const u = F5.parse(`<0>${n}</0>`), d = {
    ...c,
    ...o
  };
  function f(y, C, v) {
    const w = Cc(y), x = m(w, C.children, v);
    return Z5(w) && x.length === 0 || y.props && y.props.i18nIsDynamicList ? w : x;
  }
  function p(y, C, v, w, x) {
    y.dummy ? (y.children = C, v.push(Ws(y, {
      key: w
    }, x ? void 0 : C))) : v.push(...$n.map([y], (D) => {
      const k = {
        ...D.props
      };
      return delete k.i18nIsDynamicList, le(D.type, {
        ...k,
        key: w,
        ref: D.ref
      }, x ? null : C);
    }));
  }
  function m(y, C, v) {
    const w = Do(y);
    return Do(C).reduce((D, k, _) => {
      const M = k.children && k.children[0] && k.children[0].content && t.services.interpolator.interpolate(k.children[0].content, d, t.language);
      if (k.type === "tag") {
        let T = w[parseInt(k.name, 10)];
        v.length === 1 && !T && (T = v[0][k.name]), T || (T = {});
        const N = Object.keys(k.attrs).length !== 0 ? K5({
          props: k.attrs
        }, T) : T, I = Kn(N), O = I && bc(k, !0) && !k.voidElement, $ = i && typeof N == "object" && N.dummy && !I, j = typeof e == "object" && e !== null && Object.hasOwnProperty.call(e, k.name);
        if (typeof N == "string") {
          const Y = t.services.interpolator.interpolate(N, d, t.language);
          D.push(Y);
        } else if (bc(N) || O) {
          const Y = f(N, k, v);
          p(N, Y, D, _);
        } else if ($) {
          const Y = m(w, k.children, v);
          p(N, Y, D, _);
        } else if (Number.isNaN(parseFloat(k.name)))
          if (j) {
            const Y = f(N, k, v);
            p(N, Y, D, _, k.voidElement);
          } else if (r.transSupportBasicHtmlNodes && a.indexOf(k.name) > -1)
            if (k.voidElement)
              D.push(le(k.name, {
                key: `${k.name}-${_}`
              }));
            else {
              const Y = m(w, k.children, v);
              D.push(le(k.name, {
                key: `${k.name}-${_}`
              }, Y));
            }
          else if (k.voidElement)
            D.push(`<${k.name} />`);
          else {
            const Y = m(w, k.children, v);
            D.push(`<${k.name}>${Y}</${k.name}>`);
          }
        else if (typeof N == "object" && !I) {
          const Y = k.children[0] ? M : null;
          Y && D.push(Y);
        } else
          p(N, M, D, _, k.children.length !== 1 || !M);
      } else if (k.type === "text") {
        const T = r.transWrapTextNodes, N = s ? r.unescape(t.services.interpolator.interpolate(k.content, d, t.language)) : t.services.interpolator.interpolate(k.content, d, t.language);
        T ? D.push(le(T, {
          key: `${k.name}-${_}`
        }, N)) : D.push(N);
      }
      return D;
    }, []);
  }
  const h = m([{
    dummy: !0,
    children: e || []
  }], u, Do(e || []));
  return Cc(h[0]);
}
function G5(e) {
  let {
    children: n,
    count: t,
    parent: r,
    i18nKey: o,
    context: s,
    tOptions: a = {},
    values: i,
    defaults: c,
    components: l,
    ns: u,
    i18n: d,
    t: f,
    shouldUnescape: p,
    ...m
  } = e;
  const h = d || m1();
  if (!h)
    return Qa("You will need to pass in an i18next instance by using i18nextReactModule"), n;
  const y = f || h.t.bind(h) || ((I) => I);
  a.context = s;
  const C = {
    ...m0(),
    ...h.options && h.options.react
  };
  let v = u || y.ns || h.options && h.options.defaultNS;
  v = typeof v == "string" ? [v] : v || ["translation"];
  const w = y0(n, C), x = c || w || C.transEmptyNodeValue || o, {
    hashTransKey: D
  } = C, k = o || (D ? D(w || x) : w || x);
  h.options && h.options.interpolation && h.options.interpolation.defaultVariables && (i = i && Object.keys(i).length > 0 ? {
    ...i,
    ...h.options.interpolation.defaultVariables
  } : {
    ...h.options.interpolation.defaultVariables
  });
  const _ = {
    ...a,
    count: t,
    ...i,
    defaultValue: x,
    ns: v
  }, M = k ? y(k, _) : x;
  l && Object.keys(l).forEach((I) => {
    const O = l[I];
    if (typeof O.type == "function" || !O.props || !O.props.children || M.indexOf(`${I}/>`) < 0 && M.indexOf(`${I} />`) < 0)
      return;
    function $() {
      return le(Us, null, O);
    }
    l[I] = le($);
  });
  const T = z5(l || n, M, h, C, _, p), N = r !== void 0 ? r : C.defaultTransParent;
  return N ? le(N, m, T) : T;
}
const q5 = {
  type: "3rdParty",
  init(e) {
    U5(e.options.react), W5(e);
  }
}, g1 = Rt();
class Q5 {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(n) {
    n.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function yl(e) {
  let {
    children: n,
    count: t,
    parent: r,
    i18nKey: o,
    context: s,
    tOptions: a = {},
    values: i,
    defaults: c,
    components: l,
    ns: u,
    i18n: d,
    t: f,
    shouldUnescape: p,
    ...m
  } = e;
  const {
    i18n: h,
    defaultNS: y
  } = ze(g1) || {}, C = d || h || m1(), v = f || C && C.t.bind(C);
  return G5({
    children: n,
    count: t,
    parent: r,
    i18nKey: o,
    context: s,
    tOptions: a,
    values: i,
    defaults: c,
    components: l,
    ns: u || v && v.ns || y || C && C.options && C.options.defaultNS,
    i18n: C,
    t: f,
    shouldUnescape: p,
    ...m
  });
}
const X5 = (e, n) => {
  const t = ie();
  return W(() => {
    t.current = n ? t.current : e;
  }, [e, n]), t.current;
};
function v0(e, n, t, r) {
  return e.getFixedT(n, t, r);
}
function J5(e, n, t, r) {
  return cn(v0(e, n, t, r), [e, n, t, r]);
}
function pe(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: t
  } = n, {
    i18n: r,
    defaultNS: o
  } = ze(g1) || {}, s = t || r || m1();
  if (s && !s.reportNamespaces && (s.reportNamespaces = new Q5()), !s) {
    Qa("You will need to pass in an i18next instance by using initReactI18next");
    const x = (k, _) => typeof _ == "string" ? _ : _ && typeof _ == "object" && typeof _.defaultValue == "string" ? _.defaultValue : Array.isArray(k) ? k[k.length - 1] : k, D = [x, {}, !1];
    return D.t = x, D.i18n = {}, D.ready = !1, D;
  }
  s.options.react && s.options.react.wait !== void 0 && Qa("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...m0(),
    ...s.options.react,
    ...n
  }, {
    useSuspense: i,
    keyPrefix: c
  } = a;
  let l = e || o || s.options && s.options.defaultNS;
  l = typeof l == "string" ? [l] : l || ["translation"], s.reportNamespaces.addUsedNamespaces && s.reportNamespaces.addUsedNamespaces(l);
  const u = (s.isInitialized || s.initializedStoreOnce) && l.every((x) => $5(x, s, a)), d = J5(s, n.lng || null, a.nsMode === "fallback" ? l : l[0], c), f = () => d, p = () => v0(s, n.lng || null, a.nsMode === "fallback" ? l : l[0], c), [m, h] = K(f);
  let y = l.join();
  n.lng && (y = `${n.lng}${y}`);
  const C = X5(y), v = ie(!0);
  W(() => {
    const {
      bindI18n: x,
      bindI18nStore: D
    } = a;
    v.current = !0, !u && !i && (n.lng ? ju(s, n.lng, l, () => {
      v.current && h(p);
    }) : Bu(s, l, () => {
      v.current && h(p);
    })), u && C && C !== y && v.current && h(p);
    function k() {
      v.current && h(p);
    }
    return x && s && s.on(x, k), D && s && s.store.on(D, k), () => {
      v.current = !1, x && s && x.split(" ").forEach((_) => s.off(_, k)), D && s && D.split(" ").forEach((_) => s.store.off(_, k));
    };
  }, [s, y]), W(() => {
    v.current && u && h(f);
  }, [s, c, u]);
  const w = [m, s, u];
  if (w.t = m, w.i18n = s, w.ready = u, u || !u && !i)
    return w;
  throw new Promise((x) => {
    n.lng ? ju(s, n.lng, l, () => x()) : Bu(s, l, () => x());
  });
}
function e4(e) {
  let {
    i18n: n,
    defaultNS: t,
    children: r
  } = e;
  const o = Et(() => ({
    i18n: n,
    defaultNS: t
  }), [n, t]);
  return le(g1.Provider, {
    value: o
  }, r);
}
const vl = ["splash", "entry", "company", "contact", "invoice", "transactions", "offer", "success"], t4 = ["company", "invoice", "transactions", "offer", "contact", "success"], n4 = ["EXACT"], b0 = ["EXACT"];
function r4(e, n) {
  switch (n.type) {
    case "add_bank_account": {
      const t = n.payload, r = t.bankName, o = t.accounts, {
        transactions: s
      } = e, {
        connections: a
      } = s, i = a.find(({
        bankName: c
      }) => c === r);
      return i ? o.forEach((c) => {
        const l = c.iban;
        i.accounts.some(({
          iban: d
        }) => d === l) || i.accounts.push(c);
      }) : a.push(t), {
        ...e,
        transactions: s
      };
    }
    case "add_invoice": {
      const t = n.payload, {
        invoices: r
      } = e, o = r.findIndex(({
        id: s
      }) => s === t.id);
      return r[o] ? r[o] = {
        ...r[o],
        ...t
      } : r.push(t), {
        ...e,
        invoices: r
      };
    }
    case "remove_invoice": {
      const {
        id: t
      } = n.payload, {
        invoices: r
      } = e, o = [...r.filter((s) => s.id !== t)];
      return {
        ...e,
        invoices: o
      };
    }
    case "set_case_id": {
      const t = n.payload;
      return {
        ...e,
        caseId: t
      };
    }
    case "set_campaign_id": {
      const t = n.payload;
      return {
        ...e,
        campaignId: t
      };
    }
    case "set_consent": {
      const {
        transactions: t
      } = e;
      return t.consent = !0, {
        ...e,
        transactions: t
      };
    }
    case "set_contact_is_added":
      return {
        ...e,
        contactIsAdded: !0
      };
    case "set_customer_id": {
      const t = n.payload;
      return {
        ...e,
        customerId: t
      };
    }
    case "set_flow_is_finished":
      return {
        ...e,
        flowFinished: !0
      };
    case "set_is_loading": {
      const {
        page: t,
        payload: r
      } = n, {
        loadingState: o
      } = e;
      return o[t] = r, {
        ...e,
        loadingState: o
      };
    }
    case "set_offers": {
      const t = n.payload;
      return {
        ...e,
        offers: t
      };
    }
    case "set_page": {
      const {
        activePage: t,
        requester: r,
        contactIsAdded: o
      } = e, s = t, {
        kvkNumber: a
      } = r, i = vl.filter((u) => u === "entry" && kn ? !b0.includes(kn) : u === "company" ? !a || t === "company" : u === "contact" ? !o : !0), c = {
        next: 1,
        prev: -1
      }, {
        payload: l
      } = n;
      if (l === "next" || l === "prev") {
        const u = c[l], d = Math.max(i.indexOf(t), 0), f = Math.min(Math.max(d + u, 0), i.length - 1), p = i[f];
        return p ? {
          ...e,
          activePage: p,
          previousPage: s
        } : e;
      }
      return {
        ...e,
        activePage: l,
        previousPage: s
      };
    }
    case "set_requester": {
      const t = n.payload, {
        requester: r
      } = e;
      return {
        ...e,
        requester: {
          ...r,
          ...t
        }
      };
    }
    case "set_selected_bank": {
      const t = n.payload;
      return {
        ...e,
        selectedBank: t
      };
    }
    case "set_selected_invoice": {
      const t = n.payload;
      return {
        ...e,
        selectedInvoice: t
      };
    }
    case "set_transactions_tab": {
      const t = n.payload;
      return {
        ...e,
        transactionsTab: t
      };
    }
    case "show_rejection": {
      const t = n.payload, {
        activePage: r
      } = e;
      return {
        ...e,
        activePage: "rejection",
        rejectionError: t,
        previousPage: r
      };
    }
    default:
      return e;
  }
}
const C0 = Rt(null);
function o4({
  children: e
}) {
  const n = {
    flowFinished: !1,
    loadingState: {
      automate_eligibility: !0,
      authentication: !0
    },
    offers: [],
    activePage: "splash",
    invoices: [],
    requester: {
      newToTheBank: !1
    },
    transactions: {
      consent: !1,
      connections: []
    }
  }, [t, r] = e0(r4, n), o = Et(() => ({
    state: t,
    actions: r
  }), [t]);
  return /* @__PURE__ */ g(C0.Provider, {
    value: o,
    children: e
  });
}
function ue() {
  const e = ze(C0);
  if (!e)
    throw new Error("useStoreContext must be used within a storeProvider");
  return e;
}
function s4(e) {
  W(() => {
    e.forEach((n) => {
      const t = document.createElement("link");
      t.href = n, t.rel = "stylesheet", document.head.appendChild(t);
    });
  }, []);
}
const w0 = Rt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), Ii = Rt({}), Fi = Rt(null), Vi = typeof document < "u", y1 = Vi ? Wo : W, x0 = Rt({ strict: !1 }), v1 = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), a4 = "framerAppearId", D0 = "data-" + v1(a4), S0 = {
  skipAnimations: !1,
  useManualTiming: !1
};
class Yu {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(n) {
    if (!this.scheduled.has(n))
      return this.scheduled.add(n), this.order.push(n), !0;
  }
  remove(n) {
    const t = this.order.indexOf(n);
    t !== -1 && (this.order.splice(t, 1), this.scheduled.delete(n));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function i4(e) {
  let n = new Yu(), t = new Yu(), r = 0, o = !1, s = !1;
  const a = /* @__PURE__ */ new WeakSet(), i = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, l = !1, u = !1) => {
      const d = u && o, f = d ? n : t;
      return l && a.add(c), f.add(c) && d && o && (r = n.order.length), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      t.remove(c), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o) {
        s = !0;
        return;
      }
      if (o = !0, [n, t] = [t, n], t.clear(), r = n.order.length, r)
        for (let l = 0; l < r; l++) {
          const u = n.order[l];
          a.has(u) && (i.schedule(u), e()), u(c);
        }
      o = !1, s && (s = !1, i.process(c));
    }
  };
  return i;
}
const fa = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], c4 = 40;
function E0(e, n) {
  let t = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = fa.reduce((d, f) => (d[f] = i4(() => t = !0), d), {}), a = (d) => {
    s[d].process(o);
  }, i = () => {
    const d = performance.now();
    t = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(d - o.timestamp, c4), 1), o.timestamp = d, o.isProcessing = !0, fa.forEach(a), o.isProcessing = !1, t && n && (r = !1, e(i));
  }, c = () => {
    t = !0, r = !0, o.isProcessing || e(i);
  };
  return { schedule: fa.reduce((d, f) => {
    const p = s[f];
    return d[f] = (m, h = !1, y = !1) => (t || c(), p.schedule(m, h, y)), d;
  }, {}), cancel: (d) => fa.forEach((f) => s[f].cancel(d)), state: o, steps: s };
}
const { schedule: b1, cancel: HA } = E0(queueMicrotask, !1);
function l4(e, n, t, r) {
  const { visualElement: o } = ze(Ii), s = ze(x0), a = ze(Fi), i = ze(w0).reducedMotion, c = ie();
  r = r || s.renderer, !c.current && r && (c.current = r(e, {
    visualState: n,
    parent: o,
    props: t,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: i
  }));
  const l = c.current;
  t0(() => {
    l && l.update(t, a);
  });
  const u = ie(!!(t[D0] && !window.HandoffComplete));
  return y1(() => {
    l && (b1.postRender(l.render), u.current && l.animationState && l.animationState.animateChanges());
  }), W(() => {
    l && (l.updateFeatures(), !u.current && l.animationState && l.animationState.animateChanges(), u.current && (u.current = !1, window.HandoffComplete = !0));
  }), l;
}
function So(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function u4(e, n, t) {
  return cn(
    (r) => {
      r && e.mount && e.mount(r), n && (r ? n.mount(r) : n.unmount()), t && (typeof t == "function" ? t(r) : So(t) && (t.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [n]
  );
}
function Ms(e) {
  return typeof e == "string" || Array.isArray(e);
}
function $i(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const C1 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], w1 = ["initial", ...C1];
function Bi(e) {
  return $i(e.animate) || w1.some((n) => Ms(e[n]));
}
function _0(e) {
  return !!(Bi(e) || e.variants);
}
function d4(e, n) {
  if (Bi(e)) {
    const { initial: t, animate: r } = e;
    return {
      initial: t === !1 || Ms(t) ? t : void 0,
      animate: Ms(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? n : {};
}
function f4(e) {
  const { initial: n, animate: t } = d4(e, ze(Ii));
  return Et(() => ({ initial: n, animate: t }), [Hu(n), Hu(t)]);
}
function Hu(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Uu = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, ks = {};
for (const e in Uu)
  ks[e] = {
    isEnabled: (n) => Uu[e].some((t) => !!n[t])
  };
function p4(e) {
  for (const n in e)
    ks[n] = {
      ...ks[n],
      ...e[n]
    };
}
const As = Rt({}), M0 = Rt({}), h4 = Symbol.for("motionComponentSymbol");
function m4({ preloadedFeatures: e, createVisualElement: n, useRender: t, useVisualState: r, Component: o }) {
  e && p4(e);
  function s(i, c) {
    let l;
    const u = {
      ...ze(w0),
      ...i,
      layoutId: g4(i)
    }, { isStatic: d } = u, f = f4(i), p = r(i, d);
    if (!d && Vi) {
      f.visualElement = l4(o, p, u, n);
      const m = ze(M0), h = ze(x0).strict;
      f.visualElement && (l = f.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        u,
        h,
        e,
        m
      ));
    }
    return b.createElement(
      Ii.Provider,
      { value: f },
      l && f.visualElement ? b.createElement(l, { visualElement: f.visualElement, ...u }) : null,
      t(o, i, u4(p, f.visualElement, c), p, d, f.visualElement)
    );
  }
  const a = xe(s);
  return a[h4] = o, a;
}
function g4({ layoutId: e }) {
  const n = ze(As).id;
  return n && e !== void 0 ? n + "-" + e : e;
}
function y4(e) {
  function n(r, o = {}) {
    return m4(e(r, o));
  }
  if (typeof Proxy > "u")
    return n;
  const t = /* @__PURE__ */ new Map();
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (t.has(o) || t.set(o, n(o)), t.get(o))
  });
}
const v4 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function x1(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(v4.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const Xa = {};
function b4(e) {
  Object.assign(Xa, e);
}
const Zs = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], to = new Set(Zs);
function k0(e, { layout: n, layoutId: t }) {
  return to.has(e) || e.startsWith("origin") || (n || t !== void 0) && (!!Xa[e] || e === "opacity");
}
const Bt = (e) => !!(e && e.getVelocity), C4 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, w4 = Zs.length;
function x4(e, { enableHardwareAcceleration: n = !0, allowTransformNone: t = !0 }, r, o) {
  let s = "";
  for (let a = 0; a < w4; a++) {
    const i = Zs[a];
    if (e[i] !== void 0) {
      const c = C4[i] || i;
      s += `${c}(${e[i]}) `;
    }
  }
  return n && !e.z && (s += "translateZ(0)"), s = s.trim(), o ? s = o(e, r ? "" : s) : t && r && (s = "none"), s;
}
const A0 = (e) => (n) => typeof n == "string" && n.startsWith(e), N0 = A0("--"), D4 = A0("var(--"), Ja = (e) => D4(e) ? S4.test(e.split("/*")[0].trim()) : !1, S4 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)$/i, E4 = (e, n) => n && typeof e == "number" ? n.transform(e) : e, yr = (e, n, t) => t > n ? n : t < e ? e : t, Ko = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ys = {
  ...Ko,
  transform: (e) => yr(0, 1, e)
}, pa = {
  ...Ko,
  default: 1
}, vs = (e) => Math.round(e * 1e5) / 1e5, D1 = /(-)?([\d]*\.?[\d])+/g, _4 = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, M4 = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Ks(e) {
  return typeof e == "string";
}
const zs = (e) => ({
  test: (n) => Ks(n) && n.endsWith(e) && n.split(" ").length === 1,
  parse: parseFloat,
  transform: (n) => `${n}${e}`
}), or = zs("deg"), Sn = zs("%"), ye = zs("px"), k4 = zs("vh"), A4 = zs("vw"), Wu = {
  ...Sn,
  parse: (e) => Sn.parse(e) / 100,
  transform: (e) => Sn.transform(e * 100)
}, Zu = {
  ...Ko,
  transform: Math.round
}, L0 = {
  // Border props
  borderWidth: ye,
  borderTopWidth: ye,
  borderRightWidth: ye,
  borderBottomWidth: ye,
  borderLeftWidth: ye,
  borderRadius: ye,
  radius: ye,
  borderTopLeftRadius: ye,
  borderTopRightRadius: ye,
  borderBottomRightRadius: ye,
  borderBottomLeftRadius: ye,
  // Positioning props
  width: ye,
  maxWidth: ye,
  height: ye,
  maxHeight: ye,
  size: ye,
  top: ye,
  right: ye,
  bottom: ye,
  left: ye,
  // Spacing props
  padding: ye,
  paddingTop: ye,
  paddingRight: ye,
  paddingBottom: ye,
  paddingLeft: ye,
  margin: ye,
  marginTop: ye,
  marginRight: ye,
  marginBottom: ye,
  marginLeft: ye,
  // Transform props
  rotate: or,
  rotateX: or,
  rotateY: or,
  rotateZ: or,
  scale: pa,
  scaleX: pa,
  scaleY: pa,
  scaleZ: pa,
  skew: or,
  skewX: or,
  skewY: or,
  distance: ye,
  translateX: ye,
  translateY: ye,
  translateZ: ye,
  x: ye,
  y: ye,
  z: ye,
  perspective: ye,
  transformPerspective: ye,
  opacity: ys,
  originX: Wu,
  originY: Wu,
  originZ: ye,
  // Misc
  zIndex: Zu,
  // SVG
  fillOpacity: ys,
  strokeOpacity: ys,
  numOctaves: Zu
};
function S1(e, n, t, r) {
  const { style: o, vars: s, transform: a, transformOrigin: i } = e;
  let c = !1, l = !1, u = !0;
  for (const d in n) {
    const f = n[d];
    if (N0(d)) {
      s[d] = f;
      continue;
    }
    const p = L0[d], m = E4(f, p);
    if (to.has(d)) {
      if (c = !0, a[d] = m, !u)
        continue;
      f !== (p.default || 0) && (u = !1);
    } else
      d.startsWith("origin") ? (l = !0, i[d] = m) : o[d] = m;
  }
  if (n.transform || (c || r ? o.transform = x4(e.transform, t, u, r) : o.transform && (o.transform = "none")), l) {
    const { originX: d = "50%", originY: f = "50%", originZ: p = 0 } = i;
    o.transformOrigin = `${d} ${f} ${p}`;
  }
}
const E1 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function T0(e, n, t) {
  for (const r in n)
    !Bt(n[r]) && !k0(r, t) && (e[r] = n[r]);
}
function N4({ transformTemplate: e }, n, t) {
  return Et(() => {
    const r = E1();
    return S1(r, n, { enableHardwareAcceleration: !t }, e), Object.assign({}, r.vars, r.style);
  }, [n]);
}
function L4(e, n, t) {
  const r = e.style || {}, o = {};
  return T0(o, r, e), Object.assign(o, N4(e, n, t)), o;
}
function T4(e, n, t) {
  const r = {}, o = L4(e, n, t);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const P4 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function ei(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || P4.has(e);
}
let P0 = (e) => !ei(e);
function O4(e) {
  e && (P0 = (n) => n.startsWith("on") ? !ei(n) : e(n));
}
try {
  O4(require("@emotion/is-prop-valid").default);
} catch {
}
function R4(e, n, t) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (P0(o) || t === !0 && ei(o) || !n && !ei(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function Ku(e, n, t) {
  return typeof e == "string" ? e : ye.transform(n + t * e);
}
function I4(e, n, t) {
  const r = Ku(n, e.x, e.width), o = Ku(t, e.y, e.height);
  return `${r} ${o}`;
}
const F4 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, V4 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function $4(e, n, t = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const s = o ? F4 : V4;
  e[s.offset] = ye.transform(-r);
  const a = ye.transform(n), i = ye.transform(t);
  e[s.array] = `${a} ${i}`;
}
function _1(e, {
  attrX: n,
  attrY: t,
  attrScale: r,
  originX: o,
  originY: s,
  pathLength: a,
  pathSpacing: i = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, u, d, f) {
  if (S1(e, l, u, f), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: m, dimensions: h } = e;
  p.transform && (h && (m.transform = p.transform), delete p.transform), h && (o !== void 0 || s !== void 0 || m.transform) && (m.transformOrigin = I4(h, o !== void 0 ? o : 0.5, s !== void 0 ? s : 0.5)), n !== void 0 && (p.x = n), t !== void 0 && (p.y = t), r !== void 0 && (p.scale = r), a !== void 0 && $4(p, a, i, c, !1);
}
const O0 = () => ({
  ...E1(),
  attrs: {}
}), M1 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function B4(e, n, t, r) {
  const o = Et(() => {
    const s = O0();
    return _1(s, n, { enableHardwareAcceleration: !1 }, M1(r), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [n]);
  if (e.style) {
    const s = {};
    T0(s, e.style, e), o.style = { ...s, ...o.style };
  }
  return o;
}
function j4(e = !1) {
  return (t, r, o, { latestValues: s }, a) => {
    const c = (x1(t) ? B4 : T4)(r, s, a, t), l = R4(r, typeof t == "string", e), u = t !== Us ? { ...l, ...c, ref: o } : {}, { children: d } = r, f = Et(() => Bt(d) ? d.get() : d, [d]);
    return le(t, {
      ...u,
      children: f
    });
  };
}
function R0(e, { style: n, vars: t }, r, o) {
  Object.assign(e.style, n, o && o.getProjectionStyles(r));
  for (const s in t)
    e.style.setProperty(s, t[s]);
}
const I0 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function F0(e, n, t, r) {
  R0(e, n, void 0, r);
  for (const o in n.attrs)
    e.setAttribute(I0.has(o) ? o : v1(o), n.attrs[o]);
}
function k1(e, n) {
  const { style: t } = e, r = {};
  for (const o in t)
    (Bt(t[o]) || n.style && Bt(n.style[o]) || k0(o, e)) && (r[o] = t[o]);
  return r;
}
function V0(e, n) {
  const t = k1(e, n);
  for (const r in e)
    if (Bt(e[r]) || Bt(n[r])) {
      const o = Zs.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      t[o] = e[r];
    }
  return t;
}
function A1(e, n, t, r = {}, o = {}) {
  return typeof n == "function" && (n = n(t !== void 0 ? t : e.custom, r, o)), typeof n == "string" && (n = e.variants && e.variants[n]), typeof n == "function" && (n = n(t !== void 0 ? t : e.custom, r, o)), n;
}
function $0(e) {
  const n = ie(null);
  return n.current === null && (n.current = e()), n.current;
}
const ti = (e) => Array.isArray(e), Y4 = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), H4 = (e) => ti(e) ? e[e.length - 1] || 0 : e;
function Oa(e) {
  const n = Bt(e) ? e.get() : e;
  return Y4(n) ? n.toValue() : n;
}
function U4({ scrapeMotionValuesFromProps: e, createRenderState: n, onMount: t }, r, o, s) {
  const a = {
    latestValues: W4(r, o, s, e),
    renderState: n()
  };
  return t && (a.mount = (i) => t(r, i, a)), a;
}
const B0 = (e) => (n, t) => {
  const r = ze(Ii), o = ze(Fi), s = () => U4(e, n, r, o);
  return t ? s() : $0(s);
};
function W4(e, n, t, r) {
  const o = {}, s = r(e, {});
  for (const f in s)
    o[f] = Oa(s[f]);
  let { initial: a, animate: i } = e;
  const c = Bi(e), l = _0(e);
  n && l && !c && e.inherit !== !1 && (a === void 0 && (a = n.initial), i === void 0 && (i = n.animate));
  let u = t ? t.initial === !1 : !1;
  u = u || a === !1;
  const d = u ? i : a;
  return d && typeof d != "boolean" && !$i(d) && (Array.isArray(d) ? d : [d]).forEach((p) => {
    const m = A1(e, p);
    if (!m)
      return;
    const { transitionEnd: h, transition: y, ...C } = m;
    for (const v in C) {
      let w = C[v];
      if (Array.isArray(w)) {
        const x = u ? w.length - 1 : 0;
        w = w[x];
      }
      w !== null && (o[v] = w);
    }
    for (const v in h)
      o[v] = h[v];
  }), o;
}
const ct = (e) => e, { schedule: Qe, cancel: zn, state: St, steps: wc } = E0(typeof requestAnimationFrame < "u" ? requestAnimationFrame : ct, !0), Z4 = {
  useVisualState: B0({
    scrapeMotionValuesFromProps: V0,
    createRenderState: O0,
    onMount: (e, n, { renderState: t, latestValues: r }) => {
      Qe.read(() => {
        try {
          t.dimensions = typeof n.getBBox == "function" ? n.getBBox() : n.getBoundingClientRect();
        } catch {
          t.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Qe.render(() => {
        _1(t, r, { enableHardwareAcceleration: !1 }, M1(n.tagName), e.transformTemplate), F0(n, t);
      });
    }
  })
}, K4 = {
  useVisualState: B0({
    scrapeMotionValuesFromProps: k1,
    createRenderState: E1
  })
};
function z4(e, { forwardMotionProps: n = !1 }, t, r) {
  return {
    ...x1(e) ? Z4 : K4,
    preloadedFeatures: t,
    useRender: j4(n),
    createVisualElement: r,
    Component: e
  };
}
function Vn(e, n, t, r = { passive: !0 }) {
  return e.addEventListener(n, t, r), () => e.removeEventListener(n, t);
}
const j0 = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function ji(e, n = "page") {
  return {
    point: {
      x: e[n + "X"],
      y: e[n + "Y"]
    }
  };
}
const G4 = (e) => (n) => j0(n) && e(n, ji(n));
function jn(e, n, t, r) {
  return Vn(e, n, G4(t), r);
}
const q4 = (e, n) => (t) => n(e(t)), Yn = (...e) => e.reduce(q4);
function Y0(e) {
  let n = null;
  return () => {
    const t = () => {
      n = null;
    };
    return n === null ? (n = e, t) : !1;
  };
}
const zu = Y0("dragHorizontal"), Gu = Y0("dragVertical");
function H0(e) {
  let n = !1;
  if (e === "y")
    n = Gu();
  else if (e === "x")
    n = zu();
  else {
    const t = zu(), r = Gu();
    t && r ? n = () => {
      t(), r();
    } : (t && t(), r && r());
  }
  return n;
}
function U0() {
  const e = H0(!0);
  return e ? (e(), !1) : !0;
}
class Dr {
  constructor(n) {
    this.isMounted = !1, this.node = n;
  }
  update() {
  }
}
function qu(e, n) {
  const t = "pointer" + (n ? "enter" : "leave"), r = "onHover" + (n ? "Start" : "End"), o = (s, a) => {
    if (s.pointerType === "touch" || U0())
      return;
    const i = e.getProps();
    e.animationState && i.whileHover && e.animationState.setActive("whileHover", n), i[r] && Qe.update(() => i[r](s, a));
  };
  return jn(e.current, t, o, {
    passive: !e.getProps()[r]
  });
}
class Q4 extends Dr {
  mount() {
    this.unmount = Yn(qu(this.node, !0), qu(this.node, !1));
  }
  unmount() {
  }
}
class X4 extends Dr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let n = !1;
    try {
      n = this.node.current.matches(":focus-visible");
    } catch {
      n = !0;
    }
    !n || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Yn(Vn(this.node.current, "focus", () => this.onFocus()), Vn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const W0 = (e, n) => n ? e === n ? !0 : W0(e, n.parentElement) : !1;
function xc(e, n) {
  if (!n)
    return;
  const t = new PointerEvent("pointer" + e);
  n(t, ji(t));
}
class J4 extends Dr {
  constructor() {
    super(...arguments), this.removeStartListeners = ct, this.removeEndListeners = ct, this.removeAccessibleListeners = ct, this.startPointerPress = (n, t) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), s = jn(window, "pointerup", (i, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: u, globalTapTarget: d } = this.node.getProps();
        Qe.update(() => {
          !d && !W0(this.node.current, i.target) ? u && u(i, c) : l && l(i, c);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), a = jn(window, "pointercancel", (i, c) => this.cancelPress(i, c), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = Yn(s, a), this.startPress(n, t);
    }, this.startAccessiblePress = () => {
      const n = (s) => {
        if (s.key !== "Enter" || this.isPressing)
          return;
        const a = (i) => {
          i.key !== "Enter" || !this.checkPressEnd() || xc("up", (c, l) => {
            const { onTap: u } = this.node.getProps();
            u && Qe.update(() => u(c, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Vn(this.node.current, "keyup", a), xc("down", (i, c) => {
          this.startPress(i, c);
        });
      }, t = Vn(this.node.current, "keydown", n), r = () => {
        this.isPressing && xc("cancel", (s, a) => this.cancelPress(s, a));
      }, o = Vn(this.node.current, "blur", r);
      this.removeAccessibleListeners = Yn(t, o);
    };
  }
  startPress(n, t) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Qe.update(() => r(n, t));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !U0();
  }
  cancelPress(n, t) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Qe.update(() => r(n, t));
  }
  mount() {
    const n = this.node.getProps(), t = jn(n.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(n.onTapStart || n.onPointerStart) }), r = Vn(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Yn(t, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const bl = /* @__PURE__ */ new WeakMap(), Dc = /* @__PURE__ */ new WeakMap(), e9 = (e) => {
  const n = bl.get(e.target);
  n && n(e);
}, t9 = (e) => {
  e.forEach(e9);
};
function n9({ root: e, ...n }) {
  const t = e || document;
  Dc.has(t) || Dc.set(t, {});
  const r = Dc.get(t), o = JSON.stringify(n);
  return r[o] || (r[o] = new IntersectionObserver(t9, { root: e, ...n })), r[o];
}
function r9(e, n, t) {
  const r = n9(n);
  return bl.set(e, t), r.observe(e), () => {
    bl.delete(e), r.unobserve(e);
  };
}
const o9 = {
  some: 0,
  all: 1
};
class s9 extends Dr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: n = {} } = this.node.getProps(), { root: t, margin: r, amount: o = "some", once: s } = n, a = {
      root: t ? t.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : o9[o]
    }, i = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, s && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = l ? u : d;
      f && f(c);
    };
    return r9(this.node.current, a, i);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: n, prevProps: t } = this.node;
    ["amount", "margin", "root"].some(a9(n, t)) && this.startObserver();
  }
  unmount() {
  }
}
function a9({ viewport: e = {} }, { viewport: n = {} } = {}) {
  return (t) => e[t] !== n[t];
}
const i9 = {
  inView: {
    Feature: s9
  },
  tap: {
    Feature: J4
  },
  focus: {
    Feature: X4
  },
  hover: {
    Feature: Q4
  }
};
function Z0(e, n) {
  if (!Array.isArray(n))
    return !1;
  const t = n.length;
  if (t !== e.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (n[r] !== e[r])
      return !1;
  return !0;
}
function c9(e) {
  const n = {};
  return e.values.forEach((t, r) => n[r] = t.get()), n;
}
function l9(e) {
  const n = {};
  return e.values.forEach((t, r) => n[r] = t.getVelocity()), n;
}
function Yi(e, n, t) {
  const r = e.getProps();
  return A1(r, n, t !== void 0 ? t : r.custom, c9(e), l9(e));
}
let Gs = ct, rn = ct;
process.env.NODE_ENV !== "production" && (Gs = (e, n) => {
  !e && typeof console < "u" && console.warn(n);
}, rn = (e, n) => {
  if (!e)
    throw new Error(n);
});
const pr = (e) => e * 1e3, Hn = (e) => e / 1e3, u9 = {
  current: !1
}, K0 = (e) => Array.isArray(e) && typeof e[0] == "number";
function z0(e) {
  return !!(!e || typeof e == "string" && G0[e] || K0(e) || Array.isArray(e) && e.every(z0));
}
const ps = ([e, n, t, r]) => `cubic-bezier(${e}, ${n}, ${t}, ${r})`, G0 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: ps([0, 0.65, 0.55, 1]),
  circOut: ps([0.55, 0, 1, 0.45]),
  backIn: ps([0.31, 0.01, 0.66, -0.59]),
  backOut: ps([0.33, 1.53, 0.69, 0.99])
};
function q0(e) {
  if (e)
    return K0(e) ? ps(e) : Array.isArray(e) ? e.map(q0) : G0[e];
}
function d9(e, n, t, { delay: r = 0, duration: o, repeat: s = 0, repeatType: a = "loop", ease: i, times: c } = {}) {
  const l = { [n]: t };
  c && (l.offset = c);
  const u = q0(i);
  return Array.isArray(u) && (l.easing = u), e.animate(l, {
    delay: r,
    duration: o,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: s + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
function f9(e, { repeat: n, repeatType: t = "loop" }) {
  const r = n && t !== "loop" && n % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const Q0 = (e, n, t) => (((1 - 3 * t + 3 * n) * e + (3 * t - 6 * n)) * e + 3 * n) * e, p9 = 1e-7, h9 = 12;
function m9(e, n, t, r, o) {
  let s, a, i = 0;
  do
    a = n + (t - n) / 2, s = Q0(a, r, o) - e, s > 0 ? t = a : n = a;
  while (Math.abs(s) > p9 && ++i < h9);
  return a;
}
function qs(e, n, t, r) {
  if (e === n && t === r)
    return ct;
  const o = (s) => m9(s, 0, 1, e, t);
  return (s) => s === 0 || s === 1 ? s : Q0(o(s), n, r);
}
const g9 = qs(0.42, 0, 1, 1), y9 = qs(0, 0, 0.58, 1), X0 = qs(0.42, 0, 0.58, 1), v9 = (e) => Array.isArray(e) && typeof e[0] != "number", J0 = (e) => (n) => n <= 0.5 ? e(2 * n) / 2 : (2 - e(2 * (1 - n))) / 2, ep = (e) => (n) => 1 - e(1 - n), N1 = (e) => 1 - Math.sin(Math.acos(e)), tp = ep(N1), b9 = J0(N1), np = qs(0.33, 1.53, 0.69, 0.99), L1 = ep(np), C9 = J0(L1), w9 = (e) => (e *= 2) < 1 ? 0.5 * L1(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Qu = {
  linear: ct,
  easeIn: g9,
  easeInOut: X0,
  easeOut: y9,
  circIn: N1,
  circInOut: b9,
  circOut: tp,
  backIn: L1,
  backInOut: C9,
  backOut: np,
  anticipate: w9
}, Xu = (e) => {
  if (Array.isArray(e)) {
    rn(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [n, t, r, o] = e;
    return qs(n, t, r, o);
  } else if (typeof e == "string")
    return rn(Qu[e] !== void 0, `Invalid easing type '${e}'`), Qu[e];
  return e;
}, Ns = (e, n, t) => {
  const r = n - e;
  return r === 0 ? 1 : (t - e) / r;
}, tt = (e, n, t) => e + (n - e) * t;
function Sc(e, n, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (n - e) * 6 * t : t < 1 / 2 ? n : t < 2 / 3 ? e + (n - e) * (2 / 3 - t) * 6 : e;
}
function x9({ hue: e, saturation: n, lightness: t, alpha: r }) {
  e /= 360, n /= 100, t /= 100;
  let o = 0, s = 0, a = 0;
  if (!n)
    o = s = a = t;
  else {
    const i = t < 0.5 ? t * (1 + n) : t + n - t * n, c = 2 * t - i;
    o = Sc(c, i, e + 1 / 3), s = Sc(c, i, e), a = Sc(c, i, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(s * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const T1 = (e, n) => (t) => !!(Ks(t) && M4.test(t) && t.startsWith(e) || n && Object.prototype.hasOwnProperty.call(t, n)), rp = (e, n, t) => (r) => {
  if (!Ks(r))
    return r;
  const [o, s, a, i] = r.match(D1);
  return {
    [e]: parseFloat(o),
    [n]: parseFloat(s),
    [t]: parseFloat(a),
    alpha: i !== void 0 ? parseFloat(i) : 1
  };
}, D9 = (e) => yr(0, 255, e), Ec = {
  ...Ko,
  transform: (e) => Math.round(D9(e))
}, Fr = {
  test: T1("rgb", "red"),
  parse: rp("red", "green", "blue"),
  transform: ({ red: e, green: n, blue: t, alpha: r = 1 }) => "rgba(" + Ec.transform(e) + ", " + Ec.transform(n) + ", " + Ec.transform(t) + ", " + vs(ys.transform(r)) + ")"
};
function S9(e) {
  let n = "", t = "", r = "", o = "";
  return e.length > 5 ? (n = e.substring(1, 3), t = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (n = e.substring(1, 2), t = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), n += n, t += t, r += r, o += o), {
    red: parseInt(n, 16),
    green: parseInt(t, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Cl = {
  test: T1("#"),
  parse: S9,
  transform: Fr.transform
}, Eo = {
  test: T1("hsl", "hue"),
  parse: rp("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: n, lightness: t, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Sn.transform(vs(n)) + ", " + Sn.transform(vs(t)) + ", " + vs(ys.transform(r)) + ")"
}, _c = (e, n, t) => {
  const r = e * e, o = t * (n * n - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, E9 = [Cl, Fr, Eo], _9 = (e) => E9.find((n) => n.test(e));
function Ju(e) {
  const n = _9(e);
  rn(!!n, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let t = n.parse(e);
  return n === Eo && (t = x9(t)), t;
}
const e2 = (e, n) => {
  const t = Ju(e), r = Ju(n), o = { ...t };
  return (s) => (o.red = _c(t.red, r.red, s), o.green = _c(t.green, r.green, s), o.blue = _c(t.blue, r.blue, s), o.alpha = tt(t.alpha, r.alpha, s), Fr.transform(o));
}, Mt = {
  test: (e) => Fr.test(e) || Cl.test(e) || Eo.test(e),
  parse: (e) => Fr.test(e) ? Fr.parse(e) : Eo.test(e) ? Eo.parse(e) : Cl.parse(e),
  transform: (e) => Ks(e) ? e : e.hasOwnProperty("red") ? Fr.transform(e) : Eo.transform(e)
};
function M9(e) {
  var n, t;
  return isNaN(e) && Ks(e) && (((n = e.match(D1)) === null || n === void 0 ? void 0 : n.length) || 0) + (((t = e.match(_4)) === null || t === void 0 ? void 0 : t.length) || 0) > 0;
}
const op = "number", sp = "color", k9 = "var", A9 = "var(", t2 = "${}", n2 = /(var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\))|(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))|((-)?([\d]*\.?[\d])+)/gi;
function ni(e) {
  const n = e.toString(), t = n.match(n2) || [], r = [], o = {
    color: [],
    number: [],
    var: []
  }, s = [];
  for (let c = 0; c < t.length; c++) {
    const l = t[c];
    Mt.test(l) ? (o.color.push(c), s.push(sp), r.push(Mt.parse(l))) : l.startsWith(A9) ? (o.var.push(c), s.push(k9), r.push(l)) : (o.number.push(c), s.push(op), r.push(parseFloat(l)));
  }
  const i = n.replace(n2, t2).split(t2);
  return { values: r, split: i, indexes: o, types: s };
}
function ap(e) {
  return ni(e).values;
}
function ip(e) {
  const { split: n, types: t } = ni(e), r = n.length;
  return (o) => {
    let s = "";
    for (let a = 0; a < r; a++)
      if (s += n[a], o[a] !== void 0) {
        const i = t[a];
        i === op ? s += vs(o[a]) : i === sp ? s += Mt.transform(o[a]) : s += o[a];
      }
    return s;
  };
}
const N9 = (e) => typeof e == "number" ? 0 : e;
function L9(e) {
  const n = ap(e);
  return ip(e)(n.map(N9));
}
const vr = {
  test: M9,
  parse: ap,
  createTransformer: ip,
  getAnimatableNone: L9
};
function wl(e, n) {
  return (t) => t > 0 ? n : e;
}
function T9(e, n) {
  return (t) => tt(e, n, t);
}
function P1(e) {
  return typeof e == "number" ? T9 : typeof e == "string" ? Ja(e) ? wl : Mt.test(e) ? e2 : R9 : Array.isArray(e) ? cp : typeof e == "object" ? Mt.test(e) ? e2 : P9 : wl;
}
function cp(e, n) {
  const t = [...e], r = t.length, o = e.map((s, a) => P1(s)(s, n[a]));
  return (s) => {
    for (let a = 0; a < r; a++)
      t[a] = o[a](s);
    return t;
  };
}
function P9(e, n) {
  const t = { ...e, ...n }, r = {};
  for (const o in t)
    e[o] !== void 0 && n[o] !== void 0 && (r[o] = P1(e[o])(e[o], n[o]));
  return (o) => {
    for (const s in r)
      t[s] = r[s](o);
    return t;
  };
}
function O9(e, n) {
  var t;
  const r = [], o = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < n.values.length; s++) {
    const a = n.types[s], i = e.indexes[a][o[a]], c = (t = e.values[i]) !== null && t !== void 0 ? t : 0;
    r[s] = c, o[a]++;
  }
  return r;
}
const R9 = (e, n) => {
  const t = vr.createTransformer(n), r = ni(e), o = ni(n);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? Yn(cp(O9(r, o), o.values), t) : (Gs(!0, `Complex values '${e}' and '${n}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), wl(e, n));
};
function lp(e, n, t) {
  return typeof e == "number" && typeof n == "number" && typeof t == "number" ? tt(e, n, t) : P1(e)(e, n);
}
function I9(e, n, t) {
  const r = [], o = t || lp, s = e.length - 1;
  for (let a = 0; a < s; a++) {
    let i = o(e[a], e[a + 1]);
    if (n) {
      const c = Array.isArray(n) ? n[a] || ct : n;
      i = Yn(c, i);
    }
    r.push(i);
  }
  return r;
}
function F9(e, n, { clamp: t = !0, ease: r, mixer: o } = {}) {
  const s = e.length;
  if (rn(s === n.length, "Both input and output ranges must be the same length"), s === 1)
    return () => n[0];
  e[0] > e[s - 1] && (e = [...e].reverse(), n = [...n].reverse());
  const a = I9(n, r, o), i = a.length, c = (l) => {
    let u = 0;
    if (i > 1)
      for (; u < e.length - 2 && !(l < e[u + 1]); u++)
        ;
    const d = Ns(e[u], e[u + 1], l);
    return a[u](d);
  };
  return t ? (l) => c(yr(e[0], e[s - 1], l)) : c;
}
function V9(e, n) {
  const t = e[e.length - 1];
  for (let r = 1; r <= n; r++) {
    const o = Ns(0, n, r);
    e.push(tt(t, 1, o));
  }
}
function $9(e) {
  const n = [0];
  return V9(n, e.length - 1), n;
}
function B9(e, n) {
  return e.map((t) => t * n);
}
function j9(e, n) {
  return e.map(() => n || X0).splice(0, e.length - 1);
}
function ri({ duration: e = 300, keyframes: n, times: t, ease: r = "easeInOut" }) {
  const o = v9(r) ? r.map(Xu) : Xu(r), s = {
    done: !1,
    value: n[0]
  }, a = B9(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    t && t.length === n.length ? t : $9(n),
    e
  ), i = F9(a, n, {
    ease: Array.isArray(o) ? o : j9(n, o)
  });
  return {
    calculatedDuration: e,
    next: (c) => (s.value = i(c), s.done = c >= e, s)
  };
}
function up(e, n) {
  return n ? e * (1e3 / n) : 0;
}
const Y9 = 5;
function dp(e, n, t) {
  const r = Math.max(n - Y9, 0);
  return up(t - e(r), n - r);
}
const Mc = 1e-3, H9 = 0.01, r2 = 10, U9 = 0.05, W9 = 1;
function Z9({ duration: e = 800, bounce: n = 0.25, velocity: t = 0, mass: r = 1 }) {
  let o, s;
  Gs(e <= pr(r2), "Spring duration must be 10 seconds or less");
  let a = 1 - n;
  a = yr(U9, W9, a), e = yr(H9, r2, Hn(e)), a < 1 ? (o = (l) => {
    const u = l * a, d = u * e, f = u - t, p = xl(l, a), m = Math.exp(-d);
    return Mc - f / p * m;
  }, s = (l) => {
    const d = l * a * e, f = d * t + t, p = Math.pow(a, 2) * Math.pow(l, 2) * e, m = Math.exp(-d), h = xl(Math.pow(l, 2), a);
    return (-o(l) + Mc > 0 ? -1 : 1) * ((f - p) * m) / h;
  }) : (o = (l) => {
    const u = Math.exp(-l * e), d = (l - t) * e + 1;
    return -Mc + u * d;
  }, s = (l) => {
    const u = Math.exp(-l * e), d = (t - l) * (e * e);
    return u * d;
  });
  const i = 5 / e, c = z9(o, s, i);
  if (e = pr(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * r;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const K9 = 12;
function z9(e, n, t) {
  let r = t;
  for (let o = 1; o < K9; o++)
    r = r - e(r) / n(r);
  return r;
}
function xl(e, n) {
  return e * Math.sqrt(1 - n * n);
}
const G9 = ["duration", "bounce"], q9 = ["stiffness", "damping", "mass"];
function o2(e, n) {
  return n.some((t) => e[t] !== void 0);
}
function Q9(e) {
  let n = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!o2(e, q9) && o2(e, G9)) {
    const t = Z9(e);
    n = {
      ...n,
      ...t,
      mass: 1
    }, n.isResolvedFromDuration = !0;
  }
  return n;
}
function fp({ keyframes: e, restDelta: n, restSpeed: t, ...r }) {
  const o = e[0], s = e[e.length - 1], a = { done: !1, value: o }, { stiffness: i, damping: c, mass: l, duration: u, velocity: d, isResolvedFromDuration: f } = Q9({
    ...r,
    velocity: -Hn(r.velocity || 0)
  }), p = d || 0, m = c / (2 * Math.sqrt(i * l)), h = s - o, y = Hn(Math.sqrt(i / l)), C = Math.abs(h) < 5;
  t || (t = C ? 0.01 : 2), n || (n = C ? 5e-3 : 0.5);
  let v;
  if (m < 1) {
    const w = xl(y, m);
    v = (x) => {
      const D = Math.exp(-m * y * x);
      return s - D * ((p + m * y * h) / w * Math.sin(w * x) + h * Math.cos(w * x));
    };
  } else if (m === 1)
    v = (w) => s - Math.exp(-y * w) * (h + (p + y * h) * w);
  else {
    const w = y * Math.sqrt(m * m - 1);
    v = (x) => {
      const D = Math.exp(-m * y * x), k = Math.min(w * x, 300);
      return s - D * ((p + m * y * h) * Math.sinh(k) + w * h * Math.cosh(k)) / w;
    };
  }
  return {
    calculatedDuration: f && u || null,
    next: (w) => {
      const x = v(w);
      if (f)
        a.done = w >= u;
      else {
        let D = p;
        w !== 0 && (m < 1 ? D = dp(v, w, x) : D = 0);
        const k = Math.abs(D) <= t, _ = Math.abs(s - x) <= n;
        a.done = k && _;
      }
      return a.value = a.done ? s : x, a;
    }
  };
}
function s2({ keyframes: e, velocity: n = 0, power: t = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: s = 500, modifyTarget: a, min: i, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, p = (M) => i !== void 0 && M < i || c !== void 0 && M > c, m = (M) => i === void 0 ? c : c === void 0 || Math.abs(i - M) < Math.abs(c - M) ? i : c;
  let h = t * n;
  const y = d + h, C = a === void 0 ? y : a(y);
  C !== y && (h = C - d);
  const v = (M) => -h * Math.exp(-M / r), w = (M) => C + v(M), x = (M) => {
    const T = v(M), N = w(M);
    f.done = Math.abs(T) <= l, f.value = f.done ? C : N;
  };
  let D, k;
  const _ = (M) => {
    p(f.value) && (D = M, k = fp({
      keyframes: [f.value, m(f.value)],
      velocity: dp(w, M, f.value),
      damping: o,
      stiffness: s,
      restDelta: l,
      restSpeed: u
    }));
  };
  return _(0), {
    calculatedDuration: null,
    next: (M) => {
      let T = !1;
      return !k && D === void 0 && (T = !0, x(M), _(M)), D !== void 0 && M > D ? k.next(M - D) : (!T && x(M), f);
    }
  };
}
let Ra;
function X9() {
  Ra = void 0;
}
const Yr = {
  now: () => (Ra === void 0 && Yr.set(St.isProcessing || S0.useManualTiming ? St.timestamp : performance.now()), Ra),
  set: (e) => {
    Ra = e, queueMicrotask(X9);
  }
}, J9 = (e) => {
  const n = ({ timestamp: t }) => e(t);
  return {
    start: () => Qe.update(n, !0),
    stop: () => zn(n),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => St.isProcessing ? St.timestamp : Yr.now()
  };
}, a2 = 2e4;
function i2(e) {
  let n = 0;
  const t = 50;
  let r = e.next(n);
  for (; !r.done && n < a2; )
    n += t, r = e.next(n);
  return n >= a2 ? 1 / 0 : n;
}
const e8 = {
  decay: s2,
  inertia: s2,
  tween: ri,
  keyframes: ri,
  spring: fp
}, t8 = (e) => e / 100;
function oi({ autoplay: e = !0, delay: n = 0, driver: t = J9, keyframes: r, type: o = "keyframes", repeat: s = 0, repeatDelay: a = 0, repeatType: i = "loop", onPlay: c, onStop: l, onComplete: u, onUpdate: d, ...f }) {
  let p = 1, m = !1, h, y;
  const C = () => {
    y = new Promise((z) => {
      h = z;
    });
  };
  C();
  let v;
  const w = e8[o] || ri;
  let x;
  w !== ri && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && rn(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), x = Yn(t8, lp(r[0], r[1])), r = [0, 100]);
  const D = w({ ...f, keyframes: r });
  let k;
  i === "mirror" && (k = w({
    ...f,
    keyframes: [...r].reverse(),
    velocity: -(f.velocity || 0)
  }));
  let _ = "idle", M = null, T = null, N = null;
  D.calculatedDuration === null && s && (D.calculatedDuration = i2(D));
  const { calculatedDuration: I } = D;
  let O = 1 / 0, $ = 1 / 0;
  I !== null && (O = I + a, $ = O * (s + 1) - a);
  let j = 0;
  const Y = (z) => {
    if (T === null)
      return;
    p > 0 && (T = Math.min(T, z)), p < 0 && (T = Math.min(z - $ / p, T)), M !== null ? j = M : j = Math.round(z - T) * p;
    const me = j - n * (p >= 0 ? 1 : -1), Me = p >= 0 ? me < 0 : me > $;
    j = Math.max(me, 0), _ === "finished" && M === null && (j = $);
    let Be = j, ve = D;
    if (s) {
      const fe = Math.min(j, $) / O;
      let De = Math.floor(fe), _e = fe % 1;
      !_e && fe >= 1 && (_e = 1), _e === 1 && De--, De = Math.min(De, s + 1), !!(De % 2) && (i === "reverse" ? (_e = 1 - _e, a && (_e -= a / O)) : i === "mirror" && (ve = k)), Be = yr(0, 1, _e) * O;
    }
    const Ae = Me ? { done: !1, value: r[0] } : ve.next(Be);
    x && (Ae.value = x(Ae.value));
    let { done: Te } = Ae;
    !Me && I !== null && (Te = p >= 0 ? j >= $ : j <= 0);
    const G = M === null && (_ === "finished" || _ === "running" && Te);
    return d && d(Ae.value), G && J(), Ae;
  }, F = () => {
    v && v.stop(), v = void 0;
  }, V = () => {
    _ = "idle", F(), h(), C(), T = N = null;
  }, J = () => {
    _ = "finished", u && u(), F(), h();
  }, Q = () => {
    if (m)
      return;
    v || (v = t(Y));
    const z = v.now();
    c && c(), M !== null ? T = z - M : (!T || _ === "finished") && (T = z), _ === "finished" && C(), N = T, M = null, _ = "running", v.start();
  };
  e && Q();
  const X = {
    then(z, me) {
      return y.then(z, me);
    },
    get time() {
      return Hn(j);
    },
    set time(z) {
      z = pr(z), j = z, M !== null || !v || p === 0 ? M = z : T = v.now() - z / p;
    },
    get duration() {
      const z = D.calculatedDuration === null ? i2(D) : D.calculatedDuration;
      return Hn(z);
    },
    get speed() {
      return p;
    },
    set speed(z) {
      z === p || !v || (p = z, X.time = Hn(j));
    },
    get state() {
      return _;
    },
    play: Q,
    pause: () => {
      _ = "paused", M = j;
    },
    stop: () => {
      m = !0, _ !== "idle" && (_ = "idle", l && l(), V());
    },
    cancel: () => {
      N !== null && Y(N), V();
    },
    complete: () => {
      _ = "finished";
    },
    sample: (z) => (T = 0, Y(z))
  };
  return X;
}
function n8(e) {
  let n;
  return () => (n === void 0 && (n = e()), n);
}
const r8 = n8(() => Object.hasOwnProperty.call(Element.prototype, "animate")), o8 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
]), ha = 10, s8 = 2e4, a8 = (e, n) => n.type === "spring" || e === "backgroundColor" || !z0(n.ease);
function i8(e, n, { onUpdate: t, onComplete: r, ...o }) {
  if (!(r8() && o8.has(n) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let a = !1, i, c, l = !1;
  const u = () => {
    c = new Promise((w) => {
      i = w;
    });
  };
  u();
  let { keyframes: d, duration: f = 300, ease: p, times: m } = o;
  if (a8(n, o)) {
    const w = oi({
      ...o,
      repeat: 0,
      delay: 0
    });
    let x = { done: !1, value: d[0] };
    const D = [];
    let k = 0;
    for (; !x.done && k < s8; )
      x = w.sample(k), D.push(x.value), k += ha;
    m = void 0, d = D, f = k - ha, p = "linear";
  }
  const h = d9(e.owner.current, n, d, {
    ...o,
    duration: f,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: p,
    times: m
  }), y = () => {
    l = !1, h.cancel();
  }, C = () => {
    l = !0, Qe.update(y), i(), u();
  };
  return h.onfinish = () => {
    l || (e.set(f9(d, o)), r && r(), C());
  }, {
    then(w, x) {
      return c.then(w, x);
    },
    attachTimeline(w) {
      return h.timeline = w, h.onfinish = null, ct;
    },
    get time() {
      return Hn(h.currentTime || 0);
    },
    set time(w) {
      h.currentTime = pr(w);
    },
    get speed() {
      return h.playbackRate;
    },
    set speed(w) {
      h.playbackRate = w;
    },
    get duration() {
      return Hn(f);
    },
    play: () => {
      a || (h.play(), zn(y));
    },
    pause: () => h.pause(),
    stop: () => {
      if (a = !0, h.playState === "idle")
        return;
      const { currentTime: w } = h;
      if (w) {
        const x = oi({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(x.sample(w - ha).value, x.sample(w).value, ha);
      }
      C();
    },
    complete: () => {
      l || h.finish();
    },
    cancel: C
  };
}
function c8({ keyframes: e, delay: n, onUpdate: t, onComplete: r }) {
  const o = () => (t && t(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: ct,
    pause: ct,
    stop: ct,
    then: (s) => (s(), Promise.resolve()),
    cancel: ct,
    complete: ct
  });
  return n ? oi({
    keyframes: [0, 1],
    duration: 0,
    delay: n,
    onComplete: o
  }) : o();
}
const l8 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, u8 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), d8 = {
  type: "keyframes",
  duration: 0.8
}, f8 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, p8 = (e, { keyframes: n }) => n.length > 2 ? d8 : to.has(e) ? e.startsWith("scale") ? u8(n[1]) : l8 : f8, Dl = (e, n) => e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(vr.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url(")), h8 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function m8(e) {
  const [n, t] = e.slice(0, -1).split("(");
  if (n === "drop-shadow")
    return e;
  const [r] = t.match(D1) || [];
  if (!r)
    return e;
  const o = t.replace(r, "");
  let s = h8.has(n) ? 1 : 0;
  return r !== t && (s *= 100), n + "(" + s + o + ")";
}
const g8 = /([a-z-]*)\(.*?\)/g, Sl = {
  ...vr,
  getAnimatableNone: (e) => {
    const n = e.match(g8);
    return n ? n.map(m8).join(" ") : e;
  }
}, y8 = {
  ...L0,
  // Color props
  color: Mt,
  backgroundColor: Mt,
  outlineColor: Mt,
  fill: Mt,
  stroke: Mt,
  // Border props
  borderColor: Mt,
  borderTopColor: Mt,
  borderRightColor: Mt,
  borderBottomColor: Mt,
  borderLeftColor: Mt,
  filter: Sl,
  WebkitFilter: Sl
}, O1 = (e) => y8[e];
function pp(e, n) {
  let t = O1(e);
  return t !== Sl && (t = vr), t.getAnimatableNone ? t.getAnimatableNone(n) : void 0;
}
const hp = (e) => /^0[^.\s]+$/.test(e);
function v8(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || hp(e);
}
function b8(e, n, t, r) {
  const o = Dl(n, t);
  let s;
  Array.isArray(t) ? s = [...t] : s = [null, t];
  const a = r.from !== void 0 ? r.from : e.get();
  let i;
  const c = [];
  for (let l = 0; l < s.length; l++)
    s[l] === null && (s[l] = l === 0 ? a : s[l - 1]), v8(s[l]) && c.push(l), typeof s[l] == "string" && s[l] !== "none" && s[l] !== "0" && (i = s[l]);
  if (o && c.length && i)
    for (let l = 0; l < c.length; l++) {
      const u = c[l];
      s[u] = pp(n, i);
    }
  return s;
}
function C8({ when: e, delay: n, delayChildren: t, staggerChildren: r, staggerDirection: o, repeat: s, repeatType: a, repeatDelay: i, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
function R1(e, n) {
  return e[n] || e.default || e;
}
const I1 = (e, n, t, r = {}) => (o) => {
  const s = R1(r, e) || {}, a = s.delay || r.delay || 0;
  let { elapsed: i = 0 } = r;
  i = i - pr(a);
  const c = b8(n, e, t, s), l = c[0], u = c[c.length - 1], d = Dl(e, l), f = Dl(e, u);
  Gs(d === f, `You are trying to animate ${e} from "${l}" to "${u}". ${l} is not an animatable value - to enable this animation set ${l} to a value animatable to ${u} via the \`style\` property.`);
  let p = {
    keyframes: c,
    velocity: n.getVelocity(),
    ease: "easeOut",
    ...s,
    delay: -i,
    onUpdate: (m) => {
      n.set(m), s.onUpdate && s.onUpdate(m);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    }
  };
  if (C8(s) || (p = {
    ...p,
    ...p8(e, p)
  }), p.duration && (p.duration = pr(p.duration)), p.repeatDelay && (p.repeatDelay = pr(p.repeatDelay)), !d || !f || u9.current || s.type === !1 || S0.skipAnimations)
    return c8(p);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate
  ) {
    const m = i8(n, e, p);
    if (m)
      return m;
  }
  return oi(p);
};
function si(e) {
  return !!(Bt(e) && e.add);
}
const mp = (e) => /^\-?\d*\.?\d+$/.test(e);
function F1(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function V1(e, n) {
  const t = e.indexOf(n);
  t > -1 && e.splice(t, 1);
}
class $1 {
  constructor() {
    this.subscriptions = [];
  }
  add(n) {
    return F1(this.subscriptions, n), () => V1(this.subscriptions, n);
  }
  notify(n, t, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](n, t, r);
      else
        for (let s = 0; s < o; s++) {
          const a = this.subscriptions[s];
          a && a(n, t, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const c2 = /* @__PURE__ */ new Set();
function B1(e, n, t) {
  e || c2.has(n) || (console.warn(n), t && console.warn(t), c2.add(n));
}
const l2 = 30, w8 = (e) => !isNaN(parseFloat(e));
class x8 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(n, t = {}) {
    this.version = "11.0.8", this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      const s = Yr.now();
      this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(n), this.canTrackVelocity = w8(this.current), this.owner = t.owner;
  }
  setCurrent(n) {
    this.current = n, this.updatedAt = Yr.now();
  }
  setPrevFrameValue(n = this.current) {
    this.prevFrameValue = n, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(n) {
    return process.env.NODE_ENV !== "production" && B1(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", n);
  }
  on(n, t) {
    this.events[n] || (this.events[n] = new $1());
    const r = this.events[n].add(t);
    return n === "change" ? () => {
      r(), Qe.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const n in this.events)
      this.events[n].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(n, t) {
    this.passiveEffect = n, this.stopPassiveEffect = t;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(n, t = !0) {
    !t || !this.passiveEffect ? this.updateAndNotify(n, t) : this.passiveEffect(n, this.updateAndNotify);
  }
  setWithVelocity(n, t, r) {
    this.set(t), this.prev = void 0, this.prevFrameValue = n, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(n) {
    this.updateAndNotify(n), this.prev = n, this.prevUpdatedAt = this.prevFrameValue = void 0, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const n = Yr.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || n - this.updatedAt > l2)
      return 0;
    const t = Math.min(this.updatedAt - this.prevUpdatedAt, l2);
    return up(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(n) {
    return this.stop(), new Promise((t) => {
      this.hasAnimated = !0, this.animation = n(t), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ro(e, n) {
  return new x8(e, n);
}
const gp = (e) => (n) => n.test(e), D8 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, yp = [Ko, ye, Sn, or, A4, k4, D8], rs = (e) => yp.find(gp(e)), S8 = [...yp, Mt, vr], E8 = (e) => S8.find(gp(e));
function _8(e, n, t) {
  e.hasValue(n) ? e.getValue(n).set(t) : e.addValue(n, Ro(t));
}
function M8(e, n) {
  const t = Yi(e, n);
  let { transitionEnd: r = {}, transition: o = {}, ...s } = t ? e.makeTargetAnimatable(t, !1) : {};
  s = { ...s, ...r };
  for (const a in s) {
    const i = H4(s[a]);
    _8(e, a, i);
  }
}
function k8(e, n, t) {
  var r, o;
  const s = Object.keys(n).filter((i) => !e.hasValue(i)), a = s.length;
  if (a)
    for (let i = 0; i < a; i++) {
      const c = s[i], l = n[c];
      let u = null;
      Array.isArray(l) && (u = l[0]), u === null && (u = (o = (r = t[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && o !== void 0 ? o : n[c]), u != null && (typeof u == "string" && (mp(u) || hp(u)) ? u = parseFloat(u) : !E8(u) && vr.test(l) && (u = pp(c, l)), e.addValue(c, Ro(u, { owner: e })), t[c] === void 0 && (t[c] = u), u !== null && e.setBaseTarget(c, u));
    }
}
function A8(e, n) {
  return n ? (n[e] || n.default || n).from : void 0;
}
function N8(e, n, t) {
  const r = {};
  for (const o in e) {
    const s = A8(o, n);
    if (s !== void 0)
      r[o] = s;
    else {
      const a = t.getValue(o);
      a && (r[o] = a.get());
    }
  }
  return r;
}
function L8({ protectedKeys: e, needsAnimating: n }, t) {
  const r = e.hasOwnProperty(t) && n[t] !== !0;
  return n[t] = !1, r;
}
function T8(e, n) {
  const t = e.get();
  if (Array.isArray(n)) {
    for (let r = 0; r < n.length; r++)
      if (n[r] !== t)
        return !0;
  } else
    return t !== n;
}
function vp(e, n, { delay: t = 0, transitionOverride: r, type: o } = {}) {
  let { transition: s = e.getDefaultTransition(), transitionEnd: a, ...i } = e.makeTargetAnimatable(n);
  const c = e.getValue("willChange");
  r && (s = r);
  const l = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const d in i) {
    const f = e.getValue(d), p = i[d];
    if (!f || p === void 0 || u && L8(u, d))
      continue;
    const m = {
      delay: t,
      elapsed: 0,
      ...R1(s || {}, d)
    };
    if (window.HandoffAppearAnimations) {
      const C = e.getProps()[D0];
      if (C) {
        const v = window.HandoffAppearAnimations(C, d, f, Qe);
        v !== null && (m.elapsed = v, m.isHandoff = !0);
      }
    }
    let h = !m.isHandoff && !T8(f, p);
    if (m.type === "spring" && (f.getVelocity() || m.velocity) && (h = !1), f.animation && (h = !1), h)
      continue;
    f.start(I1(d, f, p, e.shouldReduceMotion && to.has(d) ? { type: !1 } : m));
    const y = f.animation;
    si(c) && (c.add(d), y.then(() => c.remove(d))), l.push(y);
  }
  return a && Promise.all(l).then(() => {
    a && M8(e, a);
  }), l;
}
function El(e, n, t = {}) {
  const r = Yi(e, n, t.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  t.transitionOverride && (o = t.transitionOverride);
  const s = r ? () => Promise.all(vp(e, r, t)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: l = 0, staggerChildren: u, staggerDirection: d } = o;
    return P8(e, n, l + c, u, d, t);
  } : () => Promise.resolve(), { when: i } = o;
  if (i) {
    const [c, l] = i === "beforeChildren" ? [s, a] : [a, s];
    return c().then(() => l());
  } else
    return Promise.all([s(), a(t.delay)]);
}
function P8(e, n, t = 0, r = 0, o = 1, s) {
  const a = [], i = (e.variantChildren.size - 1) * r, c = o === 1 ? (l = 0) => l * r : (l = 0) => i - l * r;
  return Array.from(e.variantChildren).sort(O8).forEach((l, u) => {
    l.notify("AnimationStart", n), a.push(El(l, n, {
      ...s,
      delay: t + c(u)
    }).then(() => l.notify("AnimationComplete", n)));
  }), Promise.all(a);
}
function O8(e, n) {
  return e.sortNodePosition(n);
}
function R8(e, n, t = {}) {
  e.notify("AnimationStart", n);
  let r;
  if (Array.isArray(n)) {
    const o = n.map((s) => El(e, s, t));
    r = Promise.all(o);
  } else if (typeof n == "string")
    r = El(e, n, t);
  else {
    const o = typeof n == "function" ? Yi(e, n, t.custom) : n;
    r = Promise.all(vp(e, o, t));
  }
  return r.then(() => e.notify("AnimationComplete", n));
}
const I8 = [...C1].reverse(), F8 = C1.length;
function V8(e) {
  return (n) => Promise.all(n.map(({ animation: t, options: r }) => R8(e, t, r)));
}
function $8(e) {
  let n = V8(e);
  const t = j8();
  let r = !0;
  const o = (c, l) => {
    const u = Yi(e, l);
    if (u) {
      const { transition: d, transitionEnd: f, ...p } = u;
      c = { ...c, ...p, ...f };
    }
    return c;
  };
  function s(c) {
    n = c(e);
  }
  function a(c, l) {
    const u = e.getProps(), d = e.getVariantContext(!0) || {}, f = [], p = /* @__PURE__ */ new Set();
    let m = {}, h = 1 / 0;
    for (let C = 0; C < F8; C++) {
      const v = I8[C], w = t[v], x = u[v] !== void 0 ? u[v] : d[v], D = Ms(x), k = v === l ? w.isActive : null;
      k === !1 && (h = C);
      let _ = x === d[v] && x !== u[v] && D;
      if (_ && r && e.manuallyAnimateOnMount && (_ = !1), w.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !x && !w.prevProp || // Or if the prop doesn't define an animation
      $i(x) || typeof x == "boolean")
        continue;
      let T = B8(w.prevProp, x) || // If we're making this variant active, we want to always make it active
      v === l && w.isActive && !_ && D || // If we removed a higher-priority variant (i is in reverse order)
      C > h && D, N = !1;
      const I = Array.isArray(x) ? x : [x];
      let O = I.reduce(o, {});
      k === !1 && (O = {});
      const { prevResolvedValues: $ = {} } = w, j = {
        ...$,
        ...O
      }, Y = (F) => {
        T = !0, p.has(F) && (N = !0, p.delete(F)), w.needsAnimating[F] = !0;
      };
      for (const F in j) {
        const V = O[F], J = $[F];
        if (m.hasOwnProperty(F))
          continue;
        let Q = !1;
        ti(V) && ti(J) ? Q = !Z0(V, J) : Q = V !== J, Q ? V !== void 0 ? Y(F) : p.add(F) : V !== void 0 && p.has(F) ? Y(F) : w.protectedKeys[F] = !0;
      }
      w.prevProp = x, w.prevResolvedValues = O, w.isActive && (m = { ...m, ...O }), r && e.blockInitialAnimation && (T = !1), T && (!_ || N) && f.push(...I.map((F) => ({
        animation: F,
        options: { type: v, ...c }
      })));
    }
    if (p.size) {
      const C = {};
      p.forEach((v) => {
        const w = e.getBaseTarget(v);
        w !== void 0 && (C[v] = w);
      }), f.push({ animation: C });
    }
    let y = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? n(f) : Promise.resolve();
  }
  function i(c, l, u) {
    var d;
    if (t[c].isActive === l)
      return Promise.resolve();
    (d = e.variantChildren) === null || d === void 0 || d.forEach((p) => {
      var m;
      return (m = p.animationState) === null || m === void 0 ? void 0 : m.setActive(c, l);
    }), t[c].isActive = l;
    const f = a(u, c);
    for (const p in t)
      t[p].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: a,
    setActive: i,
    setAnimateFunction: s,
    getState: () => t
  };
}
function B8(e, n) {
  return typeof n == "string" ? n !== e : Array.isArray(n) ? !Z0(n, e) : !1;
}
function Lr(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function j8() {
  return {
    animate: Lr(!0),
    whileInView: Lr(),
    whileHover: Lr(),
    whileTap: Lr(),
    whileDrag: Lr(),
    whileFocus: Lr(),
    exit: Lr()
  };
}
class Y8 extends Dr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(n) {
    super(n), n.animationState || (n.animationState = $8(n));
  }
  updateAnimationControlsSubscription() {
    const { animate: n } = this.node.getProps();
    this.unmount(), $i(n) && (this.unmount = n.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: n } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
    n !== t && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let H8 = 0;
class U8 extends Dr {
  constructor() {
    super(...arguments), this.id = H8++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: n, onExitComplete: t, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || n === o)
      return;
    const s = this.node.animationState.setActive("exit", !n, { custom: r ?? this.node.getProps().custom });
    t && !n && s.then(() => t(this.id));
  }
  mount() {
    const { register: n } = this.node.presenceContext || {};
    n && (this.unmount = n(this.id));
  }
  unmount() {
  }
}
const W8 = {
  animation: {
    Feature: Y8
  },
  exit: {
    Feature: U8
  }
}, u2 = (e, n) => Math.abs(e - n);
function Z8(e, n) {
  const t = u2(e.x, n.x), r = u2(e.y, n.y);
  return Math.sqrt(t ** 2 + r ** 2);
}
class bp {
  constructor(n, t, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Ac(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = Z8(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: m } = d, { timestamp: h } = St;
      this.history.push({ ...m, timestamp: h });
      const { onStart: y, onMove: C } = this.handlers;
      f || (y && y(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), C && C(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = kc(f, this.transformPagePoint), Qe.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: p, onSessionEnd: m, resumeAnimation: h } = this.handlers;
      if (this.dragSnapToOrigin && h && h(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Ac(d.type === "pointercancel" ? this.lastMoveEventInfo : kc(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, y), m && m(d, y);
    }, !j0(n))
      return;
    this.dragSnapToOrigin = s, this.handlers = t, this.transformPagePoint = r, this.contextWindow = o || window;
    const a = ji(n), i = kc(a, this.transformPagePoint), { point: c } = i, { timestamp: l } = St;
    this.history = [{ ...c, timestamp: l }];
    const { onSessionStart: u } = t;
    u && u(n, Ac(i, this.history)), this.removeListeners = Yn(jn(this.contextWindow, "pointermove", this.handlePointerMove), jn(this.contextWindow, "pointerup", this.handlePointerUp), jn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(n) {
    this.handlers = n;
  }
  end() {
    this.removeListeners && this.removeListeners(), zn(this.updatePoint);
  }
}
function kc(e, n) {
  return n ? { point: n(e.point) } : e;
}
function d2(e, n) {
  return { x: e.x - n.x, y: e.y - n.y };
}
function Ac({ point: e }, n) {
  return {
    point: e,
    delta: d2(e, Cp(n)),
    offset: d2(e, K8(n)),
    velocity: z8(n, 0.1)
  };
}
function K8(e) {
  return e[0];
}
function Cp(e) {
  return e[e.length - 1];
}
function z8(e, n) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let t = e.length - 1, r = null;
  const o = Cp(e);
  for (; t >= 0 && (r = e[t], !(o.timestamp - r.timestamp > pr(n))); )
    t--;
  if (!r)
    return { x: 0, y: 0 };
  const s = Hn(o.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (o.x - r.x) / s,
    y: (o.y - r.y) / s
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function Kt(e) {
  return e.max - e.min;
}
function _l(e, n = 0, t = 0.01) {
  return Math.abs(e - n) <= t;
}
function f2(e, n, t, r = 0.5) {
  e.origin = r, e.originPoint = tt(n.min, n.max, e.origin), e.scale = Kt(t) / Kt(n), (_l(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = tt(t.min, t.max, e.origin) - e.originPoint, (_l(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function bs(e, n, t, r) {
  f2(e.x, n.x, t.x, r ? r.originX : void 0), f2(e.y, n.y, t.y, r ? r.originY : void 0);
}
function p2(e, n, t) {
  e.min = t.min + n.min, e.max = e.min + Kt(n);
}
function G8(e, n, t) {
  p2(e.x, n.x, t.x), p2(e.y, n.y, t.y);
}
function h2(e, n, t) {
  e.min = n.min - t.min, e.max = e.min + Kt(n);
}
function Cs(e, n, t) {
  h2(e.x, n.x, t.x), h2(e.y, n.y, t.y);
}
function q8(e, { min: n, max: t }, r) {
  return n !== void 0 && e < n ? e = r ? tt(n, e, r.min) : Math.max(e, n) : t !== void 0 && e > t && (e = r ? tt(t, e, r.max) : Math.min(e, t)), e;
}
function m2(e, n, t) {
  return {
    min: n !== void 0 ? e.min + n : void 0,
    max: t !== void 0 ? e.max + t - (e.max - e.min) : void 0
  };
}
function Q8(e, { top: n, left: t, bottom: r, right: o }) {
  return {
    x: m2(e.x, t, o),
    y: m2(e.y, n, r)
  };
}
function g2(e, n) {
  let t = n.min - e.min, r = n.max - e.max;
  return n.max - n.min < e.max - e.min && ([t, r] = [r, t]), { min: t, max: r };
}
function X8(e, n) {
  return {
    x: g2(e.x, n.x),
    y: g2(e.y, n.y)
  };
}
function J8(e, n) {
  let t = 0.5;
  const r = Kt(e), o = Kt(n);
  return o > r ? t = Ns(n.min, n.max - r, e.min) : r > o && (t = Ns(e.min, e.max - o, n.min)), yr(0, 1, t);
}
function e7(e, n) {
  const t = {};
  return n.min !== void 0 && (t.min = n.min - e.min), n.max !== void 0 && (t.max = n.max - e.min), t;
}
const Ml = 0.35;
function t7(e = Ml) {
  return e === !1 ? e = 0 : e === !0 && (e = Ml), {
    x: y2(e, "left", "right"),
    y: y2(e, "top", "bottom")
  };
}
function y2(e, n, t) {
  return {
    min: v2(e, n),
    max: v2(e, t)
  };
}
function v2(e, n) {
  return typeof e == "number" ? e : e[n] || 0;
}
const b2 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), _o = () => ({
  x: b2(),
  y: b2()
}), C2 = () => ({ min: 0, max: 0 }), it = () => ({
  x: C2(),
  y: C2()
});
function Jt(e) {
  return [e("x"), e("y")];
}
function wp({ top: e, left: n, right: t, bottom: r }) {
  return {
    x: { min: n, max: t },
    y: { min: e, max: r }
  };
}
function n7({ x: e, y: n }) {
  return { top: n.min, right: e.max, bottom: n.max, left: e.min };
}
function r7(e, n) {
  if (!n)
    return e;
  const t = n({ x: e.left, y: e.top }), r = n({ x: e.right, y: e.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: r.y,
    right: r.x
  };
}
function Nc(e) {
  return e === void 0 || e === 1;
}
function kl({ scale: e, scaleX: n, scaleY: t }) {
  return !Nc(e) || !Nc(n) || !Nc(t);
}
function Tr(e) {
  return kl(e) || xp(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function xp(e) {
  return w2(e.x) || w2(e.y);
}
function w2(e) {
  return e && e !== "0%";
}
function ai(e, n, t) {
  const r = e - t, o = n * r;
  return t + o;
}
function x2(e, n, t, r, o) {
  return o !== void 0 && (e = ai(e, o, r)), ai(e, t, r) + n;
}
function Al(e, n = 0, t = 1, r, o) {
  e.min = x2(e.min, n, t, r, o), e.max = x2(e.max, n, t, r, o);
}
function Dp(e, { x: n, y: t }) {
  Al(e.x, n.translate, n.scale, n.originPoint), Al(e.y, t.translate, t.scale, t.originPoint);
}
function o7(e, n, t, r = !1) {
  const o = t.length;
  if (!o)
    return;
  n.x = n.y = 1;
  let s, a;
  for (let i = 0; i < o; i++) {
    s = t[i], a = s.projectionDelta;
    const c = s.instance;
    c && c.style && c.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && Mo(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), a && (n.x *= a.x.scale, n.y *= a.y.scale, Dp(e, a)), r && Tr(s.latestValues) && Mo(e, s.latestValues));
  }
  n.x = D2(n.x), n.y = D2(n.y);
}
function D2(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function ar(e, n) {
  e.min = e.min + n, e.max = e.max + n;
}
function S2(e, n, [t, r, o]) {
  const s = n[o] !== void 0 ? n[o] : 0.5, a = tt(e.min, e.max, s);
  Al(e, n[t], n[r], a, n.scale);
}
const s7 = ["x", "scaleX", "originX"], a7 = ["y", "scaleY", "originY"];
function Mo(e, n) {
  S2(e.x, n, s7), S2(e.y, n, a7);
}
function Sp(e, n) {
  return wp(r7(e.getBoundingClientRect(), n));
}
function i7(e, n, t) {
  const r = Sp(e, t), { scroll: o } = n;
  return o && (ar(r.x, o.offset.x), ar(r.y, o.offset.y)), r;
}
const Ep = ({ current: e }) => e ? e.ownerDocument.defaultView : null, c7 = /* @__PURE__ */ new WeakMap();
class l7 {
  constructor(n) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = it(), this.visualElement = n;
  }
  start(n, { snapToCursor: t = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), t && this.snapToCursor(ji(u, "page").point);
    }, s = (u, d) => {
      const { drag: f, dragPropagation: p, onDragStart: m } = this.getProps();
      if (f && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = H0(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Jt((y) => {
        let C = this.getAxisMotionValue(y).get() || 0;
        if (Sn.test(C)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const w = v.layout.layoutBox[y];
            w && (C = Kt(w) * (parseFloat(C) / 100));
          }
        }
        this.originPoint[y] = C;
      }), m && Qe.update(() => m(u, d), !1, !0);
      const { animationState: h } = this.visualElement;
      h && h.setActive("whileDrag", !0);
    }, a = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: m, onDrag: h } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: y } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = u7(y), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, y), this.updateAxis("y", d.point, y), this.visualElement.render(), h && h(u, d);
    }, i = (u, d) => this.stop(u, d), c = () => Jt((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: l } = this.getProps();
    this.panSession = new bp(n, {
      onSessionStart: o,
      onStart: s,
      onMove: a,
      onSessionEnd: i,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: l,
      contextWindow: Ep(this.visualElement)
    });
  }
  stop(n, t) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = t;
    this.startAnimation(o);
    const { onDragEnd: s } = this.getProps();
    s && Qe.update(() => s(n, t));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: n, animationState: t } = this.visualElement;
    n && (n.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), t && t.setActive("whileDrag", !1);
  }
  updateAxis(n, t, r) {
    const { drag: o } = this.getProps();
    if (!r || !ma(n, o, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(n);
    let a = this.originPoint[n] + r[n];
    this.constraints && this.constraints[n] && (a = q8(a, this.constraints[n], this.elastic[n])), s.set(a);
  }
  resolveConstraints() {
    var n;
    const { dragConstraints: t, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (n = this.visualElement.projection) === null || n === void 0 ? void 0 : n.layout, s = this.constraints;
    t && So(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && o ? this.constraints = Q8(o.layoutBox, t) : this.constraints = !1, this.elastic = t7(r), s !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && Jt((a) => {
      this.getAxisMotionValue(a) && (this.constraints[a] = e7(o.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: n, onMeasureDragConstraints: t } = this.getProps();
    if (!n || !So(n))
      return !1;
    const r = n.current;
    rn(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const s = i7(r, o.root, this.visualElement.getTransformPagePoint());
    let a = X8(o.layout.layoutBox, s);
    if (t) {
      const i = t(n7(a));
      this.hasMutatedConstraints = !!i, i && (a = wp(i));
    }
    return a;
  }
  startAnimation(n) {
    const { drag: t, dragMomentum: r, dragElastic: o, dragTransition: s, dragSnapToOrigin: a, onDragTransitionEnd: i } = this.getProps(), c = this.constraints || {}, l = Jt((u) => {
      if (!ma(u, t, this.currentDirection))
        return;
      let d = c && c[u] || {};
      a && (d = { min: 0, max: 0 });
      const f = o ? 200 : 1e6, p = o ? 40 : 1e7, m = {
        type: "inertia",
        velocity: r ? n[u] : 0,
        bounceStiffness: f,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...d
      };
      return this.startAxisValueAnimation(u, m);
    });
    return Promise.all(l).then(i);
  }
  startAxisValueAnimation(n, t) {
    const r = this.getAxisMotionValue(n);
    return r.start(I1(n, r, 0, t));
  }
  stopAnimation() {
    Jt((n) => this.getAxisMotionValue(n).stop());
  }
  pauseAnimation() {
    Jt((n) => {
      var t;
      return (t = this.getAxisMotionValue(n).animation) === null || t === void 0 ? void 0 : t.pause();
    });
  }
  getAnimationState(n) {
    var t;
    return (t = this.getAxisMotionValue(n).animation) === null || t === void 0 ? void 0 : t.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(n) {
    const t = "_drag" + n.toUpperCase(), r = this.visualElement.getProps(), o = r[t];
    return o || this.visualElement.getValue(n, (r.initial ? r.initial[n] : void 0) || 0);
  }
  snapToCursor(n) {
    Jt((t) => {
      const { drag: r } = this.getProps();
      if (!ma(t, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, s = this.getAxisMotionValue(t);
      if (o && o.layout) {
        const { min: a, max: i } = o.layout.layoutBox[t];
        s.set(n[t] - tt(a, i, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: n, dragConstraints: t } = this.getProps(), { projection: r } = this.visualElement;
    if (!So(t) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    Jt((a) => {
      const i = this.getAxisMotionValue(a);
      if (i) {
        const c = i.get();
        o[a] = J8({ min: c, max: c }, this.constraints[a]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Jt((a) => {
      if (!ma(a, n, null))
        return;
      const i = this.getAxisMotionValue(a), { min: c, max: l } = this.constraints[a];
      i.set(tt(c, l, o[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    c7.set(this.visualElement, this);
    const n = this.visualElement.current, t = jn(n, "pointerdown", (c) => {
      const { drag: l, dragListener: u = !0 } = this.getProps();
      l && u && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      So(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, s = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const a = Vn(window, "resize", () => this.scalePositionWithinConstraints()), i = o.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: l }) => {
      this.isDragging && l && (Jt((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += c[u].translate, d.set(d.get() + c[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), t(), s(), i && i();
    };
  }
  getProps() {
    const n = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: s = !1, dragElastic: a = Ml, dragMomentum: i = !0 } = n;
    return {
      ...n,
      drag: t,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: s,
      dragElastic: a,
      dragMomentum: i
    };
  }
}
function ma(e, n, t) {
  return (n === !0 || n === e) && (t === null || t === e);
}
function u7(e, n = 10) {
  let t = null;
  return Math.abs(e.y) > n ? t = "y" : Math.abs(e.x) > n && (t = "x"), t;
}
class d7 extends Dr {
  constructor(n) {
    super(n), this.removeGroupControls = ct, this.removeListeners = ct, this.controls = new l7(n);
  }
  mount() {
    const { dragControls: n } = this.node.getProps();
    n && (this.removeGroupControls = n.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || ct;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const E2 = (e) => (n, t) => {
  e && Qe.update(() => e(n, t));
};
class f7 extends Dr {
  constructor() {
    super(...arguments), this.removePointerDownListener = ct;
  }
  onPointerDown(n) {
    this.session = new bp(n, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Ep(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: n, onPanStart: t, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: E2(n),
      onStart: E2(t),
      onMove: r,
      onEnd: (s, a) => {
        delete this.session, o && Qe.update(() => o(s, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = jn(this.node.current, "pointerdown", (n) => this.onPointerDown(n));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function p7() {
  const e = ze(Fi);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: t, register: r } = e, o = p1();
  return W(() => r(o), []), !n && t ? [!1, () => t && t(o)] : [!0];
}
const Ia = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function _2(e, n) {
  return n.max === n.min ? 0 : e / (n.max - n.min) * 100;
}
const os = {
  correct: (e, n) => {
    if (!n.target)
      return e;
    if (typeof e == "string")
      if (ye.test(e))
        e = parseFloat(e);
      else
        return e;
    const t = _2(e, n.target.x), r = _2(e, n.target.y);
    return `${t}% ${r}%`;
  }
}, h7 = {
  correct: (e, { treeScale: n, projectionDelta: t }) => {
    const r = e, o = vr.parse(e);
    if (o.length > 5)
      return r;
    const s = vr.createTransformer(e), a = typeof o[0] != "number" ? 1 : 0, i = t.x.scale * n.x, c = t.y.scale * n.y;
    o[0 + a] /= i, o[1 + a] /= c;
    const l = tt(i, c, 0.5);
    return typeof o[2 + a] == "number" && (o[2 + a] /= l), typeof o[3 + a] == "number" && (o[3 + a] /= l), s(o);
  }
};
class m7 extends A.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: n, layoutGroup: t, switchLayoutGroup: r, layoutId: o } = this.props, { projection: s } = n;
    b4(g7), s && (t.group && t.group.add(s), r && r.register && o && r.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), Ia.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(n) {
    const { layoutDependency: t, visualElement: r, drag: o, isPresent: s } = this.props, a = r.projection;
    return a && (a.isPresent = s, o || n.layoutDependency !== t || t === void 0 ? a.willUpdate() : this.safeToRemove(), n.isPresent !== s && (s ? a.promote() : a.relegate() || Qe.postRender(() => {
      const i = a.getStack();
      (!i || !i.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: n } = this.props.visualElement;
    n && (n.root.didUpdate(), b1.postRender(() => {
      !n.currentAnimation && n.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: n, layoutGroup: t, switchLayoutGroup: r } = this.props, { projection: o } = n;
    o && (o.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: n } = this.props;
    n && n();
  }
  render() {
    return null;
  }
}
function _p(e) {
  const [n, t] = p7(), r = ze(As);
  return A.createElement(m7, { ...e, layoutGroup: r, switchLayoutGroup: ze(M0), isPresent: n, safeToRemove: t });
}
const g7 = {
  borderRadius: {
    ...os,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: os,
  borderTopRightRadius: os,
  borderBottomLeftRadius: os,
  borderBottomRightRadius: os,
  boxShadow: h7
}, Mp = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], y7 = Mp.length, M2 = (e) => typeof e == "string" ? parseFloat(e) : e, k2 = (e) => typeof e == "number" || ye.test(e);
function v7(e, n, t, r, o, s) {
  o ? (e.opacity = tt(
    0,
    // TODO Reinstate this if only child
    t.opacity !== void 0 ? t.opacity : 1,
    b7(r)
  ), e.opacityExit = tt(n.opacity !== void 0 ? n.opacity : 1, 0, C7(r))) : s && (e.opacity = tt(n.opacity !== void 0 ? n.opacity : 1, t.opacity !== void 0 ? t.opacity : 1, r));
  for (let a = 0; a < y7; a++) {
    const i = `border${Mp[a]}Radius`;
    let c = A2(n, i), l = A2(t, i);
    if (c === void 0 && l === void 0)
      continue;
    c || (c = 0), l || (l = 0), c === 0 || l === 0 || k2(c) === k2(l) ? (e[i] = Math.max(tt(M2(c), M2(l), r), 0), (Sn.test(l) || Sn.test(c)) && (e[i] += "%")) : e[i] = l;
  }
  (n.rotate || t.rotate) && (e.rotate = tt(n.rotate || 0, t.rotate || 0, r));
}
function A2(e, n) {
  return e[n] !== void 0 ? e[n] : e.borderRadius;
}
const b7 = kp(0, 0.5, tp), C7 = kp(0.5, 0.95, ct);
function kp(e, n, t) {
  return (r) => r < e ? 0 : r > n ? 1 : t(Ns(e, n, r));
}
function N2(e, n) {
  e.min = n.min, e.max = n.max;
}
function Xt(e, n) {
  N2(e.x, n.x), N2(e.y, n.y);
}
function L2(e, n, t, r, o) {
  return e -= n, e = ai(e, 1 / t, r), o !== void 0 && (e = ai(e, 1 / o, r)), e;
}
function w7(e, n = 0, t = 1, r = 0.5, o, s = e, a = e) {
  if (Sn.test(n) && (n = parseFloat(n), n = tt(a.min, a.max, n / 100) - a.min), typeof n != "number")
    return;
  let i = tt(s.min, s.max, r);
  e === s && (i -= n), e.min = L2(e.min, n, t, i, o), e.max = L2(e.max, n, t, i, o);
}
function T2(e, n, [t, r, o], s, a) {
  w7(e, n[t], n[r], n[o], n.scale, s, a);
}
const x7 = ["x", "scaleX", "originX"], D7 = ["y", "scaleY", "originY"];
function P2(e, n, t, r) {
  T2(e.x, n, x7, t ? t.x : void 0, r ? r.x : void 0), T2(e.y, n, D7, t ? t.y : void 0, r ? r.y : void 0);
}
function O2(e) {
  return e.translate === 0 && e.scale === 1;
}
function Ap(e) {
  return O2(e.x) && O2(e.y);
}
function S7(e, n) {
  return e.x.min === n.x.min && e.x.max === n.x.max && e.y.min === n.y.min && e.y.max === n.y.max;
}
function Np(e, n) {
  return Math.round(e.x.min) === Math.round(n.x.min) && Math.round(e.x.max) === Math.round(n.x.max) && Math.round(e.y.min) === Math.round(n.y.min) && Math.round(e.y.max) === Math.round(n.y.max);
}
function R2(e) {
  return Kt(e.x) / Kt(e.y);
}
class E7 {
  constructor() {
    this.members = [];
  }
  add(n) {
    F1(this.members, n), n.scheduleRender();
  }
  remove(n) {
    if (V1(this.members, n), n === this.prevLead && (this.prevLead = void 0), n === this.lead) {
      const t = this.members[this.members.length - 1];
      t && this.promote(t);
    }
  }
  relegate(n) {
    const t = this.members.findIndex((o) => n === o);
    if (t === 0)
      return !1;
    let r;
    for (let o = t; o >= 0; o--) {
      const s = this.members[o];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(n, t) {
    const r = this.lead;
    if (n !== r && (this.prevLead = r, this.lead = n, n.show(), r)) {
      r.instance && r.scheduleRender(), n.scheduleRender(), n.resumeFrom = r, t && (n.resumeFrom.preserveOpacity = !0), r.snapshot && (n.snapshot = r.snapshot, n.snapshot.latestValues = r.animationValues || r.latestValues), n.root && n.root.isUpdating && (n.isLayoutDirty = !0);
      const { crossfade: o } = n.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((n) => {
      const { options: t, resumingFrom: r } = n;
      t.onExitComplete && t.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((n) => {
      n.instance && n.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function I2(e, n, t) {
  let r = "";
  const o = e.x.translate / n.x, s = e.y.translate / n.y;
  if ((o || s) && (r = `translate3d(${o}px, ${s}px, 0) `), (n.x !== 1 || n.y !== 1) && (r += `scale(${1 / n.x}, ${1 / n.y}) `), t) {
    const { rotate: c, rotateX: l, rotateY: u } = t;
    c && (r += `rotate(${c}deg) `), l && (r += `rotateX(${l}deg) `), u && (r += `rotateY(${u}deg) `);
  }
  const a = e.x.scale * n.x, i = e.y.scale * n.y;
  return (a !== 1 || i !== 1) && (r += `scale(${a}, ${i})`), r || "none";
}
const _7 = (e, n) => e.depth - n.depth;
class M7 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(n) {
    F1(this.children, n), this.isDirty = !0;
  }
  remove(n) {
    V1(this.children, n), this.isDirty = !0;
  }
  forEach(n) {
    this.isDirty && this.children.sort(_7), this.isDirty = !1, this.children.forEach(n);
  }
}
function k7(e, n) {
  const t = Yr.now(), r = ({ timestamp: o }) => {
    const s = o - t;
    s >= n && (zn(r), e(s - n));
  };
  return Qe.read(r, !0), () => zn(r);
}
function A7(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function N7(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function L7(e, n, t) {
  const r = Bt(e) ? e : Ro(e);
  return r.start(I1("", r, n, t)), r.animation;
}
const F2 = ["", "X", "Y", "Z"], T7 = { visibility: "hidden" }, V2 = 1e3;
let P7 = 0;
const Pr = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function Lp({ attachResizeListener: e, defaultParent: n, measureScroll: t, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(a = {}, i = n == null ? void 0 : n()) {
      this.id = P7++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Pr.totalNodes = Pr.resolvedTargetDeltas = Pr.recalculatedProjection = 0, this.nodes.forEach(I7), this.nodes.forEach(j7), this.nodes.forEach(Y7), this.nodes.forEach(F7), A7(Pr);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = i ? i.root || i : this, this.path = i ? [...i.path, i] : [], this.parent = i, this.depth = i ? i.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new M7());
    }
    addEventListener(a, i) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new $1()), this.eventHandlers.get(a).add(i);
    }
    notifyListeners(a, ...i) {
      const c = this.eventHandlers.get(a);
      c && c.notify(...i);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, i = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = N7(a), this.instance = a;
      const { layoutId: c, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), i && (l || c) && (this.isLayoutDirty = !0), e) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = k7(f, 250), Ia.hasAnimatedSinceResize && (Ia.hasAnimatedSinceResize = !1, this.nodes.forEach(B2));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && u && (c || l) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: p, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || u.getDefaultTransition() || K7, { onLayoutAnimationStart: y, onLayoutAnimationComplete: C } = u.getProps(), v = !this.targetLayout || !Np(this.targetLayout, m) || p, w = !f && p;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || w || f && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, w);
          const x = {
            ...R1(h, "layout"),
            onPlay: y,
            onComplete: C
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x);
        } else
          f || B2(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, zn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(H7), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: i, layout: c } = this.options;
      if (i === void 0 && !c)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach($2);
        return;
      }
      this.isUpdating || this.nodes.forEach($7), this.isUpdating = !1, window.HandoffCancelAllAnimations && window.HandoffCancelAllAnimations(), this.nodes.forEach(B7), this.nodes.forEach(O7), this.nodes.forEach(R7), this.clearAllSnapshots();
      const i = Yr.now();
      St.delta = yr(0, 1e3 / 60, i - St.timestamp), St.timestamp = i, St.isProcessing = !0, wc.update.process(St), wc.preRender.process(St), wc.render.process(St), St.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, b1.read(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(V7), this.sharedNodes.forEach(U7);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Qe.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Qe.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = it(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: i } = this.options;
      i && i.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let i = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (i = !1), i && (this.scroll = {
        animationId: this.root.animationId,
        phase: a,
        isRoot: r(this.instance),
        offset: t(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform, i = this.projectionDelta && !Ap(this.projectionDelta), c = this.getTransformTemplate(), l = c ? c(this.latestValues, "") : void 0, u = l !== this.prevTransformTemplateValue;
      a && (i || Tr(this.latestValues) || u) && (o(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const i = this.measurePageBox();
      let c = this.removeElementScroll(i);
      return a && (c = this.removeTransform(c)), z7(c), {
        animationId: this.root.animationId,
        measuredBox: i,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return it();
      const i = a.measureViewportBox(), { scroll: c } = this.root;
      return c && (ar(i.x, c.offset.x), ar(i.y, c.offset.y)), i;
    }
    removeElementScroll(a) {
      const i = it();
      Xt(i, a);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c], { scroll: u, options: d } = l;
        if (l !== this.root && u && d.layoutScroll) {
          if (u.isRoot) {
            Xt(i, a);
            const { scroll: f } = this.root;
            f && (ar(i.x, -f.offset.x), ar(i.y, -f.offset.y));
          }
          ar(i.x, u.offset.x), ar(i.y, u.offset.y);
        }
      }
      return i;
    }
    applyTransform(a, i = !1) {
      const c = it();
      Xt(c, a);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        !i && u.options.layoutScroll && u.scroll && u !== u.root && Mo(c, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), Tr(u.latestValues) && Mo(c, u.latestValues);
      }
      return Tr(this.latestValues) && Mo(c, this.latestValues), c;
    }
    removeTransform(a) {
      const i = it();
      Xt(i, a);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        if (!l.instance || !Tr(l.latestValues))
          continue;
        kl(l.latestValues) && l.updateSnapshot();
        const u = it(), d = l.measurePageBox();
        Xt(u, d), P2(i, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, u);
      }
      return Tr(this.latestValues) && P2(i, this.latestValues), i;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== St.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var i;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== c;
      if (!(a || l && this.isSharedProjectionDirty || this.isProjectionDirty || !((i = this.parent) === null || i === void 0) && i.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = St.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = it(), this.relativeTargetOrigin = it(), Cs(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), Xt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = it(), this.targetWithTransforms = it()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), G8(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Xt(this.target, this.layout.layoutBox), Dp(this.target, this.targetDelta)) : Xt(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const p = this.getClosestProjectingParent();
            p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = it(), this.relativeTargetOrigin = it(), Cs(this.relativeTargetOrigin, this.target, p.target), Xt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Pr.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || kl(this.parent.latestValues) || xp(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const i = this.getLead(), c = !!this.resumingFrom || this !== i;
      let l = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (l = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === St.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      Xt(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, p = this.treeScale.y;
      o7(this.layoutCorrected, this.treeScale, this.path, c), i.layout && !i.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (i.target = i.layout.layoutBox, i.targetWithTransforms = it());
      const { target: m } = i;
      if (!m) {
        this.projectionTransform && (this.projectionDelta = _o(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = _o(), this.projectionDeltaWithTransform = _o());
      const h = this.projectionTransform;
      bs(this.projectionDelta, this.layoutCorrected, m, this.latestValues), this.projectionTransform = I2(this.projectionDelta, this.treeScale), (this.projectionTransform !== h || this.treeScale.x !== f || this.treeScale.y !== p) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m)), Pr.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), a) {
        const i = this.getStack();
        i && i.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(a, i = !1) {
      const c = this.snapshot, l = c ? c.latestValues : {}, u = { ...this.latestValues }, d = _o();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !i;
      const f = it(), p = c ? c.source : void 0, m = this.layout ? this.layout.source : void 0, h = p !== m, y = this.getStack(), C = !y || y.members.length <= 1, v = !!(h && !C && this.options.crossfade === !0 && !this.path.some(Z7));
      this.animationProgress = 0;
      let w;
      this.mixTargetDelta = (x) => {
        const D = x / 1e3;
        j2(d.x, a.x, D), j2(d.y, a.y, D), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Cs(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), W7(this.relativeTarget, this.relativeTargetOrigin, f, D), w && S7(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = it()), Xt(w, this.relativeTarget)), h && (this.animationValues = u, v7(u, l, this.latestValues, D, v, C)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = D;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (zn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Qe.update(() => {
        Ia.hasAnimatedSinceResize = !0, this.currentAnimation = L7(0, V2, {
          ...a,
          onUpdate: (i) => {
            this.mixTargetDelta(i), a.onUpdate && a.onUpdate(i);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(V2), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: i, target: c, layout: l, latestValues: u } = a;
      if (!(!i || !c || !l)) {
        if (this !== a && this.layout && l && Tp(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          c = this.target || it();
          const d = Kt(this.layout.layoutBox.x);
          c.x.min = a.target.x.min, c.x.max = c.x.min + d;
          const f = Kt(this.layout.layoutBox.y);
          c.y.min = a.target.y.min, c.y.max = c.y.min + f;
        }
        Xt(i, c), Mo(i, u), bs(this.projectionDeltaWithTransform, this.layoutCorrected, i, u);
      }
    }
    registerSharedNode(a, i) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new E7()), this.sharedNodes.get(a).add(i);
      const l = i.options.initialPromotionConfig;
      i.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(i) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: i, preserveFollowOpacity: c } = {}) {
      const l = this.getStack();
      l && l.promote(this, c), a && (this.projectionDelta = void 0, this.needsReset = !0), i && this.setOptions({ transition: i });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let i = !1;
      const { latestValues: c } = a;
      if ((c.rotate || c.rotateX || c.rotateY || c.rotateZ) && (i = !0), !i)
        return;
      const l = {};
      for (let u = 0; u < F2.length; u++) {
        const d = "rotate" + F2[u];
        c[d] && (l[d] = c[d], a.setStaticValue(d, 0));
      }
      a.render();
      for (const u in l)
        a.setStaticValue(u, l[u]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var i, c;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return T7;
      const l = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, l.opacity = "", l.pointerEvents = Oa(a == null ? void 0 : a.pointerEvents) || "", l.transform = u ? u(this.latestValues, "") : "none", l;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const h = {};
        return this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Oa(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Tr(this.latestValues) && (h.transform = u ? u({}, "") : "none", this.hasProjected = !1), h;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), l.transform = I2(this.projectionDeltaWithTransform, this.treeScale, f), u && (l.transform = u(f, l.transform));
      const { x: p, y: m } = this.projectionDelta;
      l.transformOrigin = `${p.origin * 100}% ${m.origin * 100}% 0`, d.animationValues ? l.opacity = d === this ? (c = (i = f.opacity) !== null && i !== void 0 ? i : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : l.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const h in Xa) {
        if (f[h] === void 0)
          continue;
        const { correct: y, applyTo: C } = Xa[h], v = l.transform === "none" ? f[h] : y(f[h], d);
        if (C) {
          const w = C.length;
          for (let x = 0; x < w; x++)
            l[C[x]] = v;
        } else
          l[h] = v;
      }
      return this.options.layoutId && (l.pointerEvents = d === this ? Oa(a == null ? void 0 : a.pointerEvents) || "" : "none"), l;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var i;
        return (i = a.currentAnimation) === null || i === void 0 ? void 0 : i.stop();
      }), this.root.nodes.forEach($2), this.root.sharedNodes.clear();
    }
  };
}
function O7(e) {
  e.updateLayout();
}
function R7(e) {
  var n;
  const t = ((n = e.resumeFrom) === null || n === void 0 ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: s } = e.options, a = t.source !== e.layout.source;
    s === "size" ? Jt((d) => {
      const f = a ? t.measuredBox[d] : t.layoutBox[d], p = Kt(f);
      f.min = r[d].min, f.max = f.min + p;
    }) : Tp(s, t.layoutBox, r) && Jt((d) => {
      const f = a ? t.measuredBox[d] : t.layoutBox[d], p = Kt(r[d]);
      f.max = f.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + p);
    });
    const i = _o();
    bs(i, r, t.layoutBox);
    const c = _o();
    a ? bs(c, e.applyTransform(o, !0), t.measuredBox) : bs(c, r, t.layoutBox);
    const l = !Ap(i);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: p } = d;
        if (f && p) {
          const m = it();
          Cs(m, t.layoutBox, f.layoutBox);
          const h = it();
          Cs(h, r, p.layoutBox), Np(m, h) || (u = !0), d.options.layoutRoot && (e.relativeTarget = h, e.relativeTargetOrigin = m, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: c,
      layoutDelta: i,
      hasLayoutChanged: l,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function I7(e) {
  Pr.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function F7(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function V7(e) {
  e.clearSnapshot();
}
function $2(e) {
  e.clearMeasurements();
}
function $7(e) {
  e.isLayoutDirty = !1;
}
function B7(e) {
  const { visualElement: n } = e.options;
  n && n.getProps().onBeforeLayoutMeasure && n.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function B2(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function j7(e) {
  e.resolveTargetDelta();
}
function Y7(e) {
  e.calcProjection();
}
function H7(e) {
  e.resetRotation();
}
function U7(e) {
  e.removeLeadSnapshot();
}
function j2(e, n, t) {
  e.translate = tt(n.translate, 0, t), e.scale = tt(n.scale, 1, t), e.origin = n.origin, e.originPoint = n.originPoint;
}
function Y2(e, n, t, r) {
  e.min = tt(n.min, t.min, r), e.max = tt(n.max, t.max, r);
}
function W7(e, n, t, r) {
  Y2(e.x, n.x, t.x, r), Y2(e.y, n.y, t.y, r);
}
function Z7(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const K7 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, H2 = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), U2 = H2("applewebkit/") && !H2("chrome/") ? Math.round : ct;
function W2(e) {
  e.min = U2(e.min), e.max = U2(e.max);
}
function z7(e) {
  W2(e.x), W2(e.y);
}
function Tp(e, n, t) {
  return e === "position" || e === "preserve-aspect" && !_l(R2(n), R2(t), 0.2);
}
const G7 = Lp({
  attachResizeListener: (e, n) => Vn(e, "resize", n),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Lc = {
  current: void 0
}, Pp = Lp({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Lc.current) {
      const e = new G7({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Lc.current = e;
    }
    return Lc.current;
  },
  resetTransform: (e, n) => {
    e.style.transform = n !== void 0 ? n : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), q7 = {
  pan: {
    Feature: f7
  },
  drag: {
    Feature: d7,
    ProjectionNode: Pp,
    MeasureLayout: _p
  }
}, Q7 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function X7(e) {
  const n = Q7.exec(e);
  if (!n)
    return [,];
  const [, t, r] = n;
  return [t, r];
}
const J7 = 4;
function Nl(e, n, t = 1) {
  rn(t <= J7, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = X7(e);
  if (!r)
    return;
  const s = window.getComputedStyle(n).getPropertyValue(r);
  if (s) {
    const a = s.trim();
    return mp(a) ? parseFloat(a) : a;
  } else
    return Ja(o) ? Nl(o, n, t + 1) : o;
}
function em(e, { ...n }, t) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: n, transitionEnd: t };
  t && (t = { ...t }), e.values.forEach((o) => {
    const s = o.get();
    if (!Ja(s))
      return;
    const a = Nl(s, r);
    a && o.set(a);
  });
  for (const o in n) {
    const s = n[o];
    if (!Ja(s))
      continue;
    const a = Nl(s, r);
    a && (n[o] = a, t || (t = {}), t[o] === void 0 && (t[o] = s));
  }
  return { target: n, transitionEnd: t };
}
const tm = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Op = (e) => tm.has(e), nm = (e) => Object.keys(e).some(Op), ga = (e) => e === Ko || e === ye, Z2 = (e, n) => parseFloat(e.split(", ")[n]), K2 = (e, n) => (t, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return Z2(o[1], n);
  {
    const s = r.match(/^matrix\((.+)\)$/);
    return s ? Z2(s[1], e) : 0;
  }
}, rm = /* @__PURE__ */ new Set(["x", "y", "z"]), om = Zs.filter((e) => !rm.has(e));
function sm(e) {
  const n = [];
  return om.forEach((t) => {
    const r = e.getValue(t);
    r !== void 0 && (n.push([t, r.get()]), r.set(t.startsWith("scale") ? 1 : 0));
  }), n.length && e.render(), n;
}
const Io = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: n = "0", paddingRight: t = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(t),
  height: ({ y: e }, { paddingTop: n = "0", paddingBottom: t = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(t),
  top: (e, { top: n }) => parseFloat(n),
  left: (e, { left: n }) => parseFloat(n),
  bottom: ({ y: e }, { top: n }) => parseFloat(n) + (e.max - e.min),
  right: ({ x: e }, { left: n }) => parseFloat(n) + (e.max - e.min),
  // Transform
  x: K2(4, 13),
  y: K2(5, 14)
};
Io.translateX = Io.x;
Io.translateY = Io.y;
const am = (e, n, t) => {
  const r = n.measureViewportBox(), o = n.current, s = getComputedStyle(o), { display: a } = s, i = {};
  a === "none" && n.setStaticValue("display", e.display || "block"), t.forEach((l) => {
    i[l] = Io[l](r, s);
  }), n.render();
  const c = n.measureViewportBox();
  return t.forEach((l) => {
    const u = n.getValue(l);
    u && u.jump(i[l]), e[l] = Io[l](c, s);
  }), e;
}, im = (e, n, t = {}, r = {}) => {
  n = { ...n }, r = { ...r };
  const o = Object.keys(n).filter(Op);
  let s = [], a = !1;
  const i = [];
  if (o.forEach((c) => {
    const l = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let u = t[c], d = rs(u);
    const f = n[c];
    let p;
    if (ti(f)) {
      const m = f.length, h = f[0] === null ? 1 : 0;
      u = f[h], d = rs(u);
      for (let y = h; y < m && f[y] !== null; y++)
        p ? rn(rs(f[y]) === p, "All keyframes must be of the same type") : (p = rs(f[y]), rn(p === d || ga(d) && ga(p), "Keyframes must be of the same dimension as the current value"));
    } else
      p = rs(f);
    if (d !== p)
      if (ga(d) && ga(p)) {
        const m = l.get();
        typeof m == "string" && l.set(parseFloat(m)), typeof f == "string" ? n[c] = parseFloat(f) : Array.isArray(f) && p === ye && (n[c] = f.map(parseFloat));
      } else
        d != null && d.transform && (p != null && p.transform) && (u === 0 || f === 0) ? u === 0 ? l.set(p.transform(u)) : n[c] = d.transform(f) : (a || (s = sm(e), a = !0), i.push(c), r[c] = r[c] !== void 0 ? r[c] : n[c], l.jump(f));
  }), i.length) {
    const c = i.indexOf("height") >= 0 ? window.pageYOffset : null, l = am(n, e, i);
    return s.length && s.forEach(([u, d]) => {
      e.getValue(u).set(d);
    }), e.render(), Vi && c !== null && window.scrollTo({ top: c }), { target: l, transitionEnd: r };
  } else
    return { target: n, transitionEnd: r };
};
function cm(e, n, t, r) {
  return nm(n) ? im(e, n, t, r) : { target: n, transitionEnd: r };
}
const lm = (e, n, t, r) => {
  const o = em(e, n, r);
  return n = o.target, r = o.transitionEnd, cm(e, n, t, r);
}, Ll = { current: null }, Rp = { current: !1 };
function um() {
  if (Rp.current = !0, !!Vi)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), n = () => Ll.current = e.matches;
      e.addListener(n), n();
    } else
      Ll.current = !1;
}
function dm(e, n, t) {
  const { willChange: r } = n;
  for (const o in n) {
    const s = n[o], a = t[o];
    if (Bt(s))
      e.addValue(o, s), si(r) && r.add(o), process.env.NODE_ENV === "development" && B1(s.version === "11.0.8", `Attempting to mix Framer Motion versions ${s.version} with 11.0.8 may not work as expected.`);
    else if (Bt(a))
      e.addValue(o, Ro(s, { owner: e })), si(r) && r.remove(o);
    else if (a !== s)
      if (e.hasValue(o)) {
        const i = e.getValue(o);
        !i.hasAnimated && i.set(s);
      } else {
        const i = e.getStaticValue(o);
        e.addValue(o, Ro(i !== void 0 ? i : s, { owner: e }));
      }
  }
  for (const o in t)
    n[o] === void 0 && e.removeValue(o);
  return n;
}
const z2 = /* @__PURE__ */ new WeakMap(), Ip = Object.keys(ks), fm = Ip.length, G2 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], pm = w1.length;
class hm {
  constructor({ parent: n, props: t, presenceContext: r, reducedMotionConfig: o, visualState: s }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Qe.render(this.render, !1, !0);
    const { latestValues: i, renderState: c } = s;
    this.latestValues = i, this.baseTarget = { ...i }, this.initialValues = t.initial ? { ...i } : {}, this.renderState = c, this.parent = n, this.props = t, this.presenceContext = r, this.depth = n ? n.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.isControllingVariants = Bi(t), this.isVariantNode = _0(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(n && n.current);
    const { willChange: l, ...u } = this.scrapeMotionValuesFromProps(t, {});
    for (const d in u) {
      const f = u[d];
      i[d] !== void 0 && Bt(f) && (f.set(i[d], !1), si(l) && l.add(d));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(n, t) {
    return {};
  }
  mount(n) {
    this.current = n, z2.set(n, this), this.projection && !this.projection.instance && this.projection.mount(n), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((t, r) => this.bindToMotionValue(r, t)), Rp.current || um(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ll.current, process.env.NODE_ENV !== "production" && B1(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    z2.delete(this.current), this.projection && this.projection.unmount(), zn(this.notifyUpdate), zn(this.render), this.valueSubscriptions.forEach((n) => n()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features)
      this.features[n].unmount();
    this.current = null;
  }
  bindToMotionValue(n, t) {
    const r = to.has(n), o = t.on("change", (a) => {
      this.latestValues[n] = a, this.props.onUpdate && Qe.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), s = t.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(n, () => {
      o(), s();
    });
  }
  sortNodePosition(n) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== n.type ? 0 : this.sortInstanceNodePosition(this.current, n.current);
  }
  loadFeatures({ children: n, ...t }, r, o, s) {
    let a, i;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      t.ignoreStrict ? Gs(!1, c) : rn(!1, c);
    }
    for (let c = 0; c < fm; c++) {
      const l = Ip[c], { isEnabled: u, Feature: d, ProjectionNode: f, MeasureLayout: p } = ks[l];
      f && (a = f), u(t) && (!this.features[l] && d && (this.features[l] = new d(this)), p && (i = p));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && a) {
      this.projection = new a(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: l, drag: u, dragConstraints: d, layoutScroll: f, layoutRoot: p } = t;
      this.projection.setOptions({
        layoutId: c,
        layout: l,
        alwaysMeasureLayout: !!u || d && So(d),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: s,
        layoutScroll: f,
        layoutRoot: p
      });
    }
    return i;
  }
  updateFeatures() {
    for (const n in this.features) {
      const t = this.features[n];
      t.isMounted ? t.update() : (t.mount(), t.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : it();
  }
  getStaticValue(n) {
    return this.latestValues[n];
  }
  setStaticValue(n, t) {
    this.latestValues[n] = t;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(n, t = !0) {
    return this.makeTargetAnimatableFromInstance(n, t);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(n, t) {
    (n.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = n, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
    for (let r = 0; r < G2.length; r++) {
      const o = G2[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const s = n["on" + o];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = dm(this, this.scrapeMotionValuesFromProps(n, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(n) {
    return this.props.variants ? this.props.variants[n] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(n = !1) {
    if (n)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const t = {};
    for (let r = 0; r < pm; r++) {
      const o = w1[r], s = this.props[o];
      (Ms(s) || s === !1) && (t[o] = s);
    }
    return t;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(n) {
    const t = this.getClosestVariantNode();
    if (t)
      return t.variantChildren && t.variantChildren.add(n), () => t.variantChildren.delete(n);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(n, t) {
    t !== this.values.get(n) && (this.removeValue(n), this.bindToMotionValue(n, t)), this.values.set(n, t), this.latestValues[n] = t.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(n) {
    this.values.delete(n);
    const t = this.valueSubscriptions.get(n);
    t && (t(), this.valueSubscriptions.delete(n)), delete this.latestValues[n], this.removeValueFromRenderState(n, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(n) {
    return this.values.has(n);
  }
  getValue(n, t) {
    if (this.props.values && this.props.values[n])
      return this.props.values[n];
    let r = this.values.get(n);
    return r === void 0 && t !== void 0 && (r = Ro(t, { owner: this }), this.addValue(n, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(n) {
    var t;
    return this.latestValues[n] !== void 0 || !this.current ? this.latestValues[n] : (t = this.getBaseTargetFromProps(this.props, n)) !== null && t !== void 0 ? t : this.readValueFromInstance(this.current, n, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(n, t) {
    this.baseTarget[n] = t;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(n) {
    var t;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (t = A1(this.props, r)) === null || t === void 0 ? void 0 : t[n] : void 0;
    if (r && o !== void 0)
      return o;
    const s = this.getBaseTargetFromProps(this.props, n);
    return s !== void 0 && !Bt(s) ? s : this.initialValues[n] !== void 0 && o === void 0 ? void 0 : this.baseTarget[n];
  }
  on(n, t) {
    return this.events[n] || (this.events[n] = new $1()), this.events[n].add(t);
  }
  notify(n, ...t) {
    this.events[n] && this.events[n].notify(...t);
  }
}
class Fp extends hm {
  sortInstanceNodePosition(n, t) {
    return n.compareDocumentPosition(t) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(n, t) {
    return n.style ? n.style[t] : void 0;
  }
  removeValueFromRenderState(n, { vars: t, style: r }) {
    delete t[n], delete r[n];
  }
  makeTargetAnimatableFromInstance({ transition: n, transitionEnd: t, ...r }, o) {
    const s = N8(r, n || {}, this);
    if (o) {
      k8(this, r, s);
      const a = lm(this, r, s, t);
      t = a.transitionEnd, r = a.target;
    }
    return {
      transition: n,
      transitionEnd: t,
      ...r
    };
  }
}
function mm(e) {
  return window.getComputedStyle(e);
}
class gm extends Fp {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(n, t) {
    if (to.has(t)) {
      const r = O1(t);
      return r && r.default || 0;
    } else {
      const r = mm(n), o = (N0(t) ? r.getPropertyValue(t) : r[t]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(n, { transformPagePoint: t }) {
    return Sp(n, t);
  }
  build(n, t, r, o) {
    S1(n, t, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(n, t) {
    return k1(n, t);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: n } = this.props;
    Bt(n) && (this.childSubscription = n.on("change", (t) => {
      this.current && (this.current.textContent = `${t}`);
    }));
  }
  renderInstance(n, t, r, o) {
    R0(n, t, r, o);
  }
}
class ym extends Fp {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(n, t) {
    return n[t];
  }
  readValueFromInstance(n, t) {
    if (to.has(t)) {
      const r = O1(t);
      return r && r.default || 0;
    }
    return t = I0.has(t) ? t : v1(t), n.getAttribute(t);
  }
  measureInstanceViewportBox() {
    return it();
  }
  scrapeMotionValuesFromProps(n, t) {
    return V0(n, t);
  }
  build(n, t, r, o) {
    _1(n, t, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(n, t, r, o) {
    F0(n, t, r, o);
  }
  mount(n) {
    this.isSVGTag = M1(n.tagName), super.mount(n);
  }
}
const vm = (e, n) => x1(e) ? new ym(n, { enableHardwareAcceleration: !1 }) : new gm(n, { enableHardwareAcceleration: !0 }), bm = {
  layout: {
    ProjectionNode: Pp,
    MeasureLayout: _p
  }
}, Cm = {
  ...W8,
  ...i9,
  ...q7,
  ...bm
}, he = /* @__PURE__ */ y4((e, n) => z4(e, n, Cm, vm));
function Vp() {
  const e = ie(!1);
  return y1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function $p() {
  const e = Vp(), [n, t] = K(0), r = cn(() => {
    e.current && t(n + 1);
  }, [n]);
  return [cn(() => Qe.postRender(r), [r]), n];
}
class wm extends b.Component {
  getSnapshotBeforeUpdate(n) {
    const t = this.props.childRef.current;
    if (t && n.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = t.offsetHeight || 0, r.width = t.offsetWidth || 0, r.top = t.offsetTop, r.left = t.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function xm({ children: e, isPresent: n }) {
  const t = p1(), r = ie(null), o = ie({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return t0(() => {
    const { width: s, height: a, top: i, left: c } = o.current;
    if (n || !r.current || !s || !a)
      return;
    r.current.dataset.motionPopId = t;
    const l = document.createElement("style");
    return document.head.appendChild(l), l.sheet && l.sheet.insertRule(`
          [data-motion-pop-id="${t}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${a}px !important;
            top: ${i}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(l);
    };
  }, [n]), b.createElement(wm, { isPresent: n, childRef: r, sizeRef: o }, b.cloneElement(e, { ref: r }));
}
const Tc = ({ children: e, initial: n, isPresent: t, onExitComplete: r, custom: o, presenceAffectsLayout: s, mode: a }) => {
  const i = $0(Dm), c = p1(), l = Et(
    () => ({
      id: c,
      initial: n,
      isPresent: t,
      custom: o,
      onExitComplete: (u) => {
        i.set(u, !0);
        for (const d of i.values())
          if (!d)
            return;
        r && r();
      },
      register: (u) => (i.set(u, !1), () => i.delete(u))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    s ? void 0 : [t]
  );
  return Et(() => {
    i.forEach((u, d) => i.set(d, !1));
  }, [t]), b.useEffect(() => {
    !t && !i.size && r && r();
  }, [t]), a === "popLayout" && (e = b.createElement(xm, { isPresent: t }, e)), b.createElement(Fi.Provider, { value: l }, e);
};
function Dm() {
  return /* @__PURE__ */ new Map();
}
function Sm(e) {
  return W(() => () => e(), []);
}
const Or = (e) => e.key || "";
function Em(e, n) {
  e.forEach((t) => {
    const r = Or(t);
    n.set(r, t);
  });
}
function _m(e) {
  const n = [];
  return $n.forEach(e, (t) => {
    Kn(t) && n.push(t);
  }), n;
}
const kt = ({ children: e, custom: n, initial: t = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: s = !0, mode: a = "sync" }) => {
  rn(!o, "Replace exitBeforeEnter with mode='wait'");
  const i = ze(As).forceRender || $p()[0], c = Vp(), l = _m(e);
  let u = l;
  const d = ie(/* @__PURE__ */ new Map()).current, f = ie(u), p = ie(/* @__PURE__ */ new Map()).current, m = ie(!0);
  if (y1(() => {
    m.current = !1, Em(l, p), f.current = u;
  }), Sm(() => {
    m.current = !0, p.clear(), d.clear();
  }), m.current)
    return b.createElement(b.Fragment, null, u.map((v) => b.createElement(Tc, { key: Or(v), isPresent: !0, initial: t ? void 0 : !1, presenceAffectsLayout: s, mode: a }, v)));
  u = [...u];
  const h = f.current.map(Or), y = l.map(Or), C = h.length;
  for (let v = 0; v < C; v++) {
    const w = h[v];
    y.indexOf(w) === -1 && !d.has(w) && d.set(w, void 0);
  }
  return a === "wait" && d.size && (u = []), d.forEach((v, w) => {
    if (y.indexOf(w) !== -1)
      return;
    const x = p.get(w);
    if (!x)
      return;
    const D = h.indexOf(w);
    let k = v;
    if (!k) {
      const _ = () => {
        d.delete(w);
        const M = Array.from(p.keys()).filter((T) => !y.includes(T));
        if (M.forEach((T) => p.delete(T)), f.current = l.filter((T) => {
          const N = Or(T);
          return (
            // filter out the node exiting
            N === w || // filter out the leftover children
            M.includes(N)
          );
        }), !d.size) {
          if (c.current === !1)
            return;
          i(), r && r();
        }
      };
      k = b.createElement(Tc, { key: Or(x), isPresent: !1, onExitComplete: _, custom: n, presenceAffectsLayout: s, mode: a }, x), d.set(w, k);
    }
    u.splice(D, 0, k);
  }), u = u.map((v) => {
    const w = v.key;
    return d.has(w) ? v : b.createElement(Tc, { key: Or(v), isPresent: !0, presenceAffectsLayout: s, mode: a }, v);
  }), process.env.NODE_ENV !== "production" && a === "wait" && u.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), b.createElement(b.Fragment, null, d.size ? u : u.map((v) => Ws(v)));
}, Mm = Rt(null), km = (e) => !e.isLayoutDirty && e.willUpdate(!1);
function q2() {
  const e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new WeakMap(), t = () => e.forEach(km);
  return {
    add: (r) => {
      e.add(r), n.set(r, r.addEventListener("willUpdate", t));
    },
    remove: (r) => {
      e.delete(r);
      const o = n.get(r);
      o && (o(), n.delete(r)), t();
    },
    dirty: t
  };
}
const Bp = (e) => e === !0, Am = (e) => Bp(e === !0) || e === "id", Nm = ({ children: e, id: n, inherit: t = !0 }) => {
  const r = ze(As), o = ze(Mm), [s, a] = $p(), i = ie(null), c = r.id || o;
  i.current === null && (Am(t) && c && (n = n ? c + "-" + n : c), i.current = {
    id: n,
    group: Bp(t) && r.group || q2()
  });
  const l = Et(() => ({ ...i.current, forceRender: s }), [a]);
  return b.createElement(As.Provider, { value: l }, e);
};
function dt(e) {
  const {
    state: n
  } = ue(), {
    loadingState: t
  } = n;
  return e ? e == null ? void 0 : e.some((o) => t[o]) : Object.values(t).some(Boolean);
}
const Lm = 0.4, Ao = Lm, Ce = {
  duration: Ao,
  ease: [0.36, 0.66, 0.04, 1]
}, Tm = "rabobank-ff", jp = Rt(null);
function Pm({
  children: e,
  root: n
}) {
  return /* @__PURE__ */ g(jp.Provider, {
    value: n,
    children: e
  });
}
function Om() {
  return ze(jp);
}
function Rm({
  children: e
}) {
  const [n, t] = K(null), r = dt(["transition"]);
  return /* @__PURE__ */ g(Nm, {
    children: /* @__PURE__ */ g(he.div, {
      className: `${Tm} wrapper`,
      layoutId: r ? void 0 : "rabo-wrapper",
      transition: Ce,
      children: /* @__PURE__ */ g(Pm, {
        root: n,
        children: /* @__PURE__ */ g("div", {
          className: "relative flex flex-col w-full flex-1 min-h-widget overflow-hidden bg-app-background sm:rounded-app",
          ref: (o) => t(o),
          children: e
        })
      })
    })
  });
}
const Q2 = (e, n) => {
  const t = e[n];
  return t ? typeof t == "function" ? t() : Promise.resolve(t) : new Promise((r, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, new Error("Unknown variable dynamic import: " + n)));
  });
}, Im = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, n) {
    console && console[e] && console[e].apply(console, n);
  }
};
class ii {
  constructor(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(n, t);
  }
  init(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = n || Im, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(n, t, r, o) {
    return o && !this.debug ? null : (typeof n[0] == "string" && (n[0] = `${r}${this.prefix} ${n[0]}`), this.logger[t](n));
  }
  create(n) {
    return new ii(this.logger, {
      prefix: `${this.prefix}:${n}:`,
      ...this.options
    });
  }
  clone(n) {
    return n = n || this.options, n.prefix = n.prefix || this.prefix, new ii(this.logger, n);
  }
}
var wn = new ii();
class Hi {
  constructor() {
    this.observers = {};
  }
  on(n, t) {
    return n.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const o = this.observers[r].get(t) || 0;
      this.observers[r].set(t, o + 1);
    }), this;
  }
  off(n, t) {
    if (this.observers[n]) {
      if (!t) {
        delete this.observers[n];
        return;
      }
      this.observers[n].delete(t);
    }
  }
  emit(n) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
      r[o - 1] = arguments[o];
    this.observers[n] && Array.from(this.observers[n].entries()).forEach((a) => {
      let [i, c] = a;
      for (let l = 0; l < c; l++)
        i(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [i, c] = a;
      for (let l = 0; l < c; l++)
        i.apply(i, [n, ...r]);
    });
  }
}
function ss() {
  let e, n;
  const t = new Promise((r, o) => {
    e = r, n = o;
  });
  return t.resolve = e, t.reject = n, t;
}
function X2(e) {
  return e == null ? "" : "" + e;
}
function Fm(e, n, t) {
  e.forEach((r) => {
    n[r] && (t[r] = n[r]);
  });
}
const Vm = /###/g;
function ws(e, n, t) {
  function r(i) {
    return i && i.indexOf("###") > -1 ? i.replace(Vm, ".") : i;
  }
  function o() {
    return !e || typeof e == "string";
  }
  const s = typeof n != "string" ? n : n.split(".");
  let a = 0;
  for (; a < s.length - 1; ) {
    if (o())
      return {};
    const i = r(s[a]);
    !e[i] && t && (e[i] = new t()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++a;
  }
  return o() ? {} : {
    obj: e,
    k: r(s[a])
  };
}
function J2(e, n, t) {
  const {
    obj: r,
    k: o
  } = ws(e, n, Object);
  if (r !== void 0 || n.length === 1) {
    r[o] = t;
    return;
  }
  let s = n[n.length - 1], a = n.slice(0, n.length - 1), i = ws(e, a, Object);
  for (; i.obj === void 0 && a.length; )
    s = `${a[a.length - 1]}.${s}`, a = a.slice(0, a.length - 1), i = ws(e, a, Object), i && i.obj && typeof i.obj[`${i.k}.${s}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${s}`] = t;
}
function $m(e, n, t, r) {
  const {
    obj: o,
    k: s
  } = ws(e, n, Object);
  o[s] = o[s] || [], r && (o[s] = o[s].concat(t)), r || o[s].push(t);
}
function ci(e, n) {
  const {
    obj: t,
    k: r
  } = ws(e, n);
  if (t)
    return t[r];
}
function Bm(e, n, t) {
  const r = ci(e, t);
  return r !== void 0 ? r : ci(n, t);
}
function Yp(e, n, t) {
  for (const r in n)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof n[r] == "string" || n[r] instanceof String ? t && (e[r] = n[r]) : Yp(e[r], n[r], t) : e[r] = n[r]);
  return e;
}
function uo(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var jm = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Ym(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (n) => jm[n]) : e;
}
class Hm {
  constructor(n) {
    this.capacity = n, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(n) {
    const t = this.regExpMap.get(n);
    if (t !== void 0)
      return t;
    const r = new RegExp(n);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(n, r), this.regExpQueue.push(n), r;
  }
}
const Um = [" ", ",", "?", "!", ";"], Wm = new Hm(20);
function Zm(e, n, t) {
  n = n || "", t = t || "";
  const r = Um.filter((a) => n.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (r.length === 0)
    return !0;
  const o = Wm.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let s = !o.test(e);
  if (!s) {
    const a = e.indexOf(t);
    a > 0 && !o.test(e.substring(0, a)) && (s = !0);
  }
  return s;
}
function Tl(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[n])
    return e[n];
  const r = n.split(t);
  let o = e;
  for (let s = 0; s < r.length; ) {
    if (!o || typeof o != "object")
      return;
    let a, i = "";
    for (let c = s; c < r.length; ++c)
      if (c !== s && (i += t), i += r[c], a = o[i], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && c < r.length - 1)
          continue;
        s += c - s + 1;
        break;
      }
    o = a;
  }
  return o;
}
function li(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class ed extends Hi {
  constructor(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = n || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(n) {
    this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
  }
  removeNamespaces(n) {
    const t = this.options.ns.indexOf(n);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, a = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    n.indexOf(".") > -1 ? i = n.split(".") : (i = [n, t], r && (Array.isArray(r) ? i.push(...r) : typeof r == "string" && s ? i.push(...r.split(s)) : i.push(r)));
    const c = ci(this.data, i);
    return !c && !t && !r && n.indexOf(".") > -1 && (n = i[0], t = i[1], r = i.slice(2).join(".")), c || !a || typeof r != "string" ? c : Tl(this.data && this.data[n] && this.data[n][t], r, s);
  }
  addResource(n, t, r, o) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let i = [n, t];
    r && (i = i.concat(a ? r.split(a) : r)), n.indexOf(".") > -1 && (i = n.split("."), o = t, t = i[1]), this.addNamespaces(t), J2(this.data, i, o), s.silent || this.emit("added", n, t, r, o);
  }
  addResources(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const s in r)
      (typeof r[s] == "string" || Object.prototype.toString.apply(r[s]) === "[object Array]") && this.addResource(n, t, s, r[s], {
        silent: !0
      });
    o.silent || this.emit("added", n, t, r);
  }
  addResourceBundle(n, t, r, o, s) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, i = [n, t];
    n.indexOf(".") > -1 && (i = n.split("."), o = r, r = t, t = i[1]), this.addNamespaces(t);
    let c = ci(this.data, i) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), o ? Yp(c, r, s) : c = {
      ...c,
      ...r
    }, J2(this.data, i, c), a.silent || this.emit("added", n, t, r);
  }
  removeResourceBundle(n, t) {
    this.hasResourceBundle(n, t) && delete this.data[n][t], this.removeNamespaces(t), this.emit("removed", n, t);
  }
  hasResourceBundle(n, t) {
    return this.getResource(n, t) !== void 0;
  }
  getResourceBundle(n, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(n, t)
    } : this.getResource(n, t);
  }
  getDataByLanguage(n) {
    return this.data[n];
  }
  hasLanguageSomeTranslations(n) {
    const t = this.getDataByLanguage(n);
    return !!(t && Object.keys(t) || []).find((o) => t[o] && Object.keys(t[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Hp = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, n, t, r, o) {
    return e.forEach((s) => {
      this.processors[s] && (n = this.processors[s].process(n, t, r, o));
    }), n;
  }
};
const td = {};
class ui extends Hi {
  constructor(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Fm(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = wn.create("translator");
  }
  changeLanguage(n) {
    n && (this.language = n);
  }
  exists(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (n == null)
      return !1;
    const r = this.resolve(n, t);
    return r && r.res !== void 0;
  }
  extractFromKey(n, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let s = t.ns || this.options.defaultNS || [];
    const a = r && n.indexOf(r) > -1, i = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Zm(n, r, o);
    if (a && !i) {
      const c = n.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: n,
          namespaces: s
        };
      const l = n.split(r);
      (r !== o || r === o && this.options.ns.indexOf(l[0]) > -1) && (s = l.shift()), n = l.join(o);
    }
    return typeof s == "string" && (s = [s]), {
      key: n,
      namespaces: s
    };
  }
  translate(n, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), n == null)
      return "";
    Array.isArray(n) || (n = [String(n)]);
    const o = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: i
    } = this.extractFromKey(n[n.length - 1], t), c = i[i.length - 1], l = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (l && l.toLowerCase() === "cimode") {
      if (u) {
        const x = t.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${c}${x}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: l,
          usedNS: c,
          usedParams: this.getUsedParamsDetails(t)
        } : `${c}${x}${a}`;
      }
      return o ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: l,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const d = this.resolve(n, t);
    let f = d && d.res;
    const p = d && d.usedKey || a, m = d && d.exactUsedKey || a, h = Object.prototype.toString.apply(f), y = ["[object Number]", "[object Function]", "[object RegExp]"], C = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (v && f && (typeof f != "string" && typeof f != "boolean" && typeof f != "number") && y.indexOf(h) < 0 && !(typeof C == "string" && h === "[object Array]")) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, f, {
          ...t,
          ns: i
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return o ? (d.res = x, d.usedParams = this.getUsedParamsDetails(t), d) : x;
      }
      if (s) {
        const x = h === "[object Array]", D = x ? [] : {}, k = x ? m : p;
        for (const _ in f)
          if (Object.prototype.hasOwnProperty.call(f, _)) {
            const M = `${k}${s}${_}`;
            D[_] = this.translate(M, {
              ...t,
              joinArrays: !1,
              ns: i
            }), D[_] === M && (D[_] = f[_]);
          }
        f = D;
      }
    } else if (v && typeof C == "string" && h === "[object Array]")
      f = f.join(C), f && (f = this.extendTranslation(f, n, t, r));
    else {
      let x = !1, D = !1;
      const k = t.count !== void 0 && typeof t.count != "string", _ = ui.hasDefaultValue(t), M = k ? this.pluralResolver.getSuffix(l, t.count, t) : "", T = t.ordinal && k ? this.pluralResolver.getSuffix(l, t.count, {
        ordinal: !1
      }) : "", N = k && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = N && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${M}`] || t[`defaultValue${T}`] || t.defaultValue;
      !this.isValidLookup(f) && _ && (x = !0, f = I), this.isValidLookup(f) || (D = !0, f = a);
      const $ = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && D ? void 0 : f, j = _ && I !== f && this.options.updateMissing;
      if (D || x || j) {
        if (this.logger.log(j ? "updateKey" : "missingKey", l, c, a, j ? I : f), s) {
          const J = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          J && J.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Y = [];
        const F = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && F && F[0])
          for (let J = 0; J < F.length; J++)
            Y.push(F[J]);
        else
          this.options.saveMissingTo === "all" ? Y = this.languageUtils.toResolveHierarchy(t.lng || this.language) : Y.push(t.lng || this.language);
        const V = (J, Q, X) => {
          const z = _ && X !== f ? X : $;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(J, c, Q, z, j, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(J, c, Q, z, j, t), this.emit("missingKey", J, c, Q, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? Y.forEach((J) => {
          const Q = this.pluralResolver.getSuffixes(J, t);
          N && t[`defaultValue${this.options.pluralSeparator}zero`] && Q.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Q.push(`${this.options.pluralSeparator}zero`), Q.forEach((X) => {
            V([J], a + X, t[`defaultValue${X}`] || I);
          });
        }) : V(Y, a, I));
      }
      f = this.extendTranslation(f, n, t, d, r), D && f === a && this.options.appendNamespaceToMissingKey && (f = `${c}:${a}`), (D || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${a}` : a, x ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return o ? (d.res = f, d.usedParams = this.getUsedParamsDetails(t), d) : f;
  }
  extendTranslation(n, t, r, o, s) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      n = this.i18nFormat.parse(n, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const l = typeof n == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (l) {
        const f = n.match(this.interpolator.nestingRegexp);
        u = f && f.length;
      }
      let d = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), n = this.interpolator.interpolate(n, d, r.lng || this.language, r), l) {
        const f = n.match(this.interpolator.nestingRegexp), p = f && f.length;
        u < p && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = o.usedLng), r.nest !== !1 && (n = this.interpolator.nest(n, function() {
        for (var f = arguments.length, p = new Array(f), m = 0; m < f; m++)
          p[m] = arguments[m];
        return s && s[0] === p[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${p[0]} in key: ${t[0]}`), null) : a.translate(...p, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const i = r.postProcess || this.options.postProcess, c = typeof i == "string" ? [i] : i;
    return n != null && c && c.length && r.applyPostProcessor !== !1 && (n = Hp.handle(c, n, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), n;
  }
  resolve(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, s, a, i;
    return typeof n == "string" && (n = [n]), n.forEach((c) => {
      if (this.isValidLookup(r))
        return;
      const l = this.extractFromKey(c, t), u = l.key;
      o = u;
      let d = l.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const f = t.count !== void 0 && typeof t.count != "string", p = f && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = t.context !== void 0 && (typeof t.context == "string" || typeof t.context == "number") && t.context !== "", h = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((y) => {
        this.isValidLookup(r) || (i = y, !td[`${h[0]}-${y}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(i) && (td[`${h[0]}-${y}`] = !0, this.logger.warn(`key "${o}" for languages "${h.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach((C) => {
          if (this.isValidLookup(r))
            return;
          a = C;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, C, y, t);
          else {
            let x;
            f && (x = this.pluralResolver.getSuffix(C, t.count, t));
            const D = `${this.options.pluralSeparator}zero`, k = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (v.push(u + x), t.ordinal && x.indexOf(k) === 0 && v.push(u + x.replace(k, this.options.pluralSeparator)), p && v.push(u + D)), m) {
              const _ = `${u}${this.options.contextSeparator}${t.context}`;
              v.push(_), f && (v.push(_ + x), t.ordinal && x.indexOf(k) === 0 && v.push(_ + x.replace(k, this.options.pluralSeparator)), p && v.push(_ + D));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (s = w, r = this.getResource(C, y, w, t));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: s,
      usedLng: a,
      usedNS: i
    };
  }
  isValidLookup(n) {
    return n !== void 0 && !(!this.options.returnNull && n === null) && !(!this.options.returnEmptyString && n === "");
  }
  getResource(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(n, t, r, o) : this.resourceStore.getResource(n, t, r, o);
  }
  getUsedParamsDetails() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = n.replace && typeof n.replace != "string";
    let o = r ? n.replace : n;
    if (r && typeof n.count < "u" && (o.count = n.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !r) {
      o = {
        ...o
      };
      for (const s of t)
        delete o[s];
    }
    return o;
  }
  static hasDefaultValue(n) {
    const t = "defaultValue";
    for (const r in n)
      if (Object.prototype.hasOwnProperty.call(n, r) && t === r.substring(0, t.length) && n[r] !== void 0)
        return !0;
    return !1;
  }
}
function Pc(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class nd {
  constructor(n) {
    this.options = n, this.supportedLngs = this.options.supportedLngs || !1, this.logger = wn.create("languageUtils");
  }
  getScriptPartFromCode(n) {
    if (n = li(n), !n || n.indexOf("-") < 0)
      return null;
    const t = n.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(n) {
    if (n = li(n), !n || n.indexOf("-") < 0)
      return n;
    const t = n.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(n) {
    if (typeof n == "string" && n.indexOf("-") > -1) {
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = n.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Pc(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Pc(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Pc(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
  }
  isSupportedCode(n) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
  }
  getBestMatchFromCodes(n) {
    if (!n)
      return null;
    let t;
    return n.forEach((r) => {
      if (t)
        return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (t = o);
    }), !t && this.options.supportedLngs && n.forEach((r) => {
      if (t)
        return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o))
        return t = o;
      t = this.options.supportedLngs.find((s) => {
        if (s === o)
          return s;
        if (!(s.indexOf("-") < 0 && o.indexOf("-") < 0) && (s.indexOf("-") > 0 && o.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === o || s.indexOf(o) === 0 && o.length > 1))
          return s;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(n, t) {
    if (!n)
      return [];
    if (typeof n == "function" && (n = n(t)), typeof n == "string" && (n = [n]), Object.prototype.toString.apply(n) === "[object Array]")
      return n;
    if (!t)
      return n.default || [];
    let r = n[t];
    return r || (r = n[this.getScriptPartFromCode(t)]), r || (r = n[this.formatLanguageCode(t)]), r || (r = n[this.getLanguagePartFromCode(t)]), r || (r = n.default), r || [];
  }
  toResolveHierarchy(n, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], n), o = [], s = (a) => {
      a && (this.isSupportedCode(a) ? o.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return typeof n == "string" && (n.indexOf("-") > -1 || n.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(n))) : typeof n == "string" && s(this.formatLanguageCode(n)), r.forEach((a) => {
      o.indexOf(a) < 0 && s(this.formatLanguageCode(a));
    }), o;
  }
}
let Km = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], zm = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const Gm = ["v1", "v2", "v3"], qm = ["v4"], rd = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Qm() {
  const e = {};
  return Km.forEach((n) => {
    n.lngs.forEach((t) => {
      e[t] = {
        numbers: n.nr,
        plurals: zm[n.fc]
      };
    });
  }), e;
}
class Xm {
  constructor(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = n, this.options = t, this.logger = wn.create("pluralResolver"), (!this.options.compatibilityJSON || qm.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Qm();
  }
  addRule(n, t) {
    this.rules[n] = t;
  }
  getRule(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(li(n === "dev" ? "en" : n), {
          type: t.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
  }
  needsPlural(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(n, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(n, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(n, r).map((o) => `${t}${o}`);
  }
  getSuffixes(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(n, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, s) => rd[o] - rd[s]).map((o) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(n, o, t)) : [];
  }
  getSuffix(n, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(n, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(t)}` : this.getSuffixRetroCompatible(o, t) : (this.logger.warn(`no plural rule found for: ${n}`), "");
  }
  getSuffixRetroCompatible(n, t) {
    const r = n.noAbs ? n.plurals(t) : n.plurals(Math.abs(t));
    let o = n.numbers[r];
    this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const s = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : s() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 ? s() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Gm.includes(this.options.compatibilityJSON);
  }
}
function od(e, n, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = Bm(e, n, t);
  return !s && o && typeof t == "string" && (s = Tl(e, t, r), s === void 0 && (s = Tl(n, t, r))), s;
}
class Jm {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = wn.create("interpolator"), this.options = n, this.format = n.interpolation && n.interpolation.format || ((t) => t), this.init(n);
  }
  init() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    n.interpolation || (n.interpolation = {
      escapeValue: !0
    });
    const t = n.interpolation;
    this.escape = t.escape !== void 0 ? t.escape : Ym, this.escapeValue = t.escapeValue !== void 0 ? t.escapeValue : !0, this.useRawValueToEscape = t.useRawValueToEscape !== void 0 ? t.useRawValueToEscape : !1, this.prefix = t.prefix ? uo(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? uo(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? uo(t.nestingPrefix) : t.nestingPrefixEscaped || uo("$t("), this.nestingSuffix = t.nestingSuffix ? uo(t.nestingSuffix) : t.nestingSuffixEscaped || uo(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = t.alwaysFormat !== void 0 ? t.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const n = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = n(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = n(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = n(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(n, t, r, o) {
    let s, a, i;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function l(m) {
      return m.replace(/\$/g, "$$$$");
    }
    const u = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const v = od(t, c, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(v, void 0, r, {
          ...o,
          ...t,
          interpolationkey: m
        }) : v;
      }
      const h = m.split(this.formatSeparator), y = h.shift().trim(), C = h.join(this.formatSeparator).trim();
      return this.format(od(t, c, y, this.options.keySeparator, this.options.ignoreJSONStructure), C, r, {
        ...o,
        ...t,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const d = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, f = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => l(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? l(this.escape(m)) : l(m)
    }].forEach((m) => {
      for (i = 0; s = m.regex.exec(n); ) {
        const h = s[1].trim();
        if (a = u(h), a === void 0)
          if (typeof d == "function") {
            const C = d(n, s, o);
            a = typeof C == "string" ? C : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, h))
            a = "";
          else if (f) {
            a = s[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${n}`), a = "";
        else
          typeof a != "string" && !this.useRawValueToEscape && (a = X2(a));
        const y = m.safeValue(a);
        if (n = n.replace(s[0], y), f ? (m.regex.lastIndex += a.length, m.regex.lastIndex -= s[0].length) : m.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), n;
  }
  nest(n, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, s, a;
    function i(c, l) {
      const u = this.nestingOptionsSeparator;
      if (c.indexOf(u) < 0)
        return c;
      const d = c.split(new RegExp(`${u}[ ]*{`));
      let f = `{${d[1]}`;
      c = d[0], f = this.interpolate(f, a);
      const p = f.match(/'/g), m = f.match(/"/g);
      (p && p.length % 2 === 0 && !m || m.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        a = JSON.parse(f), l && (a = {
          ...l,
          ...a
        });
      } catch (h) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, h), `${c}${u}${f}`;
      }
      return delete a.defaultValue, c;
    }
    for (; o = this.nestingRegexp.exec(n); ) {
      let c = [];
      a = {
        ...r
      }, a = a.replace && typeof a.replace != "string" ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let l = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const u = o[1].split(this.formatSeparator).map((d) => d.trim());
        o[1] = u.shift(), c = u, l = !0;
      }
      if (s = t(i.call(this, o[1].trim(), a), a), s && o[0] === n && typeof s != "string")
        return s;
      typeof s != "string" && (s = X2(s)), s || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${n}`), s = ""), l && (s = c.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: o[1].trim()
      }), s.trim())), n = n.replace(o[0], s), this.regexp.lastIndex = 0;
    }
    return n;
  }
}
function eg(e) {
  let n = e.toLowerCase().trim();
  const t = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    n = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    n === "currency" && o.indexOf(":") < 0 ? t.currency || (t.currency = o.trim()) : n === "relativetime" && o.indexOf(":") < 0 ? t.range || (t.range = o.trim()) : o.split(";").forEach((a) => {
      if (!a)
        return;
      const [i, ...c] = a.split(":"), l = c.join(":").trim().replace(/^'+|'+$/g, "");
      t[i.trim()] || (t[i.trim()] = l), l === "false" && (t[i.trim()] = !1), l === "true" && (t[i.trim()] = !0), isNaN(l) || (t[i.trim()] = parseInt(l, 10));
    });
  }
  return {
    formatName: n,
    formatOptions: t
  };
}
function fo(e) {
  const n = {};
  return function(r, o, s) {
    const a = o + JSON.stringify(s);
    let i = n[a];
    return i || (i = e(li(o), s), n[a] = i), i(r);
  };
}
class tg {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = wn.create("formatter"), this.options = n, this.formats = {
      number: fo((t, r) => {
        const o = new Intl.NumberFormat(t, {
          ...r
        });
        return (s) => o.format(s);
      }),
      currency: fo((t, r) => {
        const o = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (s) => o.format(s);
      }),
      datetime: fo((t, r) => {
        const o = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (s) => o.format(s);
      }),
      relativetime: fo((t, r) => {
        const o = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (s) => o.format(s, r.range || "day");
      }),
      list: fo((t, r) => {
        const o = new Intl.ListFormat(t, {
          ...r
        });
        return (s) => o.format(s);
      })
    }, this.init(n);
  }
  init(n) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(n, t) {
    this.formats[n.toLowerCase().trim()] = t;
  }
  addCached(n, t) {
    this.formats[n.toLowerCase().trim()] = fo(t);
  }
  format(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return t.split(this.formatSeparator).reduce((i, c) => {
      const {
        formatName: l,
        formatOptions: u
      } = eg(c);
      if (this.formats[l]) {
        let d = i;
        try {
          const f = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, p = f.locale || f.lng || o.locale || o.lng || r;
          d = this.formats[l](i, p, {
            ...u,
            ...o,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, n);
  }
}
function ng(e, n) {
  e.pending[n] !== void 0 && (delete e.pending[n], e.pendingCount--);
}
class rg extends Hi {
  constructor(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = n, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = wn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(n, t, r, o) {
    const s = {}, a = {}, i = {}, c = {};
    return n.forEach((l) => {
      let u = !0;
      t.forEach((d) => {
        const f = `${l}|${d}`;
        !r.reload && this.store.hasResourceBundle(l, d) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? a[f] === void 0 && (a[f] = !0) : (this.state[f] = 1, u = !1, a[f] === void 0 && (a[f] = !0), s[f] === void 0 && (s[f] = !0), c[d] === void 0 && (c[d] = !0)));
      }), u || (i[l] = !0);
    }), (Object.keys(s).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(s),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(n, t, r) {
    const o = n.split("|"), s = o[0], a = o[1];
    t && this.emit("failedLoading", s, a, t), r && this.store.addResourceBundle(s, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[n] = t ? -1 : 2;
    const i = {};
    this.queue.forEach((c) => {
      $m(c.loaded, [s], a), ng(c, n), t && c.errors.push(t), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((l) => {
        i[l] || (i[l] = {});
        const u = c.loaded[l];
        u.length && u.forEach((d) => {
          i[l][d] === void 0 && (i[l][d] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((c) => !c.done);
  }
  read(n, t, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!n.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: n,
        ns: t,
        fcName: r,
        tried: o,
        wait: s,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const i = (l, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (l && u && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, n, t, r, o + 1, s * 2, a);
        }, s);
        return;
      }
      a(l, u);
    }, c = this.backend[r].bind(this.backend);
    if (c.length === 2) {
      try {
        const l = c(n, t);
        l && typeof l.then == "function" ? l.then((u) => i(null, u)).catch(i) : i(null, l);
      } catch (l) {
        i(l);
      }
      return;
    }
    return c(n, t, i);
  }
  prepareLoading(n, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    typeof n == "string" && (n = this.languageUtils.toResolveHierarchy(n)), typeof t == "string" && (t = [t]);
    const s = this.queueLoad(n, t, r, o);
    if (!s.toLoad.length)
      return s.pending.length || o(), null;
    s.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(n, t, r) {
    this.prepareLoading(n, t, {}, r);
  }
  reload(n, t, r) {
    this.prepareLoading(n, t, {
      reload: !0
    }, r);
  }
  loadOne(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = n.split("|"), o = r[0], s = r[1];
    this.read(o, s, "read", void 0, void 0, (a, i) => {
      a && this.logger.warn(`${t}loading namespace ${s} for language ${o} failed`, a), !a && i && this.logger.log(`${t}loaded namespace ${s} for language ${o}`, i), this.loaded(n, a, i);
    });
  }
  saveMissing(n, t, r, o, s) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, i = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const c = {
          ...a,
          isUpdate: s
        }, l = this.backend.create.bind(this.backend);
        if (l.length < 6)
          try {
            let u;
            l.length === 5 ? u = l(n, t, r, o, c) : u = l(n, t, r, o), u && typeof u.then == "function" ? u.then((d) => i(null, d)).catch(i) : i(null, u);
          } catch (u) {
            i(u);
          }
        else
          l(n, t, r, o, i, c);
      }
      !n || !n[0] || this.store.addResource(n[0], t, r, o);
    }
  }
}
function sd() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(n) {
      let t = {};
      if (typeof n[1] == "object" && (t = n[1]), typeof n[1] == "string" && (t.defaultValue = n[1]), typeof n[2] == "string" && (t.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
        const r = n[3] || n[2];
        Object.keys(r).forEach((o) => {
          t[o] = r[o];
        });
      }
      return t;
    },
    interpolation: {
      escapeValue: !0,
      format: (e) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function ad(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function ya() {
}
function og(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
}
class Ls extends Hi {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ad(n), this.services = {}, this.logger = wn, this.modules = {
      external: []
    }, og(this), t && !this.isInitialized && !n.isClone) {
      if (!this.options.initImmediate)
        return this.init(n, t), this;
      setTimeout(() => {
        this.init(n, t);
      }, 0);
    }
  }
  init() {
    var n = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (typeof t.ns == "string" ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = sd();
    this.options = {
      ...o,
      ...this.options,
      ...ad(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    function s(u) {
      return u ? typeof u == "function" ? new u() : u : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? wn.init(s(this.modules.logger), this.options) : wn.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = tg);
      const d = new nd(this.options);
      this.store = new ed(this.options.resources, this.options);
      const f = this.services;
      f.logger = wn, f.resourceStore = this.store, f.languageUtils = d, f.pluralResolver = new Xm(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (f.formatter = s(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new Jm(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new rg(s(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(p) {
        for (var m = arguments.length, h = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          h[y - 1] = arguments[y];
        n.emit(p, ...h);
      }), this.modules.languageDetector && (f.languageDetector = s(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = s(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new ui(this.services, this.options), this.translator.on("*", function(p) {
        for (var m = arguments.length, h = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          h[y - 1] = arguments[y];
        n.emit(p, ...h);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = ya), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments), n;
      };
    });
    const c = ss(), l = () => {
      const u = (d, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), c.resolve(f), r(d, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), c;
  }
  loadResources(n) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ya;
    const o = typeof n == "string" ? n : this.language;
    if (typeof n == "function" && (r = n), !this.options.resources || this.options.partialBundledLanguages) {
      if (o && o.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const s = [], a = (i) => {
        if (!i || i === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(i).forEach((l) => {
          l !== "cimode" && s.indexOf(l) < 0 && s.push(l);
        });
      };
      o ? a(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => a(c)), this.options.preload && this.options.preload.forEach((i) => a(i)), this.services.backendConnector.load(s, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(i);
      });
    } else
      r(null);
  }
  reloadResources(n, t, r) {
    const o = ss();
    return n || (n = this.languages), t || (t = this.options.ns), r || (r = ya), this.services.backendConnector.reload(n, t, (s) => {
      o.resolve(), r(s);
    }), o;
  }
  use(n) {
    if (!n)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!n.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return n.type === "backend" && (this.modules.backend = n), (n.type === "logger" || n.log && n.warn && n.error) && (this.modules.logger = n), n.type === "languageDetector" && (this.modules.languageDetector = n), n.type === "i18nFormat" && (this.modules.i18nFormat = n), n.type === "postProcessor" && Hp.addPostProcessor(n), n.type === "formatter" && (this.modules.formatter = n), n.type === "3rdParty" && this.modules.external.push(n), this;
  }
  setResolvedLanguage(n) {
    if (!(!n || !this.languages) && !(["cimode", "dev"].indexOf(n) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(n, t) {
    var r = this;
    this.isLanguageChangingTo = n;
    const o = ss();
    this.emit("languageChanging", n);
    const s = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, a = (c, l) => {
      l ? (s(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), t && t(c, function() {
        return r.t(...arguments);
      });
    }, i = (c) => {
      !n && !c && this.services.languageDetector && (c = []);
      const l = typeof c == "string" ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      l && (this.language || s(l), this.translator.language || this.translator.changeLanguage(l), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(l)), this.loadResources(l, (u) => {
        a(u, l);
      });
    };
    return !n && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !n && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(n), o;
  }
  getFixedT(n, t, r) {
    var o = this;
    const s = function(a, i) {
      let c;
      if (typeof i != "object") {
        for (var l = arguments.length, u = new Array(l > 2 ? l - 2 : 0), d = 2; d < l; d++)
          u[d - 2] = arguments[d];
        c = o.options.overloadTranslationOptionHandler([a, i].concat(u));
      } else
        c = {
          ...i
        };
      c.lng = c.lng || s.lng, c.lngs = c.lngs || s.lngs, c.ns = c.ns || s.ns, c.keyPrefix = c.keyPrefix || r || s.keyPrefix;
      const f = o.options.keySeparator || ".";
      let p;
      return c.keyPrefix && Array.isArray(a) ? p = a.map((m) => `${c.keyPrefix}${f}${m}`) : p = c.keyPrefix ? `${c.keyPrefix}${f}${a}` : a, o.t(p, c);
    };
    return typeof n == "string" ? s.lng = n : s.lngs = n, s.ns = t, s.keyPrefix = r, s;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(n) {
    this.options.defaultNS = n;
  }
  hasLoadedNamespace(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const a = (i, c) => {
      const l = this.services.backendConnector.state[`${i}|${c}`];
      return l === -1 || l === 2;
    };
    if (t.precheck) {
      const i = t.precheck(this, a);
      if (i !== void 0)
        return i;
    }
    return !!(this.hasResourceBundle(r, n) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, n) && (!o || a(s, n)));
  }
  loadNamespaces(n, t) {
    const r = ss();
    return this.options.ns ? (typeof n == "string" && (n = [n]), n.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), t && t(o);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(n, t) {
    const r = ss();
    typeof n == "string" && (n = [n]);
    const o = this.options.preload || [], s = n.filter((a) => o.indexOf(a) < 0);
    return s.length ? (this.options.preload = o.concat(s), this.loadResources((a) => {
      r.resolve(), t && t(a);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(n) {
    if (n || (n = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !n)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new nd(sd());
    return t.indexOf(r.getLanguagePartFromCode(n)) > -1 || n.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Ls(n, t);
  }
  cloneInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ya;
    const r = n.forkResourceStore;
    r && delete n.forkResourceStore;
    const o = {
      ...this.options,
      ...n,
      isClone: !0
    }, s = new Ls(o);
    return (n.debug !== void 0 || n.prefix !== void 0) && (s.logger = s.logger.clone(n)), ["store", "services", "language"].forEach((i) => {
      s[i] = this[i];
    }), s.services = {
      ...this.services
    }, s.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, r && (s.store = new ed(this.store.data, o), s.services.resourceStore = s.store), s.translator = new ui(s.services, o), s.translator.on("*", function(i) {
      for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
        l[u - 1] = arguments[u];
      s.emit(i, ...l);
    }), s.init(o, t), s.translator.options = o, s.translator.backendConnector.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, s;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ot = Ls.createInstance();
ot.createInstance = Ls.createInstance;
ot.createInstance;
ot.dir;
ot.init;
ot.loadResources;
ot.reloadResources;
ot.use;
ot.changeLanguage;
ot.getFixedT;
ot.t;
ot.exists;
ot.setDefaultNamespace;
ot.hasLoadedNamespace;
ot.loadNamespaces;
ot.loadLanguages;
function sg(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Ts(e) {
  "@babel/helpers - typeof";
  return Ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ts(e);
}
function ag(e, n) {
  if (Ts(e) != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (Ts(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function ig(e) {
  var n = ag(e, "string");
  return Ts(n) == "symbol" ? n : String(n);
}
function id(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ig(r.key), r);
  }
}
function cg(e, n, t) {
  return n && id(e.prototype, n), t && id(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var Up = [], lg = Up.forEach, ug = Up.slice;
function dg(e) {
  return lg.call(ug.call(arguments, 1), function(n) {
    if (n)
      for (var t in n)
        e[t] === void 0 && (e[t] = n[t]);
  }), e;
}
var cd = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, fg = function(n, t, r) {
  var o = r || {};
  o.path = o.path || "/";
  var s = encodeURIComponent(t), a = "".concat(n, "=").concat(s);
  if (o.maxAge > 0) {
    var i = o.maxAge - 0;
    if (Number.isNaN(i))
      throw new Error("maxAge should be a Number");
    a += "; Max-Age=".concat(Math.floor(i));
  }
  if (o.domain) {
    if (!cd.test(o.domain))
      throw new TypeError("option domain is invalid");
    a += "; Domain=".concat(o.domain);
  }
  if (o.path) {
    if (!cd.test(o.path))
      throw new TypeError("option path is invalid");
    a += "; Path=".concat(o.path);
  }
  if (o.expires) {
    if (typeof o.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    a += "; Expires=".concat(o.expires.toUTCString());
  }
  if (o.httpOnly && (a += "; HttpOnly"), o.secure && (a += "; Secure"), o.sameSite) {
    var c = typeof o.sameSite == "string" ? o.sameSite.toLowerCase() : o.sameSite;
    switch (c) {
      case !0:
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return a;
}, ld = {
  create: function(n, t, r, o) {
    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (s.expires = /* @__PURE__ */ new Date(), s.expires.setTime(s.expires.getTime() + r * 60 * 1e3)), o && (s.domain = o), document.cookie = fg(n, encodeURIComponent(t), s);
  },
  read: function(n) {
    for (var t = "".concat(n, "="), r = document.cookie.split(";"), o = 0; o < r.length; o++) {
      for (var s = r[o]; s.charAt(0) === " "; )
        s = s.substring(1, s.length);
      if (s.indexOf(t) === 0)
        return s.substring(t.length, s.length);
    }
    return null;
  },
  remove: function(n) {
    this.create(n, "", -1);
  }
}, pg = {
  name: "cookie",
  lookup: function(n) {
    var t;
    if (n.lookupCookie && typeof document < "u") {
      var r = ld.read(n.lookupCookie);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(n, t) {
    t.lookupCookie && typeof document < "u" && ld.create(t.lookupCookie, n, t.cookieMinutes, t.cookieDomain, t.cookieOptions);
  }
}, hg = {
  name: "querystring",
  lookup: function(n) {
    var t;
    if (typeof window < "u") {
      var r = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var o = r.substring(1), s = o.split("&"), a = 0; a < s.length; a++) {
        var i = s[a].indexOf("=");
        if (i > 0) {
          var c = s[a].substring(0, i);
          c === n.lookupQuerystring && (t = s[a].substring(i + 1));
        }
      }
    }
    return t;
  }
}, as = null, ud = function() {
  if (as !== null)
    return as;
  try {
    as = window !== "undefined" && window.localStorage !== null;
    var n = "i18next.translate.boo";
    window.localStorage.setItem(n, "foo"), window.localStorage.removeItem(n);
  } catch {
    as = !1;
  }
  return as;
}, mg = {
  name: "localStorage",
  lookup: function(n) {
    var t;
    if (n.lookupLocalStorage && ud()) {
      var r = window.localStorage.getItem(n.lookupLocalStorage);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(n, t) {
    t.lookupLocalStorage && ud() && window.localStorage.setItem(t.lookupLocalStorage, n);
  }
}, is = null, dd = function() {
  if (is !== null)
    return is;
  try {
    is = window !== "undefined" && window.sessionStorage !== null;
    var n = "i18next.translate.boo";
    window.sessionStorage.setItem(n, "foo"), window.sessionStorage.removeItem(n);
  } catch {
    is = !1;
  }
  return is;
}, gg = {
  name: "sessionStorage",
  lookup: function(n) {
    var t;
    if (n.lookupSessionStorage && dd()) {
      var r = window.sessionStorage.getItem(n.lookupSessionStorage);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(n, t) {
    t.lookupSessionStorage && dd() && window.sessionStorage.setItem(t.lookupSessionStorage, n);
  }
}, yg = {
  name: "navigator",
  lookup: function(n) {
    var t = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          t.push(navigator.languages[r]);
      navigator.userLanguage && t.push(navigator.userLanguage), navigator.language && t.push(navigator.language);
    }
    return t.length > 0 ? t : void 0;
  }
}, vg = {
  name: "htmlTag",
  lookup: function(n) {
    var t, r = n.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (t = r.getAttribute("lang")), t;
  }
}, bg = {
  name: "path",
  lookup: function(n) {
    var t;
    if (typeof window < "u") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof n.lookupFromPathIndex == "number") {
          if (typeof r[n.lookupFromPathIndex] != "string")
            return;
          t = r[n.lookupFromPathIndex].replace("/", "");
        } else
          t = r[0].replace("/", "");
    }
    return t;
  }
}, Cg = {
  name: "subdomain",
  lookup: function(n) {
    var t = typeof n.lookupFromSubdomainIndex == "number" ? n.lookupFromSubdomainIndex + 1 : 1, r = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (r)
      return r[t];
  }
};
function wg() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(n) {
      return n;
    }
  };
}
var Wp = /* @__PURE__ */ function() {
  function e(n) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    sg(this, e), this.type = "languageDetector", this.detectors = {}, this.init(n, t);
  }
  return cg(e, [{
    key: "init",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = t || {
        languageUtils: {}
      }, this.options = dg(r, this.options || {}, wg()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(s) {
        return s.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = o, this.addDetector(pg), this.addDetector(hg), this.addDetector(mg), this.addDetector(gg), this.addDetector(yg), this.addDetector(vg), this.addDetector(bg), this.addDetector(Cg);
    }
  }, {
    key: "addDetector",
    value: function(t) {
      this.detectors[t.name] = t;
    }
  }, {
    key: "detect",
    value: function(t) {
      var r = this;
      t || (t = this.options.order);
      var o = [];
      return t.forEach(function(s) {
        if (r.detectors[s]) {
          var a = r.detectors[s].lookup(r.options);
          a && typeof a == "string" && (a = [a]), a && (o = o.concat(a));
        }
      }), o = o.map(function(s) {
        return r.options.convertDetectedLanguage(s);
      }), this.services.languageUtils.getBestMatchFromCodes ? o : o.length > 0 ? o[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(t, r) {
      var o = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(t) > -1 || r.forEach(function(s) {
        o.detectors[s] && o.detectors[s].cacheUserLanguage(t, o.options);
      }));
    }
  }]), e;
}();
Wp.type = "languageDetector";
var xg = function(n) {
  return {
    type: "backend",
    init: function(r, o, s) {
    },
    read: function(r, o, s) {
      if (typeof n == "function") {
        if (n.length < 3) {
          try {
            var a = n(r, o);
            a && typeof a.then == "function" ? a.then(function(i) {
              return s(null, i && i.default || i);
            }).catch(s) : s(null, a);
          } catch (i) {
            s(i);
          }
          return;
        }
        n(r, o, s);
        return;
      }
      s(null, n && n[r] && n[r][o]);
    }
  };
};
const Dg = [".dev", "default", "empty"], Sg = {
  lng: "base",
  fallbackLng: "base",
  debug: process.env.NODE_ENV === "development",
  interpolation: {
    escapeValue: !1
  },
  ns: Dg,
  fallbackNS: ["default", "empty"],
  defaultNS: ".dev",
  react: {
    transSupportBasicHtmlNodes: !0,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "u", "span"],
    useSuspense: !0,
    hashTransKey(e) {
      return !e.includes("<a>");
    }
  }
}, Eg = async (e, n, t) => {
  const r = n === "empty" ? "" : n;
  try {
    const o = n === "default" ? await Q2(/* @__PURE__ */ Object.assign({ "./src/assets/locales/ditto__base.dev.json": () => import("./ditto__base.dev-6H3xhT7Z.js"), "./src/assets/locales/ditto__base.json": () => import("./ditto__base-BV45UJ67.js") }), `./src/assets/locales/ditto__${e}.json`) : await Q2(/* @__PURE__ */ Object.assign({ "./src/assets/locales/ditto__base.dev.json": () => import("./ditto__base.dev-6H3xhT7Z.js"), "./src/assets/locales/ditto__base.json": () => import("./ditto__base-BV45UJ67.js") }), `./src/assets/locales/ditto__${e}${r}.json`);
    t(null, o);
  } catch (o) {
    t(o, null);
  }
};
ot.use(xg(Eg)).use(q5).use(Wp).init(Sg);
function _g(e) {
  const [n, t] = K(!1), r = async () => {
    const {
      worker: o
    } = await import("./browser-CGlpe9r1.js");
    await o.start({
      onUnhandledRequest(s, a) {
        s.url.includes("cdnfonts") || s.url.includes("/favicon") || a.warning();
      }
    }), t(!0);
  };
  return W(() => {
    if (e !== "mock" || typeof window > "u") {
      t(!0);
      return;
    }
    r();
  }, [e]), n;
}
function Ui(e) {
  const {
    state: n,
    actions: t
  } = ue(), {
    activePage: r
  } = n, o = () => {
    t({
      type: "set_is_loading",
      page: "transition",
      payload: !1
    });
  };
  return W(() => {
    t({
      type: "set_is_loading",
      page: "transition",
      payload: !0
    });
  }, [r, e]), {
    onTransitionEnd: o
  };
}
function Zp(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: Mg } = Object.prototype, { getPrototypeOf: j1 } = Object, Wi = /* @__PURE__ */ ((e) => (n) => {
  const t = Mg.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ln = (e) => (e = e.toLowerCase(), (n) => Wi(n) === e), Zi = (e) => (n) => typeof n === e, { isArray: zo } = Array, Ps = Zi("undefined");
function kg(e) {
  return e !== null && !Ps(e) && e.constructor !== null && !Ps(e.constructor) && nn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Kp = Ln("ArrayBuffer");
function Ag(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Kp(e.buffer), n;
}
const Ng = Zi("string"), nn = Zi("function"), zp = Zi("number"), Ki = (e) => e !== null && typeof e == "object", Lg = (e) => e === !0 || e === !1, Fa = (e) => {
  if (Wi(e) !== "object")
    return !1;
  const n = j1(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Tg = Ln("Date"), Pg = Ln("File"), Og = Ln("Blob"), Rg = Ln("FileList"), Ig = (e) => Ki(e) && nn(e.pipe), Fg = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || nn(e.append) && ((n = Wi(e)) === "formdata" || // detect form-data instance
  n === "object" && nn(e.toString) && e.toString() === "[object FormData]"));
}, Vg = Ln("URLSearchParams"), $g = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Qs(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), zo(e))
    for (r = 0, o = e.length; r < o; r++)
      n.call(null, e[r], r, e);
  else {
    const s = t ? Object.getOwnPropertyNames(e) : Object.keys(e), a = s.length;
    let i;
    for (r = 0; r < a; r++)
      i = s[r], n.call(null, e[i], i, e);
  }
}
function Gp(e, n) {
  n = n.toLowerCase();
  const t = Object.keys(e);
  let r = t.length, o;
  for (; r-- > 0; )
    if (o = t[r], n === o.toLowerCase())
      return o;
  return null;
}
const qp = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Qp = (e) => !Ps(e) && e !== qp;
function Pl() {
  const { caseless: e } = Qp(this) && this || {}, n = {}, t = (r, o) => {
    const s = e && Gp(n, o) || o;
    Fa(n[s]) && Fa(r) ? n[s] = Pl(n[s], r) : Fa(r) ? n[s] = Pl({}, r) : zo(r) ? n[s] = r.slice() : n[s] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Qs(arguments[r], t);
  return n;
}
const Bg = (e, n, t, { allOwnKeys: r } = {}) => (Qs(n, (o, s) => {
  t && nn(o) ? e[s] = Zp(o, t) : e[s] = o;
}, { allOwnKeys: r }), e), jg = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Yg = (e, n, t, r) => {
  e.prototype = Object.create(n.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, Hg = (e, n, t, r) => {
  let o, s, a;
  const i = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      a = o[s], (!r || r(a, e, n)) && !i[a] && (n[a] = e[a], i[a] = !0);
    e = t !== !1 && j1(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, Ug = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const r = e.indexOf(n, t);
  return r !== -1 && r === t;
}, Wg = (e) => {
  if (!e)
    return null;
  if (zo(e))
    return e;
  let n = e.length;
  if (!zp(n))
    return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, Zg = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && j1(Uint8Array)), Kg = (e, n) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const s = o.value;
    n.call(e, s[0], s[1]);
  }
}, zg = (e, n) => {
  let t;
  const r = [];
  for (; (t = e.exec(n)) !== null; )
    r.push(t);
  return r;
}, Gg = Ln("HTMLFormElement"), qg = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, o) {
    return r.toUpperCase() + o;
  }
), fd = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), Qg = Ln("RegExp"), Xp = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), r = {};
  Qs(t, (o, s) => {
    let a;
    (a = n(o, s, e)) !== !1 && (r[s] = a || o);
  }), Object.defineProperties(e, r);
}, Xg = (e) => {
  Xp(e, (n, t) => {
    if (nn(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const r = e[t];
    if (nn(r)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Jg = (e, n) => {
  const t = {}, r = (o) => {
    o.forEach((s) => {
      t[s] = !0;
    });
  };
  return zo(e) ? r(e) : r(String(e).split(n)), t;
}, ey = () => {
}, ty = (e, n) => (e = +e, Number.isFinite(e) ? e : n), Oc = "abcdefghijklmnopqrstuvwxyz", pd = "0123456789", Jp = {
  DIGIT: pd,
  ALPHA: Oc,
  ALPHA_DIGIT: Oc + Oc.toUpperCase() + pd
}, ny = (e = 16, n = Jp.ALPHA_DIGIT) => {
  let t = "";
  const { length: r } = n;
  for (; e--; )
    t += n[Math.random() * r | 0];
  return t;
};
function ry(e) {
  return !!(e && nn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const oy = (e) => {
  const n = new Array(10), t = (r, o) => {
    if (Ki(r)) {
      if (n.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        n[o] = r;
        const s = zo(r) ? [] : {};
        return Qs(r, (a, i) => {
          const c = t(a, o + 1);
          !Ps(c) && (s[i] = c);
        }), n[o] = void 0, s;
      }
    }
    return r;
  };
  return t(e, 0);
}, sy = Ln("AsyncFunction"), ay = (e) => e && (Ki(e) || nn(e)) && nn(e.then) && nn(e.catch), B = {
  isArray: zo,
  isArrayBuffer: Kp,
  isBuffer: kg,
  isFormData: Fg,
  isArrayBufferView: Ag,
  isString: Ng,
  isNumber: zp,
  isBoolean: Lg,
  isObject: Ki,
  isPlainObject: Fa,
  isUndefined: Ps,
  isDate: Tg,
  isFile: Pg,
  isBlob: Og,
  isRegExp: Qg,
  isFunction: nn,
  isStream: Ig,
  isURLSearchParams: Vg,
  isTypedArray: Zg,
  isFileList: Rg,
  forEach: Qs,
  merge: Pl,
  extend: Bg,
  trim: $g,
  stripBOM: jg,
  inherits: Yg,
  toFlatObject: Hg,
  kindOf: Wi,
  kindOfTest: Ln,
  endsWith: Ug,
  toArray: Wg,
  forEachEntry: Kg,
  matchAll: zg,
  isHTMLForm: Gg,
  hasOwnProperty: fd,
  hasOwnProp: fd,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Xp,
  freezeMethods: Xg,
  toObjectSet: Jg,
  toCamelCase: qg,
  noop: ey,
  toFiniteNumber: ty,
  findKey: Gp,
  global: qp,
  isContextDefined: Qp,
  ALPHABET: Jp,
  generateString: ny,
  isSpecCompliantForm: ry,
  toJSONObject: oy,
  isAsyncFn: sy,
  isThenable: ay
};
function Oe(e, n, t, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), r && (this.request = r), o && (this.response = o);
}
B.inherits(Oe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: B.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const e6 = Oe.prototype, t6 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  t6[e] = { value: e };
});
Object.defineProperties(Oe, t6);
Object.defineProperty(e6, "isAxiosError", { value: !0 });
Oe.from = (e, n, t, r, o, s) => {
  const a = Object.create(e6);
  return B.toFlatObject(e, a, function(c) {
    return c !== Error.prototype;
  }, (i) => i !== "isAxiosError"), Oe.call(a, e.message, n, t, r, o), a.cause = e, a.name = e.name, s && Object.assign(a, s), a;
};
const iy = null;
function Ol(e) {
  return B.isPlainObject(e) || B.isArray(e);
}
function n6(e) {
  return B.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function hd(e, n, t) {
  return e ? e.concat(n).map(function(o, s) {
    return o = n6(o), !t && s ? "[" + o + "]" : o;
  }).join(t ? "." : "") : n;
}
function cy(e) {
  return B.isArray(e) && !e.some(Ol);
}
const ly = B.toFlatObject(B, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function zi(e, n, t) {
  if (!B.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = B.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, y) {
    return !B.isUndefined(y[h]);
  });
  const r = t.metaTokens, o = t.visitor || u, s = t.dots, a = t.indexes, c = (t.Blob || typeof Blob < "u" && Blob) && B.isSpecCompliantForm(n);
  if (!B.isFunction(o))
    throw new TypeError("visitor must be a function");
  function l(m) {
    if (m === null)
      return "";
    if (B.isDate(m))
      return m.toISOString();
    if (!c && B.isBlob(m))
      throw new Oe("Blob is not supported. Use a Buffer instead.");
    return B.isArrayBuffer(m) || B.isTypedArray(m) ? c && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, h, y) {
    let C = m;
    if (m && !y && typeof m == "object") {
      if (B.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), m = JSON.stringify(m);
      else if (B.isArray(m) && cy(m) || (B.isFileList(m) || B.endsWith(h, "[]")) && (C = B.toArray(m)))
        return h = n6(h), C.forEach(function(w, x) {
          !(B.isUndefined(w) || w === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? hd([h], x, s) : a === null ? h : h + "[]",
            l(w)
          );
        }), !1;
    }
    return Ol(m) ? !0 : (n.append(hd(y, h, s), l(m)), !1);
  }
  const d = [], f = Object.assign(ly, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: Ol
  });
  function p(m, h) {
    if (!B.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      d.push(m), B.forEach(m, function(C, v) {
        (!(B.isUndefined(C) || C === null) && o.call(
          n,
          C,
          B.isString(v) ? v.trim() : v,
          h,
          f
        )) === !0 && p(C, h ? h.concat(v) : [v]);
      }), d.pop();
    }
  }
  if (!B.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), n;
}
function md(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return n[r];
  });
}
function Y1(e, n) {
  this._pairs = [], e && zi(e, this, n);
}
const r6 = Y1.prototype;
r6.append = function(n, t) {
  this._pairs.push([n, t]);
};
r6.toString = function(n) {
  const t = n ? function(r) {
    return n.call(this, r, md);
  } : md;
  return this._pairs.map(function(o) {
    return t(o[0]) + "=" + t(o[1]);
  }, "").join("&");
};
function uy(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function o6(e, n, t) {
  if (!n)
    return e;
  const r = t && t.encode || uy, o = t && t.serialize;
  let s;
  if (o ? s = o(n, t) : s = B.isURLSearchParams(n) ? n.toString() : new Y1(n, t).toString(r), s) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class gd {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, r) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    B.forEach(this.handlers, function(r) {
      r !== null && n(r);
    });
  }
}
const s6 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, dy = typeof URLSearchParams < "u" ? URLSearchParams : Y1, fy = typeof FormData < "u" ? FormData : null, py = typeof Blob < "u" ? Blob : null, hy = {
  isBrowser: !0,
  classes: {
    URLSearchParams: dy,
    FormData: fy,
    Blob: py
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, a6 = typeof window < "u" && typeof document < "u", my = ((e) => a6 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), gy = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", yy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: a6,
  hasStandardBrowserEnv: my,
  hasStandardBrowserWebWorkerEnv: gy
}, Symbol.toStringTag, { value: "Module" })), xn = {
  ...yy,
  ...hy
};
function vy(e, n) {
  return zi(e, new xn.classes.URLSearchParams(), Object.assign({
    visitor: function(t, r, o, s) {
      return xn.isNode && B.isBuffer(t) ? (this.append(r, t.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function by(e) {
  return B.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function Cy(e) {
  const n = {}, t = Object.keys(e);
  let r;
  const o = t.length;
  let s;
  for (r = 0; r < o; r++)
    s = t[r], n[s] = e[s];
  return n;
}
function i6(e) {
  function n(t, r, o, s) {
    let a = t[s++];
    if (a === "__proto__")
      return !0;
    const i = Number.isFinite(+a), c = s >= t.length;
    return a = !a && B.isArray(o) ? o.length : a, c ? (B.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !i) : ((!o[a] || !B.isObject(o[a])) && (o[a] = []), n(t, r, o[a], s) && B.isArray(o[a]) && (o[a] = Cy(o[a])), !i);
  }
  if (B.isFormData(e) && B.isFunction(e.entries)) {
    const t = {};
    return B.forEachEntry(e, (r, o) => {
      n(by(r), o, t, 0);
    }), t;
  }
  return null;
}
function wy(e, n, t) {
  if (B.isString(e))
    try {
      return (n || JSON.parse)(e), B.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(e);
}
const H1 = {
  transitional: s6,
  adapter: ["xhr", "http"],
  transformRequest: [function(n, t) {
    const r = t.getContentType() || "", o = r.indexOf("application/json") > -1, s = B.isObject(n);
    if (s && B.isHTMLForm(n) && (n = new FormData(n)), B.isFormData(n))
      return o ? JSON.stringify(i6(n)) : n;
    if (B.isArrayBuffer(n) || B.isBuffer(n) || B.isStream(n) || B.isFile(n) || B.isBlob(n))
      return n;
    if (B.isArrayBufferView(n))
      return n.buffer;
    if (B.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let i;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return vy(n, this.formSerializer).toString();
      if ((i = B.isFileList(n)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return zi(
          i ? { "files[]": n } : n,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return s || o ? (t.setContentType("application/json", !1), wy(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || H1.transitional, r = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (n && B.isString(n) && (r && !this.responseType || o)) {
      const a = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(n);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? Oe.from(i, Oe.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: xn.classes.FormData,
    Blob: xn.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
B.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  H1.headers[e] = {};
});
const U1 = H1, xy = B.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Dy = (e) => {
  const n = {};
  let t, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), t = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!t || n[t] && xy[t]) && (t === "set-cookie" ? n[t] ? n[t].push(r) : n[t] = [r] : n[t] = n[t] ? n[t] + ", " + r : r);
  }), n;
}, yd = Symbol("internals");
function cs(e) {
  return e && String(e).trim().toLowerCase();
}
function Va(e) {
  return e === !1 || e == null ? e : B.isArray(e) ? e.map(Va) : String(e);
}
function Sy(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = t.exec(e); )
    n[r[1]] = r[2];
  return n;
}
const Ey = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Rc(e, n, t, r, o) {
  if (B.isFunction(r))
    return r.call(this, n, t);
  if (o && (n = t), !!B.isString(n)) {
    if (B.isString(r))
      return n.indexOf(r) !== -1;
    if (B.isRegExp(r))
      return r.test(n);
  }
}
function _y(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, r) => t.toUpperCase() + r);
}
function My(e, n) {
  const t = B.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + t, {
      value: function(o, s, a) {
        return this[r].call(this, n, o, s, a);
      },
      configurable: !0
    });
  });
}
let Gi = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, r) {
    const o = this;
    function s(i, c, l) {
      const u = cs(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = B.findKey(o, u);
      (!d || o[d] === void 0 || l === !0 || l === void 0 && o[d] !== !1) && (o[d || c] = Va(i));
    }
    const a = (i, c) => B.forEach(i, (l, u) => s(l, u, c));
    return B.isPlainObject(n) || n instanceof this.constructor ? a(n, t) : B.isString(n) && (n = n.trim()) && !Ey(n) ? a(Dy(n), t) : n != null && s(t, n, r), this;
  }
  get(n, t) {
    if (n = cs(n), n) {
      const r = B.findKey(this, n);
      if (r) {
        const o = this[r];
        if (!t)
          return o;
        if (t === !0)
          return Sy(o);
        if (B.isFunction(t))
          return t.call(this, o, r);
        if (B.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = cs(n), n) {
      const r = B.findKey(this, n);
      return !!(r && this[r] !== void 0 && (!t || Rc(this, this[r], r, t)));
    }
    return !1;
  }
  delete(n, t) {
    const r = this;
    let o = !1;
    function s(a) {
      if (a = cs(a), a) {
        const i = B.findKey(r, a);
        i && (!t || Rc(r, r[i], i, t)) && (delete r[i], o = !0);
      }
    }
    return B.isArray(n) ? n.forEach(s) : s(n), o;
  }
  clear(n) {
    const t = Object.keys(this);
    let r = t.length, o = !1;
    for (; r--; ) {
      const s = t[r];
      (!n || Rc(this, this[s], s, n, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(n) {
    const t = this, r = {};
    return B.forEach(this, (o, s) => {
      const a = B.findKey(r, s);
      if (a) {
        t[a] = Va(o), delete t[s];
        return;
      }
      const i = n ? _y(s) : String(s).trim();
      i !== s && delete t[s], t[i] = Va(o), r[i] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return B.forEach(this, (r, o) => {
      r != null && r !== !1 && (t[o] = n && B.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const r = new this(n);
    return t.forEach((o) => r.set(o)), r;
  }
  static accessor(n) {
    const r = (this[yd] = this[yd] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(a) {
      const i = cs(a);
      r[i] || (My(o, a), r[i] = !0);
    }
    return B.isArray(n) ? n.forEach(s) : s(n), this;
  }
};
Gi.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
B.reduceDescriptors(Gi.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(r) {
      this[t] = r;
    }
  };
});
B.freezeMethods(Gi);
const Un = Gi;
function Ic(e, n) {
  const t = this || U1, r = n || t, o = Un.from(r.headers);
  let s = r.data;
  return B.forEach(e, function(i) {
    s = i.call(t, s, o.normalize(), n ? n.status : void 0);
  }), o.normalize(), s;
}
function c6(e) {
  return !!(e && e.__CANCEL__);
}
function Xs(e, n, t) {
  Oe.call(this, e ?? "canceled", Oe.ERR_CANCELED, n, t), this.name = "CanceledError";
}
B.inherits(Xs, Oe, {
  __CANCEL__: !0
});
function ky(e, n, t) {
  const r = t.config.validateStatus;
  !t.status || !r || r(t.status) ? e(t) : n(new Oe(
    "Request failed with status code " + t.status,
    [Oe.ERR_BAD_REQUEST, Oe.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const Ay = xn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, r, o, s) {
      const a = [e + "=" + encodeURIComponent(n)];
      B.isNumber(t) && a.push("expires=" + new Date(t).toGMTString()), B.isString(r) && a.push("path=" + r), B.isString(o) && a.push("domain=" + o), s === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ny(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Ly(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function l6(e, n) {
  return e && !Ny(n) ? Ly(e, n) : n;
}
const Ty = xn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const n = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let r;
    function o(s) {
      let a = s;
      return n && (t.setAttribute("href", a), a = t.href), t.setAttribute("href", a), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const i = B.isString(a) ? o(a) : a;
      return i.protocol === r.protocol && i.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function Py(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function Oy(e, n) {
  e = e || 10;
  const t = new Array(e), r = new Array(e);
  let o = 0, s = 0, a;
  return n = n !== void 0 ? n : 1e3, function(c) {
    const l = Date.now(), u = r[s];
    a || (a = l), t[o] = c, r[o] = l;
    let d = s, f = 0;
    for (; d !== o; )
      f += t[d++], d = d % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), l - a < n)
      return;
    const p = u && l - u;
    return p ? Math.round(f * 1e3 / p) : void 0;
  };
}
function vd(e, n) {
  let t = 0;
  const r = Oy(50, 250);
  return (o) => {
    const s = o.loaded, a = o.lengthComputable ? o.total : void 0, i = s - t, c = r(i), l = s <= a;
    t = s;
    const u = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: i,
      rate: c || void 0,
      estimated: c && a && l ? (a - s) / c : void 0,
      event: o
    };
    u[n ? "download" : "upload"] = !0, e(u);
  };
}
const Ry = typeof XMLHttpRequest < "u", Iy = Ry && function(e) {
  return new Promise(function(t, r) {
    let o = e.data;
    const s = Un.from(e.headers).normalize();
    let { responseType: a, withXSRFToken: i } = e, c;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c);
    }
    let u;
    if (B.isFormData(o)) {
      if (xn.hasStandardBrowserEnv || xn.hasStandardBrowserWebWorkerEnv)
        s.setContentType(!1);
      else if ((u = s.getContentType()) !== !1) {
        const [h, ...y] = u ? u.split(";").map((C) => C.trim()).filter(Boolean) : [];
        s.setContentType([h || "multipart/form-data", ...y].join("; "));
      }
    }
    let d = new XMLHttpRequest();
    if (e.auth) {
      const h = e.auth.username || "", y = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(h + ":" + y));
    }
    const f = l6(e.baseURL, e.url);
    d.open(e.method.toUpperCase(), o6(f, e.params, e.paramsSerializer), !0), d.timeout = e.timeout;
    function p() {
      if (!d)
        return;
      const h = Un.from(
        "getAllResponseHeaders" in d && d.getAllResponseHeaders()
      ), C = {
        data: !a || a === "text" || a === "json" ? d.responseText : d.response,
        status: d.status,
        statusText: d.statusText,
        headers: h,
        config: e,
        request: d
      };
      ky(function(w) {
        t(w), l();
      }, function(w) {
        r(w), l();
      }, C), d = null;
    }
    if ("onloadend" in d ? d.onloadend = p : d.onreadystatechange = function() {
      !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(p);
    }, d.onabort = function() {
      d && (r(new Oe("Request aborted", Oe.ECONNABORTED, e, d)), d = null);
    }, d.onerror = function() {
      r(new Oe("Network Error", Oe.ERR_NETWORK, e, d)), d = null;
    }, d.ontimeout = function() {
      let y = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const C = e.transitional || s6;
      e.timeoutErrorMessage && (y = e.timeoutErrorMessage), r(new Oe(
        y,
        C.clarifyTimeoutError ? Oe.ETIMEDOUT : Oe.ECONNABORTED,
        e,
        d
      )), d = null;
    }, xn.hasStandardBrowserEnv && (i && B.isFunction(i) && (i = i(e)), i || i !== !1 && Ty(f))) {
      const h = e.xsrfHeaderName && e.xsrfCookieName && Ay.read(e.xsrfCookieName);
      h && s.set(e.xsrfHeaderName, h);
    }
    o === void 0 && s.setContentType(null), "setRequestHeader" in d && B.forEach(s.toJSON(), function(y, C) {
      d.setRequestHeader(C, y);
    }), B.isUndefined(e.withCredentials) || (d.withCredentials = !!e.withCredentials), a && a !== "json" && (d.responseType = e.responseType), typeof e.onDownloadProgress == "function" && d.addEventListener("progress", vd(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", vd(e.onUploadProgress)), (e.cancelToken || e.signal) && (c = (h) => {
      d && (r(!h || h.type ? new Xs(null, e, d) : h), d.abort(), d = null);
    }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c)));
    const m = Py(f);
    if (m && xn.protocols.indexOf(m) === -1) {
      r(new Oe("Unsupported protocol " + m + ":", Oe.ERR_BAD_REQUEST, e));
      return;
    }
    d.send(o || null);
  });
}, Rl = {
  http: iy,
  xhr: Iy
};
B.forEach(Rl, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const bd = (e) => `- ${e}`, Fy = (e) => B.isFunction(e) || e === null || e === !1, u6 = {
  getAdapter: (e) => {
    e = B.isArray(e) ? e : [e];
    const { length: n } = e;
    let t, r;
    const o = {};
    for (let s = 0; s < n; s++) {
      t = e[s];
      let a;
      if (r = t, !Fy(t) && (r = Rl[(a = String(t)).toLowerCase()], r === void 0))
        throw new Oe(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(o).map(
        ([i, c]) => `adapter ${i} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = n ? s.length > 1 ? `since :
` + s.map(bd).join(`
`) : " " + bd(s[0]) : "as no adapter specified";
      throw new Oe(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Rl
};
function Fc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Xs(null, e);
}
function Cd(e) {
  return Fc(e), e.headers = Un.from(e.headers), e.data = Ic.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), u6.getAdapter(e.adapter || U1.adapter)(e).then(function(r) {
    return Fc(e), r.data = Ic.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Un.from(r.headers), r;
  }, function(r) {
    return c6(r) || (Fc(e), r && r.response && (r.response.data = Ic.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Un.from(r.response.headers))), Promise.reject(r);
  });
}
const wd = (e) => e instanceof Un ? e.toJSON() : e;
function Fo(e, n) {
  n = n || {};
  const t = {};
  function r(l, u, d) {
    return B.isPlainObject(l) && B.isPlainObject(u) ? B.merge.call({ caseless: d }, l, u) : B.isPlainObject(u) ? B.merge({}, u) : B.isArray(u) ? u.slice() : u;
  }
  function o(l, u, d) {
    if (B.isUndefined(u)) {
      if (!B.isUndefined(l))
        return r(void 0, l, d);
    } else
      return r(l, u, d);
  }
  function s(l, u) {
    if (!B.isUndefined(u))
      return r(void 0, u);
  }
  function a(l, u) {
    if (B.isUndefined(u)) {
      if (!B.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, u);
  }
  function i(l, u, d) {
    if (d in n)
      return r(l, u);
    if (d in e)
      return r(void 0, l);
  }
  const c = {
    url: s,
    method: s,
    data: s,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (l, u) => o(wd(l), wd(u), !0)
  };
  return B.forEach(Object.keys(Object.assign({}, e, n)), function(u) {
    const d = c[u] || o, f = d(e[u], n[u], u);
    B.isUndefined(f) && d !== i || (t[u] = f);
  }), t;
}
const d6 = "1.6.7", W1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  W1[e] = function(r) {
    return typeof r === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const xd = {};
W1.transitional = function(n, t, r) {
  function o(s, a) {
    return "[Axios v" + d6 + "] Transitional option '" + s + "'" + a + (r ? ". " + r : "");
  }
  return (s, a, i) => {
    if (n === !1)
      throw new Oe(
        o(a, " has been removed" + (t ? " in " + t : "")),
        Oe.ERR_DEPRECATED
      );
    return t && !xd[a] && (xd[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(s, a, i) : !0;
  };
};
function Vy(e, n, t) {
  if (typeof e != "object")
    throw new Oe("options must be an object", Oe.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const s = r[o], a = n[s];
    if (a) {
      const i = e[s], c = i === void 0 || a(i, s, e);
      if (c !== !0)
        throw new Oe("option " + s + " must be " + c, Oe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Oe("Unknown option " + s, Oe.ERR_BAD_OPTION);
  }
}
const Il = {
  assertOptions: Vy,
  validators: W1
}, er = Il.validators;
let di = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new gd(),
      response: new gd()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
      }
      throw r;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = Fo(this.defaults, t);
    const { transitional: r, paramsSerializer: o, headers: s } = t;
    r !== void 0 && Il.assertOptions(r, {
      silentJSONParsing: er.transitional(er.boolean),
      forcedJSONParsing: er.transitional(er.boolean),
      clarifyTimeoutError: er.transitional(er.boolean)
    }, !1), o != null && (B.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Il.assertOptions(o, {
      encode: er.function,
      serialize: er.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let a = s && B.merge(
      s.common,
      s[t.method]
    );
    s && B.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete s[m];
      }
    ), t.headers = Un.concat(a, s);
    const i = [];
    let c = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(t) === !1 || (c = c && h.synchronous, i.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let u, d = 0, f;
    if (!c) {
      const m = [Cd.bind(this), void 0];
      for (m.unshift.apply(m, i), m.push.apply(m, l), f = m.length, u = Promise.resolve(t); d < f; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    f = i.length;
    let p = t;
    for (d = 0; d < f; ) {
      const m = i[d++], h = i[d++];
      try {
        p = m(p);
      } catch (y) {
        h.call(this, y);
        break;
      }
    }
    try {
      u = Cd.call(this, p);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, f = l.length; d < f; )
      u = u.then(l[d++], l[d++]);
    return u;
  }
  getUri(n) {
    n = Fo(this.defaults, n);
    const t = l6(n.baseURL, n.url);
    return o6(t, n.params, n.paramsSerializer);
  }
};
B.forEach(["delete", "get", "head", "options"], function(n) {
  di.prototype[n] = function(t, r) {
    return this.request(Fo(r || {}, {
      method: n,
      url: t,
      data: (r || {}).data
    }));
  };
});
B.forEach(["post", "put", "patch"], function(n) {
  function t(r) {
    return function(s, a, i) {
      return this.request(Fo(i || {}, {
        method: n,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    };
  }
  di.prototype[n] = t(), di.prototype[n + "Form"] = t(!0);
});
const $a = di;
let $y = class f6 {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(s) {
      t = s;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const a = new Promise((i) => {
        r.subscribe(i), s = i;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(s);
      }, a;
    }, n(function(s, a, i) {
      r.reason || (r.reason = new Xs(s, a, i), t(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new f6(function(o) {
        n = o;
      }),
      cancel: n
    };
  }
};
const By = $y;
function jy(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Yy(e) {
  return B.isObject(e) && e.isAxiosError === !0;
}
const Fl = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Fl).forEach(([e, n]) => {
  Fl[n] = e;
});
const Hy = Fl;
function p6(e) {
  const n = new $a(e), t = Zp($a.prototype.request, n);
  return B.extend(t, $a.prototype, n, { allOwnKeys: !0 }), B.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(o) {
    return p6(Fo(e, o));
  }, t;
}
const Ze = p6(U1);
Ze.Axios = $a;
Ze.CanceledError = Xs;
Ze.CancelToken = By;
Ze.isCancel = c6;
Ze.VERSION = d6;
Ze.toFormData = zi;
Ze.AxiosError = Oe;
Ze.Cancel = Ze.CanceledError;
Ze.all = function(n) {
  return Promise.all(n);
};
Ze.spread = jy;
Ze.isAxiosError = Yy;
Ze.mergeConfig = Fo;
Ze.AxiosHeaders = Un;
Ze.formToJSON = (e) => i6(B.isHTMLForm(e) ? new FormData(e) : e);
Ze.getAdapter = u6.getAdapter;
Ze.HttpStatusCode = Hy;
Ze.default = Ze;
const {
  Axios: KA,
  AxiosError: zA,
  CanceledError: GA,
  isCancel: qA,
  CancelToken: QA,
  VERSION: XA,
  all: JA,
  Cancel: eN,
  isAxiosError: Zr,
  spread: tN,
  toFormData: nN,
  AxiosHeaders: rN,
  HttpStatusCode: oN,
  formToJSON: sN,
  getAdapter: aN,
  mergeConfig: iN
} = Ze, Uy = 24 * 1e3;
let h6, Vl, $l;
function Wy(e) {
  h6 = e;
}
function Z1(e) {
  $l = e;
}
function m6(e) {
  Vl = e;
}
const Zy = () => {
  const e = {
    apiKey: d0
  };
  return Vl && (e.authorization = `bearer ${Vl}`, e.cognito = "enabled"), $l && (e["x-state-correlation-id"] = $l), e;
}, qi = (e, n, t) => {
  const r = `${h6}/${n}`, o = Zy();
  return {
    method: e,
    crossDomain: !0,
    url: r,
    timeout: Uy,
    headers: {
      ...o,
      ...t
    }
  };
}, Ky = ({
  path: e,
  headers: n
}) => {
  const t = qi("GET", e, n);
  return Ze(t);
}, zy = ({
  path: e,
  body: n,
  headers: t
}) => {
  const r = qi("POST", e, t);
  return n && (r.data = n), Ze(r);
}, Gy = ({
  path: e,
  data: n,
  headers: t
}) => {
  const r = qi("PUT", e, t);
  return n && (r.data = n), Ze(r);
}, qy = ({
  path: e,
  data: n,
  headers: t
}) => {
  const r = qi("DELETE", e, t);
  return n && (r.data = n), Ze(r);
}, bt = {
  get: Ky,
  post: zy,
  put: Gy,
  remove: qy
};
var Js = (e) => e.type === "checkbox", ko = (e) => e instanceof Date, Pt = (e) => e == null;
const g6 = (e) => typeof e == "object";
var ft = (e) => !Pt(e) && !Array.isArray(e) && g6(e) && !ko(e), y6 = (e) => ft(e) && e.target ? Js(e.target) ? e.target.checked : e.target.value : e, Qy = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, v6 = (e, n) => e.has(Qy(n)), Xy = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ft(n) && n.hasOwnProperty("isPrototypeOf");
}, K1 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Vt(e) {
  let n;
  const t = Array.isArray(e);
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(K1 && (e instanceof Blob || e instanceof FileList)) && (t || ft(e)))
    if (n = t ? [] : {}, !t && !Xy(e))
      n = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (n[r] = Vt(e[r]));
  else
    return e;
  return n;
}
var ea = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, ee = (e, n, t) => {
  if (!n || !ft(e))
    return t;
  const r = ea(n.split(/[,[\].]+?/)).reduce((o, s) => Pt(o) ? o : o[s], e);
  return rt(r) || r === e ? rt(e[n]) ? t : e[n] : r;
}, sn = (e) => typeof e == "boolean";
const fi = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, an = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, On = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Jy = A.createContext(null), z1 = () => A.useContext(Jy);
var b6 = (e, n, t, r = !0) => {
  const o = {
    defaultValues: n._defaultValues
  };
  for (const s in e)
    Object.defineProperty(o, s, {
      get: () => {
        const a = s;
        return n._proxyFormState[a] !== an.all && (n._proxyFormState[a] = !r || an.all), t && (t[a] = !0), e[a];
      }
    });
  return o;
}, en = (e) => ft(e) && !Object.keys(e).length, C6 = (e, n, t, r) => {
  t(e);
  const { name: o, ...s } = e;
  return en(s) || Object.keys(s).length >= Object.keys(n).length || Object.keys(s).find((a) => n[a] === (!r || an.all));
}, Ba = (e) => Array.isArray(e) ? e : [e], w6 = (e, n, t) => !e || !n || e === n || Ba(e).some((r) => r && (t ? r === n : r.startsWith(n) || n.startsWith(r)));
function G1(e) {
  const n = A.useRef(e);
  n.current = e, A.useEffect(() => {
    const t = !e.disabled && n.current.subject && n.current.subject.subscribe({
      next: n.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function ev(e) {
  const n = z1(), { control: t = n.control, disabled: r, name: o, exact: s } = e || {}, [a, i] = A.useState(t._formState), c = A.useRef(!0), l = A.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = A.useRef(o);
  return u.current = o, G1({
    disabled: r,
    next: (d) => c.current && w6(u.current, d.name, s) && C6(d, l.current, t._updateFormState) && i({
      ...t._formState,
      ...d
    }),
    subject: t._subjects.state
  }), A.useEffect(() => (c.current = !0, l.current.isValid && t._updateValid(!0), () => {
    c.current = !1;
  }), [t]), b6(a, t, l.current, !1);
}
var Dn = (e) => typeof e == "string", x6 = (e, n, t, r, o) => Dn(e) ? (r && n.watch.add(e), ee(t, e, o)) : Array.isArray(e) ? e.map((s) => (r && n.watch.add(s), ee(t, s))) : (r && (n.watchAll = !0), t);
function tv(e) {
  const n = z1(), { control: t = n.control, name: r, defaultValue: o, disabled: s, exact: a } = e || {}, i = A.useRef(r);
  i.current = r, G1({
    disabled: s,
    subject: t._subjects.values,
    next: (u) => {
      w6(i.current, u.name, a) && l(Vt(x6(i.current, t._names, u.values || t._formValues, !1, o)));
    }
  });
  const [c, l] = A.useState(t._getWatch(r, o));
  return A.useEffect(() => t._removeUnmounted()), c;
}
var q1 = (e) => /^\w*$/.test(e), D6 = (e) => ea(e.replace(/["|']|\]/g, "").split(/\.|\[/)), He = (e, n, t) => {
  let r = -1;
  const o = q1(n) ? [n] : D6(n), s = o.length, a = s - 1;
  for (; ++r < s; ) {
    const i = o[r];
    let c = t;
    if (r !== a) {
      const l = e[i];
      c = ft(l) || Array.isArray(l) ? l : isNaN(+o[r + 1]) ? {} : [];
    }
    e[i] = c, e = e[i];
  }
  return e;
};
function Go(e) {
  const n = z1(), { name: t, disabled: r, control: o = n.control, shouldUnregister: s } = e, a = v6(o._names.array, t), i = tv({
    control: o,
    name: t,
    defaultValue: ee(o._formValues, t, ee(o._defaultValues, t, e.defaultValue)),
    exact: !0
  }), c = ev({
    control: o,
    name: t
  }), l = A.useRef(o.register(t, {
    ...e.rules,
    value: i,
    ...sn(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return A.useEffect(() => {
    const u = o._options.shouldUnregister || s, d = (f, p) => {
      const m = ee(o._fields, f);
      m && (m._f.mount = p);
    };
    if (d(t, !0), u) {
      const f = Vt(ee(o._options.defaultValues, t));
      He(o._defaultValues, t, f), rt(ee(o._formValues, t)) && He(o._formValues, t, f);
    }
    return () => {
      (a ? u && !o._state.action : u) ? o.unregister(t) : d(t, !1);
    };
  }, [t, o, a, s]), A.useEffect(() => {
    ee(o._fields, t) && o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: t,
      value: ee(o._fields, t)._f.value
    });
  }, [r, t, o]), {
    field: {
      name: t,
      value: i,
      ...sn(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: A.useCallback((u) => l.current.onChange({
        target: {
          value: y6(u),
          name: t
        },
        type: fi.CHANGE
      }), [t]),
      onBlur: A.useCallback(() => l.current.onBlur({
        target: {
          value: ee(o._formValues, t),
          name: t
        },
        type: fi.BLUR
      }), [t, o]),
      ref: (u) => {
        const d = ee(o._fields, t);
        d && u && (d._f.ref = {
          focus: () => u.focus(),
          select: () => u.select(),
          setCustomValidity: (f) => u.setCustomValidity(f),
          reportValidity: () => u.reportValidity()
        });
      }
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!ee(c.errors, t)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!ee(c.dirtyFields, t)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!ee(c.touchedFields, t)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!ee(c.validatingFields, t)
      },
      error: {
        enumerable: !0,
        get: () => ee(c.errors, t)
      }
    })
  };
}
var nv = (e, n, t, r, o) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [r]: o || !0
  }
} : {}, Dd = (e) => ({
  isOnSubmit: !e || e === an.onSubmit,
  isOnBlur: e === an.onBlur,
  isOnChange: e === an.onChange,
  isOnAll: e === an.all,
  isOnTouch: e === an.onTouched
}), Sd = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const xs = (e, n, t, r) => {
  for (const o of t || Object.keys(e)) {
    const s = ee(e, o);
    if (s) {
      const { _f: a, ...i } = s;
      if (a) {
        if (a.refs && a.refs[0] && n(a.refs[0], o) && !r)
          break;
        if (a.ref && n(a.ref, a.name) && !r)
          break;
        xs(i, n);
      } else
        ft(i) && xs(i, n);
    }
  }
};
var rv = (e, n, t) => {
  const r = ea(ee(e, t));
  return He(r, "root", n[t]), He(e, t, r), e;
}, Q1 = (e) => e.type === "file", lr = (e) => typeof e == "function", pi = (e) => {
  if (!K1)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, ja = (e) => Dn(e), X1 = (e) => e.type === "radio", hi = (e) => e instanceof RegExp;
const Ed = {
  value: !1,
  isValid: !1
}, _d = { value: !0, isValid: !0 };
var S6 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? _d : { value: e[0].value, isValid: !0 } : _d
    ) : Ed;
  }
  return Ed;
};
const Md = {
  isValid: !1,
  value: null
};
var E6 = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, Md) : Md;
function kd(e, n, t = "validate") {
  if (ja(e) || Array.isArray(e) && e.every(ja) || sn(e) && !e)
    return {
      type: t,
      message: ja(e) ? e : "",
      ref: n
    };
}
var po = (e) => ft(e) && !hi(e) ? e : {
  value: e,
  message: ""
}, Ad = async (e, n, t, r, o) => {
  const { ref: s, refs: a, required: i, maxLength: c, minLength: l, min: u, max: d, pattern: f, validate: p, name: m, valueAsNumber: h, mount: y, disabled: C } = e._f, v = ee(n, m);
  if (!y || C)
    return {};
  const w = a ? a[0] : s, x = (O) => {
    r && w.reportValidity && (w.setCustomValidity(sn(O) ? "" : O || ""), w.reportValidity());
  }, D = {}, k = X1(s), _ = Js(s), M = k || _, T = (h || Q1(s)) && rt(s.value) && rt(v) || pi(s) && s.value === "" || v === "" || Array.isArray(v) && !v.length, N = nv.bind(null, m, t, D), I = (O, $, j, Y = On.maxLength, F = On.minLength) => {
    const V = O ? $ : j;
    D[m] = {
      type: O ? Y : F,
      message: V,
      ref: s,
      ...N(O ? Y : F, V)
    };
  };
  if (o ? !Array.isArray(v) || !v.length : i && (!M && (T || Pt(v)) || sn(v) && !v || _ && !S6(a).isValid || k && !E6(a).isValid)) {
    const { value: O, message: $ } = ja(i) ? { value: !!i, message: i } : po(i);
    if (O && (D[m] = {
      type: On.required,
      message: $,
      ref: w,
      ...N(On.required, $)
    }, !t))
      return x($), D;
  }
  if (!T && (!Pt(u) || !Pt(d))) {
    let O, $;
    const j = po(d), Y = po(u);
    if (!Pt(v) && !isNaN(v)) {
      const F = s.valueAsNumber || v && +v;
      Pt(j.value) || (O = F > j.value), Pt(Y.value) || ($ = F < Y.value);
    } else {
      const F = s.valueAsDate || new Date(v), V = (X) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + X), J = s.type == "time", Q = s.type == "week";
      Dn(j.value) && v && (O = J ? V(v) > V(j.value) : Q ? v > j.value : F > new Date(j.value)), Dn(Y.value) && v && ($ = J ? V(v) < V(Y.value) : Q ? v < Y.value : F < new Date(Y.value));
    }
    if ((O || $) && (I(!!O, j.message, Y.message, On.max, On.min), !t))
      return x(D[m].message), D;
  }
  if ((c || l) && !T && (Dn(v) || o && Array.isArray(v))) {
    const O = po(c), $ = po(l), j = !Pt(O.value) && v.length > +O.value, Y = !Pt($.value) && v.length < +$.value;
    if ((j || Y) && (I(j, O.message, $.message), !t))
      return x(D[m].message), D;
  }
  if (f && !T && Dn(v)) {
    const { value: O, message: $ } = po(f);
    if (hi(O) && !v.match(O) && (D[m] = {
      type: On.pattern,
      message: $,
      ref: s,
      ...N(On.pattern, $)
    }, !t))
      return x($), D;
  }
  if (p) {
    if (lr(p)) {
      const O = await p(v, n), $ = kd(O, w);
      if ($ && (D[m] = {
        ...$,
        ...N(On.validate, $.message)
      }, !t))
        return x($.message), D;
    } else if (ft(p)) {
      let O = {};
      for (const $ in p) {
        if (!en(O) && !t)
          break;
        const j = kd(await p[$](v, n), w, $);
        j && (O = {
          ...j,
          ...N($, j.message)
        }, x(j.message), t && (D[m] = O));
      }
      if (!en(O) && (D[m] = {
        ref: w,
        ...O
      }, !t))
        return D;
    }
  }
  return x(!0), D;
};
function ov(e, n) {
  const t = n.slice(0, -1).length;
  let r = 0;
  for (; r < t; )
    e = rt(e) ? r++ : e[n[r++]];
  return e;
}
function sv(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const t = Array.isArray(n) ? n : q1(n) ? [n] : D6(n), r = t.length === 1 ? e : ov(e, t), o = t.length - 1, s = t[o];
  return r && delete r[s], o !== 0 && (ft(r) && en(r) || Array.isArray(r) && sv(r)) && yt(e, t.slice(0, -1)), e;
}
var Vc = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const s of e)
        s.next && s.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((s) => s !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, mi = (e) => Pt(e) || !g6(e);
function Vr(e, n) {
  if (mi(e) || mi(n))
    return e === n;
  if (ko(e) && ko(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), r = Object.keys(n);
  if (t.length !== r.length)
    return !1;
  for (const o of t) {
    const s = e[o];
    if (!r.includes(o))
      return !1;
    if (o !== "ref") {
      const a = n[o];
      if (ko(s) && ko(a) || ft(s) && ft(a) || Array.isArray(s) && Array.isArray(a) ? !Vr(s, a) : s !== a)
        return !1;
    }
  }
  return !0;
}
var _6 = (e) => e.type === "select-multiple", av = (e) => X1(e) || Js(e), $c = (e) => pi(e) && e.isConnected, iv = (e) => ft(e) && Object.values(e).some((n) => n), M6 = (e) => {
  for (const n in e)
    if (lr(e[n]))
      return !0;
  return !1;
};
function gi(e, n = {}) {
  const t = Array.isArray(e);
  if (ft(e) || t)
    for (const r in e)
      Array.isArray(e[r]) || ft(e[r]) && !M6(e[r]) ? (n[r] = Array.isArray(e[r]) ? [] : {}, gi(e[r], n[r])) : Pt(e[r]) || (n[r] = !0);
  return n;
}
function k6(e, n, t) {
  const r = Array.isArray(e);
  if (ft(e) || r)
    for (const o in e)
      Array.isArray(e[o]) || ft(e[o]) && !M6(e[o]) ? rt(n) || mi(t[o]) ? t[o] = Array.isArray(e[o]) ? gi(e[o], []) : { ...gi(e[o]) } : k6(e[o], Pt(n) ? {} : n[o], t[o]) : t[o] = !Vr(e[o], n[o]);
  return t;
}
var va = (e, n) => k6(e, n, gi(n)), A6 = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: r }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : t && Dn(e) ? new Date(e) : r ? r(e) : e;
function Bc(e) {
  const n = e.ref;
  if (!(e.refs ? e.refs.every((t) => t.disabled) : n.disabled))
    return Q1(n) ? n.files : X1(n) ? E6(e.refs).value : _6(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Js(n) ? S6(e.refs).value : A6(rt(n.value) ? e.ref.value : n.value, e);
}
var cv = (e, n, t, r) => {
  const o = {};
  for (const s of e) {
    const a = ee(n, s);
    a && He(o, s, a._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: r
  };
}, ls = (e) => rt(e) ? e : hi(e) ? e.source : ft(e) ? hi(e.value) ? e.value.source : e.value : e, lv = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Nd(e, n, t) {
  const r = ee(e, t);
  if (r || q1(t))
    return {
      error: r,
      name: t
    };
  const o = t.split(".");
  for (; o.length; ) {
    const s = o.join("."), a = ee(n, s), i = ee(e, s);
    if (a && !Array.isArray(a) && t !== s)
      return { name: t };
    if (i && i.type)
      return {
        name: s,
        error: i
      };
    o.pop();
  }
  return {
    name: t
  };
}
var uv = (e, n, t, r, o) => o.isOnAll ? !1 : !t && o.isOnTouch ? !(n || e) : (t ? r.isOnBlur : o.isOnBlur) ? !e : (t ? r.isOnChange : o.isOnChange) ? e : !0, dv = (e, n) => !ea(ee(e, n)).length && yt(e, n);
const fv = {
  mode: an.onSubmit,
  reValidateMode: an.onChange,
  shouldFocusError: !0
};
function pv(e = {}) {
  let n = {
    ...fv,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: lr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  }, r = {}, o = ft(n.defaultValues) || ft(n.values) ? Vt(n.defaultValues || n.values) || {} : {}, s = n.shouldUnregister ? {} : Vt(o), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, i = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, l = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: Vc(),
    array: Vc(),
    state: Vc()
  }, f = Dd(n.mode), p = Dd(n.reValidateMode), m = n.criteriaMode === an.all, h = (E) => (L) => {
    clearTimeout(l), l = setTimeout(E, L);
  }, y = async (E) => {
    if (u.isValid || E) {
      const L = n.resolver ? en((await M()).errors) : await N(r, !0);
      L !== t.isValid && d.state.next({
        isValid: L
      });
    }
  }, C = (E, L) => {
    (u.isValidating || u.validatingFields) && (L.forEach((R) => {
      He(t.validatingFields, R, E);
    }), t.isValidating = iv(t.validatingFields), d.state.next({
      validatingFields: t.validatingFields,
      isValidating: t.isValidating
    }));
  }, v = (E, L = [], R, Z, H = !0, U = !0) => {
    if (Z && R) {
      if (a.action = !0, U && Array.isArray(ee(r, E))) {
        const re = R(ee(r, E), Z.argA, Z.argB);
        H && He(r, E, re);
      }
      if (U && Array.isArray(ee(t.errors, E))) {
        const re = R(ee(t.errors, E), Z.argA, Z.argB);
        H && He(t.errors, E, re), dv(t.errors, E);
      }
      if (u.touchedFields && U && Array.isArray(ee(t.touchedFields, E))) {
        const re = R(ee(t.touchedFields, E), Z.argA, Z.argB);
        H && He(t.touchedFields, E, re);
      }
      u.dirtyFields && (t.dirtyFields = va(o, s)), d.state.next({
        name: E,
        isDirty: O(E, L),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      He(s, E, L);
  }, w = (E, L) => {
    He(t.errors, E, L), d.state.next({
      errors: t.errors
    });
  }, x = (E) => {
    t.errors = E, d.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, D = (E, L, R, Z) => {
    const H = ee(r, E);
    if (H) {
      const U = ee(s, E, rt(R) ? ee(o, E) : R);
      rt(U) || Z && Z.defaultChecked || L ? He(s, E, L ? U : Bc(H._f)) : Y(E, U), a.mount && y();
    }
  }, k = (E, L, R, Z, H) => {
    let U = !1, re = !1;
    const Ne = {
      name: E
    }, Ge = !!(ee(r, E) && ee(r, E)._f.disabled);
    if (!R || Z) {
      u.isDirty && (re = t.isDirty, t.isDirty = Ne.isDirty = O(), U = re !== Ne.isDirty);
      const at = Ge || Vr(ee(o, E), L);
      re = !!(!Ge && ee(t.dirtyFields, E)), at || Ge ? yt(t.dirtyFields, E) : He(t.dirtyFields, E, !0), Ne.dirtyFields = t.dirtyFields, U = U || u.dirtyFields && re !== !at;
    }
    if (R) {
      const at = ee(t.touchedFields, E);
      at || (He(t.touchedFields, E, R), Ne.touchedFields = t.touchedFields, U = U || u.touchedFields && at !== R);
    }
    return U && H && d.state.next(Ne), U ? Ne : {};
  }, _ = (E, L, R, Z) => {
    const H = ee(t.errors, E), U = u.isValid && sn(L) && t.isValid !== L;
    if (e.delayError && R ? (c = h(() => w(E, R)), c(e.delayError)) : (clearTimeout(l), c = null, R ? He(t.errors, E, R) : yt(t.errors, E)), (R ? !Vr(H, R) : H) || !en(Z) || U) {
      const re = {
        ...Z,
        ...U && sn(L) ? { isValid: L } : {},
        errors: t.errors,
        name: E
      };
      t = {
        ...t,
        ...re
      }, d.state.next(re);
    }
    C(!1, Object.keys(t.validatingFields).filter((re) => re === E));
  }, M = async (E) => n.resolver(s, n.context, cv(E || i.mount, r, n.criteriaMode, n.shouldUseNativeValidation)), T = async (E) => {
    const { errors: L } = await M(E);
    if (E)
      for (const R of E) {
        const Z = ee(L, R);
        Z ? He(t.errors, R, Z) : yt(t.errors, R);
      }
    else
      t.errors = L;
    return L;
  }, N = async (E, L, R = {
    valid: !0
  }) => {
    for (const Z in E) {
      const H = E[Z];
      if (H) {
        const { _f: U, ...re } = H;
        if (U) {
          const Ne = i.array.has(U.name), Ge = await Ad(H, s, m, n.shouldUseNativeValidation && !L, Ne);
          if (Ge[U.name] && (R.valid = !1, L))
            break;
          !L && (ee(Ge, U.name) ? Ne ? rv(t.errors, Ge, U.name) : He(t.errors, U.name, Ge[U.name]) : yt(t.errors, U.name));
        }
        re && await N(re, L, R);
      }
    }
    return R.valid;
  }, I = () => {
    for (const E of i.unMount) {
      const L = ee(r, E);
      L && (L._f.refs ? L._f.refs.every((R) => !$c(R)) : !$c(L._f.ref)) && Ae(E);
    }
    i.unMount = /* @__PURE__ */ new Set();
  }, O = (E, L) => (E && L && He(s, E, L), !Vr(z(), o)), $ = (E, L, R) => x6(E, i, {
    ...a.mount ? s : rt(L) ? o : Dn(E) ? { [E]: L } : L
  }, R, L), j = (E) => ea(ee(a.mount ? s : o, E, e.shouldUnregister ? ee(o, E, []) : [])), Y = (E, L, R = {}) => {
    const Z = ee(r, E);
    let H = L;
    if (Z) {
      const U = Z._f;
      U && (!U.disabled && He(s, E, A6(L, U)), H = pi(U.ref) && Pt(L) ? "" : L, _6(U.ref) ? [...U.ref.options].forEach((re) => re.selected = H.includes(re.value)) : U.refs ? Js(U.ref) ? U.refs.length > 1 ? U.refs.forEach((re) => (!re.defaultChecked || !re.disabled) && (re.checked = Array.isArray(H) ? !!H.find((Ne) => Ne === re.value) : H === re.value)) : U.refs[0] && (U.refs[0].checked = !!H) : U.refs.forEach((re) => re.checked = re.value === H) : Q1(U.ref) ? U.ref.value = "" : (U.ref.value = H, U.ref.type || d.values.next({
        name: E,
        values: { ...s }
      })));
    }
    (R.shouldDirty || R.shouldTouch) && k(E, H, R.shouldTouch, R.shouldDirty, !0), R.shouldValidate && X(E);
  }, F = (E, L, R) => {
    for (const Z in L) {
      const H = L[Z], U = `${E}.${Z}`, re = ee(r, U);
      (i.array.has(E) || !mi(H) || re && !re._f) && !ko(H) ? F(U, H, R) : Y(U, H, R);
    }
  }, V = (E, L, R = {}) => {
    const Z = ee(r, E), H = i.array.has(E), U = Vt(L);
    He(s, E, U), H ? (d.array.next({
      name: E,
      values: { ...s }
    }), (u.isDirty || u.dirtyFields) && R.shouldDirty && d.state.next({
      name: E,
      dirtyFields: va(o, s),
      isDirty: O(E, U)
    })) : Z && !Z._f && !Pt(U) ? F(E, U, R) : Y(E, U, R), Sd(E, i) && d.state.next({ ...t }), d.values.next({
      name: a.mount ? E : void 0,
      values: { ...s }
    });
  }, J = async (E) => {
    const L = E.target;
    let R = L.name, Z = !0;
    const H = ee(r, R), U = () => L.type ? Bc(H._f) : y6(E), re = (Ne) => {
      Z = Number.isNaN(Ne) || Ne === ee(s, R, Ne);
    };
    if (H) {
      let Ne, Ge;
      const at = U(), Yt = E.type === fi.BLUR || E.type === fi.FOCUS_OUT, kr = !lv(H._f) && !n.resolver && !ee(t.errors, R) && !H._f.deps || uv(Yt, ee(t.touchedFields, R), t.isSubmitted, p, f), dn = Sd(R, i, Yt);
      He(s, R, at), Yt ? (H._f.onBlur && H._f.onBlur(E), c && c(0)) : H._f.onChange && H._f.onChange(E);
      const Tn = k(R, at, Yt, !1), Ht = !en(Tn) || dn;
      if (!Yt && d.values.next({
        name: R,
        type: E.type,
        values: { ...s }
      }), kr)
        return u.isValid && y(), Ht && d.state.next({ name: R, ...dn ? {} : Tn });
      if (!Yt && dn && d.state.next({ ...t }), C(!0, [R]), n.resolver) {
        const { errors: et } = await M([R]);
        if (re(at), Z) {
          const so = Nd(t.errors, r, R), Xn = Nd(et, r, so.name || R);
          Ne = Xn.error, R = Xn.name, Ge = en(et);
        }
      } else
        Ne = (await Ad(H, s, m, n.shouldUseNativeValidation))[R], re(at), Z && (Ne ? Ge = !1 : u.isValid && (Ge = await N(r, !0)));
      Z && (H._f.deps && X(H._f.deps), _(R, Ge, Ne, Tn));
    }
  }, Q = (E, L) => {
    if (ee(t.errors, L) && E.focus)
      return E.focus(), 1;
  }, X = async (E, L = {}) => {
    let R, Z;
    const H = Ba(E);
    if (C(!0, H), n.resolver) {
      const U = await T(rt(E) ? E : H);
      R = en(U), Z = E ? !H.some((re) => ee(U, re)) : R;
    } else
      E ? (Z = (await Promise.all(H.map(async (U) => {
        const re = ee(r, U);
        return await N(re && re._f ? { [U]: re } : re);
      }))).every(Boolean), !(!Z && !t.isValid) && y()) : Z = R = await N(r);
    return d.state.next({
      ...!Dn(E) || u.isValid && R !== t.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: R } : {},
      errors: t.errors,
      isValidating: !1
    }), L.shouldFocus && !Z && xs(r, Q, E ? H : i.mount), Z;
  }, z = (E) => {
    const L = {
      ...o,
      ...a.mount ? s : {}
    };
    return rt(E) ? L : Dn(E) ? ee(L, E) : E.map((R) => ee(L, R));
  }, me = (E, L) => ({
    invalid: !!ee((L || t).errors, E),
    isDirty: !!ee((L || t).dirtyFields, E),
    isTouched: !!ee((L || t).touchedFields, E),
    isValidating: !!ee((L || t).validatingFields, E),
    error: ee((L || t).errors, E)
  }), Me = (E) => {
    E && Ba(E).forEach((L) => yt(t.errors, L)), d.state.next({
      errors: E ? t.errors : {}
    });
  }, Be = (E, L, R) => {
    const Z = (ee(r, E, { _f: {} })._f || {}).ref;
    He(t.errors, E, {
      ...L,
      ref: Z
    }), d.state.next({
      name: E,
      errors: t.errors,
      isValid: !1
    }), R && R.shouldFocus && Z && Z.focus && Z.focus();
  }, ve = (E, L) => lr(E) ? d.values.subscribe({
    next: (R) => E($(void 0, L), R)
  }) : $(E, L, !0), Ae = (E, L = {}) => {
    for (const R of E ? Ba(E) : i.mount)
      i.mount.delete(R), i.array.delete(R), L.keepValue || (yt(r, R), yt(s, R)), !L.keepError && yt(t.errors, R), !L.keepDirty && yt(t.dirtyFields, R), !L.keepTouched && yt(t.touchedFields, R), !L.keepIsValidating && yt(t.validatingFields, R), !n.shouldUnregister && !L.keepDefaultValue && yt(o, R);
    d.values.next({
      values: { ...s }
    }), d.state.next({
      ...t,
      ...L.keepDirty ? { isDirty: O() } : {}
    }), !L.keepIsValid && y();
  }, Te = ({ disabled: E, name: L, field: R, fields: Z, value: H }) => {
    if (sn(E)) {
      const U = E ? void 0 : rt(H) ? Bc(R ? R._f : ee(Z, L)._f) : H;
      He(s, L, U), k(L, U, !1, !1, !0);
    }
  }, G = (E, L = {}) => {
    let R = ee(r, E);
    const Z = sn(L.disabled);
    return He(r, E, {
      ...R || {},
      _f: {
        ...R && R._f ? R._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...L
      }
    }), i.mount.add(E), R ? Te({
      field: R,
      disabled: L.disabled,
      name: E,
      value: L.value
    }) : D(E, !0, L.value), {
      ...Z ? { disabled: L.disabled } : {},
      ...n.progressive ? {
        required: !!L.required,
        min: ls(L.min),
        max: ls(L.max),
        minLength: ls(L.minLength),
        maxLength: ls(L.maxLength),
        pattern: ls(L.pattern)
      } : {},
      name: E,
      onChange: J,
      onBlur: J,
      ref: (H) => {
        if (H) {
          G(E, L), R = ee(r, E);
          const U = rt(H.value) && H.querySelectorAll && H.querySelectorAll("input,select,textarea")[0] || H, re = av(U), Ne = R._f.refs || [];
          if (re ? Ne.find((Ge) => Ge === U) : U === R._f.ref)
            return;
          He(r, E, {
            _f: {
              ...R._f,
              ...re ? {
                refs: [
                  ...Ne.filter($c),
                  U,
                  ...Array.isArray(ee(o, E)) ? [{}] : []
                ],
                ref: { type: U.type, name: E }
              } : { ref: U }
            }
          }), D(E, !1, void 0, U);
        } else
          R = ee(r, E, {}), R._f && (R._f.mount = !1), (n.shouldUnregister || L.shouldUnregister) && !(v6(i.array, E) && a.action) && i.unMount.add(E);
      }
    };
  }, fe = () => n.shouldFocusError && xs(r, Q, i.mount), De = (E) => {
    sn(E) && (d.state.next({ disabled: E }), xs(r, (L, R) => {
      let Z = E;
      const H = ee(r, R);
      H && sn(H._f.disabled) && (Z || (Z = H._f.disabled)), L.disabled = Z;
    }, 0, !1));
  }, _e = (E, L) => async (R) => {
    let Z;
    R && (R.preventDefault && R.preventDefault(), R.persist && R.persist());
    let H = Vt(s);
    if (d.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: re } = await M();
      t.errors = U, H = re;
    } else
      await N(r);
    if (yt(t.errors, "root"), en(t.errors)) {
      d.state.next({
        errors: {}
      });
      try {
        await E(H, R);
      } catch (U) {
        Z = U;
      }
    } else
      L && await L({ ...t.errors }, R), fe(), setTimeout(fe);
    if (d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: en(t.errors) && !Z,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Z)
      throw Z;
  }, Fe = (E, L = {}) => {
    ee(r, E) && (rt(L.defaultValue) ? V(E, Vt(ee(o, E))) : (V(E, L.defaultValue), He(o, E, Vt(L.defaultValue))), L.keepTouched || yt(t.touchedFields, E), L.keepDirty || (yt(t.dirtyFields, E), t.isDirty = L.defaultValue ? O(E, Vt(ee(o, E))) : O()), L.keepError || (yt(t.errors, E), u.isValid && y()), d.state.next({ ...t }));
  }, Je = (E, L = {}) => {
    const R = E ? Vt(E) : o, Z = Vt(R), H = en(E), U = H ? o : Z;
    if (L.keepDefaultValues || (o = R), !L.keepValues) {
      if (L.keepDirtyValues)
        for (const re of i.mount)
          ee(t.dirtyFields, re) ? He(U, re, ee(s, re)) : V(re, ee(U, re));
      else {
        if (K1 && rt(E))
          for (const re of i.mount) {
            const Ne = ee(r, re);
            if (Ne && Ne._f) {
              const Ge = Array.isArray(Ne._f.refs) ? Ne._f.refs[0] : Ne._f.ref;
              if (pi(Ge)) {
                const at = Ge.closest("form");
                if (at) {
                  at.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      s = e.shouldUnregister ? L.keepDefaultValues ? Vt(o) : {} : Vt(U), d.array.next({
        values: { ...U }
      }), d.values.next({
        values: { ...U }
      });
    }
    i = {
      mount: L.keepDirtyValues ? i.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !u.isValid || !!L.keepIsValid || !!L.keepDirtyValues, a.watch = !!e.shouldUnregister, d.state.next({
      submitCount: L.keepSubmitCount ? t.submitCount : 0,
      isDirty: H ? !1 : L.keepDirty ? t.isDirty : !!(L.keepDefaultValues && !Vr(E, o)),
      isSubmitted: L.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: H ? [] : L.keepDirtyValues ? L.keepDefaultValues && s ? va(o, s) : t.dirtyFields : L.keepDefaultValues && E ? va(o, E) : {},
      touchedFields: L.keepTouched ? t.touchedFields : {},
      errors: L.keepErrors ? t.errors : {},
      isSubmitSuccessful: L.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, ke = (E, L) => Je(lr(E) ? E(s) : E, L);
  return {
    control: {
      register: G,
      unregister: Ae,
      getFieldState: me,
      handleSubmit: _e,
      setError: Be,
      _executeSchema: M,
      _getWatch: $,
      _getDirty: O,
      _updateValid: y,
      _removeUnmounted: I,
      _updateFieldArray: v,
      _updateDisabledField: Te,
      _getFieldArray: j,
      _reset: Je,
      _resetDefaultValues: () => lr(n.defaultValues) && n.defaultValues().then((E) => {
        ke(E, n.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (E) => {
        t = {
          ...t,
          ...E
        };
      },
      _disableForm: De,
      _subjects: d,
      _proxyFormState: u,
      _setErrors: x,
      get _fields() {
        return r;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return a;
      },
      set _state(E) {
        a = E;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return i;
      },
      set _names(E) {
        i = E;
      },
      get _formState() {
        return t;
      },
      set _formState(E) {
        t = E;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    trigger: X,
    register: G,
    handleSubmit: _e,
    watch: ve,
    setValue: V,
    getValues: z,
    reset: ke,
    resetField: Fe,
    clearErrors: Me,
    unregister: Ae,
    setError: Be,
    setFocus: (E, L = {}) => {
      const R = ee(r, E), Z = R && R._f;
      if (Z) {
        const H = Z.refs ? Z.refs[0] : Z.ref;
        H.focus && (H.focus(), L.shouldSelect && H.select());
      }
    },
    getFieldState: me
  };
}
function Sr(e = {}) {
  const n = A.useRef(), t = A.useRef(), [r, o] = A.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: lr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: lr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...pv(e),
    formState: r
  });
  const s = n.current.control;
  return s._options = e, G1({
    subject: s._subjects.state,
    next: (a) => {
      C6(a, s._proxyFormState, s._updateFormState, !0) && o({ ...s._formState });
    }
  }), A.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]), A.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const a = s._getDirty();
      a !== r.isDirty && s._subjects.state.next({
        isDirty: a
      });
    }
  }, [s, r.isDirty]), A.useEffect(() => {
    e.values && !Vr(e.values, t.current) ? (s._reset(e.values, s._options.resetOptions), t.current = e.values, o((a) => ({ ...a }))) : s._resetDefaultValues();
  }, [e.values, s]), A.useEffect(() => {
    e.errors && s._setErrors(e.errors);
  }, [e.errors, s]), A.useEffect(() => {
    s._state.mount || (s._updateValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), A.useEffect(() => {
    e.shouldUnregister && s._subjects.values.next({
      values: s._getWatch()
    });
  }, [e.shouldUnregister, s]), n.current.formState = b6(r, s), n.current;
}
function N6({
  invoice: e,
  file: n
}) {
  const t = "dls-invoice-finance-api/v5/invoices", r = JSON.stringify(e), o = new Blob([r], {
    type: "application/json"
  }), s = new FormData();
  s.append("invoiceDetails", o), s.append("file", n);
  const a = {
    "content-type": "multipart/form-data",
    crossorigin: !0
  };
  return bt.post({
    path: t,
    body: s,
    headers: a
  });
}
function L6(e, n) {
  const t = `dls-invoice-finance-api/v5/invoice/${n}`, r = {
    "content-type": "application/json;charset=UTF-8;",
    crossorigin: !0,
    type: "application/json"
  };
  return bt.put({
    path: t,
    data: e,
    headers: r
  });
}
function hv() {
  return bt.post({
    path: "dls-invoice-finance-api/v5/risk-evaluation"
  });
}
function mv() {
  return bt.get({
    path: "dls-invoice-finance-api/v5/offers"
  });
}
function T6(e) {
  const n = "dls-invoice-finance-api/v5/confirm-offer", {
    id: t
  } = e, r = {
    offerId: t
  };
  return bt.post({
    path: n,
    body: r
  });
}
function gv(e) {
  const n = "dls-invoice-finance-api/v5/survey-eligibility", t = {
    "content-type": "application/json;charset=UTF-8;",
    crossorigin: !0,
    type: "application/json"
  };
  return bt.post({
    path: n,
    body: e,
    headers: t
  });
}
const yv = ["SBI_CODE_INVALID", "LEGAL_STRUCTURE_INVALID", "FOUNDATION_DATE_INVALID"];
function P6(e) {
  return yv.some((n) => n === e);
}
function O6({
  kvkNumber: e
}) {
  const n = "dls-invoice-finance-api/v5/requester-eligibility", t = {
    kvkNumber: e
  };
  return bt.post({
    path: n,
    body: t
  });
}
function R6({
  name: e,
  surname: n,
  email: t,
  phoneNumber: r
}) {
  const o = "dls-invoice-finance-api/v5/contact-details", s = {
    name: e,
    surname: n,
    email: t,
    phoneNumber: r
  };
  return bt.post({
    path: o,
    body: s
  });
}
function I6(e) {
  var n, t, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (n = 0; n < o; n++)
        e[n] && (t = I6(e[n])) && (r && (r += " "), r += t);
    } else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function vt() {
  for (var e, n, t = 0, r = "", o = arguments.length; t < o; t++)
    (e = arguments[t]) && (n = I6(e)) && (r && (r += " "), r += n);
  return r;
}
var F6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringSimilarity = void 0;
  var n = function(t, r, o, s) {
    if (o === void 0 && (o = 2), s === void 0 && (s = !1), s || (t = t.toLowerCase(), r = r.toLowerCase()), t.length < o || r.length < o)
      return 0;
    for (var a = /* @__PURE__ */ new Map(), i = 0; i < t.length - (o - 1); i++) {
      var c = t.substr(i, o);
      a.set(c, a.has(c) ? a.get(c) + 1 : 1);
    }
    for (var l = 0, u = 0; u < r.length - (o - 1); u++) {
      var d = r.substr(u, o), f = a.has(d) ? a.get(d) : 0;
      f > 0 && (a.set(d, f - 1), l++);
    }
    return l * 2 / (t.length + r.length - (o - 1) * 2);
  };
  e.stringSimilarity = n, e.default = e.stringSimilarity;
})(F6);
const J1 = "-";
function vv(e) {
  const n = Cv(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = e;
  function o(a) {
    const i = a.split(J1);
    return i[0] === "" && i.length !== 1 && i.shift(), V6(i, n) || bv(a);
  }
  function s(a, i) {
    const c = t[a] || [];
    return i && r[a] ? [...c, ...r[a]] : c;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: s
  };
}
function V6(e, n) {
  var a;
  if (e.length === 0)
    return n.classGroupId;
  const t = e[0], r = n.nextPart.get(t), o = r ? V6(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (n.validators.length === 0)
    return;
  const s = e.join(J1);
  return (a = n.validators.find(({
    validator: i
  }) => i(s))) == null ? void 0 : a.classGroupId;
}
const Ld = /^\[(.+)\]$/;
function bv(e) {
  if (Ld.test(e)) {
    const n = Ld.exec(e)[1], t = n == null ? void 0 : n.substring(0, n.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function Cv(e) {
  const {
    theme: n,
    prefix: t
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return xv(Object.entries(e.classGroups), t).forEach(([s, a]) => {
    Bl(a, r, s, n);
  }), r;
}
function Bl(e, n, t, r) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const s = o === "" ? n : Td(n, o);
      s.classGroupId = t;
      return;
    }
    if (typeof o == "function") {
      if (wv(o)) {
        Bl(o(r), n, t, r);
        return;
      }
      n.validators.push({
        validator: o,
        classGroupId: t
      });
      return;
    }
    Object.entries(o).forEach(([s, a]) => {
      Bl(a, Td(n, s), t, r);
    });
  });
}
function Td(e, n) {
  let t = e;
  return n.split(J1).forEach((r) => {
    t.nextPart.has(r) || t.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(r);
  }), t;
}
function wv(e) {
  return e.isThemeGetter;
}
function xv(e, n) {
  return n ? e.map(([t, r]) => {
    const o = r.map((s) => typeof s == "string" ? n + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([a, i]) => [n + a, i])) : s);
    return [t, o];
  }) : e;
}
function Dv(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let n = 0, t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(s, a) {
    t.set(s, a), n++, n > e && (n = 0, r = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(s) {
      let a = t.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set(s, a) {
      t.has(s) ? t.set(s, a) : o(s, a);
    }
  };
}
const $6 = "!";
function Sv(e) {
  const n = e.separator, t = n.length === 1, r = n[0], o = n.length;
  return function(a) {
    const i = [];
    let c = 0, l = 0, u;
    for (let h = 0; h < a.length; h++) {
      let y = a[h];
      if (c === 0) {
        if (y === r && (t || a.slice(h, h + o) === n)) {
          i.push(a.slice(l, h)), l = h + o;
          continue;
        }
        if (y === "/") {
          u = h;
          continue;
        }
      }
      y === "[" ? c++ : y === "]" && c--;
    }
    const d = i.length === 0 ? a : a.substring(l), f = d.startsWith($6), p = f ? d.substring(1) : d, m = u && u > l ? u - l : void 0;
    return {
      modifiers: i,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: m
    };
  };
}
function Ev(e) {
  if (e.length <= 1)
    return e;
  const n = [];
  let t = [];
  return e.forEach((r) => {
    r[0] === "[" ? (n.push(...t.sort(), r), t = []) : t.push(r);
  }), n.push(...t.sort()), n;
}
function _v(e) {
  return {
    cache: Dv(e.cacheSize),
    splitModifiers: Sv(e),
    ...vv(e)
  };
}
const Mv = /\s+/;
function kv(e, n) {
  const {
    splitModifiers: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = n, s = /* @__PURE__ */ new Set();
  return e.trim().split(Mv).map((a) => {
    const {
      modifiers: i,
      hasImportantModifier: c,
      baseClassName: l,
      maybePostfixModifierPosition: u
    } = t(a);
    let d = r(u ? l.substring(0, u) : l), f = !!u;
    if (!d) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(l), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      f = !1;
    }
    const p = Ev(i).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? p + $6 : p,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: f
    };
  }).reverse().filter((a) => {
    if (!a.isTailwindClass)
      return !0;
    const {
      modifierId: i,
      classGroupId: c,
      hasPostfixModifier: l
    } = a, u = i + c;
    return s.has(u) ? !1 : (s.add(u), o(c, l).forEach((d) => s.add(i + d)), !0);
  }).reverse().map((a) => a.originalClassName).join(" ");
}
function Av() {
  let e = 0, n, t, r = "";
  for (; e < arguments.length; )
    (n = arguments[e++]) && (t = B6(n)) && (r && (r += " "), r += t);
  return r;
}
function B6(e) {
  if (typeof e == "string")
    return e;
  let n, t = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (n = B6(e[r])) && (t && (t += " "), t += n);
  return t;
}
function Nv(e, ...n) {
  let t, r, o, s = a;
  function a(c) {
    const l = n.reduce((u, d) => d(u), e());
    return t = _v(l), r = t.cache.get, o = t.cache.set, s = i, i(c);
  }
  function i(c) {
    const l = r(c);
    if (l)
      return l;
    const u = kv(c, t);
    return o(c, u), u;
  }
  return function() {
    return s(Av.apply(null, arguments));
  };
}
function Ke(e) {
  const n = (t) => t[e] || [];
  return n.isThemeGetter = !0, n;
}
const j6 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Lv = /^\d+\/\d+$/, Tv = /* @__PURE__ */ new Set(["px", "full", "screen"]), Pv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ov = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Rv = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Iv = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Fv = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Rn(e) {
  return $r(e) || Tv.has(e) || Lv.test(e);
}
function tr(e) {
  return qo(e, "length", Wv);
}
function $r(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ba(e) {
  return qo(e, "number", $r);
}
function us(e) {
  return !!e && Number.isInteger(Number(e));
}
function Vv(e) {
  return e.endsWith("%") && $r(e.slice(0, -1));
}
function Se(e) {
  return j6.test(e);
}
function nr(e) {
  return Pv.test(e);
}
const $v = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function Bv(e) {
  return qo(e, $v, Y6);
}
function jv(e) {
  return qo(e, "position", Y6);
}
const Yv = /* @__PURE__ */ new Set(["image", "url"]);
function Hv(e) {
  return qo(e, Yv, Kv);
}
function Uv(e) {
  return qo(e, "", Zv);
}
function ds() {
  return !0;
}
function qo(e, n, t) {
  const r = j6.exec(e);
  return r ? r[1] ? typeof n == "string" ? r[1] === n : n.has(r[1]) : t(r[2]) : !1;
}
function Wv(e) {
  return Ov.test(e) && !Rv.test(e);
}
function Y6() {
  return !1;
}
function Zv(e) {
  return Iv.test(e);
}
function Kv(e) {
  return Fv.test(e);
}
function zv() {
  const e = Ke("colors"), n = Ke("spacing"), t = Ke("blur"), r = Ke("brightness"), o = Ke("borderColor"), s = Ke("borderRadius"), a = Ke("borderSpacing"), i = Ke("borderWidth"), c = Ke("contrast"), l = Ke("grayscale"), u = Ke("hueRotate"), d = Ke("invert"), f = Ke("gap"), p = Ke("gradientColorStops"), m = Ke("gradientColorStopPositions"), h = Ke("inset"), y = Ke("margin"), C = Ke("opacity"), v = Ke("padding"), w = Ke("saturate"), x = Ke("scale"), D = Ke("sepia"), k = Ke("skew"), _ = Ke("space"), M = Ke("translate"), T = () => ["auto", "contain", "none"], N = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", Se, n], O = () => [Se, n], $ = () => ["", Rn, tr], j = () => ["auto", $r, Se], Y = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], F = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], J = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Q = () => ["", "0", Se], X = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], z = () => [$r, ba], me = () => [$r, Se];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [ds],
      spacing: [Rn, tr],
      blur: ["none", "", nr, Se],
      brightness: z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", nr, Se],
      borderSpacing: O(),
      borderWidth: $(),
      contrast: z(),
      grayscale: Q(),
      hueRotate: me(),
      invert: Q(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Vv, tr],
      inset: I(),
      margin: I(),
      opacity: z(),
      padding: O(),
      saturate: z(),
      scale: z(),
      sepia: Q(),
      skew: me(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Se]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [nr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": X()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": X()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Y(), Se]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: N()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": N()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": N()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: T()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": T()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": T()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", us, Se]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Se]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", us, Se]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ds]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", us, Se]
        }, Se]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ds]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [us, Se]
        }, Se]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Se]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Se]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...J()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...J(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...J(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Se, n]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Se, n, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Se, n, "none", "full", "min", "max", "fit", "prose", {
          screen: [nr]
        }, nr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Se, n, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Se, n, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Se, n, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Se, n, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", nr, tr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ba]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ds]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Se]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", $r, ba]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Rn, Se]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Se]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Se]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [C]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [C]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...F(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Rn, tr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Rn, Se]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Se]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Se]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [C]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Y(), jv]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Bv]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Hv]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [C]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...F(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [C]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: F()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...F()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Rn, Se]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Rn, tr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: $()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [C]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Rn, tr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", nr, Uv]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ds]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [C]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": V()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", nr, Se]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [D]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [C]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [D]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Se]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: me()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Se]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: me()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Se]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [us, Se]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [k]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [k]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Se]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Se]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Se]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Rn, tr, ba]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const Gv = /* @__PURE__ */ Nv(zv), Os = "text_65f542681359a2007fa1217d", qv = {
  ALPHANUMERIC: "text_660dbb63e394df0083b2f619"
}, eu = {
  // Invoice date is in the future
  ERR_3002: "text_660947791cf255005a25f86a",
  // Invoice date is too old
  ERR_3003: "text_6600cda50861cc0108cb6d0c",
  // Debtor is equal to requester
  ERR_3007: "text_660b22c4f3defe00da57ccaf"
}, Qv = {
  CRC_0001: "CRC_CHECK_FAILED",
  RER_0003: "INVOICE_NOT_SUITABLE",
  RER_0006: "MAX_LOAN_EXCEEDED"
}, Xv = {
  400: "text_65f52c5e48c285005eae9932",
  500: Os
}, pt = {
  required: "text_65f542681359a2007fa1217f",
  invalidSelection: "text_65f542681359a2007fa12181",
  email: "text_65f542681359a2007fa12187",
  phone: "text_65f542681359a2007fa12189"
};
function te(...e) {
  return Gv(vt(e));
}
const un = (e) => {
  var r;
  if (!Zr(e))
    return Os;
  const n = (r = e.response) == null ? void 0 : r.status;
  return n != null && Xv[n] || Os;
}, H6 = (e) => e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").trim().toLowerCase(), Pd = (e) => e.normalize("NFD").replace(/[^a-zA-Z0-9]/gu, "").trim().toLowerCase(), yi = (e, n) => {
  const t = Pd(e), r = Pd(n);
  return F6.stringSimilarity(t, r) * 100;
}, Ds = ({
  delay: e,
  fn: n,
  limit: t = 1,
  callback: r = () => {
  }
}) => {
  let o = !1, s, a = 0;
  return s = setInterval(async () => {
    if (o)
      return;
    o = !0, a += 1;
    const c = await n();
    o = !1, a >= t && r(), (c || a >= t) && clearInterval(s);
  }, e), s;
}, Jv = (e) => new Promise((n) => {
  setTimeout(n, e);
}), Od = 3, eb = ({
  iban: e,
  isMasked: n = !1
}) => {
  const t = e.slice(0, e.length - Od), r = e.slice(-Od);
  if (e.length !== 18)
    return n ? `...${r}` : e;
  const o = n ? t.replace(/\d/g, "*") + r : e, s = o.slice(0, 2), a = o.slice(2, 4), i = o.slice(4, 8), c = o.slice(8, 12), l = o.slice(12, 16), u = o.slice(16, 18);
  return `${s}${a} ${i} ${c} ${l} ${u}`;
}, Kr = (e) => new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 2
}).format(e), tb = 60, Gn = (e) => {
  const n = e.getTimezoneOffset(), t = new Date(e.getTime() - n * tb * 1e3), [r] = t.toISOString().split("T");
  return r;
}, nb = (e) => e.toLocaleDateString("nl-NL", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}), rb = (e, n) => {
  const t = e.getTime(), r = n.getTime();
  return Math.abs(t - r) / (1e3 * 60 * 60 * 24);
};
function ob(e) {
  const n = `dls-company-search/v1/company/search?query=${e}`;
  return bt.get({
    path: n
  });
}
function Qo(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, s;
  for (s = 0; s < r.length; s++)
    o = r[s], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var sb = ["color"], Qi = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, sb);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), ab = ["color"], ib = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, ab);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), cb = ["color"], lb = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, cb);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), ub = ["color"], U6 = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, ub);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), db = ["color"], fb = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, db);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), pb = ["color"], W6 = /* @__PURE__ */ xe(function(e, n) {
  var t = e.color, r = t === void 0 ? "currentColor" : t, o = Qo(e, pb);
  return le("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: n
  }), le("path", {
    d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
function hb(e) {
  const n = ie(null);
  return W(() => {
    const t = (r) => {
      var o;
      (o = n == null ? void 0 : n.current) != null && o.contains(r.target) || !e || e();
    };
    return document.addEventListener("touchstart", t), document.addEventListener("mousedown", t), () => {
      document.removeEventListener("touchstart", t), document.removeEventListener("mousedown", t);
    };
  }, [n]), n;
}
function Z6(e) {
  var n, t, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (n = 0; n < e.length; n++)
        e[n] && (t = Z6(e[n])) && (r && (r += " "), r += t);
    else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function mb() {
  for (var e, n, t = 0, r = ""; t < arguments.length; )
    (e = arguments[t++]) && (n = Z6(e)) && (r && (r += " "), r += n);
  return r;
}
const Rd = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Id = mb, Er = (e, n) => (t) => {
  var r;
  if ((n == null ? void 0 : n.variants) == null)
    return Id(e, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: o, defaultVariants: s } = n, a = Object.keys(o).map((l) => {
    const u = t == null ? void 0 : t[l], d = s == null ? void 0 : s[l];
    if (u === null)
      return null;
    const f = Rd(u) || Rd(d);
    return o[l][f];
  }), i = t && Object.entries(t).reduce((l, u) => {
    let [d, f] = u;
    return f === void 0 || (l[d] = f), l;
  }, {}), c = n == null || (r = n.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, u) => {
    let { class: d, className: f, ...p } = u;
    return Object.entries(p).every((m) => {
      let [h, y] = m;
      return Array.isArray(y) ? y.includes({
        ...s,
        ...i
      }[h]) : {
        ...s,
        ...i
      }[h] === y;
    }) ? [
      ...l,
      d,
      f
    ] : l;
  }, []);
  return Id(e, a, c, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, gb = Er("text-foreground w-4 h-4 shrink-0 transition-all duration-200", {
  variants: {
    direction: {
      up: "rotate-180",
      down: "",
      left: "rotate-90",
      right: "-rotate-90"
    },
    color: {
      primary: "text-primary",
      secondary: "text-secondary",
      white: "text-white",
      text: "text-foreground"
    }
  },
  defaultVariants: {
    direction: "down",
    color: "text"
  }
});
function K6({
  className: e,
  disabled: n,
  direction: t,
  color: r
}) {
  const o = n && "fill-input-disabled-foreground", s = te(gb({
    direction: t,
    color: r,
    className: e
  }), o);
  return /* @__PURE__ */ g(lb, {
    className: s
  });
}
function no({
  className: e,
  name: n
}) {
  const t = n && `${n}_divider`;
  return /* @__PURE__ */ g(he.div, {
    className: te(e, "border-t border-solid border-border/40"),
    layoutId: t,
    transition: Ce
  });
}
const z6 = Er("", {
  variants: {
    size: {
      xs: "text-xs",
      sm: "text-sm",
      md: "text-md",
      lg: "text-lg",
      xl: "text-xl"
    },
    weight: {
      inherit: "font-inherit-weight",
      normal: "font-normal",
      bold: "font-bold",
      light: "font-light",
      thin: "font-thin",
      semibold: "font-semibold"
    },
    color: {
      base: "text-foreground",
      primary: "text-primary",
      secondary: "text-secondary",
      white: "text-white",
      destructive: "text-destructive",
      success: "text-success",
      subtitle: "text-foreground/70"
    }
  },
  defaultVariants: {
    size: "md",
    weight: void 0,
    color: "base"
  }
});
function oe({
  element: e,
  className: n,
  children: t,
  size: r,
  weight: o,
  color: s
}) {
  const a = te("whitespace-pre-line", z6({
    weight: o,
    size: r,
    color: s,
    className: n
  }));
  return /* @__PURE__ */ g(e ?? "p", {
    className: a,
    children: t
  });
}
function jt({
  useLayoutId: e,
  name: n,
  error: t,
  className: r
}) {
  if (!t)
    return null;
  const o = e ? n : void 0;
  return /* @__PURE__ */ g(he.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1,
      transition: {
        delay: Ao
      }
    },
    exit: {
      opacity: 0
    },
    transition: Ce,
    layoutId: o,
    layout: "position",
    className: te("pl-px", r),
    "data-testid": `error_message_${n}`,
    children: /* @__PURE__ */ g(oe, {
      color: "destructive",
      size: "sm",
      weight: "light",
      children: t
    })
  });
}
function Xi({
  id: e,
  label: n
}) {
  const t = `label_${e}`;
  return n ? /* @__PURE__ */ g(he.label, {
    className: "block pl-px text-sm font-light text-foreground text-left",
    htmlFor: e,
    transition: Ce,
    layout: "position",
    layoutId: t,
    children: n
  }) : null;
}
const tu = Er(te("flex w-full border-input bg-transparent h-12 px-4 truncate outline-none", "text-sm font-light text-foreground transition-colors", "placeholder:text-sm placeholder:font-light placeholder:text-placeholder", "focus:border-primary focus:ring-primary", "disabled:bg-input-disabled disabled:text-input-disabled-foreground disabled:border-border/30 disabled:shadow-none"), {
  variants: {
    variant: {
      base: "rounded border shadow-sm",
      underline: "border-b"
    },
    state: {
      error: "border-destructive"
    }
  },
  defaultVariants: {
    variant: "base",
    state: void 0
  }
}), Hr = xe(({
  className: e,
  name: n,
  label: t,
  error: r,
  state: o,
  variant: s,
  type: a = "text",
  ...i
}, c) => {
  const l = `input_${n}`, f = te(tu({
    variant: s,
    state: !!r ? "error" : o,
    className: e
  }));
  return /* @__PURE__ */ P(he.div, {
    layoutId: l,
    layout: "position",
    transition: Ce,
    className: "w-full",
    children: [/* @__PURE__ */ g(Xi, {
      id: l,
      label: t
    }), /* @__PURE__ */ g("input", {
      type: a,
      name: n,
      "data-testid": l,
      id: l,
      "aria-label": l,
      className: f,
      ref: c,
      ...i
    }), /* @__PURE__ */ g(jt, {
      name: n,
      error: r
    })]
  });
}), yb = Er("animate-spin text-gray-400", {
  variants: {
    size: {
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6"
    },
    color: {
      primary: "fill-primary",
      secondary: "fill-secondary",
      gray: "fill-gray-500"
    }
  },
  defaultVariants: {
    size: "md",
    color: "primary"
  }
});
function Ji({
  className: e,
  color: n,
  size: t
}) {
  const r = te(yb({
    color: n,
    size: t,
    className: e
  }));
  return /* @__PURE__ */ P("svg", {
    className: r,
    role: "status",
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "loader",
    children: [/* @__PURE__ */ g("path", {
      d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      fill: "currentColor"
    }), /* @__PURE__ */ g("path", {
      d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      fill: "currentFill"
    })]
  });
}
const vb = {
  sm: "max-h-40",
  md: "max-h-60",
  lg: "max-h-80"
};
function G6(e) {
  return e ? typeof e == "object" && "id" in e && "title" in e : !1;
}
function q6({
  options: e,
  isMultiSelect: n = !1,
  displayValue: t,
  shouldOpen: r = !0,
  handleChange: o,
  isLoading: s,
  endAdornment: a,
  optionHeight: i = "md",
  control: c,
  className: l,
  shouldUnregister: u,
  name: d,
  label: f,
  error: p,
  rules: m,
  defaultValue: h,
  readOnly: y,
  disabled: C,
  autoFocus: v = !1,
  ...w
}) {
  const x = `option-view_${d}`, D = te("cursor-[inherit]", a || s ? "pr-[52px]" : "pr-11"), k = (G) => G ? t(G) : void 0, {
    field: _
  } = Go({
    control: c,
    name: d,
    rules: m,
    defaultValue: h,
    shouldUnregister: u
  }), {
    onChange: M,
    onBlur: T,
    value: N
  } = _, [I, O] = K(), [$, j] = K(!1), [Y, F] = K(!1), V = ie(null), J = ie(null), Q = hb(), X = e.some((G) => G.id === "empty"), z = (G, fe) => {
    const De = k(G), _e = k(fe), Fe = N == null ? void 0 : N.find((ke) => k(ke) === De), Je = N == null ? void 0 : N.find((ke) => k(ke) === _e);
    return !De || !_e ? 0 : Fe && Je ? De.localeCompare(_e) : Fe ? -1 : Je ? 1 : De.localeCompare(_e);
  }, me = n ? N == null ? void 0 : N.map((G) => k(G)).join(", ") : k(N) ?? N, Me = (G) => {
    if (!(G6(G) && k(G)) || !n) {
      M(G), o == null || o(G);
      return;
    }
    const _e = (N == null ? void 0 : N.find((Fe) => Fe.id === G.id)) ? N.filter((Fe) => Fe.id !== G.id) : [...N ?? [], G];
    M(_e), o == null || o(_e);
  }, Be = (G) => {
    const {
      type: fe
    } = G;
    !y && ["change", "focus"].includes(fe) && j(r), y && fe === "click" && j(!$);
  }, ve = (G) => {
    G !== I && O(G);
  }, Ae = (G) => {
    G.preventDefault(), j((fe) => !fe), !X && $ && I && Me(I);
  };
  W(() => {
    const [G] = e;
    Y && N && G && (j(!0), ve(G));
  }, [e]);
  const Te = /* @__PURE__ */ g(K6, {
    disabled: C,
    color: "text",
    className: "pointer-events-none"
  });
  return /* @__PURE__ */ P("div", {
    className: l,
    ref: Q,
    children: [/* @__PURE__ */ g(Xi, {
      id: x,
      label: f
    }), /* @__PURE__ */ P("div", {
      className: "relative",
      children: [/* @__PURE__ */ g(Hr, {
        name: d,
        "data-testid": x,
        id: x,
        "aria-label": x,
        value: me ?? "",
        ref: V,
        readOnly: y,
        type: "text",
        autoComplete: "off",
        disabled: C,
        className: D,
        autoFocus: v,
        ...w,
        onChange: (G) => {
          Me(G), Be(G);
        },
        onClick: (G) => {
          Be(G);
        },
        onBlur: () => {
          T(), F(!1), j(!1);
        },
        onFocus: (G) => {
          F(!0);
          const fe = J.current;
          if (!fe)
            return;
          Be(G);
          const De = e.findIndex((L) => L.id === (N == null ? void 0 : N.id)), _e = e[De], [Fe] = e, ke = [...Array(Math.max(0, De)).keys()].reduce((L, R) => L + fe.children[R].offsetHeight, 0), q = fe.children[De], ce = (q == null ? void 0 : q.offsetHeight) ?? 0, de = fe.offsetHeight, E = ce;
          fe.scroll(0, ke - de + E), ve(_e ?? Fe);
        },
        onKeyDown: async (G) => {
          switch (G.code) {
            case "ArrowDown":
            case "ArrowUp": {
              if (G.preventDefault(), j(!0), !$)
                return;
              const fe = e.filter((U) => !U.inactive), _e = {
                ArrowUp: -1,
                ArrowDown: 1
              }[G.code], Je = fe.findIndex((U) => U.id === (I == null ? void 0 : I.id)) + _e, ke = fe[Je], q = J.current;
              if (!ke || !q)
                return;
              const de = e.findIndex((U) => U.id === ke.id) + (G.code === "ArrowDown" ? 1 : 0), E = q.offsetHeight, L = q.scrollTop, R = E + L, H = [...Array(Math.max(0, de)).keys()].reduce((U, re) => U + q.children[re].offsetHeight, 0);
              H < L && q.scroll(0, H), H > R && q.scroll(0, H - E), ve(ke);
              break;
            }
            case "Tab":
              if (!$)
                break;
              Ae(G);
              break;
            case "Space":
              if (!n || !$ || !I)
                return;
              G.preventDefault(), Me(I);
              break;
            case "Enter":
            case "NumpadEnter":
              Ae(G);
              break;
            case "Escape":
              G.preventDefault(), j(!1);
              break;
          }
        }
      }), /* @__PURE__ */ g(he.div, {
        className: "absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none",
        transition: Ce,
        layoutId: `adornment_${x}`,
        children: s ? /* @__PURE__ */ g(Ji, {}) : a ?? Te
      }), /* @__PURE__ */ g(kt, {
        mode: "wait",
        children: /* @__PURE__ */ g(he.ul, {
          className: te("absolute left-0 right-0 top-full mt-1 py-0 overflow-auto rounded bg-app-background shadow-lg shadow-shadow/10 z-40 scrollbar-hide", "text-base sm:text-sm", "ring-1 ring-border/20 focus:outline-none", vb[i], !$ && "pointer-events-none"),
          "data-testid": `option-view_${d}_options`,
          ref: J,
          initial: {
            opacity: 0
          },
          animate: {
            opacity: $ ? 1 : 0
          },
          exit: {
            opacity: 0
          },
          transition: Ce,
          layout: "position",
          onAnimationComplete: () => !$ && n && e.sort(z),
          children: e.map((G, fe) => {
            const De = G.id === (I == null ? void 0 : I.id), _e = e.length === fe + 1, Fe = n ? N == null ? void 0 : N.some((L) => L.id === G.id) : G.id === (N == null ? void 0 : N.id), {
              inactive: Je
            } = G, ke = G.icon, de = Je ? "text-input-disabled-foreground bg-input-disabled cursor-default" : De ? "bg-secondary text-secondary-foreground" : "text-foreground", E = typeof G.description == "string" ? [G.description] : G.description;
            return /* @__PURE__ */ P("li", {
              className: "group cursor-default select-none relative",
              children: [/* @__PURE__ */ P("button", {
                onMouseOver: () => ve(G),
                onMouseDown: (L) => L.preventDefault(),
                onFocus: () => {
                },
                onMouseUp: () => {
                  var L;
                  Je || (Me(G), n || (L = V.current) == null || L.blur());
                },
                "aria-label": "option-view_list_button",
                type: "button",
                className: te("flex flex-col w-full px-4 py-3 text-left", de),
                tabIndex: -1,
                disabled: X,
                "data-testid": G.id,
                children: [/* @__PURE__ */ P("div", {
                  className: "flex justify-between items-center w-full",
                  children: [/* @__PURE__ */ P("div", {
                    className: "flex gap-3",
                    children: [ke && /* @__PURE__ */ g(ke, {
                      className: "w-5 h-5 mt-0.5"
                    }), /* @__PURE__ */ g(oe, {
                      className: "text-inherit",
                      size: "sm",
                      children: k(G)
                    })]
                  }), Fe && /* @__PURE__ */ g(Qi, {
                    className: te("w-4 h-4", De ? "text-secondary-foreground" : "text-secondary group-hover")
                  })]
                }), E == null ? void 0 : E.map((L) => /* @__PURE__ */ g(oe, {
                  className: te(De ? "text-secondary-foreground/60" : "text-foreground/60"),
                  size: "sm",
                  weight: "light",
                  children: L
                }, `${k(G)}-${L}`))]
              }), !_e && /* @__PURE__ */ g(no, {
                className: "mx-4"
              })]
            }, G.id);
          })
        })
      })]
    }), /* @__PURE__ */ g(jt, {
      name: d,
      error: p
    })]
  });
}
function jl(e) {
  return G6(e) && "kvkNumber" in e;
}
function nu({
  searchValue: e,
  delay: n = 500
}) {
  const [t, r] = K(!1), [o, s] = K(""), [a, i] = K([]);
  return W(() => {
    const l = setTimeout(async () => {
      var u, d, f;
      if (typeof e == "string") {
        if (e.trim().length < 3) {
          i([]);
          return;
        }
        s(""), r(!0);
        try {
          const p = H6(e), {
            data: m
          } = await ob(p), h = m.map((y) => {
            const {
              kvkNumber: C,
              name: v,
              street: w,
              homeNumber: x,
              id: D,
              postalCode: k,
              city: _
            } = y, M = w && x ? `${w} ${x}` : "", T = [k, _].filter(Boolean).join(", "), N = D ?? Object.values(y).filter(Boolean).join("_"), I = {
              kvkNumber: C,
              id: N,
              title: v,
              description: [C]
            };
            return T ? I.description.unshift(T) : I.error = "INVALID_KVK_NUMBER", M ? I.description.unshift(M) : I.error = "INVALID_ADDRESS", I;
          });
          i(h);
        } catch (p) {
          if (!Zr(p))
            return;
          const m = (f = (d = (u = p == null ? void 0 : p.response) == null ? void 0 : u.data) == null ? void 0 : d.code) == null ? void 0 : f.toLowerCase(), h = m == null ? void 0 : m.includes("invalidinput"), {
            ALPHANUMERIC: y
          } = qv, C = h ? y : un(p);
          s(C);
        } finally {
          r(!1);
        }
      }
    }, n);
    return () => {
      clearTimeout(l);
    };
  }, [e, n]), {
    companies: a,
    isFetching: t,
    error: o
  };
}
function bb({
  options: e,
  ...n
}) {
  const [t, r] = K([]), o = {
    id: "empty",
    title: "Geen resultaten"
  };
  return W(() => r(e.length ? e : [o]), [e]), /* @__PURE__ */ g(q6, {
    ...n,
    shouldOpen: (e == null ? void 0 : e.length) > 0,
    options: t,
    readOnly: !1
  });
}
function Q6({
  control: e,
  name: n,
  formState: t,
  watch: r,
  clearErrors: o,
  setError: s,
  label: a,
  placeholder: i,
  rules: c,
  disabled: l
}) {
  var w;
  const {
    t: u
  } = pe(), d = r(n), {
    errors: f
  } = t, {
    isFetching: p,
    companies: m,
    error: h
  } = nu({
    searchValue: d
  }), y = (w = f[n]) == null ? void 0 : w.message, C = typeof y == "string" ? y : void 0, v = {
    required: u(pt.required),
    ...c,
    validate: {
      invalid: jl || u(pt.invalidSelection),
      ...c == null ? void 0 : c.validate
    }
  };
  return W(() => {
    if (h) {
      s(n, {
        type: "custom",
        message: u(h)
      });
      return;
    }
    f.debtor_b2b && o(n);
  }, [h]), /* @__PURE__ */ g(bb, {
    displayValue: (x) => x.title,
    label: a,
    placeholder: i,
    control: e,
    name: n,
    isLoading: p,
    shouldUnregister: !0,
    error: C,
    state: C ? "error" : void 0,
    options: m,
    rules: v,
    disabled: l
  });
}
function At({
  children: e
}) {
  return /* @__PURE__ */ g(he.div, {
    className: "flex flex-col w-full flex-1 justify-between",
    transition: Ce,
    layout: "position",
    children: e
  });
}
const Nt = xe(({
  className: e,
  children: n
}, t) => /* @__PURE__ */ g(he.div, {
  className: te("flex flex-col items-center w-full px-6 [&>*]:sm:max-w-content", e),
  ref: t,
  transition: Ce,
  layout: "position",
  children: n
})), It = xe(({
  className: e,
  children: n
}, t) => /* @__PURE__ */ g(he.div, {
  className: te("flex flex-col w-full gap-2 text-left", e),
  ref: t,
  transition: Ce,
  layout: "position",
  children: n
})), zt = xe(({
  className: e,
  children: n,
  showBlur: t
}, r) => /* @__PURE__ */ g(he.div, {
  className: te("sticky bottom-0 flex flex-col items-center w-full mt-6 pb-6 px-6 [&>*]:sm:max-w-content", t && "backdrop-blur-md transition-[backdrop-filter] duration-1000", e),
  ref: r,
  transition: Ce,
  layout: "position",
  children: n
})), Cb = Er(te("inline-flex items-center justify-center gap-4 rounded backdrop-blur-sm", "text-sm font-semibold transition-colors", "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none", "disabled:pointer-events-none"), {
  variants: {
    variant: {
      base: te("bg-primary text-primary-foreground shadow-sm", "border-2 border-transparent", "hover:bg-primary/70", "focus-visible:ring-primary", "disabled:bg-button-disabled disabled:text-button-disabled-foreground"),
      secondary: te("bg-secondary text-secondary-foreground shadow-sm", "border-2 border-transparent", "hover:bg-secondary/70", "focus-visible:ring-secondary", "disabled:bg-button-disabled disabled:text-button-disabled-foreground"),
      destructive: te("bg-destructive text-destructive-foreground shadow-sm", "border-2 border-transparent", "hover:bg-destructive/70", "focus-visible:ring-destructive", "disabled:bg-button-disabled disabled:text-button-disabled-foreground"),
      outline: te("text-primary font-normal shadow-sm bg-app-background", "border border-primary", "hover:bg-primary/20", "focus-visible:ring-secondary focus-visible:ring-offset-app-background", "disabled:bg-input-disabled disabled:text-input-disabled-foreground disabled:font-light disabled:border-border/40"),
      outline_thin: te("text-foreground font-light shadow-sm", "border border-input", "hover:bg-primary/20", "focus-visible:ring-primary focus-visible:ring-offset-app-background", "disabled:bg-input-disabled disabled:text-input-disabled-foreground disabled:font-light disabled:border-border/40"),
      link: te("text-secondary underline-offset-2", "border-none", "hover:text-primary hover:underline", "focus-visible:ring-0 focus-visible:ring-offset-0", "disabled:text-button-disabled"),
      ghost: te("text-primary", "border-none", "hover:text-primary/50", "focus-visible:ring-primary focus-visible:ring-offset-app-background", "disabled:text-button-disabled")
    },
    size: {
      icon: "px-0",
      sm: "h-8 px-3 text-xs",
      md: "h-10 px-6",
      lg: "h-12 px-8"
    }
  },
  defaultVariants: {
    variant: "base",
    size: "md"
  }
}), Re = xe(({
  label: e,
  name: n,
  isLoading: t,
  className: r,
  variant: o,
  size: s,
  disabled: a,
  children: i,
  ...c
}, l) => {
  const u = te(Cb({
    variant: o,
    size: s,
    className: r
  })), d = `button_${n}`;
  return /* @__PURE__ */ P("button", {
    type: "button",
    disabled: a || t,
    name: n,
    "data-testid": d,
    id: d,
    "aria-label": d,
    className: u,
    ref: l,
    ...c,
    children: [t && /* @__PURE__ */ g(Ji, {}), /* @__PURE__ */ g("span", {
      className: "truncate",
      children: i ?? e
    })]
  });
});
function Ie() {
  return Ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Ie.apply(this, arguments);
}
function Wn(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), t === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function wb(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function X6(...e) {
  return (n) => e.forEach(
    (t) => wb(t, n)
  );
}
function An(...e) {
  return cn(X6(...e), e);
}
function Xo(e, n = []) {
  let t = [];
  function r(s, a) {
    const i = /* @__PURE__ */ Rt(a), c = t.length;
    t = [
      ...t,
      a
    ];
    function l(d) {
      const { scope: f, children: p, ...m } = d, h = (f == null ? void 0 : f[e][c]) || i, y = Et(
        () => m,
        Object.values(m)
      );
      return /* @__PURE__ */ le(h.Provider, {
        value: y
      }, p);
    }
    function u(d, f) {
      const p = (f == null ? void 0 : f[e][c]) || i, m = ze(p);
      if (m)
        return m;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return l.displayName = s + "Provider", [
      l,
      u
    ];
  }
  const o = () => {
    const s = t.map((a) => /* @__PURE__ */ Rt(a));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return Et(
        () => ({
          [`__scope${e}`]: {
            ...i,
            [e]: c
          }
        }),
        [
          i,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    xb(o, ...n)
  ];
}
function xb(...e) {
  const n = e[0];
  if (e.length === 1)
    return n;
  const t = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(s) {
      const a = r.reduce((i, { useScope: c, scopeName: l }) => {
        const d = c(s)[`__scope${l}`];
        return {
          ...i,
          ...d
        };
      }, {});
      return Et(
        () => ({
          [`__scope${n.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return t.scopeName = n.scopeName, t;
}
const Rs = globalThis != null && globalThis.document ? Wo : () => {
}, Db = b.useId || (() => {
});
let Sb = 0;
function Ss(e) {
  const [n, t] = b.useState(Db());
  return Rs(() => {
    e || t(
      (r) => r ?? String(Sb++)
    );
  }, [
    e
  ]), e || (n ? `radix-${n}` : "");
}
function zr(e) {
  const n = ie(e);
  return W(() => {
    n.current = e;
  }), Et(
    () => (...t) => {
      var r;
      return (r = n.current) === null || r === void 0 ? void 0 : r.call(n, ...t);
    },
    []
  );
}
function ta({ prop: e, defaultProp: n, onChange: t = () => {
} }) {
  const [r, o] = Eb({
    defaultProp: n,
    onChange: t
  }), s = e !== void 0, a = s ? e : r, i = zr(t), c = cn((l) => {
    if (s) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && i(d);
    } else
      o(l);
  }, [
    s,
    e,
    o,
    i
  ]);
  return [
    a,
    c
  ];
}
function Eb({ defaultProp: e, onChange: n }) {
  const t = K(e), [r] = t, o = ie(r), s = zr(n);
  return W(() => {
    o.current !== r && (s(r), o.current = r);
  }, [
    r,
    o,
    s
  ]), t;
}
const Is = /* @__PURE__ */ xe((e, n) => {
  const { children: t, ...r } = e, o = $n.toArray(t), s = o.find(Mb);
  if (s) {
    const a = s.props.children, i = o.map((c) => c === s ? $n.count(a) > 1 ? $n.only(null) : /* @__PURE__ */ Kn(a) ? a.props.children : null : c);
    return /* @__PURE__ */ le(Yl, Ie({}, r, {
      ref: n
    }), /* @__PURE__ */ Kn(a) ? /* @__PURE__ */ Ws(a, void 0, i) : null);
  }
  return /* @__PURE__ */ le(Yl, Ie({}, r, {
    ref: n
  }), t);
});
Is.displayName = "Slot";
const Yl = /* @__PURE__ */ xe((e, n) => {
  const { children: t, ...r } = e;
  return /* @__PURE__ */ Kn(t) ? /* @__PURE__ */ Ws(t, {
    ...kb(r, t.props),
    ref: n ? X6(n, t.ref) : t.ref
  }) : $n.count(t) > 1 ? $n.only(null) : null;
});
Yl.displayName = "SlotClone";
const _b = ({ children: e }) => /* @__PURE__ */ le(Us, null, e);
function Mb(e) {
  return /* @__PURE__ */ Kn(e) && e.type === _b;
}
function kb(e, n) {
  const t = {
    ...n
  };
  for (const r in n) {
    const o = e[r], s = n[r];
    /^on[A-Z]/.test(r) ? o && s ? t[r] = (...i) => {
      s(...i), o(...i);
    } : o && (t[r] = o) : r === "style" ? t[r] = {
      ...o,
      ...s
    } : r === "className" && (t[r] = [
      o,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...t
  };
}
const Ab = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gt = Ab.reduce((e, n) => {
  const t = /* @__PURE__ */ xe((r, o) => {
    const { asChild: s, ...a } = r, i = s ? Is : n;
    return W(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ le(i, Ie({}, a, {
      ref: o
    }));
  });
  return t.displayName = `Primitive.${n}`, {
    ...e,
    [n]: t
  };
}, {});
function Nb(e, n) {
  e && r0(
    () => e.dispatchEvent(n)
  );
}
function Lb(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = zr(e);
  W(() => {
    const r = (o) => {
      o.key === "Escape" && t(o);
    };
    return n.addEventListener("keydown", r), () => n.removeEventListener("keydown", r);
  }, [
    t,
    n
  ]);
}
const Hl = "dismissableLayer.update", Tb = "dismissableLayer.pointerDownOutside", Pb = "dismissableLayer.focusOutside";
let Fd;
const Ob = /* @__PURE__ */ Rt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Rb = /* @__PURE__ */ xe((e, n) => {
  var t;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: a, onInteractOutside: i, onDismiss: c, ...l } = e, u = ze(Ob), [d, f] = K(null), p = (t = d == null ? void 0 : d.ownerDocument) !== null && t !== void 0 ? t : globalThis == null ? void 0 : globalThis.document, [, m] = K({}), h = An(
    n,
    (M) => f(M)
  ), y = Array.from(u.layers), [C] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = y.indexOf(C), w = d ? y.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, D = w >= v, k = Ib((M) => {
    const T = M.target, N = [
      ...u.branches
    ].some(
      (I) => I.contains(T)
    );
    !D || N || (s == null || s(M), i == null || i(M), M.defaultPrevented || c == null || c());
  }, p), _ = Fb((M) => {
    const T = M.target;
    [
      ...u.branches
    ].some(
      (I) => I.contains(T)
    ) || (a == null || a(M), i == null || i(M), M.defaultPrevented || c == null || c());
  }, p);
  return Lb((M) => {
    w === u.layers.size - 1 && (o == null || o(M), !M.defaultPrevented && c && (M.preventDefault(), c()));
  }, p), W(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Fd = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Vd(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Fd);
      };
  }, [
    d,
    p,
    r,
    u
  ]), W(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Vd());
  }, [
    d,
    u
  ]), W(() => {
    const M = () => m({});
    return document.addEventListener(Hl, M), () => document.removeEventListener(Hl, M);
  }, []), /* @__PURE__ */ le(Gt.div, Ie({}, l, {
    ref: h,
    style: {
      pointerEvents: x ? D ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Wn(e.onFocusCapture, _.onFocusCapture),
    onBlurCapture: Wn(e.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: Wn(e.onPointerDownCapture, k.onPointerDownCapture)
  }));
});
function Ib(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = zr(e), r = ie(!1), o = ie(() => {
  });
  return W(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let l = function() {
          J6(Tb, t, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: i
        };
        i.pointerType === "touch" ? (n.removeEventListener("click", o.current), o.current = l, n.addEventListener("click", o.current, {
          once: !0
        })) : l();
      } else
        n.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), n.removeEventListener("pointerdown", s), n.removeEventListener("click", o.current);
    };
  }, [
    n,
    t
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Fb(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = zr(e), r = ie(!1);
  return W(() => {
    const o = (s) => {
      s.target && !r.current && J6(Pb, t, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", o), () => n.removeEventListener("focusin", o);
  }, [
    n,
    t
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Vd() {
  const e = new CustomEvent(Hl);
  document.dispatchEvent(e);
}
function J6(e, n, t, { discrete: r }) {
  const o = t.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  n && o.addEventListener(e, n, {
    once: !0
  }), r ? Nb(o, s) : o.dispatchEvent(s);
}
const jc = "focusScope.autoFocusOnMount", Yc = "focusScope.autoFocusOnUnmount", $d = {
  bubbles: !1,
  cancelable: !0
}, Vb = /* @__PURE__ */ xe((e, n) => {
  const { loop: t = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: s, ...a } = e, [i, c] = K(null), l = zr(o), u = zr(s), d = ie(null), f = An(
    n,
    (h) => c(h)
  ), p = ie({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  W(() => {
    if (r) {
      let h = function(w) {
        if (p.paused || !i)
          return;
        const x = w.target;
        i.contains(x) ? d.current = x : sr(d.current, {
          select: !0
        });
      }, y = function(w) {
        if (p.paused || !i)
          return;
        const x = w.relatedTarget;
        x !== null && (i.contains(x) || sr(d.current, {
          select: !0
        }));
      }, C = function(w) {
        if (document.activeElement === document.body)
          for (const D of w)
            D.removedNodes.length > 0 && sr(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", y);
      const v = new MutationObserver(C);
      return i && v.observe(i, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", y), v.disconnect();
      };
    }
  }, [
    r,
    i,
    p.paused
  ]), W(() => {
    if (i) {
      jd.add(p);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const C = new CustomEvent(jc, $d);
        i.addEventListener(jc, l), i.dispatchEvent(C), C.defaultPrevented || ($b(Ub(e3(i)), {
          select: !0
        }), document.activeElement === h && sr(i));
      }
      return () => {
        i.removeEventListener(jc, l), setTimeout(() => {
          const C = new CustomEvent(Yc, $d);
          i.addEventListener(Yc, u), i.dispatchEvent(C), C.defaultPrevented || sr(h ?? document.body, {
            select: !0
          }), i.removeEventListener(Yc, u), jd.remove(p);
        }, 0);
      };
    }
  }, [
    i,
    l,
    u,
    p
  ]);
  const m = cn((h) => {
    if (!t && !r || p.paused)
      return;
    const y = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, C = document.activeElement;
    if (y && C) {
      const v = h.currentTarget, [w, x] = Bb(v);
      w && x ? !h.shiftKey && C === x ? (h.preventDefault(), t && sr(w, {
        select: !0
      })) : h.shiftKey && C === w && (h.preventDefault(), t && sr(x, {
        select: !0
      })) : C === v && h.preventDefault();
    }
  }, [
    t,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ le(Gt.div, Ie({
    tabIndex: -1
  }, a, {
    ref: f,
    onKeyDown: m
  }));
});
function $b(e, { select: n = !1 } = {}) {
  const t = document.activeElement;
  for (const r of e)
    if (sr(r, {
      select: n
    }), document.activeElement !== t)
      return;
}
function Bb(e) {
  const n = e3(e), t = Bd(n, e), r = Bd(n.reverse(), e);
  return [
    t,
    r
  ];
}
function e3(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); )
    n.push(t.currentNode);
  return n;
}
function Bd(e, n) {
  for (const t of e)
    if (!jb(t, {
      upTo: n
    }))
      return t;
}
function jb(e, { upTo: n }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (n !== void 0 && e === n)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Yb(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function sr(e, { select: n = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== t && Yb(e) && n && e.select();
  }
}
const jd = Hb();
function Hb() {
  let e = [];
  return {
    add(n) {
      const t = e[0];
      n !== t && (t == null || t.pause()), e = Yd(e, n), e.unshift(n);
    },
    remove(n) {
      var t;
      e = Yd(e, n), (t = e[0]) === null || t === void 0 || t.resume();
    }
  };
}
function Yd(e, n) {
  const t = [
    ...e
  ], r = t.indexOf(n);
  return r !== -1 && t.splice(r, 1), t;
}
function Ub(e) {
  return e.filter(
    (n) => n.tagName !== "A"
  );
}
const Wb = /* @__PURE__ */ xe((e, n) => {
  var t;
  const { container: r = globalThis == null || (t = globalThis.document) === null || t === void 0 ? void 0 : t.body, ...o } = e;
  return r ? /* @__PURE__ */ n0.createPortal(/* @__PURE__ */ le(Gt.div, Ie({}, o, {
    ref: n
  })), r) : null;
});
function Zb(e, n) {
  return e0((t, r) => {
    const o = n[t][r];
    return o ?? t;
  }, e);
}
const na = (e) => {
  const { present: n, children: t } = e, r = Kb(n), o = typeof t == "function" ? t({
    present: r.isPresent
  }) : $n.only(t), s = An(r.ref, o.ref);
  return typeof t == "function" || r.isPresent ? /* @__PURE__ */ Ws(o, {
    ref: s
  }) : null;
};
na.displayName = "Presence";
function Kb(e) {
  const [n, t] = K(), r = ie({}), o = ie(e), s = ie("none"), a = e ? "mounted" : "unmounted", [i, c] = Zb(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return W(() => {
    const l = Ca(r.current);
    s.current = i === "mounted" ? l : "none";
  }, [
    i
  ]), Rs(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const f = s.current, p = Ca(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && f !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), Rs(() => {
    if (n) {
      const l = (d) => {
        const p = Ca(r.current).includes(d.animationName);
        d.target === n && p && r0(
          () => c("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === n && (s.current = Ca(r.current));
      };
      return n.addEventListener("animationstart", u), n.addEventListener("animationcancel", l), n.addEventListener("animationend", l), () => {
        n.removeEventListener("animationstart", u), n.removeEventListener("animationcancel", l), n.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    n,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(i),
    ref: cn((l) => {
      l && (r.current = getComputedStyle(l)), t(l);
    }, [])
  };
}
function Ca(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Hc = 0;
function zb() {
  W(() => {
    var e, n;
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = t[0]) !== null && e !== void 0 ? e : Hd()), document.body.insertAdjacentElement("beforeend", (n = t[1]) !== null && n !== void 0 ? n : Hd()), Hc++, () => {
      Hc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Hc--;
    };
  }, []);
}
function Hd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Ya = "right-scroll-bar-position", Ha = "width-before-scroll-bar", Gb = "with-scroll-bars-hidden", qb = "--removed-body-scroll-bar-size";
function Uc(e, n) {
  return typeof e == "function" ? e(n) : e && (e.current = n), e;
}
function Qb(e, n) {
  var t = K(function() {
    return {
      // value
      value: e,
      // last callback
      callback: n,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(r) {
          var o = t.value;
          o !== r && (t.value = r, t.callback(r, o));
        }
      }
    };
  })[0];
  return t.callback = n, t.facade;
}
var Xb = typeof window < "u" ? b.useLayoutEffect : b.useEffect, Ud = /* @__PURE__ */ new WeakMap();
function Jb(e, n) {
  var t = Qb(n || null, function(r) {
    return e.forEach(function(o) {
      return Uc(o, r);
    });
  });
  return Xb(function() {
    var r = Ud.get(t);
    if (r) {
      var o = new Set(r), s = new Set(e), a = t.current;
      o.forEach(function(i) {
        s.has(i) || Uc(i, null);
      }), s.forEach(function(i) {
        o.has(i) || Uc(i, a);
      });
    }
    Ud.set(t, e);
  }, [e]), t;
}
function eC(e) {
  return e;
}
function tC(e, n) {
  n === void 0 && (n = eC);
  var t = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(s) {
      var a = n(s, r);
      return t.push(a), function() {
        t = t.filter(function(i) {
          return i !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; t.length; ) {
        var a = t;
        t = [], a.forEach(s);
      }
      t = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var a = [];
      if (t.length) {
        var i = t;
        t = [], i.forEach(s), a = t;
      }
      var c = function() {
        var u = a;
        a = [], u.forEach(s);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), t = {
        push: function(u) {
          a.push(u), l();
        },
        filter: function(u) {
          return a = a.filter(u), t;
        }
      };
    }
  };
  return o;
}
function nC(e) {
  e === void 0 && (e = {});
  var n = tC(null);
  return n.options = gn({ async: !0, ssr: !1 }, e), n;
}
var t3 = function(e) {
  var n = e.sideCar, t = o0(e, ["sideCar"]);
  if (!n)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = n.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, gn({}, t));
};
t3.isSideCarExport = !0;
function rC(e, n) {
  return e.useMedium(n), t3;
}
var n3 = nC(), Wc = function() {
}, ec = b.forwardRef(function(e, n) {
  var t = b.useRef(null), r = b.useState({
    onScrollCapture: Wc,
    onWheelCapture: Wc,
    onTouchMoveCapture: Wc
  }), o = r[0], s = r[1], a = e.forwardProps, i = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, m = e.inert, h = e.allowPinchZoom, y = e.as, C = y === void 0 ? "div" : y, v = o0(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, x = Jb([t, n]), D = gn(gn({}, v), o);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(w, { sideCar: n3, removeScrollBar: l, shards: d, noIsolation: p, inert: m, setCallbacks: s, allowPinchZoom: !!h, lockRef: t }),
    a ? b.cloneElement(b.Children.only(i), gn(gn({}, D), { ref: x })) : b.createElement(C, gn({}, D, { className: c, ref: x }), i)
  );
});
ec.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ec.classNames = {
  fullWidth: Ha,
  zeroRight: Ya
};
var oC = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function sC() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var n = oC();
  return n && e.setAttribute("nonce", n), e;
}
function aC(e, n) {
  e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n));
}
function iC(e) {
  var n = document.head || document.getElementsByTagName("head")[0];
  n.appendChild(e);
}
var cC = function() {
  var e = 0, n = null;
  return {
    add: function(t) {
      e == 0 && (n = sC()) && (aC(n, t), iC(n)), e++;
    },
    remove: function() {
      e--, !e && n && (n.parentNode && n.parentNode.removeChild(n), n = null);
    }
  };
}, lC = function() {
  var e = cC();
  return function(n, t) {
    b.useEffect(function() {
      return e.add(n), function() {
        e.remove();
      };
    }, [n && t]);
  };
}, r3 = function() {
  var e = lC(), n = function(t) {
    var r = t.styles, o = t.dynamic;
    return e(r, o), null;
  };
  return n;
}, uC = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Zc = function(e) {
  return parseInt(e || "", 10) || 0;
}, dC = function(e) {
  var n = window.getComputedStyle(document.body), t = n[e === "padding" ? "paddingLeft" : "marginLeft"], r = n[e === "padding" ? "paddingTop" : "marginTop"], o = n[e === "padding" ? "paddingRight" : "marginRight"];
  return [Zc(t), Zc(r), Zc(o)];
}, fC = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return uC;
  var n = dC(e), t = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: n[0],
    top: n[1],
    right: n[2],
    gap: Math.max(0, r - t + n[2] - n[0])
  };
}, pC = r3(), No = "data-scroll-locked", hC = function(e, n, t, r) {
  var o = e.left, s = e.top, a = e.right, i = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(Gb, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(No, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    n && "position: relative ".concat(r, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    t === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ya, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(Ha, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(Ya, " .").concat(Ya, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ha, " .").concat(Ha, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(No, `] {
    `).concat(qb, ": ").concat(i, `px;
  }
`);
}, Wd = function() {
  var e = parseInt(document.body.getAttribute(No) || "0", 10);
  return isFinite(e) ? e : 0;
}, mC = function() {
  b.useEffect(function() {
    return document.body.setAttribute(No, (Wd() + 1).toString()), function() {
      var e = Wd() - 1;
      e <= 0 ? document.body.removeAttribute(No) : document.body.setAttribute(No, e.toString());
    };
  }, []);
}, gC = function(e) {
  var n = e.noRelative, t = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  mC();
  var s = b.useMemo(function() {
    return fC(o);
  }, [o]);
  return b.createElement(pC, { styles: hC(s, !n, o, t ? "" : "!important") });
}, Ul = !1;
if (typeof window < "u")
  try {
    var wa = Object.defineProperty({}, "passive", {
      get: function() {
        return Ul = !0, !0;
      }
    });
    window.addEventListener("test", wa, wa), window.removeEventListener("test", wa, wa);
  } catch {
    Ul = !1;
  }
var ho = Ul ? { passive: !1 } : !1, yC = function(e) {
  return e.tagName === "TEXTAREA";
}, o3 = function(e, n) {
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[n] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !yC(e) && t[n] === "visible")
  );
}, vC = function(e) {
  return o3(e, "overflowY");
}, bC = function(e) {
  return o3(e, "overflowX");
}, Zd = function(e, n) {
  var t = n;
  do {
    typeof ShadowRoot < "u" && t instanceof ShadowRoot && (t = t.host);
    var r = s3(e, t);
    if (r) {
      var o = a3(e, t), s = o[1], a = o[2];
      if (s > a)
        return !0;
    }
    t = t.parentNode;
  } while (t && t !== document.body);
  return !1;
}, CC = function(e) {
  var n = e.scrollTop, t = e.scrollHeight, r = e.clientHeight;
  return [
    n,
    t,
    r
  ];
}, wC = function(e) {
  var n = e.scrollLeft, t = e.scrollWidth, r = e.clientWidth;
  return [
    n,
    t,
    r
  ];
}, s3 = function(e, n) {
  return e === "v" ? vC(n) : bC(n);
}, a3 = function(e, n) {
  return e === "v" ? CC(n) : wC(n);
}, xC = function(e, n) {
  return e === "h" && n === "rtl" ? -1 : 1;
}, DC = function(e, n, t, r, o) {
  var s = xC(e, window.getComputedStyle(n).direction), a = s * r, i = t.target, c = n.contains(i), l = !1, u = a > 0, d = 0, f = 0;
  do {
    var p = a3(e, i), m = p[0], h = p[1], y = p[2], C = h - y - s * m;
    (m || C) && s3(e, i) && (d += C, f += m), i = i.parentNode;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (n.contains(i) || n === i)
  );
  return (u && (o && d === 0 || !o && a > d) || !u && (o && f === 0 || !o && -a > f)) && (l = !0), l;
}, xa = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Kd = function(e) {
  return [e.deltaX, e.deltaY];
}, zd = function(e) {
  return e && "current" in e ? e.current : e;
}, SC = function(e, n) {
  return e[0] === n[0] && e[1] === n[1];
}, EC = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _C = 0, mo = [];
function MC(e) {
  var n = b.useRef([]), t = b.useRef([0, 0]), r = b.useRef(), o = b.useState(_C++)[0], s = b.useState(function() {
    return r3();
  })[0], a = b.useRef(e);
  b.useEffect(function() {
    a.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = qa([e.lockRef.current], (e.shards || []).map(zd), !0).filter(Boolean);
      return h.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = b.useCallback(function(h, y) {
    if ("touches" in h && h.touches.length === 2)
      return !a.current.allowPinchZoom;
    var C = xa(h), v = t.current, w = "deltaX" in h ? h.deltaX : v[0] - C[0], x = "deltaY" in h ? h.deltaY : v[1] - C[1], D, k = h.target, _ = Math.abs(w) > Math.abs(x) ? "h" : "v";
    if ("touches" in h && _ === "h" && k.type === "range")
      return !1;
    var M = Zd(_, k);
    if (!M)
      return !0;
    if (M ? D = _ : (D = _ === "v" ? "h" : "v", M = Zd(_, k)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (w || x) && (r.current = D), !D)
      return !0;
    var T = r.current || D;
    return DC(T, y, h, T === "h" ? w : x, !0);
  }, []), c = b.useCallback(function(h) {
    var y = h;
    if (!(!mo.length || mo[mo.length - 1] !== s)) {
      var C = "deltaY" in y ? Kd(y) : xa(y), v = n.current.filter(function(D) {
        return D.name === y.type && D.target === y.target && SC(D.delta, C);
      })[0];
      if (v && v.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!v) {
        var w = (a.current.shards || []).map(zd).filter(Boolean).filter(function(D) {
          return D.contains(y.target);
        }), x = w.length > 0 ? i(y, w[0]) : !a.current.noIsolation;
        x && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = b.useCallback(function(h, y, C, v) {
    var w = { name: h, delta: y, target: C, should: v };
    n.current.push(w), setTimeout(function() {
      n.current = n.current.filter(function(x) {
        return x !== w;
      });
    }, 1);
  }, []), u = b.useCallback(function(h) {
    t.current = xa(h), r.current = void 0;
  }, []), d = b.useCallback(function(h) {
    l(h.type, Kd(h), h.target, i(h, e.lockRef.current));
  }, []), f = b.useCallback(function(h) {
    l(h.type, xa(h), h.target, i(h, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return mo.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, ho), document.addEventListener("touchmove", c, ho), document.addEventListener("touchstart", u, ho), function() {
      mo = mo.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", c, ho), document.removeEventListener("touchmove", c, ho), document.removeEventListener("touchstart", u, ho);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    m ? b.createElement(s, { styles: EC(o) }) : null,
    p ? b.createElement(gC, { gapMode: "margin" }) : null
  );
}
const kC = rC(n3, MC);
var i3 = b.forwardRef(function(e, n) {
  return b.createElement(ec, gn({}, e, { ref: n, sideCar: kC }));
});
i3.classNames = ec.classNames;
const AC = i3;
var NC = function(e) {
  if (typeof document > "u")
    return null;
  var n = Array.isArray(e) ? e[0] : e;
  return n.ownerDocument.body;
}, go = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), Sa = {}, Kc = 0, c3 = function(e) {
  return e && (e.host || c3(e.parentNode));
}, LC = function(e, n) {
  return n.map(function(t) {
    if (e.contains(t))
      return t;
    var r = c3(t);
    return r && e.contains(r) ? r : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, TC = function(e, n, t, r) {
  var o = LC(n, Array.isArray(e) ? e : [e]);
  Sa[t] || (Sa[t] = /* @__PURE__ */ new WeakMap());
  var s = Sa[t], a = [], i = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || i.has(d) || (i.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (i.has(f))
        u(f);
      else
        try {
          var p = f.getAttribute(r), m = p !== null && p !== "false", h = (go.get(f) || 0) + 1, y = (s.get(f) || 0) + 1;
          go.set(f, h), s.set(f, y), a.push(f), h === 1 && m && Da.set(f, !0), y === 1 && f.setAttribute(t, "true"), m || f.setAttribute(r, "true");
        } catch (C) {
          console.error("aria-hidden: cannot operate on ", f, C);
        }
    });
  };
  return u(n), i.clear(), Kc++, function() {
    a.forEach(function(d) {
      var f = go.get(d) - 1, p = s.get(d) - 1;
      go.set(d, f), s.set(d, p), f || (Da.has(d) || d.removeAttribute(r), Da.delete(d)), p || d.removeAttribute(t);
    }), Kc--, Kc || (go = /* @__PURE__ */ new WeakMap(), go = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), Sa = {});
  };
}, PC = function(e, n, t) {
  t === void 0 && (t = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = n || NC(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), TC(r, o, t, "aria-hidden")) : function() {
    return null;
  };
};
const l3 = "Dialog", [u3, cN] = Xo(l3), [OC, ro] = u3(l3), RC = (e) => {
  const { __scopeDialog: n, children: t, open: r, defaultOpen: o, onOpenChange: s, modal: a = !0 } = e, i = ie(null), c = ie(null), [l = !1, u] = ta({
    prop: r,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ le(OC, {
    scope: n,
    triggerRef: i,
    contentRef: c,
    contentId: Ss(),
    titleId: Ss(),
    descriptionId: Ss(),
    open: l,
    onOpenChange: u,
    onOpenToggle: cn(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: a
  }, t);
}, d3 = "DialogPortal", [IC, f3] = u3(d3, {
  forceMount: void 0
}), FC = (e) => {
  const { __scopeDialog: n, forceMount: t, children: r, container: o } = e, s = ro(d3, n);
  return /* @__PURE__ */ le(IC, {
    scope: n,
    forceMount: t
  }, $n.map(
    r,
    (a) => /* @__PURE__ */ le(na, {
      present: t || s.open
    }, /* @__PURE__ */ le(Wb, {
      asChild: !0,
      container: o
    }, a))
  ));
}, Wl = "DialogOverlay", VC = /* @__PURE__ */ xe((e, n) => {
  const t = f3(Wl, e.__scopeDialog), { forceMount: r = t.forceMount, ...o } = e, s = ro(Wl, e.__scopeDialog);
  return s.modal ? /* @__PURE__ */ le(na, {
    present: r || s.open
  }, /* @__PURE__ */ le($C, Ie({}, o, {
    ref: n
  }))) : null;
}), $C = /* @__PURE__ */ xe((e, n) => {
  const { __scopeDialog: t, ...r } = e, o = ro(Wl, t);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ le(AC, {
      as: Is,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ le(Gt.div, Ie({
      "data-state": h3(o.open)
    }, r, {
      ref: n,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Fs = "DialogContent", BC = /* @__PURE__ */ xe((e, n) => {
  const t = f3(Fs, e.__scopeDialog), { forceMount: r = t.forceMount, ...o } = e, s = ro(Fs, e.__scopeDialog);
  return /* @__PURE__ */ le(na, {
    present: r || s.open
  }, s.modal ? /* @__PURE__ */ le(jC, Ie({}, o, {
    ref: n
  })) : /* @__PURE__ */ le(YC, Ie({}, o, {
    ref: n
  })));
}), jC = /* @__PURE__ */ xe((e, n) => {
  const t = ro(Fs, e.__scopeDialog), r = ie(null), o = An(n, t.contentRef, r);
  return W(() => {
    const s = r.current;
    if (s)
      return PC(s);
  }, []), /* @__PURE__ */ le(p3, Ie({}, e, {
    ref: o,
    trapFocus: t.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Wn(e.onCloseAutoFocus, (s) => {
      var a;
      s.preventDefault(), (a = t.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Wn(e.onPointerDownOutside, (s) => {
      const a = s.detail.originalEvent, i = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || i) && s.preventDefault();
    }),
    onFocusOutside: Wn(
      e.onFocusOutside,
      (s) => s.preventDefault()
    )
  }));
}), YC = /* @__PURE__ */ xe((e, n) => {
  const t = ro(Fs, e.__scopeDialog), r = ie(!1), o = ie(!1);
  return /* @__PURE__ */ le(p3, Ie({}, e, {
    ref: n,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (s) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, s), !s.defaultPrevented) {
        var i;
        r.current || (i = t.triggerRef.current) === null || i === void 0 || i.focus(), s.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (s) => {
      var a, i;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = s.target;
      ((i = t.triggerRef.current) === null || i === void 0 ? void 0 : i.contains(c)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
    }
  }));
}), p3 = /* @__PURE__ */ xe((e, n) => {
  const { __scopeDialog: t, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...a } = e, i = ro(Fs, t), c = ie(null), l = An(n, c);
  return zb(), /* @__PURE__ */ le(Us, null, /* @__PURE__ */ le(Vb, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ le(Rb, Ie({
    role: "dialog",
    id: i.contentId,
    "aria-describedby": i.descriptionId,
    "aria-labelledby": i.titleId,
    "data-state": h3(i.open)
  }, a, {
    ref: l,
    onDismiss: () => i.onOpenChange(!1)
  }))), !1);
});
function h3(e) {
  return e ? "open" : "closed";
}
const HC = RC, UC = FC, WC = VC, ZC = BC, Gr = xe(({
  className: e,
  children: n,
  ...t
}, r) => /* @__PURE__ */ g(ZC, {
  ref: r,
  className: te("absolute left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%]", "rounded bg-app-background/80 backdrop-blur-md p-6 shadow-lg duration-200", "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]", "data-[state=closed]:fade-out-0 data-[state=closed]:animate-out data-[state=closed]:zoom-out-95", "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]", e),
  ...t,
  children: n
}));
function qr({
  children: e,
  ...n
}) {
  const t = Om();
  return /* @__PURE__ */ g(HC, {
    ...n,
    children: /* @__PURE__ */ P(UC, {
      container: t,
      children: [/* @__PURE__ */ g(WC, {
        className: te("absolute inset-0 z-50 bg-modal-overlay/80 backdrop-blur-xl", "data-[state=open]:animate-in data-[state=open]:fade-in-0", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0")
      }), e]
    })
  });
}
function vi(e, n) {
  return typeof n == "string" && n in e;
}
const m3 = {
  h1: "text-lg",
  sm: "text-sm",
  md: "text-md",
  lg: "text-lg",
  xl: "text-xl"
}, KC = Er("text-secondary", {
  variants: {
    size: m3,
    weight: {
      inherit: "font-inherit-weight",
      normal: "font-normal",
      light: "font-light",
      semibold: "font-semibold",
      bold: "font-bold"
    }
  },
  defaultVariants: {
    size: "md",
    weight: "normal"
  }
});
function Ee({
  element: e,
  className: n,
  children: t,
  size: r,
  weight: o
}) {
  const s = vi(m3, e) ? e : void 0, a = te(KC({
    weight: o,
    size: r ?? s,
    className: n
  }));
  return /* @__PURE__ */ g(e, {
    className: a,
    children: t
  });
}
function zC({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), {
    actions: t
  } = ue(), r = () => {
    t({
      type: "set_page",
      payload: "entry"
    }), e(!1);
  };
  return /* @__PURE__ */ P("div", {
    className: "flex flex-col items-center gap-6",
    children: [/* @__PURE__ */ P("div", {
      className: "flex flex-col items-center gap-4 text-center",
      children: [/* @__PURE__ */ g(Ee, {
        element: "h2",
        size: "lg",
        children: n("text_6600cda50861cc0108cb6cb8")
      }), /* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        children: n("text_6600cda50861cc0108cb6cb9")
      })]
    }), /* @__PURE__ */ g(Re, {
      name: "invalid_sbi_back_to_home",
      label: n("text_6600cda50861cc0108cb6cba"),
      onClick: r,
      color: "primary",
      className: "w-full"
    })]
  });
}
function GC({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), {
    actions: t
  } = ue(), r = () => {
    t({
      type: "set_page",
      payload: "entry"
    }), e(!1);
  };
  return /* @__PURE__ */ P("div", {
    className: "flex flex-col items-center gap-6",
    children: [/* @__PURE__ */ P("div", {
      className: "flex flex-col items-center gap-4 text-center",
      children: [/* @__PURE__ */ g(Ee, {
        element: "h2",
        size: "lg",
        children: n("text_6600cda50861cc0108cb6cbb")
      }), /* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        children: n("text_6600cda50861cc0108cb6cbc")
      })]
    }), /* @__PURE__ */ g(Re, {
      name: "invalid_structure_back_to_home",
      label: n("text_6600cda50861cc0108cb6cbd"),
      onClick: r,
      color: "primary",
      className: "w-full"
    })]
  });
}
function qC({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), {
    actions: t
  } = ue(), r = () => {
    t({
      type: "set_page",
      payload: "entry"
    }), e(!1);
  };
  return /* @__PURE__ */ P("div", {
    className: "flex flex-col items-center gap-6",
    children: [/* @__PURE__ */ P("div", {
      className: "flex flex-col items-center gap-4 text-center",
      children: [/* @__PURE__ */ g(Ee, {
        element: "h2",
        size: "lg",
        children: n("text_6600cda50861cc0108cb6cbe")
      }), /* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        children: n("text_6600cda50861cc0108cb6cbf")
      })]
    }), /* @__PURE__ */ g(Re, {
      name: "invalid_foundation_date_back_to_home",
      label: n("text_6600cda50861cc0108cb6cc0"),
      onClick: r,
      color: "primary",
      className: "w-full"
    })]
  });
}
const QC = {
  SBI_CODE_INVALID: zC,
  LEGAL_STRUCTURE_INVALID: GC,
  FOUNDATION_DATE_INVALID: qC
};
function g3({
  setIsOpen: e,
  error: n = "SBI_CODE_INVALID"
}) {
  const t = QC[n];
  return /* @__PURE__ */ g(t, {
    setIsOpen: e
  });
}
function y3({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), {
    actions: t
  } = ue(), r = () => {
    t({
      type: "set_page",
      payload: "entry"
    }), e(!1);
  }, o = () => {
    e(!1), window.open(n("text_6600cda50861cc0108cb6cb7"), "_blank");
  };
  return /* @__PURE__ */ P("div", {
    className: "flex flex-col items-center gap-6 text-center w-full",
    children: [/* @__PURE__ */ g(Ee, {
      element: "h2",
      size: "lg",
      children: n("text_6600cda50861cc0108cb6cb3")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: n("text_6600cda50861cc0108cb6cb4")
    }), /* @__PURE__ */ P("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ g(Re, {
        name: "go_to_kvk",
        label: n("text_6600cda50861cc0108cb6cb5"),
        onClick: o,
        color: "primary",
        className: "w-full"
      }), /* @__PURE__ */ g(Re, {
        name: "back_to_home",
        label: n("text_6600cda50861cc0108cb6cb6"),
        onClick: r,
        color: "secondary",
        variant: "outline",
        className: "w-full"
      })]
    })]
  });
}
const Gd = "company_form";
function XC() {
  const {
    t: e
  } = pe(), [n, t] = K(!1), [r, o] = K(!1), [s, a] = K(), [i, c] = K(!1), [l, u] = K(), {
    actions: d
  } = ue(), f = dt(), p = Sr({
    mode: "onBlur"
  }), {
    watch: m,
    formState: h,
    handleSubmit: y
  } = p, C = m("company"), {
    isValid: v
  } = h, w = v && !n, x = async () => {
    if (typeof C == "string")
      return;
    d({
      type: "set_is_loading",
      page: "company",
      payload: !0
    });
    const {
      kvkNumber: D,
      title: k
    } = C;
    try {
      const {
        data: _
      } = await O6({
        kvkNumber: D
      }), {
        eligible: M,
        nonEligibilityReasons: T,
        newToTheBank: N
      } = _;
      if (M)
        d({
          type: "set_requester",
          payload: {
            kvkNumber: D,
            company: k,
            newToTheBank: N
          }
        }), d({
          type: "set_page",
          payload: "next"
        });
      else {
        const I = T == null ? void 0 : T.find(P6);
        u(I), t(!0), o(!0);
      }
    } catch (_) {
      const M = un(_);
      a(M);
    } finally {
      d({
        type: "set_is_loading",
        page: "company",
        payload: !1
      });
    }
  };
  return W(() => {
    if (typeof C == "object") {
      if (!C.error) {
        t(!1);
        return;
      }
      t(!0), c(!0);
    }
  }, [C]), /* @__PURE__ */ P(Zo, {
    children: [/* @__PURE__ */ P(At, {
      children: [/* @__PURE__ */ P(Nt, {
        className: "gap-6",
        children: [/* @__PURE__ */ P(It, {
          children: [/* @__PURE__ */ g(Ee, {
            element: "h1",
            children: e("text_6600cda50861cc0108cb6cab")
          }), /* @__PURE__ */ g(oe, {
            weight: "light",
            children: e("text_6600cda50861cc0108cb6cac")
          })]
        }), /* @__PURE__ */ g("form", {
          className: "w-full",
          id: Gd,
          onSubmit: y(x),
          children: /* @__PURE__ */ g(Q6, {
            label: e("text_6600cda50861cc0108cb6cad"),
            placeholder: e("text_6600cda50861cc0108cb6cae"),
            name: "company",
            ...p
          })
        })]
      }), /* @__PURE__ */ g(zt, {
        children: /* @__PURE__ */ P(he.div, {
          transition: Ce,
          layout: "position",
          className: "flex flex-col gap-2 w-full",
          children: [/* @__PURE__ */ g(Re, {
            className: "w-full shadow-md",
            name: "submit",
            disabled: !w,
            form: Gd,
            type: "submit",
            isLoading: f,
            children: e("text_6600cda50861cc0108cb6caf")
          }), /* @__PURE__ */ g(jt, {
            error: s && e(s),
            className: "text-center",
            name: "eligibility_error"
          })]
        })
      })]
    }), /* @__PURE__ */ g(qr, {
      onOpenChange: o,
      open: r,
      children: /* @__PURE__ */ g(Gr, {
        children: /* @__PURE__ */ g(g3, {
          setIsOpen: o,
          error: l
        })
      })
    }), /* @__PURE__ */ g(qr, {
      onOpenChange: c,
      open: i,
      children: /* @__PURE__ */ g(Gr, {
        children: /* @__PURE__ */ g(y3, {
          setIsOpen: c
        })
      })
    })]
  });
}
function ru(e) {
  const n = e.trim().toLowerCase();
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(n);
}
function ou(e) {
  const n = e == null ? void 0 : e.replace(/ /g, "");
  return /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/gm.test(n);
}
const JC = (e, n, t) => e >= n && e <= t;
function ew({
  control: e,
  name: n,
  rules: t,
  defaultValue: r,
  ...o
}) {
  const {
    field: s
  } = Go({
    control: e,
    name: n,
    rules: t,
    defaultValue: r
  }), {
    onChange: a,
    value: i,
    onBlur: c
  } = s;
  return /* @__PURE__ */ g(Hr, {
    name: n,
    ...o,
    value: i ?? "",
    type: "tel",
    onBlur: c,
    onChange: (l) => {
      const u = l.target.value;
      u.at(-1) === "+" && u.length > 1 || !/^[0-9+]*$/.test(u) || a(l);
    }
  });
}
const tw = {
  name: "name",
  surname: "surname",
  phone: "phone",
  email: "email"
}, qd = "contact_form";
function nw() {
  var D, k, _, M;
  const {
    t: e
  } = pe(), {
    state: n,
    actions: t
  } = ue(), {
    requester: r
  } = n, [o, s] = K(), [a, i] = K(!1), {
    name: c,
    surname: l,
    email: u,
    phoneNumber: d
  } = r, f = {
    name: c,
    surname: l,
    phone: d,
    email: u
  }, {
    register: p,
    control: m,
    handleSubmit: h,
    formState: y,
    trigger: C
  } = Sr({
    mode: "onBlur",
    defaultValues: f
  }), {
    errors: v,
    isValid: w
  } = y, x = async (T) => {
    s(void 0), i(!0);
    const N = {
      name: T.name,
      surname: T.surname,
      email: T.email,
      phoneNumber: T.phone
    };
    try {
      await R6(N), t({
        type: "set_requester",
        payload: N
      }), t({
        type: "set_page",
        payload: "next"
      });
    } catch (I) {
      const O = un(I);
      s(O), i(!1);
    }
  };
  return W(() => {
    const T = Object.keys(f).filter((I) => !!(vi(f, I) && f[I])), N = Object.values(tw).filter((I) => T.includes(I));
    C(N);
  }, []), /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: e("text_6600cda50861cc0108cb6d86")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          children: e("text_6600cda50861cc0108cb6d87")
        })]
      }), /* @__PURE__ */ P("form", {
        className: "flex flex-col gap-4 w-full",
        id: qd,
        onSubmit: h(x),
        children: [/* @__PURE__ */ g(Hr, {
          label: e("text_6600cda50861cc0108cb6d88"),
          placeholder: e("text_6600cda50861cc0108cb6d89"),
          autoComplete: "given-name",
          error: (D = v.name) == null ? void 0 : D.message,
          ...p("name", {
            required: e(pt.required)
          })
        }), /* @__PURE__ */ g(Hr, {
          label: e("text_6600cda50861cc0108cb6d8a"),
          placeholder: e("text_6600cda50861cc0108cb6d8b"),
          autoComplete: "family-name",
          error: (k = v.surname) == null ? void 0 : k.message,
          ...p("surname", {
            required: e(pt.required)
          })
        }), /* @__PURE__ */ g(ew, {
          label: e("text_6600cda50861cc0108cb6d8c"),
          placeholder: e("text_6600cda50861cc0108cb6d8d"),
          autoComplete: "tel",
          error: (_ = v.phone) == null ? void 0 : _.message,
          name: "phone",
          control: m,
          rules: {
            required: e(pt.required),
            validate: {
              phone: (T) => ou(T) || e(pt.phone)
            }
          }
        }), /* @__PURE__ */ g(Hr, {
          label: e("text_6600cda50861cc0108cb6d8e"),
          placeholder: e("text_6600cda50861cc0108cb6d8f"),
          autoComplete: "email",
          error: (M = v.email) == null ? void 0 : M.message,
          ...p("email", {
            required: e(pt.required),
            validate: {
              email: (T) => ru(T) || e(pt.email)
            }
          })
        })]
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!o,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ g(Re, {
          className: "w-full shadow-md",
          name: "submit",
          type: "submit",
          form: qd,
          isLoading: a,
          disabled: !w,
          children: e("text_6600cda50861cc0108cb6d90")
        }), /* @__PURE__ */ g(jt, {
          error: o && e(o),
          className: "text-center",
          name: "contact_error"
        })]
      })
    })]
  });
}
function v3({
  text: e,
  icon: n
}) {
  return /* @__PURE__ */ P("li", {
    className: "flex gap-2",
    children: [/* @__PURE__ */ g(n ?? ib, {
      className: "mt-0.5 w-5 h-5 text-secondary shrink-0"
    }), /* @__PURE__ */ g(oe, {
      size: "sm",
      weight: "light",
      children: e
    })]
  });
}
function su({
  children: e,
  className: n,
  ...t
}) {
  return /* @__PURE__ */ g("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    className: te("text-left text-primary hover:underline", n),
    ...t,
    children: e
  });
}
function rw({
  children: e
}) {
  const [n] = e ?? [], [t, r] = (n == null ? void 0 : n.split(";")) ?? "";
  return /* @__PURE__ */ g(su, {
    href: r,
    children: t ?? r
  });
}
function au({
  langKey: e,
  values: n,
  weight: t,
  size: r,
  color: o,
  className: s
}) {
  const {
    t: a
  } = pe(), i = a(e), c = te("whitespace-pre-line", z6({
    weight: t,
    size: r,
    color: o,
    className: s
  })), l = Object.entries(n).reduce((u, [d, f]) => {
    const p = a(f), m = new RegExp(d, "g"), h = `<a>${d};${p}</a>`;
    return u.replace(m, h);
  }, i);
  return /* @__PURE__ */ g(yl, {
    className: c,
    shouldUnescape: !0,
    parent: "span",
    components: {
      a: /* @__PURE__ */ g(rw, {})
    },
    children: l
  });
}
const ow = ["text_6600cda50861cc0108cb6ca0", "text_6600cda50861cc0108cb6ca1", "text_6600cda50861cc0108cb6ca2"];
function sw() {
  const {
    state: e,
    actions: n
  } = ue(), {
    invoices: t
  } = e, {
    t: r
  } = pe(), o = dt(), s = t.reduce((i, c) => i + c.amount, 0), a = () => {
    n({
      type: "set_page",
      payload: "next"
    });
  };
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: r("text_6600cda50861cc0108cb6c9e")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          children: r("text_6600cda50861cc0108cb6c9f")
        })]
      }), s > 0 && /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full gap-0 text-left",
        children: [/* @__PURE__ */ g(oe, {
          weight: "light",
          size: "sm",
          children: r("text_6600cda50861cc0108cb6ca3")
        }), /* @__PURE__ */ g(oe, {
          color: "secondary",
          size: "lg",
          children: Kr(s)
        })]
      }), /* @__PURE__ */ g(no, {
        className: "w-full"
      }), /* @__PURE__ */ g("ul", {
        className: "flex flex-col w-full gap-2 max-w-content",
        children: ow.map((i) => {
          const c = r(i);
          return /* @__PURE__ */ g(v3, {
            text: c
          }, i);
        })
      })]
    }), /* @__PURE__ */ P(zt, {
      className: "gap-2",
      showBlur: !0,
      children: [/* @__PURE__ */ g(Re, {
        className: "w-full shadow-md",
        name: "submit",
        onClick: a,
        isLoading: o,
        children: r("text_6600cda50861cc0108cb6ca5")
      }), /* @__PURE__ */ g(au, {
        className: "text-center",
        color: "subtitle",
        size: "xs",
        weight: "light",
        langKey: "text_6600cda50861cc0108cb6ca6",
        values: {
          "Algemene Voorwaarden": "text_66152d7ecb8e8500881dbf35",
          "Privacy Statement": "text_66152d7ecb8e8500881dbf36"
        }
      })]
    })]
  });
}
function aw(e) {
  const n = e + "CollectionProvider", [t, r] = Xo(n), [o, s] = t(n, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (p) => {
    const { scope: m, children: h } = p, y = A.useRef(null), C = A.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ A.createElement(o, {
      scope: m,
      itemMap: C,
      collectionRef: y
    }, h);
  }, i = e + "CollectionSlot", c = /* @__PURE__ */ A.forwardRef((p, m) => {
    const { scope: h, children: y } = p, C = s(i, h), v = An(m, C.collectionRef);
    return /* @__PURE__ */ A.createElement(Is, {
      ref: v
    }, y);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ A.forwardRef((p, m) => {
    const { scope: h, children: y, ...C } = p, v = A.useRef(null), w = An(m, v), x = s(l, h);
    return A.useEffect(() => (x.itemMap.set(v, {
      ref: v,
      ...C
    }), () => void x.itemMap.delete(v))), /* @__PURE__ */ A.createElement(Is, {
      [u]: "",
      ref: w
    }, y);
  });
  function f(p) {
    const m = s(e + "CollectionConsumer", p);
    return A.useCallback(() => {
      const y = m.collectionRef.current;
      if (!y)
        return [];
      const C = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(m.itemMap.values()).sort(
        (x, D) => C.indexOf(x.ref.current) - C.indexOf(D.ref.current)
      );
    }, [
      m.collectionRef,
      m.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: d
    },
    f,
    r
  ];
}
const b3 = "Collapsible", [iw, C3] = Xo(b3), [cw, iu] = iw(b3), lw = /* @__PURE__ */ xe((e, n) => {
  const { __scopeCollapsible: t, open: r, defaultOpen: o, disabled: s, onOpenChange: a, ...i } = e, [c = !1, l] = ta({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ le(cw, {
    scope: t,
    disabled: s,
    contentId: Ss(),
    open: c,
    onOpenToggle: cn(
      () => l(
        (u) => !u
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ le(Gt.div, Ie({
    "data-state": cu(c),
    "data-disabled": s ? "" : void 0
  }, i, {
    ref: n
  })));
}), uw = "CollapsibleTrigger", dw = /* @__PURE__ */ xe((e, n) => {
  const { __scopeCollapsible: t, ...r } = e, o = iu(uw, t);
  return /* @__PURE__ */ le(Gt.button, Ie({
    type: "button",
    "aria-controls": o.contentId,
    "aria-expanded": o.open || !1,
    "data-state": cu(o.open),
    "data-disabled": o.disabled ? "" : void 0,
    disabled: o.disabled
  }, r, {
    ref: n,
    onClick: Wn(e.onClick, o.onOpenToggle)
  }));
}), w3 = "CollapsibleContent", fw = /* @__PURE__ */ xe((e, n) => {
  const { forceMount: t, ...r } = e, o = iu(w3, e.__scopeCollapsible);
  return /* @__PURE__ */ le(
    na,
    {
      present: t || o.open
    },
    ({ present: s }) => /* @__PURE__ */ le(pw, Ie({}, r, {
      ref: n,
      present: s
    }))
  );
}), pw = /* @__PURE__ */ xe((e, n) => {
  const { __scopeCollapsible: t, present: r, children: o, ...s } = e, a = iu(w3, t), [i, c] = K(r), l = ie(null), u = An(n, l), d = ie(0), f = d.current, p = ie(0), m = p.current, h = a.open || i, y = ie(h), C = ie();
  return W(() => {
    const v = requestAnimationFrame(
      () => y.current = !1
    );
    return () => cancelAnimationFrame(v);
  }, []), Rs(() => {
    const v = l.current;
    if (v) {
      C.current = C.current || {
        transitionDuration: v.style.transitionDuration,
        animationName: v.style.animationName
      }, v.style.transitionDuration = "0s", v.style.animationName = "none";
      const w = v.getBoundingClientRect();
      d.current = w.height, p.current = w.width, y.current || (v.style.transitionDuration = C.current.transitionDuration, v.style.animationName = C.current.animationName), c(r);
    }
  }, [
    a.open,
    r
  ]), /* @__PURE__ */ le(Gt.div, Ie({
    "data-state": cu(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !h
  }, s, {
    ref: u,
    style: {
      "--radix-collapsible-content-height": f ? `${f}px` : void 0,
      "--radix-collapsible-content-width": m ? `${m}px` : void 0,
      ...e.style
    }
  }), h && o);
});
function cu(e) {
  return e ? "open" : "closed";
}
const hw = lw, mw = dw, gw = fw, yw = /* @__PURE__ */ Rt(void 0);
function vw(e) {
  const n = ze(yw);
  return e || n || "ltr";
}
const _r = "Accordion", bw = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [lu, Cw, ww] = aw(_r), [tc, lN] = Xo(_r, [
  ww,
  C3
]), uu = C3(), x3 = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { type: t, ...r } = e, o = r, s = r;
  return /* @__PURE__ */ A.createElement(lu.Provider, {
    scope: e.__scopeAccordion
  }, t === "multiple" ? /* @__PURE__ */ A.createElement(Ew, Ie({}, s, {
    ref: n
  })) : /* @__PURE__ */ A.createElement(Sw, Ie({}, o, {
    ref: n
  })));
});
x3.propTypes = {
  type(e) {
    const n = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof n == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(n) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [D3, xw] = tc(_r), [S3, Dw] = tc(_r, {
  collapsible: !1
}), Sw = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { value: t, defaultValue: r, onValueChange: o = () => {
  }, collapsible: s = !1, ...a } = e, [i, c] = ta({
    prop: t,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ A.createElement(D3, {
    scope: e.__scopeAccordion,
    value: i ? [
      i
    ] : [],
    onItemOpen: c,
    onItemClose: A.useCallback(
      () => s && c(""),
      [
        s,
        c
      ]
    )
  }, /* @__PURE__ */ A.createElement(S3, {
    scope: e.__scopeAccordion,
    collapsible: s
  }, /* @__PURE__ */ A.createElement(E3, Ie({}, a, {
    ref: n
  }))));
}), Ew = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { value: t, defaultValue: r, onValueChange: o = () => {
  }, ...s } = e, [a = [], i] = ta({
    prop: t,
    defaultProp: r,
    onChange: o
  }), c = A.useCallback(
    (u) => i(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      i
    ]
  ), l = A.useCallback(
    (u) => i(
      (d = []) => d.filter(
        (f) => f !== u
      )
    ),
    [
      i
    ]
  );
  return /* @__PURE__ */ A.createElement(D3, {
    scope: e.__scopeAccordion,
    value: a,
    onItemOpen: c,
    onItemClose: l
  }, /* @__PURE__ */ A.createElement(S3, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ A.createElement(E3, Ie({}, s, {
    ref: n
  }))));
}), [_w, nc] = tc(_r), E3 = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { __scopeAccordion: t, disabled: r, dir: o, orientation: s = "vertical", ...a } = e, i = A.useRef(null), c = An(i, n), l = Cw(t), d = vw(o) === "ltr", f = Wn(e.onKeyDown, (p) => {
    var m;
    if (!bw.includes(p.key))
      return;
    const h = p.target, y = l().filter((T) => {
      var N;
      return !((N = T.ref.current) !== null && N !== void 0 && N.disabled);
    }), C = y.findIndex(
      (T) => T.ref.current === h
    ), v = y.length;
    if (C === -1)
      return;
    p.preventDefault();
    let w = C;
    const x = 0, D = v - 1, k = () => {
      w = C + 1, w > D && (w = x);
    }, _ = () => {
      w = C - 1, w < x && (w = D);
    };
    switch (p.key) {
      case "Home":
        w = x;
        break;
      case "End":
        w = D;
        break;
      case "ArrowRight":
        s === "horizontal" && (d ? k() : _());
        break;
      case "ArrowDown":
        s === "vertical" && k();
        break;
      case "ArrowLeft":
        s === "horizontal" && (d ? _() : k());
        break;
      case "ArrowUp":
        s === "vertical" && _();
        break;
    }
    const M = w % v;
    (m = y[M].ref.current) === null || m === void 0 || m.focus();
  });
  return /* @__PURE__ */ A.createElement(_w, {
    scope: t,
    disabled: r,
    direction: o,
    orientation: s
  }, /* @__PURE__ */ A.createElement(lu.Slot, {
    scope: t
  }, /* @__PURE__ */ A.createElement(Gt.div, Ie({}, a, {
    "data-orientation": s,
    ref: c,
    onKeyDown: r ? void 0 : f
  }))));
}), Zl = "AccordionItem", [Mw, du] = tc(Zl), kw = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { __scopeAccordion: t, value: r, ...o } = e, s = nc(Zl, t), a = xw(Zl, t), i = uu(t), c = Ss(), l = r && a.value.includes(r) || !1, u = s.disabled || e.disabled;
  return /* @__PURE__ */ A.createElement(Mw, {
    scope: t,
    open: l,
    disabled: u,
    triggerId: c
  }, /* @__PURE__ */ A.createElement(hw, Ie({
    "data-orientation": s.orientation,
    "data-state": _3(l)
  }, i, o, {
    ref: n,
    disabled: u,
    open: l,
    onOpenChange: (d) => {
      d ? a.onItemOpen(r) : a.onItemClose(r);
    }
  })));
}), Aw = "AccordionHeader", Nw = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { __scopeAccordion: t, ...r } = e, o = nc(_r, t), s = du(Aw, t);
  return /* @__PURE__ */ A.createElement(Gt.h3, Ie({
    "data-orientation": o.orientation,
    "data-state": _3(s.open),
    "data-disabled": s.disabled ? "" : void 0
  }, r, {
    ref: n
  }));
}), Qd = "AccordionTrigger", Lw = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { __scopeAccordion: t, ...r } = e, o = nc(_r, t), s = du(Qd, t), a = Dw(Qd, t), i = uu(t);
  return /* @__PURE__ */ A.createElement(lu.ItemSlot, {
    scope: t
  }, /* @__PURE__ */ A.createElement(mw, Ie({
    "aria-disabled": s.open && !a.collapsible || void 0,
    "data-orientation": o.orientation,
    id: s.triggerId
  }, i, r, {
    ref: n
  })));
}), Tw = "AccordionContent", Pw = /* @__PURE__ */ A.forwardRef((e, n) => {
  const { __scopeAccordion: t, ...r } = e, o = nc(_r, t), s = du(Tw, t), a = uu(t);
  return /* @__PURE__ */ A.createElement(gw, Ie({
    role: "region",
    "aria-labelledby": s.triggerId,
    "data-orientation": o.orientation
  }, a, r, {
    ref: n,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function _3(e) {
  return e ? "open" : "closed";
}
const Ow = x3, Rw = kw, Iw = Nw, Fw = Lw, Vw = Pw, fu = Ow, ur = xe(({
  className: e,
  ...n
}, t) => /* @__PURE__ */ g(Rw, {
  ref: t,
  className: te("border-b border-border/40", e),
  ...n
})), dr = xe(({
  className: e,
  children: n,
  ...t
}, r) => /* @__PURE__ */ g(Iw, {
  className: "flex",
  children: /* @__PURE__ */ P(Fw, {
    ref: r,
    className: te("flex flex-1 justify-between py-4 gap-4", "text-sm font-medium text-foreground text-left whitespace-pre-line", "transition-all [&[data-state=open]>svg]:rotate-180", e),
    ...t,
    children: [n, /* @__PURE__ */ g(K6, {
      color: "text",
      className: "mt-0.5"
    })]
  })
})), fr = xe(({
  className: e,
  children: n,
  ...t
}, r) => /* @__PURE__ */ g(Vw, {
  ref: r,
  className: te("text-left text-sm font-thin text-foreground whitespace-pre-line overflow-hidden", "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"),
  ...t,
  children: /* @__PURE__ */ g("div", {
    className: te("pb-4 pt-0", e),
    children: n
  })
})), $w = ["text_6655dd3aa3bdfb00cb305fea", "text_6655dd3aa3bdfb00cb305feb", "text_6655dd3aa3bdfb00cb305fec", "text_6655dd3aa3bdfb00cb305fed", "text_6655dd3aa3bdfb00cb305fee"];
function Bw() {
  const {
    t: e
  } = pe();
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-10",
      children: [/* @__PURE__ */ P("div", {
        className: "flex flex-col gap-6",
        children: [/* @__PURE__ */ P("div", {
          className: "flex flex-col gap-1",
          children: [/* @__PURE__ */ g(Ee, {
            className: "w-full",
            element: "h2",
            size: "lg",
            weight: "normal",
            children: e("text_6655dd3aa3bdfb00cb305fe8")
          }), /* @__PURE__ */ g(oe, {
            weight: "light",
            children: e("text_6655dd3aa3bdfb00cb305fe9")
          })]
        }), /* @__PURE__ */ g("ul", {
          className: "flex flex-col gap-2 max-w-content",
          children: $w.map((n) => {
            const t = e(n);
            return /* @__PURE__ */ g(v3, {
              text: t
            }, n);
          })
        })]
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full gap-6",
        children: [/* @__PURE__ */ g(Ee, {
          className: "w-full",
          element: "h1",
          size: "lg",
          weight: "normal",
          children: e("text_6600cda50861cc0108cb6da4")
        }), /* @__PURE__ */ P(fu, {
          type: "single",
          collapsible: !0,
          className: "w-full border-t border-border/40",
          children: [/* @__PURE__ */ P(ur, {
            value: "item_1",
            children: [/* @__PURE__ */ g(dr, {
              children: e("text_6600cda50861cc0108cb6da5")
            }), /* @__PURE__ */ g(fr, {
              className: "flex flex-col gap-4",
              children: /* @__PURE__ */ g(yl, {
                i18nKey: "text_6600cda50861cc0108cb6da6",
                shouldUnescape: !0,
                parent: "span",
                components: {
                  ul: /* @__PURE__ */ g("ul", {
                    className: "list-disc pl-6"
                  }),
                  li: /* @__PURE__ */ g("li", {})
                }
              })
            })]
          }), /* @__PURE__ */ P(ur, {
            value: "item_2",
            children: [/* @__PURE__ */ g(dr, {
              children: e("text_6600cda50861cc0108cb6da7")
            }), /* @__PURE__ */ g(fr, {
              className: "flex flex-col gap-4",
              children: /* @__PURE__ */ g(yl, {
                i18nKey: "text_6600cda50861cc0108cb6da8",
                shouldUnescape: !0,
                parent: "span",
                components: {
                  ul: /* @__PURE__ */ g("ul", {
                    className: "list-disc pl-6"
                  }),
                  li: /* @__PURE__ */ g("li", {})
                }
              })
            })]
          }), /* @__PURE__ */ P(ur, {
            value: "item_3",
            children: [/* @__PURE__ */ g(dr, {
              children: e("text_6600cda50861cc0108cb6da9")
            }), /* @__PURE__ */ g(fr, {
              className: "flex flex-col gap-4",
              children: e("text_6600cda50861cc0108cb6daa")
            })]
          })]
        }), /* @__PURE__ */ g(su, {
          className: "text-sm text-secondary text-center font-light",
          href: e("text_6600cda50861cc0108cb6db0"),
          children: e("text_6600cda50861cc0108cb6dab")
        })]
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full gap-1",
        children: [/* @__PURE__ */ g(Ee, {
          element: "h2",
          size: "lg",
          weight: "normal",
          children: e("text_66152d46a2ade02c1666a6d4")
        }), /* @__PURE__ */ g(au, {
          weight: "light",
          size: "sm",
          langKey: "text_66152d46a2ade02c1666a6d5",
          values: {
            "www.rabobank.nl": "text_66152e351d70d5008e534764"
          }
        })]
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full gap-1",
        children: [/* @__PURE__ */ g(Ee, {
          element: "h2",
          size: "lg",
          weight: "normal",
          children: e("text_6600cda50861cc0108cb6dac")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          size: "sm",
          children: e("text_6600cda50861cc0108cb6dad")
        })]
      })]
    }), /* @__PURE__ */ P(zt, {
      className: "gap-2",
      showBlur: !0,
      children: [/* @__PURE__ */ g(Re, {
        className: "w-full shadow-md",
        name: "call_csc",
        onClick: () => {
          window.location.href = `tel:${e("text_6600cda50861cc0108cb6db1")}`;
        },
        children: e("text_6600cda50861cc0108cb6dae")
      }), /* @__PURE__ */ g(oe, {
        weight: "light",
        size: "xs",
        color: "subtitle",
        className: "text-center",
        children: e("text_6600cda50861cc0108cb6daf")
      })]
    })]
  });
}
function M3(e) {
  const n = "dls-nh-ocr-integration/v1/parse-document", t = new FormData();
  t.append("documentType", "invfin"), t.append("document", e);
  const r = {
    "content-type": "multipart/form-data",
    crossorigin: !0
  };
  return bt.post({
    path: n,
    body: t,
    headers: r
  });
}
function jw(e, n) {
  const [t, r] = K(e), [o, s] = K();
  return W(() => {
    o && clearTimeout(o);
    const a = setTimeout(() => {
      r(e);
    }, n);
    return s(a), () => {
      clearTimeout(a);
    };
  }, [e, n]), t;
}
const Xd = 90;
function Yw(e, n) {
  const [t, r] = K(), o = jw(n, 500), {
    state: s
  } = ue(), {
    requester: a
  } = s, i = typeof o == "string" || o == null ? void 0 : o.kvkNumber;
  return W(() => {
    r(void 0), e != null && e.debtorKvk && i && e.debtorKvk !== i && r("text_6600cda50861cc0108cb6d06");
    const c = typeof o == "string" ? o : o == null ? void 0 : o.title;
    if (e != null && e.debtorName && c && yi(e.debtorName, c) < Xd && r("text_6600cda50861cc0108cb6d06"), (e == null ? void 0 : e.debtorKvk) && e.debtorKvk === a.kvkNumber && r("text_660b22c4f3defe00da57ccaf"), !(e != null && e.debtorName) || !a.company)
      return;
    yi(e.debtorName, a.company) >= Xd && r("text_660b22c4f3defe00da57ccaf");
  }, [e, o]), t;
}
const Hw = 80;
function Uw(e) {
  const [n, t] = K(), {
    state: r
  } = ue(), {
    requester: o
  } = r;
  return W(() => {
    t(void 0);
    const s = (e == null ? void 0 : e.companyKvk) === o.kvkNumber;
    if (e != null && e.companyKvk && !s && t("text_660b22b4943ceb005004c506"), !(e != null && e.companyName) || !o.company)
      return;
    yi(e.companyName, o.company) < Hw && t("text_660b22b4943ceb005004c506");
  }, [e]), n;
}
function k3(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
}
var Vs;
(function(e) {
  e.event = "event", e.props = "prop";
})(Vs || (Vs = {}));
function cr() {
}
function Ww(e) {
  var n, t = void 0;
  return function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return n && r.length === n.length && r.every(function(s, a) {
      return s === n[a];
    }) || (n = r, t = e.apply(void 0, r)), t;
  };
}
function $s(e) {
  return !!(e || "").match(/\d/);
}
function Lo(e) {
  return e == null;
}
function Zw(e) {
  return typeof e == "number" && isNaN(e);
}
function A3(e) {
  return Lo(e) || Zw(e) || typeof e == "number" && !isFinite(e);
}
function N3(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function Kw(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function zw(e, n, t) {
  var r = Kw(t), o = e.search(/[1-9]/);
  return o = o === -1 ? e.length : o, e.substring(0, o) + e.substring(o, e.length).replace(r, "$1" + n);
}
function Gw(e) {
  var n = ie(e);
  n.current = e;
  var t = ie(function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return n.current.apply(n, r);
  });
  return t.current;
}
function pu(e, n) {
  n === void 0 && (n = !0);
  var t = e[0] === "-", r = t && n;
  e = e.replace("-", "");
  var o = e.split("."), s = o[0], a = o[1] || "";
  return {
    beforeDecimal: s,
    afterDecimal: a,
    hasNegation: t,
    addNegation: r
  };
}
function qw(e) {
  if (!e)
    return e;
  var n = e[0] === "-";
  n && (e = e.substring(1, e.length));
  var t = e.split("."), r = t[0].replace(/^0+/, "") || "0", o = t[1] || "";
  return (n ? "-" : "") + r + (o ? "." + o : "");
}
function L3(e, n, t) {
  for (var r = "", o = t ? "0" : "", s = 0; s <= n - 1; s++)
    r += e[s] || o;
  return r;
}
function Jd(e, n) {
  return Array(n + 1).join(e);
}
function T3(e) {
  var n = e + "", t = n[0] === "-" ? "-" : "";
  t && (n = n.substring(1));
  var r = n.split(/[eE]/g), o = r[0], s = r[1];
  if (s = Number(s), !s)
    return t + o;
  o = o.replace(".", "");
  var a = 1 + s, i = o.length;
  return a < 0 ? o = "0." + Jd("0", Math.abs(a)) + o : a >= i ? o = o + Jd("0", a - i) : o = (o.substring(0, a) || "0") + "." + o.substring(a), t + o;
}
function ef(e, n, t) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || t) && n, o = pu(e), s = o.beforeDecimal, a = o.afterDecimal, i = o.hasNegation, c = parseFloat("0." + (a || "0")), l = a.length <= n ? "0." + a : c.toFixed(n), u = l.split("."), d = s.split("").reverse().reduce(function(h, y, C) {
    return h.length > C ? (Number(h[0]) + Number(y)).toString() + h.substring(1, h.length) : y + h;
  }, u[0]), f = L3(u[1] || "", n, t), p = i ? "-" : "", m = r ? "." : "";
  return "" + p + d + m + f;
}
function Ir(e, n) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var t = e.createTextRange();
      return t.move("character", n), t.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(n, n), !0) : (e.focus(), !1);
  }
}
var P3 = Ww(function(e, n) {
  for (var t = 0, r = 0, o = e.length, s = n.length; e[t] === n[t] && t < o; )
    t++;
  for (; e[o - 1 - r] === n[s - 1 - r] && s - r > t && o - r > t; )
    r++;
  return {
    from: { start: t, end: o - r },
    to: { start: t, end: s - r }
  };
});
function Qw(e, n, t) {
  return Math.min(Math.max(e, n), t);
}
function zc(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function Xw() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function Jw(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function ex(e) {
  var n = e.currentValue, t = e.formattedValue, r = e.currentValueIndex, o = e.formattedValueIndex;
  return n[r] === t[o];
}
function tx(e, n, t, r, o, s, a) {
  a === void 0 && (a = ex);
  var i = o.findIndex(function(x) {
    return x;
  }), c = e.slice(0, i);
  !n && !t.startsWith(c) && (n = c, t = c + t, r = r + c.length);
  for (var l = t.length, u = e.length, d = {}, f = new Array(l), p = 0; p < l; p++) {
    f[p] = -1;
    for (var m = 0, h = u; m < h; m++) {
      var y = a({
        currentValue: t,
        lastValue: n,
        formattedValue: e,
        currentValueIndex: p,
        formattedValueIndex: m
      });
      if (y && d[m] !== !0) {
        f[p] = m, d[m] = !0;
        break;
      }
    }
  }
  for (var C = r; C < l && (f[C] === -1 || !s(t[C])); )
    C++;
  var v = C === l || f[C] === -1 ? u : f[C];
  for (C = r - 1; C > 0 && f[C] === -1; )
    C--;
  var w = C === -1 || f[C] === -1 ? 0 : f[C] + 1;
  return w > v ? v : r - w < v - r ? w : v;
}
function tf(e, n, t, r) {
  var o = e.length;
  if (n = Qw(n, 0, o), r === "left") {
    for (; n >= 0 && !t[n]; )
      n--;
    n === -1 && (n = t.indexOf(!0));
  } else {
    for (; n <= o && !t[n]; )
      n++;
    n > o && (n = t.lastIndexOf(!0));
  }
  return n === -1 && (n = o), n;
}
function nx(e) {
  for (var n = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), t = 0, r = n.length; t < r; t++)
    n[t] = !!($s(e[t]) || $s(e[t - 1]));
  return n;
}
function O3(e, n, t, r, o, s) {
  s === void 0 && (s = cr);
  var a = Gw(function(m, h) {
    var y, C;
    return A3(m) ? (C = "", y = "") : typeof m == "number" || h ? (C = typeof m == "number" ? T3(m) : m, y = r(C)) : (C = o(m, void 0), y = r(C)), { formattedValue: y, numAsString: C };
  }), i = K(function() {
    return a(Lo(e) ? n : e, t);
  }), c = i[0], l = i[1], u = function(m, h) {
    m.formattedValue !== c.formattedValue && l({
      formattedValue: m.formattedValue,
      numAsString: m.value
    }), s(m, h);
  }, d = e, f = t;
  Lo(e) && (d = c.numAsString, f = !0);
  var p = a(d, f);
  return Et(function() {
    l(p);
  }, [p.formattedValue]), [c, u];
}
function rx(e) {
  return e.replace(/[^0-9]/g, "");
}
function ox(e) {
  return e;
}
function sx(e) {
  var n = e.type;
  n === void 0 && (n = "text");
  var t = e.displayType;
  t === void 0 && (t = "input");
  var r = e.customInput, o = e.renderText, s = e.getInputRef, a = e.format;
  a === void 0 && (a = ox);
  var i = e.removeFormatting;
  i === void 0 && (i = rx);
  var c = e.defaultValue, l = e.valueIsNumericString, u = e.onValueChange, d = e.isAllowed, f = e.onChange;
  f === void 0 && (f = cr);
  var p = e.onKeyDown;
  p === void 0 && (p = cr);
  var m = e.onMouseUp;
  m === void 0 && (m = cr);
  var h = e.onFocus;
  h === void 0 && (h = cr);
  var y = e.onBlur;
  y === void 0 && (y = cr);
  var C = e.value, v = e.getCaretBoundary;
  v === void 0 && (v = nx);
  var w = e.isValidInputCharacter;
  w === void 0 && (w = $s);
  var x = e.isCharacterSame, D = k3(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), k = O3(C, c, !!l, a, i, u), _ = k[0], M = _.formattedValue, T = _.numAsString, N = k[1], I = ie({ formattedValue: M, numAsString: T }), O = function(q, ce) {
    I.current = { formattedValue: q.formattedValue, numAsString: q.value }, N(q, ce);
  }, $ = K(!1), j = $[0], Y = $[1], F = ie(null), V = ie({
    setCaretTimeout: null,
    focusTimeout: null
  });
  W(function() {
    return Y(!0), function() {
      clearTimeout(V.current.setCaretTimeout), clearTimeout(V.current.focusTimeout);
    };
  }, []);
  var J = a, Q = function(q, ce) {
    var de = parseFloat(ce);
    return {
      formattedValue: q,
      value: ce,
      floatValue: isNaN(de) ? void 0 : de
    };
  }, X = function(q, ce, de) {
    q.selectionStart === 0 && q.selectionEnd === q.value.length || (Ir(q, ce), V.current.setCaretTimeout = setTimeout(function() {
      q.value === de && q.selectionStart !== q.selectionEnd && Ir(q, ce);
    }, 0));
  }, z = function(q, ce, de) {
    return tf(q, ce, v(q), de);
  }, me = function(q, ce, de) {
    var E = v(ce), L = tx(ce, M, q, de, E, w, x);
    return L = tf(ce, L, E), L;
  }, Me = function(q) {
    var ce = q.formattedValue;
    ce === void 0 && (ce = "");
    var de = q.input, E = q.setCaretPosition;
    E === void 0 && (E = !0);
    var L = q.source, R = q.event, Z = q.numAsString, H = q.caretPos;
    if (de) {
      if (H === void 0 && E) {
        var U = q.inputValue || de.value, re = zc(de);
        de.value = ce, H = me(U, ce, re);
      }
      de.value = ce, E && H !== void 0 && X(de, H, ce);
    }
    ce !== M && O(Q(ce, Z), { event: R, source: L });
  };
  W(function() {
    var q = I.current, ce = q.formattedValue, de = q.numAsString;
    M !== ce && (M !== T || ce !== de) && O(Q(M, T), {
      event: void 0,
      source: Vs.props
    });
  }, [M, T]);
  var Be = F.current ? zc(F.current) : void 0, ve = typeof window < "u" ? Wo : W;
  ve(function() {
    var q = F.current;
    if (M !== I.current.formattedValue && q) {
      var ce = me(I.current.formattedValue, M, Be);
      q.value = M, X(q, ce, M);
    }
  }, [M]);
  var Ae = function(q, ce, de) {
    var E = P3(M, q), L = Object.assign(Object.assign({}, E), { lastValue: M }), R = i(q, L), Z = J(R);
    if (R = i(Z, void 0), d && !d(Q(Z, R))) {
      var H = ce.target, U = zc(H), re = me(q, M, U);
      return H.value = M, X(H, re, M), !1;
    }
    return Me({
      formattedValue: Z,
      numAsString: R,
      inputValue: q,
      event: ce,
      source: de,
      setCaretPosition: !0,
      input: ce.target
    }), !0;
  }, Te = function(q) {
    var ce = q.target, de = ce.value, E = Ae(de, q, Vs.event);
    E && f(q);
  }, G = function(q) {
    var ce = q.target, de = q.key, E = ce.selectionStart, L = ce.selectionEnd, R = ce.value;
    R === void 0 && (R = "");
    var Z;
    if (de === "ArrowLeft" || de === "Backspace" ? Z = Math.max(E - 1, 0) : de === "ArrowRight" ? Z = Math.min(E + 1, R.length) : de === "Delete" && (Z = E), Z === void 0 || E !== L) {
      p(q);
      return;
    }
    var H = Z;
    if (de === "ArrowLeft" || de === "ArrowRight") {
      var U = de === "ArrowLeft" ? "left" : "right";
      H = z(R, Z, U), H !== Z && q.preventDefault();
    } else
      de === "Delete" && !w(R[Z]) ? H = z(R, Z, "right") : de === "Backspace" && !w(R[Z]) && (H = z(R, Z, "left"));
    H !== Z && X(ce, H, R), q.isUnitTestRun && X(ce, H, R), p(q);
  }, fe = function(q) {
    var ce = q.target, de = ce.selectionStart, E = ce.selectionEnd, L = ce.value;
    if (L === void 0 && (L = ""), de === E) {
      var R = z(L, de);
      R !== de && X(ce, R, L);
    }
    m(q);
  }, De = function(q) {
    q.persist && q.persist();
    var ce = q.target;
    F.current = ce, V.current.focusTimeout = setTimeout(function() {
      var de = ce.selectionStart, E = ce.selectionEnd, L = ce.value;
      L === void 0 && (L = "");
      var R = z(L, de);
      R !== de && !(de === 0 && E === L.length) && X(ce, R, L), h(q);
    }, 0);
  }, _e = function(q) {
    F.current = null, clearTimeout(V.current.focusTimeout), clearTimeout(V.current.setCaretTimeout), y(q);
  }, Fe = j && Xw() ? "numeric" : void 0, Je = Object.assign({ inputMode: Fe }, D, {
    type: n,
    value: M,
    onChange: Te,
    onKeyDown: G,
    onMouseUp: fe,
    onFocus: De,
    onBlur: _e
  });
  if (t === "text")
    return o ? A.createElement(A.Fragment, null, o(M, D) || null) : A.createElement("span", Object.assign({}, D, { ref: s }), M);
  if (r) {
    var ke = r;
    return A.createElement(ke, Object.assign({}, Je, { ref: s }));
  }
  return A.createElement("input", Object.assign({}, Je, { ref: s }));
}
function nf(e, n) {
  var t = n.decimalScale, r = n.fixedDecimalScale, o = n.prefix;
  o === void 0 && (o = "");
  var s = n.suffix;
  s === void 0 && (s = "");
  var a = n.allowNegative, i = n.thousandsGroupStyle;
  if (i === void 0 && (i = "thousand"), e === "" || e === "-")
    return e;
  var c = rc(n), l = c.thousandSeparator, u = c.decimalSeparator, d = t !== 0 && e.indexOf(".") !== -1 || t && r, f = pu(e, a), p = f.beforeDecimal, m = f.afterDecimal, h = f.addNegation;
  return t !== void 0 && (m = L3(m, t, !!r)), l && (p = zw(p, l, i)), o && (p = o + p), s && (m = m + s), h && (p = "-" + p), e = p + (d && u || "") + m, e;
}
function rc(e) {
  var n = e.decimalSeparator;
  n === void 0 && (n = ".");
  var t = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return t === !0 && (t = ","), r || (r = [n, "."]), {
    decimalSeparator: n,
    thousandSeparator: t,
    allowedDecimalSeparators: r
  };
}
function ax(e, n) {
  e === void 0 && (e = "");
  var t = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), o = t.test(e), s = r.test(e);
  return e = e.replace(/-/g, ""), o && !s && n && (e = "-" + e), e;
}
function ix(e, n) {
  return new RegExp("(^-)|[0-9]|" + N3(e), n ? "g" : void 0);
}
function cx(e, n, t) {
  return e === "" ? !0 : !(n != null && n.match(/\d/)) && !(t != null && t.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function lx(e, n, t) {
  var r;
  n === void 0 && (n = Jw(e));
  var o = t.allowNegative, s = t.prefix;
  s === void 0 && (s = "");
  var a = t.suffix;
  a === void 0 && (a = "");
  var i = t.decimalScale, c = n.from, l = n.to, u = l.start, d = l.end, f = rc(t), p = f.allowedDecimalSeparators, m = f.decimalSeparator, h = e[d] === m;
  if ($s(e) && (e === s || e === a) && n.lastValue === "")
    return e;
  if (d - u === 1 && p.indexOf(e[u]) !== -1) {
    var y = i === 0 ? "" : m;
    e = e.substring(0, u) + y + e.substring(u + 1, e.length);
  }
  var C = function(V, J, Q) {
    var X = !1, z = !1;
    s.startsWith("-") ? X = !1 : V.startsWith("--") ? (X = !1, z = !0) : a.startsWith("-") && V.length === a.length ? X = !1 : V[0] === "-" && (X = !0);
    var me = X ? 1 : 0;
    return z && (me = 2), me && (V = V.substring(me), J -= me, Q -= me), { value: V, start: J, end: Q, hasNegation: X };
  }, v = C(e, u, d), w = v.hasNegation;
  r = v, e = r.value, u = r.start, d = r.end;
  var x = C(n.lastValue, c.start, c.end), D = x.start, k = x.end, _ = x.value, M = e.substring(u, d);
  e.length && _.length && (D > _.length - a.length || k < s.length) && !(M && a.startsWith(M)) && (e = _);
  var T = 0;
  e.startsWith(s) ? T += s.length : u < s.length && (T = u), e = e.substring(T), d -= T;
  var N = e.length, I = e.length - a.length;
  e.endsWith(a) ? N = I : (d > I || d > e.length - a.length) && (N = d), e = e.substring(0, N), e = ax(w ? "-" + e : e, o), e = (e.match(ix(m, !0)) || []).join("");
  var O = e.indexOf(m);
  e = e.replace(new RegExp(N3(m), "g"), function(V, J) {
    return J === O ? "." : "";
  });
  var $ = pu(e, o), j = $.beforeDecimal, Y = $.afterDecimal, F = $.addNegation;
  return l.end - l.start < c.end - c.start && j === "" && h && !parseFloat(Y) && (e = F ? "-" : ""), e;
}
function ux(e, n) {
  var t = n.prefix;
  t === void 0 && (t = "");
  var r = n.suffix;
  r === void 0 && (r = "");
  var o = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), s = e[0] === "-";
  o.fill(!1, 0, t.length + (s ? 1 : 0));
  var a = e.length;
  return o.fill(!1, a - r.length + 1, a + 1), o;
}
function dx(e) {
  var n = rc(e), t = n.thousandSeparator, r = n.decimalSeparator, o = e.prefix;
  o === void 0 && (o = "");
  var s = e.allowNegative;
  if (s === void 0 && (s = !0), t === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + t + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return o.startsWith("-") && s && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + o + `
      allowNegative: ` + s + `
    `), s = !1), Object.assign(Object.assign({}, e), { allowNegative: s });
}
function fx(e) {
  e = dx(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var n = e.suffix, t = e.allowNegative, r = e.allowLeadingZeros, o = e.onKeyDown;
  o === void 0 && (o = cr);
  var s = e.onBlur;
  s === void 0 && (s = cr);
  var a = e.thousandSeparator, i = e.decimalScale, c = e.fixedDecimalScale, l = e.prefix;
  l === void 0 && (l = "");
  var u = e.defaultValue, d = e.value, f = e.valueIsNumericString, p = e.onValueChange, m = k3(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), h = rc(e), y = h.decimalSeparator, C = h.allowedDecimalSeparators, v = function(F) {
    return nf(F, e);
  }, w = function(F, V) {
    return lx(F, V, e);
  }, x = Lo(d) ? u : d, D = f ?? cx(x, l, n);
  Lo(d) ? Lo(u) || (D = D || typeof u == "number") : D = D || typeof d == "number";
  var k = function(F) {
    return A3(F) ? F : (typeof F == "number" && (F = T3(F)), D && typeof i == "number" ? ef(F, i, !!c) : F);
  }, _ = O3(k(d), k(u), !!D, v, w, p), M = _[0], T = M.numAsString, N = M.formattedValue, I = _[1], O = function(F) {
    var V = F.target, J = F.key, Q = V.selectionStart, X = V.selectionEnd, z = V.value;
    if (z === void 0 && (z = ""), Q !== X) {
      o(F);
      return;
    }
    J === "Backspace" && z[0] === "-" && Q === l.length + 1 && t && Ir(V, 1), i && c && (J === "Backspace" && z[Q - 1] === y ? (Ir(V, Q - 1), F.preventDefault()) : J === "Delete" && z[Q] === y && F.preventDefault()), C != null && C.includes(J) && z[Q] === y && Ir(V, Q + 1);
    var me = a === !0 ? "," : a;
    J === "Backspace" && z[Q - 1] === me && Ir(V, Q - 1), J === "Delete" && z[Q] === me && Ir(V, Q + 1), o(F);
  }, $ = function(F) {
    var V = T;
    if (V.match(/\d/g) || (V = ""), r || (V = qw(V)), c && i && (V = ef(V, i, c)), V !== T) {
      var J = nf(V, e);
      I({
        formattedValue: J,
        value: V,
        floatValue: parseFloat(V)
      }, {
        event: F,
        source: Vs.event
      });
    }
    s(F);
  }, j = function(F) {
    return F === y ? !0 : $s(F);
  }, Y = function(F) {
    var V = F.currentValue, J = F.lastValue, Q = F.formattedValue, X = F.currentValueIndex, z = F.formattedValueIndex, me = V[X], Me = Q[z], Be = P3(J, V), ve = Be.to;
    return X >= ve.start && X < ve.end && C && C.includes(me) && Me === y ? !0 : me === Me;
  };
  return Object.assign(Object.assign({}, m), {
    value: N,
    valueIsNumericString: !1,
    isValidInputCharacter: j,
    isCharacterSame: Y,
    onValueChange: I,
    format: v,
    removeFormatting: w,
    getCaretBoundary: function(F) {
      return ux(F, e);
    },
    onKeyDown: O,
    onBlur: $
  });
}
function px(e) {
  var n = fx(e);
  return A.createElement(sx, Object.assign({}, n));
}
function hx({
  control: e,
  name: n,
  allowDecimals: t,
  label: r,
  error: o,
  className: s,
  state: a,
  variant: i,
  rules: c,
  defaultValue: l,
  disabled: u,
  ...d
}) {
  const f = `input_${n}`, h = te(tu({
    variant: i,
    state: !!o ? "error" : a,
    className: s
  }), "pl-[34px]"), {
    field: y
  } = Go({
    control: e,
    name: n,
    rules: c,
    defaultValue: l
  }), {
    onChange: C,
    value: v,
    onBlur: w
  } = y, x = te("absolute inset-y-0 left-0 flex items-center pl-4", "text-sm font-light", v ? "text-foreground" : "text-placeholder", u && v && "text-input-disabled-foreground");
  return /* @__PURE__ */ P(he.div, {
    transition: Ce,
    layoutId: f,
    className: "w-full",
    layout: "position",
    children: [/* @__PURE__ */ g(Xi, {
      id: f,
      label: r
    }), /* @__PURE__ */ P("div", {
      className: "relative flex w-full",
      children: [/* @__PURE__ */ g("span", {
        className: x,
        children: "€"
      }), /* @__PURE__ */ g(px, {
        name: n,
        "data-testid": f,
        id: f,
        "aria-label": f,
        className: h,
        disabled: u,
        decimalSeparator: ",",
        thousandSeparator: ".",
        decimalScale: t ? 2 : 0,
        allowNegative: !1,
        ...d,
        value: v,
        type: "text",
        onBlur: w,
        onValueChange: ({
          floatValue: D
        }) => {
          C(D);
        }
      })]
    }), /* @__PURE__ */ g(jt, {
      name: n,
      error: o
    })]
  });
}
function Qr(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ae(e) {
  const n = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && n === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || n === "[object Number]" || typeof e == "string" || n === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Vo(e) {
  if (!Qr(e) && typeof e != "number")
    return !1;
  const n = ae(e);
  return !isNaN(Number(n));
}
const mx = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, gx = (e, n, t) => {
  let r;
  const o = mx[e];
  return typeof o == "string" ? r = o : n === 1 ? r = o.one : r = o.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function To(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const yx = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, vx = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, bx = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cx = {
  date: To({
    formats: yx,
    defaultWidth: "full"
  }),
  time: To({
    formats: vx,
    defaultWidth: "full"
  }),
  dateTime: To({
    formats: bx,
    defaultWidth: "full"
  })
}, wx = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, xx = (e, n, t, r) => wx[e];
function yn(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[i] || e.values[a];
    }
    const s = e.argumentCallback ? e.argumentCallback(n) : n;
    return o[s];
  };
}
const Dx = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Sx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ex = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, _x = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Mx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, kx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ax = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Nx = {
  ordinalNumber: Ax,
  era: yn({
    values: Dx,
    defaultWidth: "wide"
  }),
  quarter: yn({
    values: Sx,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: yn({
    values: Ex,
    defaultWidth: "wide"
  }),
  day: yn({
    values: _x,
    defaultWidth: "wide"
  }),
  dayPeriod: yn({
    values: Mx,
    defaultWidth: "wide",
    formattingValues: kx,
    defaultFormattingWidth: "wide"
  })
};
function vn(e) {
  return (n, t = {}) => {
    const r = t.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = n.match(o);
    if (!s)
      return null;
    const a = s[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(i) ? Tx(i, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Lx(i, (d) => d.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(l)
    ) : l;
    const u = n.slice(a.length);
    return { value: l, rest: u };
  };
}
function Lx(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Tx(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function R3(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], s = n.match(e.parsePattern);
    if (!s)
      return null;
    let a = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const i = n.slice(o.length);
    return { value: a, rest: i };
  };
}
const Px = /^(\d+)(th|st|nd|rd)?/i, Ox = /\d+/i, Rx = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ix = {
  any: [/^b/i, /^(a|c)/i]
}, Fx = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Vx = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $x = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Bx = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jx = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Yx = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Hx = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ux = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Wx = {
  ordinalNumber: R3({
    matchPattern: Px,
    parsePattern: Ox,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: vn({
    matchPatterns: Rx,
    defaultMatchWidth: "wide",
    parsePatterns: Ix,
    defaultParseWidth: "any"
  }),
  quarter: vn({
    matchPatterns: Fx,
    defaultMatchWidth: "wide",
    parsePatterns: Vx,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: vn({
    matchPatterns: $x,
    defaultMatchWidth: "wide",
    parsePatterns: Bx,
    defaultParseWidth: "any"
  }),
  day: vn({
    matchPatterns: jx,
    defaultMatchWidth: "wide",
    parsePatterns: Yx,
    defaultParseWidth: "any"
  }),
  dayPeriod: vn({
    matchPatterns: Hx,
    defaultMatchWidth: "any",
    parsePatterns: Ux,
    defaultParseWidth: "any"
  })
}, I3 = {
  code: "en-US",
  formatDistance: gx,
  formatLong: Cx,
  formatRelative: xx,
  localize: Nx,
  match: Wx,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Zx = {};
function oo() {
  return Zx;
}
const F3 = 6048e5, Kx = 864e5, oc = 6e4, sc = 36e5, zx = 1e3;
function En(e) {
  const n = ae(e);
  return n.setHours(0, 0, 0, 0), n;
}
function bi(e) {
  const n = ae(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Bs(e, n) {
  const t = En(e), r = En(n), o = +t - bi(t), s = +r - bi(r);
  return Math.round((o - s) / Kx);
}
function Ye(e, n) {
  return e instanceof Date ? new e.constructor(n) : new Date(n);
}
function hu(e) {
  const n = ae(e), t = Ye(e, 0);
  return t.setFullYear(n.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Gx(e) {
  const n = ae(e);
  return Bs(n, hu(n)) + 1;
}
function qn(e, n) {
  var i, c, l, u;
  const t = oo(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((c = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = ae(e), s = o.getDay(), a = (s < r ? 7 : 0) + s - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function $o(e) {
  return qn(e, { weekStartsOn: 1 });
}
function V3(e) {
  const n = ae(e), t = n.getFullYear(), r = Ye(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = $o(r), s = Ye(e, 0);
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0);
  const a = $o(s);
  return n.getTime() >= o.getTime() ? t + 1 : n.getTime() >= a.getTime() ? t : t - 1;
}
function qx(e) {
  const n = V3(e), t = Ye(e, 0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), $o(t);
}
function mu(e) {
  const n = ae(e), t = +$o(n) - +qx(n);
  return Math.round(t / F3) + 1;
}
function gu(e, n) {
  var u, d, f, p;
  const t = ae(e), r = t.getFullYear(), o = oo(), s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = Ye(e, 0);
  a.setFullYear(r + 1, 0, s), a.setHours(0, 0, 0, 0);
  const i = qn(a, n), c = Ye(e, 0);
  c.setFullYear(r, 0, s), c.setHours(0, 0, 0, 0);
  const l = qn(c, n);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= l.getTime() ? r : r - 1;
}
function Qx(e, n) {
  var i, c, l, u;
  const t = oo(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((c = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : c.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = gu(e, n), s = Ye(e, 0);
  return s.setFullYear(o, 0, r), s.setHours(0, 0, 0, 0), qn(s, n);
}
function $3(e, n) {
  const t = ae(e), r = +qn(t, n) - +Qx(t, n);
  return Math.round(r / F3) + 1;
}
function je(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const rr = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return je(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : je(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return je(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return je(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return je(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return je(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return je(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return je(o, n.length);
  }
}, yo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, rf = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return rr.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const o = gu(e, r), s = o > 0 ? o : 1 - o;
    if (n === "YY") {
      const a = s % 100;
      return je(a, 2);
    }
    return n === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : je(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = V3(e);
    return je(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return je(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(r);
      case "QQ":
        return je(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(r);
      case "qq":
        return je(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return rr.M(e, n);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "L":
        return String(r + 1);
      case "LL":
        return je(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const o = $3(e, r);
    return n === "wo" ? t.ordinalNumber(o, { unit: "week" }) : je(o, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = mu(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : je(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : rr.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = Gx(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : je(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return je(s, 2);
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return je(s, n.length);
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return je(o, n.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = yo.noon : r === 0 ? o = yo.midnight : o = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = yo.evening : r >= 12 ? o = yo.afternoon : r >= 4 ? o = yo.morning : o = yo.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return rr.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : rr.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : je(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : je(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : rr.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : rr.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return rr.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      case "X":
        return sf(r);
      case "XXXX":
      case "XX":
        return Rr(r);
      case "XXXXX":
      case "XXX":
      default:
        return Rr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return sf(r);
      case "xxxx":
      case "xx":
        return Rr(r);
      case "xxxxx":
      case "xxx":
      default:
        return Rr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + of(r, ":");
      case "OOOO":
      default:
        return "GMT" + Rr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + of(r, ":");
      case "zzzz":
      default:
        return "GMT" + Rr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(e.getTime() / 1e3);
    return je(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    const r = e.getTime();
    return je(r, n.length);
  }
};
function of(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? t + String(o) : t + String(o) + n + je(s, 2);
}
function sf(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + je(Math.abs(e) / 60, 2) : Rr(e, n);
}
function Rr(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = je(Math.trunc(r / 60), 2), s = je(r % 60, 2);
  return t + o + n + s;
}
const af = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, B3 = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, Xx = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], o = t[2];
  if (!o)
    return af(e, n);
  let s;
  switch (r) {
    case "P":
      s = n.dateTime({ width: "short" });
      break;
    case "PP":
      s = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = n.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", af(r, n)).replace("{{time}}", B3(o, n));
}, Ci = {
  p: B3,
  P: Xx
}, Jx = /^D+$/, eD = /^Y+$/, tD = ["D", "DD", "YY", "YYYY"];
function j3(e) {
  return Jx.test(e);
}
function Y3(e) {
  return eD.test(e);
}
function Kl(e, n, t) {
  const r = nD(e, n, t);
  if (console.warn(r), tD.includes(e))
    throw new RangeError(r);
}
function nD(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const rD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, oD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, sD = /^'([^]*?)'?$/, aD = /''/g, iD = /[a-zA-Z]/;
function cf(e, n, t) {
  var u, d, f, p, m, h, y, C;
  const r = oo(), o = (t == null ? void 0 : t.locale) ?? r.locale ?? I3, s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (t == null ? void 0 : t.weekStartsOn) ?? ((h = (m = t == null ? void 0 : t.locale) == null ? void 0 : m.options) == null ? void 0 : h.weekStartsOn) ?? r.weekStartsOn ?? ((C = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : C.weekStartsOn) ?? 0, i = ae(e);
  if (!Vo(i))
    throw new RangeError("Invalid time value");
  let c = n.match(oD).map((v) => {
    const w = v[0];
    if (w === "p" || w === "P") {
      const x = Ci[w];
      return x(v, o.formatLong);
    }
    return v;
  }).join("").match(rD).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const w = v[0];
    if (w === "'")
      return { isToken: !1, value: cD(v) };
    if (rf[w])
      return { isToken: !0, value: v };
    if (w.match(iD))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: v };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(i, c));
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: o
  };
  return c.map((v) => {
    if (!v.isToken)
      return v.value;
    const w = v.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Y3(w) || !(t != null && t.useAdditionalDayOfYearTokens) && j3(w)) && Kl(w, n, String(e));
    const x = rf[w[0]];
    return x(i, w, o.localize, l);
  }).join("");
}
function cD(e) {
  const n = e.match(sD);
  return n ? n[1].replace(aD, "'") : e;
}
function H3(e, n) {
  const t = +ae(e);
  return Ye(e, t + n);
}
function zl(e, n) {
  return H3(e, n * oc);
}
function lD(e, n) {
  return H3(e, n * sc);
}
function Mr(e, n) {
  const t = ae(e);
  return isNaN(n) ? Ye(e, NaN) : (n && t.setDate(t.getDate() + n), t);
}
function wi(e, n) {
  const t = n * 7;
  return Mr(e, t);
}
function ln(e, n) {
  const t = ae(e);
  if (isNaN(n))
    return Ye(e, NaN);
  if (!n)
    return t;
  const r = t.getDate(), o = Ye(e, t.getTime());
  o.setMonth(t.getMonth() + n + 1, 0);
  const s = o.getDate();
  return r >= s ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), t);
}
function U3(e, n) {
  const t = n * 3;
  return ln(e, t);
}
function hr(e, n) {
  return ln(e, n * 12);
}
function uD(e, n) {
  return Mr(e, -n);
}
function lf(e, n) {
  return wi(e, -n);
}
function Bo(e, n) {
  return ln(e, -n);
}
function dD(e, n) {
  return U3(e, -n);
}
function ra(e, n) {
  return hr(e, -n);
}
function uf(e) {
  return ae(e).getSeconds();
}
function _n(e) {
  return ae(e).getMinutes();
}
function Mn(e) {
  return ae(e).getHours();
}
function fD(e) {
  return ae(e).getDay();
}
function df(e) {
  return ae(e).getDate();
}
function Ot(e) {
  return ae(e).getMonth();
}
function Es(e) {
  const n = ae(e);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function Le(e) {
  return ae(e).getFullYear();
}
function Gl(e) {
  return ae(e).getTime();
}
function pD(e, n) {
  const t = ae(e);
  return t.setSeconds(n), t;
}
function Ua(e, n) {
  const t = ae(e);
  return t.setMinutes(n), t;
}
function Wa(e, n) {
  const t = ae(e);
  return t.setHours(n), t;
}
function hD(e) {
  const n = ae(e), t = n.getFullYear(), r = n.getMonth(), o = Ye(e, 0);
  return o.setFullYear(t, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Tt(e, n) {
  const t = ae(e), r = t.getFullYear(), o = t.getDate(), s = Ye(e, 0);
  s.setFullYear(r, n, 15), s.setHours(0, 0, 0, 0);
  const a = hD(s);
  return t.setMonth(n, Math.min(o, a)), t;
}
function wo(e, n) {
  const t = ae(e), r = Math.trunc(t.getMonth() / 3) + 1, o = n - r;
  return Tt(t, t.getMonth() + o * 3);
}
function hn(e, n) {
  const t = ae(e);
  return isNaN(+t) ? Ye(e, NaN) : (t.setFullYear(n), t);
}
function ff(e) {
  let n;
  return e.forEach((t) => {
    const r = ae(t);
    (!n || n > r || isNaN(+r)) && (n = r);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function pf(e) {
  let n;
  return e.forEach(function(t) {
    const r = ae(t);
    (n === void 0 || n < r || isNaN(Number(r))) && (n = r);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function xi(e, n) {
  const t = ae(e), r = ae(n), o = t.getFullYear() - r.getFullYear(), s = t.getMonth() - r.getMonth();
  return o * 12 + s;
}
function Di(e, n) {
  const t = ae(e), r = ae(n);
  return t.getFullYear() - r.getFullYear();
}
function W3(e) {
  const n = ae(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function ql(e) {
  const n = ae(e), t = n.getMonth(), r = t - t % 3;
  return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
}
function Ql(e) {
  const n = ae(e);
  return n.setHours(23, 59, 59, 999), n;
}
function mD(e, n) {
  var i, c, l, u;
  const t = oo(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((c = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = ae(e), s = o.getDay(), a = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function gD(e) {
  const n = ae(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function yD(e) {
  const n = ae(e), t = n.getFullYear();
  return n.setFullYear(t + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function vD(e, n) {
  const t = ae(e), r = ae(n);
  return +t == +r;
}
function bD(e, n) {
  const t = En(e), r = En(n);
  return +t == +r;
}
function CD(e, n) {
  const t = ae(e), r = ae(n);
  return t.getFullYear() === r.getFullYear() && t.getMonth() === r.getMonth();
}
function wD(e, n) {
  const t = ae(e), r = ae(n);
  return t.getFullYear() === r.getFullYear();
}
function xD(e, n) {
  const t = ql(e), r = ql(n);
  return +t == +r;
}
function br(e, n) {
  const t = ae(e), r = ae(n);
  return t.getTime() > r.getTime();
}
function Xr(e, n) {
  const t = ae(e), r = ae(n);
  return +t < +r;
}
function js(e, n) {
  const t = +ae(e), [r, o] = [
    +ae(n.start),
    +ae(n.end)
  ].sort((s, a) => s - a);
  return t >= r && t <= o;
}
function DD() {
  return Object.assign({}, oo());
}
function SD(e, n) {
  const t = n instanceof Date ? Ye(n, 0) : new n(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const ED = 10;
class Z3 {
  constructor() {
    se(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class _D extends Z3 {
  constructor(n, t, r, o, s) {
    super(), this.value = n, this.validateValue = t, this.setValue = r, this.priority = o, s && (this.subPriority = s);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, r) {
    return this.setValue(n, t, this.value, r);
  }
}
class MD extends Z3 {
  constructor() {
    super(...arguments);
    se(this, "priority", ED);
    se(this, "subPriority", -1);
  }
  set(t, r) {
    return r.timestampIsSet ? t : Ye(t, SD(t, Date));
  }
}
class $e {
  run(n, t, r, o) {
    const s = this.parse(n, t, r, o);
    return s ? {
      setter: new _D(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(n, t, r) {
    return !0;
  }
}
class kD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 140);
    se(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, r, o) {
    return r.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const lt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, bn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function ut(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function nt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Cn(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, s = t[3] ? parseInt(t[3], 10) : 0, a = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (o * sc + s * oc + a * zx),
    rest: n.slice(t[0].length)
  };
}
function K3(e) {
  return nt(lt.anyDigitsSigned, e);
}
function st(e, n) {
  switch (e) {
    case 1:
      return nt(lt.singleDigit, n);
    case 2:
      return nt(lt.twoDigits, n);
    case 3:
      return nt(lt.threeDigits, n);
    case 4:
      return nt(lt.fourDigits, n);
    default:
      return nt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function Si(e, n) {
  switch (e) {
    case 1:
      return nt(lt.singleDigitSigned, n);
    case 2:
      return nt(lt.twoDigitsSigned, n);
    case 3:
      return nt(lt.threeDigitsSigned, n);
    case 4:
      return nt(lt.fourDigitsSigned, n);
    default:
      return nt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function yu(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function z3(e, n) {
  const t = n > 0, r = t ? n : 1 - n;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const s = r + 50, a = Math.trunc(s / 100) * 100, i = e >= s % 100;
    o = e + a - (i ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function G3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class AD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 130);
    se(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, o) {
    const s = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return ut(st(4, t), s);
      case "yo":
        return ut(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return ut(st(r.length, t), s);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o) {
    const s = t.getFullYear();
    if (o.isTwoDigitYear) {
      const i = z3(
        o.year,
        s
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ND extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 130);
    se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const s = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return ut(st(4, t), s);
      case "Yo":
        return ut(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return ut(st(r.length, t), s);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o, s) {
    const a = gu(t, s);
    if (o.isTwoDigitYear) {
      const c = z3(
        o.year,
        a
      );
      return t.setFullYear(
        c,
        0,
        s.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), qn(t, s);
    }
    const i = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(i, 0, s.firstWeekContainsDate), t.setHours(0, 0, 0, 0), qn(t, s);
  }
}
class LD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 130);
    se(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return Si(r === "R" ? 4 : r.length, t);
  }
  set(t, r, o) {
    const s = Ye(t, 0);
    return s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0), $o(s);
  }
}
class TD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 130);
    se(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return Si(r === "u" ? 4 : r.length, t);
  }
  set(t, r, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class PD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 120);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return st(r.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class OD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 120);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return st(r.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class RD extends $e {
  constructor() {
    super(...arguments);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    se(this, "priority", 110);
  }
  parse(t, r, o) {
    const s = (a) => a - 1;
    switch (r) {
      case "M":
        return ut(
          nt(lt.month, t),
          s
        );
      case "MM":
        return ut(st(2, t), s);
      case "Mo":
        return ut(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ID extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 110);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const s = (a) => a - 1;
    switch (r) {
      case "L":
        return ut(
          nt(lt.month, t),
          s
        );
      case "LL":
        return ut(st(2, t), s);
      case "Lo":
        return ut(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function FD(e, n, t) {
  const r = ae(e), o = $3(r, t) - n;
  return r.setDate(r.getDate() - o * 7), r;
}
class VD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 100);
    se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "w":
        return nt(lt.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o, s) {
    return qn(FD(t, o, s), s);
  }
}
function $D(e, n) {
  const t = ae(e), r = mu(t) - n;
  return t.setDate(t.getDate() - r * 7), t;
}
class BD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 100);
    se(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "I":
        return nt(lt.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o) {
    return $o($D(t, o));
  }
}
const jD = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], YD = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class HD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "subPriority", 1);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "d":
        return nt(lt.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear(), s = G3(o), a = t.getMonth();
    return s ? r >= 1 && r <= YD[a] : r >= 1 && r <= jD[a];
  }
  set(t, r, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class UD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "subpriority", 1);
    se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return nt(lt.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear();
    return G3(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function vu(e, n, t) {
  var d, f, p, m;
  const r = oo(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, s = ae(e), a = s.getDay(), c = (n % 7 + 7) % 7, l = 7 - o, u = n < 0 || n > 6 ? n - (a + l) % 7 : (c + l) % 7 - (a + l) % 7;
  return Mr(s, u);
}
class WD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, s) {
    return t = vu(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
class ZD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o, s) {
    const a = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + s.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "e":
      case "ee":
        return ut(st(r.length, t), a);
      case "eo":
        return ut(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, s) {
    return t = vu(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
class KD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, o, s) {
    const a = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + s.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "c":
      case "cc":
        return ut(st(r.length, t), a);
      case "co":
        return ut(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, s) {
    return t = vu(t, o, s), t.setHours(0, 0, 0, 0), t;
  }
}
function zD(e) {
  let t = ae(e).getDay();
  return t === 0 && (t = 7), t;
}
function GD(e, n) {
  const t = ae(e), r = zD(t), o = n - r;
  return Mr(t, o);
}
class qD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 90);
    se(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const s = (a) => a === 0 ? 7 : a;
    switch (r) {
      case "i":
      case "ii":
        return st(r.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return ut(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiii":
        return ut(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiiii":
        return ut(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiii":
      default:
        return ut(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, o) {
    return t = GD(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class QD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 80);
    se(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(yu(o), 0, 0, 0), t;
  }
}
class XD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 80);
    se(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(yu(o), 0, 0, 0), t;
  }
}
class JD extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 80);
    se(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(yu(o), 0, 0, 0), t;
  }
}
class eS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 70);
    se(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "h":
        return nt(lt.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, o) {
    const s = t.getHours() >= 12;
    return s && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !s && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class tS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 70);
    se(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "H":
        return nt(lt.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class nS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 70);
    se(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "K":
        return nt(lt.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class rS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 70);
    se(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "k":
        return nt(lt.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, o) {
    const s = o <= 24 ? o % 24 : o;
    return t.setHours(s, 0, 0, 0), t;
  }
}
class oS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 60);
    se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "m":
        return nt(lt.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class sS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 50);
    se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "s":
        return nt(lt.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return st(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setSeconds(o, 0), t;
  }
}
class aS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 30);
    se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const o = (s) => Math.trunc(s * Math.pow(10, -r.length + 3));
    return ut(st(r.length, t), o);
  }
  set(t, r, o) {
    return t.setMilliseconds(o), t;
  }
}
class iS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 10);
    se(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return Cn(
          bn.basicOptionalMinutes,
          t
        );
      case "XX":
        return Cn(bn.basic, t);
      case "XXXX":
        return Cn(
          bn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Cn(
          bn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Cn(bn.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : Ye(
      t,
      t.getTime() - bi(t) - o
    );
  }
}
class cS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 10);
    se(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return Cn(
          bn.basicOptionalMinutes,
          t
        );
      case "xx":
        return Cn(bn.basic, t);
      case "xxxx":
        return Cn(
          bn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Cn(
          bn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Cn(bn.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : Ye(
      t,
      t.getTime() - bi(t) - o
    );
  }
}
class lS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 40);
    se(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return K3(t);
  }
  set(t, r, o) {
    return [Ye(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class uS extends $e {
  constructor() {
    super(...arguments);
    se(this, "priority", 20);
    se(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return K3(t);
  }
  set(t, r, o) {
    return [Ye(t, o), { timestampIsSet: !0 }];
  }
}
const dS = {
  G: new kD(),
  y: new AD(),
  Y: new ND(),
  R: new LD(),
  u: new TD(),
  Q: new PD(),
  q: new OD(),
  M: new RD(),
  L: new ID(),
  w: new VD(),
  I: new BD(),
  d: new HD(),
  D: new UD(),
  E: new WD(),
  e: new ZD(),
  c: new KD(),
  i: new qD(),
  a: new QD(),
  b: new XD(),
  B: new JD(),
  h: new eS(),
  H: new tS(),
  K: new nS(),
  k: new rS(),
  m: new oS(),
  s: new sS(),
  S: new aS(),
  X: new iS(),
  x: new cS(),
  t: new lS(),
  T: new uS()
}, fS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hS = /^'([^]*?)'?$/, mS = /''/g, gS = /\S/, yS = /[a-zA-Z]/;
function Gc(e, n, t, r) {
  var h, y, C, v, w, x, D, k;
  const o = DD(), s = (r == null ? void 0 : r.locale) ?? o.locale ?? I3, a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((y = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : y.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((v = (C = o.locale) == null ? void 0 : C.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, i = (r == null ? void 0 : r.weekStartsOn) ?? ((x = (w = r == null ? void 0 : r.locale) == null ? void 0 : w.options) == null ? void 0 : x.weekStartsOn) ?? o.weekStartsOn ?? ((k = (D = o.locale) == null ? void 0 : D.options) == null ? void 0 : k.weekStartsOn) ?? 0;
  if (n === "")
    return e === "" ? ae(t) : Ye(t, NaN);
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: s
  }, l = [new MD()], u = n.match(pS).map((_) => {
    const M = _[0];
    if (M in Ci) {
      const T = Ci[M];
      return T(_, s.formatLong);
    }
    return _;
  }).join("").match(fS), d = [];
  for (let _ of u) {
    !(r != null && r.useAdditionalWeekYearTokens) && Y3(_) && Kl(_, n, e), !(r != null && r.useAdditionalDayOfYearTokens) && j3(_) && Kl(_, n, e);
    const M = _[0], T = dS[M];
    if (T) {
      const { incompatibleTokens: N } = T;
      if (Array.isArray(N)) {
        const O = d.find(
          ($) => N.includes($.token) || $.token === M
        );
        if (O)
          throw new RangeError(
            `The format string mustn't contain \`${O.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (T.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      d.push({ token: M, fullToken: _ });
      const I = T.run(
        e,
        _,
        s.match,
        c
      );
      if (!I)
        return Ye(t, NaN);
      l.push(I.setter), e = I.rest;
    } else {
      if (M.match(yS))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + M + "`"
        );
      if (_ === "''" ? _ = "'" : M === "'" && (_ = vS(_)), e.indexOf(_) === 0)
        e = e.slice(_.length);
      else
        return Ye(t, NaN);
    }
  }
  if (e.length > 0 && gS.test(e))
    return Ye(t, NaN);
  const f = l.map((_) => _.priority).sort((_, M) => M - _).filter((_, M, T) => T.indexOf(_) === M).map(
    (_) => l.filter((M) => M.priority === _).sort((M, T) => T.subPriority - M.subPriority)
  ).map((_) => _[0]);
  let p = ae(t);
  if (isNaN(p.getTime()))
    return Ye(t, NaN);
  const m = {};
  for (const _ of f) {
    if (!_.validate(p, c))
      return Ye(t, NaN);
    const M = _.set(p, m, c);
    Array.isArray(M) ? (p = M[0], Object.assign(m, M[1])) : p = M;
  }
  return Ye(t, p);
}
function vS(e) {
  return e.match(hS)[1].replace(mS, "'");
}
function bS(e, n) {
  const t = (n == null ? void 0 : n.additionalDigits) ?? 2, r = DS(e);
  let o;
  if (r.date) {
    const c = SS(r.date, t);
    o = ES(c.restDateString, c.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const s = o.getTime();
  let a = 0, i;
  if (r.time && (a = _S(r.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (i = MS(r.timezone), isNaN(i))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const c = new Date(s + a), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return new Date(s + a + i);
}
const Ea = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, CS = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, wS = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, xS = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function DS(e) {
  const n = {}, t = e.split(Ea.dateTimeDelimiter);
  let r;
  if (t.length > 2)
    return n;
  if (/:/.test(t[0]) ? r = t[0] : (n.date = t[0], r = t[1], Ea.timeZoneDelimiter.test(n.date) && (n.date = e.split(Ea.timeZoneDelimiter)[0], r = e.substr(
    n.date.length,
    e.length
  ))), r) {
    const o = Ea.timezone.exec(r);
    o ? (n.time = r.replace(o[1], ""), n.timezone = o[1]) : n.time = r;
  }
  return n;
}
function SS(e, n) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), r = e.match(t);
  if (!r)
    return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, s = r[2] ? parseInt(r[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function ES(e, n) {
  if (n === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = e.match(CS);
  if (!t)
    return /* @__PURE__ */ new Date(NaN);
  const r = !!t[4], o = fs(t[1]), s = fs(t[2]) - 1, a = fs(t[3]), i = fs(t[4]), c = fs(t[5]) - 1;
  if (r)
    return TS(n, i, c) ? kS(n, i, c) : /* @__PURE__ */ new Date(NaN);
  {
    const l = /* @__PURE__ */ new Date(0);
    return !NS(n, s, a) || !LS(n, o) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(n, s, Math.max(o, a)), l);
  }
}
function fs(e) {
  return e ? parseInt(e) : 1;
}
function _S(e) {
  const n = e.match(wS);
  if (!n)
    return NaN;
  const t = qc(n[1]), r = qc(n[2]), o = qc(n[3]);
  return PS(t, r, o) ? t * sc + r * oc + o * 1e3 : NaN;
}
function qc(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function MS(e) {
  if (e === "Z")
    return 0;
  const n = e.match(xS);
  if (!n)
    return 0;
  const t = n[1] === "+" ? -1 : 1, r = parseInt(n[2]), o = n[3] && parseInt(n[3]) || 0;
  return OS(r, o) ? t * (r * sc + o * oc) : NaN;
}
function kS(e, n, t) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, s = (n - 1) * 7 + t + 1 - o;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
const AS = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function q3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function NS(e, n, t) {
  return n >= 0 && n <= 11 && t >= 1 && t <= (AS[n] || (q3(e) ? 29 : 28));
}
function LS(e, n) {
  return n >= 1 && n <= (q3(e) ? 366 : 365);
}
function TS(e, n, t) {
  return n >= 1 && n <= 53 && t >= 0 && t <= 6;
}
function PS(e, n, t) {
  return e === 24 ? n === 0 && t === 0 : t >= 0 && t < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function OS(e, n) {
  return n >= 0 && n <= 59;
}
function RS(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Xl(e, n);
}
function Xl(e, n) {
  return Xl = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Xl(e, n);
}
function IS(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, s;
  for (s = 0; s < r.length; s++)
    o = r[s], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function hf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FS(e, n, t) {
  return e === n ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(t) : e.classList.contains(t);
}
function VS(e, n, t) {
  if (e === n)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && FS(e, n, t))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function $S(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var BS = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var n = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        n = !0;
      }
    }), r = function() {
    };
    return window.addEventListener("testPassiveEventSupport", r, t), window.removeEventListener("testPassiveEventSupport", r, t), n;
  }
};
function jS(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var YS = jS(), Jl, _a = {}, Qc = {}, HS = ["touchstart", "touchmove"], US = "ignore-react-onclickoutside";
function mf(e, n) {
  var t = {}, r = HS.indexOf(n) !== -1;
  return r && Jl && (t.passive = !e.props.preventDefault), t;
}
function ac(e, n) {
  var t, r, o = e.displayName || e.name || "Component";
  return r = t = /* @__PURE__ */ function(s) {
    RS(a, s);
    function a(c) {
      var l;
      return l = s.call(this, c) || this, l.__outsideClickHandler = function(u) {
        if (typeof l.__clickOutsideHandlerProp == "function") {
          l.__clickOutsideHandlerProp(u);
          return;
        }
        var d = l.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + o + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, l.__getComponentNode = function() {
        var u = l.getInstance();
        return n && typeof n.setClickOutsideRef == "function" ? n.setClickOutsideRef()(u) : typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : n5(u);
      }, l.enableOnClickOutside = function() {
        if (!(typeof document > "u" || Qc[l._uid])) {
          typeof Jl > "u" && (Jl = BS()), Qc[l._uid] = !0;
          var u = l.props.eventTypes;
          u.forEach || (u = [u]), _a[l._uid] = function(d) {
            if (l.componentNode !== null && (l.props.preventDefault && d.preventDefault(), l.props.stopPropagation && d.stopPropagation(), !(l.props.excludeScrollbar && $S(d)))) {
              var f = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              VS(f, l.componentNode, l.props.outsideClickIgnoreClass) === document && l.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, _a[l._uid], mf(hf(l), d));
          });
        }
      }, l.disableOnClickOutside = function() {
        delete Qc[l._uid];
        var u = _a[l._uid];
        if (u && typeof document < "u") {
          var d = l.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(f) {
            return document.removeEventListener(f, u, mf(hf(l), f));
          }), delete _a[l._uid];
        }
      }, l.getRef = function(u) {
        return l.instanceRef = u;
      }, l._uid = YS(), l;
    }
    var i = a.prototype;
    return i.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, i.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var l = this.getInstance();
        if (n && typeof n.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = n.handleClickOutside(l), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + o + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, i.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, i.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, i.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var u = IS(l, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? u.ref = this.getRef : u.wrappedRef = this.getRef, u.disableOnClickOutside = this.disableOnClickOutside, u.enableOnClickOutside = this.enableOnClickOutside, le(e, u);
    }, a;
  }(Qh), t.displayName = "OnClickOutside(" + o + ")", t.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: n && n.excludeScrollbar || !1,
    outsideClickIgnoreClass: US,
    preventDefault: !1,
    stopPropagation: !1
  }, t.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, r;
}
function Cr(e) {
  return Q3(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Zt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Qn(e) {
  var n;
  return (n = (Q3(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function Q3(e) {
  return e instanceof Node || e instanceof Zt(e).Node;
}
function $t(e) {
  return e instanceof Element || e instanceof Zt(e).Element;
}
function Nn(e) {
  return e instanceof HTMLElement || e instanceof Zt(e).HTMLElement;
}
function gf(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Zt(e).ShadowRoot;
}
function oa(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: r,
    display: o
  } = on(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + r + t) && !["inline", "contents"].includes(o);
}
function WS(e) {
  return ["table", "td", "th"].includes(Cr(e));
}
function bu(e) {
  const n = Cu(), t = on(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function ZS(e) {
  let n = jo(e);
  for (; Nn(n) && !ic(n); ) {
    if (bu(n))
      return n;
    n = jo(n);
  }
  return null;
}
function Cu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ic(e) {
  return ["html", "body", "#document"].includes(Cr(e));
}
function on(e) {
  return Zt(e).getComputedStyle(e);
}
function cc(e) {
  return $t(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function jo(e) {
  if (Cr(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    gf(e) && e.host || // Fallback.
    Qn(e)
  );
  return gf(n) ? n.host : n;
}
function X3(e) {
  const n = jo(e);
  return ic(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : Nn(n) && oa(n) ? n : X3(n);
}
function Ys(e, n, t) {
  var r;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const o = X3(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Zt(o);
  return s ? n.concat(a, a.visualViewport || [], oa(o) ? o : [], a.frameElement && t ? Ys(a.frameElement) : []) : n.concat(o, Ys(o, [], t));
}
const Yo = Math.min, Ur = Math.max, Ei = Math.round, Ma = Math.floor, wr = (e) => ({
  x: e,
  y: e
}), KS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, zS = {
  start: "end",
  end: "start"
};
function e1(e, n, t) {
  return Ur(e, Yo(n, t));
}
function sa(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Jr(e) {
  return e.split("-")[0];
}
function aa(e) {
  return e.split("-")[1];
}
function J3(e) {
  return e === "x" ? "y" : "x";
}
function wu(e) {
  return e === "y" ? "height" : "width";
}
function lc(e) {
  return ["top", "bottom"].includes(Jr(e)) ? "y" : "x";
}
function xu(e) {
  return J3(lc(e));
}
function GS(e, n, t) {
  t === void 0 && (t = !1);
  const r = aa(e), o = xu(e), s = wu(o);
  let a = o === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return n.reference[s] > n.floating[s] && (a = _i(a)), [a, _i(a)];
}
function qS(e) {
  const n = _i(e);
  return [t1(e), n, t1(n)];
}
function t1(e) {
  return e.replace(/start|end/g, (n) => zS[n]);
}
function QS(e, n, t) {
  const r = ["left", "right"], o = ["right", "left"], s = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? o : r : n ? r : o;
    case "left":
    case "right":
      return n ? s : a;
    default:
      return [];
  }
}
function XS(e, n, t, r) {
  const o = aa(e);
  let s = QS(Jr(e), t === "start", r);
  return o && (s = s.map((a) => a + "-" + o), n && (s = s.concat(s.map(t1)))), s;
}
function _i(e) {
  return e.replace(/left|right|bottom|top/g, (n) => KS[n]);
}
function JS(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function eh(e) {
  return typeof e != "number" ? JS(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Mi(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function yf(e, n, t) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = lc(n), a = xu(n), i = wu(a), c = Jr(n), l = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[i] / 2 - o[i] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (aa(n)) {
    case "start":
      p[a] -= f * (t && l ? -1 : 1);
      break;
    case "end":
      p[a] += f * (t && l ? -1 : 1);
      break;
  }
  return p;
}
const eE = async (e, n, t) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: a
  } = t, i = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(n));
  let l = await a.getElementRects({
    reference: e,
    floating: n,
    strategy: o
  }), {
    x: u,
    y: d
  } = yf(l, r, c), f = r, p = {}, m = 0;
  for (let h = 0; h < i.length; h++) {
    const {
      name: y,
      fn: C
    } = i[h], {
      x: v,
      y: w,
      data: x,
      reset: D
    } = await C({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: n
      }
    });
    u = v ?? u, d = w ?? d, p = {
      ...p,
      [y]: {
        ...p[y],
        ...x
      }
    }, D && m <= 50 && (m++, typeof D == "object" && (D.placement && (f = D.placement), D.rects && (l = D.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: n,
      strategy: o
    }) : D.rects), {
      x: u,
      y: d
    } = yf(l, f, c)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function th(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: a,
    elements: i,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = sa(n, e), m = eh(p), y = i[f ? d === "floating" ? "reference" : "floating" : d], C = Mi(await s.getClippingRect({
    element: (t = await (s.isElement == null ? void 0 : s.isElement(y))) == null || t ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), v = d === "floating" ? {
    ...a.floating,
    x: r,
    y: o
  } : a.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), x = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Mi(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: v,
    offsetParent: w,
    strategy: c
  }) : v);
  return {
    top: (C.top - D.top + m.top) / x.y,
    bottom: (D.bottom - C.bottom + m.bottom) / x.y,
    left: (C.left - D.left + m.left) / x.x,
    right: (D.right - C.right + m.right) / x.x
  };
}
const tE = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: r,
      placement: o,
      rects: s,
      platform: a,
      elements: i,
      middlewareData: c
    } = n, {
      element: l,
      padding: u = 0
    } = sa(e, n) || {};
    if (l == null)
      return {};
    const d = eh(u), f = {
      x: t,
      y: r
    }, p = xu(o), m = wu(p), h = await a.getDimensions(l), y = p === "y", C = y ? "top" : "left", v = y ? "bottom" : "right", w = y ? "clientHeight" : "clientWidth", x = s.reference[m] + s.reference[p] - f[p] - s.floating[m], D = f[p] - s.reference[p], k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let _ = k ? k[w] : 0;
    (!_ || !await (a.isElement == null ? void 0 : a.isElement(k))) && (_ = i.floating[w] || s.floating[m]);
    const M = x / 2 - D / 2, T = _ / 2 - h[m] / 2 - 1, N = Yo(d[C], T), I = Yo(d[v], T), O = N, $ = _ - h[m] - I, j = _ / 2 - h[m] / 2 + M, Y = e1(O, j, $), F = !c.arrow && aa(o) != null && j !== Y && s.reference[m] / 2 - (j < O ? N : I) - h[m] / 2 < 0, V = F ? j < O ? j - O : j - $ : 0;
    return {
      [p]: f[p] + V,
      data: {
        [p]: Y,
        centerOffset: j - Y - V,
        ...F && {
          alignmentOffset: V
        }
      },
      reset: F
    };
  }
}), nE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, r;
      const {
        placement: o,
        middlewareData: s,
        rects: a,
        initialPlacement: i,
        platform: c,
        elements: l
      } = n, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...y
      } = sa(e, n);
      if ((t = s.arrow) != null && t.alignmentOffset)
        return {};
      const C = Jr(o), v = Jr(i) === i, w = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), x = f || (v || !h ? [_i(i)] : qS(i));
      !f && m !== "none" && x.push(...XS(i, h, m, w));
      const D = [i, ...x], k = await th(n, y), _ = [];
      let M = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && _.push(k[C]), d) {
        const O = GS(o, a, w);
        _.push(k[O[0]], k[O[1]]);
      }
      if (M = [...M, {
        placement: o,
        overflows: _
      }], !_.every((O) => O <= 0)) {
        var T, N;
        const O = (((T = s.flip) == null ? void 0 : T.index) || 0) + 1, $ = D[O];
        if ($)
          return {
            data: {
              index: O,
              overflows: M
            },
            reset: {
              placement: $
            }
          };
        let j = (N = M.filter((Y) => Y.overflows[0] <= 0).sort((Y, F) => Y.overflows[1] - F.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!j)
          switch (p) {
            case "bestFit": {
              var I;
              const Y = (I = M.map((F) => [F.placement, F.overflows.filter((V) => V > 0).reduce((V, J) => V + J, 0)]).sort((F, V) => F[1] - V[1])[0]) == null ? void 0 : I[0];
              Y && (j = Y);
              break;
            }
            case "initialPlacement":
              j = i;
              break;
          }
        if (o !== j)
          return {
            reset: {
              placement: j
            }
          };
      }
      return {};
    }
  };
};
async function rE(e, n) {
  const {
    placement: t,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Jr(t), i = aa(t), c = lc(t) === "y", l = ["left", "top"].includes(a) ? -1 : 1, u = s && c ? -1 : 1, d = sa(n, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return i && typeof m == "number" && (p = i === "end" ? m * -1 : m), c ? {
    x: p * u,
    y: f * l
  } : {
    x: f * l,
    y: p * u
  };
}
const nh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, r;
      const {
        x: o,
        y: s,
        placement: a,
        middlewareData: i
      } = n, c = await rE(n, e);
      return a === ((t = i.offset) == null ? void 0 : t.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
}, oE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: r,
        placement: o
      } = n, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: i = {
          fn: (y) => {
            let {
              x: C,
              y: v
            } = y;
            return {
              x: C,
              y: v
            };
          }
        },
        ...c
      } = sa(e, n), l = {
        x: t,
        y: r
      }, u = await th(n, c), d = lc(Jr(o)), f = J3(d);
      let p = l[f], m = l[d];
      if (s) {
        const y = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", v = p + u[y], w = p - u[C];
        p = e1(v, p, w);
      }
      if (a) {
        const y = d === "y" ? "top" : "left", C = d === "y" ? "bottom" : "right", v = m + u[y], w = m - u[C];
        m = e1(v, m, w);
      }
      const h = i.fn({
        ...n,
        [f]: p,
        [d]: m
      });
      return {
        ...h,
        data: {
          x: h.x - t,
          y: h.y - r
        }
      };
    }
  };
};
function rh(e) {
  const n = on(e);
  let t = parseFloat(n.width) || 0, r = parseFloat(n.height) || 0;
  const o = Nn(e), s = o ? e.offsetWidth : t, a = o ? e.offsetHeight : r, i = Ei(t) !== s || Ei(r) !== a;
  return i && (t = s, r = a), {
    width: t,
    height: r,
    $: i
  };
}
function Du(e) {
  return $t(e) ? e : e.contextElement;
}
function Po(e) {
  const n = Du(e);
  if (!Nn(n))
    return wr(1);
  const t = n.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = rh(n);
  let a = (s ? Ei(t.width) : t.width) / r, i = (s ? Ei(t.height) : t.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const sE = /* @__PURE__ */ wr(0);
function oh(e) {
  const n = Zt(e);
  return !Cu() || !n.visualViewport ? sE : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function aE(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Zt(e) ? !1 : n;
}
function eo(e, n, t, r) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), s = Du(e);
  let a = wr(1);
  n && (r ? $t(r) && (a = Po(r)) : a = Po(e));
  const i = aE(s, t, r) ? oh(s) : wr(0);
  let c = (o.left + i.x) / a.x, l = (o.top + i.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (s) {
    const f = Zt(s), p = r && $t(r) ? Zt(r) : r;
    let m = f, h = m.frameElement;
    for (; h && r && p !== m; ) {
      const y = Po(h), C = h.getBoundingClientRect(), v = on(h), w = C.left + (h.clientLeft + parseFloat(v.paddingLeft)) * y.x, x = C.top + (h.clientTop + parseFloat(v.paddingTop)) * y.y;
      c *= y.x, l *= y.y, u *= y.x, d *= y.y, c += w, l += x, m = Zt(h), h = m.frameElement;
    }
  }
  return Mi({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
const iE = [":popover-open", ":modal"];
function sh(e) {
  return iE.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function cE(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", a = Qn(r), i = n ? sh(n.floating) : !1;
  if (r === a || i && s)
    return t;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = wr(1);
  const u = wr(0), d = Nn(r);
  if ((d || !d && !s) && ((Cr(r) !== "body" || oa(a)) && (c = cc(r)), Nn(r))) {
    const f = eo(r);
    l = Po(r), u.x = f.x + r.clientLeft, u.y = f.y + r.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - c.scrollLeft * l.x + u.x,
    y: t.y * l.y - c.scrollTop * l.y + u.y
  };
}
function lE(e) {
  return Array.from(e.getClientRects());
}
function ah(e) {
  return eo(Qn(e)).left + cc(e).scrollLeft;
}
function uE(e) {
  const n = Qn(e), t = cc(e), r = e.ownerDocument.body, o = Ur(n.scrollWidth, n.clientWidth, r.scrollWidth, r.clientWidth), s = Ur(n.scrollHeight, n.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -t.scrollLeft + ah(e);
  const i = -t.scrollTop;
  return on(r).direction === "rtl" && (a += Ur(n.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: a,
    y: i
  };
}
function dE(e, n) {
  const t = Zt(e), r = Qn(e), o = t.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, i = 0, c = 0;
  if (o) {
    s = o.width, a = o.height;
    const l = Cu();
    (!l || l && n === "fixed") && (i = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: i,
    y: c
  };
}
function fE(e, n) {
  const t = eo(e, !0, n === "fixed"), r = t.top + e.clientTop, o = t.left + e.clientLeft, s = Nn(e) ? Po(e) : wr(1), a = e.clientWidth * s.x, i = e.clientHeight * s.y, c = o * s.x, l = r * s.y;
  return {
    width: a,
    height: i,
    x: c,
    y: l
  };
}
function vf(e, n, t) {
  let r;
  if (n === "viewport")
    r = dE(e, t);
  else if (n === "document")
    r = uE(Qn(e));
  else if ($t(n))
    r = fE(n, t);
  else {
    const o = oh(e);
    r = {
      ...n,
      x: n.x - o.x,
      y: n.y - o.y
    };
  }
  return Mi(r);
}
function ih(e, n) {
  const t = jo(e);
  return t === n || !$t(t) || ic(t) ? !1 : on(t).position === "fixed" || ih(t, n);
}
function pE(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let r = Ys(e, [], !1).filter((i) => $t(i) && Cr(i) !== "body"), o = null;
  const s = on(e).position === "fixed";
  let a = s ? jo(e) : e;
  for (; $t(a) && !ic(a); ) {
    const i = on(a), c = bu(a);
    !c && i.position === "fixed" && (o = null), (s ? !c && !o : !c && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || oa(a) && !c && ih(e, a)) ? r = r.filter((u) => u !== a) : o = i, a = jo(a);
  }
  return n.set(e, r), r;
}
function hE(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...t === "clippingAncestors" ? pE(n, this._c) : [].concat(t), r], i = a[0], c = a.reduce((l, u) => {
    const d = vf(n, u, o);
    return l.top = Ur(d.top, l.top), l.right = Yo(d.right, l.right), l.bottom = Yo(d.bottom, l.bottom), l.left = Ur(d.left, l.left), l;
  }, vf(n, i, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function mE(e) {
  const {
    width: n,
    height: t
  } = rh(e);
  return {
    width: n,
    height: t
  };
}
function gE(e, n, t) {
  const r = Nn(n), o = Qn(n), s = t === "fixed", a = eo(e, !0, s, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = wr(0);
  if (r || !r && !s)
    if ((Cr(n) !== "body" || oa(o)) && (i = cc(n)), r) {
      const d = eo(n, !0, s, n);
      c.x = d.x + n.clientLeft, c.y = d.y + n.clientTop;
    } else
      o && (c.x = ah(o));
  const l = a.left + i.scrollLeft - c.x, u = a.top + i.scrollTop - c.y;
  return {
    x: l,
    y: u,
    width: a.width,
    height: a.height
  };
}
function bf(e, n) {
  return !Nn(e) || on(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function ch(e, n) {
  const t = Zt(e);
  if (!Nn(e) || sh(e))
    return t;
  let r = bf(e, n);
  for (; r && WS(r) && on(r).position === "static"; )
    r = bf(r, n);
  return r && (Cr(r) === "html" || Cr(r) === "body" && on(r).position === "static" && !bu(r)) ? t : r || ZS(e) || t;
}
const yE = async function(e) {
  const n = this.getOffsetParent || ch, t = this.getDimensions;
  return {
    reference: gE(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await t(e.floating)
    }
  };
};
function vE(e) {
  return on(e).direction === "rtl";
}
const lh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: cE,
  getDocumentElement: Qn,
  getClippingRect: hE,
  getOffsetParent: ch,
  getElementRects: yE,
  getClientRects: lE,
  getDimensions: mE,
  getScale: Po,
  isElement: $t,
  isRTL: vE
};
function bE(e, n) {
  let t = null, r;
  const o = Qn(e);
  function s() {
    var i;
    clearTimeout(r), (i = t) == null || i.disconnect(), t = null;
  }
  function a(i, c) {
    i === void 0 && (i = !1), c === void 0 && (c = 1), s();
    const {
      left: l,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (i || n(), !d || !f)
      return;
    const p = Ma(u), m = Ma(o.clientWidth - (l + d)), h = Ma(o.clientHeight - (u + f)), y = Ma(l), v = {
      rootMargin: -p + "px " + -m + "px " + -h + "px " + -y + "px",
      threshold: Ur(0, Yo(1, c)) || 1
    };
    let w = !0;
    function x(D) {
      const k = D[0].intersectionRatio;
      if (k !== c) {
        if (!w)
          return a();
        k ? a(!1, k) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, v);
    }
    t.observe(e);
  }
  return a(!0), s;
}
function uh(e, n, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Du(e), u = o || s ? [...l ? Ys(l) : [], ...Ys(n)] : [];
  u.forEach((C) => {
    o && C.addEventListener("scroll", t, {
      passive: !0
    }), s && C.addEventListener("resize", t);
  });
  const d = l && i ? bE(l, t) : null;
  let f = -1, p = null;
  a && (p = new ResizeObserver((C) => {
    let [v] = C;
    v && v.target === l && p && (p.unobserve(n), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(n);
    })), t();
  }), l && !c && p.observe(l), p.observe(n));
  let m, h = c ? eo(e) : null;
  c && y();
  function y() {
    const C = eo(e);
    h && (C.x !== h.x || C.y !== h.y || C.width !== h.width || C.height !== h.height) && t(), h = C, m = requestAnimationFrame(y);
  }
  return t(), () => {
    var C;
    u.forEach((v) => {
      o && v.removeEventListener("scroll", t), s && v.removeEventListener("resize", t);
    }), d == null || d(), (C = p) == null || C.disconnect(), p = null, c && cancelAnimationFrame(m);
  };
}
const CE = oE, dh = nE, n1 = tE, r1 = (e, n, t) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: lh,
    ...t
  }, s = {
    ...o.platform,
    _c: r
  };
  return eE(e, n, {
    ...o,
    platform: s
  });
}, wE = (e) => {
  function n(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(t) : e;
      return r && n(r) ? r.current != null ? n1({
        element: r.current,
        padding: o
      }).fn(t) : {} : r ? n1({
        element: r,
        padding: o
      }).fn(t) : {};
    }
  };
};
var Za = typeof document < "u" ? Wo : W;
function ki(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let t, r, o;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== n.length)
        return !1;
      for (r = t; r-- !== 0; )
        if (!ki(e[r], n[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), t = o.length, t !== Object.keys(n).length)
      return !1;
    for (r = t; r-- !== 0; )
      if (!{}.hasOwnProperty.call(n, o[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !ki(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function fh(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Cf(e, n) {
  const t = fh(e);
  return Math.round(n * t) / t;
}
function wf(e) {
  const n = b.useRef(e);
  return Za(() => {
    n.current = e;
  }), n;
}
function xE(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: t = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: i = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = b.useState(r);
  ki(f, r) || p(r);
  const [m, h] = b.useState(null), [y, C] = b.useState(null), v = b.useCallback((V) => {
    V !== k.current && (k.current = V, h(V));
  }, []), w = b.useCallback((V) => {
    V !== _.current && (_.current = V, C(V));
  }, []), x = s || m, D = a || y, k = b.useRef(null), _ = b.useRef(null), M = b.useRef(u), T = c != null, N = wf(c), I = wf(o), O = b.useCallback(() => {
    if (!k.current || !_.current)
      return;
    const V = {
      placement: n,
      strategy: t,
      middleware: f
    };
    I.current && (V.platform = I.current), r1(k.current, _.current, V).then((J) => {
      const Q = {
        ...J,
        isPositioned: !0
      };
      $.current && !ki(M.current, Q) && (M.current = Q, t5.flushSync(() => {
        d(Q);
      }));
    });
  }, [f, n, t, I]);
  Za(() => {
    l === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [l]);
  const $ = b.useRef(!1);
  Za(() => ($.current = !0, () => {
    $.current = !1;
  }), []), Za(() => {
    if (x && (k.current = x), D && (_.current = D), x && D) {
      if (N.current)
        return N.current(x, D, O);
      O();
    }
  }, [x, D, O, N, T]);
  const j = b.useMemo(() => ({
    reference: k,
    floating: _,
    setReference: v,
    setFloating: w
  }), [v, w]), Y = b.useMemo(() => ({
    reference: x,
    floating: D
  }), [x, D]), F = b.useMemo(() => {
    const V = {
      position: t,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return V;
    const J = Cf(Y.floating, u.x), Q = Cf(Y.floating, u.y);
    return i ? {
      ...V,
      transform: "translate(" + J + "px, " + Q + "px)",
      ...fh(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: J,
      top: Q
    };
  }, [t, i, Y.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: O,
    refs: j,
    elements: Y,
    floatingStyles: F
  }), [u, O, j, Y, F]);
}
const DE = b.useInsertionEffect, SE = DE || ((e) => e());
function EE(e) {
  const n = b.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return SE(() => {
    n.current = e;
  }), b.useCallback(function() {
    for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
      r[o] = arguments[o];
    return n.current == null ? void 0 : n.current(...r);
  }, []);
}
var ph = typeof document < "u" ? Wo : W;
function o1() {
  return o1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, o1.apply(this, arguments);
}
let Xc = !1, _E = 0;
const xf = () => "floating-ui-" + _E++;
function ME() {
  const [e, n] = b.useState(() => Xc ? xf() : void 0);
  return ph(() => {
    e == null && n(xf());
  }, []), b.useEffect(() => {
    Xc || (Xc = !0);
  }, []), e;
}
const kE = b.useId, hh = kE || ME, AE = /* @__PURE__ */ b.forwardRef(function(n, t) {
  let {
    context: {
      placement: r,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: s
      }
    },
    width: a = 14,
    height: i = 7,
    tipRadius: c = 0,
    strokeWidth: l = 0,
    staticOffset: u,
    stroke: d,
    d: f,
    style: {
      transform: p,
      ...m
    } = {},
    ...h
  } = n;
  process.env.NODE_ENV !== "production" && (t || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const y = hh();
  if (!o)
    return null;
  l *= 2;
  const C = l / 2, v = a / 2 * (c / -8 + 1), w = i / 2 * c / 4, [x, D] = r.split("-"), k = lh.isRTL(o), _ = !!f, M = x === "top" || x === "bottom", T = u && D === "end" ? "bottom" : "top";
  let N = u && D === "end" ? "right" : "left";
  u && k && (N = D === "end" ? "left" : "right");
  const I = (s == null ? void 0 : s.x) != null ? u || s.x : "", O = (s == null ? void 0 : s.y) != null ? u || s.y : "", $ = f || // biome-ignore lint/style/useTemplate: readability
  "M0,0" + (" H" + a) + (" L" + (a - v) + "," + (i - w)) + (" Q" + a / 2 + "," + i + " " + v + "," + (i - w)) + " Z", j = {
    top: _ ? "rotate(180deg)" : "",
    left: _ ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: _ ? "" : "rotate(180deg)",
    right: _ ? "rotate(-90deg)" : "rotate(90deg)"
  }[x];
  return /* @__PURE__ */ b.createElement("svg", o1({}, h, {
    "aria-hidden": !0,
    ref: t,
    width: _ ? a : a + l,
    height: a,
    viewBox: "0 0 " + a + " " + (i > a ? i : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [N]: I,
      [T]: O,
      [x]: M || _ ? "100%" : "calc(100% - " + l / 2 + "px)",
      transform: "" + j + (p ?? ""),
      ...m
    }
  }), l > 0 && /* @__PURE__ */ b.createElement("path", {
    clipPath: "url(#" + y + ")",
    fill: "none",
    stroke: d,
    strokeWidth: l + (f ? 0 : 1),
    d: $
  }), /* @__PURE__ */ b.createElement("path", {
    stroke: l && !f ? h.fill : "none",
    d: $
  }), /* @__PURE__ */ b.createElement("clipPath", {
    id: y
  }, /* @__PURE__ */ b.createElement("rect", {
    x: -C,
    y: C * (_ ? -1 : 1),
    width: a + l,
    height: a
  })));
});
function NE() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(n, t) {
      var r;
      (r = e.get(n)) == null || r.forEach((o) => o(t));
    },
    on(n, t) {
      e.set(n, [...e.get(n) || [], t]);
    },
    off(n, t) {
      var r;
      e.set(n, ((r = e.get(n)) == null ? void 0 : r.filter((o) => o !== t)) || []);
    }
  };
}
const LE = /* @__PURE__ */ b.createContext(null), TE = /* @__PURE__ */ b.createContext(null), PE = () => {
  var e;
  return ((e = b.useContext(LE)) == null ? void 0 : e.id) || null;
}, OE = () => b.useContext(TE);
let s1;
process.env.NODE_ENV !== "production" && (s1 = /* @__PURE__ */ new Set());
function RE(e) {
  var n;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: r,
    nodeId: o
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var s;
    const M = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((s = e.elements) != null && s.reference && !$t(e.elements.reference)) {
      var a;
      if (!((a = s1) != null && a.has(M))) {
        var i;
        (i = s1) == null || i.add(M), console.error(M);
      }
    }
  }
  const [c, l] = b.useState(null), u = ((n = e.elements) == null ? void 0 : n.reference) || c, d = xE(e), f = OE(), p = PE() != null, m = EE((M, T, N) => {
    M && (y.current.openEvent = T), C.emit("openchange", {
      open: M,
      event: T,
      reason: N,
      nested: p
    }), r == null || r(M, T, N);
  }), h = b.useRef(null), y = b.useRef({}), C = b.useState(() => NE())[0], v = hh(), w = b.useCallback((M) => {
    const T = $t(M) ? {
      getBoundingClientRect: () => M.getBoundingClientRect(),
      contextElement: M
    } : M;
    d.refs.setReference(T);
  }, [d.refs]), x = b.useCallback((M) => {
    ($t(M) || M === null) && (h.current = M, l(M)), ($t(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    M !== null && !$t(M)) && d.refs.setReference(M);
  }, [d.refs]), D = b.useMemo(() => ({
    ...d.refs,
    setReference: x,
    setPositionReference: w,
    domReference: h
  }), [d.refs, x, w]), k = b.useMemo(() => ({
    ...d.elements,
    domReference: u
  }), [d.elements, u]), _ = b.useMemo(() => ({
    ...d,
    refs: D,
    elements: k,
    dataRef: y,
    nodeId: o,
    floatingId: v,
    events: C,
    open: t,
    onOpenChange: m
  }), [d, o, v, C, t, m, D, k]);
  return ph(() => {
    const M = f == null ? void 0 : f.nodesRef.current.find((T) => T.id === o);
    M && (M.context = _);
  }), b.useMemo(() => ({
    ...d,
    context: _,
    refs: D,
    elements: k
  }), [d, D, k, _]);
}
function IE(e, n) {
  let t = ae(e);
  return isNaN(+t) ? Ye(e, NaN) : (n.year != null && t.setFullYear(n.year), n.month != null && (t = Tt(t, n.month)), n.date != null && t.setDate(n.date), n.hours != null && t.setHours(n.hours), n.minutes != null && t.setMinutes(n.minutes), n.seconds != null && t.setSeconds(n.seconds), n.milliseconds != null && t.setMilliseconds(n.milliseconds), t);
}
/*!
  react-datepicker v6.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
function Ct(e, n, t) {
  return n = Ai(n), $E(e, mh() ? Reflect.construct(n, t || [], Ai(e).constructor) : n.apply(e, t));
}
function mh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mh = function() {
    return !!e;
  })();
}
function Df(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function In(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Df(Object(t), !0).forEach(function(r) {
      S(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Df(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function FE(e, n) {
  if (typeof e != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function gh(e) {
  var n = FE(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
function a1(e) {
  "@babel/helpers - typeof";
  return a1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, a1(e);
}
function wt(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Sf(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, gh(r.key), r);
  }
}
function xt(e, n, t) {
  return n && Sf(e.prototype, n), t && Sf(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function S(e, n, t) {
  return n = gh(n), n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Hs() {
  return Hs = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Hs.apply(this, arguments);
}
function Dt(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && i1(e, n);
}
function Ai(e) {
  return Ai = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ai(e);
}
function i1(e, n) {
  return i1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, i1(e, n);
}
function VE(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $E(e, n) {
  if (n && (typeof n == "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return VE(e);
}
function xr(e) {
  return BE(e) || jE(e) || YE(e) || HE();
}
function BE(e) {
  if (Array.isArray(e))
    return c1(e);
}
function jE(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function YE(e, n) {
  if (e) {
    if (typeof e == "string")
      return c1(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return c1(e, n);
  }
}
function c1(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function HE() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var ia = 12, UE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ue(e) {
  var n = e ? typeof e == "string" || e instanceof String ? bS(e) : ae(e) : /* @__PURE__ */ new Date();
  return ir(n) ? n : null;
}
function WE(e, n, t, r, o) {
  var s = null, a = Zn(t) || Zn(Wr()), i = !0;
  return Array.isArray(n) ? (n.forEach(function(c) {
    var l = Gc(e, c, /* @__PURE__ */ new Date(), {
      locale: a,
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
    r && (i = ir(l, o) && e === Xe(l, c, t)), ir(l, o) && i && (s = l);
  }), s) : (s = Gc(e, n, /* @__PURE__ */ new Date(), {
    locale: a,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), r ? i = ir(s) && e === Xe(s, n, t) : ir(s) || (n = n.match(UE).map(function(c) {
    var l = c[0];
    if (l === "p" || l === "P") {
      var u = Ci[l];
      return a ? u(c, a.formatLong) : l;
    }
    return c;
  }).join(""), e.length > 0 && (s = Gc(e, n.slice(0, e.length), /* @__PURE__ */ new Date(), {
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  })), ir(s) || (s = new Date(e))), ir(s) && i ? s : null);
}
function ir(e, n) {
  return n = n || /* @__PURE__ */ new Date("1/1/1000"), Vo(e) && !Xr(e, n);
}
function Xe(e, n, t) {
  if (t === "en")
    return cf(e, n, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var r = Zn(t);
  return t && !r && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !r && Wr() && Zn(Wr()) && (r = Zn(Wr())), cf(e, n, {
    locale: r || null,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function tn(e, n) {
  var t = n.dateFormat, r = n.locale;
  return e && Xe(e, Array.isArray(t) ? t[0] : t, r) || "";
}
function ZE(e, n, t) {
  if (!e)
    return "";
  var r = tn(e, t), o = n ? tn(n, t) : "";
  return "".concat(r, " - ").concat(o);
}
function KE(e, n) {
  if (!(e != null && e.length))
    return "";
  var t = tn(e[0], n);
  if (e.length === 1)
    return t;
  if (e.length === 2) {
    var r = tn(e[1], n);
    return "".concat(t, ", ").concat(r);
  }
  var o = e.length - 1;
  return "".concat(t, " (+").concat(o, ")");
}
function Jc(e, n) {
  var t = n.hour, r = t === void 0 ? 0 : t, o = n.minute, s = o === void 0 ? 0 : o, a = n.second, i = a === void 0 ? 0 : a;
  return Wa(Ua(pD(e, i), s), r);
}
function zE(e, n) {
  return n && Zn(n) || Wr() && Zn(Wr()), mu(e);
}
function GE(e, n) {
  return Xe(e, "ddd", n);
}
function qE(e) {
  return En(e);
}
function mr(e, n, t) {
  var r = Zn(n || Wr());
  return qn(e, {
    locale: r,
    weekStartsOn: t
  });
}
function gr(e) {
  return W3(e);
}
function hs(e) {
  return hu(e);
}
function Ef(e) {
  return ql(e);
}
function _f() {
  return En(Ue());
}
function QE(e) {
  return mD(e);
}
function mn(e, n) {
  return e && n ? wD(e, n) : !e && !n;
}
function Wt(e, n) {
  return e && n ? CD(e, n) : !e && !n;
}
function Ni(e, n) {
  return e && n ? xD(e, n) : !e && !n;
}
function Ve(e, n) {
  return e && n ? bD(e, n) : !e && !n;
}
function Br(e, n) {
  return e && n ? vD(e, n) : !e && !n;
}
function ms(e, n, t) {
  var r, o = En(n), s = Ql(t);
  try {
    r = js(e, {
      start: o,
      end: s
    });
  } catch {
    r = !1;
  }
  return r;
}
function XE(e, n) {
  var t = typeof window < "u" ? window : globalThis;
  t.__localeData__ || (t.__localeData__ = {}), t.__localeData__[e] = n;
}
function Wr() {
  var e = typeof window < "u" ? window : globalThis;
  return e.__localeId__;
}
function Zn(e) {
  if (typeof e == "string") {
    var n = typeof window < "u" ? window : globalThis;
    return n.__localeData__ ? n.__localeData__[e] : null;
  } else
    return e;
}
function JE(e, n, t) {
  return n(Xe(e, "EEEE", t));
}
function e_(e, n) {
  return Xe(e, "EEEEEE", n);
}
function t_(e, n) {
  return Xe(e, "EEE", n);
}
function Su(e, n) {
  return Xe(Tt(Ue(), e), "LLLL", n);
}
function yh(e, n) {
  return Xe(Tt(Ue(), e), "LLL", n);
}
function n_(e, n) {
  return Xe(wo(Ue(), e), "QQQ", n);
}
function uc(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, o = n.excludeDates, s = n.excludeDateIntervals, a = n.includeDates, i = n.includeDateIntervals, c = n.filterDate;
  return dc(e, {
    minDate: t,
    maxDate: r
  }) || o && o.some(function(l) {
    return Ve(e, l.date ? l.date : l);
  }) || s && s.some(function(l) {
    var u = l.start, d = l.end;
    return js(e, {
      start: u,
      end: d
    });
  }) || a && !a.some(function(l) {
    return Ve(e, l);
  }) || i && !i.some(function(l) {
    var u = l.start, d = l.end;
    return js(e, {
      start: u,
      end: d
    });
  }) || c && !c(Ue(e)) || !1;
}
function Eu(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.excludeDates, r = n.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(o) {
    var s = o.start, a = o.end;
    return js(e, {
      start: s,
      end: a
    });
  }) : t && t.some(function(o) {
    return Ve(e, o.date ? o.date : o);
  }) || !1;
}
function Ka(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, o = n.excludeDates, s = n.includeDates, a = n.filterDate;
  return dc(e, {
    minDate: W3(t),
    maxDate: gD(r)
  }) || o && o.some(function(i) {
    return Wt(e, i);
  }) || s && !s.some(function(i) {
    return Wt(e, i);
  }) || a && !a(Ue(e)) || !1;
}
function ka(e, n, t, r) {
  var o = Le(e), s = Ot(e), a = Le(n), i = Ot(n), c = Le(r);
  if (o === a && o === c)
    return s <= t && t <= i;
  if (o < a)
    return c === o && s <= t || c === a && i >= t || c < a && c > o;
}
function el(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, o = n.excludeDates, s = n.includeDates, a = n.filterDate;
  return dc(e, {
    minDate: t,
    maxDate: r
  }) || o && o.some(function(i) {
    return Ni(e, i);
  }) || s && !s.some(function(i) {
    return Ni(e, i);
  }) || a && !a(Ue(e)) || !1;
}
function Aa(e, n, t) {
  if (!Vo(n) || !Vo(t))
    return !1;
  var r = Le(n), o = Le(t);
  return r <= e && o >= e;
}
function vh(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, o = n.excludeDates, s = n.includeDates, a = n.filterDate, i = new Date(e, 0, 1);
  return dc(i, {
    minDate: hu(t),
    maxDate: yD(r)
  }) || o && o.some(function(c) {
    return mn(i, c);
  }) || s && !s.some(function(c) {
    return mn(i, c);
  }) || a && !a(Ue(i)) || !1;
}
function Na(e, n, t, r) {
  var o = Le(e), s = Es(e), a = Le(n), i = Es(n), c = Le(r);
  if (o === a && o === c)
    return s <= t && t <= i;
  if (o < a)
    return c === o && s <= t || c === a && i >= t || c < a && c > o;
}
function dc(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate;
  return t && Bs(e, t) < 0 || r && Bs(e, r) > 0;
}
function Mf(e, n) {
  return n.some(function(t) {
    return Mn(t) === Mn(e) && _n(t) === _n(e);
  });
}
function kf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.excludeTimes, r = n.includeTimes, o = n.filterTime;
  return t && Mf(e, t) || r && !Mf(e, r) || o && !o(e) || !1;
}
function Af(e, n) {
  var t = n.minTime, r = n.maxTime;
  if (!t || !r)
    throw new Error("Both minTime and maxTime props required");
  var o = Ue(), s = Wa(Ua(o, _n(e)), Mn(e)), a = Wa(Ua(o, _n(t)), Mn(t)), i = Wa(Ua(o, _n(r)), Mn(r)), c;
  try {
    c = !js(s, {
      start: a,
      end: i
    });
  } catch {
    c = !1;
  }
  return c;
}
function Nf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.includeDates, o = Bo(e, 1);
  return t && xi(t, o) > 0 || r && r.every(function(s) {
    return xi(s, o) > 0;
  }) || !1;
}
function Lf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.includeDates, o = ln(e, 1);
  return t && xi(o, t) > 0 || r && r.every(function(s) {
    return xi(o, s) > 0;
  }) || !1;
}
function Tf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.includeDates, o = ra(e, 1);
  return t && Di(t, o) > 0 || r && r.every(function(s) {
    return Di(s, o) > 0;
  }) || !1;
}
function r_(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.yearItemNumber, o = r === void 0 ? ia : r, s = hs(ra(e, o)), a = Ho(s, o), i = a.endPeriod, c = t && Le(t);
  return c && c > i || !1;
}
function Pf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.includeDates, o = hr(e, 1);
  return t && Di(o, t) > 0 || r && r.every(function(s) {
    return Di(o, s) > 0;
  }) || !1;
}
function o_(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.yearItemNumber, o = r === void 0 ? ia : r, s = hr(e, o), a = Ho(s, o), i = a.startPeriod, c = t && Le(t);
  return c && c < i || !1;
}
function bh(e) {
  var n = e.minDate, t = e.includeDates;
  if (t && n) {
    var r = t.filter(function(o) {
      return Bs(o, n) >= 0;
    });
    return ff(r);
  } else
    return t ? ff(t) : n;
}
function Ch(e) {
  var n = e.maxDate, t = e.includeDates;
  if (t && n) {
    var r = t.filter(function(o) {
      return Bs(o, n) <= 0;
    });
    return pf(r);
  } else
    return t ? pf(t) : n;
}
function Of() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", t = /* @__PURE__ */ new Map(), r = 0, o = e.length; r < o; r++) {
    var s = e[r];
    if (Qr(s)) {
      var a = Xe(s, "MM.dd.yyyy"), i = t.get(a) || [];
      i.includes(n) || (i.push(n), t.set(a, i));
    } else if (a1(s) === "object") {
      var c = Object.keys(s), l = c[0], u = s[c[0]];
      if (typeof l == "string" && u.constructor === Array)
        for (var d = 0, f = u.length; d < f; d++) {
          var p = Xe(u[d], "MM.dd.yyyy"), m = t.get(p) || [];
          m.includes(l) || (m.push(l), t.set(p, m));
        }
    }
  }
  return t;
}
function s_(e, n) {
  return e.length !== n.length ? !1 : e.every(function(t, r) {
    return t === n[r];
  });
}
function a_() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", t = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    var o = r.date, s = r.holidayName;
    if (Qr(o)) {
      var a = Xe(o, "MM.dd.yyyy"), i = t.get(a) || {};
      if (!("className" in i && i.className === n && s_(i.holidayNames, [s]))) {
        i.className = n;
        var c = i.holidayNames;
        i.holidayNames = c ? [].concat(xr(c), [s]) : [s], t.set(a, i);
      }
    }
  }), t;
}
function i_(e, n, t, r, o) {
  for (var s = o.length, a = [], i = 0; i < s; i++) {
    var c = zl(lD(e, Mn(o[i])), _n(o[i])), l = zl(e, (t + 1) * r);
    br(c, n) && Xr(c, l) && a.push(o[i]);
  }
  return a;
}
function Rf(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Ho(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ia, t = Math.ceil(Le(e) / n) * n, r = t - (n - 1);
  return {
    startPeriod: r,
    endPeriod: t
  };
}
function c_(e) {
  var n = new Date(e.getFullYear(), e.getMonth(), e.getDate()), t = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
  return Math.round((+t - +n) / 36e5);
}
function If(e) {
  var n = e.getSeconds(), t = e.getMilliseconds();
  return ae(e.getTime() - n * 1e3 - t);
}
function l_(e, n) {
  return If(e).getTime() === If(n).getTime();
}
function Ff(e) {
  if (!Qr(e))
    throw new Error("Invalid date");
  var n = new Date(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Vf(e, n) {
  if (!Qr(e) || !Qr(n))
    throw new Error("Invalid date received");
  var t = Ff(e), r = Ff(n);
  return Xr(t, r);
}
function wh(e) {
  var n = " ";
  return e.key === n;
}
function u_(e, n, t, r) {
  for (var o = [], s = 0; s < 2 * n + 1; s++) {
    var a = e + n - s, i = !0;
    t && (i = Le(t) <= a), r && i && (i = Le(r) >= a), i && o.push(a);
  }
  return o;
}
var d_ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    wt(this, n), r = Ct(this, n, [t]), S(r, "renderOptions", function() {
      var i = r.props.year, c = r.state.yearsList.map(function(d) {
        return /* @__PURE__ */ A.createElement("div", {
          className: i === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
          key: d,
          onClick: r.onChange.bind(r, d),
          "aria-selected": i === d ? "true" : void 0
        }, i === d ? /* @__PURE__ */ A.createElement("span", {
          className: "react-datepicker__year-option--selected"
        }, "✓") : "", d);
      }), l = r.props.minDate ? Le(r.props.minDate) : null, u = r.props.maxDate ? Le(r.props.maxDate) : null;
      return (!u || !r.state.yearsList.find(function(d) {
        return d === u;
      })) && c.unshift(/* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__year-option",
        key: "upcoming",
        onClick: r.incrementYears
      }, /* @__PURE__ */ A.createElement("a", {
        className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
      }))), (!l || !r.state.yearsList.find(function(d) {
        return d === l;
      })) && c.push(/* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__year-option",
        key: "previous",
        onClick: r.decrementYears
      }, /* @__PURE__ */ A.createElement("a", {
        className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
      }))), c;
    }), S(r, "onChange", function(i) {
      r.props.onChange(i);
    }), S(r, "handleClickOutside", function() {
      r.props.onCancel();
    }), S(r, "shiftYears", function(i) {
      var c = r.state.yearsList.map(function(l) {
        return l + i;
      });
      r.setState({
        yearsList: c
      });
    }), S(r, "incrementYears", function() {
      return r.shiftYears(1);
    }), S(r, "decrementYears", function() {
      return r.shiftYears(-1);
    });
    var o = t.yearDropdownItemNumber, s = t.scrollableYearDropdown, a = o || (s ? 10 : 5);
    return r.state = {
      yearsList: u_(r.props.year, a, r.props.minDate, r.props.maxDate)
    }, r.dropdownRef = /* @__PURE__ */ Xh(), r;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      var r = this.dropdownRef.current;
      if (r) {
        var o = r.children ? Array.from(r.children) : null, s = o ? o.find(function(a) {
          return a.ariaSelected;
        }) : null;
        r.scrollTop = s ? s.offsetTop + (s.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
      }
    }
  }, {
    key: "render",
    value: function() {
      var r = vt({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /* @__PURE__ */ A.createElement("div", {
        className: r,
        ref: this.dropdownRef
      }, this.renderOptions());
    }
  }]);
}(A.Component), f_ = ac(d_), p_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "state", {
      dropdownVisible: !1
    }), S(t, "renderSelectOptions", function() {
      for (var a = t.props.minDate ? Le(t.props.minDate) : 1900, i = t.props.maxDate ? Le(t.props.maxDate) : 2100, c = [], l = a; l <= i; l++)
        c.push(/* @__PURE__ */ A.createElement("option", {
          key: l,
          value: l
        }, l));
      return c;
    }), S(t, "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), S(t, "renderSelectMode", function() {
      return /* @__PURE__ */ A.createElement("select", {
        value: t.props.year,
        className: "react-datepicker__year-select",
        onChange: t.onSelectChange
      }, t.renderSelectOptions());
    }), S(t, "renderReadView", function(a) {
      return /* @__PURE__ */ A.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__year-read-view",
        onClick: function(c) {
          return t.toggleDropdown(c);
        }
      }, /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__year-read-view--down-arrow"
      }), /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__year-read-view--selected-year"
      }, t.props.year));
    }), S(t, "renderDropdown", function() {
      return /* @__PURE__ */ A.createElement(f_, {
        key: "dropdown",
        year: t.props.year,
        onChange: t.onChange,
        onCancel: t.toggleDropdown,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        scrollableYearDropdown: t.props.scrollableYearDropdown,
        yearDropdownItemNumber: t.props.yearDropdownItemNumber
      });
    }), S(t, "renderScrollMode", function() {
      var a = t.state.dropdownVisible, i = [t.renderReadView(!a)];
      return a && i.unshift(t.renderDropdown()), i;
    }), S(t, "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.year && t.props.onChange(a);
    }), S(t, "toggleDropdown", function(a) {
      t.setState({
        dropdownVisible: !t.state.dropdownVisible
      }, function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, a);
      });
    }), S(t, "handleYearChange", function(a, i) {
      t.onSelect(a, i), t.setOpen();
    }), S(t, "onSelect", function(a, i) {
      t.props.onSelect && t.props.onSelect(a, i);
    }), S(t, "setOpen", function() {
      t.props.setOpen && t.props.setOpen(!0);
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
      }, r);
    }
  }]);
}(A.Component), h_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "isSelectedMonth", function(a) {
      return t.props.month === a;
    }), S(t, "renderOptions", function() {
      return t.props.monthNames.map(function(a, i) {
        return /* @__PURE__ */ A.createElement("div", {
          className: t.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
          key: a,
          onClick: t.onChange.bind(t, i),
          "aria-selected": t.isSelectedMonth(i) ? "true" : void 0
        }, t.isSelectedMonth(i) ? /* @__PURE__ */ A.createElement("span", {
          className: "react-datepicker__month-option--selected"
        }, "✓") : "", a);
      });
    }), S(t, "onChange", function(a) {
      return t.props.onChange(a);
    }), S(t, "handleClickOutside", function() {
      return t.props.onCancel();
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__month-dropdown"
      }, this.renderOptions());
    }
  }]);
}(A.Component), m_ = ac(h_), g_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "state", {
      dropdownVisible: !1
    }), S(t, "renderSelectOptions", function(a) {
      return a.map(function(i, c) {
        return /* @__PURE__ */ A.createElement("option", {
          key: c,
          value: c
        }, i);
      });
    }), S(t, "renderSelectMode", function(a) {
      return /* @__PURE__ */ A.createElement("select", {
        value: t.props.month,
        className: "react-datepicker__month-select",
        onChange: function(c) {
          return t.onChange(c.target.value);
        }
      }, t.renderSelectOptions(a));
    }), S(t, "renderReadView", function(a, i) {
      return /* @__PURE__ */ A.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__month-read-view",
        onClick: t.toggleDropdown
      }, /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__month-read-view--down-arrow"
      }), /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__month-read-view--selected-month"
      }, i[t.props.month]));
    }), S(t, "renderDropdown", function(a) {
      return /* @__PURE__ */ A.createElement(m_, {
        key: "dropdown",
        month: t.props.month,
        monthNames: a,
        onChange: t.onChange,
        onCancel: t.toggleDropdown
      });
    }), S(t, "renderScrollMode", function(a) {
      var i = t.state.dropdownVisible, c = [t.renderReadView(!i, a)];
      return i && c.unshift(t.renderDropdown(a)), c;
    }), S(t, "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.month && t.props.onChange(a);
    }), S(t, "toggleDropdown", function() {
      return t.setState({
        dropdownVisible: !t.state.dropdownVisible
      });
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(a) {
        return yh(a, r.props.locale);
      } : function(a) {
        return Su(a, r.props.locale);
      }), s;
      switch (this.props.dropdownMode) {
        case "scroll":
          s = this.renderScrollMode(o);
          break;
        case "select":
          s = this.renderSelectMode(o);
          break;
      }
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
      }, s);
    }
  }]);
}(A.Component);
function y_(e, n) {
  for (var t = [], r = gr(e), o = gr(n); !br(r, o); )
    t.push(Ue(r)), r = ln(r, 1);
  return t;
}
var v_ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "renderOptions", function() {
      return r.state.monthYearsList.map(function(o) {
        var s = Gl(o), a = mn(r.props.date, o) && Wt(r.props.date, o);
        return /* @__PURE__ */ A.createElement("div", {
          className: a ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
          key: s,
          onClick: r.onChange.bind(r, s),
          "aria-selected": a ? "true" : void 0
        }, a ? /* @__PURE__ */ A.createElement("span", {
          className: "react-datepicker__month-year-option--selected"
        }, "✓") : "", Xe(o, r.props.dateFormat, r.props.locale));
      });
    }), S(r, "onChange", function(o) {
      return r.props.onChange(o);
    }), S(r, "handleClickOutside", function() {
      r.props.onCancel();
    }), r.state = {
      monthYearsList: y_(r.props.minDate, r.props.maxDate)
    }, r;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r = vt({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /* @__PURE__ */ A.createElement("div", {
        className: r
      }, this.renderOptions());
    }
  }]);
}(A.Component), b_ = ac(v_), C_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "state", {
      dropdownVisible: !1
    }), S(t, "renderSelectOptions", function() {
      for (var a = gr(t.props.minDate), i = gr(t.props.maxDate), c = []; !br(a, i); ) {
        var l = Gl(a);
        c.push(/* @__PURE__ */ A.createElement("option", {
          key: l,
          value: l
        }, Xe(a, t.props.dateFormat, t.props.locale))), a = ln(a, 1);
      }
      return c;
    }), S(t, "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), S(t, "renderSelectMode", function() {
      return /* @__PURE__ */ A.createElement("select", {
        value: Gl(gr(t.props.date)),
        className: "react-datepicker__month-year-select",
        onChange: t.onSelectChange
      }, t.renderSelectOptions());
    }), S(t, "renderReadView", function(a) {
      var i = Xe(t.props.date, t.props.dateFormat, t.props.locale);
      return /* @__PURE__ */ A.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__month-year-read-view",
        onClick: function(l) {
          return t.toggleDropdown(l);
        }
      }, /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__month-year-read-view--down-arrow"
      }), /* @__PURE__ */ A.createElement("span", {
        className: "react-datepicker__month-year-read-view--selected-month-year"
      }, i));
    }), S(t, "renderDropdown", function() {
      return /* @__PURE__ */ A.createElement(b_, {
        key: "dropdown",
        date: t.props.date,
        dateFormat: t.props.dateFormat,
        onChange: t.onChange,
        onCancel: t.toggleDropdown,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown,
        locale: t.props.locale
      });
    }), S(t, "renderScrollMode", function() {
      var a = t.state.dropdownVisible, i = [t.renderReadView(!a)];
      return a && i.unshift(t.renderDropdown()), i;
    }), S(t, "onChange", function(a) {
      t.toggleDropdown();
      var i = Ue(parseInt(a));
      mn(t.props.date, i) && Wt(t.props.date, i) || t.props.onChange(i);
    }), S(t, "toggleDropdown", function() {
      return t.setState({
        dropdownVisible: !t.state.dropdownVisible
      });
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
      }, r);
    }
  }]);
}(A.Component), w_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "dayEl", /* @__PURE__ */ A.createRef()), S(t, "handleClick", function(a) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(a);
    }), S(t, "handleMouseEnter", function(a) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(a);
    }), S(t, "handleOnKeyDown", function(a) {
      var i = a.key;
      i === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), S(t, "isSameDay", function(a) {
      return Ve(t.props.day, a);
    }), S(t, "isKeyboardSelected", function() {
      var a;
      if (t.props.disabledKeyboardNavigation)
        return !1;
      var i = t.props.selectsMultiple ? (a = t.props.selectedDates) === null || a === void 0 ? void 0 : a.some(function(c) {
        return t.isSameDayOrWeek(c);
      }) : t.isSameDayOrWeek(t.props.selected);
      return !i && t.isSameDayOrWeek(t.props.preSelection);
    }), S(t, "isDisabled", function() {
      return uc(t.props.day, t.props);
    }), S(t, "isExcluded", function() {
      return Eu(t.props.day, t.props);
    }), S(t, "isStartOfWeek", function() {
      return Ve(t.props.day, mr(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), S(t, "isSameWeek", function(a) {
      return t.props.showWeekPicker && Ve(a, mr(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), S(t, "isSameDayOrWeek", function(a) {
      return t.isSameDay(a) || t.isSameWeek(a);
    }), S(t, "getHighLightedClass", function() {
      var a = t.props, i = a.day, c = a.highlightDates;
      if (!c)
        return !1;
      var l = Xe(i, "MM.dd.yyyy");
      return c.get(l);
    }), S(t, "getHolidaysClass", function() {
      var a = t.props, i = a.day, c = a.holidays;
      if (!c)
        return !1;
      var l = Xe(i, "MM.dd.yyyy");
      if (c.has(l))
        return [c.get(l).className];
    }), S(t, "isInRange", function() {
      var a = t.props, i = a.day, c = a.startDate, l = a.endDate;
      return !c || !l ? !1 : ms(i, c, l);
    }), S(t, "isInSelectingRange", function() {
      var a, i = t.props, c = i.day, l = i.selectsStart, u = i.selectsEnd, d = i.selectsRange, f = i.selectsDisabledDaysInRange, p = i.startDate, m = i.endDate, h = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return !(l || u || d) || !h || !f && t.isDisabled() ? !1 : l && m && (Xr(h, m) || Br(h, m)) ? ms(c, h, m) : u && p && (br(h, p) || Br(h, p)) || d && p && !m && (br(h, p) || Br(h, p)) ? ms(c, p, h) : !1;
    }), S(t, "isSelectingRangeStart", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var i = t.props, c = i.day, l = i.startDate, u = i.selectsStart, d = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return u ? Ve(c, d) : Ve(c, l);
    }), S(t, "isSelectingRangeEnd", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var i = t.props, c = i.day, l = i.endDate, u = i.selectsEnd, d = i.selectsRange, f = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return u || d ? Ve(c, f) : Ve(c, l);
    }), S(t, "isRangeStart", function() {
      var a = t.props, i = a.day, c = a.startDate, l = a.endDate;
      return !c || !l ? !1 : Ve(c, i);
    }), S(t, "isRangeEnd", function() {
      var a = t.props, i = a.day, c = a.startDate, l = a.endDate;
      return !c || !l ? !1 : Ve(l, i);
    }), S(t, "isWeekend", function() {
      var a = fD(t.props.day);
      return a === 0 || a === 6;
    }), S(t, "isAfterMonth", function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === Ot(t.props.day);
    }), S(t, "isBeforeMonth", function() {
      return t.props.month !== void 0 && (Ot(t.props.day) + 1) % 12 === t.props.month;
    }), S(t, "isCurrentDay", function() {
      return t.isSameDay(Ue());
    }), S(t, "isSelected", function() {
      if (t.props.selectsMultiple) {
        var a;
        return (a = t.props.selectedDates) === null || a === void 0 ? void 0 : a.some(function(i) {
          return t.isSameDayOrWeek(i);
        });
      }
      return t.isSameDayOrWeek(t.props.selected);
    }), S(t, "getClassNames", function(a) {
      var i = t.props.dayClassName ? t.props.dayClassName(a) : void 0;
      return vt("react-datepicker__day", i, "react-datepicker__day--" + GE(t.props.day), {
        "react-datepicker__day--disabled": t.isDisabled(),
        "react-datepicker__day--excluded": t.isExcluded(),
        "react-datepicker__day--selected": t.isSelected(),
        "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
        "react-datepicker__day--range-start": t.isRangeStart(),
        "react-datepicker__day--range-end": t.isRangeEnd(),
        "react-datepicker__day--in-range": t.isInRange(),
        "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
        "react-datepicker__day--today": t.isCurrentDay(),
        "react-datepicker__day--weekend": t.isWeekend(),
        "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
      }, t.getHighLightedClass("react-datepicker__day--highlighted"), t.getHolidaysClass());
    }), S(t, "getAriaLabel", function() {
      var a = t.props, i = a.day, c = a.ariaLabelPrefixWhenEnabled, l = c === void 0 ? "Choose" : c, u = a.ariaLabelPrefixWhenDisabled, d = u === void 0 ? "Not available" : u, f = t.isDisabled() || t.isExcluded() ? d : l;
      return "".concat(f, " ").concat(Xe(i, "PPPP", t.props.locale));
    }), S(t, "getTitle", function() {
      var a = t.props, i = a.day, c = a.holidays, l = c === void 0 ? /* @__PURE__ */ new Map() : c, u = a.excludeDates, d = Xe(i, "MM.dd.yyyy"), f = [];
      return l.has(d) && f.push.apply(f, xr(l.get(d).holidayNames)), t.isExcluded() && f.push(u == null ? void 0 : u.filter(function(p) {
        return Ve(p.date ? p.date : p, i);
      }).map(function(p) {
        return p.message;
      })), f.join(", ");
    }), S(t, "getTabIndex", function(a, i) {
      var c = a || t.props.selected, l = i || t.props.preSelection, u = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(c) && Ve(l, c)) ? 0 : -1;
      return u;
    }), S(t, "handleFocusDay", function() {
      var a, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      t.getTabIndex() === 0 && !i.isInputFocused && t.isSameDay(t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (c = !0), t.props.inline && !t.props.shouldFocusDayInline && (c = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (c = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (c = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (c = !1)), c && ((a = t.dayEl.current) === null || a === void 0 || a.focus({
        preventScroll: !0
      }));
    }), S(t, "renderDayContents", function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(df(t.props.day), t.props.day) : df(t.props.day);
    }), S(t, "render", function() {
      return /* @__PURE__ */ A.createElement("div", {
        ref: t.dayEl,
        className: t.getClassNames(t.props.day),
        onKeyDown: t.handleOnKeyDown,
        onClick: t.handleClick,
        onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter,
        onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0,
        tabIndex: t.getTabIndex(),
        "aria-label": t.getAriaLabel(),
        role: "option",
        title: t.getTitle(),
        "aria-disabled": t.isDisabled(),
        "aria-current": t.isCurrentDay() ? "date" : void 0,
        "aria-selected": t.isSelected() || t.isInRange()
      }, t.renderDayContents(), t.getTitle() !== "" && /* @__PURE__ */ A.createElement("span", {
        className: "overlay"
      }, t.getTitle()));
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.handleFocusDay(r);
    }
  }]);
}(A.Component), x_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "weekNumberEl", /* @__PURE__ */ A.createRef()), S(t, "handleClick", function(a) {
      t.props.onClick && t.props.onClick(a);
    }), S(t, "handleOnKeyDown", function(a) {
      var i = a.key;
      i === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), S(t, "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ve(t.props.date, t.props.selected) && Ve(t.props.date, t.props.preSelection);
    }), S(t, "getTabIndex", function() {
      return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Ve(t.props.date, t.props.selected) && Ve(t.props.preSelection, t.props.selected)) ? 0 : -1;
    }), S(t, "handleFocusWeekNumber", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = !1;
      t.getTabIndex() === 0 && !a.isInputFocused && Ve(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (i = !0), t.props.inline && !t.props.shouldFocusDayInline && (i = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (i = !0)), i && t.weekNumberEl.current && t.weekNumberEl.current.focus({
        preventScroll: !0
      });
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusWeekNumber();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.handleFocusWeekNumber(r);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.weekNumber, s = r.ariaLabelPrefix, a = s === void 0 ? "week " : s, i = r.onClick, c = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!i,
        "react-datepicker__week-number--selected": !!i && Ve(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ A.createElement("div", {
        ref: this.weekNumberEl,
        className: vt(c),
        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex()
      }, o);
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        ariaLabelPrefix: "week "
      };
    }
  }]);
}(A.Component), D_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "handleDayClick", function(a, i) {
      t.props.onDayClick && t.props.onDayClick(a, i);
    }), S(t, "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), S(t, "handleWeekClick", function(a, i, c) {
      typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(a, i, c), t.props.showWeekPicker && t.handleDayClick(a, c), t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    }), S(t, "formatWeekNumber", function(a) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(a) : zE(a);
    }), S(t, "renderDays", function() {
      var a = t.startOfWeek(), i = [], c = t.formatWeekNumber(a);
      if (t.props.showWeekNumber) {
        var l = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, a, c) : void 0;
        i.push(/* @__PURE__ */ A.createElement(x_, {
          key: "W",
          weekNumber: c,
          date: a,
          onClick: l,
          selected: t.props.selected,
          preSelection: t.props.preSelection,
          ariaLabelPrefix: t.props.ariaLabelPrefix,
          showWeekPicker: t.props.showWeekPicker,
          showWeekNumber: t.props.showWeekNumber,
          disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
          handleOnKeyDown: t.props.handleOnKeyDown,
          isInputFocused: t.props.isInputFocused,
          containerRef: t.props.containerRef
        }));
      }
      return i.concat([0, 1, 2, 3, 4, 5, 6].map(function(u) {
        var d = Mr(a, u);
        return /* @__PURE__ */ A.createElement(w_, {
          ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
          ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
          key: d.valueOf(),
          day: d,
          month: t.props.month,
          onClick: t.handleDayClick.bind(t, d),
          usePointerEvent: t.props.usePointerEvent,
          onMouseEnter: t.handleDayMouseEnter.bind(t, d),
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          calendarStartDay: t.props.calendarStartDay,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDates: t.props.includeDates,
          includeDateIntervals: t.props.includeDateIntervals,
          highlightDates: t.props.highlightDates,
          holidays: t.props.holidays,
          selectingDate: t.props.selectingDate,
          filterDate: t.props.filterDate,
          preSelection: t.props.preSelection,
          selected: t.props.selected,
          selectsStart: t.props.selectsStart,
          selectsEnd: t.props.selectsEnd,
          selectsRange: t.props.selectsRange,
          showWeekPicker: t.props.showWeekPicker,
          showWeekNumber: t.props.showWeekNumber,
          selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange,
          selectsMultiple: t.props.selectsMultiple,
          selectedDates: t.props.selectedDates,
          startDate: t.props.startDate,
          endDate: t.props.endDate,
          dayClassName: t.props.dayClassName,
          renderDayContents: t.props.renderDayContents,
          disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
          handleOnKeyDown: t.props.handleOnKeyDown,
          isInputFocused: t.props.isInputFocused,
          containerRef: t.props.containerRef,
          inline: t.props.inline,
          shouldFocusDayInline: t.props.shouldFocusDayInline,
          monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart,
          locale: t.props.locale
        });
      }));
    }), S(t, "startOfWeek", function() {
      return mr(t.props.day, t.props.locale, t.props.calendarStartDay);
    }), S(t, "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ve(t.startOfWeek(), t.props.selected) && Ve(t.startOfWeek(), t.props.preSelection);
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": Ve(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ A.createElement("div", {
        className: vt(r)
      }, this.renderDays());
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        shouldCloseOnSelect: !0
      };
    }
  }]);
}(A.Component), S_ = 6, Oo = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, tl = S(S(S({}, Oo.TWO_COLUMNS, {
  grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
  verticalNavigationOffset: 2
}), Oo.THREE_COLUMNS, {
  grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
  verticalNavigationOffset: 3
}), Oo.FOUR_COLUMNS, {
  grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
  verticalNavigationOffset: 4
}), La = 1;
function $f(e, n) {
  return e ? Oo.FOUR_COLUMNS : n ? Oo.TWO_COLUMNS : Oo.THREE_COLUMNS;
}
var E_ = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "MONTH_REFS", xr(Array(12)).map(function() {
      return /* @__PURE__ */ A.createRef();
    })), S(t, "QUARTER_REFS", xr(Array(4)).map(function() {
      return /* @__PURE__ */ A.createRef();
    })), S(t, "isDisabled", function(a) {
      return uc(a, t.props);
    }), S(t, "isExcluded", function(a) {
      return Eu(a, t.props);
    }), S(t, "handleDayClick", function(a, i) {
      t.props.onDayClick && t.props.onDayClick(a, i, t.props.orderInDisplay);
    }), S(t, "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), S(t, "handleMouseLeave", function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    }), S(t, "isRangeStartMonth", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate;
      return !l || !u ? !1 : Wt(Tt(c, a), l);
    }), S(t, "isRangeStartQuarter", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate;
      return !l || !u ? !1 : Ni(wo(c, a), l);
    }), S(t, "isRangeEndMonth", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate;
      return !l || !u ? !1 : Wt(Tt(c, a), u);
    }), S(t, "isRangeEndQuarter", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate;
      return !l || !u ? !1 : Ni(wo(c, a), u);
    }), S(t, "isInSelectingRangeMonth", function(a) {
      var i, c = t.props, l = c.day, u = c.selectsStart, d = c.selectsEnd, f = c.selectsRange, p = c.startDate, m = c.endDate, h = (i = t.props.selectingDate) !== null && i !== void 0 ? i : t.props.preSelection;
      return !(u || d || f) || !h ? !1 : u && m ? ka(h, m, a, l) : d && p || f && p && !m ? ka(p, h, a, l) : !1;
    }), S(t, "isSelectingMonthRangeStart", function(a) {
      var i;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var c = t.props, l = c.day, u = c.startDate, d = c.selectsStart, f = Tt(l, a), p = (i = t.props.selectingDate) !== null && i !== void 0 ? i : t.props.preSelection;
      return d ? Wt(f, p) : Wt(f, u);
    }), S(t, "isSelectingMonthRangeEnd", function(a) {
      var i;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var c = t.props, l = c.day, u = c.endDate, d = c.selectsEnd, f = c.selectsRange, p = Tt(l, a), m = (i = t.props.selectingDate) !== null && i !== void 0 ? i : t.props.preSelection;
      return d || f ? Wt(p, m) : Wt(p, u);
    }), S(t, "isInSelectingRangeQuarter", function(a) {
      var i, c = t.props, l = c.day, u = c.selectsStart, d = c.selectsEnd, f = c.selectsRange, p = c.startDate, m = c.endDate, h = (i = t.props.selectingDate) !== null && i !== void 0 ? i : t.props.preSelection;
      return !(u || d || f) || !h ? !1 : u && m ? Na(h, m, a, l) : d && p || f && p && !m ? Na(p, h, a, l) : !1;
    }), S(t, "isWeekInMonth", function(a) {
      var i = t.props.day, c = Mr(a, 6);
      return Wt(a, i) || Wt(c, i);
    }), S(t, "isCurrentMonth", function(a, i) {
      return Le(a) === Le(Ue()) && i === Ot(Ue());
    }), S(t, "isCurrentQuarter", function(a, i) {
      return Le(a) === Le(Ue()) && i === Es(Ue());
    }), S(t, "isSelectedMonth", function(a, i, c) {
      return Ot(c) === i && Le(a) === Le(c);
    }), S(t, "isSelectedQuarter", function(a, i, c) {
      return Es(a) === i && Le(a) === Le(c);
    }), S(t, "renderWeeks", function() {
      for (var a = [], i = t.props.fixedHeight, c = 0, l = !1, u = mr(gr(t.props.day), t.props.locale, t.props.calendarStartDay), d = t.props.showWeekPicker ? mr(t.props.selected, t.props.locale, t.props.calendarStartDay) : t.props.selected, f = t.props.showWeekPicker ? mr(t.props.preSelection, t.props.locale, t.props.calendarStartDay) : t.props.preSelection; a.push(/* @__PURE__ */ A.createElement(D_, {
        ariaLabelPrefix: t.props.weekAriaLabelPrefix,
        chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix,
        key: c,
        day: u,
        month: Ot(t.props.day),
        onDayClick: t.handleDayClick,
        usePointerEvent: t.props.usePointerEvent,
        onDayMouseEnter: t.handleDayMouseEnter,
        onWeekSelect: t.props.onWeekSelect,
        formatWeekNumber: t.props.formatWeekNumber,
        locale: t.props.locale,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        excludeDates: t.props.excludeDates,
        excludeDateIntervals: t.props.excludeDateIntervals,
        includeDates: t.props.includeDates,
        includeDateIntervals: t.props.includeDateIntervals,
        inline: t.props.inline,
        shouldFocusDayInline: t.props.shouldFocusDayInline,
        highlightDates: t.props.highlightDates,
        holidays: t.props.holidays,
        selectingDate: t.props.selectingDate,
        filterDate: t.props.filterDate,
        preSelection: f,
        selected: d,
        selectsStart: t.props.selectsStart,
        selectsEnd: t.props.selectsEnd,
        selectsRange: t.props.selectsRange,
        selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange,
        selectsMultiple: t.props.selectsMultiple,
        selectedDates: t.props.selectedDates,
        showWeekNumber: t.props.showWeekNumbers,
        showWeekPicker: t.props.showWeekPicker,
        startDate: t.props.startDate,
        endDate: t.props.endDate,
        dayClassName: t.props.dayClassName,
        setOpen: t.props.setOpen,
        shouldCloseOnSelect: t.props.shouldCloseOnSelect,
        disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
        renderDayContents: t.props.renderDayContents,
        handleOnKeyDown: t.props.handleOnKeyDown,
        isInputFocused: t.props.isInputFocused,
        containerRef: t.props.containerRef,
        calendarStartDay: t.props.calendarStartDay,
        monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd,
        monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart
      })), !l; ) {
        c++, u = wi(u, 1);
        var p = i && c >= S_, m = !i && !t.isWeekInMonth(u);
        if (p || m)
          if (t.props.peekNextMonth)
            l = !0;
          else
            break;
      }
      return a;
    }), S(t, "onMonthClick", function(a, i) {
      var c = Tt(t.props.day, i);
      Ka(c, t.props) || t.handleDayClick(gr(c), a);
    }), S(t, "onMonthMouseEnter", function(a) {
      var i = Tt(t.props.day, a);
      Ka(i, t.props) || t.handleDayMouseEnter(gr(i));
    }), S(t, "handleMonthNavigation", function(a, i) {
      t.isDisabled(i) || t.isExcluded(i) || (t.props.setPreSelection(i), t.MONTH_REFS[a].current && t.MONTH_REFS[a].current.focus());
    }), S(t, "onMonthKeyDown", function(a, i) {
      var c = t.props, l = c.selected, u = c.preSelection, d = c.disabledKeyboardNavigation, f = c.showTwoColumnMonthYearPicker, p = c.showFourColumnMonthYearPicker, m = c.setPreSelection, h = c.handleOnMonthKeyDown, y = a.key;
      if (y !== "Tab" && a.preventDefault(), !d) {
        var C = $f(p, f), v = tl[C].verticalNavigationOffset, w = tl[C].grid;
        switch (y) {
          case "Enter":
            t.onMonthClick(a, i), m(l);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(i === 11 ? 0 : i + La, ln(u, La));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(i === 0 ? 11 : i - La, Bo(u, La));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(
              // Check if month on the first row
              w[0].includes(i) ? i + 12 - v : i - v,
              Bo(u, v)
            );
            break;
          case "ArrowDown":
            t.handleMonthNavigation(
              // Check if month on the last row
              w[w.length - 1].includes(i) ? i - 12 + v : i + v,
              ln(u, v)
            );
            break;
        }
      }
      h && h(a);
    }), S(t, "onQuarterClick", function(a, i) {
      var c = wo(t.props.day, i);
      el(c, t.props) || t.handleDayClick(Ef(c), a);
    }), S(t, "onQuarterMouseEnter", function(a) {
      var i = wo(t.props.day, a);
      el(i, t.props) || t.handleDayMouseEnter(Ef(i));
    }), S(t, "handleQuarterNavigation", function(a, i) {
      t.isDisabled(i) || t.isExcluded(i) || (t.props.setPreSelection(i), t.QUARTER_REFS[a - 1].current && t.QUARTER_REFS[a - 1].current.focus());
    }), S(t, "onQuarterKeyDown", function(a, i) {
      var c = a.key;
      if (!t.props.disabledKeyboardNavigation)
        switch (c) {
          case "Enter":
            t.onQuarterClick(a, i), t.props.setPreSelection(t.props.selected);
            break;
          case "ArrowRight":
            t.handleQuarterNavigation(i === 4 ? 1 : i + 1, U3(t.props.preSelection, 1));
            break;
          case "ArrowLeft":
            t.handleQuarterNavigation(i === 1 ? 4 : i - 1, dD(t.props.preSelection, 1));
            break;
        }
    }), S(t, "getMonthClassNames", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate, d = i.selected, f = i.minDate, p = i.maxDate, m = i.preSelection, h = i.monthClassName, y = i.excludeDates, C = i.includeDates, v = h ? h(Tt(c, a)) : void 0, w = Tt(c, a);
      return vt("react-datepicker__month-text", "react-datepicker__month-".concat(a), v, {
        "react-datepicker__month-text--disabled": (f || p || y || C) && Ka(w, t.props),
        "react-datepicker__month-text--selected": t.isSelectedMonth(c, a, d),
        "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && t.isSelectedMonth(c, a, m),
        "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(a),
        "react-datepicker__month-text--in-range": ka(l, u, a, c),
        "react-datepicker__month-text--range-start": t.isRangeStartMonth(a),
        "react-datepicker__month-text--range-end": t.isRangeEndMonth(a),
        "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(a),
        "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(a),
        "react-datepicker__month-text--today": t.isCurrentMonth(c, a)
      });
    }), S(t, "getTabIndex", function(a) {
      var i = Ot(t.props.preSelection), c = !t.props.disabledKeyboardNavigation && a === i ? "0" : "-1";
      return c;
    }), S(t, "getQuarterTabIndex", function(a) {
      var i = Es(t.props.preSelection), c = !t.props.disabledKeyboardNavigation && a === i ? "0" : "-1";
      return c;
    }), S(t, "getAriaLabel", function(a) {
      var i = t.props, c = i.chooseDayAriaLabelPrefix, l = c === void 0 ? "Choose" : c, u = i.disabledDayAriaLabelPrefix, d = u === void 0 ? "Not available" : u, f = i.day, p = Tt(f, a), m = t.isDisabled(p) || t.isExcluded(p) ? d : l;
      return "".concat(m, " ").concat(Xe(p, "MMMM yyyy"));
    }), S(t, "getQuarterClassNames", function(a) {
      var i = t.props, c = i.day, l = i.startDate, u = i.endDate, d = i.selected, f = i.minDate, p = i.maxDate, m = i.preSelection, h = i.disabledKeyboardNavigation;
      return vt("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(a), {
        "react-datepicker__quarter-text--disabled": (f || p) && el(wo(c, a), t.props),
        "react-datepicker__quarter-text--selected": t.isSelectedQuarter(c, a, d),
        "react-datepicker__quarter-text--keyboard-selected": !h && t.isSelectedQuarter(c, a, m),
        "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(a),
        "react-datepicker__quarter-text--in-range": Na(l, u, a, c),
        "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(a),
        "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(a)
      });
    }), S(t, "getMonthContent", function(a) {
      var i = t.props, c = i.showFullMonthYearPicker, l = i.renderMonthContent, u = i.locale, d = i.day, f = yh(a, u), p = Su(a, u);
      return l ? l(a, f, p, d) : c ? p : f;
    }), S(t, "getQuarterContent", function(a) {
      var i = t.props, c = i.renderQuarterContent, l = i.locale, u = n_(a, l);
      return c ? c(a, u) : u;
    }), S(t, "renderMonths", function() {
      var a = t.props, i = a.showTwoColumnMonthYearPicker, c = a.showFourColumnMonthYearPicker, l = a.day, u = a.selected, d = tl[$f(c, i)].grid;
      return d.map(function(f, p) {
        return /* @__PURE__ */ A.createElement("div", {
          className: "react-datepicker__month-wrapper",
          key: p
        }, f.map(function(m, h) {
          return /* @__PURE__ */ A.createElement("div", {
            ref: t.MONTH_REFS[m],
            key: h,
            onClick: function(C) {
              t.onMonthClick(C, m);
            },
            onKeyDown: function(C) {
              wh(C) && (C.preventDefault(), C.key = "Enter"), t.onMonthKeyDown(C, m);
            },
            onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(m);
            },
            onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(m);
            } : void 0,
            tabIndex: t.getTabIndex(m),
            className: t.getMonthClassNames(m),
            role: "option",
            "aria-label": t.getAriaLabel(m),
            "aria-current": t.isCurrentMonth(l, m) ? "date" : void 0,
            "aria-selected": t.isSelectedMonth(l, m, u)
          }, t.getMonthContent(m));
        }));
      });
    }), S(t, "renderQuarters", function() {
      var a = t.props, i = a.day, c = a.selected, l = [1, 2, 3, 4];
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__quarter-wrapper"
      }, l.map(function(u, d) {
        return /* @__PURE__ */ A.createElement("div", {
          key: d,
          ref: t.QUARTER_REFS[d],
          role: "option",
          onClick: function(p) {
            t.onQuarterClick(p, u);
          },
          onKeyDown: function(p) {
            t.onQuarterKeyDown(p, u);
          },
          onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(u);
          },
          onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(u);
          } : void 0,
          className: t.getQuarterClassNames(u),
          "aria-selected": t.isSelectedQuarter(i, u, c),
          tabIndex: t.getQuarterTabIndex(u),
          "aria-current": t.isCurrentQuarter(i, u) ? "date" : void 0
        }, t.getQuarterContent(u));
      }));
    }), S(t, "getClassNames", function() {
      var a = t.props, i = a.selectingDate, c = a.selectsStart, l = a.selectsEnd, u = a.showMonthYearPicker, d = a.showQuarterYearPicker, f = a.showWeekPicker;
      return vt("react-datepicker__month", {
        "react-datepicker__month--selecting-range": i && (c || l)
      }, {
        "react-datepicker__monthPicker": u
      }, {
        "react-datepicker__quarterPicker": d
      }, {
        "react-datepicker__weekPicker": f
      });
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.showMonthYearPicker, s = r.showQuarterYearPicker, a = r.day, i = r.ariaLabelPrefix, c = i === void 0 ? "Month " : i, l = c ? c.trim() + " " : "";
      return /* @__PURE__ */ A.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
        "aria-label": "".concat(l).concat(Xe(a, "MMMM, yyyy")),
        role: "listbox"
      }, o ? this.renderMonths() : s ? this.renderQuarters() : this.renderWeeks());
    }
  }]);
}(A.Component), xh = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    wt(this, n);
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return t = Ct(this, n, [].concat(o)), S(t, "state", {
      height: null
    }), S(t, "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        t.list && (t.list.scrollTop = t.centerLi && n.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - t.header.clientHeight : t.list.clientHeight, t.centerLi));
      });
    }), S(t, "handleClick", function(a) {
      (t.props.minTime || t.props.maxTime) && Af(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && kf(a, t.props) || t.props.onChange(a);
    }), S(t, "isSelectedTime", function(a) {
      return t.props.selected && l_(t.props.selected, a);
    }), S(t, "isDisabledTime", function(a) {
      return (t.props.minTime || t.props.maxTime) && Af(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && kf(a, t.props);
    }), S(t, "liClasses", function(a) {
      var i = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(a) : void 0];
      return t.isSelectedTime(a) && i.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(a) && i.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (Mn(a) * 60 + _n(a)) % t.props.intervals !== 0 && i.push("react-datepicker__time-list-item--injected"), i.join(" ");
    }), S(t, "handleOnKeyDown", function(a, i) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), (a.key === "ArrowUp" || a.key === "ArrowLeft") && a.target.previousSibling && (a.preventDefault(), a.target.previousSibling.focus()), (a.key === "ArrowDown" || a.key === "ArrowRight") && a.target.nextSibling && (a.preventDefault(), a.target.nextSibling.focus()), a.key === "Enter" && t.handleClick(i), t.props.handleOnKeyDown(a);
    }), S(t, "renderTimes", function() {
      for (var a = [], i = t.props.format ? t.props.format : "p", c = t.props.intervals, l = t.props.selected || t.props.openToDate || Ue(), u = qE(l), d = t.props.injectTimes && t.props.injectTimes.sort(function(v, w) {
        return v - w;
      }), f = 60 * c_(l), p = f / c, m = 0; m < p; m++) {
        var h = zl(u, m * c);
        if (a.push(h), d) {
          var y = i_(u, h, m, c, d);
          a = a.concat(y);
        }
      }
      var C = a.reduce(function(v, w) {
        return w.getTime() <= l.getTime() ? w : v;
      }, a[0]);
      return a.map(function(v, w) {
        return /* @__PURE__ */ A.createElement("li", {
          key: w,
          onClick: t.handleClick.bind(t, v),
          className: t.liClasses(v),
          ref: function(D) {
            v === C && (t.centerLi = D);
          },
          onKeyDown: function(D) {
            t.handleOnKeyDown(D, v);
          },
          tabIndex: v === C ? 0 : -1,
          role: "option",
          "aria-selected": t.isSelectedTime(v) ? "true" : void 0,
          "aria-disabled": t.isDisabledTime(v) ? "true" : void 0
        }, Xe(v, i, t.props.locale));
      });
    }), t;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.state.height;
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
        ref: function(a) {
          r.header = a;
        }
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker-time__header"
      }, this.props.timeCaption)), /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__time"
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__time-box"
      }, /* @__PURE__ */ A.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function(a) {
          r.list = a;
        },
        style: o ? {
          height: o
        } : {},
        role: "listbox",
        "aria-label": this.props.timeCaption
      }, this.renderTimes()))));
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        intervals: 30,
        onTimeChange: function() {
        },
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
}(A.Component);
S(xh, "calcCenterPosition", function(e, n) {
  return n.offsetTop - (e / 2 - n.clientHeight / 2);
});
var __ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "YEAR_REFS", xr(Array(r.props.yearItemNumber)).map(function() {
      return /* @__PURE__ */ A.createRef();
    })), S(r, "isDisabled", function(o) {
      return uc(o, r.props);
    }), S(r, "isExcluded", function(o) {
      return Eu(o, r.props);
    }), S(r, "selectingDate", function() {
      var o;
      return (o = r.props.selectingDate) !== null && o !== void 0 ? o : r.props.preSelection;
    }), S(r, "updateFocusOnPaginate", function(o) {
      var s = (function() {
        this.YEAR_REFS[o].current.focus();
      }).bind(r);
      window.requestAnimationFrame(s);
    }), S(r, "handleYearClick", function(o, s) {
      r.props.onDayClick && r.props.onDayClick(o, s);
    }), S(r, "handleYearNavigation", function(o, s) {
      var a = r.props, i = a.date, c = a.yearItemNumber, l = Ho(i, c), u = l.startPeriod;
      r.isDisabled(s) || r.isExcluded(s) || (r.props.setPreSelection(s), o - u === -1 ? r.updateFocusOnPaginate(c - 1) : o - u === c ? r.updateFocusOnPaginate(0) : r.YEAR_REFS[o - u].current.focus());
    }), S(r, "isSameDay", function(o, s) {
      return Ve(o, s);
    }), S(r, "isCurrentYear", function(o) {
      return o === Le(Ue());
    }), S(r, "isRangeStart", function(o) {
      return r.props.startDate && r.props.endDate && mn(hn(Ue(), o), r.props.startDate);
    }), S(r, "isRangeEnd", function(o) {
      return r.props.startDate && r.props.endDate && mn(hn(Ue(), o), r.props.endDate);
    }), S(r, "isInRange", function(o) {
      return Aa(o, r.props.startDate, r.props.endDate);
    }), S(r, "isInSelectingRange", function(o) {
      var s = r.props, a = s.selectsStart, i = s.selectsEnd, c = s.selectsRange, l = s.startDate, u = s.endDate;
      return !(a || i || c) || !r.selectingDate() ? !1 : a && u ? Aa(o, r.selectingDate(), u) : i && l || c && l && !u ? Aa(o, l, r.selectingDate()) : !1;
    }), S(r, "isSelectingRangeStart", function(o) {
      if (!r.isInSelectingRange(o))
        return !1;
      var s = r.props, a = s.startDate, i = s.selectsStart, c = hn(Ue(), o);
      return i ? mn(c, r.selectingDate()) : mn(c, a);
    }), S(r, "isSelectingRangeEnd", function(o) {
      if (!r.isInSelectingRange(o))
        return !1;
      var s = r.props, a = s.endDate, i = s.selectsEnd, c = s.selectsRange, l = hn(Ue(), o);
      return i || c ? mn(l, r.selectingDate()) : mn(l, a);
    }), S(r, "isKeyboardSelected", function(o) {
      var s = hs(hn(r.props.date, o));
      return !r.props.disabledKeyboardNavigation && !r.props.inline && !Ve(s, hs(r.props.selected)) && Ve(s, hs(r.props.preSelection));
    }), S(r, "onYearClick", function(o, s) {
      var a = r.props.date;
      r.handleYearClick(hs(hn(a, s)), o);
    }), S(r, "onYearKeyDown", function(o, s) {
      var a = o.key, i = r.props.handleOnKeyDown;
      if (!r.props.disabledKeyboardNavigation)
        switch (a) {
          case "Enter":
            r.onYearClick(o, s), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleYearNavigation(s + 1, hr(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleYearNavigation(s - 1, ra(r.props.preSelection, 1));
            break;
        }
      i && i(o);
    }), S(r, "getYearClassNames", function(o) {
      var s = r.props, a = s.date, i = s.minDate, c = s.maxDate, l = s.selected, u = s.excludeDates, d = s.includeDates, f = s.filterDate, p = s.yearClassName;
      return vt("react-datepicker__year-text", "react-datepicker__year-".concat(o), p ? p(hn(a, o)) : void 0, {
        "react-datepicker__year-text--selected": o === Le(l),
        "react-datepicker__year-text--disabled": (i || c || u || d || f) && vh(o, r.props),
        "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(o),
        "react-datepicker__year-text--range-start": r.isRangeStart(o),
        "react-datepicker__year-text--range-end": r.isRangeEnd(o),
        "react-datepicker__year-text--in-range": r.isInRange(o),
        "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(o),
        "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(o),
        "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(o),
        "react-datepicker__year-text--today": r.isCurrentYear(o)
      });
    }), S(r, "getYearTabIndex", function(o) {
      if (r.props.disabledKeyboardNavigation)
        return "-1";
      var s = Le(r.props.preSelection);
      return o === s ? "0" : "-1";
    }), S(r, "getYearContainerClassNames", function() {
      var o = r.props, s = o.selectingDate, a = o.selectsStart, i = o.selectsEnd, c = o.selectsRange;
      return vt("react-datepicker__year", {
        "react-datepicker__year--selecting-range": s && (a || i || c)
      });
    }), S(r, "getYearContent", function(o) {
      return r.props.renderYearContent ? r.props.renderYearContent(o) : o;
    }), r;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      for (var r = this, o = [], s = this.props, a = s.date, i = s.yearItemNumber, c = s.onYearMouseEnter, l = s.onYearMouseLeave, u = Ho(a, i), d = u.startPeriod, f = u.endPeriod, p = function(y) {
        o.push(/* @__PURE__ */ A.createElement("div", {
          ref: r.YEAR_REFS[y - d],
          onClick: function(v) {
            r.onYearClick(v, y);
          },
          onKeyDown: function(v) {
            wh(v) && (v.preventDefault(), v.key = "Enter"), r.onYearKeyDown(v, y);
          },
          tabIndex: r.getYearTabIndex(y),
          className: r.getYearClassNames(y),
          onMouseEnter: r.props.usePointerEvent ? void 0 : function(C) {
            return c(C, y);
          },
          onPointerEnter: r.props.usePointerEvent ? function(C) {
            return c(C, y);
          } : void 0,
          onMouseLeave: r.props.usePointerEvent ? void 0 : function(C) {
            return l(C, y);
          },
          onPointerLeave: r.props.usePointerEvent ? function(C) {
            return l(C, y);
          } : void 0,
          key: y,
          "aria-current": r.isCurrentYear(y) ? "date" : void 0
        }, r.getYearContent(y)));
      }, m = d; m <= f; m++)
        p(m);
      return /* @__PURE__ */ A.createElement("div", {
        className: this.getYearContainerClassNames()
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__year-wrapper",
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
      }, o));
    }
  }]);
}(A.Component), M_ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "onTimeChange", function(o) {
      r.setState({
        time: o
      });
      var s = r.props.date, a = s instanceof Date && !isNaN(s), i = a ? s : /* @__PURE__ */ new Date();
      i.setHours(o.split(":")[0]), i.setMinutes(o.split(":")[1]), r.props.onChange(i);
    }), S(r, "renderTimeInput", function() {
      var o = r.state.time, s = r.props, a = s.date, i = s.timeString, c = s.customTimeInput;
      return c ? /* @__PURE__ */ A.cloneElement(c, {
        date: a,
        value: o,
        onChange: r.onTimeChange
      }) : /* @__PURE__ */ A.createElement("input", {
        type: "time",
        className: "react-datepicker-time__input",
        placeholder: "Time",
        name: "time-input",
        required: !0,
        value: o,
        onChange: function(u) {
          r.onTimeChange(u.target.value || i);
        }
      });
    }), r.state = {
      time: r.props.timeString
    }, r;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__input-time-container"
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker-time__caption"
      }, this.props.timeInputLabel), /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker-time__input-container"
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker-time__input"
      }, this.renderTimeInput())));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.timeString !== o.time ? {
        time: r.timeString
      } : null;
    }
  }]);
}(A.Component);
function k_(e) {
  var n = e.showTimeSelectOnly, t = n === void 0 ? !1 : n, r = e.showTime, o = r === void 0 ? !1 : r, s = e.className, a = e.children, i = t ? "Choose Time" : "Choose Date".concat(o ? " and Time" : "");
  return /* @__PURE__ */ A.createElement("div", {
    className: s,
    role: "dialog",
    "aria-label": i,
    "aria-modal": "true"
  }, a);
}
var A_ = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], N_ = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = (n.className || "").split(/\s+/);
  return A_.some(function(r) {
    return t.indexOf(r) >= 0;
  });
}, L_ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "handleClickOutside", function(o) {
      r.props.onClickOutside(o);
    }), S(r, "setClickOutsideRef", function() {
      return r.containerRef.current;
    }), S(r, "handleDropdownFocus", function(o) {
      N_(o.target) && r.props.onDropdownFocus();
    }), S(r, "getDateInView", function() {
      var o = r.props, s = o.preSelection, a = o.selected, i = o.openToDate, c = bh(r.props), l = Ch(r.props), u = Ue(), d = i || a || s;
      return d || (c && Xr(u, c) ? c : l && br(u, l) ? l : u);
    }), S(r, "increaseMonth", function() {
      r.setState(function(o) {
        var s = o.date;
        return {
          date: ln(s, 1)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), S(r, "decreaseMonth", function() {
      r.setState(function(o) {
        var s = o.date;
        return {
          date: Bo(s, 1)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), S(r, "handleDayClick", function(o, s, a) {
      r.props.onSelect(o, s, a), r.props.setPreSelection && r.props.setPreSelection(o);
    }), S(r, "handleDayMouseEnter", function(o) {
      r.setState({
        selectingDate: o
      }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(o);
    }), S(r, "handleMonthMouseLeave", function() {
      r.setState({
        selectingDate: null
      }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
    }), S(r, "handleYearMouseEnter", function(o, s) {
      r.setState({
        selectingDate: hn(Ue(), s)
      }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(o, s);
    }), S(r, "handleYearMouseLeave", function(o, s) {
      r.props.onYearMouseLeave && r.props.onYearMouseLeave(o, s);
    }), S(r, "handleYearChange", function(o) {
      r.props.onYearChange && (r.props.onYearChange(o), r.setState({
        isRenderAriaLiveMessage: !0
      })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(o), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(o);
    }), S(r, "handleMonthChange", function(o) {
      r.handleCustomMonthChange(o), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(o), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(o);
    }), S(r, "handleCustomMonthChange", function(o) {
      r.props.onMonthChange && (r.props.onMonthChange(o), r.setState({
        isRenderAriaLiveMessage: !0
      }));
    }), S(r, "handleMonthYearChange", function(o) {
      r.handleYearChange(o), r.handleMonthChange(o);
    }), S(r, "changeYear", function(o) {
      r.setState(function(s) {
        var a = s.date;
        return {
          date: hn(a, o)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), S(r, "changeMonth", function(o) {
      r.setState(function(s) {
        var a = s.date;
        return {
          date: Tt(a, o)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), S(r, "changeMonthYear", function(o) {
      r.setState(function(s) {
        var a = s.date;
        return {
          date: hn(Tt(a, Ot(o)), Le(o))
        };
      }, function() {
        return r.handleMonthYearChange(r.state.date);
      });
    }), S(r, "header", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, s = mr(o, r.props.locale, r.props.calendarStartDay), a = [];
      return r.props.showWeekNumbers && a.push(/* @__PURE__ */ A.createElement("div", {
        key: "W",
        className: "react-datepicker__day-name"
      }, r.props.weekLabel || "#")), a.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
        var c = Mr(s, i), l = r.formatWeekday(c, r.props.locale), u = r.props.weekDayClassName ? r.props.weekDayClassName(c) : void 0;
        return /* @__PURE__ */ A.createElement("div", {
          key: i,
          className: vt("react-datepicker__day-name", u)
        }, l);
      }));
    }), S(r, "formatWeekday", function(o, s) {
      return r.props.formatWeekDay ? JE(o, r.props.formatWeekDay, s) : r.props.useWeekdaysShort ? t_(o, s) : e_(o, s);
    }), S(r, "decreaseYear", function() {
      r.setState(function(o) {
        var s = o.date;
        return {
          date: ra(s, r.props.showYearPicker ? r.props.yearItemNumber : 1)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), S(r, "clearSelectingDate", function() {
      r.setState({
        selectingDate: null
      });
    }), S(r, "renderPreviousButton", function() {
      if (!r.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case r.props.showMonthYearPicker:
            o = Tf(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            o = r_(r.state.date, r.props);
            break;
          default:
            o = Nf(r.state.date, r.props);
            break;
        }
        if (!(!r.props.forceShowMonthNavigation && !r.props.showDisabledMonthNavigation && o || r.props.showTimeSelectOnly)) {
          var s = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"], a = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], i = r.decreaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (i = r.decreaseYear), o && r.props.showDisabledMonthNavigation && (a.push("react-datepicker__navigation--previous--disabled"), i = null);
          var c = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, l = r.props, u = l.previousMonthButtonLabel, d = l.previousYearButtonLabel, f = r.props, p = f.previousMonthAriaLabel, m = p === void 0 ? typeof u == "string" ? u : "Previous Month" : p, h = f.previousYearAriaLabel, y = h === void 0 ? typeof d == "string" ? d : "Previous Year" : h;
          return /* @__PURE__ */ A.createElement("button", {
            type: "button",
            className: a.join(" "),
            onClick: i,
            onKeyDown: r.props.handleOnKeyDown,
            "aria-label": c ? y : m
          }, /* @__PURE__ */ A.createElement("span", {
            className: s.join(" ")
          }, c ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
        }
      }
    }), S(r, "increaseYear", function() {
      r.setState(function(o) {
        var s = o.date;
        return {
          date: hr(s, r.props.showYearPicker ? r.props.yearItemNumber : 1)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), S(r, "renderNextButton", function() {
      if (!r.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case r.props.showMonthYearPicker:
            o = Pf(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            o = o_(r.state.date, r.props);
            break;
          default:
            o = Lf(r.state.date, r.props);
            break;
        }
        if (!(!r.props.forceShowMonthNavigation && !r.props.showDisabledMonthNavigation && o || r.props.showTimeSelectOnly)) {
          var s = ["react-datepicker__navigation", "react-datepicker__navigation--next"], a = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
          r.props.showTimeSelect && s.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && s.push("react-datepicker__navigation--next--with-today-button");
          var i = r.increaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (i = r.increaseYear), o && r.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--next--disabled"), i = null);
          var c = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, l = r.props, u = l.nextMonthButtonLabel, d = l.nextYearButtonLabel, f = r.props, p = f.nextMonthAriaLabel, m = p === void 0 ? typeof u == "string" ? u : "Next Month" : p, h = f.nextYearAriaLabel, y = h === void 0 ? typeof d == "string" ? d : "Next Year" : h;
          return /* @__PURE__ */ A.createElement("button", {
            type: "button",
            className: s.join(" "),
            onClick: i,
            onKeyDown: r.props.handleOnKeyDown,
            "aria-label": c ? y : m
          }, /* @__PURE__ */ A.createElement("span", {
            className: a.join(" ")
          }, c ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
        }
      }
    }), S(r, "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, s = ["react-datepicker__current-month"];
      return r.props.showYearDropdown && s.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && s.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && s.push("react-datepicker__current-month--hasMonthYearDropdown"), /* @__PURE__ */ A.createElement("div", {
        className: s.join(" ")
      }, Xe(o, r.props.dateFormat, r.props.locale));
    }), S(r, "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showYearDropdown || o))
        return /* @__PURE__ */ A.createElement(p_, {
          adjustDateOnChange: r.props.adjustDateOnChange,
          date: r.state.date,
          onSelect: r.props.onSelect,
          setOpen: r.props.setOpen,
          dropdownMode: r.props.dropdownMode,
          onChange: r.changeYear,
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          year: Le(r.state.date),
          scrollableYearDropdown: r.props.scrollableYearDropdown,
          yearDropdownItemNumber: r.props.yearDropdownItemNumber
        });
    }), S(r, "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showMonthDropdown || o))
        return /* @__PURE__ */ A.createElement(g_, {
          dropdownMode: r.props.dropdownMode,
          locale: r.props.locale,
          onChange: r.changeMonth,
          month: Ot(r.state.date),
          useShortMonthInDropdown: r.props.useShortMonthInDropdown
        });
    }), S(r, "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showMonthYearDropdown || o))
        return /* @__PURE__ */ A.createElement(C_, {
          dropdownMode: r.props.dropdownMode,
          locale: r.props.locale,
          dateFormat: r.props.dateFormat,
          onChange: r.changeMonthYear,
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          date: r.state.date,
          scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
        });
    }), S(r, "handleTodayButtonClick", function(o) {
      r.props.onSelect(_f(), o), r.props.setPreSelection && r.props.setPreSelection(_f());
    }), S(r, "renderTodayButton", function() {
      if (!(!r.props.todayButton || r.props.showTimeSelectOnly))
        return /* @__PURE__ */ A.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: function(s) {
            return r.handleTodayButtonClick(s);
          }
        }, r.props.todayButton);
    }), S(r, "renderDefaultHeader", function(o) {
      var s = o.monthDate, a = o.i;
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
      }, r.renderCurrentMonth(s), /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
        onFocus: r.handleDropdownFocus
      }, r.renderMonthDropdown(a !== 0), r.renderMonthYearDropdown(a !== 0), r.renderYearDropdown(a !== 0)), /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__day-names"
      }, r.header(s)));
    }), S(r, "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = o.monthDate, a = o.i;
      if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly)
        return null;
      var i = Nf(r.state.date, r.props), c = Lf(r.state.date, r.props), l = Tf(r.state.date, r.props), u = Pf(r.state.date, r.props), d = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--custom",
        onFocus: r.props.onDropdownFocus
      }, r.props.renderCustomHeader(In(In({}, r.state), {}, {
        customHeaderCount: a,
        monthDate: s,
        changeMonth: r.changeMonth,
        changeYear: r.changeYear,
        decreaseMonth: r.decreaseMonth,
        increaseMonth: r.increaseMonth,
        decreaseYear: r.decreaseYear,
        increaseYear: r.increaseYear,
        prevMonthButtonDisabled: i,
        nextMonthButtonDisabled: c,
        prevYearButtonDisabled: l,
        nextYearButtonDisabled: u
      })), d && /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__day-names"
      }, r.header(s)));
    }), S(r, "renderYearHeader", function(o) {
      var s = o.monthDate, a = r.props, i = a.showYearPicker, c = a.yearItemNumber, l = Ho(s, c), u = l.startPeriod, d = l.endPeriod;
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__header react-datepicker-year-header"
      }, i ? "".concat(u, " - ").concat(d) : Le(s));
    }), S(r, "renderHeader", function(o) {
      switch (!0) {
        case r.props.renderCustomHeader !== void 0:
          return r.renderCustomHeader(o);
        case (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker):
          return r.renderYearHeader(o);
        default:
          return r.renderDefaultHeader(o);
      }
    }), S(r, "renderMonths", function() {
      var o;
      if (!(r.props.showTimeSelectOnly || r.props.showYearPicker)) {
        for (var s = [], a = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, i = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? hr(r.state.date, a) : Bo(r.state.date, a), c = (o = r.props.monthSelectedIn) !== null && o !== void 0 ? o : a, l = 0; l < r.props.monthsShown; ++l) {
          var u = l - c + a, d = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? hr(i, u) : ln(i, u), f = "month-".concat(l), p = l < r.props.monthsShown - 1, m = l > 0;
          s.push(/* @__PURE__ */ A.createElement("div", {
            key: f,
            ref: function(y) {
              r.monthContainer = y;
            },
            className: "react-datepicker__month-container"
          }, r.renderHeader({
            monthDate: d,
            i: l
          }), /* @__PURE__ */ A.createElement(E_, {
            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
            onChange: r.changeMonthYear,
            day: d,
            dayClassName: r.props.dayClassName,
            calendarStartDay: r.props.calendarStartDay,
            monthClassName: r.props.monthClassName,
            onDayClick: r.handleDayClick,
            handleOnKeyDown: r.props.handleOnDayKeyDown,
            handleOnMonthKeyDown: r.props.handleOnKeyDown,
            usePointerEvent: r.props.usePointerEvent,
            onDayMouseEnter: r.handleDayMouseEnter,
            onMouseLeave: r.handleMonthMouseLeave,
            onWeekSelect: r.props.onWeekSelect,
            orderInDisplay: l,
            formatWeekNumber: r.props.formatWeekNumber,
            locale: r.props.locale,
            minDate: r.props.minDate,
            maxDate: r.props.maxDate,
            excludeDates: r.props.excludeDates,
            excludeDateIntervals: r.props.excludeDateIntervals,
            highlightDates: r.props.highlightDates,
            holidays: r.props.holidays,
            selectingDate: r.state.selectingDate,
            includeDates: r.props.includeDates,
            includeDateIntervals: r.props.includeDateIntervals,
            inline: r.props.inline,
            shouldFocusDayInline: r.props.shouldFocusDayInline,
            fixedHeight: r.props.fixedHeight,
            filterDate: r.props.filterDate,
            preSelection: r.props.preSelection,
            setPreSelection: r.props.setPreSelection,
            selected: r.props.selected,
            selectsStart: r.props.selectsStart,
            selectsEnd: r.props.selectsEnd,
            selectsRange: r.props.selectsRange,
            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
            selectsMultiple: r.props.selectsMultiple,
            selectedDates: r.props.selectedDates,
            showWeekNumbers: r.props.showWeekNumbers,
            startDate: r.props.startDate,
            endDate: r.props.endDate,
            peekNextMonth: r.props.peekNextMonth,
            setOpen: r.props.setOpen,
            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
            renderDayContents: r.props.renderDayContents,
            renderMonthContent: r.props.renderMonthContent,
            renderQuarterContent: r.props.renderQuarterContent,
            renderYearContent: r.props.renderYearContent,
            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
            showMonthYearPicker: r.props.showMonthYearPicker,
            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
            showYearPicker: r.props.showYearPicker,
            showQuarterYearPicker: r.props.showQuarterYearPicker,
            showWeekPicker: r.props.showWeekPicker,
            isInputFocused: r.props.isInputFocused,
            containerRef: r.containerRef,
            monthShowsDuplicateDaysEnd: p,
            monthShowsDuplicateDaysStart: m
          })));
        }
        return s;
      }
    }), S(r, "renderYears", function() {
      if (!r.props.showTimeSelectOnly && r.props.showYearPicker)
        return /* @__PURE__ */ A.createElement("div", {
          className: "react-datepicker__year--container"
        }, r.renderHeader({
          monthDate: r.state.date
        }), /* @__PURE__ */ A.createElement(__, Hs({
          onDayClick: r.handleDayClick,
          selectingDate: r.state.selectingDate,
          clearSelectingDate: r.clearSelectingDate,
          date: r.state.date
        }, r.props, {
          onYearMouseEnter: r.handleYearMouseEnter,
          onYearMouseLeave: r.handleYearMouseLeave
        })));
    }), S(r, "renderTimeSection", function() {
      if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly))
        return /* @__PURE__ */ A.createElement(xh, {
          selected: r.props.selected,
          openToDate: r.props.openToDate,
          onChange: r.props.onTimeChange,
          timeClassName: r.props.timeClassName,
          format: r.props.timeFormat,
          includeTimes: r.props.includeTimes,
          intervals: r.props.timeIntervals,
          minTime: r.props.minTime,
          maxTime: r.props.maxTime,
          excludeTimes: r.props.excludeTimes,
          filterTime: r.props.filterTime,
          timeCaption: r.props.timeCaption,
          todayButton: r.props.todayButton,
          showMonthDropdown: r.props.showMonthDropdown,
          showMonthYearDropdown: r.props.showMonthYearDropdown,
          showYearDropdown: r.props.showYearDropdown,
          withPortal: r.props.withPortal,
          monthRef: r.state.monthContainer,
          injectTimes: r.props.injectTimes,
          locale: r.props.locale,
          handleOnKeyDown: r.props.handleOnKeyDown,
          showTimeSelectOnly: r.props.showTimeSelectOnly
        });
    }), S(r, "renderInputTimeSection", function() {
      var o = new Date(r.props.selected), s = ir(o) && !!r.props.selected, a = s ? "".concat(Rf(o.getHours()), ":").concat(Rf(o.getMinutes())) : "";
      if (r.props.showTimeInput)
        return /* @__PURE__ */ A.createElement(M_, {
          date: o,
          timeString: a,
          timeInputLabel: r.props.timeInputLabel,
          onChange: r.props.onTimeChange,
          customTimeInput: r.props.customTimeInput
        });
    }), S(r, "renderAriaLiveRegion", function() {
      var o = Ho(r.state.date, r.props.yearItemNumber), s = o.startPeriod, a = o.endPeriod, i;
      return r.props.showYearPicker ? i = "".concat(s, " - ").concat(a) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? i = Le(r.state.date) : i = "".concat(Su(Ot(r.state.date), r.props.locale), " ").concat(Le(r.state.date)), /* @__PURE__ */ A.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, r.state.isRenderAriaLiveMessage && i);
    }), S(r, "renderChildren", function() {
      if (r.props.children)
        return /* @__PURE__ */ A.createElement("div", {
          className: "react-datepicker__children-container"
        }, r.props.children);
    }), r.containerRef = /* @__PURE__ */ A.createRef(), r.state = {
      date: r.getDateInView(),
      selectingDate: null,
      monthContainer: null,
      isRenderAriaLiveMessage: !1
    }, r;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      var r = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        r.setState({
          monthContainer: r.monthContainer
        });
      }());
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var o = this;
      if (this.props.preSelection && (!Ve(this.props.preSelection, r.preSelection) || this.props.monthSelectedIn !== r.monthSelectedIn)) {
        var s = !Wt(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return s && o.handleCustomMonthChange(o.state.date);
        });
      } else
        this.props.openToDate && !Ve(this.props.openToDate, r.openToDate) && this.setState({
          date: this.props.openToDate
        });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props.container || k_;
      return /* @__PURE__ */ A.createElement("div", {
        style: {
          display: "contents"
        },
        ref: this.containerRef
      }, /* @__PURE__ */ A.createElement(r, {
        className: vt("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showTime: this.props.showTimeSelect || this.props.showTimeInput,
        showTimeSelectOnly: this.props.showTimeSelectOnly
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        onDropdownFocus: function() {
        },
        monthsShown: 1,
        forceShowMonthNavigation: !1,
        timeCaption: "Time",
        previousYearButtonLabel: "Previous Year",
        nextYearButtonLabel: "Next Year",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month",
        customTimeInput: null,
        yearItemNumber: ia
      };
    }
  }]);
}(A.Component), T_ = function(n) {
  var t = n.icon, r = n.className, o = r === void 0 ? "" : r, s = n.onClick, a = "react-datepicker__calendar-icon";
  return /* @__PURE__ */ A.isValidElement(t) ? /* @__PURE__ */ A.cloneElement(t, {
    className: "".concat(t.props.className || "", " ").concat(a, " ").concat(o),
    onClick: function(c) {
      typeof t.props.onClick == "function" && t.props.onClick(c), typeof s == "function" && s(c);
    }
  }) : typeof t == "string" ? /* @__PURE__ */ A.createElement("i", {
    className: "".concat(a, " ").concat(t, " ").concat(o),
    "aria-hidden": "true",
    onClick: s
  }) : /* @__PURE__ */ A.createElement("svg", {
    className: "".concat(a, " ").concat(o),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    onClick: s
  }, /* @__PURE__ */ A.createElement("path", {
    d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
  }));
}, P_ = T_, Dh = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), r.el = document.createElement("div"), r;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ n0.createPortal(this.props.children, this.el);
    }
  }]);
}(A.Component), O_ = "[tabindex], a, button, input, select, textarea", R_ = function(n) {
  return !n.disabled && n.tabIndex !== -1;
}, Sh = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "getTabChildren", function() {
      return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll(O_), 1, -1).filter(R_);
    }), S(r, "handleFocusStart", function() {
      var o = r.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), S(r, "handleFocusEnd", function() {
      var o = r.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), r.tabLoopRef = /* @__PURE__ */ A.createRef(), r;
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      return this.props.enableTabLoop ? /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef
      }, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__tab-loop__start",
        tabIndex: "0",
        onFocus: this.handleFocusStart
      }), this.props.children, /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__tab-loop__end",
        tabIndex: "0",
        onFocus: this.handleFocusEnd
      })) : this.props.children;
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        enableTabLoop: !0
      };
    }
  }]);
}(A.Component);
function I_(e) {
  var n = function(r) {
    var o = In(In({}, r), {}, {
      popperModifiers: r.popperModifiers || [],
      popperProps: r.popperProps || {},
      hidePopper: typeof r.hidePopper == "boolean" ? r.hidePopper : !0
    }), s = A.useRef(), a = RE(In({
      open: !o.hidePopper,
      whileElementsMounted: uh,
      placement: o.popperPlacement,
      middleware: [dh({
        padding: 15
      }), nh(10), wE({
        element: s
      })].concat(xr(o.popperModifiers))
    }, o.popperProps));
    return /* @__PURE__ */ A.createElement(e, Hs({}, o, {
      popperProps: In(In({}, a), {}, {
        arrowRef: s
      })
    }));
  };
  return n;
}
var F_ = /* @__PURE__ */ function(e) {
  function n() {
    return wt(this, n), Ct(this, n, arguments);
  }
  return Dt(n, e), xt(n, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.className, s = r.wrapperClassName, a = r.hidePopper, i = r.popperComponent, c = r.targetComponent, l = r.enableTabLoop, u = r.popperOnKeyDown, d = r.portalId, f = r.portalHost, p = r.popperProps, m = r.showArrow, h;
      if (!a) {
        var y = vt("react-datepicker-popper", o);
        h = /* @__PURE__ */ A.createElement(Sh, {
          enableTabLoop: l
        }, /* @__PURE__ */ A.createElement("div", {
          ref: p.refs.setFloating,
          style: p.floatingStyles,
          className: y,
          "data-placement": p.placement,
          onKeyDown: u
        }, i, m && /* @__PURE__ */ A.createElement(AE, {
          ref: p.arrowRef,
          context: p.context,
          fill: "currentColor",
          strokeWidth: 1,
          height: 8,
          width: 16,
          style: {
            transform: "translateY(-1px)"
          },
          className: "react-datepicker__triangle"
        })));
      }
      this.props.popperContainer && (h = /* @__PURE__ */ A.createElement(this.props.popperContainer, {}, h)), d && !a && (h = /* @__PURE__ */ A.createElement(Dh, {
        portalId: d,
        portalHost: f
      }, h));
      var C = vt("react-datepicker-wrapper", s);
      return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement("div", {
        ref: p.refs.setReference,
        className: C
      }, c), h);
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        hidePopper: !0
      };
    }
  }]);
}(A.Component), V_ = I_(F_), Bf = "react-datepicker-ignore-onclickoutside", $_ = ac(L_);
function B_(e, n) {
  return e && n ? Ot(e) !== Ot(n) || Le(e) !== Le(n) : e !== n;
}
var nl = "Date input not valid.", j_ = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return wt(this, n), r = Ct(this, n, [t]), S(r, "getPreSelection", function() {
      return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Ue();
    }), S(r, "modifyHolidays", function() {
      var o;
      return (o = r.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(s, a) {
        var i = new Date(a.date);
        return Vo(i) ? [].concat(xr(s), [In(In({}, a), {}, {
          date: i
        })]) : s;
      }, []);
    }), S(r, "calcInitialState", function() {
      var o, s = r.getPreSelection(), a = bh(r.props), i = Ch(r.props), c = a && Xr(s, En(a)) ? a : i && br(s, Ql(i)) ? i : s;
      return {
        open: r.props.startOpen || !1,
        preventFocus: !1,
        preSelection: (o = r.props.selectsRange ? r.props.startDate : r.props.selected) !== null && o !== void 0 ? o : c,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: Of(r.props.highlightDates),
        focused: !1,
        // used to focus day in inline version after month has changed, but not on
        // initial render
        shouldFocusDayInline: !1,
        isRenderAriaLiveMessage: !1
      };
    }), S(r, "clearPreventFocusTimeout", function() {
      r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
    }), S(r, "setFocus", function() {
      r.input && r.input.focus && r.input.focus({
        preventScroll: !0
      });
    }), S(r, "setBlur", function() {
      r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
    }), S(r, "setOpen", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      r.setState({
        open: o,
        preSelection: o && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
        lastPreSelectChange: rl
      }, function() {
        o || r.setState(function(a) {
          return {
            focused: s ? a.focused : !1
          };
        }, function() {
          !s && r.setBlur(), r.setState({
            inputValue: null
          });
        });
      });
    }), S(r, "inputOk", function() {
      return Qr(r.state.preSelection);
    }), S(r, "isCalendarOpen", function() {
      return r.props.open === void 0 ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
    }), S(r, "handleFocus", function(o) {
      r.state.preventFocus || (r.props.onFocus(o), !r.props.preventOpenOnFocus && !r.props.readOnly && r.setOpen(!0)), r.setState({
        focused: !0
      });
    }), S(r, "sendFocusBackToInput", function() {
      r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
        preventFocus: !0
      }, function() {
        r.preventFocusTimeout = setTimeout(function() {
          r.setFocus(), r.setState({
            preventFocus: !1
          });
        });
      });
    }), S(r, "cancelFocusInput", function() {
      clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
    }), S(r, "deferFocusInput", function() {
      r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
        return r.setFocus();
      }, 1);
    }), S(r, "handleDropdownFocus", function() {
      r.cancelFocusInput();
    }), S(r, "handleBlur", function(o) {
      (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(o), r.setState({
        focused: !1
      });
    }), S(r, "handleCalendarClickOutside", function(o) {
      r.props.inline || r.setOpen(!1), r.props.onClickOutside(o), r.props.withPortal && o.preventDefault();
    }), S(r, "handleChange", function() {
      for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
        s[a] = arguments[a];
      var i = s[0];
      if (!(r.props.onChangeRaw && (r.props.onChangeRaw.apply(r, s), typeof i.isDefaultPrevented != "function" || i.isDefaultPrevented()))) {
        r.setState({
          inputValue: i.target.value,
          lastPreSelectChange: Y_
        });
        var c = WE(i.target.value, r.props.dateFormat, r.props.locale, r.props.strictParsing, r.props.minDate);
        r.props.showTimeSelectOnly && r.props.selected && c && !Ve(c, r.props.selected) && (c = IE(r.props.selected, {
          hours: Mn(c),
          minutes: _n(c),
          seconds: uf(c)
        })), (c || !i.target.value) && r.setSelected(c, i, !0);
      }
    }), S(r, "handleSelect", function(o, s, a) {
      if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(s), r.setSelected(o, s, !1, a), r.props.showDateSelect && r.setState({
        isRenderAriaLiveMessage: !0
      }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect)
        r.setPreSelection(o);
      else if (!r.props.inline) {
        r.props.selectsRange || r.setOpen(!1);
        var i = r.props, c = i.startDate, l = i.endDate;
        c && !l && !Vf(o, c) && r.setOpen(!1);
      }
    }), S(r, "setSelected", function(o, s, a, i) {
      var c = o;
      if (r.props.showYearPicker) {
        if (c !== null && vh(Le(c), r.props))
          return;
      } else if (r.props.showMonthYearPicker) {
        if (c !== null && Ka(c, r.props))
          return;
      } else if (c !== null && uc(c, r.props))
        return;
      var l = r.props, u = l.onChange, d = l.selectsRange, f = l.startDate, p = l.endDate, m = l.selectsMultiple, h = l.selectedDates, y = l.minTime;
      if (!Br(r.props.selected, c) || r.props.allowSameDay || d || m)
        if (c !== null && (r.props.selected && (!a || !r.props.showTimeSelect && !r.props.showTimeSelectOnly && !r.props.showTimeInput) && (c = Jc(c, {
          hour: Mn(r.props.selected),
          minute: _n(r.props.selected),
          second: uf(r.props.selected)
        })), !a && (r.props.showTimeSelect || r.props.showTimeSelectOnly) && y && (c = Jc(c, {
          hour: y.getHours(),
          minute: y.getMinutes(),
          second: y.getSeconds()
        })), r.props.inline || r.setState({
          preSelection: c
        }), r.props.focusSelectedMonth || r.setState({
          monthSelectedIn: i
        })), d) {
          var C = !f && !p, v = f && !p, w = f && p;
          C ? u([c, null], s) : v && (c === null ? u([null, null], s) : Vf(c, f) ? u([c, null], s) : u([f, c], s)), w && u([c, null], s);
        } else if (m)
          if (!(h != null && h.length))
            u([c], s);
          else {
            var x = h.some(function(k) {
              return Ve(k, c);
            });
            if (x) {
              var D = h.filter(function(k) {
                return !Ve(k, c);
              });
              u(D, s);
            } else
              u([].concat(xr(h), [c]), s);
          }
        else
          u(c, s);
      a || (r.props.onSelect(c, s), r.setState({
        inputValue: null
      }));
    }), S(r, "setPreSelection", function(o) {
      var s = typeof r.props.minDate < "u", a = typeof r.props.maxDate < "u", i = !0;
      if (o) {
        var c = En(o);
        if (s && a)
          i = ms(o, r.props.minDate, r.props.maxDate);
        else if (s) {
          var l = En(r.props.minDate);
          i = br(o, l) || Br(c, l);
        } else if (a) {
          var u = Ql(r.props.maxDate);
          i = Xr(o, u) || Br(c, u);
        }
      }
      i && r.setState({
        preSelection: o
      });
    }), S(r, "toggleCalendar", function() {
      r.setOpen(!r.state.open);
    }), S(r, "handleTimeChange", function(o) {
      var s = r.props.selected ? r.props.selected : r.getPreSelection(), a = r.props.selected ? o : Jc(s, {
        hour: Mn(o),
        minute: _n(o)
      });
      r.setState({
        preSelection: a
      }), r.props.onChange(a), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
        isRenderAriaLiveMessage: !0
      }), r.setState({
        inputValue: null
      });
    }), S(r, "onInputClick", function() {
      !r.props.disabled && !r.props.readOnly && r.setOpen(!0), r.props.onInputClick();
    }), S(r, "onInputKeyDown", function(o) {
      r.props.onKeyDown(o);
      var s = o.key;
      if (!r.state.open && !r.props.inline && !r.props.preventOpenOnFocus) {
        (s === "ArrowDown" || s === "ArrowUp" || s === "Enter") && r.onInputClick();
        return;
      }
      if (r.state.open) {
        if (s === "ArrowDown" || s === "ArrowUp") {
          o.preventDefault();
          var a = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', i = r.calendar.componentNode && r.calendar.componentNode.querySelector(a);
          i && i.focus({
            preventScroll: !0
          });
          return;
        }
        var c = Ue(r.state.preSelection);
        s === "Enter" ? (o.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === rl ? (r.handleSelect(c, o), !r.props.shouldCloseOnSelect && r.setPreSelection(c)) : r.setOpen(!1)) : s === "Escape" ? (o.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : s === "Tab" && r.setOpen(!1), r.inputOk() || r.props.onInputError({
          code: 1,
          msg: nl
        });
      }
    }), S(r, "onPortalKeyDown", function(o) {
      var s = o.key;
      s === "Escape" && (o.preventDefault(), r.setState({
        preventFocus: !0
      }, function() {
        r.setOpen(!1), setTimeout(function() {
          r.setFocus(), r.setState({
            preventFocus: !1
          });
        });
      }));
    }), S(r, "onDayKeyDown", function(o) {
      r.props.onKeyDown(o);
      var s = o.key, a = o.shiftKey, i = Ue(r.state.preSelection);
      if (s === "Enter")
        o.preventDefault(), r.handleSelect(i, o), !r.props.shouldCloseOnSelect && r.setPreSelection(i);
      else if (s === "Escape")
        o.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
          code: 1,
          msg: nl
        });
      else if (!r.props.disabledKeyboardNavigation) {
        var c;
        switch (s) {
          case "ArrowLeft":
            r.props.showWeekPicker ? c = lf(i, 1) : c = uD(i, 1);
            break;
          case "ArrowRight":
            r.props.showWeekPicker ? c = wi(i, 1) : c = Mr(i, 1);
            break;
          case "ArrowUp":
            c = lf(i, 1);
            break;
          case "ArrowDown":
            c = wi(i, 1);
            break;
          case "PageUp":
            c = a ? ra(i, 1) : Bo(i, 1);
            break;
          case "PageDown":
            c = a ? hr(i, 1) : ln(i, 1);
            break;
          case "Home":
            c = mr(i, r.props.locale, r.props.calendarStartDay);
            break;
          case "End":
            c = QE(i);
            break;
          default:
            c = null;
            break;
        }
        if (!c) {
          r.props.onInputError && r.props.onInputError({
            code: 1,
            msg: nl
          });
          return;
        }
        if (o.preventDefault(), r.setState({
          lastPreSelectChange: rl
        }), r.props.adjustDateOnChange && r.setSelected(c), r.setPreSelection(c), r.props.inline) {
          var l = Ot(i), u = Ot(c), d = Le(i), f = Le(c);
          l !== u || d !== f ? r.setState({
            shouldFocusDayInline: !0
          }) : r.setState({
            shouldFocusDayInline: !1
          });
        }
      }
    }), S(r, "onPopperKeyDown", function(o) {
      var s = o.key;
      s === "Escape" && (o.preventDefault(), r.sendFocusBackToInput());
    }), S(r, "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([null, null], o) : r.props.onChange(null, o), r.setState({
        inputValue: null
      });
    }), S(r, "clear", function() {
      r.onClearClick();
    }), S(r, "onScroll", function(o) {
      typeof r.props.closeOnScroll == "boolean" && r.props.closeOnScroll ? (o.target === document || o.target === document.documentElement || o.target === document.body) && r.setOpen(!1) : typeof r.props.closeOnScroll == "function" && r.props.closeOnScroll(o) && r.setOpen(!1);
    }), S(r, "renderCalendar", function() {
      return !r.props.inline && !r.isCalendarOpen() ? null : /* @__PURE__ */ A.createElement($_, {
        ref: function(s) {
          r.calendar = s;
        },
        locale: r.props.locale,
        calendarStartDay: r.props.calendarStartDay,
        chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
        weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
        monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
        adjustDateOnChange: r.props.adjustDateOnChange,
        setOpen: r.setOpen,
        shouldCloseOnSelect: r.props.shouldCloseOnSelect,
        dateFormat: r.props.dateFormatCalendar,
        useWeekdaysShort: r.props.useWeekdaysShort,
        formatWeekDay: r.props.formatWeekDay,
        dropdownMode: r.props.dropdownMode,
        selected: r.props.selected,
        preSelection: r.state.preSelection,
        onSelect: r.handleSelect,
        onWeekSelect: r.props.onWeekSelect,
        openToDate: r.props.openToDate,
        minDate: r.props.minDate,
        maxDate: r.props.maxDate,
        selectsStart: r.props.selectsStart,
        selectsEnd: r.props.selectsEnd,
        selectsRange: r.props.selectsRange,
        selectsMultiple: r.props.selectsMultiple,
        selectedDates: r.props.selectedDates,
        startDate: r.props.startDate,
        endDate: r.props.endDate,
        excludeDates: r.props.excludeDates,
        excludeDateIntervals: r.props.excludeDateIntervals,
        filterDate: r.props.filterDate,
        onClickOutside: r.handleCalendarClickOutside,
        formatWeekNumber: r.props.formatWeekNumber,
        highlightDates: r.state.highlightDates,
        holidays: a_(r.modifyHolidays()),
        includeDates: r.props.includeDates,
        includeDateIntervals: r.props.includeDateIntervals,
        includeTimes: r.props.includeTimes,
        injectTimes: r.props.injectTimes,
        inline: r.props.inline,
        shouldFocusDayInline: r.state.shouldFocusDayInline,
        peekNextMonth: r.props.peekNextMonth,
        showMonthDropdown: r.props.showMonthDropdown,
        showPreviousMonths: r.props.showPreviousMonths,
        useShortMonthInDropdown: r.props.useShortMonthInDropdown,
        showMonthYearDropdown: r.props.showMonthYearDropdown,
        showWeekNumbers: r.props.showWeekNumbers,
        showYearDropdown: r.props.showYearDropdown,
        withPortal: r.props.withPortal,
        forceShowMonthNavigation: r.props.forceShowMonthNavigation,
        showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
        scrollableYearDropdown: r.props.scrollableYearDropdown,
        scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
        todayButton: r.props.todayButton,
        weekLabel: r.props.weekLabel,
        outsideClickIgnoreClass: Bf,
        fixedHeight: r.props.fixedHeight,
        monthsShown: r.props.monthsShown,
        monthSelectedIn: r.state.monthSelectedIn,
        onDropdownFocus: r.handleDropdownFocus,
        onMonthChange: r.props.onMonthChange,
        onYearChange: r.props.onYearChange,
        dayClassName: r.props.dayClassName,
        weekDayClassName: r.props.weekDayClassName,
        monthClassName: r.props.monthClassName,
        timeClassName: r.props.timeClassName,
        showDateSelect: r.props.showDateSelect,
        showTimeSelect: r.props.showTimeSelect,
        showTimeSelectOnly: r.props.showTimeSelectOnly,
        onTimeChange: r.handleTimeChange,
        timeFormat: r.props.timeFormat,
        timeIntervals: r.props.timeIntervals,
        minTime: r.props.minTime,
        maxTime: r.props.maxTime,
        excludeTimes: r.props.excludeTimes,
        filterTime: r.props.filterTime,
        timeCaption: r.props.timeCaption,
        className: r.props.calendarClassName,
        container: r.props.calendarContainer,
        yearItemNumber: r.props.yearItemNumber,
        yearDropdownItemNumber: r.props.yearDropdownItemNumber,
        previousMonthAriaLabel: r.props.previousMonthAriaLabel,
        previousMonthButtonLabel: r.props.previousMonthButtonLabel,
        nextMonthAriaLabel: r.props.nextMonthAriaLabel,
        nextMonthButtonLabel: r.props.nextMonthButtonLabel,
        previousYearAriaLabel: r.props.previousYearAriaLabel,
        previousYearButtonLabel: r.props.previousYearButtonLabel,
        nextYearAriaLabel: r.props.nextYearAriaLabel,
        nextYearButtonLabel: r.props.nextYearButtonLabel,
        timeInputLabel: r.props.timeInputLabel,
        disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
        renderCustomHeader: r.props.renderCustomHeader,
        popperProps: r.props.popperProps,
        renderDayContents: r.props.renderDayContents,
        renderMonthContent: r.props.renderMonthContent,
        renderQuarterContent: r.props.renderQuarterContent,
        renderYearContent: r.props.renderYearContent,
        onDayMouseEnter: r.props.onDayMouseEnter,
        onMonthMouseLeave: r.props.onMonthMouseLeave,
        onYearMouseEnter: r.props.onYearMouseEnter,
        onYearMouseLeave: r.props.onYearMouseLeave,
        selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
        showTimeInput: r.props.showTimeInput,
        showMonthYearPicker: r.props.showMonthYearPicker,
        showFullMonthYearPicker: r.props.showFullMonthYearPicker,
        showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
        showYearPicker: r.props.showYearPicker,
        showQuarterYearPicker: r.props.showQuarterYearPicker,
        showWeekPicker: r.props.showWeekPicker,
        excludeScrollbar: r.props.excludeScrollbar,
        handleOnKeyDown: r.props.onKeyDown,
        handleOnDayKeyDown: r.onDayKeyDown,
        isInputFocused: r.state.focused,
        customTimeInput: r.props.customTimeInput,
        setPreSelection: r.setPreSelection,
        usePointerEvent: r.props.usePointerEvent,
        yearClassName: r.props.yearClassName
      }, r.props.children);
    }), S(r, "renderAriaLiveRegion", function() {
      var o = r.props, s = o.dateFormat, a = o.locale, i = r.props.showTimeInput || r.props.showTimeSelect, c = i ? "PPPPp" : "PPPP", l;
      return r.props.selectsRange ? l = "Selected start date: ".concat(tn(r.props.startDate, {
        dateFormat: c,
        locale: a
      }), ". ").concat(r.props.endDate ? "End date: " + tn(r.props.endDate, {
        dateFormat: c,
        locale: a
      }) : "") : r.props.showTimeSelectOnly ? l = "Selected time: ".concat(tn(r.props.selected, {
        dateFormat: s,
        locale: a
      })) : r.props.showYearPicker ? l = "Selected year: ".concat(tn(r.props.selected, {
        dateFormat: "yyyy",
        locale: a
      })) : r.props.showMonthYearPicker ? l = "Selected month: ".concat(tn(r.props.selected, {
        dateFormat: "MMMM yyyy",
        locale: a
      })) : r.props.showQuarterYearPicker ? l = "Selected quarter: ".concat(tn(r.props.selected, {
        dateFormat: "yyyy, QQQ",
        locale: a
      })) : l = "Selected date: ".concat(tn(r.props.selected, {
        dateFormat: c,
        locale: a
      })), /* @__PURE__ */ A.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, l);
    }), S(r, "renderDateInput", function() {
      var o, s = vt(r.props.className, S({}, Bf, r.state.open)), a = r.props.customInput || /* @__PURE__ */ A.createElement("input", {
        type: "text"
      }), i = r.props.customInputRef || "ref", c = typeof r.props.value == "string" ? r.props.value : typeof r.state.inputValue == "string" ? r.state.inputValue : r.props.selectsRange ? ZE(r.props.startDate, r.props.endDate, r.props) : r.props.selectsMultiple ? KE(r.props.selectedDates, r.props) : tn(r.props.selected, r.props);
      return /* @__PURE__ */ A.cloneElement(a, (o = {}, S(S(S(S(S(S(S(S(S(S(o, i, function(l) {
        r.input = l;
      }), "value", c), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), S(S(S(S(S(S(S(S(S(S(o, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", vt(a.props.className, s)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), S(S(S(o, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
    }), S(r, "renderClearButton", function() {
      var o = r.props, s = o.isClearable, a = o.disabled, i = o.selected, c = o.startDate, l = o.endDate, u = o.clearButtonTitle, d = o.clearButtonClassName, f = d === void 0 ? "" : d, p = o.ariaLabelClose, m = p === void 0 ? "Close" : p, h = o.selectedDates;
      return s && (i != null || c != null || l != null || h != null && h.length) ? /* @__PURE__ */ A.createElement("button", {
        type: "button",
        className: vt("react-datepicker__close-icon", f, {
          "react-datepicker__close-icon--disabled": a
        }),
        disabled: a,
        "aria-label": m,
        onClick: r.onClearClick,
        title: u,
        tabIndex: -1
      }) : null;
    }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
  }
  return Dt(n, e), xt(n, [{
    key: "componentDidMount",
    value: function() {
      window.addEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, o) {
      r.inline && B_(r.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({
        monthSelectedIn: 0
      }), r.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: Of(this.props.highlightDates)
      }), !o.focused && !Br(r.selected, this.props.selected) && this.setState({
        inputValue: null
      }), o.open !== this.state.open && (o.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), o.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "renderInputContainer",
    value: function() {
      var r = this.props, o = r.showIcon, s = r.icon, a = r.calendarIconClassname, i = r.toggleCalendarOnIconClick, c = this.state.open;
      return /* @__PURE__ */ A.createElement("div", {
        className: "react-datepicker__input-container".concat(o ? " react-datepicker__view-calendar-icon" : "")
      }, o && /* @__PURE__ */ A.createElement(P_, Hs({
        icon: s,
        className: "".concat(a, " ").concat(c && "react-datepicker-ignore-onclickoutside")
      }, i ? {
        onClick: this.toggleCalendar
      } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    }
  }, {
    key: "render",
    value: function() {
      var r = this.renderCalendar();
      if (this.props.inline)
        return r;
      if (this.props.withPortal) {
        var o = this.state.open ? /* @__PURE__ */ A.createElement(Sh, {
          enableTabLoop: this.props.enableTabLoop
        }, /* @__PURE__ */ A.createElement("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown
        }, r)) : null;
        return this.state.open && this.props.portalId && (o = /* @__PURE__ */ A.createElement(Dh, {
          portalId: this.props.portalId,
          portalHost: this.props.portalHost
        }, o)), /* @__PURE__ */ A.createElement("div", null, this.renderInputContainer(), o);
      }
      return /* @__PURE__ */ A.createElement(V_, {
        className: this.props.popperClassName,
        wrapperClassName: this.props.wrapperClassName,
        hidePopper: !this.isCalendarOpen(),
        portalId: this.props.portalId,
        portalHost: this.props.portalHost,
        popperModifiers: this.props.popperModifiers,
        targetComponent: this.renderInputContainer(),
        popperContainer: this.props.popperContainer,
        popperComponent: r,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps,
        popperOnKeyDown: this.onPopperKeyDown,
        enableTabLoop: this.props.enableTabLoop,
        showArrow: this.props.showPopperArrow
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        allowSameDay: !1,
        dateFormat: "MM/dd/yyyy",
        dateFormatCalendar: "LLLL yyyy",
        onChange: function() {
        },
        disabled: !1,
        disabledKeyboardNavigation: !1,
        dropdownMode: "scroll",
        onFocus: function() {
        },
        onBlur: function() {
        },
        onKeyDown: function() {
        },
        onInputClick: function() {
        },
        onSelect: function() {
        },
        onClickOutside: function() {
        },
        onMonthChange: function() {
        },
        onCalendarOpen: function() {
        },
        onCalendarClose: function() {
        },
        preventOpenOnFocus: !1,
        onYearChange: function() {
        },
        onInputError: function() {
        },
        monthsShown: 1,
        readOnly: !1,
        withPortal: !1,
        selectsDisabledDaysInRange: !1,
        shouldCloseOnSelect: !0,
        showTimeSelect: !1,
        showTimeInput: !1,
        showPreviousMonths: !1,
        showMonthYearPicker: !1,
        showFullMonthYearPicker: !1,
        showTwoColumnMonthYearPicker: !1,
        showFourColumnMonthYearPicker: !1,
        showYearPicker: !1,
        showQuarterYearPicker: !1,
        showWeekPicker: !1,
        strictParsing: !1,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthAriaLabel: "Previous Month",
        previousMonthButtonLabel: "Previous Month",
        nextMonthAriaLabel: "Next Month",
        nextMonthButtonLabel: "Next Month",
        previousYearAriaLabel: "Previous Year",
        previousYearButtonLabel: "Previous Year",
        nextYearAriaLabel: "Next Year",
        nextYearButtonLabel: "Next Year",
        timeInputLabel: "Time",
        enableTabLoop: !0,
        yearItemNumber: ia,
        focusSelectedMonth: !1,
        showPopperArrow: !0,
        excludeScrollbar: !0,
        customTimeInput: null,
        calendarStartDay: void 0,
        toggleCalendarOnIconClick: !1,
        usePointerEvent: !1
      };
    }
  }]);
}(A.Component), Y_ = "input", rl = "navigate";
const H_ = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, U_ = (e, n, t) => {
  let r;
  const o = H_[e];
  return typeof o == "string" ? r = o : n === 1 ? r = o.one : r = o.other.replace("{{count}}", String(n)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "over " + r : r + " geleden" : r;
}, W_ = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, Z_ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, K_ = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, z_ = {
  date: To({
    formats: W_,
    defaultWidth: "full"
  }),
  time: To({
    formats: Z_,
    defaultWidth: "full"
  }),
  dateTime: To({
    formats: K_,
    defaultWidth: "full"
  })
}, G_ = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, q_ = (e, n, t, r) => G_[e], Q_ = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, X_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, J_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, eM = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, tM = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, nM = (e, n) => Number(e) + "e", rM = {
  ordinalNumber: nM,
  era: yn({
    values: Q_,
    defaultWidth: "wide"
  }),
  quarter: yn({
    values: X_,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: yn({
    values: J_,
    defaultWidth: "wide"
  }),
  day: yn({
    values: eM,
    defaultWidth: "wide"
  }),
  dayPeriod: yn({
    values: tM,
    defaultWidth: "wide"
  })
}, oM = /^(\d+)e?/i, sM = /\d+/i, aM = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, iM = {
  any: [/^v/, /^n/]
}, cM = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, lM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, dM = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, fM = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, pM = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, hM = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, mM = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, gM = {
  ordinalNumber: R3({
    matchPattern: oM,
    parsePattern: sM,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: vn({
    matchPatterns: aM,
    defaultMatchWidth: "wide",
    parsePatterns: iM,
    defaultParseWidth: "any"
  }),
  quarter: vn({
    matchPatterns: cM,
    defaultMatchWidth: "wide",
    parsePatterns: lM,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: vn({
    matchPatterns: uM,
    defaultMatchWidth: "wide",
    parsePatterns: dM,
    defaultParseWidth: "any"
  }),
  day: vn({
    matchPatterns: fM,
    defaultMatchWidth: "wide",
    parsePatterns: pM,
    defaultParseWidth: "any"
  }),
  dayPeriod: vn({
    matchPatterns: hM,
    defaultMatchWidth: "any",
    parsePatterns: mM,
    defaultParseWidth: "any"
  })
}, yM = {
  code: "nl",
  formatDistance: U_,
  formatLong: z_,
  formatRelative: q_,
  localize: rM,
  match: gM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
XE("nl", yM);
function Eh({
  control: e,
  name: n,
  defaultValue: t,
  trigger: r,
  minDate: o,
  maxDate: s,
  todayTitle: a,
  placeholder: i,
  label: c,
  error: l,
  rules: u,
  className: d,
  state: f,
  variant: p,
  ...m
}) {
  const {
    t: h
  } = pe(), y = te(tu({
    variant: p,
    className: d,
    state: f
  })), C = ie(null), [v, w] = K(), x = {}, D = `input_${n}`;
  o && (x.minDate = (I) => typeof I == "string" ? !0 : I.getTime() >= o.getTime() || h("text_6600cda50861cc0108cb6d0c")), s && (x.maxDate = (I) => typeof I == "string" ? !0 : I.getTime() <= s.getTime() || h("text_660947791cf255005a25f86a"));
  const {
    field: k
  } = Go({
    control: e,
    name: n,
    defaultValue: t,
    rules: {
      ...u,
      validate: x
    }
  }), {
    onChange: _,
    value: M,
    onBlur: T
  } = k, N = (I) => {
    const O = I.target.value;
    if (typeof O != "string")
      return;
    const [$, j, Y] = O.split("-").map(Number), F = /* @__PURE__ */ new Date(), V = j || F.getMonth() + 1, Q = `${Y || F.getFullYear()}/${V}/${$}`, X = new Date(Q);
    _(Vo(X) ? X : "");
  };
  return /* @__PURE__ */ P(he.div, {
    transition: Ce,
    layoutId: D,
    className: "relative [&>*]:w-full",
    layout: "position",
    children: [/* @__PURE__ */ g(Xi, {
      id: D,
      label: c
    }), /* @__PURE__ */ g(j_, {
      className: y,
      id: D,
      title: D,
      name: n,
      autoComplete: "off",
      popperPlacement: "bottom-start",
      showPopperArrow: !1,
      locale: "nl",
      dateFormat: "dd-MM-yyyy",
      ...m,
      selected: M,
      onBlur: T,
      onFocus: () => w(M),
      onChangeRaw: N,
      onChange: (I) => {
        if (!I)
          return;
        const O = new Date(I.toDateString());
        _(O);
      },
      onCalendarClose: () => r == null ? void 0 : r(n),
      todayButton: a,
      placeholderText: i,
      ref: C,
      minDate: o,
      maxDate: s,
      openToDate: M,
      onKeyDown: (I) => {
        var O;
        switch (I.code) {
          case "Tab":
            (O = C.current) == null || O.setOpen(!1);
            break;
          case "Escape":
            _(v);
            break;
        }
      }
    }), /* @__PURE__ */ g(jt, {
      name: n,
      error: l
    })]
  });
}
Eh.displayName = "DateInput";
function _u({
  hasDynamicOptions: e,
  ...n
}) {
  const {
    options: t,
    className: r,
    disabled: o
  } = n, s = e ? t : Et(() => t, []);
  return /* @__PURE__ */ g(q6, {
    ...n,
    className: te(r, !o && "cursor-pointer"),
    readOnly: !0,
    options: s
  });
}
const vM = Er(te("relative w-full rounded border border-border/40 px-4 py-3", "[&>svg]:absolute [&>svg~*]:pl-8 [&>svg~*]:pt-1 [&>svg+div]:translate-y-[-3px] [&>svg]:left-4 [&>svg]:top-3.5", "text-left [&>svg]:text-foreground [&>svg]:w-5 [&>svg]:h-5"), {
  variants: {
    variant: {
      base: te("bg-border/20 text-foreground"),
      success: te("border-success/50 bg-success/10 dark:border-success", "text-foreground [&>svg]:text-success"),
      destructive: te("border-destructive/50 bg-destructive/10 dark:border-destructive", "text-destructive [&>svg]:text-destructive")
    }
  },
  defaultVariants: {
    variant: "base"
  }
}), Li = xe(({
  className: e,
  variant: n,
  ...t
}, r) => /* @__PURE__ */ g("div", {
  ref: r,
  role: "alert",
  className: te(vM({
    variant: n
  }), e),
  ...t
}));
function _h({
  className: e,
  children: n
}) {
  return /* @__PURE__ */ g(Ee, {
    className: te("mb-1 text-inherit leading-none tracking-tight", e),
    element: "h5",
    weight: "normal",
    children: n
  });
}
const Ti = xe(({
  className: e,
  ...n
}, t) => /* @__PURE__ */ g("div", {
  ref: t,
  className: te("text-sm font-thin [&_p]:leading-relaxed", e),
  ...n
})), Uo = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 5.5V6.5H8.5V5.5H7.5Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C4.68629 2 2 4.68629 2 8C2 10.6688 3.7428 12.9319 6.1537 13.7107L5.8463 14.6623C3.03467 13.754 1 11.1153 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.685 12.1528 14.7046 8.53792 14.9796C7.9476 15.0245 7.5 14.5418 7.5 14V8H8.5V13.9795C11.5795 13.7257 14 11.1453 14 8C14 4.68629 11.3137 2 8 2Z", fill: "current" }));
function bM(e) {
  const n = ie({
    value: e,
    previous: e
  });
  return Et(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [
    e
  ]);
}
function CM(e) {
  const [n, t] = K(void 0);
  return Rs(() => {
    if (e) {
      t({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, i = l.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        t({
          width: a,
          height: i
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      t(void 0);
  }, [
    e
  ]), n;
}
const Mh = "Switch", [wM, uN] = Xo(Mh), [xM, DM] = wM(Mh), SM = /* @__PURE__ */ xe((e, n) => {
  const { __scopeSwitch: t, name: r, checked: o, defaultChecked: s, required: a, disabled: i, value: c = "on", onCheckedChange: l, ...u } = e, [d, f] = K(null), p = An(
    n,
    (v) => f(v)
  ), m = ie(!1), h = d ? !!d.closest("form") : !0, [y = !1, C] = ta({
    prop: o,
    defaultProp: s,
    onChange: l
  });
  return /* @__PURE__ */ le(xM, {
    scope: t,
    checked: y,
    disabled: i
  }, /* @__PURE__ */ le(Gt.button, Ie({
    type: "button",
    role: "switch",
    "aria-checked": y,
    "aria-required": a,
    "data-state": kh(y),
    "data-disabled": i ? "" : void 0,
    disabled: i,
    value: c
  }, u, {
    ref: p,
    onClick: Wn(e.onClick, (v) => {
      C(
        (w) => !w
      ), h && (m.current = v.isPropagationStopped(), m.current || v.stopPropagation());
    })
  })), h && /* @__PURE__ */ le(MM, {
    control: d,
    bubbles: !m.current,
    name: r,
    value: c,
    checked: y,
    required: a,
    disabled: i,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), EM = "SwitchThumb", _M = /* @__PURE__ */ xe((e, n) => {
  const { __scopeSwitch: t, ...r } = e, o = DM(EM, t);
  return /* @__PURE__ */ le(Gt.span, Ie({
    "data-state": kh(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: n
  }));
}), MM = (e) => {
  const { control: n, checked: t, bubbles: r = !0, ...o } = e, s = ie(null), a = bM(t), i = CM(n);
  return W(() => {
    const c = s.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== t && d) {
      const f = new Event("click", {
        bubbles: r
      });
      d.call(c, t), c.dispatchEvent(f);
    }
  }, [
    a,
    t,
    r
  ]), /* @__PURE__ */ le("input", Ie({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: t
  }, o, {
    tabIndex: -1,
    ref: s,
    style: {
      ...e.style,
      ...i,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function kh(e) {
  return e ? "checked" : "unchecked";
}
const kM = SM, AM = _M;
function Ah({
  className: e,
  control: n,
  name: t,
  rules: r,
  defaultValue: o,
  ...s
}) {
  const a = `switch_${t}`, {
    field: i
  } = Go({
    control: n,
    name: t,
    rules: r,
    defaultValue: o
  }), {
    onChange: c,
    ref: l,
    value: u,
    onBlur: d
  } = i;
  return /* @__PURE__ */ g(kM, {
    "aria-label": a,
    id: a,
    "data-testid": a,
    className: te("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full", "border-2 border-transparent transition-colors", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-app-background", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:bg-secondary data-[state=unchecked]:bg-input", e),
    onBlur: d,
    checked: u,
    ref: l,
    onCheckedChange: c,
    ...s,
    children: /* @__PURE__ */ g(AM, {
      className: te("pointer-events-none block size-5 rounded-full bg-app-background shadow-lg ring-0 transition-transform", "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0")
    })
  });
}
function NM({
  control: e,
  disabled: n
}) {
  const {
    t
  } = pe();
  return /* @__PURE__ */ P(he.div, {
    className: te("flex flex-col p-4 gap-2 bg-primary/20 rounded", n && "bg-border/20"),
    layoutId: "invoice_extension",
    layout: "position",
    transition: Ce,
    children: [/* @__PURE__ */ g(oe, {
      weight: "normal",
      size: "sm",
      children: t("text_6600cda50861cc0108cb6cd5")
    }), /* @__PURE__ */ P("div", {
      className: "flex justify-between items-start gap-2",
      children: [/* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        children: t("text_6600cda50861cc0108cb6cd6")
      }), /* @__PURE__ */ g(Ah, {
        disabled: n,
        name: "extension",
        control: e
      })]
    })]
  });
}
const xo = "invoice_upload", ol = `${xo}_input`, LM = 128;
function TM({
  hasError: e
}) {
  const n = dt(), t = "p-1 shrink-0 bg-secondary rounded-full text-secondary-foreground", r = "size-[22px]";
  return n ? /* @__PURE__ */ g(Ji, {
    className: r
  }) : e ? /* @__PURE__ */ g(U6, {
    className: te(r, t, "p-[5px] bg-destructive")
  }) : /* @__PURE__ */ g(Qi, {
    className: te(r, t)
  });
}
function PM({
  disabled: e,
  isLoading: n,
  ...t
}) {
  var x;
  const r = ie(null), {
    t: o
  } = pe(), {
    setValue: s,
    watch: a,
    formState: i,
    setError: c,
    clearErrors: l
  } = t, {
    errors: u
  } = i, {
    file: d
  } = a(), f = (x = u.file) == null ? void 0 : x.message, p = {
    ".jpg": "image/jpeg",
    ".png": "image/png",
    ".pdf": "application/pdf"
  }, m = Object.keys(p).join(","), h = !!f, y = !!d, C = (D) => {
    l("file");
    const k = Object.values(p), _ = D.target.files ?? [], [M] = _;
    if (!M)
      return;
    if (M.name.length > LM) {
      const N = o("text_660b23684edb130076c75d26");
      c("file", {
        type: "name_length",
        message: N
      });
    }
    const T = k.includes(M.type);
    s("file", T ? M : void 0);
  }, v = /* @__PURE__ */ P("button", {
    className: te("flex items-center w-full gap-4 p-4", "text-foreground text-sm font-thin text-left", "border border-dashed rounded border-input", "disabled:bg-input-disabled disabled:text-input-disabled-foreground", !n && "hover:bg-primary/10"),
    type: "button",
    disabled: e || n,
    name: xo,
    "data-testid": xo,
    id: xo,
    "aria-label": xo,
    onClick: () => {
      var D;
      return (D = r.current) == null ? void 0 : D.click();
    },
    children: [n ? /* @__PURE__ */ g(Ji, {
      className: "size-[22px]"
    }) : /* @__PURE__ */ g(W6, {
      className: "size-[22px] p-[5px] shrink-0 bg-secondary rounded-full text-secondary-foreground"
    }), /* @__PURE__ */ P("div", {
      className: "flex flex-col",
      children: [/* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        children: o("text_6600cda50861cc0108cb6cca")
      }), /* @__PURE__ */ g(oe, {
        className: "text-foreground/50",
        weight: "thin",
        size: "sm",
        children: o("text_6600cda50861cc0108cb6ccb")
      })]
    })]
  }), w = /* @__PURE__ */ P("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ P("div", {
      className: "flex flex-col",
      children: [/* @__PURE__ */ P("div", {
        className: te("flex p-4 justify-between items-center gap-2 border border-border rounded", h && "border-destructive"),
        children: [/* @__PURE__ */ g(oe, {
          className: "truncate",
          weight: "thin",
          size: "sm",
          children: (d == null ? void 0 : d.name) ?? o("text_66130a825ac10f007698517a")
        }), /* @__PURE__ */ g(TM, {
          hasError: h
        })]
      }), /* @__PURE__ */ g(jt, {
        name: xo,
        error: f
      })]
    }), /* @__PURE__ */ g(he.div, {
      layoutId: "invoice_change",
      layout: "position",
      transition: Ce,
      children: /* @__PURE__ */ g(Re, {
        name: "invoice_change",
        onClick: () => {
          var D;
          return (D = r.current) == null ? void 0 : D.click();
        },
        variant: "outline",
        className: "w-full",
        disabled: e || n,
        children: o("text_6600cda50861cc0108cb6ce2")
      })
    })]
  });
  return /* @__PURE__ */ P(Zo, {
    children: [y ? w : v, /* @__PURE__ */ g("input", {
      className: "hidden",
      type: "file",
      name: ol,
      "data-testid": ol,
      id: ol,
      accept: m,
      ref: r,
      onChange: C,
      tabIndex: -1,
      disabled: e
    })]
  });
}
const Mu = "invoice_form", OM = 1e3, RM = 1e5, IM = 10, FM = 24 * 60 * 60 * 1e3, VM = 90;
function Nh({
  onSubmit: e,
  prefill: n,
  ...t
}) {
  var Q, X, z, me, Me, Be;
  const {
    state: r
  } = ue(), {
    t: o
  } = pe(), {
    requester: s
  } = r, {
    kvkNumber: a
  } = s, i = dt(), [c, l] = K(!0), [u, d] = K(!1), {
    formState: f,
    watch: p,
    setValue: m,
    register: h,
    control: y,
    resetField: C,
    trigger: v,
    getValues: w
  } = t, {
    errors: x
  } = f, {
    debtor_b2c: D,
    debtor_b2b: k,
    debtor_type: _,
    period: M,
    file: T
  } = p(), [N] = K(!!T), I = Yw(n, D ?? k), O = Uw(n), $ = !!D || jl(k), j = M && (M == null ? void 0 : M.value) > 60, Y = /* @__PURE__ */ new Date();
  Y.setDate(Y.getDate() - IM), Y.setHours(0, 0, 0, 0);
  const F = [{
    id: 1,
    title: ot.t("text_6600cda50861cc0108cb6cd9"),
    value: 14
  }, {
    id: 2,
    title: ot.t("text_6600cda50861cc0108cb6cda"),
    value: 30
  }, {
    id: 3,
    title: ot.t("text_6600cda50861cc0108cb6cdb"),
    value: 45
  }, {
    id: 4,
    title: ot.t("text_6600cda50861cc0108cb6cdc"),
    value: 60
  }, {
    id: 5,
    title: ot.t("text_6600cda50861cc0108cb6cdd"),
    value: 90
  }], V = () => {
    var Ae;
    const ve = !!((Ae = x.file) != null && Ae.message);
    l(ve), d(!1);
  }, J = (ve, Ae) => {
    if (!ve || !Ae) {
      C("period");
      return;
    }
    const Te = new Date(ve), G = new Date(Ae), fe = F.map((ke) => ke.value).sort(), _e = (G.valueOf() - Te.valueOf()) / FM, Fe = fe.find((ke) => ke >= _e), Je = F.find((ke) => ke.value === Fe);
    Je && m("period", Je);
  };
  return W(() => {
    T && (C("amount"), C("invoice_id"), C("issue_date"), C("period"), C("extension"));
  }, [T]), W(() => {
    const {
      issue_date: ve,
      deadline_date: Ae
    } = w();
    if (!ve || !Ae)
      return;
    const Te = Gn(ve), G = Gn(Ae);
    J(Te, G);
  }, []), W(() => {
    !n || u || (J(n == null ? void 0 : n.issueDate, n == null ? void 0 : n.deadlineDate), n != null && n.amount && v("amount"), n != null && n.invoiceId && v("invoice_id"), n != null && n.issueDate && v("issue_date"));
  }, [n, u]), W(() => {
    j && m("extension", !1);
  }, [M]), W(() => d(!0), [T == null ? void 0 : T.name]), /* @__PURE__ */ P("form", {
    onSubmit: e,
    className: "flex flex-col w-full gap-4",
    id: Mu,
    children: [/* @__PURE__ */ P("div", {
      className: "flex flex-col gap-1",
      children: [/* @__PURE__ */ g(oe, {
        weight: "light",
        size: "sm",
        element: "div",
        children: o("text_6600cda50861cc0108cb6cc5")
      }), /* @__PURE__ */ P("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ g(Re, {
          variant: "outline_thin",
          name: "debtor_type_b2c",
          className: te("flex-1 px-2", _ === "B2C" && "border-primary"),
          size: "lg",
          disabled: N,
          onClick: () => m("debtor_type", "B2C"),
          children: o("text_6600cda50861cc0108cb6cc6")
        }), /* @__PURE__ */ g(Re, {
          variant: "outline_thin",
          name: "debtor_type_b2b",
          className: te("flex-1 px-2", _ === "B2B" && "border-primary"),
          size: "lg",
          disabled: N,
          onClick: () => m("debtor_type", "B2B"),
          children: o("text_6600cda50861cc0108cb6cc7")
        })]
      })]
    }), /* @__PURE__ */ P(kt, {
      mode: "wait",
      children: [_ === "B2C" && /* @__PURE__ */ g(he.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: Ce,
        children: /* @__PURE__ */ g(Hr, {
          label: o("text_6600cda50861cc0108cb6cdf"),
          placeholder: o("text_6600cda50861cc0108cb6ce0"),
          autoComplete: "on",
          disabled: N,
          error: (Q = x.debtor_b2c) == null ? void 0 : Q.message,
          ...h("debtor_b2c", {
            required: o(pt.required),
            shouldUnregister: !0,
            validate: {
              debtorIsRequester: (ve) => s.company ? yi(ve, s.company) < VM || o("text_6600cda50861cc0108cb6d02") : !0
            }
          })
        })
      }, _), _ === "B2B" && /* @__PURE__ */ g(he.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: Ce,
        children: /* @__PURE__ */ g(Q6, {
          label: o("text_6600cda50861cc0108cb6cc8"),
          placeholder: o("text_6600cda50861cc0108cb6cc9"),
          name: "debtor_b2b",
          disabled: N,
          ...t,
          rules: {
            validate: {
              debtorIsRequester: (ve) => jl(ve) && (ve == null ? void 0 : ve.kvkNumber) !== a || o("text_6600cda50861cc0108cb6d02")
            }
          }
        })
      }, _)]
    }), /* @__PURE__ */ g(kt, {
      mode: "wait",
      children: ($ || T) && /* @__PURE__ */ P(he.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: Ce,
        layout: "position",
        layoutId: "invoice_upload",
        className: "flex flex-col gap-4",
        children: [/* @__PURE__ */ g(PM, {
          isLoading: i,
          disabled: N,
          ...t
        }), /* @__PURE__ */ g(kt, {
          mode: "wait",
          children: !i && T && !((X = x.file) != null && X.message) && /* @__PURE__ */ P(he.div, {
            className: "flex flex-col gap-4",
            initial: {
              opacity: 0
            },
            animate: {
              transition: {
                ...Ce,
                delay: c ? Ao : 0
              },
              opacity: 1
            },
            exit: {
              opacity: 0
            },
            onAnimationComplete: V,
            transition: Ce,
            layoutId: "invoice_details",
            children: [/* @__PURE__ */ g(no, {
              className: "w-full"
            }), /* @__PURE__ */ g(kt, {
              mode: "wait",
              children: I && /* @__PURE__ */ g(he.div, {
                layoutId: "notification_debtor_check",
                layout: "position",
                initial: {
                  opacity: 0
                },
                animate: {
                  opacity: 1,
                  transition: {
                    ...Ce,
                    delay: Ao
                  }
                },
                exit: {
                  opacity: 0
                },
                transition: Ce,
                children: /* @__PURE__ */ P(Li, {
                  children: [/* @__PURE__ */ g(Uo, {
                    className: "size-6 fill-foreground"
                  }), /* @__PURE__ */ g(Ti, {
                    children: o(I)
                  })]
                })
              }, I)
            }), /* @__PURE__ */ g(kt, {
              mode: "wait",
              children: O && /* @__PURE__ */ g(he.div, {
                layoutId: "notification_requester_check",
                layout: "position",
                initial: {
                  opacity: 0
                },
                animate: {
                  opacity: 1,
                  transition: {
                    ...Ce,
                    delay: Ao
                  }
                },
                exit: {
                  opacity: 0
                },
                transition: Ce,
                children: /* @__PURE__ */ P(Li, {
                  children: [/* @__PURE__ */ g(Uo, {
                    className: "size-6 fill-foreground"
                  }), /* @__PURE__ */ g(Ti, {
                    children: o(O)
                  })]
                })
              }, I)
            }), /* @__PURE__ */ g(hx, {
              label: o("text_6600cda50861cc0108cb6ccc"),
              placeholder: o("text_6600cda50861cc0108cb6cce"),
              control: y,
              value: 100,
              name: "amount",
              error: (z = x.amount) == null ? void 0 : z.message,
              rules: {
                required: o(pt.required),
                validate: {
                  amount: (ve) => JC(ve, OM, RM) || o("text_6600cda50861cc0108cb6d0a")
                }
              }
            }), /* @__PURE__ */ g(Hr, {
              label: o("text_6600cda50861cc0108cb6ccf"),
              placeholder: o("text_6600cda50861cc0108cb6cd0"),
              autoComplete: "on",
              error: (me = x.invoice_id) == null ? void 0 : me.message,
              ...h("invoice_id", {
                required: o(pt.required)
              })
            }), /* @__PURE__ */ g(Eh, {
              label: o("text_6600cda50861cc0108cb6cd1"),
              placeholder: o("text_6600cda50861cc0108cb6cd2"),
              control: y,
              name: "issue_date",
              trigger: v,
              todayTitle: o("text_6600cda50861cc0108cb6cde"),
              error: (Me = x.issue_date) == null ? void 0 : Me.message,
              minDate: Y,
              maxDate: /* @__PURE__ */ new Date(),
              rules: {
                required: o(pt.required)
              }
            }), /* @__PURE__ */ g(_u, {
              label: o("text_6600cda50861cc0108cb6cd3"),
              placeholder: o("text_6600cda50861cc0108cb6cd4"),
              control: y,
              name: "period",
              optionHeight: "sm",
              error: (Be = x.period) == null ? void 0 : Be.message,
              options: F,
              displayValue: (ve) => ve.title,
              rules: {
                required: o(pt.required)
              }
            }), /* @__PURE__ */ g(NM, {
              disabled: j,
              control: y
            })]
          }, T.name)
        })]
      }, T ? "file" : _)
    })]
  });
}
function $M({
  setView: e
}) {
  const {
    t: n
  } = pe(), {
    actions: t
  } = ue(), [r, o] = K(), [s, a] = K(!1), [i, c] = K(), l = Sr({
    mode: "onBlur",
    defaultValues: {
      extension: !1
    }
  }), {
    handleSubmit: u,
    watch: d,
    setError: f,
    formState: p,
    trigger: m,
    setValue: h
  } = l, {
    isValid: y
  } = p, {
    file: C
  } = d(), v = y && C, w = async (x) => {
    var me;
    if (!C)
      return;
    o(void 0), a(!0);
    const {
      amount: D,
      period: k,
      debtor_type: _,
      extension: M
    } = x, T = new Date(x.issue_date);
    T.setDate(x.issue_date.getDate() + k.value);
    const N = Gn(x.issue_date), I = Gn(T);
    if (!N || !I)
      throw new Error("One of the date is invalid");
    const O = x.invoice_id.trim(), $ = x.debtor_b2b ?? x.debtor_b2c, j = typeof $ == "string" ? $ : $.title, Y = (Me) => Me ? "OCR" : "USER", F = i != null && i.issueDate ? new Date(i.issueDate) === x.issue_date : !1, V = i != null && i.deadlineDate ? new Date(i.deadlineDate) === T : !1, J = {
      invoiceId: Y((i == null ? void 0 : i.invoiceId) === O),
      invoiceAmount: Y((i == null ? void 0 : i.amount) === D),
      invoiceIssueDate: Y(F),
      invoiceDeadlineDate: Y(V)
    }, Q = typeof $ == "string" ? void 0 : $.kvkNumber, X = typeof $ == "string" ? void 0 : $.id, z = {
      invoiceId: O,
      amount: D,
      issueDate: N,
      deadlineDate: I,
      debtorName: j,
      debtorType: _,
      debtorCompanyId: X,
      debtorKvk: Q,
      invoiceLineItems: i == null ? void 0 : i.lineItems,
      dataSource: J,
      thirtyDaysExtension: M
    };
    try {
      const {
        data: Me
      } = await N6({
        invoice: z,
        file: C
      }), {
        eligible: Be,
        invoicesData: ve,
        message: Ae
      } = Me;
      if (Ae === "SBI_CODE_INVALID") {
        f("debtor_b2b", {
          message: n("text_6600cda50861cc0108cb6d04"),
          type: "invalid_sbi"
        });
        return;
      }
      if (!Be) {
        o(Os);
        return;
      }
      const G = ve[O];
      if (!G)
        return;
      const {
        preliminaryOffer: fe
      } = G, {
        interestCost: De,
        interestRate: _e,
        invoiceAmount: Fe,
        loanAmount: Je
      } = fe, ke = {
        id: O,
        interestCost: De,
        interestRate: _e,
        invoiceAmount: Fe,
        file: C,
        loanAmount: Je,
        invoiceIban: i == null ? void 0 : i.invoiceIban,
        ...z
      };
      t({
        type: "set_offers",
        payload: []
      }), t({
        type: "add_invoice",
        payload: ke
      }), e("overview");
    } catch (Me) {
      if (!Zr(Me))
        return;
      const ve = (((me = Me == null ? void 0 : Me.response) == null ? void 0 : me.data) ?? {}).errorCode, Te = (ve && eu[ve]) ?? un(Me);
      o(Te), a(!1);
    }
  };
  return W(() => {
    if (!C)
      return;
    (async () => {
      var D;
      t({
        page: "invoice",
        type: "set_is_loading",
        payload: !0
      });
      try {
        const {
          data: k
        } = await M3(C), _ = k.amount ? Math.floor(k.amount / 100) : void 0;
        c({
          ...k,
          amount: _
        }), _ && h("amount", _), k != null && k.invoiceId && h("invoice_id", k.invoiceId), k != null && k.issueDate && h("issue_date", new Date(k.issueDate)), m();
      } catch (k) {
        if (!Zr(k) || ((D = k == null ? void 0 : k.response) == null ? void 0 : D.status) !== 413)
          return;
        f("file", {
          message: n("text_6600cda50861cc0108cb6d08"),
          type: "file_too_big"
        });
      } finally {
        t({
          page: "invoice",
          type: "set_is_loading",
          payload: !1
        });
      }
    })();
  }, [C]), /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: n("text_6600cda50861cc0108cb6cc4")
        })
      }), /* @__PURE__ */ g(Nh, {
        prefill: i,
        onSubmit: u(w),
        ...l
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!r,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ g(Re, {
          className: "w-full shadow-md",
          name: "submit",
          disabled: !v,
          form: Mu,
          type: "submit",
          isLoading: s,
          children: n("text_6600cda50861cc0108cb6cd8")
        }), /* @__PURE__ */ g(jt, {
          error: r && n(r),
          className: "text-center",
          name: "eligibility_error"
        })]
      })
    })]
  });
}
function BM({
  setView: e
}) {
  const {
    state: n
  } = ue(), {
    selectedInvoice: t
  } = n, {
    companies: r
  } = nu({
    searchValue: t == null ? void 0 : t.debtorKvk
  }), [o] = r, s = {
    debtor_type: t == null ? void 0 : t.debtorType,
    invoice_id: t == null ? void 0 : t.invoiceId,
    file: t == null ? void 0 : t.file,
    amount: t == null ? void 0 : t.amount,
    extension: (t == null ? void 0 : t.thirtyDaysExtension) ?? !1
  };
  t != null && t.issueDate && (s.issue_date = new Date(t.issueDate)), t != null && t.deadlineDate && (s.deadline_date = new Date(t.deadlineDate)), (t == null ? void 0 : t.debtorType) === "B2C" && (s.debtor_b2c = t == null ? void 0 : t.debtorName);
  const a = Sr({
    mode: "onBlur",
    defaultValues: s
  }), {
    t: i
  } = pe(), {
    actions: c
  } = ue(), [l, u] = K(), [d, f] = K(!1), {
    handleSubmit: p,
    watch: m,
    formState: h,
    trigger: y,
    setValue: C
  } = a, {
    isValid: v
  } = h, {
    file: w
  } = m(), x = v && w, D = async (k) => {
    var X;
    if (!w)
      return;
    u(void 0), f(!0);
    const {
      amount: _,
      period: M,
      debtor_type: T,
      extension: N
    } = k, I = new Date(k.issue_date);
    I.setDate(k.issue_date.getDate() + M.value);
    const O = Gn(k.issue_date), $ = Gn(I);
    if (!O || !$)
      throw new Error("One of the date is invalid");
    const j = k.invoice_id.trim(), Y = k.debtor_b2b ?? k.debtor_b2c, F = typeof Y == "string" ? Y : Y.title, V = typeof Y == "string" ? void 0 : Y.kvkNumber, J = typeof Y == "string" ? void 0 : Y.id, Q = {
      invoiceId: j,
      amount: _,
      issueDate: O,
      deadlineDate: $,
      debtorName: F,
      debtorType: T,
      debtorCompanyId: J,
      debtorKvk: V,
      thirtyDaysExtension: N
    };
    if (t != null && t.dataSource) {
      const z = {
        ...t.dataSource
      };
      (t == null ? void 0 : t.invoiceId) !== j && (z.invoiceId = "USER"), (t == null ? void 0 : t.amount) !== _ && (z.invoiceAmount = "USER"), (t == null ? void 0 : t.issueDate) !== O && (z.invoiceIssueDate = "USER"), (t == null ? void 0 : t.deadlineDate) !== $ && (z.invoiceDeadlineDate = "USER"), Q.dataSource = z;
    }
    try {
      const z = t == null ? void 0 : t.invoiceId, me = t == null ? void 0 : t.id;
      if (!z || !me)
        throw new Error("Original ID is not available to use the edit");
      const {
        data: Me
      } = await L6(Q, z), {
        eligible: Be,
        invoicesData: ve
      } = Me;
      if (!Be) {
        u(Os);
        return;
      }
      const Ae = ve[j];
      if (!Ae)
        return;
      const {
        preliminaryOffer: Te
      } = Ae, {
        interestCost: G,
        interestRate: fe,
        invoiceAmount: De,
        loanAmount: _e
      } = Te, Fe = {
        id: me,
        interestCost: G,
        interestRate: fe,
        invoiceAmount: De,
        file: w,
        loanAmount: _e,
        ...Q
      };
      c({
        type: "set_offers",
        payload: []
      }), c({
        type: "add_invoice",
        payload: Fe
      }), e("overview");
    } catch (z) {
      if (!Zr(z))
        return;
      const Me = (((X = z == null ? void 0 : z.response) == null ? void 0 : X.data) ?? {}).errorCode, ve = (Me && eu[Me]) ?? un(z);
      u(ve), f(!1);
    }
  };
  return W(() => {
    !o || (t == null ? void 0 : t.debtorType) !== "B2B" || (C("debtor_b2b", o), y("debtor_b2b"));
  }, [r]), /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: i("text_6600cda50861cc0108cb6cc4")
        })
      }), /* @__PURE__ */ g(Nh, {
        onSubmit: p(D),
        ...a
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!l,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ P("div", {
          className: "flex w-full gap-2",
          children: [/* @__PURE__ */ g(Re, {
            className: "w-fit",
            disabled: d,
            name: "back",
            onClick: () => e("overview"),
            variant: "outline",
            children: i("text_65f533dea3bf5f00996bd1d3")
          }), /* @__PURE__ */ g(Re, {
            className: "w-full shadow-md",
            name: "submit",
            disabled: !x,
            form: Mu,
            type: "submit",
            isLoading: d,
            children: i("text_660f23543f0fed0102d3f194")
          })]
        }), /* @__PURE__ */ g(jt, {
          error: l && i(l),
          className: "text-center",
          name: "eligibility_error"
        })]
      })
    })]
  });
}
const jM = 60, Lh = 30;
function sl({
  label: e,
  value: n
}) {
  return /* @__PURE__ */ P("div", {
    className: "flex justify-between",
    children: [/* @__PURE__ */ g(oe, {
      className: "truncate whitespace-nowrap",
      size: "sm",
      weight: "thin",
      children: e
    }), /* @__PURE__ */ g(oe, {
      size: "sm",
      weight: "thin",
      children: n
    })]
  });
}
function YM({
  invoice: e,
  setError: n
}) {
  const {
    state: t,
    actions: r
  } = ue(), {
    offers: o
  } = t, {
    t: s
  } = pe(), a = dt(), {
    control: i,
    watch: c,
    formState: l
  } = Sr({
    mode: "all",
    values: {
      extension: e.thirtyDaysExtension
    }
  }), {
    isDirty: u
  } = l, {
    extension: d
  } = c(), f = (e.interestRate * 100).toFixed(2), p = o.length > 0, m = new Date(e.issueDate), h = new Date(e.deadlineDate), y = new Date(e.deadlineDate);
  e.thirtyDaysExtension && y.setDate(y.getDate() + Lh);
  const v = rb(m, h) <= jM;
  return W(() => {
    if (!u)
      return;
    (async () => {
      var k;
      r({
        type: "set_is_loading",
        page: "invoice",
        payload: !0
      });
      const {
        id: x
      } = e;
      if (!x)
        throw new Error("Invoice ID is not available");
      const D = {
        ...e,
        thirtyDaysExtension: d
      };
      try {
        const {
          data: _
        } = await L6(D, x), {
          invoicesData: M
        } = _, T = M[x];
        if (!T)
          return;
        const {
          preliminaryOffer: N
        } = T, I = {
          ...D,
          ...N
        };
        r({
          type: "add_invoice",
          payload: I
        }), r({
          type: "set_offers",
          payload: []
        });
      } catch (_) {
        if (!Zr(_))
          return;
        const T = (((k = _ == null ? void 0 : _.response) == null ? void 0 : k.data) ?? {}).errorCode, I = (T && eu[T]) ?? un(_);
        n(I);
      } finally {
        r({
          type: "set_is_loading",
          page: "invoice",
          payload: !1
        });
      }
    })();
  }, [d]), /* @__PURE__ */ P(he.div, {
    className: "flex flex-col w-full p-4 gap-2 border border-border/20 rounded",
    transition: Ce,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    layoutId: e.id,
    children: [/* @__PURE__ */ P("div", {
      className: "flex w-full items-center justify-between",
      children: [/* @__PURE__ */ g(oe, {
        size: "sm",
        children: e.debtorName
      }), /* @__PURE__ */ g(oe, {
        size: "sm",
        children: Kr(e.invoiceAmount)
      })]
    }), /* @__PURE__ */ P("div", {
      children: [/* @__PURE__ */ g(sl, {
        label: s("text_664d85945993f901960bc4f3"),
        value: e.invoiceId
      }), /* @__PURE__ */ g(sl, {
        label: s("text_664d85945993f901960bc4f5", {
          rate: f
        }),
        value: Kr(e.interestCost)
      }), /* @__PURE__ */ g(sl, {
        label: s("text_664d85945993f901960bc4f7"),
        value: nb(y)
      })]
    }), /* @__PURE__ */ P("div", {
      className: "flex justify-between items-center p-2 gap-4 rounded bg-border/20",
      children: [/* @__PURE__ */ g(oe, {
        size: "sm",
        children: s("text_664d85945993f901960bc4f9")
      }), /* @__PURE__ */ g(Ah, {
        disabled: !v || a || p,
        name: "extension",
        control: i
      })]
    })]
  }, e.id);
}
function HM() {
  const [e, n] = K(), t = dt(), {
    t: r
  } = pe(), {
    state: o,
    actions: s
  } = ue(), {
    invoices: a
  } = o, i = a.reduce((u, d) => d.invoiceAmount + u, 0), c = a.reduce((u, d) => d.interestCost + u, 0), l = () => {
    s({
      type: "set_page",
      payload: "transactions"
    });
  };
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: r("text_6600cda50861cc0108cb6ce6")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          children: r("text_664d844fe72b5000ff1700ec")
        })]
      }), /* @__PURE__ */ g("div", {
        className: "flex flex-col w-full gap-4",
        children: /* @__PURE__ */ g(kt, {
          children: a.map((u) => /* @__PURE__ */ g(YM, {
            invoice: u,
            setError: n
          }, u.id))
        })
      }), /* @__PURE__ */ P(he.div, {
        className: "flex flex-col w-full p-4 gap-4 rounded bg-border/20",
        layoutId: "invoice_summary",
        transition: Ce,
        children: [/* @__PURE__ */ P("div", {
          className: "flex justify-between",
          children: [/* @__PURE__ */ g(oe, {
            className: "truncate whitespace-nowrap",
            size: "sm",
            weight: "normal",
            children: r("text_665462c32c5d7800c42baa95")
          }), /* @__PURE__ */ g(oe, {
            size: "sm",
            weight: "normal",
            children: Kr(i)
          })]
        }), /* @__PURE__ */ P("div", {
          className: "flex justify-between gap-2",
          children: [/* @__PURE__ */ g(oe, {
            className: "truncate whitespace-nowrap",
            size: "sm",
            weight: "thin",
            color: "subtitle",
            children: r("text_665462c32c5d7800c42baa97")
          }), /* @__PURE__ */ g(oe, {
            size: "sm",
            weight: "thin",
            color: "subtitle",
            children: Kr(c)
          })]
        })]
      })]
    }), /* @__PURE__ */ g(zt, {
      className: "gap-2",
      showBlur: !0,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ g(Re, {
          className: "w-full shadow-md",
          name: "submit",
          onClick: l,
          isLoading: t,
          children: r("text_664d837ccd528800bd65df9e")
        }), /* @__PURE__ */ g(jt, {
          error: e && r(e),
          className: "text-center",
          name: "invoice_overview_error"
        }), kn && b0.includes(kn) && /* @__PURE__ */ g(au, {
          className: "text-center",
          color: "subtitle",
          size: "xs",
          weight: "light",
          langKey: "text_664d837ccd528800bd65df9f",
          values: {
            "Algemene Voorwaarden": "text_665c701d42d47f00ff3a7f23",
            "Privacy Statement": "text_665c701d42d47f00ff3a7f24"
          }
        })]
      })
    })]
  });
}
const UM = {
  overview: HM,
  edit_invoice: BM,
  add_invoice: $M
};
function WM() {
  const {
    state: e
  } = ue(), {
    invoices: n
  } = e, r = n.length > 0 ? "overview" : "add_invoice", [o, s] = K(r), a = UM[o], {
    onTransitionEnd: i
  } = Ui(o);
  return /* @__PURE__ */ g(kt, {
    mode: "wait",
    children: /* @__PURE__ */ g(he.div, {
      className: "flex w-full flex-1",
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: Ce,
      onAnimationComplete: i,
      children: /* @__PURE__ */ g(a, {
        setView: s
      })
    }, o)
  });
}
function ZM({
  setView: e
}) {
  const {
    actions: n
  } = ue(), {
    t
  } = pe(), r = () => {
    n({
      type: "show_rejection",
      payload: "TIMEOUT"
    }), n({
      type: "set_is_loading",
      page: "offer",
      payload: !1
    });
  }, o = (a) => {
    n({
      type: "show_rejection",
      payload: a
    }), n({
      type: "set_is_loading",
      page: "offer",
      payload: !1
    });
  }, s = async () => {
    try {
      const {
        data: a
      } = await mv(), i = "ERR_6001", {
        offersList: c,
        eligible: l,
        errorCode: u
      } = a;
      if (u === i)
        return o("RED_SCORE"), !0;
      if (!l)
        return o("GENERIC"), !0;
      if ((c == null ? void 0 : c.length) > 0)
        return n({
          type: "set_offers",
          payload: c
        }), e("overview"), n({
          type: "set_is_loading",
          page: "offer",
          payload: !1
        }), !0;
    } catch {
      o("GENERIC");
    }
    return !1;
  };
  return W(() => {
    const a = Ds({
      delay: 2e3,
      limit: 150,
      fn: s,
      callback: r
    });
    return n({
      type: "set_is_loading",
      page: "offer",
      payload: !0
    }), () => clearInterval(a);
  }, []), /* @__PURE__ */ g(At, {
    children: /* @__PURE__ */ P(Nt, {
      className: "gap-6 pb-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: t("text_6600cda50861cc0108cb6d48")
        })
      }), /* @__PURE__ */ P(Li, {
        children: [/* @__PURE__ */ g(Uo, {
          className: "w-6 h-6 fill-foreground"
        }), /* @__PURE__ */ g(_h, {
          children: t("text_6600cda50861cc0108cb6d49")
        }), /* @__PURE__ */ g(Ti, {
          children: t("text_6600cda50861cc0108cb6d4a")
        })]
      }), /* @__PURE__ */ g(no, {
        className: "w-full"
      })]
    })
  });
}
const KM = {
  AFG: "Afghanistan",
  ALA: "Åland",
  ALB: "Albanië",
  DZA: "Algerije",
  VIR: "Amerikaanse Maagdeneilanden",
  ASM: "Amerikaans-Samoa",
  AND: "Andorra",
  AGO: "Angola",
  AIA: "Anguilla",
  ATA: "Antarctica",
  ATG: "Antigua en Barbuda",
  ARG: "Argentinië",
  ARM: "Armenië",
  ABW: "Aruba",
  AUS: "Australië",
  AZE: "Azerbeidzjan",
  BHS: "Bahama`s",
  BHR: "Bahrein",
  BGD: "Bangladesh",
  BRB: "Barbados",
  BEL: "België",
  BLZ: "Belize",
  BEN: "Benin",
  BMU: "Bermuda",
  BTN: "Bhutan",
  BOL: "Bolivia",
  BIH: "Bosnië en Herzegovina",
  BWA: "Botswana",
  BVT: "Bouveteiland",
  BRA: "Brazilië",
  IOT: "Brits Territorium in Ind. Oc.",
  VGB: "Britse Maagdeneilanden",
  BRN: "Brunei",
  BGR: "Bulgarije",
  BFA: "Burkina Faso",
  BDI: "Burundi",
  KHM: "Cambodja",
  CAN: "Canada",
  BES: "Caribisch Nederland",
  CAF: "Centraal-Afrikaanse Republiek",
  CHL: "Chili",
  CHN: "China",
  CXR: "Christmaseiland",
  CCK: "Cocoseilanden",
  COL: "Colombia",
  COM: "Comoren",
  COG: "Congo-Brazzaville",
  COD: "Congo-Kinshasa",
  COK: "Cookeilanden",
  CRI: "Costa Rica",
  CUB: "Cuba",
  CUW: "Curaçao",
  CYP: "Cyprus",
  DNK: "Denemarken",
  DJI: "Djibouti",
  DMA: "Dominica",
  DOM: "Dominicaanse Republiek",
  DEU: "Duitsland",
  ECU: "Ecuador",
  EGY: "Egypte",
  SLV: "El Salvador",
  GNQ: "Equatoriaal-Guinea",
  ERI: "Eritrea",
  EST: "Estland",
  ETH: "Ethiopië",
  FRO: "Faeröer",
  FLK: "Falklandeilanden",
  FJI: "Fiji",
  PHL: "Filipijnen",
  FIN: "Finland",
  FRA: "Frankrijk",
  ATF: "Franse Zuid. en Antarct. Geb.",
  GUF: "Frans-Guyana",
  PYF: "Frans-Polynesië",
  GAB: "Gabon",
  GMB: "Gambia",
  GEO: "Georgië",
  GHA: "Ghana",
  GIB: "Gibraltar",
  GRD: "Grenada",
  GRC: "Griekenland",
  GRL: "Groenland",
  GLP: "Guadeloupe",
  GUM: "Guam",
  GTM: "Guatemala",
  GGY: "Guernsey",
  GIN: "Guinee",
  GNB: "Guinee-Bissau",
  GUY: "Guyana",
  HTI: "Haïti",
  HMD: "Heard en McDonaldeilanden",
  HND: "Honduras",
  HUN: "Hongarije",
  HKG: "Hongkong",
  IRL: "Ierland",
  ISL: "IJsland",
  IND: "India",
  IDN: "Indonesië",
  IRQ: "Irak",
  IRN: "Iran",
  ISR: "Israël",
  ITA: "Italië",
  CIV: "Ivoorkust",
  JAM: "Jamaica",
  JPN: "Japan",
  YEM: "Jemen",
  JEY: "Jersey",
  JOR: "Jordanië",
  CYM: "Kaaimaneilanden",
  CPV: "Kaapverdië",
  CMR: "Kameroen",
  KAZ: "Kazachstan",
  KEN: "Kenia",
  KGZ: "Kirgizië",
  KIR: "Kiribati",
  UMI: "Kleine afgelegen eilanden VS",
  KWT: "Koeweit",
  RKS: "Kosovo",
  HRV: "Kroatië",
  LAO: "Laos",
  LSO: "Lesotho",
  LVA: "Letland",
  LBN: "Libanon",
  LBR: "Liberia",
  LBY: "Libië",
  LIE: "Liechtenstein",
  LTU: "Litouwen",
  LUX: "Luxemburg",
  MAC: "Macau",
  MDG: "Madagaskar",
  MWI: "Malawi",
  MDV: "Maldiven",
  MYS: "Maleisië",
  MLI: "Mali",
  MLT: "Malta",
  IMN: "Man",
  MAR: "Marokko",
  MHL: "Marshalleilanden",
  MTQ: "Martinique",
  MRT: "Mauritanië",
  MUS: "Mauritius",
  MYT: "Mayotte",
  MEX: "Mexico",
  FSM: "Micronesia",
  MDA: "Moldavië",
  MCO: "Monaco",
  MNG: "Mongolië",
  MNE: "Montenegro",
  MSR: "Montserrat",
  MOZ: "Mozambique",
  MMR: "Myanmar",
  NAM: "Namibië",
  NRU: "Nauru",
  NLD: "Nederland",
  ANT: "Nederlandse Antillen",
  NPL: "Nepal",
  NIC: "Nicaragua",
  NCL: "Nieuw-Caledonië",
  NZL: "Nieuw-Zeeland",
  NER: "Niger",
  NGA: "Nigeria",
  NIU: "Niue",
  MNP: "Noordelijke Marianen",
  PRK: "Noord-Korea",
  MKD: "Noord-Macedonië",
  NOR: "Noorwegen",
  NFK: "Norfolk",
  UGA: "Oeganda",
  UKR: "Oekraïne",
  UZB: "Oezbekistan",
  OMN: "Oman",
  AUT: "Oostenrijk",
  TLS: "Oost-Timor",
  PAK: "Pakistan",
  PLW: "Palau",
  PSE: "Palestina",
  PAN: "Panama",
  PNG: "Papoea-Nieuw-Guinea",
  PRY: "Paraguay",
  PER: "Peru",
  PCN: "Pitcairneilanden",
  POL: "Polen",
  PRT: "Portugal",
  PRI: "Puerto Rico",
  QAT: "Qatar",
  REU: "Réunion",
  ROU: "Roemenië",
  RUS: "Rusland",
  RWA: "Rwanda",
  KNA: "Saint Kitts en Nevis",
  LCA: "Saint Lucia",
  VCT: "Saint Vincent en de Grenadines",
  BLM: "Saint-Barthélemy",
  SPM: "Saint-Pierre en Miquelon",
  SLB: "Salomonseilanden",
  WSM: "Samoa",
  SMR: "San Marino",
  STP: "Sao Tomé en Principe",
  SAU: "Saoedi-Arabië",
  SEN: "Senegal",
  SRB: "Servië",
  SCG: "Servië en Montenegro",
  SYC: "Seychellen",
  SLE: "Sierra Leone",
  SGP: "Singapore",
  SXM: "Sint Maarten (NL)",
  SHN: "Sint-Helena, Ascension, Trist.",
  MAF: "Sint-Maarten (FR)",
  SVN: "Slovenië",
  SVK: "Slowakije",
  SDN: "Soedan",
  SOM: "Somalië",
  ESP: "Spanje",
  SJM: "Spitsbergen en Jan Mayen",
  LKA: "Sri Lanka",
  SUR: "Suriname",
  SWZ: "Swaziland",
  SYR: "Syrië",
  TJK: "Tadzjikistan",
  TWN: "Taiwan",
  TZA: "Tanzania",
  THA: "Thailand",
  TGO: "Togo",
  TKL: "Tokelau",
  TON: "Tonga",
  TTO: "Trinidad en Tobago",
  TCD: "Tsjaad",
  CZE: "Tsjechië",
  TUN: "Tunesië",
  TUR: "Turkije",
  TKM: "Turkmenistan",
  TCA: "Turks- en Caicoseilanden",
  TUV: "Tuvalu",
  URY: "Uruguay",
  VUT: "Vanuatu",
  VAT: "Vaticaanstad",
  VEN: "Venezuela",
  GBR: "Verenigd Koninkrijk",
  ARE: "Verenigde Arabische Emiraten",
  USA: "Verenigde Staten",
  VNM: "Vietnam",
  WLF: "Wallis en Futuna",
  ESH: "Westelijke Sahara",
  BLR: "Wit-Rusland",
  ZAR: "Zaire",
  ZMB: "Zambia",
  ZWE: "Zimbabwe",
  ZAF: "Zuid-Afrika",
  SGS: "Zuid-Georgië en Sandwicheiland",
  KOR: "Zuid-Korea",
  SSD: "Zuid-Soedan",
  SWE: "Zweden",
  CHE: "Zwitserland"
};
function zM({
  control: e,
  disabled: n
}) {
  const {
    t
  } = pe(), r = Object.entries(KM).map(([o, s]) => ({
    id: o,
    title: s
  }));
  return /* @__PURE__ */ g(_u, {
    label: t("text_6600cda50861cc0108cb6d71"),
    placeholder: t("text_6600cda50861cc0108cb6d72"),
    options: r,
    displayValue: (o) => o.title,
    control: e,
    name: "business_countries",
    isMultiSelect: !0,
    disabled: n,
    className: "w-full",
    rules: {
      required: t(pt.required)
    }
  });
}
const jf = "new_to_the_bank_form";
function vo({
  label: e,
  name: n,
  control: t
}) {
  const {
    field: r
  } = Go({
    control: t,
    name: n,
    rules: {
      validate: {
        required: (i) => i != null
      }
    }
  }), {
    t: o
  } = pe(), {
    onChange: s,
    value: a
  } = r;
  return /* @__PURE__ */ P(he.div, {
    className: "flex flex-col w-full gap-1",
    layoutId: n,
    transition: Ce,
    children: [/* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      element: "div",
      children: e
    }), /* @__PURE__ */ P("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ g(Re, {
        variant: "outline_thin",
        name: `${n}_yes`,
        className: te("w-full", a && "border-primary"),
        size: "lg",
        onClick: () => s(!0),
        children: o("text_6610aa01c5154f0083366656")
      }), /* @__PURE__ */ g(Re, {
        variant: "outline_thin",
        name: `${n}_no`,
        className: te("w-full", a === !1 && "border-primary"),
        size: "lg",
        onClick: () => s(!1),
        children: o("text_6610aa0c0db0510092a6511c")
      })]
    })]
  });
}
function GM() {
  const {
    state: e,
    actions: n
  } = ue(), {
    t
  } = pe(), [r, o] = K(), {
    offers: s
  } = e, [a] = s;
  if (!a)
    throw new Error("No offer is available");
  const i = dt(), c = Sr(), {
    handleSubmit: l,
    watch: u,
    formState: d
  } = c, {
    isValid: f
  } = d, {
    foreign_business: p
  } = u(), m = async (h) => {
    const {
      is_dutch_citizen: y,
      business_countries: C,
      is_us_person: v,
      is_born_in_us: w,
      has_lived_abroad: x,
      is_multi_company: D
    } = h, k = {
      businessInOtherCountry: p,
      nlTaxResident: y,
      usPerson: v,
      usBorn: w,
      liveAbroad3years: x,
      multipleCompanies: D
    };
    p && (k.countryName = C.map(({
      id: _
    }) => `${_}`)), n({
      type: "set_is_loading",
      page: "offer",
      payload: !0
    });
    try {
      const {
        data: _
      } = await gv(k), {
        eligible: M
      } = _;
      if (!M) {
        n({
          type: "show_rejection",
          payload: "NEW_TO_THE_BANK"
        });
        return;
      }
      await T6(a), n({
        type: "set_page",
        payload: "next"
      });
    } catch (_) {
      const M = un(_);
      o(M);
    } finally {
      n({
        type: "set_is_loading",
        page: "offer",
        payload: !1
      });
    }
  };
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        className: "sm:text-left",
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: t("text_6600cda50861cc0108cb6d6c")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          size: "sm",
          children: t("text_6600cda50861cc0108cb6d6d")
        })]
      }), /* @__PURE__ */ P("form", {
        onSubmit: l(m),
        className: "flex flex-col w-full gap-4",
        id: jf,
        children: [/* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d6e"),
          name: "foreign_business",
          ...c
        }), /* @__PURE__ */ g(kt, {
          children: p && /* @__PURE__ */ g(he.div, {
            className: "w-full",
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1,
              transition: {
                delay: Ao
              }
            },
            exit: {
              opacity: 0
            },
            transition: Ce,
            children: /* @__PURE__ */ g(zM, {
              ...c
            })
          })
        }), /* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d73"),
          name: "is_dutch_citizen",
          ...c
        }), /* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d76"),
          name: "is_us_person",
          ...c
        }), /* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d79"),
          name: "is_born_in_us",
          ...c
        }), /* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d7c"),
          name: "has_lived_abroad",
          ...c
        }), /* @__PURE__ */ g(vo, {
          label: t("text_6600cda50861cc0108cb6d7f"),
          name: "is_multi_company",
          ...c
        })]
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!r,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ g(Re, {
          className: "w-full shadow-md",
          name: "submit",
          isLoading: i,
          form: jf,
          type: "submit",
          disabled: !f,
          children: t("text_6600cda50861cc0108cb6d65")
        }), /* @__PURE__ */ g(jt, {
          error: r && t(r),
          className: "text-center",
          name: "offer_error"
        })]
      })
    })]
  });
}
const qM = Er(te("flex justify-center items-center pt-px h-6 w-6 flex-shrink-0", "border rounded-full", "font-semibold text-[0.75rem] leading-[0.875rem]"), {
  variants: {
    state: {
      inactive: "text-secondary bg-transparent border-secondary",
      active: "text-secondary-foreground bg-secondary border-secondary",
      disabled: "text-input-disabled-foreground bg-transparent border-input-disabled-foreground"
    }
  },
  defaultVariants: {
    state: "inactive"
  }
});
function gs({
  children: e,
  className: n,
  state: t
}) {
  const r = te(qM({
    state: t,
    className: n
  }));
  return /* @__PURE__ */ g("div", {
    className: r,
    children: e
  });
}
const QM = {
  primary: "stroke-primary",
  secondary: "stroke-secondary",
  white: "stroke-white",
  black: "stroke-off-black"
};
function XM({
  strokeWidth: e = 4,
  duration: n = 1,
  color: t = "secondary"
}) {
  const r = `0 0 ${90 + e} ${90 + e}`;
  return /* @__PURE__ */ g(kt, {
    children: /* @__PURE__ */ g(he.div, {
      className: "absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full",
      animate: {
        opacity: 1
      },
      initial: {
        opacity: 0
      },
      exit: {
        opacity: 0
      },
      transition: {
        duration: n
      },
      children: /* @__PURE__ */ g("svg", {
        viewBox: r,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "150%",
        height: "150%",
        className: "absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2",
        children: /* @__PURE__ */ g(he.circle, {
          cx: "50%",
          cy: "50%",
          r: 45,
          className: te("fill-transparent", QM[t]),
          strokeWidth: e,
          strokeLinecap: "round",
          animate: {
            pathLength: 0.15,
            rotate: 360,
            opacity: 1
          },
          transition: {
            repeat: 1 / 0,
            duration: n,
            ease: "linear"
          }
        })
      })
    }, "loading_circle_container")
  });
}
function l1({
  children: e
}) {
  return /* @__PURE__ */ g("div", {
    className: "relative",
    children: e
  });
}
l1.Loader = XM;
function ku({
  className: e,
  steps: n,
  activeId: t,
  showLoader: r = !1,
  isStatic: o
}) {
  const s = () => n.filter((a, i) => i < t - 3).reduce((a, i) => {
    var c, l;
    return a + (((l = (c = i.ref) == null ? void 0 : c.current) == null ? void 0 : l.offsetHeight) ?? 0);
  }, 0);
  return /* @__PURE__ */ g("div", {
    className: te("flex flex-col", e),
    children: n.map((a, i) => {
      const c = i === n.length - 1, {
        id: l,
        header: u,
        text: d
      } = a, f = l === t, p = t - l === 1, m = l < t, h = l > t && !o, y = o || m ? "border-secondary" : "border-border/40";
      let C;
      m && (C = "active"), f && (C = "active"), h && (C = "disabled");
      const v = r && p && "pb-[5px]", w = r && f && "pt-[5px]", x = Math.abs(i + 1 - t), D = o ? 1 : Math.max(1 - x * 0.3, 0), k = t > 2 ? s() : 0;
      return /* @__PURE__ */ P(he.div, {
        className: te("flex gap-4", h && "opacity-75", !c && "pb-4"),
        transition: {
          ease: "easeOut",
          duration: 0.5
        },
        initial: {
          opacity: 0,
          y: 0
        },
        animate: {
          opacity: D,
          y: -k
        },
        ref: a.ref,
        children: [/* @__PURE__ */ P("div", {
          className: "flex flex-col gap-4",
          children: [/* @__PURE__ */ P(l1, {
            children: [/* @__PURE__ */ g(gs, {
              state: C,
              children: m ? /* @__PURE__ */ g(Qi, {
                className: "w-4 h-4"
              }) : l
            }), f && r && /* @__PURE__ */ g(l1.Loader, {})]
          }), /* @__PURE__ */ g("div", {
            className: te("flex justify-center basis-full min-h-[16px]", v, w),
            children: !c && /* @__PURE__ */ g("div", {
              className: te("w-px h-full border-l", y)
            })
          })]
        }), /* @__PURE__ */ P("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ g(oe, {
            size: "md",
            weight: "semibold",
            color: "secondary",
            className: te("pt-px", h ? "text-input-disabled-foreground" : "text-secondary"),
            children: u
          }), d && /* @__PURE__ */ g(oe, {
            weight: "light",
            size: "sm",
            className: te(h && "text-input-disabled-foreground"),
            element: "span",
            children: d
          })]
        })]
      }, l);
    })
  });
}
function al({
  href: e,
  children: n
}) {
  return /* @__PURE__ */ P("div", {
    className: "flex gap-2",
    children: [/* @__PURE__ */ g(fb, {
      className: "w-4 h-4 mt-1 shrink-0 text-primary"
    }), /* @__PURE__ */ g(su, {
      href: e,
      children: n
    })]
  });
}
function JM({
  setView: e
}) {
  const [n, t] = K(), r = dt(), {
    t: o
  } = pe(), {
    state: s,
    actions: a
  } = ue(), {
    invoices: i,
    offers: c,
    requester: l
  } = s, {
    newToTheBank: u
  } = l, [d] = c, [f] = i;
  if (!d || !f)
    throw new Error("No offer or invoice is available");
  const p = new Date(f.deadlineDate), m = [{
    id: 1,
    header: o("text_665465afc7347e011942702f"),
    text: o("text_665465afc7347e0119427030")
  }, {
    id: 2,
    header: o("text_665465afc7347e0119427032"),
    text: o("text_665465afc7347e0119427033")
  }, {
    id: 3,
    header: o("text_665465afc7347e0119427035"),
    text: o("text_665465afc7347e0119427036")
  }, {
    id: 4,
    header: o("text_665465afc7347e0119427038"),
    text: o("text_665465afc7347e0119427039")
  }];
  f.thirtyDaysExtension && p.setDate(p.getDate() + Lh);
  const h = () => {
    a({
      type: "set_page",
      payload: "prev"
    });
  }, y = async () => {
    if (u) {
      e("new_to_the_bank");
      return;
    }
    a({
      type: "set_is_loading",
      page: "offer",
      payload: !0
    });
    try {
      await T6(d), a({
        type: "set_page",
        payload: "next"
      });
    } catch (C) {
      const v = un(C);
      t(v);
    } finally {
      a({
        type: "set_is_loading",
        page: "offer",
        payload: !1
      });
    }
  };
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: o("text_6600cda50861cc0108cb6d54")
        })
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full",
        children: [/* @__PURE__ */ g(oe, {
          size: "sm",
          weight: "thin",
          children: o("text_6600cda50861cc0108cb6d55")
        }), /* @__PURE__ */ g(oe, {
          size: "xl",
          weight: "normal",
          children: Kr(d.totalInvoiceAmount)
        })]
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col w-full",
        children: [/* @__PURE__ */ g(oe, {
          size: "sm",
          weight: "thin",
          children: o("text_6600cda50861cc0108cb6d59")
        }), /* @__PURE__ */ g(oe, {
          size: "lg",
          weight: "normal",
          children: Kr(d.totalInterestCost)
        })]
      }), /* @__PURE__ */ g(no, {
        className: "w-full"
      }), /* @__PURE__ */ g(ku, {
        steps: m,
        activeId: 1,
        isStatic: !0,
        className: "w-full"
      }), /* @__PURE__ */ g(fu, {
        type: "single",
        collapsible: !0,
        className: "w-full border-t border-border/40",
        children: /* @__PURE__ */ P(ur, {
          value: "item-1",
          children: [/* @__PURE__ */ g(dr, {
            children: /* @__PURE__ */ g(oe, {
              weight: "normal",
              children: o("text_6600cda50861cc0108cb6d5f")
            })
          }), /* @__PURE__ */ P(fr, {
            className: "flex flex-col gap-4",
            children: [o("text_6600cda50861cc0108cb6d60"), /* @__PURE__ */ P("div", {
              className: "flex flex-col gap-1",
              children: [/* @__PURE__ */ g(al, {
                href: o("text_6600cda50861cc0108cb6d66"),
                children: o("text_6600cda50861cc0108cb6d61")
              }), /* @__PURE__ */ g(al, {
                href: o("text_6600cda50861cc0108cb6d67"),
                children: o("text_6600cda50861cc0108cb6d62")
              }), /* @__PURE__ */ g(al, {
                href: o("text_6600cda50861cc0108cb6d68"),
                children: o("text_6600cda50861cc0108cb6d63")
              })]
            }), o("text_6600cda50861cc0108cb6d64")]
          })]
        })
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!n,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ P("div", {
          className: "flex w-full gap-2",
          children: [/* @__PURE__ */ g(Re, {
            className: "w-fit",
            disabled: r,
            name: "back",
            onClick: h,
            variant: "outline",
            children: o("text_66591773642cbf00a4be3698")
          }), /* @__PURE__ */ g(Re, {
            className: "w-full shadow-md",
            name: "submit",
            isLoading: r,
            onClick: y,
            children: o("text_6600cda50861cc0108cb6d65")
          })]
        }), /* @__PURE__ */ g(jt, {
          error: n && o(n),
          className: "text-center",
          name: "offer_error"
        })]
      })
    })]
  });
}
const ek = {
  overview: JM,
  new_to_the_bank: GM,
  get_offer: ZM
};
function tk() {
  const {
    state: e
  } = ue(), {
    offers: n
  } = e, r = n.length > 0 ? "overview" : "get_offer", [o, s] = K(r), a = ek[o], {
    onTransitionEnd: i
  } = Ui(o);
  return /* @__PURE__ */ g(kt, {
    mode: "wait",
    children: /* @__PURE__ */ g(he.div, {
      className: "flex w-full flex-1",
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: Ce,
      onAnimationComplete: i,
      children: /* @__PURE__ */ g(a, {
        setView: s
      })
    }, o)
  });
}
function Ft({
  buttonLabel: e,
  onClick: n,
  children: t,
  showBackButton: r = !0
}) {
  const {
    state: o,
    actions: s
  } = ue(), {
    t: a
  } = pe(), {
    previousPage: i
  } = o;
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ g(Nt, {
      children: /* @__PURE__ */ g(It, {
        className: "gap-6 text-center",
        children: t
      })
    }), /* @__PURE__ */ P(zt, {
      className: "flex-row gap-2",
      children: [r && /* @__PURE__ */ g(Re, {
        className: "w-fit",
        name: "back",
        onClick: () => {
          if (!i)
            return;
          s({
            type: "set_page",
            payload: i === "offer" ? "transactions" : i
          });
        },
        variant: "outline",
        children: a("text_65f542681359a2007fa1218c")
      }), /* @__PURE__ */ g(Re, {
        className: "w-full shadow-md",
        name: "submit",
        onClick: n,
        children: e
      })]
    })]
  });
}
function nk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_6600cda50861cc0108cb6e12"),
    onClick: r,
    showBackButton: !1,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_6600cda50861cc0108cb6e0f")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_6600cda50861cc0108cb6e10")
    })]
  });
}
function rk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa12192"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1f1")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1f2")
    })]
  });
}
function ok() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa12194"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1f7")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1f8")
    })]
  });
}
function sk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f533dea3bf5f00996bd1db"),
    onClick: r,
    showBackButton: !1,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1d9")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1da")
    })]
  });
}
function ak() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa1218e"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1e5")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1e6")
    })]
  });
}
function ik() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa12190"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1eb")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1ec")
    })]
  });
}
function ck() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa12196"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd1fd")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd1fe")
    })]
  });
}
function lk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa12198"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd203")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd204")
    })]
  });
}
function uk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa1219a"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd209")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd20a")
    })]
  });
}
function dk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa1219c"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd20f")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd210")
    })]
  });
}
function fk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_65f542681359a2007fa1219e"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_65f533dea3bf5f00996bd215")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_65f533dea3bf5f00996bd216")
    })]
  });
}
function pk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_6600cda50861cc0108cb6e0a"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_6600cda50861cc0108cb6e07")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_6600cda50861cc0108cb6e08")
    })]
  });
}
function hk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_6600cda50861cc0108cb6dcf"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_6600cda50861cc0108cb6dcc")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_6600cda50861cc0108cb6dcd")
    })]
  });
}
function mk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_6600cda50861cc0108cb6e1a"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_6600cda50861cc0108cb6e17")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_6600cda50861cc0108cb6e18")
    })]
  });
}
function gk() {
  const {
    t: e
  } = pe(), {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, r = () => {
    ht(t);
  };
  return /* @__PURE__ */ P(Ft, {
    buttonLabel: e("text_66571bf8fb71063f6803fcf5"),
    onClick: r,
    children: [/* @__PURE__ */ g(Ee, {
      element: "h1",
      size: "lg",
      children: e("text_662ab9a4f2a701008bfd2a4e")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: e("text_662ab9a4f2a701008bfd2a4f")
    })]
  });
}
const yk = {
  NEW_TO_THE_BANK: nk,
  GENERIC: rk,
  TIMEOUT: ok,
  RED_SCORE: sk,
  TRANSACTION_STATUS: ck,
  NO_CONNECTION_ID: lk,
  GET_TRANSACTIONS: uk,
  CONSENT_DECLINED: dk,
  CREATE_CONNECTION: fk,
  INSUFFICIENT_TRANSACTIONS: ik,
  TRANSACTIONS_NOT_RECENT: ak,
  CRC_CHECK_FAILED: pk,
  INVOICE_NOT_SUITABLE: hk,
  MAX_LOAN_EXCEEDED: mk,
  TRANSACTIONS_NO_MATCHES: gk
};
function vk() {
  const {
    state: e
  } = ue(), {
    rejectionError: n
  } = e;
  if (!n)
    throw new Error("error key not provided");
  const t = yk[n];
  return W(() => {
    _s("error", n);
  }, []), /* @__PURE__ */ g(t, {});
}
function bk() {
  const {
    state: e,
    actions: n
  } = ue(), {
    requester: t
  } = e, {
    kvkNumber: r
  } = t, {
    t: o
  } = pe(), [s, a] = K(1), i = dt(["automate_eligibility"]), c = dt(["automate_contact", "automate_invoices"]), l = [{
    id: 1,
    header: o("text_664d811a6e17e700eaebbf64"),
    text: o("text_664d811a6e17e700eaebbf65"),
    ref: ie(null)
  }, {
    id: 2,
    header: o("text_664d811a6e17e700eaebbf67"),
    text: o("text_664d811a6e17e700eaebbf68"),
    ref: ie(null)
  }];
  return W(() => {
    !r || c || n({
      type: "set_page",
      payload: "next"
    });
  }, [c]), W(() => {
    i || r || n({
      type: "set_page",
      payload: "next"
    });
  }, [i]), W(() => {
    i || a(2);
  }, [i]), /* @__PURE__ */ g(At, {
    children: /* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: o("text_664d811a6e17e700eaebbf63")
        })
      }), /* @__PURE__ */ g(ku, {
        activeId: s,
        showLoader: !0,
        steps: l,
        className: "w-full"
      })]
    })
  });
}
function Ck() {
  const {
    state: e,
    actions: n
  } = ue(), {
    t
  } = pe(), {
    requester: r,
    flowFinished: o
  } = e, {
    name: s
  } = r, a = () => {
    ht(o);
  };
  return W(() => {
    n({
      type: "set_flow_is_finished"
    }), _s("success");
  }, []), /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: t("text_6600cda50861cc0108cb6d94")
        }), /* @__PURE__ */ g(oe, {
          weight: "light",
          children: t("text_6600cda50861cc0108cb6d95", {
            name: s
          })
        })]
      }), /* @__PURE__ */ P(fu, {
        type: "multiple",
        className: "w-full border-t border-border/40",
        children: [/* @__PURE__ */ P(ur, {
          value: "item-1",
          children: [/* @__PURE__ */ g(dr, {
            children: /* @__PURE__ */ P("div", {
              className: "flex gap-2 items-center",
              children: [/* @__PURE__ */ g(gs, {
                state: "active",
                className: "-mt-0.5",
                children: "1"
              }), /* @__PURE__ */ g(oe, {
                weight: "normal",
                children: t("text_6654721909542300c5fb2ff2")
              })]
            })
          }), /* @__PURE__ */ g(fr, {
            children: t("text_6654721909542300c5fb2ff3")
          })]
        }), /* @__PURE__ */ P(ur, {
          value: "item-2",
          children: [/* @__PURE__ */ g(dr, {
            children: /* @__PURE__ */ P("div", {
              className: "flex gap-2 items-center",
              children: [/* @__PURE__ */ g(gs, {
                state: "active",
                className: "-mt-0.5",
                children: "2"
              }), /* @__PURE__ */ g(oe, {
                weight: "normal",
                children: t("text_6654721909542300c5fb2ff5")
              })]
            })
          }), /* @__PURE__ */ g(fr, {
            children: t("text_6654721909542300c5fb2ff6")
          })]
        }), /* @__PURE__ */ P(ur, {
          value: "item-3",
          children: [/* @__PURE__ */ g(dr, {
            children: /* @__PURE__ */ P("div", {
              className: "flex gap-2 items-center",
              children: [/* @__PURE__ */ g(gs, {
                state: "active",
                className: "-mt-0.5",
                children: "3"
              }), /* @__PURE__ */ g(oe, {
                weight: "normal",
                children: t("text_6654721909542300c5fb2ff8")
              })]
            })
          }), /* @__PURE__ */ g(fr, {
            children: t("text_6654721909542300c5fb2ff9")
          })]
        }), /* @__PURE__ */ P(ur, {
          value: "item-4",
          children: [/* @__PURE__ */ g(dr, {
            children: /* @__PURE__ */ P("div", {
              className: "flex gap-2 items-center",
              children: [/* @__PURE__ */ g(gs, {
                state: "active",
                className: "-mt-0.5",
                children: "4"
              }), /* @__PURE__ */ g(oe, {
                weight: "normal",
                children: t("text_6654721909542300c5fb2ffb")
              })]
            })
          }), /* @__PURE__ */ g(fr, {
            children: t("text_6654721909542300c5fb2ffc")
          })]
        })]
      })]
    }), /* @__PURE__ */ g(zt, {
      className: "gap-2",
      children: /* @__PURE__ */ g(Re, {
        className: "w-full shadow-md",
        name: "submit",
        onClick: a,
        children: t("text_6600cda50861cc0108cb6da2")
      })
    })]
  });
}
const il = {
  RABOBANK: "Rabobank",
  ING: "ING Bank",
  ABN: "ABN Amro",
  KNAB: "Knab",
  ASN: "ASN Bank",
  SNS: "SNS Bank",
  REGIOBANK: "Regiobank",
  TRIODOS: "Triodos",
  BUNQ: "Bunq Bank"
};
function wk({
  returnUrl: e,
  bankToConnect: n,
  caseId: t
}) {
  const r = "dls-psd2-aggregator/v1/create/session", o = {
    returnUrl: e,
    caseId: t,
    bankToConnect: n,
    needFutureConsent: !0
  };
  return bt.post({
    path: r,
    body: o
  });
}
function xk({
  connectionId: e
}) {
  const n = `dls-psd2-aggregator/v1/fetch/connection/${e}`;
  return bt.get({
    path: n
  });
}
function Dk({
  connectionId: e,
  kvkNumber: n
}) {
  const t = "dls-psd2-aggregator/v2/fetch/transactions", r = {
    kvkNumber: n,
    connectionId: e
  };
  return bt.post({
    path: t,
    body: r
  });
}
function Sk({
  customerId: e
}) {
  const n = `dls-psd2-aggregator/v1/fetch/connections?customer_id=${e}`;
  return bt.get({
    path: n
  });
}
function Ek({
  transactionUsageConsent: e
}) {
  const n = "dls-transaction-processing/v1/financials/consent", t = {
    transactionUsageConsent: e
  };
  return bt.post({
    path: n,
    body: t
  });
}
function _k({
  bankName: e,
  username: n
}) {
  const t = `dls-transaction-processing/v1/financials/psd2/status?bank=${e}&trackingId=${n}&username=${n}`;
  return bt.get({
    path: t
  });
}
function Mk(e) {
  return bt.post({
    path: "dls-transaction-processing/v3/financials/confirm",
    body: {}
  });
}
const kk = {
  caseIdNotFound: "text_65f542681359a2007fa12185"
};
class Yf extends Error {
  constructor(n) {
    const t = kk[n];
    super(t), this.name = "auth_error";
  }
}
const za = xe(({
  className: e,
  name: n,
  disabled: t,
  children: r,
  onChange: o,
  ...s
}, a) => {
  const [i, c] = K(!1), l = `checkbox_${n}`;
  return /* @__PURE__ */ P("label", {
    htmlFor: l,
    ref: a,
    role: "presentation",
    onMouseDown: (u) => u.preventDefault(),
    className: te("flex items-start gap-3", "text-left text-sm font-light text-foreground", t ? "text-input-disabled-foreground" : "cursor-pointer", e),
    children: [/* @__PURE__ */ P("div", {
      className: "relative flex justify-center items-center mt-0.5",
      children: [/* @__PURE__ */ g("input", {
        type: "checkbox",
        name: n,
        "data-testid": l,
        id: l,
        "aria-label": l,
        disabled: t,
        className: "peer absolute cursor-pointer opacity-0 disabled:cursor-auto",
        ...s,
        onChange: (u) => {
          c(u.target.checked), o == null || o(u);
        }
      }), /* @__PURE__ */ g("div", {
        className: te("flex items-center justify-center w-5 h-5 border rounded border-border", "peer-checked:bg-primary peer-checked:border-none", "peer-focus-visible:ring-primary peer-focus-visible:ring-1 peer-focus-visible:ring-offset-2", "transition-colors duration-300", t && "bg-input-disabled border-border/30")
      }), /* @__PURE__ */ g(Qi, {
        className: te("absolute w-4 h-4 text-primary-foreground pointer-events-none transition-opacity duration-300", i ? "opacity-1" : "opacity-0")
      })]
    }), r]
  });
});
var Th = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function t() {
      for (var s = "", a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        i && (s = o(s, r(i)));
      }
      return s;
    }
    function r(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return t.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var a = "";
      for (var i in s)
        n.call(s, i) && s[i] && (a = o(a, i));
      return a;
    }
    function o(s, a) {
      return a ? s ? s + " " + a : s + a : s;
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Th);
var Ak = Th.exports;
const u1 = /* @__PURE__ */ f0(Ak);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const Nk = "react-tooltip-core-styles", Lk = "react-tooltip-base-styles", Hf = { core: !1, base: !1 };
function Uf({ css: e, id: n = Lk, type: t = "base", ref: r }) {
  var o, s;
  if (!e || typeof document > "u" || Hf[t] || t === "core" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_CORE_STYLES) || t !== "base" && typeof process < "u" && (!((s = process == null ? void 0 : process.env) === null || s === void 0) && s.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  t === "core" && (n = Nk), r || (r = {});
  const { insertAt: a } = r;
  if (document.getElementById(n))
    return void console.warn(`[react-tooltip] Element with id '${n}' already exists. Call \`removeStyle()\` first`);
  const i = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = n, c.type = "text/css", a === "top" && i.firstChild ? i.insertBefore(c, i.firstChild) : i.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), Hf[t] = !0;
}
const Wf = async ({ elementReference: e = null, tooltipReference: n = null, tooltipArrowReference: t = null, place: r = "top", offset: o = 10, strategy: s = "absolute", middlewares: a = [nh(Number(o)), dh({ fallbackAxisSideDirection: "start" }), CE({ padding: 5 })], border: i }) => {
  if (!e)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (n === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const c = a;
  return t ? (c.push(n1({ element: t, padding: 5 })), r1(e, n, { placement: r, strategy: s, middleware: c }).then(({ x: l, y: u, placement: d, middlewareData: f }) => {
    var p, m;
    const h = { left: `${l}px`, top: `${u}px`, border: i }, { x: y, y: C } = (p = f.arrow) !== null && p !== void 0 ? p : { x: 0, y: 0 }, v = (m = { top: "bottom", right: "left", bottom: "top", left: "right" }[d.split("-")[0]]) !== null && m !== void 0 ? m : "bottom", w = i && { borderBottom: i, borderRight: i };
    let x = 0;
    if (i) {
      const D = `${i}`.match(/(\d+)px/);
      x = D != null && D[1] ? Number(D[1]) : 1;
    }
    return { tooltipStyles: h, tooltipArrowStyles: { left: y != null ? `${y}px` : "", top: C != null ? `${C}px` : "", right: "", bottom: "", ...w, [v]: `-${4 + x}px` }, place: d };
  })) : r1(e, n, { placement: "bottom", strategy: s, middleware: c }).then(({ x: l, y: u, placement: d }) => ({ tooltipStyles: { left: `${l}px`, top: `${u}px` }, tooltipArrowStyles: {}, place: d }));
}, Zf = (e, n) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, n), Kf = (e, n, t) => {
  let r = null;
  const o = function(...s) {
    const a = () => {
      r = null, t || e.apply(this, s);
    };
    t && !r && (e.apply(this, s), r = setTimeout(a, n)), t || (r && clearTimeout(r), r = setTimeout(a, n));
  };
  return o.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, o;
}, zf = (e) => e !== null && !Array.isArray(e) && typeof e == "object", d1 = (e, n) => {
  if (e === n)
    return !0;
  if (Array.isArray(e) && Array.isArray(n))
    return e.length === n.length && e.every((o, s) => d1(o, n[s]));
  if (Array.isArray(e) !== Array.isArray(n))
    return !1;
  if (!zf(e) || !zf(n))
    return e === n;
  const t = Object.keys(e), r = Object.keys(n);
  return t.length === r.length && t.every((o) => d1(e[o], n[o]));
}, Tk = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement))
    return !1;
  const n = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((t) => {
    const r = n.getPropertyValue(t);
    return r === "auto" || r === "scroll";
  });
}, Gf = (e) => {
  if (!e)
    return null;
  let n = e.parentElement;
  for (; n; ) {
    if (Tk(n))
      return n;
    n = n.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Pk = typeof window < "u" ? Wo : W, Ok = "DEFAULT_TOOLTIP_ID", Rk = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, Ik = Rt({ getTooltipData: () => Rk });
function Ph(e = Ok) {
  return ze(Ik).getTooltipData(e);
}
var bo = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, cl = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const Fk = ({ forwardRef: e, id: n, className: t, classNameArrow: r, variant: o = "dark", anchorId: s, anchorSelect: a, place: i = "top", offset: c = 10, events: l = ["hover"], openOnClick: u = !1, positionStrategy: d = "absolute", middlewares: f, wrapper: p, delayShow: m = 0, delayHide: h = 0, float: y = !1, hidden: C = !1, noArrow: v = !1, clickable: w = !1, closeOnEsc: x = !1, closeOnScroll: D = !1, closeOnResize: k = !1, openEvents: _, closeEvents: M, globalCloseEvents: T, imperativeModeOnly: N, style: I, position: O, afterShow: $, afterHide: j, content: Y, contentWrapperRef: F, isOpen: V, defaultIsOpen: J = !1, setIsOpen: Q, activeAnchor: X, setActiveAnchor: z, border: me, opacity: Me, arrowColor: Be, role: ve = "tooltip" }) => {
  var Ae;
  const Te = ie(null), G = ie(null), fe = ie(null), De = ie(null), _e = ie(null), [Fe, Je] = K({ tooltipStyles: {}, tooltipArrowStyles: {}, place: i }), [ke, q] = K(!1), [ce, de] = K(!1), [E, L] = K(null), R = ie(!1), Z = ie(null), { anchorRefs: H, setActiveAnchor: U } = Ph(n), re = ie(!1), [Ne, Ge] = K([]), at = ie(!1), Yt = u || l.includes("click"), kr = Yt || (_ == null ? void 0 : _.click) || (_ == null ? void 0 : _.dblclick) || (_ == null ? void 0 : _.mousedown), dn = _ ? { ..._ } : { mouseenter: !0, focus: !0, click: !1, dblclick: !1, mousedown: !1 };
  !_ && Yt && Object.assign(dn, { mouseenter: !1, focus: !1, click: !0 });
  const Tn = M ? { ...M } : { mouseleave: !0, blur: !0, click: !1, dblclick: !1, mouseup: !1 };
  !M && Yt && Object.assign(Tn, { mouseleave: !1, blur: !1 });
  const Ht = T ? { ...T } : { escape: x || !1, scroll: D || !1, resize: k || !1, clickOutsideAnchor: kr || !1 };
  N && (Object.assign(dn, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Tn, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(Ht, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), Pk(() => (at.current = !0, () => {
    at.current = !1;
  }), []);
  const et = (ne) => {
    at.current && (ne && de(!0), setTimeout(() => {
      at.current && (Q == null || Q(ne), V === void 0 && q(ne));
    }, 10));
  };
  W(() => {
    if (V === void 0)
      return () => null;
    V && de(!0);
    const ne = setTimeout(() => {
      q(V);
    }, 10);
    return () => {
      clearTimeout(ne);
    };
  }, [V]), W(() => {
    if (ke !== R.current)
      if (_e.current && clearTimeout(_e.current), R.current = ke, ke)
        $ == null || $();
      else {
        const ne = ((be) => {
          const we = be.match(/^([\d.]+)(ms|s)$/);
          if (!we)
            return 0;
          const [, gt, _t] = we;
          return Number(gt) * (_t === "ms" ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        _e.current = setTimeout(() => {
          de(!1), L(null), j == null || j();
        }, ne + 25);
      }
  }, [ke]);
  const so = (ne) => {
    Je((be) => d1(be, ne) ? be : ne);
  }, Xn = (ne = m) => {
    fe.current && clearTimeout(fe.current), ce ? et(!0) : fe.current = setTimeout(() => {
      et(!0);
    }, ne);
  }, ao = (ne = h) => {
    De.current && clearTimeout(De.current), De.current = setTimeout(() => {
      re.current || et(!1);
    }, ne);
  }, Jo = (ne) => {
    var be;
    if (!ne)
      return;
    const we = (be = ne.currentTarget) !== null && be !== void 0 ? be : ne.target;
    if (!(we != null && we.isConnected))
      return z(null), void U({ current: null });
    m ? Xn() : et(!0), z(we), U({ current: we }), De.current && clearTimeout(De.current);
  }, io = () => {
    w ? ao(h || 100) : h ? ao() : et(!1), fe.current && clearTimeout(fe.current);
  }, co = ({ x: ne, y: be }) => {
    var we;
    const gt = { getBoundingClientRect: () => ({ x: ne, y: be, width: 0, height: 0, top: be, left: ne, right: ne, bottom: be }) };
    Wf({ place: (we = E == null ? void 0 : E.place) !== null && we !== void 0 ? we : i, offset: c, elementReference: gt, tooltipReference: Te.current, tooltipArrowReference: G.current, strategy: d, middlewares: f, border: me }).then((_t) => {
      so(_t);
    });
  }, lo = (ne) => {
    if (!ne)
      return;
    const be = ne, we = { x: be.clientX, y: be.clientY };
    co(we), Z.current = we;
  }, es = (ne) => {
    var be;
    if (!ke)
      return;
    const we = ne.target;
    we.isConnected && (!((be = Te.current) === null || be === void 0) && be.contains(we) || [document.querySelector(`[id='${s}']`), ...Ne].some((gt) => gt == null ? void 0 : gt.contains(we)) || (et(!1), fe.current && clearTimeout(fe.current)));
  }, ca = Kf(Jo, 50, !0), mt = Kf(io, 50, !0), qt = (ne) => {
    mt.cancel(), ca(ne);
  }, ge = () => {
    ca.cancel(), mt();
  }, Pe = cn(() => {
    var ne, be;
    const we = (ne = E == null ? void 0 : E.position) !== null && ne !== void 0 ? ne : O;
    we ? co(we) : y ? Z.current && co(Z.current) : X != null && X.isConnected && Wf({ place: (be = E == null ? void 0 : E.place) !== null && be !== void 0 ? be : i, offset: c, elementReference: X, tooltipReference: Te.current, tooltipArrowReference: G.current, strategy: d, middlewares: f, border: me }).then((gt) => {
      at.current && so(gt);
    });
  }, [ke, X, Y, I, i, E == null ? void 0 : E.place, c, d, O, E == null ? void 0 : E.position, y]);
  W(() => {
    var ne, be;
    const we = new Set(H);
    Ne.forEach((We) => {
      we.add({ current: We });
    });
    const gt = document.querySelector(`[id='${s}']`);
    gt && we.add({ current: gt });
    const _t = () => {
      et(!1);
    }, fn = Gf(X), pn = Gf(Te.current);
    Ht.scroll && (window.addEventListener("scroll", _t), fn == null || fn.addEventListener("scroll", _t), pn == null || pn.addEventListener("scroll", _t));
    let Lt = null;
    Ht.resize ? window.addEventListener("resize", _t) : X && Te.current && (Lt = uh(X, Te.current, Pe, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const Qt = (We) => {
      We.key === "Escape" && et(!1);
    };
    Ht.escape && window.addEventListener("keydown", Qt), Ht.clickOutsideAnchor && window.addEventListener("click", es);
    const qe = [], ts = (We) => {
      ke && (We == null ? void 0 : We.target) === X || Jo(We);
    }, Kh = (We) => {
      ke && (We == null ? void 0 : We.target) === X && io();
    }, Au = ["mouseenter", "mouseleave", "focus", "blur"], Nu = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(dn).forEach(([We, Pn]) => {
      Pn && (Au.includes(We) ? qe.push({ event: We, listener: qt }) : Nu.includes(We) && qe.push({ event: We, listener: ts }));
    }), Object.entries(Tn).forEach(([We, Pn]) => {
      Pn && (Au.includes(We) ? qe.push({ event: We, listener: ge }) : Nu.includes(We) && qe.push({ event: We, listener: Kh }));
    }), y && qe.push({ event: "pointermove", listener: lo });
    const Lu = () => {
      re.current = !0;
    }, Tu = () => {
      re.current = !1, io();
    };
    return w && !kr && ((ne = Te.current) === null || ne === void 0 || ne.addEventListener("mouseenter", Lu), (be = Te.current) === null || be === void 0 || be.addEventListener("mouseleave", Tu)), qe.forEach(({ event: We, listener: Pn }) => {
      we.forEach((pc) => {
        var ns;
        (ns = pc.current) === null || ns === void 0 || ns.addEventListener(We, Pn);
      });
    }), () => {
      var We, Pn;
      Ht.scroll && (window.removeEventListener("scroll", _t), fn == null || fn.removeEventListener("scroll", _t), pn == null || pn.removeEventListener("scroll", _t)), Ht.resize ? window.removeEventListener("resize", _t) : Lt == null || Lt(), Ht.clickOutsideAnchor && window.removeEventListener("click", es), Ht.escape && window.removeEventListener("keydown", Qt), w && !kr && ((We = Te.current) === null || We === void 0 || We.removeEventListener("mouseenter", Lu), (Pn = Te.current) === null || Pn === void 0 || Pn.removeEventListener("mouseleave", Tu)), qe.forEach(({ event: pc, listener: ns }) => {
        we.forEach((zh) => {
          var hc;
          (hc = zh.current) === null || hc === void 0 || hc.removeEventListener(pc, ns);
        });
      });
    };
  }, [X, Pe, ce, H, Ne, _, M, T, Yt, m, h]), W(() => {
    var ne, be;
    let we = (be = (ne = E == null ? void 0 : E.anchorSelect) !== null && ne !== void 0 ? ne : a) !== null && be !== void 0 ? be : "";
    !we && n && (we = `[data-tooltip-id='${n}']`);
    const gt = new MutationObserver((_t) => {
      const fn = [], pn = [];
      _t.forEach((Lt) => {
        if (Lt.type === "attributes" && Lt.attributeName === "data-tooltip-id" && (Lt.target.getAttribute("data-tooltip-id") === n ? fn.push(Lt.target) : Lt.oldValue === n && pn.push(Lt.target)), Lt.type === "childList") {
          if (X) {
            const Qt = [...Lt.removedNodes].filter((qe) => qe.nodeType === 1);
            if (we)
              try {
                pn.push(...Qt.filter((qe) => qe.matches(we))), pn.push(...Qt.flatMap((qe) => [...qe.querySelectorAll(we)]));
              } catch {
              }
            Qt.some((qe) => {
              var ts;
              return !!(!((ts = qe == null ? void 0 : qe.contains) === null || ts === void 0) && ts.call(qe, X)) && (de(!1), et(!1), z(null), fe.current && clearTimeout(fe.current), De.current && clearTimeout(De.current), !0);
            });
          }
          if (we)
            try {
              const Qt = [...Lt.addedNodes].filter((qe) => qe.nodeType === 1);
              fn.push(...Qt.filter((qe) => qe.matches(we))), fn.push(...Qt.flatMap((qe) => [...qe.querySelectorAll(we)]));
            } catch {
            }
        }
      }), (fn.length || pn.length) && Ge((Lt) => [...Lt.filter((Qt) => !pn.includes(Qt)), ...fn]);
    });
    return gt.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      gt.disconnect();
    };
  }, [n, a, E == null ? void 0 : E.anchorSelect, X]), W(() => {
    Pe();
  }, [Pe]), W(() => {
    if (!(F != null && F.current))
      return () => null;
    const ne = new ResizeObserver(() => {
      setTimeout(() => Pe());
    });
    return ne.observe(F.current), () => {
      ne.disconnect();
    };
  }, [Y, F == null ? void 0 : F.current]), W(() => {
    var ne;
    const be = document.querySelector(`[id='${s}']`), we = [...Ne, be];
    X && we.includes(X) || z((ne = Ne[0]) !== null && ne !== void 0 ? ne : be);
  }, [s, Ne, X]), W(() => (J && et(!0), () => {
    fe.current && clearTimeout(fe.current), De.current && clearTimeout(De.current);
  }), []), W(() => {
    var ne;
    let be = (ne = E == null ? void 0 : E.anchorSelect) !== null && ne !== void 0 ? ne : a;
    if (!be && n && (be = `[data-tooltip-id='${n}']`), be)
      try {
        const we = Array.from(document.querySelectorAll(be));
        Ge(we);
      } catch {
        Ge([]);
      }
  }, [n, a, E == null ? void 0 : E.anchorSelect]), W(() => {
    fe.current && (clearTimeout(fe.current), Xn(m));
  }, [m]);
  const Ut = (Ae = E == null ? void 0 : E.content) !== null && Ae !== void 0 ? Ae : Y, Ar = ke && Object.keys(Fe.tooltipStyles).length > 0;
  return Jh(e, () => ({ open: (ne) => {
    if (ne != null && ne.anchorSelect)
      try {
        document.querySelector(ne.anchorSelect);
      } catch {
        return void console.warn(`[react-tooltip] "${ne.anchorSelect}" is not a valid CSS selector`);
      }
    L(ne ?? null), ne != null && ne.delay ? Xn(ne.delay) : et(!0);
  }, close: (ne) => {
    ne != null && ne.delay ? ao(ne.delay) : et(!1);
  }, activeAnchor: X, place: Fe.place, isOpen: !!(ce && !C && Ut && Ar) })), ce && !C && Ut ? A.createElement(p, { id: n, role: ve, className: u1("react-tooltip", bo.tooltip, cl.tooltip, cl[o], t, `react-tooltip__place-${Fe.place}`, bo[Ar ? "show" : "closing"], Ar ? "react-tooltip__show" : "react-tooltip__closing", d === "fixed" && bo.fixed, w && bo.clickable), onTransitionEnd: (ne) => {
    _e.current && clearTimeout(_e.current), ke || ne.propertyName !== "opacity" || (de(!1), L(null), j == null || j());
  }, style: { ...I, ...Fe.tooltipStyles, opacity: Me !== void 0 && Ar ? Me : void 0 }, ref: Te }, Ut, A.createElement(p, { className: u1("react-tooltip-arrow", bo.arrow, cl.arrow, r, v && bo.noArrow), style: { ...Fe.tooltipArrowStyles, background: Be ? `linear-gradient(to right bottom, transparent 50%, ${Be} 50%)` : void 0 }, ref: G })) : null;
}, Vk = ({ content: e }) => A.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), $k = A.forwardRef(({ id: e, anchorId: n, anchorSelect: t, content: r, html: o, render: s, className: a, classNameArrow: i, variant: c = "dark", place: l = "top", offset: u = 10, wrapper: d = "div", children: f = null, events: p = ["hover"], openOnClick: m = !1, positionStrategy: h = "absolute", middlewares: y, delayShow: C = 0, delayHide: v = 0, float: w = !1, hidden: x = !1, noArrow: D = !1, clickable: k = !1, closeOnEsc: _ = !1, closeOnScroll: M = !1, closeOnResize: T = !1, openEvents: N, closeEvents: I, globalCloseEvents: O, imperativeModeOnly: $ = !1, style: j, position: Y, isOpen: F, defaultIsOpen: V = !1, disableStyleInjection: J = !1, border: Q, opacity: X, arrowColor: z, setIsOpen: me, afterShow: Me, afterHide: Be, role: ve = "tooltip" }, Ae) => {
  const [Te, G] = K(r), [fe, De] = K(o), [_e, Fe] = K(l), [Je, ke] = K(c), [q, ce] = K(u), [de, E] = K(C), [L, R] = K(v), [Z, H] = K(w), [U, re] = K(x), [Ne, Ge] = K(d), [at, Yt] = K(p), [kr, dn] = K(h), [Tn, Ht] = K(null), [et, so] = K(null), Xn = ie(J), { anchorRefs: ao, activeAnchor: Jo } = Ph(e), io = (mt) => mt == null ? void 0 : mt.getAttributeNames().reduce((qt, ge) => {
    var Pe;
    return ge.startsWith("data-tooltip-") && (qt[ge.replace(/^data-tooltip-/, "")] = (Pe = mt == null ? void 0 : mt.getAttribute(ge)) !== null && Pe !== void 0 ? Pe : null), qt;
  }, {}), co = (mt) => {
    const qt = { place: (ge) => {
      var Pe;
      Fe((Pe = ge) !== null && Pe !== void 0 ? Pe : l);
    }, content: (ge) => {
      G(ge ?? r);
    }, html: (ge) => {
      De(ge ?? o);
    }, variant: (ge) => {
      var Pe;
      ke((Pe = ge) !== null && Pe !== void 0 ? Pe : c);
    }, offset: (ge) => {
      ce(ge === null ? u : Number(ge));
    }, wrapper: (ge) => {
      var Pe;
      Ge((Pe = ge) !== null && Pe !== void 0 ? Pe : d);
    }, events: (ge) => {
      const Pe = ge == null ? void 0 : ge.split(" ");
      Yt(Pe ?? p);
    }, "position-strategy": (ge) => {
      var Pe;
      dn((Pe = ge) !== null && Pe !== void 0 ? Pe : h);
    }, "delay-show": (ge) => {
      E(ge === null ? C : Number(ge));
    }, "delay-hide": (ge) => {
      R(ge === null ? v : Number(ge));
    }, float: (ge) => {
      H(ge === null ? w : ge === "true");
    }, hidden: (ge) => {
      re(ge === null ? x : ge === "true");
    }, "class-name": (ge) => {
      Ht(ge);
    } };
    Object.values(qt).forEach((ge) => ge(null)), Object.entries(mt).forEach(([ge, Pe]) => {
      var Ut;
      (Ut = qt[ge]) === null || Ut === void 0 || Ut.call(qt, Pe);
    });
  };
  W(() => {
    G(r);
  }, [r]), W(() => {
    De(o);
  }, [o]), W(() => {
    Fe(l);
  }, [l]), W(() => {
    ke(c);
  }, [c]), W(() => {
    ce(u);
  }, [u]), W(() => {
    E(C);
  }, [C]), W(() => {
    R(v);
  }, [v]), W(() => {
    H(w);
  }, [w]), W(() => {
    re(x);
  }, [x]), W(() => {
    dn(h);
  }, [h]), W(() => {
    Xn.current !== J && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [J]), W(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: J === "core", disableBase: J } }));
  }, []), W(() => {
    var mt;
    const qt = new Set(ao);
    let ge = t;
    if (!ge && e && (ge = `[data-tooltip-id='${e}']`), ge)
      try {
        document.querySelectorAll(ge).forEach((be) => {
          qt.add({ current: be });
        });
      } catch {
        console.warn(`[react-tooltip] "${ge}" is not a valid CSS selector`);
      }
    const Pe = document.querySelector(`[id='${n}']`);
    if (Pe && qt.add({ current: Pe }), !qt.size)
      return () => null;
    const Ut = (mt = et ?? Pe) !== null && mt !== void 0 ? mt : Jo.current, Ar = new MutationObserver((be) => {
      be.forEach((we) => {
        var gt;
        if (!Ut || we.type !== "attributes" || !(!((gt = we.attributeName) === null || gt === void 0) && gt.startsWith("data-tooltip-")))
          return;
        const _t = io(Ut);
        co(_t);
      });
    }), ne = { attributes: !0, childList: !1, subtree: !1 };
    if (Ut) {
      const be = io(Ut);
      co(be), Ar.observe(Ut, ne);
    }
    return () => {
      Ar.disconnect();
    };
  }, [ao, Jo, et, n, t]), W(() => {
    j != null && j.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), Q && !Zf("border", `${Q}`) && console.warn(`[react-tooltip] "${Q}" is not a valid \`border\`.`), j != null && j.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), X && !Zf("opacity", `${X}`) && console.warn(`[react-tooltip] "${X}" is not a valid \`opacity\`.`);
  }, []);
  let lo = f;
  const es = ie(null);
  if (s) {
    const mt = s({ content: (et == null ? void 0 : et.getAttribute("data-tooltip-content")) || Te || null, activeAnchor: et });
    lo = mt ? A.createElement("div", { ref: es, className: "react-tooltip-content-wrapper" }, mt) : null;
  } else
    Te && (lo = Te);
  fe && (lo = A.createElement(Vk, { content: fe }));
  const ca = { forwardRef: Ae, id: e, anchorId: n, anchorSelect: t, className: u1(a, Tn), classNameArrow: i, content: lo, contentWrapperRef: es, place: _e, variant: Je, offset: q, wrapper: Ne, events: at, openOnClick: m, positionStrategy: kr, middlewares: y, delayShow: de, delayHide: L, float: Z, hidden: U, noArrow: D, clickable: k, closeOnEsc: _, closeOnScroll: M, closeOnResize: T, openEvents: N, closeEvents: I, globalCloseEvents: O, imperativeModeOnly: $, style: j, position: Y, isOpen: F, defaultIsOpen: V, border: Q, opacity: X, arrowColor: z, setIsOpen: me, afterShow: Me, afterHide: Be, activeAnchor: et, setActiveAnchor: (mt) => so(mt), role: ve };
  return A.createElement(Fk, { ...ca });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || Uf({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || Uf({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
function Oh({
  trigger: e,
  className: n,
  name: t,
  children: r
}) {
  const o = `tooltip_${t}`;
  return /* @__PURE__ */ P(Zo, {
    children: [/* @__PURE__ */ g("span", {
      "data-tooltip-id": o,
      children: e ?? /* @__PURE__ */ g(Uo, {
        className: te("w-5 h-5 fill-primary inline-flex", n)
      })
    }), /* @__PURE__ */ g($k, {
      id: o,
      "data-testid": o,
      place: "bottom",
      clickable: !0,
      className: te("!px-5 !py-4 max-w-60 max-h-fit !rounded z-40", "!text-left !text-xs text-tooltip-foreground font-extralight", "!bg-tooltip"),
      delayShow: 300,
      delayHide: 100,
      children: r
    })]
  });
}
const Rh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M27.4067 2.90735V20.4231L16.9844 30.9073L6.5 20.4231V2.90735H27.4067Z", fill: "#009286" }), /* @__PURE__ */ b.createElement("path", { d: "M27.4065 20.4231L16.9841 30.9074L16.9531 10.0007L27.4065 20.4231Z", fill: "#F3C000" })), Ih = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.40076 15.9231C8.94223 16.7923 8.58951 17.731 8.37788 18.7044C8.20152 19.5736 8.13097 20.4775 8.16625 21.4161C8.41315 27.222 13.2454 31.8807 19.1358 31.9502C20.2645 31.985 21.358 31.8111 22.3808 31.533C18.5362 30.3162 15.7144 26.7353 15.7144 22.4939C15.7144 19.8905 17.088 17.8673 18.4856 15.8086L18.4857 15.8085L18.4858 15.8084C18.6559 15.5578 18.8263 15.3067 18.9947 15.054C20.1587 13.2462 20.9347 11.2645 20.8289 9.10904C20.582 4.06799 16.3493 0.0351562 11.1644 0.0351562C5.8383 0.0351562 1.53512 4.24182 1.49985 9.49146C1.46458 10.3258 1.57039 11.1255 1.78202 11.8903C2.41692 10.3258 3.96888 9.2481 5.76775 9.2481C8.16625 9.2481 10.1062 11.1602 10.1062 13.5243C10.1062 13.7677 10.0709 14.0458 10.0004 14.2891C9.89457 14.8802 9.68294 15.4017 9.40076 15.9231ZM24.0592 12.9357C24.5676 12.9357 24.9744 13.3534 24.9744 13.8755C24.9744 14.3628 24.5676 14.7804 24.0592 14.8152C23.5507 14.8152 23.1439 14.3976 23.1439 13.8755C23.1439 13.3534 23.5507 12.9357 24.0592 12.9357ZM27.6524 24.8741C27.5846 23.2383 28.4998 21.8112 29.8558 21.1499V21.1151C29.4829 21.0455 29.0761 21.0107 28.6693 21.0107C25.2795 21.0107 22.4998 23.83 22.4998 27.3454C22.4998 28.7028 22.9066 29.9906 23.6524 31C25.5507 30.095 27.1778 28.6332 28.2626 26.7885C27.8897 26.2316 27.6863 25.5703 27.6524 24.8741ZM29.3134 7.85406C29.3134 8.55017 29.1778 9.24629 28.9405 9.8728C30.0253 10.8822 30.4998 12.1004 30.4998 13.7711C30.4998 14.1191 30.466 14.4323 30.4321 14.7456L30.4321 14.7456C30.2965 15.7202 29.9236 16.6599 29.3473 17.4257C28.8049 15.7898 27.8897 14.2931 26.7032 13.1097C26.4261 12.8252 26.149 12.5981 25.8465 12.3502C25.816 12.3252 25.7852 12.2999 25.7541 12.2744H25.7202C24.127 11.091 23.0761 9.10707 23.0761 6.9143C23.0761 6.25299 23.1778 5.59167 23.3473 4.99997C23.6524 6.11376 24.3643 7.05352 25.3134 7.61041C25.5168 7.74964 25.788 7.92367 26.0592 8.06289C26.4321 8.23692 26.771 8.41095 27.11 8.58498L27.1439 8.51537C27.8897 7.5408 28.3982 6.3574 28.5676 5.03478C29.0422 5.87012 29.3134 6.80988 29.3134 7.85406Z", fill: "#EF533D" })), Bk = (e) => /* @__PURE__ */ b.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M3.33333 2.54633V17.4537C1.2875 15.6226 0 12.9617 0 10C0 7.03835 1.2875 4.37739 3.33333 2.54633V2.54633Z", fill: "#238647" }), /* @__PURE__ */ b.createElement("path", { d: "M4.99984 1.33777V18.6622C3.66189 17.8883 2.51989 16.8132 1.6665 15.5298V4.47022C2.51989 3.18675 3.66189 2.11172 4.99984 1.33777V1.33777Z", fill: "#2F9B47" }), /* @__PURE__ */ b.createElement("path", { d: "M6.66683 0.56897V19.431C5.42477 18.9921 4.29533 18.3147 3.3335 17.4538V2.54618C4.29533 1.68535 5.42477 1.00795 6.66683 0.56897V0.56897Z", fill: "#62B64F" }), /* @__PURE__ */ b.createElement("path", { d: "M8.33334 0.138245V19.8617C7.1368 19.661 6.01231 19.2477 5 18.6622V1.3378C6.01231 0.752215 7.1368 0.338986 8.33334 0.138245V0.138245Z", fill: "#89CC53" }), /* @__PURE__ */ b.createElement("path", { d: "M9.99984 0V20H9.98717C8.82295 19.9986 7.70533 19.7982 6.6665 19.431V0.568992C7.70908 0.200504 8.83101 0 9.99976 0H9.99984Z", fill: "#3DB8AD" }), /* @__PURE__ */ b.createElement("path", { d: "M11.6668 0.13829V19.8617C11.1288 19.952 10.5762 19.9993 10.0126 20H9.98742C9.42398 19.9993 8.87146 19.952 8.3335 19.8618V0.138239C8.87546 0.0473226 9.43221 0 10 0C10.5679 0 11.1248 0.0473402 11.6668 0.13829V0.13829Z", fill: "#3394D7" }), /* @__PURE__ */ b.createElement("path", { d: "M13.3333 0.56902V19.431C12.2945 19.7982 11.1768 19.9986 10.0126 20H10V0C11.1688 0 12.2907 0.200514 13.3333 0.56902Z", fill: "#2872BC" }), /* @__PURE__ */ b.createElement("path", { d: "M14.9998 1.3379V18.6622C13.9875 19.2478 12.863 19.661 11.6665 19.8618V0.138306C12.863 0.339057 13.9875 0.752296 14.9998 1.3379V1.3379Z", fill: "#1D5C84" }), /* @__PURE__ */ b.createElement("path", { d: "M16.6668 2.54637V17.4536C15.705 18.3145 14.5756 18.9919 13.3335 19.4309V0.569031C14.5756 1.00805 15.705 1.6855 16.6668 2.54637Z", fill: "#993233" }), /* @__PURE__ */ b.createElement("path", { d: "M18.3333 15.5296C17.48 16.8131 16.338 17.8882 15 18.6622V1.33789C16.338 2.11188 17.48 3.18695 18.3333 4.47047V15.5296Z", fill: "#E13030" }), /* @__PURE__ */ b.createElement("path", { d: "M16.6665 17.4536V2.54639C18.7123 4.37745 19.9998 7.03838 19.9998 10C19.9998 12.9616 18.7123 15.6226 16.6665 17.4536V17.4536Z", fill: "#F28825" }), /* @__PURE__ */ b.createElement("path", { d: "M20.0002 10.0384C19.9925 12.0684 19.38 13.9558 18.3335 15.5297V4.47021C19.38 6.04416 19.9925 7.93157 20.0002 9.96158V10.0384Z", fill: "#F5C836" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.6665 11.5833H3.24984L3.28234 11.2931C3.569 11.5266 3.93484 11.6667 4.33317 11.6667C5.25317 11.6667 5.99983 10.9198 5.99983 10C5.99983 9.08017 5.25317 8.33333 4.33317 8.33333C3.95817 8.33333 3.6115 8.4575 3.33317 8.66692V7H2.6665V10C2.6665 10.0279 2.66734 10.0558 2.669 10.0833H2.6665V11.5833ZM3.24984 10C3.24984 9.40209 3.7165 8.91667 4.2915 8.91667C4.8665 8.91667 5.33317 9.40209 5.33317 10C5.33317 10.5979 4.8665 11.0833 4.2915 11.0833C3.7165 11.0833 3.24984 10.5979 3.24984 10Z", fill: "white" }), /* @__PURE__ */ b.createElement("path", { d: "M8.99983 8.41663H9.6665V10.1666C9.6665 10.9945 8.99433 11.6666 8.1665 11.6666C7.33867 11.6666 6.6665 10.9945 6.6665 10.1666V8.41663H7.33317V10.1666C7.33317 10.6725 7.70659 11.0833 8.1665 11.0833C8.62642 11.0833 8.99983 10.6725 8.99983 10.1666V8.41663Z", fill: "white" }), /* @__PURE__ */ b.createElement("path", { d: "M12.6702 11.5833H13.3369V9.83331C13.3369 9.00548 12.6647 8.33331 11.8369 8.33331C11.0091 8.33331 10.3369 9.00548 10.3369 9.83331V11.5833H11.0036V9.83331C11.0036 9.32739 11.377 8.91665 11.8369 8.91665C12.2968 8.91665 12.6702 9.32739 12.6702 9.83331V11.5833Z", fill: "white" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3338 8.41665H16.7505L16.718 8.7069C16.4313 8.4734 16.0655 8.33331 15.6672 8.33331C14.7472 8.33331 14.0005 9.08015 14.0005 9.99998C14.0005 10.9198 14.7472 11.6667 15.6672 11.6667C16.0422 11.6667 16.3888 11.5425 16.6672 11.3331V13H17.3338V9.99998C17.3338 9.97206 17.333 9.94423 17.3313 9.91665H17.3338V8.41665ZM16.7505 9.99998C16.7505 10.5979 16.2838 11.0833 15.7088 11.0833C15.1338 11.0833 14.6672 10.5979 14.6672 9.99998C14.6672 9.40206 15.1338 8.91665 15.7088 8.91665C16.2838 8.91665 16.7505 9.40206 16.7505 9.99998Z", fill: "white" })), Fh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.27705 7.83838L7.42563 7.85161C7.51041 7.88851 7.60642 7.92156 7.70533 7.95561C8.06873 8.08071 8.47134 8.21931 8.5 8.61191C8.0967 8.74941 7.70973 8.93464 7.38917 9.21769C7.29186 9.13152 7.15504 9.09861 7.02041 9.06623C6.81692 9.01729 6.61843 8.96955 6.56897 8.74091C6.64571 8.38179 6.79266 7.93099 7.27705 7.83838Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M8.39441 10.3282C8.60963 10.3341 8.82659 10.3399 9.05053 10.3212C9.15992 10.3685 9.27494 10.4633 9.32759 10.5733C9.32001 10.8363 9.2752 11.0933 9.23005 11.3523C9.18684 11.6001 9.14331 11.8497 9.13181 12.1082C8.93552 12.1887 8.74434 12.3517 8.69629 12.5656C8.57857 12.6005 8.469 12.6586 8.35809 12.7175C8.30237 12.7471 8.2463 12.7768 8.1887 12.8039C8.11304 12.642 8.12633 12.399 8.26077 12.2656C8.33394 12.1632 8.45237 12.1103 8.56717 12.0589C8.74594 11.9789 8.91593 11.9028 8.89258 11.6504C8.97624 11.5165 8.94997 11.3565 8.92468 11.2024C8.91227 11.1268 8.90009 11.0527 8.90127 10.9837C8.87305 10.89 8.84483 10.9261 8.81052 10.9699C8.78703 10.9998 8.76068 11.0335 8.72952 11.0316C8.57668 11.0642 8.41924 11.0739 8.28531 10.9975C8.2636 10.975 8.24087 10.9534 8.21828 10.9318C8.13555 10.8531 8.05454 10.7759 8.03126 10.6639C7.89733 10.5972 7.73938 10.4928 7.67241 10.3543L7.74449 10.3359C7.96294 10.3165 8.17781 10.3224 8.39441 10.3282Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M8.45426 13.4717C8.38224 13.4788 8.30906 13.4861 8.23734 13.4737C8.23841 13.4967 8.23517 13.5276 8.23162 13.5613C8.22148 13.6578 8.20892 13.7773 8.28848 13.7998L8.57778 13.6398C8.65056 13.6188 8.74177 13.5885 8.77586 13.5162C8.67835 13.4494 8.56774 13.4604 8.45426 13.4717Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M9.3628 9.31352C9.53046 9.25118 9.70519 9.18621 9.87931 9.23443C9.723 9.37967 9.59759 9.56546 9.47827 9.74221L9.45991 9.76939L8.77586 9.75511C8.8511 9.58959 9.04105 9.45167 9.2054 9.36842C9.25698 9.35286 9.30954 9.33332 9.3628 9.31352Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M11.4465 9.37264C11.3724 9.28961 11.3 9.2085 11.1356 9.23179C11.0107 9.21811 10.8527 9.20491 10.733 9.24075C10.679 9.25773 10.722 9.31054 10.7441 9.33742C10.9685 9.32455 11.009 9.43538 11.0517 9.55207C11.0824 9.6362 11.1142 9.72336 11.2169 9.76939C11.297 9.75447 11.3872 9.75089 11.477 9.74732C11.5945 9.74266 11.7114 9.73801 11.8042 9.70809C11.8272 9.64072 11.7812 9.59566 11.7363 9.55164C11.7278 9.54329 11.7193 9.53495 11.7113 9.52653C11.5786 9.52078 11.5119 9.44596 11.4465 9.37264Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M10.7688 10.5308C10.8839 10.3855 11.0519 10.3584 11.2191 10.3315C11.2399 10.3281 11.2608 10.3247 11.2815 10.3212L12.6214 10.3441C12.6547 10.3717 12.6315 10.3975 12.6064 10.4253C12.5886 10.445 12.57 10.4658 12.57 10.4889C12.5281 10.5243 12.477 10.5467 12.4274 10.5684C12.3786 10.5897 12.3313 10.6104 12.2957 10.6423C12.1907 10.6449 12.1539 10.7121 12.1151 10.7828C12.0886 10.831 12.0613 10.8808 12.0109 10.9131C11.8492 11.0587 11.6247 11.0243 11.4242 10.9937C11.3874 10.9881 11.3515 10.9826 11.3169 10.9783C11.24 10.9265 11.1521 10.8573 11.115 10.7777L11.0525 10.8335C11.0961 10.9797 11.1091 11.1346 11.1221 11.2891C11.1323 11.4108 11.1425 11.5322 11.1675 11.6489L11.4883 11.8401C11.4917 12.1024 11.7026 12.1603 11.9214 12.2203C12.0598 12.2583 12.2014 12.2972 12.2957 12.3892C12.2382 12.5436 12.1248 12.6735 12.0009 12.8039C11.8041 12.6317 11.5806 12.5202 11.3434 12.4455C11.3258 12.2403 11.1187 12.1027 10.9507 11.991C10.9133 11.9661 10.8778 11.9425 10.8468 11.9198C10.8306 11.7643 10.8189 11.6078 10.8072 11.4516C10.7844 11.1483 10.7617 10.846 10.7069 10.5542L10.7688 10.5308Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M11.8103 13.4695H11.3218C11.2936 13.464 11.2488 13.48 11.2605 13.5313L11.7495 13.7945L11.8103 13.4695Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M12.4619 7.98376L12.896 7.83838C13.1451 7.96268 13.3785 8.11805 13.6078 8.29506C13.7881 8.64797 13.7594 9.12574 13.6761 9.52082C13.6186 9.58825 13.5317 9.59694 13.443 9.60581C13.328 9.6173 13.2101 9.62909 13.1498 9.76941H13.13C12.9695 9.28222 12.5104 8.84496 12.0862 8.62245C12.1545 8.3733 12.2279 8.12859 12.4619 7.98376Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.9397 16.2493C32.4857 17.8506 32.6794 19.7319 32.3101 21.4145C32.2324 21.7714 32.1288 22.1189 31.9978 22.453C31.8222 22.994 31.5502 23.4457 31.2063 23.9292C30.8162 24.478 30.3335 24.9801 29.7969 25.4142C28.779 26.1274 27.4655 26.448 26.171 26.2488C25.9232 26.4776 25.6085 26.5144 25.2943 26.5511C25.221 26.5597 25.1478 26.5682 25.0755 26.5792H21.619C21.5935 26.4532 21.6319 26.3668 21.6714 26.2779C21.7063 26.1992 21.7421 26.1186 21.7351 26.0071C21.7796 25.7633 21.8516 25.4624 22.1184 25.3903C22.1206 25.3881 22.1228 25.3862 22.1248 25.3844C22.1319 25.3781 22.137 25.3736 22.1334 25.366C22.2199 25.5937 22.3276 25.8411 22.4576 26.0652C22.6327 25.9676 22.7291 25.7778 22.7493 25.5849C22.7146 25.3706 22.5602 25.201 22.3991 25.0402L22.3509 25.0262C22.433 24.9664 22.4854 24.8823 22.5388 24.7965C22.577 24.7351 22.6158 24.6728 22.6664 24.618C22.6856 24.6381 22.7055 24.6603 22.726 24.6832C22.8395 24.8104 22.9737 24.9608 23.1466 24.9002L23.1564 24.8959C23.2238 24.8668 23.3157 24.8271 23.3206 24.7342C23.3118 24.722 23.3088 24.7063 23.3059 24.691C23.3007 24.6646 23.2958 24.6389 23.2621 24.633C23.1669 24.5726 23.0753 24.4792 22.9822 24.3843C22.7541 24.1517 22.5177 23.9107 22.2012 24.1273C21.7895 24.5796 21.4398 25.0745 21.3528 25.6668L21.2699 26.5792C21.1894 26.5753 21.1061 26.5814 21.0231 26.5875C20.8958 26.5969 20.769 26.6062 20.6546 26.5792C20.6808 26.3836 20.6683 26.1879 20.6558 25.9923C20.6407 25.7558 20.6256 25.5192 20.6789 25.2825C20.7535 25.2571 20.8172 25.3142 20.8818 25.3721C20.9137 25.4006 20.9457 25.4293 20.9793 25.4484C20.9933 25.477 21.0379 25.477 21.0524 25.4484C21.0656 25.4004 21.0973 25.3548 21.1291 25.3091C21.1906 25.2206 21.2522 25.132 21.1788 25.0262C21.1371 24.9218 21.0396 24.8349 20.9462 24.7518C20.9176 24.7263 20.8894 24.7013 20.8633 24.6761C20.8871 24.5596 20.9569 24.4599 21.0267 24.3602C21.0557 24.3188 21.0847 24.2773 21.1104 24.2347C21.1347 24.2379 21.1379 24.2504 21.1418 24.2653C21.144 24.2742 21.1466 24.284 21.1539 24.2933C21.2316 24.3753 21.343 24.3996 21.4445 24.3851C21.4545 24.3816 21.4689 24.3795 21.4843 24.3772C21.536 24.3695 21.5997 24.36 21.5507 24.2933C21.546 24.2627 21.53 24.2316 21.5141 24.2009C21.4844 24.1432 21.4552 24.0866 21.5025 24.0355C21.573 24.0104 21.654 24.0328 21.7341 24.0549C21.8522 24.0875 21.968 24.1196 22.0443 23.9971C22.0552 23.9795 22.0655 23.9587 22.0754 23.9344C21.7698 23.7497 21.4595 23.565 21.0524 23.6766C20.9052 23.6568 20.8338 23.7527 20.7603 23.8515C20.7202 23.9053 20.6795 23.96 20.6256 23.9971C20.609 24.008 20.5914 24.0179 20.5727 24.0256C20.3445 23.9868 20.1107 24.0203 19.8853 24.0525C19.7466 24.0724 19.6109 24.0918 19.4819 24.0936L18.8613 25.0402C18.8652 25.1221 18.8642 25.2101 18.8633 25.3006C18.8606 25.5535 18.8577 25.8261 18.9577 26.0408C19.0789 26.2249 19.1804 26.38 19.2679 26.5792H12.6275C12.7238 26.366 12.9134 26.1471 13.0678 25.9822C13.0803 26.0256 13.1228 26.0413 13.1658 26.0571C13.19 26.066 13.2143 26.075 13.2335 26.089L13.6986 26.1814C13.722 26.1729 13.7457 26.1646 13.7695 26.1564C13.9088 26.1078 14.0518 26.0579 14.1633 25.9578C14.029 25.8858 13.8891 25.8282 13.7495 25.7708C13.5973 25.7081 13.4454 25.6455 13.3014 25.5646C13.307 25.4938 13.3174 25.4182 13.3281 25.3403C13.3716 25.0237 13.4202 24.6697 13.175 24.4432C13.0498 24.3477 12.8946 24.3216 12.7403 24.2956C12.691 24.2873 12.6414 24.2789 12.5933 24.2684C12.3654 24.3467 12.1085 24.4531 11.9873 24.6911C11.8075 24.5065 11.6086 24.3363 11.3714 24.2684C11.3791 24.1807 11.3957 24.09 11.4138 23.9971L11.4271 23.9309C11.4403 23.8656 11.4537 23.7997 11.4641 23.7347C11.7463 23.5722 12.0701 23.677 12.3733 23.7751C12.4602 23.8032 12.5454 23.8308 12.6275 23.8514C12.661 23.8514 12.693 23.8595 12.7245 23.8674C12.7699 23.8789 12.8142 23.89 12.86 23.8763C12.8727 23.843 12.8497 23.8271 12.8247 23.8098C12.8017 23.794 12.7772 23.777 12.7772 23.7445C12.4384 23.2346 11.8422 23.1765 11.2414 23.2543C11.1308 23.2648 11.0677 23.3693 11.0106 23.4639C10.9347 23.5895 10.8693 23.6977 10.7172 23.5453C10.605 23.515 10.4999 23.5503 10.3921 23.5865C10.3097 23.6141 10.2256 23.6423 10.1355 23.6423L9.74285 23.7928C9.70721 23.85 9.67306 23.9077 9.6385 23.9661L9.62009 23.9971C9.42067 24.3426 9.24301 24.6979 9.06896 25.0501C9.07522 25.152 9.06672 25.2612 9.05811 25.3717C9.03965 25.6087 9.02073 25.8515 9.14614 26.0408C9.2342 26.2203 9.35075 26.4293 9.47661 26.5792H0.910821C0.610394 26.1767 0.425994 25.631 0.528554 25.1061C0.600035 24.8732 0.71658 24.6403 0.935166 24.4894C0.925843 24.3229 0.953295 24.1688 1.01027 24.0288C1.0947 23.8265 1.24284 23.6527 1.43398 23.5085C1.70125 23.329 2.04985 23.2709 2.38965 23.3342C2.77191 22.9317 3.37743 22.8202 3.90214 22.9945C4.02801 23.0484 4.14922 23.106 4.26058 23.1843C4.41932 22.8729 4.50948 22.5325 4.59959 22.1923C4.6665 21.9397 4.73338 21.6872 4.82828 21.4467C4.8547 21.3787 4.88319 21.3129 4.91479 21.2475C5.0033 21.062 5.08044 20.8662 5.15802 20.6694C5.27564 20.3709 5.39426 20.0699 5.55501 19.7983C5.16186 18.7157 4.81896 17.5803 4.60141 16.4299C4.61125 16.3635 4.65062 16.3028 4.69983 16.2493C4.74644 16.2001 4.80135 16.1581 4.84797 16.128C4.94535 15.8951 5.02822 15.657 5.08986 15.4148C5.03093 15.4225 4.97318 15.4534 4.91379 15.4851C4.86147 15.5131 4.80787 15.5418 4.75111 15.5558C4.72745 15.5929 4.69913 15.6277 4.67086 15.6625C4.61803 15.7274 4.56532 15.7922 4.5434 15.8712C4.49505 15.8551 4.47726 15.7708 4.46131 15.6952C4.45778 15.6785 4.45434 15.6622 4.45068 15.6471C4.45904 15.5426 4.43768 15.431 4.41634 15.3196C4.37425 15.0997 4.33224 14.8803 4.51853 14.7161L4.7998 14.4832C4.80361 14.2962 4.82403 14.1131 4.84437 13.9306C4.84892 13.8898 4.85346 13.8491 4.85781 13.8084H4.80912C4.76679 13.848 4.71668 13.8857 4.66558 13.9242C4.53594 14.0218 4.3999 14.1242 4.36832 14.2741H4.34449L4.33465 13.2834C4.37197 13.2541 4.41496 13.2269 4.45942 13.1988C4.52417 13.1578 4.59206 13.1148 4.6501 13.0604C4.60555 11.9535 4.68325 10.871 4.98368 9.89531C5.04523 9.73759 5.14925 9.60114 5.25314 9.46485C5.30574 9.39585 5.3583 9.32689 5.40531 9.25524C5.40912 9.18494 5.41133 9.11407 5.41353 9.04333C5.42003 8.83483 5.4265 8.62742 5.47368 8.43881C5.56401 8.38522 5.6496 8.31054 5.73576 8.23538C5.82055 8.1614 5.90589 8.08694 5.99684 8.03163C5.93577 7.98124 5.84279 7.97079 5.75319 7.96071C5.72196 7.9572 5.69114 7.95373 5.66223 7.94864C5.82228 7.51293 6.16208 7.14725 6.49617 6.81788L6.5462 6.77908C6.6794 6.67546 6.81074 6.57329 6.96132 6.51703C7.00864 6.51252 7.03636 6.54139 7.06528 6.57152L7.07838 6.58498C7.21415 6.5985 7.3446 6.62851 7.47432 6.65835C7.66826 6.70297 7.86059 6.74722 8.06668 6.73541C7.95531 6.55594 7.76107 6.37595 7.53368 6.37595L7.57615 6.35209C7.88124 6.22138 8.09258 6.13372 8.42201 6.06992C8.44943 6.22356 8.55011 6.3476 8.65015 6.47084C8.72775 6.56643 8.80496 6.66155 8.84727 6.76964L9.04617 6.93459C9.03736 6.84928 9.03923 6.75704 9.04114 6.66325C9.04651 6.39888 9.05214 6.12219 8.8193 5.95373C8.8048 5.89045 8.87731 5.90549 8.91202 5.92053C9.27978 6.06992 9.64237 6.26962 9.98682 6.4688C10.034 6.44606 10.0815 6.42266 10.1294 6.39912C10.2977 6.31633 10.4696 6.23176 10.639 6.16795C10.6171 6.26934 10.586 6.37386 10.5539 6.48145C10.4864 6.70796 10.4148 6.94818 10.4173 7.20171C10.5102 7.13465 10.5856 7.0337 10.663 6.93003C10.7156 6.8597 10.7691 6.78813 10.8296 6.72503C10.8207 6.58356 10.901 6.46326 10.9794 6.34575C11.0244 6.27842 11.0687 6.21201 11.0953 6.14305C11.3527 6.06992 11.7692 6.02168 12.0214 6.14305C11.786 6.1822 11.7947 6.35908 11.8026 6.52099C11.8035 6.5393 11.8044 6.55742 11.8049 6.57513L11.8287 6.5938C12.0277 6.55075 12.3074 6.47398 12.4617 6.31734C12.729 6.36143 12.9041 6.40085 13.118 6.56009C13.0904 6.57329 13.0617 6.58635 13.0325 6.59968C12.8664 6.67533 12.6819 6.75935 12.5705 6.92473C12.8657 6.91487 13.1812 6.8962 13.477 6.85159L13.608 6.76964C14.2984 7.20149 14.5656 7.92495 14.8203 8.61432C14.846 8.68407 14.8718 8.75392 14.8978 8.82264C14.8517 8.8138 14.8059 8.79231 14.7585 8.77005C14.7001 8.7427 14.6393 8.71417 14.5725 8.70645C14.5772 8.72624 14.5816 8.74759 14.5862 8.76981C14.6138 8.90493 14.6481 9.07221 14.8149 9.11363C14.9866 9.13166 15.062 9.25353 15.1403 9.38006C15.1701 9.4283 15.2004 9.47723 15.2365 9.52133C15.3511 9.63488 15.4836 9.73382 15.6161 9.83274C15.875 10.0262 16.1339 10.2195 16.259 10.5219C16.4917 10.9058 16.5814 11.3502 16.671 11.7939C16.7252 12.0623 16.7793 12.3304 16.865 12.5848C16.7973 12.4943 16.6854 12.4664 16.5699 12.4375C16.462 12.4105 16.3509 12.3827 16.2694 12.3026C16.2973 12.5121 16.4185 12.7398 16.6076 12.8659C16.7226 12.9271 16.8428 12.9741 16.9644 13.0216C17.0169 13.0422 17.0698 13.0628 17.1225 13.0848C17.3115 13.4147 17.3835 13.7886 17.4462 14.1673C17.3064 14.0848 17.1706 14.0065 17.0158 13.9583L16.9914 13.9832C17.0111 14.2975 17.2333 14.5651 17.5042 14.7062C17.5095 14.8421 17.5159 14.9709 17.5222 15.0979C17.5282 15.2196 17.5341 15.3396 17.5389 15.4625C18.0108 15.8427 18.6319 16.1731 19.2467 16.2493C19.3638 16.2639 19.4839 16.2701 19.6077 16.2639C19.683 16.2645 19.7582 16.2493 19.8325 16.2344C19.8855 16.2237 19.938 16.2131 19.99 16.2084C20.5007 16.1653 20.9695 16.0227 21.3865 15.7571C21.3476 15.4122 21.4595 15.0968 21.7263 14.8639C22.0987 14.4515 22.7099 14.4754 23.2046 14.6066C24.0111 14.9075 24.6409 15.5102 25.1465 16.2084C25.5702 16.794 25.9079 17.446 26.1907 18.044C26.6331 19.0856 26.8724 20.1691 26.9236 21.3736C26.9247 21.4093 26.9257 21.4446 26.9278 21.4804C26.9682 22.3093 26.8977 23.1392 26.7444 23.9292C26.718 24.0682 26.6885 24.2067 26.6553 24.3415C26.6412 24.4164 26.701 24.4415 26.7567 24.4648C26.7766 24.4732 26.796 24.4813 26.8112 24.4914C27.7353 24.7461 28.6319 24.4966 29.3602 23.9292C29.5907 23.7497 29.8036 23.5386 29.9958 23.3026C30.5039 22.745 30.8214 22.1002 31.1089 21.4145C31.6502 19.7687 31.5476 17.8277 31.0079 16.2493C30.9789 16.1643 30.9483 16.0808 30.9167 15.9973C30.2713 14.269 28.7889 12.4478 27.0526 11.6516C26.717 11.594 26.3956 11.6423 26.0723 11.6909C25.7141 11.7447 25.3535 11.7989 24.9688 11.7097C24.4596 11.5588 23.9608 11.3062 23.5972 10.8788L23.6112 10.8357C23.8981 10.8705 24.1685 10.9369 24.426 11.0447C24.4314 10.9772 24.3963 10.917 24.3607 10.856C24.3323 10.8074 24.3036 10.7583 24.2949 10.7045C24.5953 10.6313 24.8963 10.5644 25.2164 10.5442C25.109 10.3113 24.8969 10.2952 24.6842 10.2791C24.5511 10.269 24.4178 10.2589 24.3099 10.1956C24.2805 10.1941 24.2503 10.1898 24.22 10.1855C24.1451 10.1747 24.0696 10.1639 24.0043 10.1956C24.0135 10.2395 24.0295 10.2812 24.0456 10.3233C24.0721 10.3927 24.0989 10.4628 24.096 10.5442C24.0074 10.5672 23.92 10.5375 23.8315 10.5074C23.7704 10.4867 23.7089 10.4657 23.6459 10.4617C23.611 10.4649 23.5736 10.4599 23.5362 10.4548C23.4593 10.4443 23.3828 10.434 23.3304 10.4965C23.2281 10.3649 23.1474 10.2129 23.0661 10.0596C22.9008 9.7483 22.733 9.43208 22.3758 9.27287L22.3903 9.22411C22.6411 9.16079 22.8868 9.07807 23.1329 8.99516C23.7377 8.79149 24.3457 8.58674 25.0418 8.666L25.0879 8.67612C25.1797 8.69611 25.2734 8.71649 25.3573 8.7578L25.0998 8.9907C25.3324 9.20959 25.5997 9.38906 25.9385 9.3792L25.9581 9.35483C25.9368 9.20571 25.8598 9.0797 25.7821 8.95271C25.7712 8.93481 25.7602 8.9169 25.7494 8.89889C26.0046 8.94156 26.2076 9.1387 26.4052 9.33051C26.455 9.37888 26.5045 9.42692 26.5543 9.47205C27.0091 10.2771 27.7514 11.0567 28.5573 11.5598C29.989 12.454 30.9167 13.978 31.5994 15.3909C31.7248 15.6653 31.8382 15.9521 31.9397 16.2493ZM12.9474 11.3683C13.0613 11.3449 13.1996 11.3148 13.2901 11.1936C13.318 11.2727 13.2967 11.3626 13.2702 11.4468C13.2606 11.4762 13.2508 11.5063 13.2423 11.5346C13.3 11.8291 13.0975 12.0549 12.9151 12.2584C12.8869 12.2898 12.8592 12.3207 12.833 12.3512C12.7425 12.7021 12.4715 13.1055 12.0908 13.1689C12.0857 13.2125 12.0953 13.2754 12.1243 13.3191C12.9088 13.329 13.6271 13.5676 14.2834 13.9273L14.2931 14.2771C13.6703 13.9034 12.9525 13.6653 12.196 13.6206C12.1923 13.7351 12.1722 13.8401 12.152 13.9458C12.1473 13.9706 12.1426 13.9953 12.138 14.0203C12.7761 14.2974 13.3892 14.6519 13.9413 15.1535L13.9184 15.5625L13.8469 15.5008C13.2869 15.0177 12.7 14.5114 12.0242 14.2771L12.0225 14.2795C11.9279 14.4208 11.8241 14.5757 11.6912 14.7101C11.2967 14.4533 10.8961 14.2152 10.4446 14.1024C10.278 14.1401 10.2465 13.9931 10.2204 13.8706C10.2159 13.8496 10.2115 13.8293 10.2067 13.8108L10.1741 13.5291C10.4355 13.4506 10.5636 13.1834 10.6398 12.9443L10.6572 12.9526C10.7491 12.9962 10.8601 13.0489 10.9581 12.9937C11.0405 12.9384 11.049 12.8531 11.0574 12.7677C11.0593 12.7489 11.0612 12.73 11.0638 12.7115C10.9777 12.4118 10.6589 12.3791 10.3871 12.3512C10.3411 12.3465 10.2964 12.3419 10.2545 12.3362C9.86453 12.3076 9.46443 12.3175 9.15533 12.5124C9.08076 12.5687 9.09377 12.6704 9.10503 12.7582C9.1082 12.783 9.11123 12.8067 9.11212 12.8279C9.14618 12.9059 9.21786 12.9261 9.29311 12.9443C9.38411 12.9407 9.46901 12.9157 9.54527 12.8773C9.52595 13.1439 9.67389 13.3726 9.89758 13.5041C9.91543 13.5007 9.92534 13.5105 9.93493 13.52C9.93818 13.5233 9.94139 13.5265 9.94486 13.5291L9.86453 13.972C9.7957 14.1008 9.66558 14.1164 9.53456 14.1322C9.44882 14.1425 9.36269 14.1528 9.29311 14.195C8.96062 14.2823 8.64593 14.4237 8.35615 14.6134C8.19329 14.5215 8.06488 14.3667 7.94167 14.2181L7.92249 14.195C7.44206 14.3748 7.00485 14.6519 6.58645 14.9783L6.1533 15.338C6.12517 15.2548 6.1277 15.1504 6.13024 15.0459C6.13155 14.9919 6.13286 14.9374 6.12991 14.8863C6.4771 14.5306 6.8932 14.3401 7.30938 14.1495C7.47398 14.0742 7.63859 13.9988 7.79895 13.9132L7.77557 13.4943C7.62281 13.4509 7.44915 13.4699 7.28196 13.4882C7.22491 13.4944 7.16861 13.5006 7.11415 13.5041C6.61441 13.5972 6.16296 13.8056 5.74405 14.0884C5.74787 14.0478 5.74586 14.0027 5.74382 13.9569C5.73828 13.8324 5.73251 13.7029 5.84369 13.6455C6.43851 13.3004 7.09992 13.1101 7.84267 13.1346C7.85691 13.0956 7.85182 13.0036 7.81827 12.9594C7.80016 12.9258 7.79184 12.8857 7.78357 12.8459C7.76793 12.7707 7.75248 12.6964 7.67135 12.6678C7.32513 12.3185 7.11161 11.911 7.044 11.4468H7.04959C7.07915 11.4652 7.11594 11.4637 7.15206 11.4622C7.1619 11.4618 7.17168 11.4613 7.18126 11.4613C7.18126 11.4613 7.19651 11.4484 7.19651 11.4468C7.19651 11.4484 7.20414 11.4416 7.20414 11.4416C7.06687 10.9551 7.06687 10.3817 7.20414 9.90039C6.91385 9.77356 6.5717 9.52562 6.4624 9.20906C6.33886 8.99959 6.23464 8.78075 6.20058 8.53281C6.3109 8.23133 6.47206 7.95427 6.64339 7.68138C6.70077 7.64624 6.76501 7.62682 6.82906 7.60745C6.87112 7.59474 6.91309 7.58205 6.95299 7.56495C6.98403 7.54452 7.01532 7.52273 7.047 7.50066C7.24833 7.36044 7.46519 7.20941 7.72829 7.33156C7.81962 7.35157 7.90712 7.38272 7.99483 7.41395C8.09849 7.45085 8.20246 7.48786 8.31344 7.50673C8.31344 7.61329 8.33632 7.73492 8.44613 7.77442C8.64907 7.80918 8.73537 7.9844 8.82171 8.15971C8.8671 8.25186 8.9125 8.34404 8.97485 8.41585C9.05142 8.4761 9.15534 8.47464 9.26407 8.47312C9.33078 8.47219 9.39929 8.47123 9.46443 8.48447C9.51997 8.50064 9.57594 8.51458 9.63169 8.52847C9.81067 8.57306 9.98735 8.61707 10.1401 8.73241C10.5163 8.45952 11.0247 8.40598 11.496 8.47459C11.5337 8.315 11.593 8.15905 11.6493 8.01121C11.6636 7.97367 11.6777 7.93664 11.6912 7.90022C11.7529 7.90264 11.7647 7.86457 11.777 7.82464C11.7884 7.78766 11.8003 7.74909 11.8528 7.7396C11.8886 7.71623 11.9248 7.69117 11.9615 7.66573C12.1835 7.5118 12.426 7.34369 12.7288 7.44851C12.8233 7.49339 12.9287 7.51852 13.034 7.54364C13.2252 7.58923 13.4164 7.6348 13.5422 7.79834L13.5275 7.80821C13.6819 7.95052 13.7603 8.13305 13.8391 8.31623C13.8866 8.42678 13.9343 8.53757 13.9987 8.63989C13.9531 8.76203 13.9403 8.8987 13.9275 9.0351C13.9041 9.28473 13.8808 9.53342 13.6566 9.6904L13.3943 9.92379L13.4039 9.93418C13.3386 9.97235 13.2669 9.99376 13.196 10.015C13.1587 10.0261 13.1216 10.0372 13.0857 10.0506C13.2423 10.4737 13.1477 10.9946 12.9474 11.3683ZM5.53724 10.3211L5.94552 10.0878V9.49356C5.83362 9.5596 5.75549 9.65676 5.67714 9.75421C5.63574 9.8057 5.59427 9.85727 5.54772 9.90436L5.53724 10.3211ZM5.69877 12.8039L5.46552 11.9646C5.47369 11.7081 5.55417 11.4934 5.65057 11.2792L6.01724 11.1487L5.84467 11.4471C5.86631 11.709 5.8206 11.9453 5.77475 12.1825C5.73582 12.3837 5.6968 12.5855 5.69877 12.8039ZM13.1647 16.7951C13.3686 17.0658 13.6714 17.2735 14.0172 17.2043L13.986 17.1734C13.8165 17.0065 13.635 16.8277 13.625 16.5931C13.6604 16.2715 13.4345 16.1511 13.2074 16.0301C13.1008 15.9733 12.994 15.9163 12.9138 15.8384C12.9421 15.9455 12.9597 16.0567 12.9772 16.1679C13.0119 16.3879 13.0466 16.6078 13.1647 16.7951ZM6.66168 16.7535C6.89256 17.0562 7.27865 17.3963 7.67241 17.4936C7.64305 17.2441 7.47882 17.0447 7.31501 16.8459C7.22487 16.7365 7.13486 16.6272 7.06751 16.5098L7.05709 16.3993C6.90792 16.27 6.72859 16.1826 6.57448 16.1143C6.55375 16.2956 6.59524 16.4706 6.63595 16.6423L6.63618 16.6433C6.64489 16.68 6.65368 16.7171 6.66168 16.7535ZM5.46552 17.5633C5.51255 17.7086 5.56911 17.8904 5.60102 18.0453C5.69883 17.851 5.86086 17.7282 6.03421 17.5968C6.11987 17.5318 6.20829 17.4648 6.2931 17.386C6.1464 17.2971 5.9633 17.2546 5.80092 17.2272V17.2177C5.77209 17.2431 5.73942 17.2687 5.70596 17.2949C5.60489 17.3739 5.49665 17.4586 5.46552 17.5633ZM6.56897 19.1487L6.7539 18.9115C6.93972 18.6731 7.09251 18.3994 7.12069 18.0949C6.98947 17.9972 6.81599 18.0645 6.68873 18.1208C6.67676 18.2092 6.66303 18.2974 6.64924 18.3859C6.61085 18.6324 6.57188 18.8827 6.56897 19.1487ZM6.72041 19.9599C6.6703 19.9552 6.61975 19.9504 6.56897 19.9471C6.94327 19.7329 7.27198 19.3112 7.43633 18.8845C7.48618 18.8635 7.53834 18.8751 7.5914 18.8868C7.61823 18.8928 7.6453 18.8988 7.67241 18.9007L7.42303 19.837C7.21566 20.0065 6.97353 19.9837 6.72041 19.9599ZM8.69702 19.6121C8.46671 19.6835 8.19769 19.7261 7.94828 19.6835L8.0046 19.6383C8.14823 19.5228 8.29896 19.4015 8.45716 19.3182L8.90872 18.8729H9.32759C9.21495 19.1622 9.03091 19.531 8.69702 19.6121ZM7.6771 16.1143C7.7549 16.5132 7.92593 16.875 8.15821 17.2177L8.21945 16.457L7.6771 16.1143ZM9.27467 17.6093C9.3071 17.7572 9.34026 17.9084 9.32273 18.0453C9.0578 17.8311 8.78484 17.5491 8.77586 17.2177C8.8441 17.2594 8.92397 17.2783 9.00341 17.297C9.08396 17.3161 9.16406 17.335 9.23111 17.3775C9.24016 17.452 9.25732 17.5303 9.27467 17.6093ZM9.05172 20.528C9.3583 20.435 9.65602 20.333 9.93917 20.1837C9.98972 20.1143 10.0475 20.0468 10.1054 19.9792C10.2538 19.8059 10.4026 19.6321 10.431 19.4246C10.3329 19.451 10.2407 19.4526 10.1504 19.4542C10.0338 19.4561 9.92052 19.4581 9.80228 19.5136C9.77291 19.5641 9.74616 19.6162 9.71937 19.6683C9.63036 19.8415 9.54079 20.0158 9.35361 20.137C9.32953 20.2359 9.25014 20.3147 9.17365 20.3907C9.12777 20.4363 9.08294 20.4808 9.05172 20.528ZM10.0226 18.3212L9.87931 17.6825C10.1075 17.5804 10.2219 17.4518 10.4051 17.2458L10.4301 17.2177C10.4402 17.6437 10.3688 18.0458 10.0226 18.3212ZM10.9828 18.8729C10.9878 18.9693 11.0135 19.0598 11.071 19.1352C11.2851 19.2096 11.3983 19.377 11.5122 19.5455C11.615 19.6976 11.7184 19.8505 11.8972 19.9366C12.1382 20.0415 12.4154 19.9161 12.6274 19.8202L12.6379 19.8154C12.5643 19.735 12.4861 19.6661 12.4079 19.5973C12.3149 19.5155 12.2218 19.4335 12.1366 19.3323C12.0272 19.287 11.9172 19.2213 11.9223 19.0905L10.9828 18.8729ZM11.6193 17.2177C11.6518 17.585 11.6984 17.9888 11.8103 18.3212C11.7655 18.2845 11.7046 18.2513 11.6395 18.2157C11.4496 18.112 11.2245 17.9891 11.263 17.7078C11.324 17.6055 11.3885 17.5241 11.4539 17.4415C11.509 17.372 11.5647 17.3018 11.6193 17.2177ZM12.4993 17.9045C12.6564 18.1151 12.9986 18.0436 13.1897 17.9812C13.1479 17.9079 13.064 17.8483 12.9802 17.7887C12.8805 17.7179 12.7809 17.6471 12.7524 17.5535C12.7223 17.2452 12.6615 16.9461 12.5656 16.666L12.5618 16.6753C12.411 17.0525 12.2325 17.4987 12.4993 17.9045ZM12.7511 18.8489C12.7133 18.8178 12.6757 18.7868 12.6379 18.7563C12.9001 18.7221 13.1612 18.6863 13.405 18.597H13.5038L13.7202 18.9465C13.7959 18.9945 13.873 19.0393 13.95 19.0841C14.066 19.1516 14.1819 19.219 14.2931 19.2971C14.2871 19.3388 14.2524 19.3518 14.2165 19.3652C14.1973 19.3724 14.1777 19.3797 14.162 19.3917C13.5841 19.5342 13.1639 19.1885 12.7511 18.8489ZM14.5456 18.6717C14.3455 18.5426 14.1376 18.4084 14.0172 18.2193C14.1477 18.1133 14.3253 18.0908 14.5011 18.0686C14.5561 18.0616 14.6109 18.0547 14.664 18.0453C14.7172 18.0925 14.7441 18.151 14.771 18.2096C14.7895 18.2499 14.808 18.2902 14.8352 18.3269C15.0059 18.5143 15.1913 18.6931 15.3966 18.85C15.1822 18.8954 14.921 18.8724 14.7209 18.7878C14.6649 18.7486 14.6056 18.7104 14.5456 18.6717ZM14.2931 16.4318C14.4519 16.6553 14.6772 16.6402 14.9061 16.6249C14.9779 16.6201 15.0501 16.6152 15.1207 16.6178V16.5808L14.6656 16.1477C14.5382 16.1935 14.402 16.3226 14.2931 16.4318ZM14.4653 12.4092L14.0427 12.528L14.2545 11.4246C14.2851 11.4844 14.3236 11.5434 14.3624 11.6029C14.4806 11.7841 14.602 11.9701 14.5127 12.2003L14.4653 12.4092ZM14.8481 13.9713C14.8866 14.01 14.9248 14.0527 14.9639 14.0962C15.1485 14.3021 15.3509 14.5277 15.6724 14.4394C15.6539 14.3418 15.6088 14.2556 15.5643 14.1705C15.5405 14.125 15.5169 14.0798 15.4975 14.0333C15.4665 14.0002 15.4417 13.9483 15.4164 13.8953C15.3593 13.7755 15.2997 13.6506 15.1593 13.7255C15.0576 13.6643 15.0064 13.5755 14.9552 13.4868C14.9294 13.4419 14.9034 13.3969 14.871 13.3557C14.8402 13.487 14.8436 13.6404 14.8469 13.7853C14.8484 13.8499 14.8498 13.9128 14.8481 13.9713ZM15.2086 15.5494C15.1842 15.4922 15.1594 15.4341 15.1207 15.3833C15.1719 15.3727 15.2234 15.3571 15.2748 15.3415C15.4396 15.2914 15.6041 15.2414 15.7596 15.3579C15.8319 15.4185 15.8931 15.4885 15.9533 15.5574C16.0365 15.6525 16.1181 15.7458 16.2241 15.809C16.1436 15.8609 16.077 15.8338 16.007 15.8054C15.9507 15.7826 15.8923 15.7588 15.8228 15.7746C15.6495 15.7889 15.4399 15.8037 15.2984 15.7154C15.2589 15.6672 15.2339 15.6088 15.2086 15.5494ZM15.476 17.7437C15.7995 17.9207 16.2094 18.0935 16.6404 18.0329C16.655 18.0263 16.6729 18.0221 16.6908 18.018C16.73 18.009 16.7694 17.9999 16.7759 17.9641C16.6587 17.926 16.5392 17.8573 16.4183 17.7877C16.2635 17.6988 16.1064 17.6085 15.949 17.5792C15.8537 17.4428 15.7402 17.4968 15.6208 17.5536C15.5473 17.5886 15.4716 17.6247 15.3966 17.618C15.3995 17.652 15.4242 17.6801 15.4464 17.7053C15.4583 17.7188 15.4694 17.7314 15.476 17.7437ZM17.3276 17.0976C17.073 17.2002 16.721 17.1803 16.5 16.9734L16.8566 16.7257C16.9887 16.8697 17.1665 16.9894 17.3276 17.0976ZM8.74338 15.6268L9.03748 15.3652C9.06212 15.3652 9.08204 15.3701 9.0962 15.3874L9.07208 15.8879C9.21415 16.0093 9.3903 16.0497 9.57693 16.0589C9.5866 15.9704 9.63895 15.8989 9.6917 15.8268C9.7191 15.7893 9.7466 15.7517 9.76829 15.7116C9.78895 15.6754 9.79672 15.6327 9.80449 15.5899C9.81701 15.5209 9.82955 15.4518 9.8962 15.4105L9.9308 15.4413C9.94166 15.4889 9.94802 15.5382 9.95438 15.5876C9.968 15.693 9.98173 15.7991 10.0388 15.8879C10.0488 15.9601 10.0624 16.0497 10.0724 16.1133C10.2889 16.122 10.4855 16.068 10.6516 15.9958C10.645 15.8809 10.6719 15.7801 10.699 15.6785C10.7123 15.629 10.7255 15.5792 10.735 15.5276C10.7528 15.506 10.7477 15.4771 10.7429 15.4504C10.7358 15.4105 10.7296 15.3756 10.8032 15.3782C10.8357 15.4421 10.8801 15.5067 10.9251 15.5723C10.9758 15.6462 11.0273 15.7212 11.0637 15.7978C11.3479 15.5319 11.4663 15.1851 11.5345 14.8238C11.4845 14.7616 11.4182 14.7369 11.3517 14.7122C11.3081 14.696 11.2644 14.6797 11.2252 14.6528C10.3916 14.4052 9.32267 14.3556 8.51795 14.7386C8.46343 15.0444 8.53158 15.3826 8.74338 15.6268ZM1.06319 24.9784C1.03862 25.3087 1.05819 25.621 1.07842 25.944L1.08527 26.0543C1.15727 26.1737 1.28782 26.3125 1.41838 26.3212L1.44046 26.0778C1.46159 25.9447 1.44801 25.8083 1.43468 25.6743C1.41409 25.4676 1.39409 25.2667 1.50333 25.0927C1.62909 25.1355 1.75532 25.2023 1.86332 25.2646C1.91708 24.9493 1.84028 24.5815 1.55709 24.3901L1.06319 24.9784ZM2.27536 26.0453C2.04314 25.4719 2.18596 24.8006 2.37903 24.2557C2.45175 24.0557 2.58577 23.8804 2.72004 23.7047C2.74204 23.6759 2.76406 23.6471 2.78581 23.6182L3.37931 23.5625C3.22182 23.6428 3.19596 23.7903 3.17053 23.9353C3.16479 23.9681 3.15907 24.0007 3.15185 24.0324C3.19219 24.061 3.24749 24.0744 3.30251 24.0877C3.4091 24.1135 3.51465 24.1391 3.50837 24.2746C3.57238 24.5346 3.51789 24.8051 3.35391 25C3.26029 24.7862 3.09631 24.5679 2.85404 24.4978C2.60533 24.824 2.63175 25.2334 2.65738 25.6306C2.66031 25.676 2.66323 25.7213 2.66573 25.7663C2.56422 25.8651 2.44833 25.9373 2.33305 26.0091L2.27536 26.0453ZM3.53448 25.909C3.54462 25.9269 3.54671 25.9506 3.54871 25.9732C3.55174 26.0075 3.55455 26.0394 3.58503 26.0453C3.63106 25.7814 3.77971 25.5758 3.92993 25.368C4.0211 25.2419 4.11284 25.115 4.18257 24.9738C4.2169 24.9255 4.23734 24.8694 4.2578 24.8133C4.2903 24.724 4.32289 24.6346 4.41137 24.5758C4.5138 24.5758 4.60098 24.615 4.6883 24.6543C4.76655 24.6896 4.84489 24.7248 4.93441 24.732C4.97165 24.7606 4.95051 24.7871 4.92811 24.8152C4.91466 24.832 4.90076 24.8495 4.89876 24.8683C4.88387 24.9982 4.85603 25.1196 4.82856 25.2394C4.7834 25.4363 4.73922 25.6289 4.7551 25.8486H4.78968C5.0435 25.5767 5.21906 25.2848 5.40488 24.9758L5.42713 24.9388L5.46171 24.6517C5.50694 24.3091 5.13873 24.0877 4.89876 23.946L5.11373 23.6686L4.81469 23.5625C4.46564 23.5975 4.15224 23.744 3.90801 24.022C3.60419 24.5865 3.5547 25.2238 3.53448 25.909ZM5.06932 23.2436C5.01822 23.2555 4.967 23.2674 4.91379 23.252C4.91854 23.0551 5.02197 22.8878 5.17554 22.7584L5.28372 22.7349C5.27638 22.7521 5.28545 22.762 5.29435 22.7716C5.29761 22.7751 5.30085 22.7787 5.30325 22.7825C5.34335 22.7487 5.41723 22.7487 5.44678 22.7922L5.49586 22.85C5.53078 22.8545 5.57242 22.8537 5.61529 22.8528C5.74864 22.8502 5.89396 22.8473 5.88637 23.0029C5.94023 23.0462 6.01912 23.0741 6.09902 23.1024C6.27515 23.1647 6.45621 23.2288 6.38506 23.4627C6.37797 23.4841 6.36736 23.5065 6.35645 23.5295C6.32106 23.6043 6.28247 23.6859 6.35023 23.7594C6.3732 23.7604 6.39732 23.7611 6.4222 23.7618C6.62774 23.7679 6.88597 23.7755 6.98718 23.989L7.12069 24.3235L6.91858 24.9418L6.51382 23.9404C6.17609 23.5767 5.70877 23.4091 5.25843 23.2476L5.24361 23.2423C5.18389 23.2169 5.12668 23.2302 5.06932 23.2436ZM4.91379 22.0962C4.92908 22.1547 4.9681 22.2142 5.01766 22.2512C5.07778 22.2364 5.13724 22.2152 5.19708 22.1939C5.35816 22.1364 5.52191 22.0779 5.70837 22.1416L5.72188 22.1525C6.04888 22.4183 6.38976 22.6953 6.78451 22.8391L6.92792 22.8167C6.94574 22.8221 6.96399 22.8266 6.98225 22.8312C7.05423 22.849 7.12654 22.8669 7.17363 22.94C7.21059 23.0223 7.16107 23.0821 7.11104 23.1424C7.08614 23.1725 7.0611 23.2027 7.04656 23.2359C7.17471 23.3233 7.19921 23.4503 7.22368 23.5771C7.24149 23.6694 7.25929 23.7616 7.31704 23.8384L7.67241 23.4006C7.64788 23.3441 7.63821 23.2757 7.62848 23.207C7.60516 23.0422 7.58151 22.8751 7.35237 22.862C7.2427 22.8118 7.16994 22.7119 7.17363 22.5978C7.06971 22.5104 6.95357 22.4471 6.83722 22.3836C6.71684 22.318 6.59622 22.2523 6.48872 22.1596C6.42946 22.1161 6.37839 22.0646 6.32799 22.0137C6.23086 21.9157 6.13626 21.8203 5.99046 21.7901C5.83702 21.7121 5.66936 21.6716 5.49167 21.6356C5.28322 21.6061 5.19447 21.7405 5.10275 21.8794C5.04901 21.9609 4.99425 22.0438 4.91379 22.0962ZM5.52311 21.1093L5.46552 21.0167L5.85182 20.528C5.96782 20.5586 6.09277 20.5708 6.2177 20.583C6.50884 20.6115 6.79986 20.64 6.97709 20.9009C7.03996 20.9445 7.10745 20.9836 7.17497 21.0227C7.30176 21.096 7.42869 21.1695 7.52546 21.2737L7.51956 21.2915C7.50382 21.3384 7.49391 21.3679 7.51119 21.4242C7.55544 21.4625 7.60728 21.4962 7.65963 21.5302C7.72548 21.573 7.79214 21.6163 7.84551 21.6699C7.92094 21.8586 7.98311 22.1007 7.92603 22.3096V22.459C7.792 22.1498 7.57795 21.7278 7.19114 21.6699C7.01282 21.5561 6.87914 21.3699 6.75659 21.1993L6.73349 21.1672C6.65842 21.1288 6.57388 21.1093 6.48909 21.0898C6.39141 21.0673 6.29337 21.0447 6.20907 20.9929C6.08228 20.9904 5.96119 21.0205 5.8388 21.051C5.73589 21.0766 5.63205 21.1024 5.52311 21.1093ZM9.32759 21.1039L9.7416 21.5948C9.96276 21.6595 10.2388 21.6402 10.431 21.5252L10.2836 21.0798C9.99048 21.1793 9.64252 21.1498 9.32759 21.1039ZM12.047 21.3556C11.7799 21.3124 11.5252 21.2327 11.3364 21.0783C11.2966 20.9986 11.2699 20.9116 11.2586 20.8243C11.3532 20.8292 11.4547 20.822 11.5576 20.8148C11.6225 20.8102 11.6884 20.8056 11.7532 20.8039L12.0862 21.3281C12.0809 21.3411 12.062 21.3383 12.0482 21.3363C12.0326 21.3341 12.0235 21.3328 12.047 21.3556ZM12.6379 22.6554H12.6712C12.921 22.4761 13.2125 22.4041 13.5083 22.331L13.5095 22.3307C13.5425 22.3226 13.5755 22.3144 13.6085 22.3061C13.6545 22.3214 13.6618 22.3521 13.6691 22.3827C13.676 22.4114 13.6829 22.4399 13.7212 22.4558C13.8281 22.416 13.9473 22.4022 14.0663 22.3883C14.169 22.3764 14.2717 22.3645 14.3662 22.3358L14.3797 22.3362C14.6202 22.3436 14.8166 22.3496 15.0121 22.4429C15.1059 22.5539 15.2473 22.5919 15.3898 22.6303C15.4888 22.6569 15.5882 22.6836 15.6724 22.735L15.6391 22.4429C15.2077 21.99 14.534 21.9572 13.9109 21.9656L13.897 21.9074C13.7486 21.9074 13.5812 21.9358 13.4417 21.9945C13.2992 22.0002 13.1613 22.0462 13.0247 22.0918C12.9699 22.1101 12.9154 22.1283 12.8609 22.1438C12.7893 22.2726 12.7297 22.4237 12.6749 22.5624C12.6624 22.5941 12.65 22.6254 12.6379 22.6554ZM12.9707 23.7395H12.9138C12.9255 23.7061 12.9357 23.6694 12.9461 23.6316C12.9909 23.4697 13.041 23.2884 13.2416 23.2727C13.3492 23.1741 13.4847 23.1675 13.6264 23.1606C13.7037 23.1568 13.7827 23.153 13.8602 23.1341L14.2596 23.0108C14.5703 23.0108 14.841 23.1123 15.1121 23.2139C15.26 23.2694 15.4081 23.3249 15.5628 23.3639C15.7763 23.5112 15.8866 23.7395 15.9145 23.983C15.9479 24.0059 15.992 24.0216 16.0364 24.0373C16.1312 24.0708 16.2275 24.1049 16.224 24.2118C16.183 24.3083 16.1544 24.4096 16.1257 24.5114C16.0975 24.6113 16.0692 24.7116 16.0289 24.808C16.0021 24.7526 15.977 24.6913 15.9511 24.6278C15.8427 24.3629 15.7193 24.0613 15.4012 24.0075C15.3493 23.8307 15.2873 23.6401 15.1161 23.5351L14.6114 23.4684L14.592 23.4918C14.6154 23.5532 14.6698 23.6071 14.7248 23.6616C14.8279 23.7638 14.933 23.868 14.8396 24.0269C14.8925 24.101 14.9709 24.1458 15.0497 24.1908C15.1478 24.2469 15.2465 24.3032 15.297 24.4172C15.3704 24.5172 15.3584 24.6408 15.3464 24.7646C15.3389 24.8413 15.3314 24.9181 15.3443 24.9894L14.9778 25.2177C14.9752 25.1523 14.9764 25.0826 14.9777 25.0109C14.9834 24.6961 14.9897 24.3456 14.6688 24.1787C14.4649 24.2408 14.3764 24.0984 14.2827 23.9475C14.2257 23.8557 14.1667 23.7608 14.0787 23.7069C14.0438 23.6875 14.0204 23.6492 13.9979 23.6122C13.9595 23.5493 13.9234 23.4902 13.8363 23.5351C13.7102 23.6203 13.5532 23.6311 13.3962 23.6419C13.2452 23.6523 13.0941 23.6627 12.9707 23.7395ZM13.1897 21.4945L13.2848 21.5323C13.348 21.508 13.4111 21.4825 13.4744 21.457C13.6172 21.3994 13.7612 21.3413 13.9105 21.2947C14.0593 21.2597 14.1935 21.3028 14.3213 21.3439C14.4809 21.3952 14.6305 21.4433 14.7864 21.3321C14.8732 21.2809 14.9501 21.3349 15.0189 21.3833C15.0332 21.3934 15.0471 21.4032 15.0607 21.4117C15.1517 21.5489 15.3319 21.5759 15.5052 21.6019C15.5629 21.6105 15.6198 21.6191 15.6724 21.6315L15.6603 21.6044C15.5564 21.3704 15.4223 21.0686 15.0714 21.0322C15.008 21.0087 14.9397 20.9962 14.8712 20.9837C14.7832 20.9676 14.6948 20.9514 14.6163 20.9117C14.407 20.7191 14.2373 20.8222 14.0584 20.9309C13.9083 21.0222 13.7517 21.1174 13.5597 21.0451C13.5336 21.069 13.5065 21.0927 13.4792 21.1165C13.3503 21.2291 13.2188 21.3439 13.1897 21.4945ZM13.5636 24.0134C13.5302 23.983 13.4977 23.9534 13.4655 23.9276L13.6153 23.8722C13.6482 23.874 13.6832 23.8647 13.7181 23.8554C13.7756 23.84 13.833 23.8247 13.8812 23.8594L13.8963 23.8718C14.0008 23.9574 14.0894 24.0299 14.1032 24.1707C14.1558 24.2048 14.2141 24.203 14.2729 24.2013C14.3335 24.1995 14.3946 24.1976 14.4507 24.2349C14.5333 24.3957 14.601 24.6389 14.553 24.7756L14.5432 24.7629L14.5184 24.7854L14.5333 24.7948L14.3593 24.9418C14.2928 24.8615 14.274 24.7515 14.2551 24.6404C14.2274 24.4782 14.1993 24.3135 14.0216 24.2349C13.8304 24.2567 13.6903 24.1289 13.5636 24.0134ZM16.5 21.9073L16.5617 22.0713C16.5821 22.2483 16.6254 22.4207 16.6688 22.5934C16.7563 22.9417 16.844 23.2913 16.7455 23.6827C16.8287 23.7556 16.8725 23.8612 16.9161 23.9663C16.9371 24.0169 16.9582 24.0675 16.9835 24.1142H17.004C17.0902 23.7034 17.0422 23.2791 16.9955 22.8662L16.9835 22.7594C17.014 22.4228 16.7936 22.2032 16.6077 22.0179C16.5695 21.9798 16.5328 21.9432 16.5 21.9073ZM17.9383 18.8728C17.7833 18.7783 17.6393 18.6221 17.6641 18.434C17.6503 18.3066 17.6824 18.1964 17.7151 18.0847L17.7265 18.0453C17.9273 18.1751 18.0514 18.3499 18.0978 18.5419C18.0906 18.6268 18.0453 18.6978 17.9994 18.7698C17.9779 18.8034 17.9563 18.8373 17.9383 18.8728ZM17.6069 20.5991C17.5824 20.7607 17.6929 20.8284 17.8025 20.8956C17.8572 20.9291 17.9116 20.9625 17.9489 21.0073C18.0055 21.076 17.9706 21.1315 17.9346 21.1888C17.9113 21.2258 17.8876 21.2636 17.8876 21.3062C18.0824 21.5588 18.1963 21.8473 18.1963 22.1832C18.2233 22.0703 18.2558 21.9595 18.2883 21.8488C18.3463 21.6508 18.4044 21.4527 18.431 21.2444C18.4213 21.1383 18.3385 21.0918 18.2585 21.0469C18.1667 20.9953 18.0786 20.9458 18.1087 20.8109C18.1922 20.5992 18.1247 20.3911 18.0609 20.1944C18.047 20.1513 18.0331 20.1087 18.0211 20.0668C18.0014 20.0315 17.9544 19.9587 17.9139 19.9802C17.8807 20.0559 17.8297 20.1237 17.7787 20.1916C17.6877 20.3126 17.5967 20.4336 17.6069 20.5991ZM18.6896 19.9763L18.431 19.5093L18.5006 18.8764C18.5625 18.8609 18.6236 18.8994 18.6793 18.9344C18.6909 18.9417 18.7023 18.9489 18.7135 18.9554C18.7638 19.0127 18.7686 19.0877 18.7735 19.1624C18.7769 19.2139 18.7802 19.2652 18.7984 19.3103C18.8168 19.3634 18.8497 19.4127 18.8826 19.4621C18.9479 19.5599 19.0135 19.6582 18.9672 19.7867C18.9451 19.8051 18.9239 19.8251 18.9028 19.8451C18.8386 19.9056 18.775 19.9655 18.6896 19.9763ZM18.7069 18.3212C18.9048 18.4385 19.1316 18.6074 19.2378 18.8145C19.3368 19.0948 19.4703 19.3587 19.6037 19.6225C19.6982 19.8092 19.7927 19.996 19.875 20.1886C19.8895 20.2541 19.9035 20.3181 19.9173 20.3812C19.9718 20.6305 20.0233 20.8661 20.0961 21.1201C20.1054 21.1429 20.1107 21.1714 20.1162 21.2006C20.1313 21.2803 20.1473 21.3654 20.2461 21.3547C20.259 21.2343 20.2758 21.1155 20.2926 20.9966C20.3256 20.7636 20.3587 20.5305 20.3621 20.2849C20.2686 20.1657 20.1529 20.0994 20.0358 20.0322C20.0012 20.0124 19.9665 19.9924 19.9322 19.9711V19.938C19.9518 19.8588 20.0198 19.764 20.1208 19.7785C20.1322 19.7662 20.1497 19.7538 20.1683 19.7407C20.2197 19.7043 20.2791 19.6623 20.2363 19.6001C20.1418 19.5082 20.085 19.3915 20.0295 19.2777C19.9375 19.0891 19.8494 18.9083 19.6002 18.8611C19.46 18.805 19.4265 18.6636 19.4121 18.5332C19.2234 18.3773 18.944 18.3262 18.7069 18.3212ZM19.1376 21.6031C19.1607 21.3413 19.1839 21.0773 18.9996 20.8855C18.9309 20.644 19.0845 20.5398 19.2377 20.436C19.3184 20.3813 19.3989 20.3267 19.4468 20.2522C19.4929 20.3499 19.4906 20.4766 19.4882 20.6044C19.4864 20.7071 19.4845 20.8105 19.5076 20.9001C19.5161 20.9479 19.5269 20.9975 19.5379 21.0483C19.5836 21.2582 19.6334 21.4874 19.5429 21.6849C19.5253 21.7636 19.5819 21.8023 19.6339 21.8176C19.6505 21.8214 19.6734 21.8195 19.6972 21.8176C19.7614 21.8124 19.8323 21.8067 19.8039 21.9103C19.8061 21.9644 19.7806 22.0011 19.7566 22.0357C19.7349 22.0669 19.7144 22.0965 19.7161 22.1358C19.6538 22.2873 19.5712 22.4177 19.4876 22.5497C19.4492 22.6102 19.4103 22.6716 19.3734 22.735L19.3835 22.6842C19.4309 22.4456 19.4906 22.1452 19.3646 21.935C19.3378 21.8946 19.2871 21.889 19.2389 21.8836C19.1694 21.8759 19.1052 21.8687 19.1255 21.7588C19.1284 21.7074 19.133 21.6553 19.1376 21.6031ZM19.2586 17.5017C19.4221 17.6942 19.5672 17.887 19.7115 18.0787C19.9134 18.3468 20.1137 18.6128 20.3602 18.8728C20.3659 18.7367 20.3575 18.608 20.349 18.4782C20.3451 18.4173 20.3411 18.356 20.3385 18.2938C20.287 18.1781 20.1984 18.0875 20.1136 18.0008C20.0969 17.9838 20.0802 17.9667 20.0641 17.9498C19.9232 17.934 19.8128 17.8255 19.7036 17.7184C19.5708 17.588 19.4399 17.4596 19.2586 17.5017ZM20.3989 19.8689C20.384 19.8355 20.37 19.8043 20.3621 19.769L20.5011 19.7134C20.5077 19.7128 20.5145 19.7119 20.5216 19.711C20.5271 19.7102 20.5327 19.7095 20.5385 19.7087C20.621 19.6973 20.7246 19.6829 20.7591 19.7783C20.9552 19.9532 20.9217 20.1993 20.8882 20.4447C20.8714 20.5676 20.8547 20.6903 20.8667 20.8039C20.7463 20.4869 20.5816 20.1827 20.4078 19.8889L20.3989 19.8689ZM21.7643 15.8451C21.743 15.9368 21.7219 16.0278 21.7735 16.1038C21.8493 16.0085 21.9587 15.9808 22.0675 15.9533C22.1181 15.9405 22.1687 15.9277 22.2156 15.9081C22.5559 15.8734 22.883 15.9675 23.2031 16.0597C23.2678 16.0783 23.3323 16.0968 23.3966 16.1142C23.3569 16.0441 23.3227 15.9705 23.2887 15.8975C23.2402 15.7932 23.1922 15.69 23.1298 15.5998C23.0648 15.5806 22.9895 15.5828 22.9153 15.585C22.7477 15.5899 22.5855 15.5946 22.56 15.352C22.4628 15.2587 22.324 15.2858 22.2043 15.3093C22.1654 15.3169 22.1285 15.3241 22.0957 15.3267C21.9665 15.4295 21.8614 15.5581 21.7872 15.7075C21.7858 15.7523 21.775 15.7988 21.7643 15.8451ZM22.1549 23.1809C22.0289 23.2558 21.8679 23.3515 21.7414 23.2927C21.8596 23.2339 21.9203 23.1418 21.9846 23.0443C22.0443 22.9538 22.1071 22.8586 22.2217 22.7811C22.2723 22.7115 22.3262 22.7346 22.3852 22.7599C22.4031 22.7676 22.4216 22.7755 22.4405 22.7811C22.5679 22.856 22.6684 22.9042 22.8248 22.9042C22.8299 22.9893 22.8299 23.1028 22.7827 23.1793C22.8234 23.2317 22.8905 23.2423 22.9591 23.2532C23.0085 23.261 23.0585 23.269 23.1 23.2927C23.2528 23.4062 23.4143 23.5537 23.395 23.7573L23.3143 23.8384C23.0624 23.6727 22.7827 23.5678 22.4979 23.4873C22.4918 23.4583 22.4946 23.4292 22.4973 23.3998C22.5013 23.3573 22.5053 23.3141 22.4831 23.2694C22.3923 23.2081 22.2927 23.1413 22.1739 23.1696L22.1549 23.1809ZM21.7807 17.2177L21.798 17.2129C21.9213 17.1789 22.0478 17.144 22.1513 17.0578C22.3973 16.8419 22.721 16.8835 23.0322 16.9235C23.1577 16.9397 23.2811 16.9555 23.3966 16.9541C23.319 16.8197 23.2107 16.6853 23.1129 16.5711C23.0906 16.5626 23.0686 16.5539 23.0467 16.5452C22.927 16.4979 22.8096 16.4515 22.6708 16.4515C22.404 16.3001 22.2032 16.4574 22.0043 16.6133C21.9422 16.6621 21.8802 16.7106 21.8165 16.7496C21.7444 16.884 21.7087 17.0833 21.7807 17.2177ZM22.0674 18.1576C22.0529 18.1621 22.0529 18.1779 22.0529 18.1942C22.0048 18.0574 22.016 17.8796 22.026 17.7206L22.0282 17.6853L22.0302 17.6504C22.1646 17.6637 22.2669 17.5895 22.3721 17.5132C22.4321 17.4697 22.4931 17.4255 22.5614 17.3965C22.8631 17.4274 23.1437 17.3296 23.4165 17.2346L23.4649 17.2177C23.5613 17.2224 23.5842 17.329 23.6056 17.429C23.6333 17.5578 23.6586 17.6757 23.8357 17.5506C23.9437 17.4552 24.0613 17.3655 24.2121 17.4236C24.4799 17.5759 24.7437 17.8885 24.7759 18.2303C24.3251 17.946 23.8126 17.8304 23.2945 17.7243C23.1404 17.7243 23.0164 17.8093 22.8917 17.8947C22.766 17.9808 22.6397 18.0673 22.4815 18.0673L22.4409 18.0998C22.3412 18.1799 22.2407 18.2606 22.1333 18.3212C22.0934 18.3093 22.0913 18.2718 22.0892 18.2338C22.0876 18.2048 22.0859 18.1756 22.0674 18.1576ZM22.0919 19.2848C22.171 19.3585 22.2906 19.3656 22.4092 19.3728C22.4459 19.375 22.4826 19.3772 22.5179 19.3813L22.9488 19.2328C22.951 19.2014 22.9243 19.1807 22.8976 19.1599C22.8658 19.1352 22.8339 19.1104 22.8503 19.0675C22.922 18.9966 23.0099 18.9988 23.1011 19.0012C23.1609 19.0027 23.2221 19.0043 23.2812 18.9854C23.3491 18.9768 23.4178 18.9515 23.4867 18.9261C23.6279 18.874 23.7702 18.8214 23.91 18.9116C23.9078 18.9199 23.9085 18.9294 23.9092 18.9391C23.9105 18.9551 23.9118 18.9718 23.8999 18.9854C23.8359 19.12 23.9444 19.2031 24.0634 19.2546C24.1505 19.2688 24.2357 19.3032 24.3204 19.3373C24.4713 19.3982 24.6206 19.4584 24.7759 19.4022C24.7561 19.254 24.715 19.1157 24.6735 18.9757C24.6686 18.9594 24.6638 18.9431 24.659 18.9268C24.6554 18.9146 24.6518 18.9024 24.6483 18.8902C24.5316 18.8726 24.4342 18.8164 24.3369 18.7603C24.2648 18.7187 24.1927 18.677 24.1127 18.6511C24.029 18.7208 23.919 18.7728 23.8157 18.764C23.7338 18.7471 23.6485 18.7243 23.5612 18.7009C23.2416 18.6155 22.8952 18.5228 22.5926 18.6901C22.5038 18.7845 22.371 18.8008 22.2375 18.8172C22.1616 18.8265 22.0855 18.8359 22.0172 18.8596C22.0273 19.0067 22.0469 19.1511 22.0919 19.2848ZM22.3282 22.022L22.3351 22.0044L22.3381 21.9964L22.3436 21.9811C22.3678 21.9499 22.3889 21.9169 22.4099 21.8839C22.4411 21.8351 22.4722 21.7863 22.5135 21.7434C22.5832 21.7434 22.6489 21.715 22.7141 21.6868C22.7945 21.6519 22.8742 21.6174 22.9598 21.6373C23.1175 21.6156 23.2367 21.6995 23.3551 21.7829C23.4595 21.8565 23.5634 21.9297 23.6927 21.9297C23.8331 22.038 23.9129 22.1977 23.9483 22.3636C23.9451 22.5181 23.9107 22.6566 23.876 22.7962C23.8585 22.8667 23.8409 22.9375 23.8272 23.0108L23.4061 22.6488C23.4071 22.6312 23.4096 22.6118 23.4122 22.5912C23.4226 22.508 23.4352 22.4077 23.3664 22.3536C23.1891 22.1703 22.9307 22.2024 22.6813 22.2333C22.5786 22.246 22.4776 22.2585 22.3843 22.2558C22.2503 22.2198 22.294 22.1087 22.3282 22.022ZM22.3143 19.6967C22.3248 19.7195 22.3356 19.7447 22.3468 19.7709C22.4034 19.9032 22.4713 20.0619 22.5724 20.0742C22.8598 19.9424 23.2799 19.8606 23.6005 20.0034C23.7072 20.0235 23.7072 20.151 23.6838 20.2327C23.761 20.2802 23.8459 20.3234 23.9323 20.3674C24.0305 20.4175 24.1308 20.4686 24.2241 20.528L24.1757 20.2224C24.1707 20.0541 24.0655 19.9635 23.9599 19.8724C23.8573 19.784 23.7542 19.6951 23.7421 19.5343C23.4152 19.4221 23.0498 19.3861 22.7041 19.4727C22.6226 19.5505 22.5149 19.5641 22.41 19.5774C22.3709 19.5823 22.3323 19.5872 22.2955 19.5953C22.2892 19.6212 22.2966 19.6413 22.304 19.6616C22.3082 19.6728 22.3124 19.6842 22.3143 19.6967ZM22.8116 21.1347C22.7358 21.1869 22.6599 21.2391 22.5692 21.2617C22.5659 21.2128 22.5933 21.1762 22.6211 21.1392C22.6343 21.1217 22.6475 21.104 22.6576 21.0849C22.666 21.0391 22.6683 20.9882 22.6706 20.9363C22.678 20.7709 22.6859 20.5962 22.8931 20.5509L23.273 20.528C23.3779 20.7235 23.574 20.7497 23.768 20.7756C23.9452 20.7992 24.1207 20.8226 24.2231 20.9748C24.2278 21.0716 24.2156 21.164 24.2036 21.2553C24.1873 21.38 24.1712 21.5027 24.1984 21.6315C24.1066 21.6315 24.0761 21.5696 24.0434 21.5034C24.0192 21.4544 23.9938 21.4029 23.9415 21.3723C23.7357 21.1209 23.4426 21.0025 23.1149 20.9977C22.9962 21.0078 22.9039 21.0712 22.8116 21.1347ZM24.2241 23.4501C24.2917 23.5734 24.3903 23.6853 24.4887 23.7969C24.6491 23.9789 24.8091 24.1604 24.8335 24.3901C24.9205 24.2968 24.9819 24.1891 25.0412 24.0848L25.0517 24.0664C25.0485 24.0068 25.0036 23.9814 24.9563 23.9546C24.9212 23.9348 24.8847 23.9141 24.863 23.8782C24.8255 23.7822 24.855 23.694 24.8836 23.6081C24.8955 23.5727 24.9072 23.5376 24.914 23.5026C24.839 23.3094 24.6601 23.1264 24.459 23.0108L24.2241 23.4501ZM25.1694 23.2867L24.7981 22.7536C24.8472 22.6781 24.8789 22.5913 24.9106 22.5048C24.9518 22.3922 24.9928 22.28 25.0717 22.1943C25.1639 22.1502 25.2312 22.2483 25.267 22.3081C25.3288 22.6287 25.3288 23.0207 25.1694 23.2867ZM23.3966 9.59698C23.5239 9.66429 23.6466 9.72608 23.7992 9.73656C23.9019 9.67974 24.0346 9.63781 24.1625 9.67422C24.276 9.7519 24.4047 9.72221 24.537 9.69167C24.6162 9.67341 24.6966 9.65485 24.7759 9.65877C24.5892 9.47284 24.3774 9.35863 24.1625 9.2505C24.0167 9.28318 23.8864 9.35644 23.756 9.42973C23.6399 9.49502 23.5238 9.56033 23.3966 9.59698ZM25.8842 10.2363C25.727 10.0766 25.557 9.90363 25.3276 9.88358C25.526 9.80078 25.7497 9.78253 25.9765 9.76943C26.1374 9.9537 26.2944 10.1335 26.3511 10.3659L26.431 10.597C26.3035 10.4529 26.1425 10.3121 25.9294 10.2822L25.8842 10.2363Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M9.63045 25.2466C9.68252 25.2118 9.74358 25.1843 9.80545 25.1566C9.96422 25.0852 10.1283 25.0115 10.159 24.8046C10.1409 24.7903 10.1233 24.7751 10.1059 24.7601C10.0503 24.7123 9.99603 24.6655 9.9306 24.6502L9.73525 24.7096C9.74468 24.6309 9.77507 24.5457 9.80576 24.4597C9.82142 24.4158 9.83715 24.3717 9.85022 24.3281L10.478 24.1143C10.392 24.4119 10.3589 24.7844 10.3299 25.1272C10.3874 25.6339 10.4592 26.1752 10.7069 26.597H10.0303C10.001 26.4153 9.91206 26.253 9.82293 26.0903C9.68334 25.8356 9.54321 25.5798 9.63045 25.2466Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M11.2762 24.666H11.2373C11.1689 24.7322 11.1205 24.8239 11.0719 24.916C11.044 24.9689 11.0161 25.0218 10.9843 25.0702C10.9697 25.4695 11.0638 25.8607 11.1547 26.2389C11.1838 26.3596 11.2125 26.4791 11.2373 26.597H11.7423C11.7475 26.0754 11.7724 25.5828 11.8103 25.0802L11.7423 25.0954L11.2762 24.666Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M12.2439 24.9891C12.2682 24.9567 12.2884 24.9178 12.3089 24.8783C12.3592 24.7814 12.4113 24.6813 12.5296 24.666C12.6484 24.6693 12.7582 24.6876 12.8464 24.7737C12.9683 24.9303 12.8994 25.1213 12.8377 25.2921C12.8216 25.3369 12.8059 25.3804 12.7943 25.4214C12.7324 25.7229 12.6263 26.0374 12.5296 26.3211H12.0862L12.2439 24.9891Z", fill: "#FE7A22" }), /* @__PURE__ */ b.createElement("path", { d: "M19.5668 25.1226C19.5328 25.0606 19.4992 24.9995 19.454 24.9455C19.3956 24.9932 19.3571 25.0569 19.3182 25.1214C19.2995 25.1524 19.2807 25.1836 19.2595 25.2132C19.2439 25.7112 19.4449 26.1236 19.6537 26.552L19.6757 26.597H20.2697C20.2548 26.431 20.2351 26.2674 20.2156 26.1053C20.1793 25.8044 20.1438 25.5089 20.1404 25.2132C20.1205 24.9887 20.1986 24.8006 20.2763 24.6134C20.307 24.5396 20.3376 24.4659 20.3621 24.3901C20.2823 24.4039 20.2008 24.4147 20.1189 24.4255C19.9958 24.4418 19.8719 24.4582 19.7519 24.4851L19.9078 24.6325C19.9834 24.8899 19.9459 25.2029 19.7894 25.4053C19.6789 25.3268 19.6222 25.2235 19.5668 25.1226Z", fill: "#FE7A22" })), Vh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.9424 15.4854V10H0.859688L0.791621 10.0103C0.635088 10.0573 0.5 10.2568 0.5 10.4425V20.0786L0.506682 20.1593C0.537521 20.3459 0.672671 20.5143 0.861372 20.5143H2.9424V18.2441L3.61414 17.5881L5.28343 20.2323L5.35387 20.316C5.50181 20.466 5.69116 20.5143 5.90536 20.5143H8.27143L5.29402 15.8207L8.04167 13.001H5.52469L5.42807 13.0096C5.26824 13.0379 5.11701 13.1317 5.01347 13.2401L2.9424 15.4854ZM15.8124 15.9646C15.7752 14.2625 15.1832 12.9714 13.0944 12.9714C12.0217 12.9714 11.3417 13.5124 10.9339 14.1734H10.9035L10.9181 13.1061H8.85603L8.78864 13.1163C8.63366 13.1627 8.5 13.3602 8.5 13.55V20.083L8.50785 20.1642C8.54379 20.3511 8.69809 20.5143 8.86652 20.5143H10.9181V16.8482L10.9201 16.6973C10.9472 15.7023 11.2557 14.9394 12.2476 14.9394C13.2461 14.9394 13.3967 15.6756 13.3967 16.6528V20.078L13.4044 20.1619C13.4398 20.354 13.591 20.5143 13.7497 20.5143H15.8143V16.1421L15.8124 15.9646ZM19.8515 12.9714C21.2654 12.9714 22.0791 13.2892 22.6786 13.8349C23.224 14.3435 23.5415 15.0109 23.5814 16.1205L23.5857 16.3651V20.5761H21.5564C21.3939 20.5761 21.2699 20.474 21.2317 20.357L21.2199 20.2977L21.1887 19.7888L21.0532 19.921C20.7024 20.2555 20.0978 20.7429 19.0216 20.7429C17.6857 20.7429 16.2714 20.031 16.2714 18.364C16.2714 16.7602 17.711 16.1807 19.0663 16.0863L19.2222 16.0775L21.1268 16.0014V15.8339C21.1268 15.0472 20.5589 14.6375 19.5754 14.6375C18.6767 14.6375 17.7779 15.0034 17.3466 15.2499L17.2556 15.3044L16.7515 14.0757C16.6812 13.8975 16.75 13.6646 16.925 13.5852C17.6045 13.293 18.6414 12.9714 19.8515 12.9714ZM19.9281 17.3651L21.1428 17.2891V18.5154L21.0982 18.5832C20.9126 18.8419 20.488 19.1982 19.8821 19.1982C19.2059 19.1982 18.7301 18.8487 18.7301 18.2737C18.7301 17.7133 19.1759 17.3948 19.9281 17.3651ZM26.9323 10L26.9312 12.7775L26.9142 13.6005C27.3204 13.2303 27.9933 12.8807 28.9711 12.8807C31.1302 12.8807 32.5 14.582 32.5 16.8042C32.5 19.0258 31.1302 20.7429 28.9561 20.7429C28.1911 20.7429 27.4951 20.535 26.9576 20.0943L26.8013 19.9551L26.8112 20.5742H24.864C24.6954 20.5742 24.5432 20.4107 24.5077 20.2148L24.5 20.1292V10.4476C24.5 10.2609 24.6346 10.0582 24.7906 10.0105L24.8584 10H26.9323ZM26.7268 16.7314C26.7268 15.566 27.423 14.7687 28.4442 14.7687C29.4654 14.7687 30.1455 15.566 30.1455 16.7314C30.1455 17.8968 29.4654 18.6931 28.4442 18.6931C27.423 18.6931 26.7268 17.8968 26.7268 16.7314Z", fill: "#00374E" })), $h = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M16.4259 32.7799C11.8278 32.7799 8.451 31.5036 6.29177 29.3845C4.39177 27.5197 4.10423 24.946 5.00408 23.1451C5.42577 22.3008 5.88992 21.798 6.47792 21.2299C6.47731 21.2305 6.47669 21.2311 6.47592 21.2319C6.119 21.5902 5.811 21.972 5.55885 22.3746C5.45777 22.536 5.36561 22.7008 5.28285 22.8688C4.36069 24.7426 4.69931 26.81 6.53669 28.6128C6.66546 28.7394 6.80008 28.8625 6.93977 28.9831C6.94023 28.9829 6.94008 28.9829 6.94054 28.9829C9.08469 30.8291 12.4836 31.9491 16.3916 31.9494C20.543 31.9491 24.1198 30.6852 26.2282 28.6294C26.2341 28.6237 26.2399 28.618 26.2458 28.6123C26.2725 28.586 26.2992 28.5596 26.3253 28.5331C26.3255 28.5329 26.3255 28.5329 26.3258 28.5328C26.3272 28.5312 26.3287 28.5297 26.3301 28.5283C26.3305 28.5279 26.331 28.5274 26.3315 28.5269C26.3325 28.5257 26.3338 28.5246 26.335 28.5234C26.3356 28.5228 26.3362 28.522 26.3368 28.5214C26.3378 28.5205 26.3387 28.5196 26.3396 28.5186C26.3407 28.5176 26.3416 28.5166 26.3425 28.5157C26.3432 28.5151 26.3438 28.5145 26.3444 28.5139C26.3455 28.5126 26.3468 28.5114 26.3481 28.5102C26.3482 28.5099 26.3485 28.5096 26.3488 28.5092C26.8073 28.0426 27.1667 27.5589 27.431 27.0662C27.9144 26.1676 28.0848 25.2511 27.9539 24.3226C27.8888 23.8519 27.7464 23.3856 27.5296 22.9303C27.5295 22.9302 27.5293 22.93 27.5293 22.9299C27.5288 22.9289 27.5284 22.928 27.5279 22.9271C27.5185 22.9074 27.5092 22.8879 27.4995 22.8682C27.4925 22.8542 27.4855 22.84 27.4784 22.826C27.1996 22.2722 26.8182 21.7534 26.3499 21.2756C26.9701 21.8399 27.421 22.4385 27.7585 23.0874C28.591 24.6888 28.5122 27.3442 26.4832 29.3845C24.4136 31.4651 21.037 32.7799 16.4259 32.7799Z", fill: "url(#paint0_linear_3380_70755)" }), /* @__PURE__ */ b.createElement("path", { d: "M22.9206 19.062C20.9695 18.2531 18.6975 17.8371 16.391 17.8369C14.0847 17.8371 11.8126 18.2531 9.86149 19.062C7.72641 19.9475 6.07441 21.2612 5.28287 22.8681C4.36072 24.742 4.69933 26.8094 6.53672 28.6123C8.64287 30.6781 12.2283 31.9491 16.3913 31.9494C20.5541 31.9491 24.1392 30.6781 26.2455 28.6123C28.083 26.8094 28.4215 24.742 27.4992 22.8681C26.7078 21.2612 25.0556 19.9475 22.9206 19.062Z", fill: "#E5702A" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.2105 23.2165C24.4204 19.6906 19.5307 18.6426 16.4639 18.6425C13.3971 18.6423 8.50714 19.69 7.71761 23.2158C6.73468 27.6048 13.2858 29.2394 16.4645 29.2394C19.643 29.2394 26.1938 27.6054 25.2105 23.2165ZM8.03776 23.1906C8.78068 19.784 13.5115 18.7737 16.4639 18.7737C19.4165 18.7738 24.147 19.7846 24.8902 23.1912C25.8098 27.4066 19.5193 28.9649 16.4645 28.9649C13.4095 28.9646 7.11853 27.4063 8.03776 23.1906Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.2388 23.3246C24.4488 19.7988 19.7516 18.7322 16.4922 18.7322C13.2219 18.7322 8.53559 19.7979 7.7459 23.3239C6.76313 27.7126 13.3141 29.3473 16.4927 29.3474C19.6713 29.3474 26.2221 27.7133 25.2388 23.3246ZM8.06621 23.2985C8.80913 19.892 13.5397 18.8814 16.4922 18.8817C19.4448 18.8819 24.1753 19.8926 24.9185 23.2993C25.8382 27.5146 19.5476 29.0729 16.4927 29.0729C13.4379 29.0729 7.14698 27.5139 8.06621 23.2985Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.53672 28.6128C6.66549 28.7394 6.8001 28.8624 6.93979 28.9831L6.94056 28.9829C8.49856 28.892 9.90733 28.6361 11.1475 28.2524C9.49318 27.5514 8.10056 26.4854 7.73826 24.9757C7.59195 24.4463 7.57379 23.8606 7.7181 23.2158C8.50749 19.6904 13.3969 18.6424 16.4638 18.6424H16.4644H16.4864C16.4875 18.3608 16.5193 18.0924 16.5512 17.8384C16.4979 17.838 16.4444 17.8375 16.3909 17.8375C14.0847 17.8377 11.8126 18.2537 9.86149 19.0624C7.94964 19.8554 6.42503 20.9918 5.55887 22.3746C5.45779 22.536 5.36564 22.7008 5.28287 22.8688C4.36072 24.7426 4.69933 26.81 6.53672 28.6128ZM8.0641 24.8703C8.48441 26.3808 9.98641 27.4166 11.7029 28.0683C13.5063 27.4288 14.9152 26.5084 15.865 25.4374C15.7719 25.0112 15.6761 24.5829 15.5753 24.1491C13.8272 24.9743 12.237 25.7606 10.5041 26.68C11.729 25.4655 12.889 24.4124 14.2067 23.2968C12.3392 23.1764 10.5487 23.1512 8.63672 23.1243C10.5118 22.7189 12.3658 22.4023 14.2693 22.1594C13.3764 21.4563 12.4987 20.8014 11.5433 20.1912C11.5426 20.1909 11.5416 20.1908 11.5409 20.1906L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542L11.4842 20.1542C11.4553 20.1356 11.4263 20.117 11.3972 20.0986C12.8383 20.4648 14.2083 20.9009 15.6019 21.4157C15.8764 20.5914 16.1679 19.7724 16.5004 18.9691C16.4978 18.9398 16.4955 18.9108 16.4936 18.8817H16.4923H16.4912C13.5387 18.8817 8.80903 19.8923 8.06626 23.2984C7.94149 23.8704 7.94949 24.3934 8.0641 24.8703ZM11.6089 25.8723C12.9079 24.9369 14.2361 24.0428 15.6004 23.2035L15.6126 23.2571V23.2569L15.6129 23.2584C15.6486 23.414 15.6844 23.5697 15.7198 23.7254C14.3253 24.3951 12.9559 25.1134 11.6089 25.8723ZM16.4101 23.3251C16.4239 23.7702 16.4379 24.2201 16.4509 24.6695C16.7779 24.1632 17.0107 23.6331 17.1427 23.0904C17.0952 23.0875 17.0481 23.086 17.0018 23.086C16.9321 23.086 16.8644 23.0897 16.8012 23.0981C16.8012 23.0981 16.6132 23.1486 16.4063 23.2018L16.4101 23.3251ZM15.6004 23.2035C13.6866 23.0523 12.2229 22.9814 10.3386 22.9754C12.4827 22.7908 14.2066 22.6898 16.3896 22.6569L16.3916 22.7235C16.1266 22.8812 15.8627 23.0414 15.6004 23.2035ZM16.3936 22.7874L16.399 22.9681C16.4552 22.8892 16.5099 22.8188 16.5655 22.7528L16.5058 22.7208L16.3936 22.7874ZM16.4489 22.6895C16.4293 22.6786 16.4101 22.6677 16.3915 22.6569C16.4296 22.6563 16.4683 22.6557 16.5067 22.6552L16.4911 22.6645L16.4489 22.6895ZM16.5067 22.6552L16.5064 21.5764L16.5058 19.4254C16.1784 20.3232 15.8895 21.2341 15.617 22.1498C14.5158 21.536 13.3918 20.9638 12.2375 20.4543C13.1172 21.0101 13.967 21.6098 14.7963 22.2374C15.0678 22.2066 15.3398 22.1778 15.6118 22.1503L15.617 22.1498C15.9027 22.3083 16.1867 22.4695 16.4693 22.6334L16.5067 22.6552ZM16.5067 22.6552C16.6178 22.5897 16.729 22.5244 16.8404 22.4597C16.773 22.526 16.7106 22.5897 16.6506 22.6557L16.5721 22.6553L16.5327 22.6552H16.5067Z", fill: "url(#paint1_linear_3380_70755)" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4099 21.4138C17.1341 20.5855 16.8409 19.7629 16.5058 18.9559C16.1712 19.7635 15.8778 20.5867 15.6019 21.4156C14.2083 20.9009 12.8383 20.4647 11.3972 20.0985C12.4095 20.7349 13.331 21.4205 14.2693 22.1593C12.3658 22.4022 10.5118 22.7189 8.63672 23.1242C10.5487 23.1512 12.3392 23.1764 14.2067 23.2967C12.889 24.4124 11.729 25.4655 10.5041 26.6799C12.237 25.7605 13.8272 24.9742 15.5753 24.149C15.8465 25.3169 16.0821 26.444 16.3236 27.5991C16.3841 27.8888 16.4451 28.1803 16.507 28.4747C16.8161 27.0062 17.1361 25.5401 17.4752 24.0782C19.2232 24.9044 20.7979 25.7092 22.4763 26.6672C21.2521 25.4522 20.1243 24.3724 18.8076 23.2569C20.6741 23.1369 22.435 23.0704 24.3052 23.1113C22.4287 22.7055 20.646 22.3901 18.741 22.1472C19.6804 21.4084 20.5761 20.7519 21.5895 20.1159C20.1484 20.4815 18.8036 20.8998 17.4099 21.4138ZM16.3934 22.6579L16.5067 22.6552L16.4484 22.6893C16.5785 22.762 16.7252 22.8351 16.8729 22.9086L16.8729 22.9086C17.0657 23.0047 17.26 23.1015 17.4209 23.1992C17.0992 24.5889 16.7978 25.9827 16.5076 27.3792C16.4959 26.1021 16.4533 24.7214 16.4119 23.3824L16.4119 23.3823L16.4119 23.3811C16.4044 23.1377 16.3969 22.8956 16.3896 22.6558L16.3934 22.6579ZM15.6004 23.2035C13.6866 23.0522 12.2229 22.9813 10.3386 22.9753C12.2784 22.8083 13.8743 22.7098 15.7774 22.6681L16.3887 22.6569L16.3896 22.6558L16.3906 22.7241C16.1259 22.8817 15.8624 23.0414 15.6004 23.2035ZM15.6004 23.2035L15.7198 23.7253C14.3253 24.395 12.9559 25.1133 11.6089 25.8722C12.9079 24.9369 14.2361 24.0427 15.6004 23.2035ZM17.4209 23.1992C17.6996 23.177 17.9784 23.1562 18.2575 23.1373C19.3392 24.0124 20.3867 24.9272 21.4075 25.8709C20.1103 24.9344 18.7836 24.0395 17.4209 23.1992ZM17.389 22.1456C19.3359 22.3725 21.2224 22.6409 23.1647 22.9913C20.9519 22.7696 18.7309 22.6596 16.5067 22.6552C16.7992 22.4824 17.0932 22.3124 17.389 22.1456ZM17.389 22.1456C18.4918 21.5329 19.6173 20.9616 20.773 20.4533C19.5819 20.815 18.4099 21.2333 17.2538 21.6932C17.2995 21.8439 17.3444 21.9947 17.389 22.1456ZM16.5064 21.5797L16.5067 22.6552C16.2118 22.4838 15.9155 22.3153 15.617 22.1498C15.8895 21.2341 16.1784 20.3232 16.5058 19.4253L16.5064 21.5797ZM15.617 22.1498C15.3433 22.1773 15.0695 22.2064 14.7963 22.2373C13.967 21.6098 13.1172 21.0101 12.2375 20.4542C13.3918 20.9638 14.5158 21.5359 15.617 22.1498Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M16.5061 19.0102C16.8412 19.8172 17.1344 20.6398 17.4102 21.4681C18.7576 20.9712 20.0544 20.5669 21.4458 20.2079C21.4939 20.1775 21.5415 20.1462 21.5898 20.1159C20.1487 20.4815 18.8039 20.8998 17.4102 21.4138C17.1344 20.5855 16.8412 19.7629 16.5061 18.9559C16.1715 19.7635 15.8781 20.5867 15.6022 21.4156C14.2085 20.9009 12.8385 20.4647 11.3975 20.0985C11.4456 20.1289 11.4932 20.1599 11.5412 20.1905C12.9325 20.5501 14.255 20.9724 15.6022 21.4699C15.8781 20.641 16.1715 19.8178 16.5061 19.0102Z", fill: "#B5272D" }), /* @__PURE__ */ b.createElement("path", { d: "M14.2019 23.2968C12.9054 24.3972 11.7104 25.4837 10.5039 26.68C10.5471 26.6555 10.653 26.5952 10.6962 26.5708C11.8808 25.4015 12.9304 24.4544 14.2019 23.3784V23.2968Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4606 22.6829C16.4455 22.692 16.4304 22.7011 16.4153 22.71C16.1424 22.8723 15.8706 23.0368 15.6006 23.2036L15.6127 23.2571C15.9095 23.0736 16.2067 22.8983 16.5069 22.7203V22.6553C16.4915 22.6645 16.4759 22.6737 16.4606 22.6829Z", fill: "#AF2127" }), /* @__PURE__ */ b.createElement("path", { d: "M15.6168 22.1498C15.5892 22.1525 15.5616 22.1556 15.5339 22.1584C15.2878 22.1835 15.0419 22.2096 14.7961 22.2373C13.9668 21.6098 13.117 21.0101 12.2373 20.4542V20.5193C13.117 21.0753 13.9668 21.675 14.7961 22.3025C15.0693 22.2716 15.3432 22.2425 15.6168 22.215C15.8836 22.363 16.135 22.5028 16.399 22.6556C16.4302 22.6555 16.4753 22.6551 16.5065 22.6551C16.2164 22.4864 15.9104 22.3127 15.6168 22.1498Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M11.6084 25.9484C12.9555 25.1895 14.3249 24.4709 15.7193 23.8015V23.7253C14.3249 24.395 12.9555 25.1133 11.6084 25.8723V25.9484Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M17.421 23.1992C17.1035 24.5729 16.7947 25.9986 16.5078 27.3792V27.4337C16.798 26.0371 17.097 24.6529 17.4187 23.2637C18.3483 23.8366 19.6981 24.7186 21.4077 25.9523V25.8709C20.1104 24.9344 18.7838 24.0395 17.421 23.1992Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M18.867 23.3076L18.8076 23.2568V23.3439C20.0781 24.4201 21.0922 25.3842 22.2761 26.5535C22.3193 26.5779 22.4328 26.6427 22.4762 26.6671C21.2318 25.4322 20.1207 24.3728 18.867 23.3076Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M14.2099 22.1673C12.3263 22.4093 10.4924 22.7229 8.63672 23.1241C8.72733 23.1241 8.83764 23.1299 8.93072 23.1286C10.7144 22.7509 12.4603 22.4553 14.2693 22.2246V22.1593L14.2099 22.1673Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M15.6 23.2035C13.8464 23.0522 12.1009 22.9656 10.3418 22.9791V23.0336C12.077 23.0202 13.7986 23.1048 15.5284 23.2522C15.5523 23.2361 15.576 23.2196 15.6 23.2035Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M18.7412 22.1472C20.6461 22.3901 22.4289 22.7055 24.3054 23.1113C24.2123 23.1093 24.0849 23.107 23.9917 23.1055C22.2067 22.7272 20.5518 22.4433 18.7412 22.2124V22.1472Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M16.5068 22.6552C18.731 22.6597 20.9521 22.7697 23.1648 22.9914V23.0511C20.9831 22.8325 18.8008 22.7215 16.6079 22.714C16.5922 22.7049 16.5688 22.6915 16.5531 22.6825C16.5376 22.6735 16.5224 22.6643 16.5068 22.6552C16.5376 22.6552 16.5684 22.6555 16.5991 22.6555L16.5068 22.6552Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M17.3887 22.1457C17.4162 22.1484 17.4417 22.1524 17.4693 22.1552C18.5457 21.5598 19.6437 21.0041 20.7707 20.5083V20.454C19.615 20.9624 18.4914 21.5329 17.3887 22.1457Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M17.3889 22.1456C17.3443 21.9947 17.2994 21.844 17.2537 21.6932V21.7475C17.2946 21.8827 17.3351 22.0181 17.3751 22.1535L17.3889 22.1456Z", fill: "#AF2127" }), /* @__PURE__ */ b.createElement("path", { d: "M16.7271 31.5205C16.662 31.5692 16.5722 31.6182 16.507 31.6672C16.4406 31.6182 16.3499 31.5692 16.2833 31.5205C16.2846 30.9158 16.2816 30.3107 16.2831 29.7061C16.3483 29.6615 16.442 29.617 16.5073 29.5724C16.5713 29.617 16.6597 29.6613 16.7237 29.7061C16.725 30.3107 16.7262 30.9158 16.7271 31.5205Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M5.95576 27.1318C5.92038 27.1999 5.88499 27.2682 5.84961 27.3367C5.91607 27.3624 6.04376 27.403 6.10099 27.4265C6.7353 27.0881 7.36253 26.7502 7.98607 26.4241C8.01007 26.3281 8.02438 26.2753 8.05099 26.2031C7.98699 26.1862 7.92299 26.1691 7.85884 26.1528C7.22192 26.4688 6.58746 26.7951 5.95576 27.1318Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M5.48815 23.4086C5.4303 23.4549 5.37245 23.5012 5.31445 23.5478C5.34645 23.5896 5.38168 23.6393 5.41076 23.6799C6.00353 23.5952 6.59661 23.5226 7.18984 23.4624C7.24507 23.4092 7.31184 23.3447 7.3643 23.2952C7.32953 23.2596 7.29476 23.2241 7.25999 23.1887C6.66922 23.2498 6.07845 23.3229 5.48815 23.4086Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M7.7645 20.4041C7.70465 20.43 7.64481 20.4557 7.58496 20.4817C7.5905 20.5174 7.59696 20.5828 7.6025 20.6183C8.03911 20.68 8.47511 20.7537 8.91004 20.8383C8.96588 20.8055 9.04142 20.7608 9.09404 20.7326C9.08635 20.6948 9.07881 20.6568 9.07111 20.6188C8.63635 20.536 8.20081 20.4641 7.7645 20.4041Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M21.1088 18.5541C21.1641 18.5544 21.2196 18.555 21.2747 18.5557C21.297 18.5775 21.319 18.5997 21.3413 18.6217C21.1124 18.7664 20.8879 18.9173 20.6667 19.073C20.6085 19.0737 20.5505 19.0744 20.4925 19.075C20.471 19.0507 20.4498 19.0266 20.4282 19.0024C20.6515 18.8475 20.8782 18.6977 21.1088 18.5541Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M16.3507 17.9241C16.3924 17.9111 16.4341 17.8985 16.4758 17.8859C16.5183 17.8985 16.5607 17.9111 16.603 17.9241C16.6044 18.1019 16.6059 18.2799 16.6072 18.4582C16.5633 18.4728 16.5192 18.4876 16.4753 18.5025C16.4323 18.4876 16.3892 18.4728 16.3459 18.4582C16.3475 18.2801 16.349 18.1019 16.3507 17.9241Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M11.5725 18.6328C11.5939 18.6109 11.6421 18.5723 11.6636 18.5506C11.7195 18.5498 11.7755 18.5491 11.8316 18.5485C12.0621 18.6918 12.2884 18.8417 12.5115 18.9965C12.4893 19.0208 12.4671 19.0452 12.445 19.0697C12.3878 19.0688 12.3038 19.0848 12.2465 19.0838C12.0255 18.9281 11.801 18.7772 11.5725 18.6328Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M10.1819 30.4121C10.0924 30.4337 9.97776 30.4334 9.88823 30.4554C9.86884 30.3917 9.82423 30.3281 9.80469 30.2648C10.2478 29.7357 10.6962 29.2101 11.1508 28.6888C11.2393 28.67 11.3528 28.6511 11.4413 28.6324C11.4619 28.6868 11.5025 28.7795 11.5267 28.8303C11.0725 29.3538 10.6245 29.8811 10.1819 30.4121Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M26.9095 27.1318C26.9449 27.1999 26.9805 27.2682 27.0157 27.3367C26.9494 27.3624 26.8217 27.403 26.7645 27.4265C26.1303 27.0881 25.5029 26.7502 24.8794 26.4241C24.8554 26.3281 24.8411 26.2753 24.8145 26.2031C24.8785 26.1862 24.9425 26.1691 25.0066 26.1528C25.6435 26.4688 26.2778 26.7951 26.9095 27.1318Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M27.3763 23.4086C27.4342 23.4549 27.492 23.5012 27.5498 23.5478C27.518 23.5896 27.4826 23.6393 27.4537 23.6799C26.8609 23.5952 26.2677 23.5226 25.6746 23.4624C25.6194 23.4092 25.5526 23.3447 25.5 23.2952C25.5348 23.2596 25.5695 23.2241 25.6043 23.1887C26.1951 23.2498 26.7858 23.3229 27.3763 23.4086Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M25.101 20.4041C25.1609 20.43 25.2207 20.4557 25.2806 20.4817C25.275 20.5174 25.2686 20.5828 25.263 20.6183C24.8263 20.68 24.3904 20.7537 23.9555 20.8383C23.8996 20.8055 23.8239 20.7608 23.7715 20.7326C23.7792 20.6948 23.7867 20.6568 23.7944 20.6188C24.2292 20.536 24.6646 20.4641 25.101 20.4041Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M22.6825 30.4121C22.7556 30.4235 22.8864 30.4412 22.9762 30.4554C23.0051 30.3932 23.0339 30.3298 23.0597 30.2648C22.617 29.7357 22.1684 29.2101 21.7136 28.6888C21.6253 28.67 21.5116 28.6511 21.4233 28.6324C21.4027 28.6868 21.3619 28.7795 21.3379 28.8303C21.7919 29.3538 22.2399 29.8811 22.6825 30.4121Z", fill: "#FFFFFE" }), /* @__PURE__ */ b.createElement("path", { d: "M5.9493 27.2394C5.93269 27.2711 5.90607 27.3202 5.88961 27.3522C5.87638 27.3465 5.86592 27.343 5.84961 27.3367C5.88499 27.2682 5.92038 27.1999 5.95576 27.1318C6.58746 26.7951 7.22192 26.4688 7.85884 26.1528C7.92299 26.1691 7.98699 26.1862 8.05099 26.2031C8.03761 26.2414 8.02776 26.2762 8.01607 26.3113C7.96469 26.2965 7.8953 26.2854 7.84422 26.2721C7.20715 26.5881 6.58099 26.9027 5.9493 27.2394Z", fill: "#B95B30" }), /* @__PURE__ */ b.createElement("path", { d: "M5.50768 23.4907C5.47553 23.5164 5.38815 23.5794 5.35615 23.6052C5.33907 23.5834 5.33615 23.5769 5.31445 23.5478C5.37245 23.5012 5.4303 23.4549 5.48815 23.4086C6.07845 23.3229 6.66922 23.2498 7.25999 23.1887C7.29476 23.2241 7.32953 23.2597 7.3643 23.2952L7.32922 23.3303C7.31322 23.3141 7.2803 23.2843 7.26722 23.272C6.67645 23.333 6.09815 23.4052 5.50768 23.4907Z", fill: "#B95B30" }), /* @__PURE__ */ b.createElement("path", { d: "M7.59665 20.5735C7.59204 20.5382 7.59019 20.5218 7.58496 20.4816C7.64481 20.4556 7.70465 20.4299 7.7645 20.4041C8.20081 20.4641 8.63635 20.5359 9.07111 20.6187C9.07881 20.6567 9.08635 20.6947 9.09404 20.7325C9.08404 20.7381 8.20127 20.559 7.76788 20.4995C7.72081 20.5198 7.64373 20.5531 7.59665 20.5735Z", fill: "#B95B30" }), /* @__PURE__ */ b.createElement("path", { d: "M21.2747 18.6481L21.2845 18.658C21.3035 18.646 21.3222 18.6337 21.3413 18.6217C21.319 18.5997 21.297 18.5775 21.2747 18.5557C21.2196 18.5551 21.1641 18.5544 21.1088 18.5541C20.8782 18.6977 20.6515 18.8475 20.4282 19.0024C20.4452 19.0217 20.4622 19.0409 20.4792 19.0601C20.6861 18.9175 20.8956 18.7794 21.1088 18.6467C21.1641 18.6471 21.2196 18.6475 21.2747 18.6481Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M16.3504 18.0166C16.3921 18.0038 16.4338 17.9912 16.4755 17.9784C16.5179 17.9912 16.5604 18.0038 16.6027 18.0166V17.9241C16.5604 17.9112 16.5179 17.8986 16.4755 17.886C16.4338 17.8986 16.3921 17.9112 16.3504 17.9241V18.0166Z", fill: "#A31F25" }), /* @__PURE__ */ b.createElement("path", { d: "M11.8367 18.6289C12.0495 18.7613 12.2542 18.9114 12.4605 19.0536C12.4778 19.0345 12.495 19.0154 12.5122 18.9965C12.2891 18.8417 12.0628 18.6919 11.8324 18.5485C11.7762 18.5491 11.7202 18.5499 11.6644 18.5506C11.6428 18.5723 11.5931 18.6109 11.5718 18.6328C11.5904 18.6445 11.6088 18.6566 11.6275 18.6686L11.6687 18.6311C11.7247 18.6303 11.7807 18.6296 11.8367 18.6289Z", fill: "#B7482F" }), /* @__PURE__ */ b.createElement("path", { d: "M11.4245 28.7088C11.4488 28.7417 11.4771 28.818 11.5036 28.8571L11.5267 28.8303C11.5188 28.8066 11.465 28.6868 11.4413 28.6324C11.3528 28.6511 11.2393 28.67 11.1508 28.6888C10.6962 29.2101 10.2478 29.7357 9.80469 30.2648C9.81176 30.2877 9.83146 30.3164 9.83838 30.3395C10.1231 30.0006 10.7371 29.2666 11.1847 28.7535C11.255 28.7375 11.351 28.7248 11.4245 28.7088Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M26.9161 27.2394C26.9326 27.2711 26.9592 27.3202 26.976 27.3522C26.9891 27.3465 26.9995 27.343 27.0157 27.3367C26.9805 27.2682 26.9449 27.1999 26.9095 27.1318C26.2778 26.7951 25.6435 26.4688 25.0066 26.1528C24.9425 26.1691 24.8785 26.1862 24.8145 26.2031C24.8278 26.2414 24.8377 26.2762 24.8494 26.3113C24.9008 26.2965 24.9701 26.2854 25.0211 26.2721C25.6581 26.5881 26.2843 26.9027 26.9161 27.2394Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M27.3566 23.4907C27.3889 23.5164 27.4762 23.5794 27.5083 23.6052C27.5254 23.5834 27.5282 23.5769 27.5498 23.5478C27.492 23.5012 27.4342 23.4549 27.3763 23.4086C26.7858 23.3229 26.1951 23.2498 25.6043 23.1887C25.5695 23.2241 25.5348 23.2597 25.5 23.2952L25.5352 23.3303C25.5512 23.3141 25.5842 23.2843 25.5972 23.272C26.188 23.333 26.7663 23.4052 27.3566 23.4907Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M25.2689 20.5735C25.2735 20.5382 25.2753 20.5218 25.2806 20.4816C25.2207 20.4556 25.1609 20.4299 25.101 20.4041C24.6646 20.4641 24.2292 20.5359 23.7944 20.6187C23.7867 20.6567 23.7792 20.6947 23.7715 20.7325C23.7815 20.7381 24.6641 20.559 25.0976 20.4995C25.1446 20.5198 25.2218 20.5531 25.2689 20.5735Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M21.44 28.7088C21.4157 28.7417 21.3873 28.818 21.361 28.8571L21.3379 28.8303C21.3457 28.8066 21.3996 28.6868 21.4233 28.6324C21.5116 28.6511 21.6253 28.67 21.7136 28.6888C22.1684 29.2101 22.617 29.7357 23.0597 30.2648C23.0499 30.2895 23.0405 30.3138 23.0296 30.3391C22.7451 30.0003 22.1274 29.2666 21.6799 28.7535C21.6096 28.7375 21.5137 28.7248 21.44 28.7088Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M16.6846 29.7716L16.7269 31.5205L16.7235 29.7061C16.6595 29.6613 16.571 29.617 16.507 29.5724C16.4418 29.617 16.3481 29.6615 16.2829 29.7061L16.283 31.5205L16.3246 29.7708C16.3772 29.7356 16.4553 29.7004 16.507 29.665C16.5581 29.7004 16.6333 29.7361 16.6846 29.7716Z", fill: "#932226" }), /* @__PURE__ */ b.createElement("path", { d: "M17.0017 23.086C16.932 23.086 16.8643 23.0897 16.8011 23.0981L16.4062 23.2018L16.3989 22.9681L16.5654 22.7528L17.1519 23.052L17.1426 23.0904C17.0951 23.0875 17.048 23.086 17.0017 23.086Z", fill: "url(#paint2_linear_3380_70755)" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5806 25.4227C23.7846 25.4932 24.1267 25.658 24.4315 25.8126C24.838 25.1966 25.046 24.4784 24.9637 23.6495C24.755 23.5341 24.5327 23.3623 24.4092 23.1715C24.2773 22.9681 24.0234 22.6682 23.7899 22.3925L23.7899 22.3925L23.7899 22.3925C23.6684 22.2491 23.5525 22.1122 23.4621 21.9987C23.2485 21.7301 22.8748 21.4749 22.5767 21.2713L22.5767 21.2713L22.5767 21.2713C22.3646 21.1264 22.1908 21.0077 22.1401 20.9289C22.0181 20.7397 21.8169 20.4069 21.7612 20.2758C21.7087 20.1517 21.5898 20.0492 21.3952 20.0492C21.3833 20.0492 21.3712 20.0495 21.3589 20.0504C21.2464 20.0572 21.1873 20.0806 21.1305 20.1031C21.078 20.1238 21.0276 20.1437 20.9389 20.1492C20.9158 20.1506 20.8915 20.1512 20.8667 20.1512C20.6933 20.1512 20.4952 20.1209 20.4952 20.1209C20.3824 20.098 20.3044 20.0843 20.2263 20.0841C20.1117 20.2738 19.9363 20.3901 19.5103 20.3901C19.4806 20.3901 19.4563 20.3869 19.436 20.3813C19.4784 20.4732 19.8493 20.5284 19.9358 20.5284C19.9389 20.5284 19.9417 20.5283 19.9441 20.5281H19.9484C19.9658 20.5281 19.9973 20.5332 20.0367 20.5412C20.5461 20.3909 21.0612 20.25 21.5893 20.116C21.5628 20.1326 21.5365 20.1495 21.5103 20.1664C21.4887 20.1803 21.4671 20.1942 21.4453 20.208L21.4426 20.2087C21.1946 20.3666 20.9533 20.526 20.7164 20.6877C20.7566 20.7047 20.8097 20.7323 20.8867 20.7769C21.3446 21.0412 22.0298 21.77 22.1658 22.4026C22.185 22.4924 22.2392 22.597 22.31 22.7083C22.9697 22.8317 23.6313 22.9657 24.305 23.1113L24.2275 23.1098L23.9913 23.1055H23.9912C23.7223 23.1013 23.4553 23.0993 23.1898 23.0993C22.9897 23.0993 22.79 23.1004 22.591 23.1027C22.7407 23.305 22.8795 23.5 22.9118 23.6446C22.3053 23.5995 21.5481 23.2852 21.215 23.1346C20.4207 23.1621 19.6241 23.2044 18.8075 23.2569C18.9592 23.3853 19.1084 23.5135 19.2555 23.6413C19.8715 23.8441 20.8732 24.1949 21.1984 24.4318C21.5147 24.6624 23.1473 25.2732 23.5806 25.4227ZM25.7073 26.5052C26.2847 26.7866 27.0643 27.1177 27.349 27.2129C27.3773 27.164 27.4046 27.115 27.4309 27.0661C27.811 26.3577 27.9947 25.6306 27.9943 24.9078C27.9941 24.7123 27.9806 24.517 27.9538 24.3226C27.9509 24.3024 27.948 24.2823 27.9447 24.2621L27.9444 24.2612L26.9333 24.0509L25.4995 23.8337L25.3164 23.7913C25.4077 24.6373 25.2075 25.3727 24.8064 26.0067C24.9635 26.0895 25.0683 26.1466 25.0683 26.1466C25.1263 26.1961 25.2441 26.2667 25.398 26.3484C25.5012 26.4004 25.6043 26.4527 25.7073 26.5052ZM18.6153 23.4295C18.4603 23.3732 18.2063 23.2861 18.028 23.2498C18.028 23.2498 17.9047 23.2138 17.726 23.1755C17.903 23.1621 18.0801 23.1493 18.2573 23.1373C18.377 23.2343 18.4964 23.3317 18.6153 23.4295ZM17.1426 23.0904C17.1763 23.0926 17.2103 23.0952 17.244 23.0984C17.214 23.0823 17.1833 23.0661 17.1523 23.05L17.1451 23.0802L17.1426 23.0904ZM23.1646 22.9913C22.9297 22.9678 22.6946 22.9455 22.4593 22.9246L22.4123 22.8592C22.6623 22.902 22.913 22.946 23.1646 22.9913ZM20.3229 20.6097C20.3456 20.6155 20.3672 20.6209 20.3867 20.6257C20.5144 20.5677 20.6424 20.5104 20.7709 20.454V20.4543L20.7729 20.4533C20.6127 20.502 20.4529 20.5517 20.2933 20.6023C20.3034 20.6048 20.3132 20.6073 20.3229 20.6097Z", fill: "#90483E" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5801 20.657C20.6226 20.6591 20.6537 20.6607 20.7167 20.6877C20.9536 20.526 21.1948 20.3666 21.4428 20.2087C21.0019 20.3226 20.5705 20.4407 20.1439 20.5652C20.1842 20.5748 20.2263 20.5854 20.2669 20.5956C20.2759 20.5978 20.2848 20.6001 20.2936 20.6023C20.4531 20.5517 20.613 20.502 20.7731 20.4534L20.7711 20.4543V20.5083C20.6691 20.553 20.5676 20.5984 20.4662 20.6441L20.4714 20.6452C20.5203 20.6541 20.5526 20.6557 20.5801 20.657ZM19.2557 23.6414L19.2551 23.641C19.1271 23.5298 18.9979 23.4189 18.8671 23.3077L18.8077 23.2569C18.9594 23.3854 19.1087 23.5135 19.2557 23.6414ZM21.2153 23.1346C20.421 23.1621 19.6244 23.2044 18.8077 23.2569V23.344C18.9047 23.4261 19.0002 23.5077 19.0944 23.5886C18.8871 23.5217 18.7527 23.4806 18.7527 23.4806C18.7527 23.4806 18.6982 23.4594 18.6156 23.4295C18.4967 23.3317 18.3773 23.2343 18.2576 23.1374C18.0804 23.1494 17.9033 23.1621 17.7262 23.1755C17.5882 23.146 17.4173 23.1152 17.2442 23.0984C17.2142 23.0823 17.1836 23.0661 17.1525 23.05C17.0604 23.002 16.9644 22.9541 16.8689 22.9066C16.7655 22.855 16.6626 22.8038 16.5656 22.7527C16.577 22.7391 16.5886 22.7257 16.6001 22.7125L16.6017 22.7106L16.6079 22.714C17.9008 22.7184 19.1899 22.7589 20.4776 22.836C20.7522 22.9101 20.911 22.9901 20.911 22.9901L21.0447 23.0546C21.0447 23.0546 21.1079 23.0861 21.2153 23.1346ZM16.0234 23.2964C16.1414 23.2647 16.2391 23.2086 16.2967 23.1195C16.3317 23.0654 16.3657 23.0152 16.3991 22.9681C16.4016 23.0458 16.4041 23.1238 16.4064 23.2018C16.271 23.2366 16.1276 23.2726 16.0234 23.2964ZM23.9914 23.1055C23.7225 23.1014 23.4556 23.0994 23.1901 23.0994C22.9899 23.0994 22.7902 23.1004 22.5913 23.1027L22.5065 22.9883C22.7261 23.0081 22.9454 23.029 23.1648 23.051V22.9914C22.9133 22.946 22.6625 22.902 22.4125 22.8592C22.3934 22.8323 22.3747 22.8055 22.3568 22.779C22.8948 22.8795 23.437 22.988 23.9914 23.1055Z", fill: "#937D86" }), /* @__PURE__ */ b.createElement("path", { d: "M20.0897 22.7548C19.136 22.7033 18.1811 22.6719 17.2256 22.6602C17.2468 22.5122 17.2608 22.3636 17.2671 22.2144C17.4148 22.2328 17.4179 22.2802 17.6644 22.363C17.802 22.4093 18.3248 22.5933 19.7039 22.7168C19.842 22.7232 19.9713 22.7367 20.0897 22.7548Z", fill: "#90483E" }), /* @__PURE__ */ b.createElement("path", { d: "M17.2259 22.6603C17.0342 22.658 16.8424 22.6565 16.6505 22.6557C16.7105 22.5897 16.773 22.526 16.8404 22.4597C16.9824 22.3772 17.1247 22.2955 17.2674 22.2145C17.2611 22.3637 17.2471 22.5123 17.2259 22.6603Z", fill: "url(#paint3_linear_3380_70755)" }), /* @__PURE__ */ b.createElement("path", { d: "M16.8402 22.4597C16.8734 22.4272 16.9077 22.394 16.9437 22.3595C16.9983 22.3072 17.0365 22.2546 17.0628 22.2017C17.1023 22.2035 17.1439 22.2057 17.188 22.2078C17.2188 22.2094 17.2448 22.2115 17.2672 22.2145C17.1245 22.2955 16.9822 22.3772 16.8402 22.4597Z", fill: "#937D86" }), /* @__PURE__ */ b.createElement("path", { d: "M20.144 20.5652C20.1054 20.556 20.0688 20.5477 20.0371 20.5412C20.5465 20.3909 21.0616 20.25 21.5897 20.116C21.5414 20.1463 21.4939 20.1775 21.4457 20.208C21.4448 20.2083 21.4439 20.2086 21.443 20.2087C21.002 20.3226 20.5706 20.4407 20.144 20.5652Z", fill: "#7B2B38" }), /* @__PURE__ */ b.createElement("path", { d: "M19.2549 23.6411C19.1979 23.6223 19.1439 23.6047 19.0942 23.5886C19 23.5077 18.9045 23.4261 18.8076 23.344V23.2569L18.8669 23.3077C18.9977 23.4189 19.1269 23.5298 19.2549 23.6411Z", fill: "#6E2531" }), /* @__PURE__ */ b.createElement("path", { d: "M20.4663 20.6441C20.4484 20.6406 20.4206 20.634 20.387 20.6257C20.5147 20.5677 20.6427 20.5105 20.7712 20.454V20.5083C20.6692 20.5531 20.5676 20.5985 20.4663 20.6441Z", fill: "#6E2531" }), /* @__PURE__ */ b.createElement("path", { d: "M24.5051 25.85C24.4809 25.8377 24.4565 25.8252 24.4318 25.8126C24.8383 25.1966 25.0463 24.4785 24.964 23.6495C24.9695 23.6526 24.9751 23.6555 24.9806 23.6586C25.0863 24.4978 24.8971 25.2251 24.5051 25.85Z", fill: "#7D373B" }), /* @__PURE__ */ b.createElement("path", { d: "M24.8068 26.0067C24.7194 25.9607 24.6159 25.9066 24.5051 25.85C24.8971 25.225 25.0864 24.4978 24.9807 23.6586C25.1042 23.7252 25.2218 23.7716 25.3101 23.7898L25.3168 23.7913C25.4081 24.6373 25.2079 25.3727 24.8068 26.0067Z", fill: "#937D86" }), /* @__PURE__ */ b.createElement("path", { d: "M27.6745 23.2665C27.2786 23.2471 26.5051 23.2242 26.1417 23.0311C26.1428 22.9028 25.649 22.8702 25.649 22.8702C25.649 22.8702 25.4723 22.7651 25.5213 22.6845L25.9119 22.4529C25.9119 22.4529 26.0634 22.4176 26.2002 22.4176C26.2036 22.4176 26.207 22.4176 26.2102 22.4176C26.278 22.4162 26.342 22.4154 26.4026 22.4154C27.024 22.4154 27.2734 22.4859 27.2939 22.492L27.2943 22.4922C27.3596 22.602 27.4211 22.7131 27.4779 22.826C27.4837 22.8377 27.4896 22.8494 27.4954 22.8609C27.4956 22.8613 27.4956 22.8614 27.4957 22.8617C27.4968 22.8639 27.4979 22.866 27.499 22.8682C27.5086 22.8879 27.5182 22.9076 27.5274 22.9271C27.5279 22.928 27.5283 22.9289 27.5288 22.9299C27.5288 22.93 27.529 22.9302 27.5291 22.9303C27.582 23.0417 27.6305 23.1539 27.6745 23.2663V23.2665Z", fill: "#90483E" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.699 27.1073C22.5599 27.1073 22.5697 27.2519 22.6243 27.4142C22.7771 27.3261 22.9253 27.2339 23.0679 27.1375C22.9805 27.1202 22.8613 27.1076 22.6994 27.1073H22.699ZM25.3062 28.6158C25.3062 28.6158 25.6816 28.6656 26.0663 28.7819C26.1211 28.7316 26.1751 28.6807 26.2279 28.6293L26.2454 28.6122C26.2722 28.5859 26.2988 28.5595 26.325 28.533L26.3254 28.5327L26.3297 28.5282L26.3311 28.5268L26.3346 28.5233L26.3365 28.5213C26.3374 28.5204 26.3385 28.5195 26.3393 28.5185C26.34 28.5179 26.3406 28.5172 26.3413 28.5166C26.3416 28.5162 26.3419 28.5159 26.3422 28.5156C26.3424 28.5154 26.3426 28.5152 26.3428 28.515C26.3431 28.5146 26.3435 28.5142 26.344 28.5138L26.3477 28.5101L26.3485 28.5091C26.5302 28.3242 26.6962 28.1365 26.8471 27.9465C26.8279 27.9461 26.8085 27.9457 26.789 27.9453C25.922 27.9277 24.7197 27.9031 23.8025 27.4247C23.7702 27.3301 23.7019 27.277 23.6256 27.2482C23.3682 27.4421 23.0902 27.621 22.796 27.7858C22.8208 27.8304 22.8376 27.8579 22.8376 27.8579C23.1239 28.0499 24.1559 28.3441 24.3711 28.3728C24.5863 28.4008 25.3062 28.6158 25.3062 28.6158Z", fill: "#90483E" }), /* @__PURE__ */ b.createElement("path", { d: "M22.6633 27.516C22.649 27.482 22.6358 27.4479 22.6246 27.4143C22.7773 27.3262 22.9255 27.234 23.0681 27.1376C23.1243 27.1485 23.1672 27.1614 23.1996 27.1739C23.029 27.2942 22.8495 27.4082 22.6633 27.516Z", fill: "#7D373B" }), /* @__PURE__ */ b.createElement("path", { d: "M22.7962 27.7859C22.7601 27.7209 22.707 27.6202 22.6633 27.516C22.8495 27.4082 23.029 27.2942 23.1996 27.1739C23.2733 27.2022 23.2938 27.2286 23.2938 27.2286C23.2938 27.2286 23.3521 27.2168 23.4299 27.2168C23.4895 27.2168 23.5605 27.2237 23.6258 27.2483C23.3684 27.4422 23.0904 27.6211 22.7962 27.7859Z", fill: "#937D86" }), /* @__PURE__ */ b.createElement("path", { d: "M20.6486 13.5482C20.6486 13.5482 20.3589 13.2854 20.3542 13.27C20.3333 13.1772 20.4362 13.054 20.4613 12.8997C20.4311 12.8891 20.4011 12.8748 20.3726 12.8622C20.3023 12.5952 20.2443 12.1135 20.3729 11.8558C20.4356 11.7302 20.5099 11.5648 20.4669 11.4178C20.2283 10.5997 19.7554 9.88692 19.4217 9.10985C19.3313 8.89938 19.3463 8.74738 19.3333 8.53185C19.0751 8.24785 18.7765 7.50354 18.6323 7.044C18.3319 7.80415 18.1325 8.67754 18.1325 8.87969C18.1325 9.73523 18.9997 10.1498 18.6994 11.572C18.6414 11.8463 18.538 12.226 18.4353 12.6177C18.6153 13.6088 18.6153 14.328 18.8805 15.4762C19.2514 15.8431 19.5613 16.3138 19.7262 16.9117C19.8283 17.2815 20.1403 18.1506 20.5389 18.2809C20.786 18.3615 19.7008 18.5605 19.3933 18.1754C19.0974 17.8045 18.5865 17.5085 18.3446 17.1143C18.1514 16.8002 17.8517 16.1306 17.6623 15.8126L17.4303 17.0314C17.746 18.3325 17.5579 18.6197 17.2771 19.6754C17.1557 20.1315 16.2348 17.9982 16.2339 17.8317C16.2339 17.368 16.204 17.1966 16.0957 16.7882C15.9025 16.4122 15.9234 15.8785 15.9497 15.4732C15.9939 14.7945 15.9883 13.5163 16.0177 13.1798C15.7854 12.6089 15.1905 11.5775 15.1308 10.9971C15.0382 10.0925 15.1909 9.17723 15.0651 8.27554C14.9097 8.72738 14.7449 9.30015 14.3939 9.64615C13.868 10.1645 13.3825 10.7389 12.9134 11.3071C12.742 11.5409 12.8934 11.6551 12.6282 12.0294C12.3673 12.3975 12.5071 12.2315 12.4526 12.5832C12.4433 12.6442 12.4128 12.6918 12.3925 12.7128C12.2528 12.8298 12.1045 12.9302 11.9045 12.8462C11.5177 12.652 11.49 12.3645 11.4634 11.9946C11.4126 11.2888 11.9346 11.2554 12.2302 10.8285C12.8106 9.98969 13.1045 8.58308 13.726 7.95C13.7649 7.82461 13.9103 7.37323 14.1885 6.70123C14.1968 5.86631 14.4031 5.12354 15.2614 4.78092C15.6133 4.64061 16.0742 4.60492 16.0913 4.11892C16.0934 4.06108 16.0814 3.91169 16.0443 3.85861C15.9023 3.74415 15.8034 3.74123 15.7351 3.66015C15.596 3.48169 15.4809 2.33385 15.4963 2.26061C15.6982 1.28677 16.1636 0.962307 16.7539 0.991538C17.4514 1.02615 18.0045 1.36092 17.9745 2.29815C17.9503 3.05277 17.1713 4.02061 18.3368 4.38754C18.7819 4.52769 18.8666 4.43061 19.2493 4.81523C19.6782 5.24631 19.7825 6.012 19.854 6.72169L20.2914 7.73723C21.0936 9.08708 20.8031 9.514 21.0982 10.8883C21.1746 11.244 21.3062 11.5586 21.3343 12.336C21.3476 12.7071 21.0536 13.5346 20.6486 13.5482Z", fill: "#F2AC59" }), /* @__PURE__ */ b.createElement("path", { d: "M12.2883 12.5293C12.3241 12.1695 12.2724 12.1999 12.502 11.8664C12.7147 11.5569 12.612 11.3993 12.8003 11.1336C13.2631 10.5556 13.7001 9.97179 14.2195 9.44425C14.5671 9.09118 15.0394 7.90333 15.1503 7.4861C15.1715 7.42487 15.2049 7.39456 15.2191 7.44748C15.2918 8.24333 15.4041 8.90702 15.376 9.68902C15.3167 11.3316 15.3615 11.1595 16.0444 12.6935C16.1011 12.0767 16.25 11.1818 16.61 10.8786C16.1903 12.4773 16.1644 14.7559 16.1201 15.4576C16.0975 15.8144 16.0003 16.3773 16.1715 16.7058C16.2291 16.9279 16.2332 17.263 16.2384 17.5176C16.2394 17.6727 16.2491 20.3221 16.2491 20.3221L16.0032 21.5521C15.9152 21.907 15.4572 22.5039 15.1189 22.6895C15.0112 22.7489 14.7584 22.8836 14.7584 23.0041C14.7584 23.1981 16.0107 23.5612 16.2961 23.1195C16.5109 22.7873 16.6877 22.6046 16.9435 22.3595C17.3377 21.9818 16.9006 21.5929 16.9524 21.0816C17.0427 20.1906 17.4261 19.4172 17.552 18.5756C17.6275 18.0693 17.6147 17.6221 17.3837 17.0449L17.55 15.4369C17.7341 15.7143 17.9081 16.1546 18.0841 16.5212C18.3969 17.1724 18.4014 17.2361 18.9423 17.7703C19.1244 17.9499 19.3127 18.1629 19.45 18.3807C19.7043 18.7849 19.8797 19.1856 19.8571 19.6679C19.6694 20.0072 19.5887 19.9861 19.3481 20.1918C19.356 20.2032 19.2814 20.3903 19.51 20.3903C20.3246 20.3903 20.2237 19.9649 20.532 19.4133C20.7311 19.0567 21.3023 18.5144 20.6755 18.3266C20.4789 18.2675 20.294 18.1496 20.1798 17.959C19.7454 17.2332 19.7286 17.2518 19.5027 16.5835C19.3661 16.179 19.0878 15.8524 18.7589 15.5867C18.5584 15.1309 18.4786 14.8067 18.4138 14.3224C18.3261 13.6658 18.2666 13.1955 18.1552 12.5239C18.4732 11.2632 18.6364 10.9964 18.0957 9.7841C17.9714 9.50548 17.9011 9.20856 17.9011 8.87964C17.9011 8.47625 18.1231 7.57148 18.3384 7.10241C18.4135 6.91148 18.5191 6.73195 18.6672 6.67472C18.7987 7.16379 19.2503 8.16918 19.5126 8.41548C19.5289 8.61318 19.5209 8.81241 19.5986 8.99933C19.9292 9.79225 20.4046 10.5133 20.6412 11.3492C20.7226 11.6364 20.6143 11.7749 20.5324 12.0066C20.5074 12.1181 20.5007 12.4403 20.5501 12.6796L20.6634 12.7413C20.6438 12.8141 20.5934 13.0163 20.5531 13.1099C20.5678 13.2232 20.7072 13.2876 20.7072 13.2876C20.8887 13.2473 21.1481 12.5901 21.1389 12.3275C21.1107 11.5233 20.9415 11.1635 20.8944 10.9238C20.6263 9.55995 20.7812 9.18502 20.0177 7.86518L19.5834 6.79256C19.53 6.24271 19.3109 4.98902 18.6072 4.76395C18.4889 4.72625 18.3698 4.71933 18.1911 4.66133C17.2701 4.36256 17.2727 3.65564 17.5238 2.88318C17.7472 2.19548 17.7769 1.38502 16.7652 1.29964C16.1392 1.24702 15.9492 1.73979 15.8154 2.30718C15.8197 2.36902 15.8511 3.29148 15.9871 3.48995C16.2549 3.68902 16.4051 3.63056 16.3881 4.12887C16.3738 4.54733 16.1078 4.79456 15.7463 4.92179C15.1578 5.12902 14.8571 5.24995 14.6586 5.85718C14.5961 6.04764 14.5427 6.32148 14.5412 6.7301L14.5411 6.75764C14.3729 7.17456 14.1607 7.65225 14.0324 8.10025C13.308 8.82641 12.9484 10.4795 12.2147 11.1773C11.7274 11.6409 11.5801 11.6706 11.7586 12.3855C11.7766 12.4578 12.0104 12.6438 12.0603 12.6704C12.0961 12.6836 12.2892 12.5707 12.2883 12.5293Z", fill: "url(#paint4_linear_3380_70755)" }), /* @__PURE__ */ b.createElement("defs", null, /* @__PURE__ */ b.createElement("linearGradient", { id: "paint0_linear_3380_70755", x1: 4.51367, y1: 31.0118, x2: 28.2558, y2: 31.0118, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#BA5B30" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#623133" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint1_linear_3380_70755", x1: 7.63796, y1: 31.3688, x2: 19.5158, y2: 25.2946, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F9CB70" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#E6762E" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint2_linear_3380_70755", x1: 16.4534, y1: 23.4707, x2: 17.2148, y2: 23.358, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#914C40" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#914A3F" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint3_linear_3380_70755", x1: 16.6859, y1: 22.9203, x2: 17.3817, y2: 22.7853, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#914B3F" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#91493E" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint4_linear_3380_70755", x1: 7.20633, y1: 12.1468, x2: 22.2699, y2: 18.705, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#27327C" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#212867" })))), Bh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.9746 2.09998C24.5865 2.09998 25.0653 2.60538 25.0653 3.20388C25.0653 3.82899 24.5865 4.32109 23.9746 4.32109C23.3495 4.32109 22.8707 3.82899 22.8707 3.20388V3.19058C22.8707 2.57878 23.3761 2.09998 23.9746 2.09998ZM8.38695 14.3361C7.76185 12.607 7.16334 11.0642 6.95054 10.6253C6.56484 9.78742 5.88653 8.94952 4.90233 8.77662C4.90676 8.77662 4.91858 8.77514 4.93435 8.77317L4.93436 8.77317L4.93438 8.77316C4.9659 8.76922 5.01317 8.76332 5.04863 8.76332C6.85744 8.51062 7.64214 7.18061 7.64214 5.8373C7.64214 4.68019 7.00374 2.87138 4.05112 2.87138H0.978803C0.766002 2.87138 0.5665 3.04428 0.5665 3.25708V14.4292C0.5665 14.642 0.766002 14.8149 0.978803 14.8149H1.83001C2.04281 14.8149 2.21571 14.642 2.21571 14.4292V9.44162H3.05362C4.26392 9.44162 4.80923 10.1864 5.22153 10.9578C5.58916 11.6434 5.87513 12.5368 6.19037 13.5216C6.2971 13.8551 6.40719 14.199 6.52494 14.5489C6.59144 14.775 6.75104 14.8282 6.95054 14.8282H8.12095C8.44015 14.8149 8.49335 14.6154 8.38695 14.3361ZM3.82502 8.01851H2.22901V4.32109H4.02452C5.30133 4.32109 5.96633 5.07919 5.96633 6.0501C5.95303 7.27371 5.14173 8.01851 3.82502 8.01851ZM8.25395 10.479C8.25395 7.79241 9.57066 6.1033 11.5258 6.1033C13.3346 6.1033 14.7577 7.26041 14.7444 10.5322C14.7444 10.745 14.5715 10.9179 14.3587 10.9179H9.92976C10.0096 12.5804 10.5416 13.4981 12.1376 13.4981C12.7464 13.4981 13.1945 13.3696 13.655 13.2374L13.655 13.2374C13.7075 13.2224 13.7602 13.2072 13.8134 13.1922C14.0794 13.1124 14.2257 13.2454 14.2922 13.4449L14.4917 14.0168C14.5715 14.2297 14.4651 14.4026 14.2656 14.4957C13.6937 14.7484 13.0952 14.908 12.0578 14.908C9.62386 14.908 8.25395 13.3917 8.25395 10.479ZM9.94306 9.69432C10.116 7.84561 10.9273 7.40671 11.579 7.40671C12.6829 7.40671 13.0686 8.56382 13.1085 9.69432H9.94306ZM18.3487 13.2986H19.825C21.4343 13.2986 22.4717 14.1366 22.485 15.5996C22.485 17.6611 20.5831 18.4059 18.9472 18.4059C17.2315 18.4059 15.436 17.834 15.4227 15.9188V15.9055C15.4227 15.6927 15.5956 15.5331 15.8084 15.5331L16.6995 15.573C16.9123 15.5863 17.0453 15.7193 17.0852 15.9454C17.2315 16.8897 18.1492 17.0493 18.9871 17.0493C20.0777 17.0493 20.9289 16.5705 20.9289 15.7858C20.9289 15.0543 20.5565 14.6686 19.5989 14.6686H17.8699C16.8192 14.6686 15.9148 14.3095 15.9148 13.2853C15.9148 12.6602 16.2739 12.1947 16.6995 11.809C15.9148 11.2903 15.4227 10.3992 15.4227 9.22882C15.4227 7.23381 16.7128 6.1166 18.6147 6.1166C18.8009 6.1166 18.9838 6.13988 19.1667 6.16315C19.3495 6.18643 19.5324 6.2097 19.7186 6.2097H21.7668C22.0062 6.2097 22.1525 6.3959 22.1525 6.622V7.08751C22.1525 7.31361 22.0062 7.44661 21.7934 7.45991L21.2082 7.52641C21.5806 8.03181 21.8466 8.63032 21.8466 9.22882C21.8466 11.1839 20.5831 12.3809 18.6147 12.3809C18.3221 12.3809 18.0295 12.341 17.7502 12.2745C17.5773 12.4341 17.431 12.6203 17.431 12.8198C17.431 13.1922 17.7103 13.2986 18.3487 13.2986ZM18.628 7.32691C19.4925 7.32691 20.2107 7.63281 20.2107 9.18892C20.2107 10.7849 19.4526 11.1307 18.628 11.1307C17.7768 11.1307 17.0586 10.8514 17.0586 9.18892C17.0586 7.61951 17.7768 7.32691 18.628 7.32691ZM24.786 14.4159V6.5954C24.786 6.3826 24.5865 6.2097 24.4002 6.2097H23.6022C23.3894 6.2097 23.1899 6.3826 23.1899 6.5954V14.4159C23.1899 14.6287 23.3894 14.8016 23.6022 14.8016H24.4002C24.5865 14.8149 24.786 14.6287 24.786 14.4159ZM25.584 10.5056C25.584 7.77911 26.9273 6.1033 29.0553 6.1033C31.1833 6.1033 32.5 7.79241 32.5 10.5056C32.5 13.2188 31.2099 14.8947 29.0553 14.8947C26.914 14.8947 25.584 13.2587 25.584 10.5056ZM30.8109 10.5056C30.8109 12.6602 30.1326 13.538 29.0154 13.538C27.9115 13.538 27.2332 12.6469 27.2332 10.5056C27.2332 8.39091 27.9115 7.47321 29.0154 7.47321C30.1326 7.47321 30.8109 8.39091 30.8109 10.5056ZM7.61554 21.1058C7.61554 22.4358 7.00374 23.3269 5.56733 23.7525C7.26974 23.952 8.12095 25.1889 8.13425 26.7184C8.13425 28.8597 6.77764 30.0834 4.54323 30.0834H0.912303C0.699501 30.0834 0.5 29.9104 0.5 29.6976V18.5256C0.5 18.3128 0.699501 18.1399 0.912303 18.1399H4.35702C6.41854 18.1399 7.61554 19.3502 7.61554 21.1058ZM2.16251 19.563H4.03782C5.30133 19.563 5.92643 20.2014 5.92643 21.3452C5.92643 22.4491 5.24813 23.1407 3.91812 23.1407H2.16251V19.563ZM4.38362 28.6336C5.60723 28.6336 6.33874 27.8622 6.33874 26.5588C6.33874 25.3485 5.48753 24.4574 4.05112 24.4574H2.14921V28.6336H4.38362ZM15.1035 29.7109L14.9971 29.1922C14.9012 28.7129 14.9025 28.2768 14.9037 27.8742L14.904 27.7425V24.6569C14.904 23.2205 14.6779 21.4117 11.845 21.4117C11.0869 21.4117 10.2091 21.6112 9.69036 21.7442C9.47756 21.7974 9.38446 21.9703 9.43766 22.2097L9.58396 22.8614C9.63716 23.0875 9.81006 23.2205 10.0495 23.1407C10.1381 23.1185 10.2286 23.0941 10.3216 23.069L10.3216 23.069C10.7308 22.9584 11.1884 22.8348 11.7519 22.8348C13.0154 22.8348 13.2947 23.3136 13.2947 24.351V24.7766L11.3396 24.8963C9.90316 25.0027 8.67955 25.7475 8.67955 27.6494C8.67955 29.2454 9.54406 30.1898 10.9672 30.1898C11.9514 30.1898 12.8691 29.8306 13.4144 28.9661L13.5341 29.7508C13.574 30.0035 13.7336 30.11 13.9464 30.11H14.7577C15.0104 30.0966 15.1301 29.937 15.1035 29.7109ZM11.446 28.8863C12.5765 28.8863 13.308 27.9021 13.308 27.2504V25.9071L12.1908 25.947C11.1135 25.9869 10.3288 26.3061 10.3288 27.6361C10.3288 28.5006 10.7943 28.8863 11.446 28.8863ZM22.0993 29.7109V23.6195C22.0993 22.2895 21.2481 21.3984 19.9181 21.3984C18.9738 21.3984 18.229 21.7575 17.4842 22.622L17.3113 21.824C17.2581 21.5979 17.1384 21.5048 16.8857 21.5048H16.3537C16.1409 21.5048 15.9414 21.6644 15.9414 21.8772V29.7109C15.9414 29.9237 16.1409 30.0966 16.3537 30.0966H17.165C17.3778 30.0966 17.5507 29.9237 17.5507 29.7109V24.883C17.5507 23.6993 18.3886 22.7816 19.4659 22.7816C20.1974 22.7816 20.4767 23.154 20.4767 23.9786V29.7109C20.4767 29.9237 20.6762 30.0966 20.889 30.0966H21.7003C21.9131 30.0966 22.0993 29.9237 22.0993 29.7109ZM26.3155 25.1889L29.2282 29.6311C29.3479 29.8306 29.2548 30.0966 29.0154 30.11H27.7519C27.5524 30.11 27.3928 29.9902 27.2731 29.7774L24.6929 25.4815V29.7242C24.6929 29.937 24.52 30.11 24.3071 30.11H23.5091C23.2963 30.11 23.1234 29.937 23.1234 29.7242V17.8739C23.1234 17.6611 23.2963 17.5015 23.5091 17.5015H24.3204C24.5333 17.5015 24.6929 17.6744 24.6929 17.8872V25.0958L26.8475 21.8107C26.9539 21.6245 27.1135 21.5048 27.3662 21.5048H28.4967C28.7494 21.5048 28.8425 21.7442 28.6962 21.9437L26.3155 25.1889Z", fill: "#CA031A" })), jh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M32.1129 15.9677C32.1129 24.598 25.1311 31.5798 16.5008 31.5798C7.87049 31.5798 0.888672 24.598 0.888672 15.9677C0.888672 7.33741 7.87049 0.355591 16.5008 0.355591C25.0988 0.355591 32.1129 7.33741 32.1129 15.9677Z", fill: "white" }), /* @__PURE__ */ b.createElement("circle", { cx: 16.4678, cy: 15.9677, r: 15.6768, fill: "white" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9677L22.286 12.7354L31.5627 20.299L16.4678 15.9677Z", fill: "url(#paint0_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M22.2861 12.7354L31.5629 20.299L30.6255 19.8141L22.2861 12.9939V12.7354Z", fill: "#E53121" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9677L22.286 12.7354L22.2536 12.9939L16.9849 15.903L16.4678 15.9677Z", fill: "#F08465" }), /* @__PURE__ */ b.createElement("path", { d: "M31.5627 20.299L16.4678 15.9677L17.0173 15.9031L30.6253 19.8142L31.5627 20.299Z", fill: "#B82B18" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9678L22.286 12.7354L20.7991 0.872803L16.4678 15.9678Z", fill: "#F5B0AC" }), /* @__PURE__ */ b.createElement("path", { d: "M20.7991 0.872803L16.4678 15.9678L16.8233 15.5476L20.7344 1.90715L20.7991 0.872803Z", fill: "#D47785" }), /* @__PURE__ */ b.createElement("path", { d: "M22.2859 12.7354L20.799 0.872803L20.7344 1.90715L22.092 12.6061L22.2859 12.7354Z", fill: "#D99E9B" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9677L22.286 12.7354L22.0597 12.6061L16.791 15.5152L16.4678 15.9677Z", fill: "#F9D1CD" }), /* @__PURE__ */ b.createElement("path", { d: "M19.7004 21.7859L12.1367 31.0626L12.6216 30.1253L19.4418 21.7535L19.7004 21.7859Z", fill: "#F9F9FC" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9678L19.7001 21.786L19.4415 21.7536L16.5324 16.4849L16.4678 15.9678Z", fill: "#F3F2F9" }), /* @__PURE__ */ b.createElement("path", { d: "M12.1367 31.0627L16.468 15.9678L16.5327 16.5173L12.6216 30.1253L12.1367 31.0627Z", fill: "#DCDAEE" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9678L19.7001 21.786L31.5627 20.2991L16.4678 15.9678Z", fill: "#2B2B85" }), /* @__PURE__ */ b.createElement("path", { d: "M31.5627 20.2991L16.4678 15.9678L16.888 16.3233L30.5284 20.2344L31.5627 20.2991Z", fill: "#484293" }), /* @__PURE__ */ b.createElement("path", { d: "M19.7002 21.7859L31.5628 20.299L30.5285 20.2344L19.8295 21.592L19.7002 21.7859Z", fill: "#24236F" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4678 15.9678L19.7001 21.786L19.8294 21.5597L16.9203 16.291L16.4678 15.9678Z", fill: "#8F88C0" }), /* @__PURE__ */ b.createElement("path", { d: "M16.468 15.9677L10.6498 19.2L1.37305 11.6364L16.468 15.9677Z", fill: "url(#paint1_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M10.6498 19.2L1.37305 11.6364L2.31042 12.1212L10.6821 18.9414L10.6498 19.2Z", fill: "#BBB7DB" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4676 15.9678L10.6494 19.2001L10.6817 18.9415L15.9504 16.0324L16.4676 15.9678Z", fill: "#B0AAD4" }), /* @__PURE__ */ b.createElement("path", { d: "M1.37305 11.6364L16.468 15.9677L15.9185 16.0323L2.31042 12.1212L1.37305 11.6364Z", fill: "#D1CCE6" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4676 15.9678L10.6494 19.2001L12.1363 31.0627L16.4676 15.9678Z", fill: "#FFDD00" }), /* @__PURE__ */ b.createElement("path", { d: "M12.1367 31.0627L16.468 15.9678L16.1125 16.388L12.2337 30.0284L12.1367 31.0627Z", fill: "#DBBB85" }), /* @__PURE__ */ b.createElement("path", { d: "M10.6494 19.2001L12.1363 31.0627L12.2009 30.0284L10.8434 19.3294L10.6494 19.2001Z", fill: "#EBC536" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4676 15.9678L10.6494 19.2001L10.8757 19.3294L16.1444 16.4203L16.4676 15.9678Z", fill: "#FFE167" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4677 15.9678L13.2354 10.1496L20.799 0.872803L16.4677 15.9678Z", fill: "#E53121" }), /* @__PURE__ */ b.createElement("path", { d: "M13.2354 10.1496L20.799 0.872803L20.3141 1.81018L13.4939 10.1819L13.2354 10.1496Z", fill: "#EA583C" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4677 15.9677L13.2354 10.1495L13.4939 10.1819L16.403 15.4505L16.4677 15.9677Z", fill: "#D42F1E" }), /* @__PURE__ */ b.createElement("path", { d: "M20.7993 0.872803L16.468 15.9678L16.4033 15.4183L20.3144 1.81018L20.7993 0.872803Z", fill: "#C22C1A" }), /* @__PURE__ */ b.createElement("path", { d: "M16.468 15.9677L13.2357 10.1495L1.37305 11.6364L16.468 15.9677Z", fill: "#F3F2F9" }), /* @__PURE__ */ b.createElement("path", { d: "M1.37305 11.6364L16.468 15.9677L16.0478 15.6121L2.40739 11.7333L1.37305 11.6364Z", fill: "#F9F8FB" }), /* @__PURE__ */ b.createElement("path", { d: "M13.2357 10.1495L1.37305 11.6364L2.40739 11.7011L13.1064 10.3435L13.2357 10.1495Z", fill: "#DCDAEE" }), /* @__PURE__ */ b.createElement("path", { d: "M16.4681 15.9677L13.2357 10.1495L13.1064 10.3758L16.0155 15.6445L16.4681 15.9677Z", fill: "#F9F9FC" }), /* @__PURE__ */ b.createElement("path", { d: "M27.7806 5.07482C25.8413 3.07078 23.4493 1.64856 20.7988 0.872803L22.2857 12.7354L27.7806 5.07482Z", fill: "url(#paint2_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M20.7988 0.872803L22.2857 12.7354L22.415 12.1859L21.0251 0.937449C20.9604 0.937449 20.8635 0.905126 20.7988 0.872803Z", fill: "#8F88C0" }), /* @__PURE__ */ b.createElement("path", { d: "M27.6194 4.91321L22.4477 12.1859L22.3184 12.7354L27.781 5.0425C27.7163 5.01018 27.684 4.94553 27.6194 4.91321Z", fill: "#A59FCE" }), /* @__PURE__ */ b.createElement("path", { d: "M27.7806 5.07482C25.8413 3.07078 23.4493 1.64856 20.7988 0.872803L21.0897 1.38997C23.4817 2.13341 25.615 3.45866 27.3928 5.23644L27.7806 5.07482Z", fill: "url(#paint3_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M22.2861 12.7354L27.7488 5.04248C29.6558 7.0142 31.0134 9.47076 31.6922 12.1536L22.2861 12.7354Z", fill: "url(#paint4_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M27.7811 5.07483L22.2861 12.7354L22.7063 12.5092L27.9104 5.23645C27.8781 5.1718 27.8134 5.10715 27.7811 5.07483Z", fill: "#ED6F50" }), /* @__PURE__ */ b.createElement("path", { d: "M31.6598 11.9597L22.7386 12.5092L22.3184 12.7354L31.7244 12.1536C31.6921 12.0889 31.6598 12.0243 31.6598 11.9597Z", fill: "#A62714" }), /* @__PURE__ */ b.createElement("path", { d: "M31.2401 11.992C30.5937 9.60006 29.3654 7.40208 27.6846 5.55965L27.7815 5.04248C29.6886 7.0142 31.0462 9.47076 31.725 12.1536L31.2401 11.992Z", fill: "url(#paint5_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M22.2861 12.7354L31.6922 12.1536C32.3387 14.7394 32.3387 17.5192 31.5629 20.2667L22.2861 12.7354Z", fill: "url(#paint6_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M31.7244 12.1859L22.3184 12.7677L22.8679 12.9293L31.7891 12.3798C31.7567 12.3152 31.7244 12.2505 31.7244 12.1859Z", fill: "#D1CEE8" }), /* @__PURE__ */ b.createElement("path", { d: "M31.5629 20.299C31.5952 20.2344 31.5952 20.1374 31.6275 20.0728L22.8356 12.9293L22.2861 12.7677L31.5629 20.299Z", fill: "#F3F2F9" }), /* @__PURE__ */ b.createElement("path", { d: "M31.2722 19.7819C31.9187 17.293 31.9187 14.7718 31.3369 12.4122L31.7248 12.1859C32.3712 14.7718 32.3712 17.5516 31.5955 20.299L31.2722 19.7819Z", fill: "url(#paint7_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M5.57507 4.68689C3.63567 6.52931 2.18113 8.88891 1.37305 11.6364L13.2357 10.1495L5.57507 4.68689Z", fill: "url(#paint8_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M1.37305 11.6364L13.2357 10.1496L12.6862 10.0203L1.43769 11.4102C1.43769 11.4748 1.40537 11.5718 1.37305 11.6364Z", fill: "#FFCB00" }), /* @__PURE__ */ b.createElement("path", { d: "M5.41309 4.81618L12.6858 9.9879L13.2353 10.1172L5.5747 4.68689C5.51006 4.71921 5.47773 4.78386 5.41309 4.81618Z", fill: "#FFDD00" }), /* @__PURE__ */ b.createElement("path", { d: "M5.57507 4.68689C3.57103 6.59396 2.1488 8.98588 1.37305 11.6364L1.89022 11.3455C2.63365 8.95356 3.95891 6.82022 5.73668 5.04245C5.76901 5.07477 5.57507 4.68689 5.57507 4.68689Z", fill: "#FFF8C7" }), /* @__PURE__ */ b.createElement("path", { d: "M13.2358 10.1496L5.5752 4.68696C7.54691 2.77989 10.0035 1.42232 12.6863 0.74353L13.2358 10.1496Z", fill: "url(#paint9_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0095 9.69707L12.46 0.775854L12.6863 0.74353L13.234 10.0862L13.0419 9.72939L13.0177 9.71215L13.0095 9.69707ZM13.0177 9.71215L5.73681 4.52535C5.71391 4.54825 5.69101 4.56709 5.66955 4.58476C5.63042 4.61695 5.59607 4.64522 5.5752 4.68696L13.2681 10.1496L13.234 10.0862L13.2358 10.1173L13.0177 9.71215Z", fill: "#E53121" }), /* @__PURE__ */ b.createElement("path", { d: "M12.4925 1.22838C10.1005 1.87484 7.90256 3.10313 6.06014 4.78393L5.54297 4.68696C7.51469 2.77989 9.97125 1.42232 12.6541 0.74353L12.4925 1.22838Z", fill: "url(#paint10_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M13.236 10.1495L12.6865 0.743472C15.2724 0.0970073 18.0522 0.0970073 20.7997 0.872765L13.236 10.1495Z", fill: "url(#paint11_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M12.6859 0.743479L13.2677 10.1495L13.4293 9.60005L12.8798 0.678833C12.8152 0.711156 12.7505 0.711156 12.6859 0.743479Z", fill: "#1E398E" }), /* @__PURE__ */ b.createElement("path", { d: "M20.7989 0.872752C20.7342 0.840429 20.6373 0.840429 20.5726 0.808105L13.4292 9.60002L13.2676 10.1495L20.7989 0.872752Z", fill: "#2F2482" }), /* @__PURE__ */ b.createElement("path", { d: "M20.2825 1.16367C17.7936 0.517208 15.2724 0.517208 12.9128 1.09903L12.6865 0.711147C15.2724 0.0646825 18.0522 0.0646825 20.7997 0.84044L20.2825 1.16367Z", fill: "url(#paint12_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M5.1875 26.893C7.09457 28.8647 9.51881 30.3193 12.1693 31.0627L10.6824 19.2001L5.1875 26.893Z", fill: "#2B2B85" }), /* @__PURE__ */ b.createElement("path", { d: "M12.1367 31.0627L10.6498 19.2001L10.5205 19.7496L11.9427 30.9981C12.0074 31.0304 12.072 31.0304 12.1367 31.0627Z", fill: "#24236F" }), /* @__PURE__ */ b.createElement("path", { d: "M5.31679 27.0223L10.4885 19.7496L10.6178 19.2001L5.1875 26.893L5.31679 27.0223Z", fill: "#5B549F" }), /* @__PURE__ */ b.createElement("path", { d: "M5.1875 26.8929C7.09457 28.8646 9.51881 30.3192 12.1693 31.0626L11.8784 30.5454C9.48649 29.802 7.35316 28.4768 5.57538 26.699L5.1875 26.8929Z", fill: "url(#paint13_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M10.6502 19.2001L5.18757 26.893C3.28784 24.898 1.93029 22.4499 1.24414 19.7819L10.6502 19.2001Z", fill: "url(#paint14_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M5.18701 26.893L10.6496 19.2001L10.2294 19.4263L5.02539 26.7314C5.09004 26.7637 5.12236 26.8284 5.18701 26.893Z", fill: "#B0AAD4" }), /* @__PURE__ */ b.createElement("path", { d: "M1.27646 19.9758L10.1977 19.4263L10.6179 19.2L1.24414 19.7818C1.24414 19.8465 1.27646 19.9111 1.27646 19.9758Z", fill: "#DAD8ED" }), /* @__PURE__ */ b.createElement("path", { d: "M1.72899 19.9435C2.37545 22.3354 3.60374 24.5334 5.28454 26.3758L5.18757 26.893C3.28784 24.8979 1.93029 22.4499 1.24414 19.7819L1.72899 19.9435Z", fill: "url(#paint15_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M10.6503 19.2L1.2442 19.7818C0.59774 17.196 0.59774 14.4162 1.3735 11.6687L10.6503 19.2Z", fill: "#E53121" }), /* @__PURE__ */ b.createElement("path", { d: "M1.24336 19.7819L10.6494 19.2001L10.0999 19.0384L1.17871 19.5556C1.21103 19.6203 1.21103 19.6849 1.24336 19.7819Z", fill: "#CA2D0A" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.59931 19.5232C1.01749 17.1636 1.01749 14.6424 1.66396 12.1535L1.66322 12.1522L10.1003 19.0384L10.6498 19.2L1.37305 11.6364C1.35689 11.6687 1.34881 11.7091 1.34073 11.7495C1.33976 11.7543 1.33879 11.7592 1.33781 11.764C1.33037 11.7914 1.323 11.8188 1.3157 11.8462C1.31346 11.8519 1.31104 11.8573 1.3084 11.8626L1.31082 11.8646C0.626494 14.4479 0.583492 17.1749 1.21143 19.7495L1.59931 19.5232ZM1.31082 11.8646L1.66322 12.1522L1.37305 11.6364C1.36113 11.6789 1.34938 11.7214 1.33781 11.764C1.33193 11.7929 1.32555 11.8213 1.3157 11.8462C1.31407 11.8523 1.31244 11.8585 1.31082 11.8646Z", fill: "#ED6F50" }), /* @__PURE__ */ b.createElement("path", { d: "M27.3931 27.2809C29.3648 25.3738 30.8194 22.9496 31.5628 20.2991L19.7002 21.7859L27.3931 27.2809Z", fill: "url(#paint16_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M31.5628 20.2991L19.7002 21.7859L20.2497 21.9152L31.4982 20.493C31.5305 20.4607 31.5305 20.3637 31.5628 20.2991Z", fill: "#7B73B3" }), /* @__PURE__ */ b.createElement("path", { d: "M27.5224 27.1192L20.2497 21.9475L19.7002 21.8182L27.3931 27.2809C27.4254 27.2162 27.4901 27.1516 27.5224 27.1192Z", fill: "#D1CEE8" }), /* @__PURE__ */ b.createElement("path", { d: "M27.3932 27.2809C29.3002 25.4385 30.7871 23.0465 31.5629 20.2991L31.0457 20.59C30.3022 22.9819 28.977 25.1152 27.1992 26.893L27.3932 27.2809Z", fill: "#655EA5" }), /* @__PURE__ */ b.createElement("path", { d: "M19.7002 21.7859L27.3931 27.2485C25.4214 29.1556 22.9648 30.5132 20.282 31.1919L19.7002 21.7859Z", fill: "url(#paint17_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7002 21.7859L27.3931 27.2808C27.3608 27.297 27.3285 27.3212 27.2962 27.3455C27.2638 27.3697 27.2315 27.394 27.1992 27.4101L19.9265 22.2061L19.7002 21.7859ZM19.9265 22.2384L20.476 31.1596C20.4113 31.1596 20.3467 31.1919 20.282 31.2243L19.7002 21.8182L19.9265 22.2384Z", fill: "#E53121" }), /* @__PURE__ */ b.createElement("path", { d: "M20.4438 30.7394C22.8358 30.0929 25.0337 28.8646 26.8762 27.1838L27.3933 27.2808C25.4216 29.1879 22.9651 30.5455 20.2822 31.2242L20.4438 30.7394Z", fill: "url(#paint18_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M19.7003 21.7859L20.2821 31.1919C17.6962 31.8384 14.9164 31.8384 12.1689 31.0627L19.7003 21.7859Z", fill: "url(#paint19_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("path", { d: "M20.2819 31.1919L19.7001 21.7859L19.5384 22.3354L20.0879 31.2566C20.1203 31.2243 20.2172 31.2243 20.2819 31.1919Z", fill: "#F5B0AC" }), /* @__PURE__ */ b.createElement("path", { d: "M12.1367 31.0627L12.363 31.1273L19.5387 22.3354L19.7004 21.7859L12.1367 31.0627Z", fill: "#FAD9D5" }), /* @__PURE__ */ b.createElement("path", { d: "M12.6539 30.7718C15.1428 31.4183 17.664 31.4183 20.0236 30.8364L20.2499 31.2243C17.567 31.9031 14.7872 31.8385 12.1367 31.095L12.6539 30.7718Z", fill: "url(#paint20_linear_4744_76622)" }), /* @__PURE__ */ b.createElement("defs", null, /* @__PURE__ */ b.createElement("linearGradient", { id: "paint0_linear_4744_76622", x1: 21.4722, y1: 16.9565, x2: 24.9592, y2: 20.8779, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#E53121" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#C22C1A" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint1_linear_4744_76622", x1: -2.7705, y1: 17.9039, x2: 5.9802, y2: 27.7448, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#DCDAEE" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#8F88C0" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint2_linear_4744_76622", x1: 27.8795, y1: 1.55713, x2: 19.7742, y2: 0.80487, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#7B73B3" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#C6C2E2" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint3_linear_4744_76622", x1: 31.269, y1: 2.76424, x2: 27.0828, y2: -3.42336, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#6C62A8" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#CBCAE6" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint4_linear_4744_76622", x1: 19.6708, y1: 8.77648, x2: 22.7217, y2: 16.6767, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#E53121" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#A62714" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint5_linear_4744_76622", x1: 25.7538, y1: 8.73997, x2: 31.982, y2: 12.2225, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#E84D2C" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#811F08" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint6_linear_4744_76622", x1: 20.3773, y1: 12.6213, x2: 22.9184, y2: 22.9664, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F3F2F9" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#BBB7DB" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint7_linear_4744_76622", x1: 30.3832, y1: 25.0398, x2: 32.6501, y2: 25.0505, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "white" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#BBB7DB" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint8_linear_4744_76622", x1: 0.910215, y1: 11.0285, x2: 8.22033, y2: 17.0426, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#FFF098" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#FFD530" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint9_linear_4744_76622", x1: 4.76751, y1: 8.44531, x2: 13.9734, y2: 10.668, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F4A286" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#E53121" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint10_linear_4744_76622", x1: 9.17672, y1: 6.88402, x2: 12.7704, y2: 0.457074, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F4A286" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#E53121" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint11_linear_4744_76622", x1: 11.5232, y1: 8.7849, x2: 19.1729, y2: 10.2426, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#4464AC" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#1D3584" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint12_linear_4744_76622", x1: 12.7744, y1: 1.20321, x2: 20.9005, y2: 1.20321, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#4464AC" }), /* @__PURE__ */ b.createElement("stop", { offset: 0.373, stopColor: "#2F4B97" }), /* @__PURE__ */ b.createElement("stop", { offset: 0.728, stopColor: "#223B89" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#1D3584" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint13_linear_4744_76622", x1: 3.05145, y1: 30.1315, x2: 9.12302, y2: 34.5888, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#5B62A2" }), /* @__PURE__ */ b.createElement("stop", { offset: 0.152, stopColor: "#4C579A" }), /* @__PURE__ */ b.createElement("stop", { offset: 0.482, stopColor: "#31438C" }), /* @__PURE__ */ b.createElement("stop", { offset: 0.776, stopColor: "#213783" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#1B3380" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint14_linear_4744_76622", x1: 1.13342, y1: 19.532, x2: 1.593, y2: 27.3849, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "white" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#DAD8ED" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint15_linear_4744_76622", x1: -0.14819, y1: 27.5117, x2: 5.64174, y2: 28.0476, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "white" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#D1CEE8" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint16_linear_4744_76622", x1: 18.0522, y1: 24.3765, x2: 25.8357, y2: 30.7209, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#D1CEE8" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#7B73B3" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint17_linear_4744_76622", x1: 16.1203, y1: 24.7527, x2: 22.335, y2: 31.9534, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#E53121" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#B02916" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint18_linear_4744_76622", x1: 23.9574, y1: 33.5421, x2: 27.5508, y2: 27.1153, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#E53121" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#9D2511" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint19_linear_4744_76622", x1: 13.2739, y1: 29.17, x2: 19.377, y2: 33.2889, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F5B0AC" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#EF8495" })), /* @__PURE__ */ b.createElement("linearGradient", { id: "paint20_linear_4744_76622", x1: 12.2502, y1: 31.7345, x2: 20.3756, y2: 31.7345, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ b.createElement("stop", { stopColor: "#F5B0AC" }), /* @__PURE__ */ b.createElement("stop", { offset: 1, stopColor: "#EE788F" })))), Yh = (e) => /* @__PURE__ */ b.createElement("svg", { viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.0531 5.25976C30.9305 8.41561 32.5 12.4481 32.5 16.7436C32.5 19.8994 31.4537 23.0553 29.5354 25.5098C27.8787 27.0878 25.6117 27.9644 23.2575 27.8767C19.5954 27.7014 16.1076 26.1235 13.579 23.4936C11.3992 21.302 9.8297 18.4968 9.04496 15.5163C8.08583 15.9546 7.2139 16.5682 6.51635 17.3572C5.38283 18.3215 4.68529 19.8118 4.59809 21.302C4.59809 22.091 4.85967 22.7923 5.38283 23.3183C6.25477 24.1072 7.38828 24.5455 8.60899 24.4579C9.8297 24.4579 11.1376 24.1072 12.2711 23.6689C13.1431 24.6332 14.1894 25.5098 15.3229 26.2988C13.8406 27.0001 12.1839 27.3507 10.5272 27.3507C9.65531 27.3507 8.78338 27.1754 7.99864 26.9124C11.0504 29.1917 14.7125 30.4189 18.549 30.3313C21.0777 30.3313 23.5191 29.7176 25.6989 28.4904L25.8733 29.0163C23.0831 30.9449 19.8569 31.9969 16.4564 31.9969C12.0967 32.0845 7.99864 30.3313 4.85967 27.3507C2.94142 25.5975 1.8079 23.1429 1.72071 20.5131C1.8951 17.8832 3.02861 15.4286 4.94687 13.5877C6.77793 11.7468 9.04496 10.4319 11.5736 9.81821C14.5381 8.85393 17.6771 8.85393 20.6417 9.81821C20.8161 8.15262 20.4673 6.39937 19.6826 4.90911C19.0722 3.68183 17.8515 2.8052 16.4564 2.71754C15.5845 2.71754 14.7997 3.15585 14.1894 3.76949C12.9687 5.1721 12.1839 6.83769 12.0095 8.6786C10.7016 8.94159 9.48093 9.3799 8.26022 9.99354C8.26022 9.3799 8.34741 8.76626 8.5218 8.15263C9.04496 6.31171 10.0041 4.55846 11.3992 3.24352C9.39373 4.12014 7.64986 5.43508 6.08038 6.92535C3.02861 9.81821 1.37193 13.763 1.37193 17.9708H0.587193C0.5 17.2695 0.5 16.5682 0.5 15.8669C0.5 11.6591 2.24387 7.62665 5.20845 4.73378C7.82425 1.84092 11.5736 0.0876626 15.4973 0C18.6362 0 21.5136 1.75325 22.9959 4.55846C24.1294 6.5747 24.6526 8.85393 24.6526 11.1332C24.6526 12.5358 24.4782 13.8507 24.1294 15.1656C23.4319 18.1462 21.8624 20.8637 19.6826 23.0553C21.0777 24.0196 22.7343 24.5455 24.391 24.6332C25.5245 24.6332 26.5708 24.2825 27.4428 23.5812C28.0531 23.0553 28.4019 22.2663 28.4019 21.4773C28.3147 19.8994 27.6172 18.4092 26.4837 17.3572C26.0477 16.9189 25.6117 16.4806 25.0886 16.1299C25.4373 14.815 25.6989 13.5 25.7861 12.1851C26.3965 12.4481 26.8324 12.8864 27.2684 13.4124C28.5763 14.815 29.5354 16.4806 30.0586 18.3215C30.1458 17.4449 30.1458 16.3929 30.1458 15.7793C30.0586 11.4838 28.4019 7.45132 25.4373 4.38313C24.5654 3.50651 23.6063 2.71754 22.5599 2.1039L22.9959 1.4026C24.9142 2.36689 26.5708 3.68183 28.0531 5.25976ZM16.3692 20.6007C18.2003 18.7598 19.5954 16.5682 20.3801 14.1137C18.985 13.763 17.5027 13.5 16.0204 13.5C14.9741 13.5 13.9278 13.5877 12.8815 13.8507C13.4918 16.3929 14.6253 18.6721 16.3692 20.6007Z", fill: "#00937B" })), qf = "transaction_form";
function jk({
  setView: e
}) {
  var N;
  const n = dt(), [t, r] = K(), {
    state: o,
    actions: s
  } = ue(), {
    t: a
  } = pe(), {
    selectedBank: i,
    caseId: c,
    transactions: l
  } = o, {
    formState: u,
    control: d,
    register: f,
    watch: p,
    handleSubmit: m
  } = Sr({
    mode: "onBlur"
  }), {
    consent: h,
    connections: y
  } = l, {
    isValid: C,
    errors: v
  } = u, w = y.length > 0, {
    bank: x
  } = p(), [D] = K(h), k = [{
    id: 1,
    title: a("text_664e70c53858d7008976cc45"),
    icon: $h,
    code: "RABOBANK"
  }, {
    id: 2,
    title: a("text_664e70c53858d7008976cc46"),
    icon: Rh,
    code: "ABN"
  }, {
    id: 3,
    title: a("text_664e70c53858d7008976cc47"),
    icon: Ih,
    code: "ASN"
  }, {
    id: 4,
    title: a("text_664e70c53858d7008976cc48"),
    icon: Bk,
    code: "BUNQ"
  }, {
    id: 5,
    title: a("text_664e70c53858d7008976cc49"),
    icon: Fh,
    code: "ING"
  }, {
    id: 6,
    title: a("text_664e70c53858d7008976cc4a"),
    icon: Vh,
    code: "KNAB"
  }, {
    id: 7,
    title: a("text_664e70c53858d7008976cc4b"),
    icon: Bh,
    code: "REGIOBANK"
  }, {
    id: 8,
    title: a("text_664e70c53858d7008976cc4c"),
    icon: jh,
    code: "SNS"
  }, {
    id: 9,
    title: a("text_664e70c53858d7008976cc4d"),
    icon: Yh,
    code: "TRIODOS"
  }], _ = () => {
    s({
      type: "set_selected_bank"
    }), e("overview");
  }, M = () => {
    s({
      type: "set_page",
      payload: "prev"
    });
  }, T = async () => {
    const I = "https://public-production-partner-return.s3.eu-west-1.amazonaws.com/index.html";
    if (!c)
      throw new Yf("caseIdNotFound");
    if (!i)
      throw new Error("No valid bank has been selected");
    const O = {
      returnUrl: I,
      caseId: c,
      bankToConnect: i
    };
    s({
      type: "set_is_loading",
      page: "transactions",
      payload: !0
    }), r(void 0);
    const $ = window.open();
    if ($)
      try {
        await Ek({
          transactionUsageConsent: !0
        }), s({
          type: "set_consent"
        });
        const {
          data: j
        } = await wk(O), {
          connectUrl: Y,
          customer: F
        } = j, V = F;
        $.location = Y, s({
          type: "set_customer_id",
          payload: V
        }), s({
          type: "set_transactions_tab",
          payload: $
        }), e("get_transactions");
      } catch (j) {
        if ($.close(), j instanceof Yf) {
          r(j.message);
          return;
        }
        const Y = un(j);
        r(Y);
      } finally {
        s({
          type: "set_is_loading",
          page: "transactions",
          payload: !1
        });
      }
  };
  return W(() => {
    x && s({
      type: "set_selected_bank",
      payload: x.code
    });
  }, [x]), /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ P(It, {
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: a("text_6600cda50861cc0108cb6d10")
        }), /* @__PURE__ */ P(oe, {
          weight: "light",
          element: "span",
          children: [a("text_6600cda50861cc0108cb6d11"), /* @__PURE__ */ g(Oh, {
            className: "ml-1 mb-0.5",
            name: "has_expenses",
            children: a("text_6600cda50861cc0108cb6d16")
          })]
        })]
      }), /* @__PURE__ */ P("form", {
        className: "flex flex-col gap-6 w-full",
        id: qf,
        onSubmit: m(T),
        children: [/* @__PURE__ */ g(_u, {
          label: a("text_664e70c53858d7008976cc43"),
          placeholder: a("text_664e70c53858d7008976cc44"),
          control: d,
          name: "bank",
          optionHeight: "md",
          error: (N = v.bank) == null ? void 0 : N.message,
          options: k,
          displayValue: (I) => I.title,
          rules: {
            required: a(pt.required)
          }
        }), !D && /* @__PURE__ */ P(Zo, {
          children: [/* @__PURE__ */ g(no, {
            className: "w-full"
          }), /* @__PURE__ */ P("div", {
            className: "flex flex-col self-center gap-2",
            children: [/* @__PURE__ */ g(za, {
              ...f("transactions", {
                required: a(pt.required)
              }),
              children: a("text_6600cda50861cc0108cb6d12")
            }), /* @__PURE__ */ g(za, {
              ...f("privacy", {
                required: a(pt.required)
              }),
              children: a("text_6600cda50861cc0108cb6d13")
            }), /* @__PURE__ */ g(za, {
              ...f("automation", {
                required: a(pt.required)
              }),
              children: a("text_6600cda50861cc0108cb6d14")
            })]
          })]
        })]
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!t,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ P("div", {
          className: "flex w-full gap-2",
          children: [/* @__PURE__ */ g(Re, {
            className: "w-fit",
            disabled: n,
            name: "back",
            onClick: w ? _ : M,
            variant: "outline",
            children: a("text_665913bd720e46011b6df043")
          }), /* @__PURE__ */ g(Re, {
            className: "w-full shadow-md",
            name: "submit",
            disabled: !C || !i,
            isLoading: n,
            onClick: T,
            form: qf,
            children: a("text_665913bd720e46011b6df044")
          })]
        }), /* @__PURE__ */ g(jt, {
          error: t && a(t),
          className: "text-center",
          name: "add_transaction_error"
        })]
      })
    })]
  });
}
const Yk = {
  RABO: "RABOBANK",
  ING: "ING",
  ABN: "ABN",
  KNAB: "KNAB",
  ASNB: "ASN",
  SNSB: "SNS",
  RBRB: "REGIOBANK",
  TRIO: "TRIODOS",
  BUNQ: "BUNQ"
};
function Hk({
  setView: e
}) {
  const [n, t] = K(1), {
    t: r
  } = pe(), {
    state: o,
    actions: s
  } = ue(), {
    customerId: a
  } = o, {
    requester: i,
    transactionsTab: c,
    selectedBank: l
  } = o, {
    kvkNumber: u
  } = i;
  let d;
  const f = vi(il, l) ? il[l] : "", p = [{
    id: 1,
    header: r("text_6600cda50861cc0108cb6d2e"),
    text: r("text_6600cda50861cc0108cb6d2f", {
      bankName: f
    }),
    ref: ie(null)
  }, {
    id: 2,
    header: r("text_6600cda50861cc0108cb6d31"),
    text: r("text_6600cda50861cc0108cb6d32"),
    ref: ie(null)
  }, {
    id: 3,
    header: r("text_6600cda50861cc0108cb6d34"),
    text: r("text_6600cda50861cc0108cb6d35"),
    ref: ie(null)
  }, {
    id: 4,
    header: r("text_6600cda50861cc0108cb6d37"),
    text: r("text_6600cda50861cc0108cb6d38"),
    ref: ie(null)
  }], m = () => {
    s({
      type: "show_rejection",
      payload: "TIMEOUT"
    }), s({
      type: "set_is_loading",
      page: "transactions",
      payload: !1
    });
  }, h = (x) => {
    s({
      type: "show_rejection",
      payload: x
    }), s({
      type: "set_is_loading",
      page: "transactions",
      payload: !1
    });
  }, y = async ({
    bank: x,
    accounts: D,
    sub: k
  }) => {
    try {
      const {
        data: _
      } = await _k({
        username: k,
        bankName: x
      }), {
        psd2StatusV1: M
      } = _;
      if (M === "STORAGE") {
        const N = Yk[x];
        if (!vi(il, N))
          throw new Error(`unsupported bank used: ${N}`);
        const O = {
          bankName: N,
          accounts: D,
          connectionId: d
        };
        return t(($) => $ + 1), s({
          type: "add_bank_account",
          payload: O
        }), s({
          type: "set_offers",
          payload: []
        }), await Jv(1500), e("overview"), s({
          type: "set_is_loading",
          page: "transactions",
          payload: !1
        }), !0;
      }
    } catch {
      return h("TRANSACTION_STATUS"), !0;
    }
    return !1;
  }, C = async () => {
    if (!u)
      throw new Error("kvk number not available when getting transactions");
    try {
      const {
        data: x
      } = await Dk({
        connectionId: d,
        kvkNumber: u
      }), {
        accounts: D
      } = x;
      if (D.every((_) => _.matchState === "NO_MATCH")) {
        h("TRANSACTIONS_NO_MATCHES");
        return;
      }
      if (D.length === 0) {
        h("CONSENT_DECLINED");
        return;
      }
      t((_) => _ + 1), Ds({
        delay: 2e3,
        limit: 150,
        fn: () => y(x),
        callback: m
      });
    } catch {
      h("GET_TRANSACTIONS");
    }
  }, v = async () => {
    try {
      const {
        data: x
      } = await xk({
        connectionId: d
      }), {
        finished: D
      } = x;
      if (!D)
        return !1;
      c == null || c.close(), await C();
    } catch {
      h("CREATE_CONNECTION");
    }
    return !0;
  }, w = async () => {
    try {
      if (!a)
        throw new Error("customer id not available");
      const {
        data: x
      } = await Sk({
        customerId: a
      }), {
        connections: D
      } = x;
      if (!D || D.length === 0)
        return !1;
      const [k] = D.sort((_, M) => {
        const T = new Date(_.created_at);
        return new Date(M.created_at).valueOf() - T.valueOf();
      });
      if (!k)
        throw new Error("no connections found");
      d = k.id, t((_) => _ + 1), Ds({
        limit: 30 * 5,
        delay: 2e3,
        fn: v,
        callback: m
      });
    } catch {
      h("NO_CONNECTION_ID");
    }
    return !0;
  };
  return W(() => {
    const x = Ds({
      limit: 150,
      delay: 2e3,
      fn: w,
      callback: m
    });
    return s({
      type: "set_is_loading",
      page: "transactions",
      payload: !0
    }), () => clearInterval(x);
  }, []), /* @__PURE__ */ g(At, {
    children: /* @__PURE__ */ P(Nt, {
      className: "pb-6",
      children: [/* @__PURE__ */ P(It, {
        className: "gap-6 pb-6 border-b border-border/40 z-10",
        children: [/* @__PURE__ */ g(Ee, {
          element: "h1",
          children: r("text_6600cda50861cc0108cb6d2b")
        }), /* @__PURE__ */ P(Li, {
          children: [/* @__PURE__ */ g(Uo, {
            className: "w-6 h-6 fill-foreground"
          }), /* @__PURE__ */ g(_h, {
            children: r("text_6600cda50861cc0108cb6d2c")
          }), /* @__PURE__ */ g(Ti, {
            children: r("text_6600cda50861cc0108cb6d2d")
          })]
        })]
      }), /* @__PURE__ */ g(ku, {
        activeId: n,
        showLoader: n !== p.length,
        steps: p,
        className: "w-full pt-6 overflow-y-clip"
      })]
    })
  });
}
const Uk = 1e3, Wk = 100;
function Zk({
  seconds: e
}) {
  const {
    state: n
  } = ue(), {
    selectedBank: t
  } = n, [r, o] = K(0), [s, a] = K("");
  return W(() => {
    const c = Ds({
      limit: e,
      delay: Uk,
      fn: () => {
        if (!t)
          return !0;
        const l = 100 / e;
        return o((u) => Math.min(u + l, Wk)), !1;
      }
    });
    return () => clearInterval(c);
  }, []), {
    percentage: r,
    setProgressWarning: a,
    progressWarning: s
  };
}
const Kk = {
  RABOBANK: $h,
  ING: Fh,
  ABN: Rh,
  KNAB: Vh,
  ASN: Ih,
  SNS: jh,
  REGIOBANK: Bh,
  TRIODOS: Yh
}, Qf = xe(({
  iban: e,
  clientName: n,
  bankName: t,
  className: r,
  percentage: o = 0
}, s) => {
  const {
    state: a,
    actions: i
  } = ue(), {
    selectedBank: c
  } = a, l = !!n, u = Kk[t], d = c === t, f = o === 100, [p, m] = K(d), h = () => {
    m(!1), i({
      type: "set_is_loading",
      page: "transactions",
      payload: !1
    });
  };
  return W(() => {
    i({
      type: "set_is_loading",
      page: "transactions",
      payload: d
    });
  }, []), W(() => {
    o === 100 && i({
      type: "set_selected_bank"
    });
  }, [o]), /* @__PURE__ */ P("div", {
    ref: s,
    className: te("relative flex items-center w-full px-4 py-5 border rounded border-input", r),
    children: [/* @__PURE__ */ g(kt, {
      onExitComplete: h,
      children: d && /* @__PURE__ */ g(he.div, {
        className: "absolute inset-0 h-1.5 bg-success",
        transition: {
          duration: 1,
          ease: "easeInOut"
        },
        animate: {
          width: `${o}%`,
          opacity: f ? 0 : 1
        },
        initial: {
          width: 0
        },
        exit: {
          transition: {
            delay: 1.5
          },
          opacity: 0
        }
      })
    }), /* @__PURE__ */ P(he.div, {
      className: "flex items-center gap-4",
      transition: Ce,
      animate: {
        opacity: p ? 0.35 : 1
      },
      children: [u && /* @__PURE__ */ g(u, {
        className: "w-10 h-8 pb-1"
      }), /* @__PURE__ */ P("div", {
        className: "flex flex-col truncate flex-1",
        children: [l && /* @__PURE__ */ g(oe, {
          size: "sm",
          className: "truncate",
          children: n
        }), /* @__PURE__ */ g(oe, {
          className: "truncate font-thin",
          size: "sm",
          children: eb({
            iban: e
          })
        })]
      })]
    })]
  });
}), zk = xe(({
  onClick: e
}, n) => {
  const {
    t
  } = pe(), r = dt();
  return /* @__PURE__ */ P("button", {
    className: te("flex items-center w-full gap-4 px-4 py-5", "text-foreground text-sm font-thin text-left", "border border-dashed rounded border-input", "disabled:bg-input-disabled disabled:text-input-disabled-foreground", !r && "hover:bg-primary/10"),
    ref: n,
    disabled: r,
    "aria-label": "add_account_button",
    type: "button",
    onClick: e,
    children: [/* @__PURE__ */ g(W6, {
      className: te("p-[5px] size-6 mx-2 bg-secondary rounded-full text-secondary-foreground", r && "opacity-20")
    }), t("text_6600cda50861cc0108cb6d40")]
  });
}), Gk = {
  not_enough_transactions: "INSUFFICIENT_TRANSACTIONS",
  missing_transaction_files: "INSUFFICIENT_TRANSACTIONS",
  transactions_not_recent: "TRANSACTIONS_NOT_RECENT",
  no_transactions_uploaded: "INSUFFICIENT_TRANSACTIONS"
}, Xf = "overview_form";
function qk({
  setView: e
}) {
  const {
    t: n
  } = pe(), {
    percentage: t
  } = Zk({
    seconds: 1
  }), [r, o] = K(), {
    state: s,
    actions: a
  } = ue(), {
    register: i,
    formState: c,
    handleSubmit: l
  } = Sr({
    mode: "onChange"
  }), {
    isValid: u
  } = c, {
    transactions: d,
    selectedBank: f,
    offers: p
  } = s, m = dt(), {
    connections: h
  } = d, y = h.flatMap((_) => _.accounts.map((M) => ({
    bankName: _.bankName,
    ...M
  }))), C = y.filter(({
    matchState: _
  }) => _ === "MATCH" || _ === "COULD_NOT_MATCH"), v = y.filter(({
    matchState: _
  }) => _ === "NO_MATCH"), w = y.length > 0, x = u && w && !m && !f, D = () => {
    a({
      type: "set_page",
      payload: "prev"
    });
  }, k = async () => {
    var M, T;
    if (p.length > 0) {
      a({
        type: "set_page",
        payload: "next"
      });
      return;
    }
    a({
      type: "set_is_loading",
      page: "transactions",
      payload: !0
    });
    try {
      await Mk();
      const {
        data: N
      } = await hv(), {
        eligible: I,
        evaluationCode: O
      } = N, $ = Qv[O];
      if ($) {
        a({
          type: "show_rejection",
          payload: $
        });
        return;
      }
      if (!I) {
        a({
          type: "show_rejection",
          payload: "GENERIC"
        });
        return;
      }
      a({
        type: "set_page",
        payload: "next"
      });
    } catch (N) {
      if (!Zr(N))
        return;
      const I = (T = (M = N == null ? void 0 : N.response) == null ? void 0 : M.data) == null ? void 0 : T.code, O = Gk[I];
      O && a({
        type: "show_rejection",
        payload: O
      });
      const $ = un(N);
      o($);
    } finally {
      a({
        type: "set_is_loading",
        page: "transactions",
        payload: !1
      });
    }
  };
  return /* @__PURE__ */ P(At, {
    children: [/* @__PURE__ */ P(Nt, {
      className: "gap-6",
      children: [/* @__PURE__ */ g(It, {
        children: /* @__PURE__ */ g(Ee, {
          element: "h1",
          children: n("text_6600cda50861cc0108cb6d3f")
        })
      }), /* @__PURE__ */ g(zk, {
        onClick: () => e("add_account")
      }), C.map((_) => {
        const {
          bankName: M,
          iban: T,
          clientName: N
        } = _;
        return /* @__PURE__ */ g(Qf, {
          clientName: N,
          iban: T,
          bankName: M,
          percentage: f === M ? t : 0
        }, T);
      }), v.length > 0 && /* @__PURE__ */ g(no, {
        className: "w-full"
      }), v.map((_) => {
        const {
          bankName: M,
          iban: T,
          clientName: N
        } = _;
        return /* @__PURE__ */ P(Us, {
          children: [/* @__PURE__ */ P("div", {
            className: "flex items-center w-full gap-1",
            children: [/* @__PURE__ */ g(oe, {
              weight: "normal",
              size: "md",
              element: "h3",
              color: "secondary",
              children: n("text_664efdb168227f00e261b7cb")
            }), /* @__PURE__ */ g(Oh, {
              name: "has_expenses",
              className: "mb-px",
              children: n("text_664efdb168227f00e261b7ce")
            })]
          }), /* @__PURE__ */ g(Qf, {
            clientName: N,
            iban: T,
            bankName: M,
            percentage: 0,
            className: "opacity-30"
          })]
        }, T);
      }), /* @__PURE__ */ g("form", {
        className: "flex flex-col gap-2 w-full",
        id: Xf,
        onSubmit: l(k),
        children: /* @__PURE__ */ g(za, {
          ...i("confirm", {
            required: n(pt.required)
          }),
          children: n("text_6600cda50861cc0108cb6d43")
        })
      })]
    }), /* @__PURE__ */ g(zt, {
      showBlur: !!r,
      children: /* @__PURE__ */ P(he.div, {
        transition: Ce,
        layout: "position",
        className: "flex flex-col gap-2 w-full",
        children: [/* @__PURE__ */ P("div", {
          className: "flex w-full gap-2",
          children: [/* @__PURE__ */ g(Re, {
            className: "w-fit",
            disabled: m,
            name: "back",
            onClick: D,
            variant: "outline",
            children: n("text_665913bd720e46011b6df045")
          }), /* @__PURE__ */ g(Re, {
            className: "w-full shadow-md",
            name: "submit",
            type: "submit",
            form: Xf,
            disabled: !x,
            isLoading: m,
            children: n("text_665913bd720e46011b6df046")
          })]
        }), /* @__PURE__ */ g(jt, {
          error: r && n(r),
          className: "text-center",
          name: "transaction_overview_error"
        })]
      })
    })]
  });
}
const Qk = {
  overview: qk,
  get_transactions: Hk,
  add_account: jk
};
function Xk() {
  const {
    state: e
  } = ue(), {
    transactions: n
  } = e, {
    connections: t
  } = n, s = t.flatMap((u) => u.accounts).length > 0 ? "overview" : "add_account", [a, i] = K(s), c = Qk[a], {
    onTransitionEnd: l
  } = Ui(a);
  return /* @__PURE__ */ g(kt, {
    mode: "wait",
    children: /* @__PURE__ */ g(he.div, {
      className: "flex w-full flex-1",
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: Ce,
      onAnimationComplete: l,
      children: /* @__PURE__ */ g(c, {
        setView: i
      })
    }, a)
  });
}
const Jk = {
  splash: bk,
  company: XC,
  contact: nw,
  faq: Bw,
  entry: sw,
  invoice: WM,
  offer: tk,
  success: Ck,
  transactions: Xk,
  rejection: vk
};
function eA({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), t = () => {
    e(!1);
  };
  return /* @__PURE__ */ P(he.div, {
    className: "flex flex-col items-center gap-4 p-4 text-center",
    layout: "position",
    children: [/* @__PURE__ */ g(Ee, {
      element: "h2",
      size: "lg",
      children: n("text_664d810c6e94c60051dbb3e2")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: n("text_664d810c6e94c60051dbb3e3")
    }), /* @__PURE__ */ g(Re, {
      name: "start_new_session",
      className: "mt-2 w-fit",
      onClick: t,
      children: n("text_664d810c6e94c60051dbb3e4")
    })]
  });
}
function tA(e) {
  if (!["name", "surname", "email", "phoneNumber"].every((s) => s in e && e[s] != null))
    return !1;
  const {
    email: r,
    phoneNumber: o
  } = e;
  return !(r && !ru(r) || o && !ou(o));
}
function nA() {
  const {
    state: e,
    actions: n
  } = ue(), t = dt(["automate_eligibility"]), {
    requester: r
  } = e, {
    kvkNumber: o
  } = r, [s, a] = K([]), [i, c] = K(!1), [l, u] = K(!1), {
    name: d,
    surname: f,
    email: p,
    phoneNumber: m
  } = r;
  return W(() => {
    if (!o)
      return;
    const h = [];
    if (n({
      type: "set_is_loading",
      page: "automate_contact",
      payload: !0
    }), !kn || !n4.includes(kn)) {
      u(!0);
      return;
    }
    if (d || h.push("NAME"), f || h.push("SURNAME"), (!p || !ru(p)) && h.push("EMAIL"), (!m || !ou(m)) && h.push("PHONENUMBER"), Object.keys(h).length > 0 && a(h), !tA(r)) {
      u(!0);
      return;
    }
    (async () => {
      try {
        await R6(r), n({
          type: "set_contact_is_added"
        });
      } catch (v) {
        console.warn(v);
      } finally {
        u(!0);
      }
    })();
  }, [t]), W(() => {
    l && (n({
      type: "set_is_loading",
      page: "automate_contact",
      payload: !1
    }), s.length !== 0 && c(!0));
  }, [l]), /* @__PURE__ */ g(qr, {
    onOpenChange: c,
    open: i,
    children: /* @__PURE__ */ g(Gr, {
      children: /* @__PURE__ */ g(eA, {
        setIsOpen: c
      })
    })
  });
}
function rA({
  kvkNumber: e
}) {
  const {
    actions: n
  } = ue(), t = dt(["authentication"]), [r, o] = K(), [s, a] = K(!1), [i, c] = K(), [l, u] = K(!1), [d, f] = K(), {
    companies: p,
    error: m
  } = nu({
    searchValue: d
  }), h = async () => {
    if (!e || !i)
      return;
    const {
      title: y
    } = i;
    try {
      const {
        data: C
      } = await O6({
        kvkNumber: e
      }), {
        eligible: v,
        nonEligibilityReasons: w,
        newToTheBank: x
      } = C;
      if (v)
        n({
          type: "set_requester",
          payload: {
            kvkNumber: e,
            company: y,
            newToTheBank: x
          }
        });
      else {
        const D = w == null ? void 0 : w.find(P6);
        o(D), a(!0);
      }
    } catch (C) {
      console.warn(C);
    } finally {
      n({
        type: "set_is_loading",
        page: "automate_eligibility",
        payload: !1
      });
    }
  };
  return W(() => {
    m && n({
      type: "set_is_loading",
      page: "automate_eligibility",
      payload: !1
    });
  }, [m]), W(() => {
    i && h();
  }, [i]), W(() => {
    if (!d)
      return;
    const [y] = p, C = !!(y != null && y.error);
    if (C && u(!0), !y || C) {
      n({
        type: "set_is_loading",
        page: "automate_eligibility",
        payload: !1
      });
      return;
    }
    c(y);
  }, [p]), W(() => {
    t || !e || f(e);
  }, [t]), W(() => {
    e || n({
      type: "set_is_loading",
      page: "automate_eligibility",
      payload: !1
    });
  }, []), /* @__PURE__ */ P(Zo, {
    children: [/* @__PURE__ */ g(qr, {
      onOpenChange: a,
      open: s,
      children: /* @__PURE__ */ g(Gr, {
        children: /* @__PURE__ */ g(g3, {
          setIsOpen: a,
          error: r
        })
      })
    }), /* @__PURE__ */ g(qr, {
      onOpenChange: u,
      open: l,
      children: /* @__PURE__ */ g(Gr, {
        children: /* @__PURE__ */ g(y3, {
          setIsOpen: u
        })
      })
    })]
  });
}
function oA({
  setIsOpen: e
}) {
  const {
    t: n
  } = pe(), t = () => {
    e(!1);
  };
  return /* @__PURE__ */ P(he.div, {
    className: "flex flex-col items-center gap-4 p-4 text-center",
    layout: "position",
    children: [/* @__PURE__ */ g(Ee, {
      element: "h2",
      size: "lg",
      children: n("text_665c5f7f33803e00cc13e932")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: n("text_665c5f7f33803e00cc13e933")
    }), /* @__PURE__ */ g(Re, {
      name: "start_new_session",
      className: "mt-2 w-fit",
      onClick: t,
      children: n("text_665c5f7f33803e00cc13e934")
    })]
  });
}
async function sA(e) {
  try {
    const {
      data: n
    } = await M3(e);
    return n.amount && (n.amount = Math.floor(n.amount / 100)), n;
  } catch (n) {
    console.warn(n);
  }
  return {};
}
function aA(e) {
  return ["invoiceId", "amount", "issueDate", "deadlineDate", "debtorName", "filename", "invoiceUrl"].every((t) => t in e);
}
function iA({
  invoices: e
}) {
  const {
    state: n,
    actions: t
  } = ue(), r = dt(["automate_eligibility"]), {
    requester: o
  } = n, {
    kvkNumber: s
  } = o, [a, i] = K(), [c, l] = K([]), [u, d] = K(!1), [f, p] = K(!1), m = async ({
    invoiceId: h,
    amount: y,
    issueDate: C,
    deadlineDate: v,
    debtorName: w,
    debtorKvk: x,
    filename: D,
    invoiceUrl: k
  }) => {
    const M = await (await fetch(k)).blob(), T = new File([M], D), N = await sA(T), I = (V) => V ? "OCR" : "USER", O = (N == null ? void 0 : N.issueDate) === C, $ = (N == null ? void 0 : N.deadlineDate) === v, j = {
      invoiceId: I((N == null ? void 0 : N.invoiceId) === h),
      invoiceAmount: I((N == null ? void 0 : N.amount) === y),
      invoiceIssueDate: I(O),
      invoiceDeadlineDate: I($)
    }, F = {
      invoiceId: h,
      amount: y,
      issueDate: C,
      deadlineDate: v,
      debtorName: w,
      debtorType: x ? "B2B" : "B2C",
      debtorKvk: x,
      invoiceLineItems: N == null ? void 0 : N.lineItems,
      dataSource: j,
      thirtyDaysExtension: !1
    };
    try {
      const {
        data: V
      } = await N6({
        invoice: F,
        file: T
      }), {
        eligible: J,
        invoicesData: Q,
        message: X
      } = V;
      if (!J || X === "SBI_CODE_INVALID") {
        const fe = new Set(c);
        fe.add(h), l([...fe]);
        return;
      }
      const me = Q[h];
      if (!me)
        return;
      const {
        preliminaryOffer: Me
      } = me, {
        interestCost: Be,
        interestRate: ve,
        invoiceAmount: Ae,
        loanAmount: Te
      } = Me, G = {
        id: h,
        interestCost: Be,
        interestRate: ve,
        invoiceAmount: Ae,
        file: T,
        loanAmount: Te,
        invoiceIban: N == null ? void 0 : N.invoiceIban,
        ...F
      };
      t({
        type: "add_invoice",
        payload: G
      });
    } catch {
      const V = new Set(c);
      V.add(h), l([...V]);
    }
  };
  return W(() => {
    if (!s)
      return;
    if (t({
      type: "set_is_loading",
      page: "automate_invoices",
      payload: !0
    }), !e || e.length === 0) {
      p(!0);
      return;
    }
    const h = {};
    (async () => {
      for (const v of e) {
        const w = [], {
          invoiceId: x,
          amount: D,
          issueDate: k,
          deadlineDate: _,
          debtorName: M,
          filename: T,
          invoiceUrl: N
        } = v;
        if ((!k || !_) && w.push("DATE"), x || w.push("INVOICE_ID"), D || w.push("AMOUNT"), M || w.push("DEBTOR_NAME"), T || w.push("FILENAME"), N || w.push("FILE"), w.length > 0) {
          const I = [.../* @__PURE__ */ new Set([...h.UNKNOWN_ID ?? [], ...w])];
          x ? h[x] = w : h.UNKNOWN_ID = I;
        }
        aA(v) && await m(v);
      }
      Object.keys(h).length > 0 && i(h), p(!0);
    })();
  }, [r]), W(() => {
    f && (t({
      type: "set_is_loading",
      page: "automate_invoices",
      payload: !1
    }), !(!a && c.length === 0) && d(!0));
  }, [f]), /* @__PURE__ */ g(qr, {
    onOpenChange: d,
    open: u,
    children: /* @__PURE__ */ g(Gr, {
      children: /* @__PURE__ */ g(oA, {
        setIsOpen: d
      })
    })
  });
}
function cA() {
  const {
    actions: e
  } = ue(), {
    t: n
  } = pe(), t = dt();
  return /* @__PURE__ */ g(Re, {
    className: "flex h-auto gap-1 p-0 text-sm font-light text-foreground fill-foreground hover:fill-primary disabled:fill-button-disabled",
    variant: "link",
    name: "support",
    disabled: t,
    onClick: () => {
      e({
        type: "set_page",
        payload: "faq"
      });
    },
    children: /* @__PURE__ */ P("div", {
      className: "flex items-center gap-1",
      children: [/* @__PURE__ */ g(Uo, {
        className: "fill-inherit"
      }), /* @__PURE__ */ g("span", {
        children: n("text_6600cda50861cc0108cb6cc2")
      })]
    })
  });
}
const lA = (e) => /* @__PURE__ */ b.createElement("svg", { width: 66, height: 12, viewBox: "0 0 66 12", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { clipPath: "url(#clip0_2669_7670)" }, /* @__PURE__ */ b.createElement("path", { d: "M21.5554 3.63941C20.7283 3.63941 20.1314 3.71413 19.6653 3.95454L20.3423 0H18.2622L16.2021 11.8124H18.0076L18.3309 11.2404C18.5179 11.4746 18.7576 11.6613 19.0304 11.7853C19.3033 11.9094 19.6015 11.9672 19.9009 11.9543C22.3974 11.9543 23.826 10.15 24.2167 7.81917C24.7132 4.94746 23.3146 3.63941 21.5554 3.63941ZM22.042 7.74357C21.7843 9.63367 20.8336 10.4805 19.7055 10.4805C18.999 10.4805 18.5927 9.9859 18.7282 9.21767L19.1194 6.78209C19.2696 5.87944 19.811 5.17286 20.7583 5.17286H20.7732C21.841 5.17286 22.295 5.8941 22.042 7.74357Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M13.2927 3.62402C10.9472 3.62402 9.92443 4.73689 9.92443 4.73689L10.646 5.95414C10.646 5.95414 11.4045 5.06703 12.9173 5.06703C13.7617 5.06703 13.7794 5.49575 13.6986 5.95414L13.5335 6.99193C10.5107 6.91615 8.96207 7.56249 8.6162 9.5478C8.33039 11.1719 9.54836 11.9548 10.9165 11.9548C11.623 11.9548 12.195 11.8488 12.8866 11.2469L12.9774 11.8122H14.7829L14.8065 11.6774L15.4248 8.13941L15.8041 5.96969C16.1047 4.22603 15.172 3.62402 13.2927 3.62402ZM11.5277 10.7036C10.7458 10.7036 10.4547 10.1675 10.5881 9.46354C10.7697 8.5079 11.4925 8.08995 13.3229 8.08995C12.9878 10.4664 12.6716 10.7038 11.5277 10.7038V10.7036Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M54.9083 3.62402C53.4644 3.62402 52.8965 4.25994 52.3553 4.80154L52.4083 3.80473L50.5911 3.81621L49.2266 11.8126H51.3286L52.0057 7.57857C52.2458 6.12037 53.2537 5.00733 54.2003 5.00733C55.2533 5.00733 55.2408 5.60916 55.0756 6.52647L54.1588 11.8131H56.2466L57.1943 6.28588C57.51 4.49647 56.8472 3.62402 54.9083 3.62402Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M62.5573 7.01857L65.9603 3.63953H63.5094L60.6928 6.62483L60.6516 6.61882L61.7795 0.00683594H59.735L57.6748 11.812H59.7502L59.9622 10.6306L60.3828 8.04417C61.4796 8.04417 62.0962 8.16517 62.5779 10.3446L62.9086 11.812H65.0283C65.0283 11.812 64.5018 9.57815 64.1559 8.70658C63.7943 7.78909 63.4 7.18356 62.5573 7.01857Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M46.357 3.62402C44.0115 3.62402 42.9888 4.73689 42.9888 4.73689L43.7105 5.95414C43.7105 5.95414 44.4689 5.06703 45.9818 5.06703C46.8262 5.06703 46.8437 5.49575 46.7629 5.95414L46.5978 6.99193C43.5752 6.91615 42.0266 7.56249 41.6807 9.5478C41.3947 11.1719 42.6129 11.9548 43.9808 11.9548C44.6874 11.9548 45.2595 11.8488 45.9509 11.2471L46.0419 11.8124H47.8474L47.8709 11.6776L48.4891 8.13959L48.8685 5.96987C49.1692 4.22603 48.2365 3.62402 46.357 3.62402ZM44.5922 10.7036C43.8101 10.7036 43.5192 10.1675 43.6526 9.46354C43.8342 8.5079 44.557 8.08995 46.3874 8.08995C46.0523 10.4664 45.7359 10.7038 44.5922 10.7038V10.7036Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M38.5739 3.63941C37.7469 3.63941 37.15 3.71413 36.6838 3.95454L37.3611 0H35.2809L33.2207 11.8124H35.0262L35.3496 11.2404C35.5366 11.4746 35.7763 11.6613 36.0491 11.7854C36.322 11.9094 36.6202 11.9673 36.9196 11.9543C39.4162 11.9543 40.8447 10.15 41.2352 7.81917C41.7318 4.94746 40.3331 3.63941 38.5739 3.63941ZM39.0607 7.74357C38.803 9.63367 37.8523 10.4805 36.7241 10.4805C36.0175 10.4805 35.6112 9.9859 35.7467 9.21767L36.1382 6.78209C36.2883 5.87944 36.8296 5.17286 37.7771 5.17286H37.7917C38.8597 5.17286 39.313 5.8941 39.0607 7.74357Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M8.4505 4.18103C8.99139 1.98516 8.01419 0.270825 5.2179 0.301031L2.01198 0.297852L0 11.8126H2.08918L2.91605 7.18805C4.84306 7.13506 5.07747 7.60458 5.44101 9.84903L5.77151 11.8126H7.93912C7.68351 10.6249 7.51782 9.50351 7.30761 8.60139C7.08221 7.65369 6.73087 6.91284 5.82804 6.56132L5.93402 6.53729C6.5258 6.40533 7.07138 6.11715 7.51397 5.70274C7.95655 5.28833 8.27995 4.76286 8.4505 4.18103ZM4.40534 5.53466H3.17254L3.81111 1.89949L4.93192 1.89401C6.26187 1.89401 6.52084 2.7707 6.35567 3.79329C6.17479 4.81589 5.38307 5.53466 4.40516 5.53466H4.40534Z", fill: "current" }), /* @__PURE__ */ b.createElement("path", { d: "M29.9916 3.59375C26.7695 3.59375 25.4137 5.45399 25.0924 8.46066C24.8873 10.3804 26.064 12.0001 28.0516 12.0001C31.119 12.0001 32.3403 10.5219 32.8547 7.38189C33.1762 5.42026 32.3846 3.59375 29.9916 3.59375ZM30.6733 7.52869C30.2419 9.86428 29.2483 10.5366 28.4335 10.5366C27.3195 10.5366 27.0498 9.41649 27.2959 8.021C27.7002 5.73486 28.5976 5.08304 29.5592 5.08304C30.99 5.08304 30.8268 6.6974 30.6733 7.52869Z", fill: "current" })), /* @__PURE__ */ b.createElement("defs", null, /* @__PURE__ */ b.createElement("clipPath", { id: "clip0_2669_7670" }, /* @__PURE__ */ b.createElement("rect", { width: 65.9605, height: 12, fill: "white" }))));
function uA() {
  const {
    t: e
  } = pe();
  return /* @__PURE__ */ P("div", {
    className: "flex items-center gap-1 whitespace-nowrap",
    children: [/* @__PURE__ */ g(oe, {
      className: "text-foreground/40 font-['Manrope'] text-[0.9rem] leading-[1.5rem]",
      size: "sm",
      weight: "light",
      children: e("text_65f0d89e6fca7d7a5f9dfe01")
    }), /* @__PURE__ */ g(lA, {
      className: "w-fit h-[12px] mb-0.5 fill-foreground/50 shrink-0"
    })]
  });
}
function dA() {
  const {
    state: e,
    actions: n
  } = ue(), {
    previousPage: t
  } = e, {
    t: r
  } = pe();
  return /* @__PURE__ */ g(Re, {
    className: "text-sm font-light text-foreground",
    onClick: () => {
      t && n({
        type: "set_page",
        payload: t
      });
    },
    variant: "link",
    size: "icon",
    name: "close_faq",
    children: /* @__PURE__ */ g("span", {
      children: r("text_665d01dcce70a100a23b0d52")
    })
  });
}
function fA({
  children: e,
  showCross: n,
  showCloseButton: t
}) {
  const {
    state: r
  } = ue(), {
    flowFinished: o
  } = r, s = () => {
    ht(o);
  };
  return /* @__PURE__ */ P(he.div, {
    className: "sticky top-0 flex flex-col w-full p-6 gap-3 bg-navigation-bar z-40",
    layout: "position",
    children: [t && /* @__PURE__ */ g(Re, {
      onClick: s,
      name: "close_button",
      variant: "ghost",
      size: "icon",
      className: "self-end font-light text-foreground",
      children: /* @__PURE__ */ g(U6, {
        className: "size-5"
      })
    }), /* @__PURE__ */ P("div", {
      className: "flex items-center justify-between gap-4",
      children: [/* @__PURE__ */ g(uA, {}), /* @__PURE__ */ g(kt, {
        mode: "wait",
        children: /* @__PURE__ */ g(he.div, {
          className: "flex justify-center",
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          exit: {
            opacity: 0
          },
          transition: Ce,
          children: n ? /* @__PURE__ */ g(dA, {}) : /* @__PURE__ */ g(cA, {})
        }, n ? "open" : "close")
      })]
    }), e]
  });
}
const Hh = "Progress", fc = 100, [pA, dN] = Xo(Hh), [hA, mA] = pA(Hh), Uh = /* @__PURE__ */ xe((e, n) => {
  const { __scopeProgress: t, value: r, max: o, getValueLabel: s = vA, ...a } = e, i = f1(o) ? o : fc, c = Zh(r, i) ? r : null, l = Pi(c) ? s(c, i) : void 0;
  return /* @__PURE__ */ le(hA, {
    scope: t,
    value: c,
    max: i
  }, /* @__PURE__ */ le(Gt.div, Ie({
    "aria-valuemax": i,
    "aria-valuemin": 0,
    "aria-valuenow": Pi(c) ? c : void 0,
    "aria-valuetext": l,
    role: "progressbar",
    "data-state": Wh(c, i),
    "data-value": c ?? void 0,
    "data-max": i
  }, a, {
    ref: n
  })));
});
Uh.propTypes = {
  max(e, n, t) {
    const r = e[n], o = String(r);
    return r && !f1(r) ? new Error(bA(o, t)) : null;
  },
  value(e, n, t) {
    const r = e[n], o = String(r), s = f1(e.max) ? e.max : fc;
    return r != null && !Zh(r, s) ? new Error(CA(o, t)) : null;
  }
};
const gA = "ProgressIndicator", yA = /* @__PURE__ */ xe((e, n) => {
  var t;
  const { __scopeProgress: r, ...o } = e, s = mA(gA, r);
  return /* @__PURE__ */ le(Gt.div, Ie({
    "data-state": Wh(s.value, s.max),
    "data-value": (t = s.value) !== null && t !== void 0 ? t : void 0,
    "data-max": s.max
  }, o, {
    ref: n
  }));
});
function vA(e, n) {
  return `${Math.round(e / n * 100)}%`;
}
function Wh(e, n) {
  return e == null ? "indeterminate" : e === n ? "complete" : "loading";
}
function Pi(e) {
  return typeof e == "number";
}
function f1(e) {
  return Pi(e) && !isNaN(e) && e > 0;
}
function Zh(e, n) {
  return Pi(e) && !isNaN(e) && e <= n && e >= 0;
}
function bA(e, n) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${n}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${fc}\`.`;
}
function CA(e, n) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${n}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${fc} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const wA = Uh, xA = yA, DA = xe(({
  className: e,
  value: n,
  ...t
}, r) => {
  const o = 100 - (n ?? 0);
  return /* @__PURE__ */ g(wA, {
    className: te("relative h-1 w-full overflow-hidden rounded-full bg-border/20", e),
    ref: r,
    ...t,
    children: /* @__PURE__ */ g(xA, {
      className: "h-full w-full flex-1 bg-primary transition-all ease-out duration-300",
      style: {
        transform: `translateX(-${o}%)`
      }
    })
  });
}), Co = {
  name: "Dimensio Verpakkingen B.V.",
  kvkNumber: "33236408"
}, Ga = {
  name: "Hoveniersbedrijf Nieland B.V.",
  kvkNumber: "02034426"
}, SA = 5, Jf = 365;
function jr(e) {
  const n = /* @__PURE__ */ new Date();
  return e === "past" && n.setDate(n.getDate() - Jf / 2), e === "near_future" && n.setDate(n.getDate() + SA), e === "future" && n.setDate(n.getDate() + Jf / 2), Gn(n) ?? "";
}
jr("past"), Co.name, Co.name, jr("near_future"), Co.name, Co.name, jr("future"), Co.name, Co.name;
function fN({
  issueDate: e,
  period: n,
  invoiceId: t = "",
  amount: r,
  debtorName: o = "",
  debtorKvk: s = "",
  companyName: a = "",
  companyKvk: i = ""
}) {
  const c = new Date(e), l = {
    requestId: t,
    invoiceId: t,
    amount: r,
    issueDate: "",
    deadlineDate: "",
    debtorName: o,
    debtorKvk: s,
    companyName: a,
    companyKvk: i
  };
  if (e && (l.issueDate = Gn(c)), n != null) {
    const u = new Date(e);
    u.setDate(c.getDate() + n), l.deadlineDate = Gn(u);
  }
  return l;
}
function pN(e = "Invoice A", n = "B2C") {
  return {
    eligible: !0,
    totalInvoiceAmount: 1e4,
    totalInterestCost: 120,
    totalLoanAmount: 9880,
    message: "[]",
    invoicesData: {
      [e]: {
        invoiceAmount: 1e4,
        invoiceIssueDate: "2023-01-01",
        invoiceDeadlineDate: "2023-01-31",
        debtorName: Ga.name,
        debtorType: n,
        preliminaryOffer: {
          duration: 30,
          interestCost: 120,
          interestRate: 0.012,
          invoiceAmount: 1e4,
          loanAmount: 9880
        }
      }
    }
  };
}
new File([], "invoice_a.pdf"), jr(), jr("near_future"), Ga.name, new File([], "invoice_b.pdf"), jr(), jr("past"), Ga.kvkNumber, Ga.name;
const EA = "data:application/pdf;base64,JVBERi0xLjQKMSAwIG9iago8PAovVGl0bGUgKP7/ADIAMAAyADMALQAwADAAMAAwADIAMykKL0NyZWF0b3IgKP7/AHcAawBoAHQAbQBsAHQAbwBwAGQAZgAgADAALgAxADIALgA1KQovUHJvZHVjZXIgKP7/AFEAdAAgADQALgA4AC4ANykKL0NyZWF0aW9uRGF0ZSAoRDoyMDIzMTIwMTEwNDYyMSswMScwMCcpCj4+CmVuZG9iagozIDAgb2JqCjw8Ci9UeXBlIC9FeHRHU3RhdGUKL1NBIHRydWUKL1NNIDAuMDIKL2NhIDEuMAovQ0EgMS4wCi9BSVMgZmFsc2UKL1NNYXNrIC9Ob25lPj4KZW5kb2JqCjQgMCBvYmoKWy9QYXR0ZXJuIC9EZXZpY2VSR0JdCmVuZG9iago3IDAgb2JqCjw8Ci9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKNSAwIG9iago8PAovVHlwZSAvUGFnZQovUGFyZW50IDIgMCBSCi9Db250ZW50cyA4IDAgUgovUmVzb3VyY2VzIDEwIDAgUgovQW5ub3RzIDExIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQo+PgplbmRvYmoKMTAgMCBvYmoKPDwKL0NvbG9yU3BhY2UgPDwKL1BDU3AgNCAwIFIKL0NTcCAvRGV2aWNlUkdCCi9DU3BnIC9EZXZpY2VHcmF5Cj4+Ci9FeHRHU3RhdGUgPDwKL0dTYSAzIDAgUgo+PgovUGF0dGVybiA8PAo+PgovRm9udCA8PAovRjYgNiAwIFIKPj4KL1hPYmplY3QgPDwKPj4KPj4KZW5kb2JqCjExIDAgb2JqClsgXQplbmRvYmoKOCAwIG9iago8PAovTGVuZ3RoIDkgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCj4+CnN0cmVhbQp4nO1cW29bNwx+9684zwOqiNQdCAIkTjpgwAYEMdCHYQ9F2m4o2qJdO2w/f7oenxt9Oc5JjhM3aCybRxRFUh8pic7Zz3dvqz+/V2fLu6/VfX5d3i04Q8nTvyr8vGp/IB1n6W11/3nxrfq2uF3c+t/lNTzzeYHSON/4lBpgufFtvm4E0l+LNz9VX3zHIgHEn+/3XxZnSbb4YOJgnKz+fr/4MMXDuO1hiJNBQGg8frtIk+XV3fI33/q3wuoX//9j9fsf/sN3Y/WBaCvju0jnqkAMr8BF6Aum2bKlAcyhcc5PGjG3he+aGN0HvlHNRyRseHIXtqbpRlvmt/YzzqxFodBJCG1nuXAIKrYlgNHStMyfRkKLldPF9snlx3I8eKk80oCT+eL4eezkx9M4+w4uNpkPJgsILWsfHMvJ6mAQIw5m5IT2jJRUB3MCacGzksgPZ+U4xMVqGot1IuwDm1YHooK4PHzDMG6QY3R5je31EN5bvwhSKy8ez6PRzIA2HV5PKnODu8bMfVu3ybE7DmXky8Puid3zBOHMKW01Ghkm6/w8ufKqiG1urBQgemlE0GUzkRjLqwRiKczBvAKOB17DSL4fr4jkUbBBLN+TWcDypLHDZ1m7cgsKmtZEXu9yiHZrA7HD84QTjR/0arU4e60rv9JWH/weJW7P0svKLwNvx1faVat31bnvCBfV6uMCFRNG5b1bpmCiIOMu0tYUkSjAUCuNqkGRpQ86bU2ToiIF0NtDQKuPThTOIDLbqY+JlJuVt838NKw8PjY0bIuG0yQas3CJ4n3RO2JLW5eF4n20PfOrpBPHhOxYZZkompmu7mkNX9c2lg9gr5viFyD5kF/M1F4BDxr2ej1nWQFQNoQFnlSuGdi4fndZimMWXFKKYxYt7OpCYxySdm96sczEYEINGkxw1TQYZEUmlTQmCFimbnhb+SAoRUIysmWoioxtpVgmHG+rGFQZR3eUD7rGddFWMSS8BctMx/xg56F8YrVobAa7PI3gq9AJXDR00WuCDIOQfNWnzT0vnrevGjz56pPlZeHpnXyV9jtRq8uAHcDIIfymUZpO8+g14Wat4pD6glZFXZd1iEzRcwd1ZRXPdIKAWrRmeEXNEJYkRea5Zx9qUK7JPmMoN3kcuTe3uWpf25P2nxA/hWlpn9Yxue5HaWUmIZ3QCvKWVuaSgGwAaKHhKIR1SjWFxbwVk/1oQp6kIIzYf0+Sqnbmdnb39e2X6vy8Oru8//HP20+r9//9qM4vqouL6up66acumDOB1bPRwM2vy7k6Wooraz0/07iypw96rUBywhegmzl7p0N+PKAdI4xU5iiEjRFmLeyjZTTbch0BzLoO8tI7poTJKBjvnH+XPbxktnP3ALM+3wcDbbuQmIM4Ao1eUM6esONYlmPEDqXEUQgbsWMt7GMffY7PJ59M5jnH2JgBNjTzoFnObFDqgAzw2etmzt4ZUXwYGHes0vmWbQ+RsRA2VI3Xwsafbll2mxvv1/wkPrnuJ73JtT8IhseSn7pRyHX9z0OKs6l0fXCk8EEqUgof5BqUJ+axLovbop09Pesp3TnkHUNgK7y/qHpHmRBAYK8WA1NEkbZ3jZ1PNQTv3VuVa2zHoHNFg5LqQ1PGcMurE0TvkghT7BSqfy1Pj6PJcbBQuphKcyt1L4Y57FByXLe9HMCDaefWsFxp7RtNhGEqmPhk/OM3/pzDZcQXAF20mNNczdLOua+rfs0L1tU9vWNTuk6GvOndUK8wotQPZ13slbVvypYT6/K8XJew1gp5cEH3oY9B0JGHBOThzQYKmZYifRhBS0D3uZyHLYlIHRI7Y7AImxxcyJJe7wAXeF2AqreTpCGMBioaXm9KIOm5zJhx9gBEOlBtgOJxEdTkAKpOVpnQKnMObWFBWlFj6/OMbEOyzfosMJnF2ecQiuhqrSdX/oYgBV7mMo+MRpLp4Sp5AfUnghes6ZV30wmwLvzTmmtQrurl2L29oTHn9aGR4NinPgu4HXYtodv6zUeSgvdmCdckhewjgKRgwc5eWS49zsNStkm9p8MKLYYc9qTQWuoZL4O8pWuY7ZKaDJ0K5q9pCcVUkWU7QtCoQo4ziUsdcNT1ktU2C5+WYpNP1+cUQpQzB0lcbCIT3SzblIy5a5y8/RCaCbRDFfxDl66ynIeIrtlUMZvqfl0xG5T3ZMOaWy9WY03pOg4pm5BlHDn87bABCbIT+HG6eX4pp+lTaG7la56697WTDRq9KvbpfSuDHKdcOw5IfU1SyD4H4Efc/Z5c9OSij+OiNVaXG+WHvaHtP0DeT8c/GHH49XRk87n1xyhi2y8dFe+k60amDtxNHyzKrlfTZaDwPl2hS9jvUnkKDj5E1pfSXad4ANVs9onqdvE/U+GjrgplbmRzdHJlYW0KZW5kb2JqCjkgMCBvYmoKMTc4NAplbmRvYmoKMTIgMCBvYmoKPDwgL1R5cGUgL0ZvbnREZXNjcmlwdG9yCi9Gb250TmFtZSAvUU1BQUFBK0RJTk5leHRMVFByby1SZWd1bGFyCi9GbGFncyA0IAovRm9udEJCb3ggWy0xNTkgLTIxMyAxMDA4IDkxNyBdCi9JdGFsaWNBbmdsZSAwIAovQXNjZW50IDkxNyAKL0Rlc2NlbnQgLTIxMyAKL0NhcEhlaWdodCA5MTcgCi9TdGVtViA1MCAKL0ZvbnRGaWxlMiAxMyAwIFIKPj4KZW5kb2JqCjEzIDAgb2JqCjw8Ci9MZW5ndGgxIDE5NTY0IAovTGVuZ3RoIDE2IDAgUgovRmlsdGVyIC9GbGF0ZURlY29kZQo+PgpzdHJlYW0KeJytewt8VNW571ozk0lIZvKa2UmQKjsEiEgIeRIQCBASSAIECgERFdgzsyfZZGb2sPeehIBUEZD6QHxQFa0iHOqh/Kin9lpPr7W11T7s/R1rbeu1Httfb4+3b9t6aqtWyOZ+31przyOJ1p5zsZNZs/fa3/oe/++11i6hhJACcjNxE7J+0/ymI21DKly5Ez47B2Kj0b+d/OvtMH6LkMp/G1SViLqwZwchVV+BawsG4ULh4fxvw++34ffMwbi150f/Z+qLhEwNwu8fx/Sw8uipM+Xw+zfwOxZX9iTJYgLPX9YPv+WEElff/HH7BfhtEdL4PnHRL9K7SR4hrttdW2HGGtezLlid/ow0kQ/galGe2+Vy57ncjxEyfwORryPi39qevvVkOZEveNyfuTSXvOj+DHlVJuRhvEd/7jqLqxEP/Af/3K/k7SZFpIosJT2EtJa1NFc3SWXBmuoZbd626oq2stkwrCyjM9paZ7e1LWhtqZ1dMyPfW1s7u21B24LmisoKKZif75WkYE1NfmtLc3MTG84Ius9K0sWtwQgtdv3JR6lvrKyY0lUSpXOuWzSjekG8Ki+4RvIEVnQMah0rO7bWBDdMk64PBq+XgnndkvTBV4JxmF/secDnu6DRmNTYtWDvqo6WGXJCcvndge1tC+jyFcrOtfvq2mZKb0QkKSKBSsjeS6c9z+YdIZ8gLYTkzaidXTs74GKcyoGKstJ8b35lRT6y761taqtFiSor4fZsLlWlt7LCNfrk6L6W2ZTObtk3+iRNxGfNCsy4x+fbVlZ8bO+XB3oe9PmuK/HfXXgFpVd0/vL/rpQplVdWbuo/qdPL6DT95KZN9ld1+5f2r/SFi4/5S3cWFx/tPzf3IV9ZyOe75xM7331358svs7+EkhOXfus+634VrEGqa2a0ttZ4a4Dl1rLZbc0VUpm3uQkUXtbCfgTd9x0Mujb/66lrt1HpoET/PbJkafCgFLzh02rknEsNUBoY+9bFjuVJ1yocX9wUBG0MA/0j7rfIbNRG1gptLaCQ5qZWtGZt2ppoyzLvLFy0taWG6SPoNkcl14Yffmbb9TQc/p8/9zU3H74zFJiysMC370c/uHYrtcNGZ4fv2zddvZgGtxxYu/bYA+vW+FdrdXPpqpKyHaW+nZSuXffU2HBwf3Pztrhv9uxND4PcgED3s8CXkLusBZlA1LEfKK/ULPgBHB2U3lDb26WDQZDXtfEbJ7ddF3S1/412rIiPfSUYdH8B5b3uMKUR9Z/HToCrUdJ76V3XrLxCMg8wwDWK8oBUbSC0o9BmXAaXhHFlRRsDrqt0zbEl7b6NweBGHyzof1iSHvZf/onOuVJhR8e9rkZ/MBygPirhkvbvfTQQDvrHXl09bRqVRoKIvzOw/FbmUZUwYmuCoislrzstWlmQdt4ZDN4JNKqYTJ4vSZ+R4H8X+oQwaDyQYp59zP1PgI4rCAnUMP9DQLS1UYRHJW0OLIDvfOrN9/6yFfxKmrV05szqavsBb+WxsgLq8ryXX35HRZ69f8WKTvuYNBKg8vTN29xnGFQWu76N3xfeObe0Hfk+T4jnAPBdTC4npA2jAPcXVzUGgmYIBAvaXAAWiAXnJfoqVZVZsxT7YXuu9DQtpmRs+Sco/cTysUukmKL/2q8Z9n/Yv0jarz3to8998hIlG75O/bBODBB5HixfQxoc/0Qw8kiCsQSijQRe2FyBnlmR76XVTa2OdwZdlQ9EonOq6RVzopG7jkbVOdMrxu7z0bLFX3tkR2lxf4nvVnsq/a6P+lu/8ERzCa1c1XVz9N6TW2/q6qJdq/Zvf0bydbSeo4lS31p/6VnXFv/KuQ89NHelH3S95dJv3IeBr0bOFcaFCuZ+6CG1M1uFf2DoYB4jAWQqOcfA4wdvnSsu7i8uueULgwvbrrwyodlv0NCOL/yve0t9XcUl+45ua2yYO3coel9v74BWedxfus3v3z3nyq6l8nR/4fR379zQR2msqHxrSdF6OmvW0iXT5cKi4tWr99x3zbWIgzjobBB4mwM4SOuKc8J4wajVhsjgGqthWo1fMWcgevSNVGHptjLfvPnzu881VlJa2Xiue/78eb6ybaWFqTeORgfmXEHfOh5GBX2uzNfrK267bCp9qOvAoa6H6WVTF/qLev2lj3d13qwQ4bUNwMdljtcKR82w4w0AuJdxR+356ugG/xRQdO+6H1MBbPVu2lNSHCkvrqfU/o+xX2OMOgso/wVQnYry0ZwA4OHqrZ5RWxYMNGWSDwrsLPPJ79D83pqaXvu9F/rfPt1aUdF6+vNcUsB83uW46g1HKP199Ikno2/dbjdK9IP7O2+7pff48c5PH11+P2GY/J37KeBAIjMJmeVhmGTZra3CsfAsT87q7jx7HwMirZ49GD12dzRaW109Z+xNGm+pqGg5d64ZGZjf1dX1KeXE8fD+VV0U8Rc+fkL5VKjv4Z6bb+x96KHeG2/uQa2euvRbzz7wvMsF8spYwMCQxMP/bEypZcCD69hvbzlIg3cFaH//sbv6+6l0VLrlYOXhQ++4RyDV3vG5rddcs/Vz7hSMb3vn0GGkffOlfvpO3lukDGi7Aq4ABv18V1lpoALCHk39ldK/+oOrKwqff76wYnXwQWrRb9EXqCVJ9l57vb3O3sfiEMaGacBhjYgMGCgxEECCqsbQViPGLJxWzzgvubskaUzD9O1qZtHmJTZ+ADj7Kk/vByTqtwf8wQOSz94KYfSWIKwDvud+HOLd5Qxfte4atxfYbKMY75oqA83IPsQ7WuG+476A7w/uPxQF75nmo332y77LjldM+b77h4WB41OL7JfoBl85vc7+XHmQvkW/GaDl9vdpUzlE7GV2kEl0DP70k9chSpO2Vg43TATHJIz3UvBJZPpJNhMylOcGkD3AeeKs0GbKWfG69o+We+2lUyrvrPBS1UO3eoN3Sfn28oJgXmcVlS685GmWaNUHz7LcMBdo/QujBbmhDUkAKbRErbuaiUqr3TWN9M388sOSl/4sL3B30Ds09tJQQfndQRqhX3vD45RGQdpg/wCEc+1heQLoTge6lY5f1lR7Me84hoKk7orfFfTbhyTJ/SIY96CPBj2P+ymYgVniwjYm6yZAy3c5WirLy0rdiLzK8oCL8bb9hReKKrvLS96h9J2S8u7KB+lh+j/ok/RWoHenvdReYt+JNjxz6V36R+BFymRejl+AM8uw9PVVn1q0EDy3sqq5Vipsb7/VA8XbhceXVFVhCqXkP0FVj3GNzyqryffyupMTQR39xfMb8K6St0vK9klYE3gOnS6Z9mCp7wk/agbluB7i5QWoAdcDBSeNVMvu2a2iCOCVT6YgaGkrr5ZFCKvxYmwHLFfmI64lHDeJcRCLwxMbp5Tr/nzDfs/+wXXTfFskaYuP/512HW2gU4x8v14+ZeOJJ5olH/10gAbzi+2jPh/dwYdP+6Tm2+jDpd62KeV/plM3ftYX3CL5dJ+0BeqKY5to1X8G89sKyk/Qx5bsB78Q94K+2xefBslOgoc8BZLNRNzOBgg5hatTjjexcEUdtzxNi+i7CqVXL4l8a3pe+f6A268NPPGloV1H7I2uauaaFcHgUEmx66YbUzvbl/6b5JnmLT8SUoaGPvdP58feRIu4yDHQ53dh1RIyHdadXVaK+gpUBFxQHcA3hqmyUs5HwPXE9Omb6ZW0dgvWx1vs1+2fbG48faqpoqLp1GmMy3+O0BANqbTAfl+1H7Ufjdjv0bl33NFJd9KdnfBtP2Y/hh56qYZ2g4f6YUXhoPmY2lqPScck/01+f4DVL89dXnq2uBx6JKik8x4DHv2gmxayjtwA+KOiPkIPmx3wZuI6qonH9fzaCpHjvSywV9KcKZVwVSTUNiZnplGgHe4roRqs8F18zV8eKnLl/fF3y5ZVlVFaVrWs/ZrNMC4trVr23lemFhZO3XxNVRGlRT7XYbw/tV3cpxRmLNt8TXv71P1V12yeWkipM9eVl0LxPrhDys9zvX7VVXPWND36aHPP3KuumtvT/OijTWvmJGtW1xw9OnMV9FQzjx6tmTm2rvnRR1r4jJZHHm3unQNP9VZ3d8+462hNd3fN0btAq9sg1/SBlhrTtZdT57TxOqcM64umCXWOJ4D5Z+PRI7duKPZdV1T21CvHNn2SdnScXGVHb7zx5Q+eYHXOucch03V2fXYlPUEPHa5sblzjLxvyF93dsWJo+6I2qWgBXfOMHqcH/KXJkqIBurQ9ekNbW7Cozf7S10wLKwHA2S/A81klwCMZc/ucSkAKtv3DlQALm3ZBpgzYEbwtpwigJAae9S6sfRXgbQbmBAGe6qZWJyGnW1tJ8vLgUQPB00ufL5BuqyiwO+luX/AQePFNknQTuO6hoO8vwd0+n/tlMHT5xdYiaGIl+7g/mAr6fxQM/sjPKyrvLKg8mibtgz6kKeKdETDkLT0YfCO8bHlwXIP0vS0u/eV/vn4bzW6TJu2YTpygNBz5POuaeG3+eLb+sVuUudPMggVFJJ/VlNswu++BxrT/Bfv93hpKa3ppwbc2SYckO3K2sQJydePZM6waag7uuP2t6JNPRH9P6RH6Pktjt92//OinO48f773lts77nS7kNlYL1Yl8y0oLrgEMxNwjKfYFFZwLUYh4Rs6UT7F/Z2OlETgqSfS95/fuobSn9yY6x+vJs1tGu1ZSurJr1P4q1iJB19W+sR8GERi6/tSdocicsS9PKShwvU/bl8Zj7UuhOun1MZ1Adfp4TnWao5NWp6P7r+kESlT6ckYtNzCffxNL1GzF8ArsGOjlMl6BsRLEMQdGN8q+zksHqwpdIwXSgWDw0NTCsUPSLbzauvCWJ8jrBk/ZhT+la7qv8arTqTgR8ej6lNck1M0Uf146GqCuDT7pbKHbXWD30Z+VTDsTKLRH30c9M/Jjc12vlVNQ39i7F79XWe76F/tV+1OwipvsB0S9DvGmGrq9dtG9tIqWj0VYDMGSiMUYZum4OtsFnU06Qu9fsODa1fUNNBZ/6unYLjp//qqtbQv27Pn6cyN7oAd1tS9d2h4KL22ntL1qdfeq3cYq+GeY9GBq27b5ntq+deqp3bq++5S6rq/WM3/bttTTBvxznVyxYtmO7cuXLVu+fccy+yf2/+7upbS3e3eyB2IraOqLIMg3QVNVUE3Qar7RJeAIgYCnFzqPvgF1rLRXkly/lqjHri4ovx3C5tM0/wnAIpTDNxX4LvSUI6IOgE5eY9XaLKYRVgfm00q+3yH0EHBltZ/eA9fTkFe6o2KK/aJn/o6zu43R0Wee2bPnr11dK40kSpk06H3Hz7nuKZHGnvNMpzRpPPOilTINesB+qae3tydl9XaDMGARtPsuVp/Nwj0hVs9XMEOkzVA9I4DtPuu6uXO5+QYAMwzfAPjD94d20Wc+uWJ5auTf7culF+jiZEcHXb7CsL+N7uUHe3Tt7ezo6NyL/oYooYpy/lc9nsrNmw88H1XdlXTJ4nBk8RK/rfrGHvaB2w1p7ctwh2CXvcd9H3jcLNIKQPWms1RbUxnGI7jQ2sJaM8f38r3upkwSx4RFfx3dvqPRV7KptCS+7z1X73fstdXVa+3v9EqHgwn96UewSXvks81VVc32KJ1T21Fc0u/3hyktMI7QPymnTob/4DjjxV2v7N7tarpv5Y17Vt1D6T1rjVTvfeg/eyGTNgGy0Ya4w1jOgpOoIQG8ZaXcgKz4BKXKj+GO4gAdPJGyluT590kF27/x065p07p++o3tBdI+f94SK3XCfpA2JuhUWqXT7p7uI8H8xUXSMy9ttD+wP9j40lcDUxZPKT/S08O9l4bYLlPae9O+mnZLUQ3PB7Ofgq4qq4OpYM0UL45cNSnoYE56K49C/HS2jE7liyQxtsz1zawdqVtFJbgYpc7UDhiG2QZVc3PTh20RSxxlDN23uYP7y72LnkusWA6N8WqzHXevFmvLli9dEn1ynrd8n5RXoQ2c+vKQdn4NxOLU8JfPxHVaGvBO90pf7OqKWatXUWlYWrZsKNS+9Fy5a7onuA/64QHt7Dd3eaqv23boadPcuBH43UlfcZ1zMT0FZvCWCAtjaJF59UtfCULrzHfuHM8IYp9bnck4widAw+kgz72C9mGe+dOLe/fs2fui/RzgnnYd6MaCrPuA/T2WZcAMhvHs13YbvrE/BV1vdCy3jI4Ovz3PB+s9AAq9HuzCdgoDfHuvArlzp0doUdDMZ5HVL4rvz0qui06DOlaV1amyz+/nLvn5jpIlf8VDjIn/7D3eWdDfUeJNX8KgwM4ICiABX/q+dxajlP2v1f0KaOYvZJ9nA3nIU0tGPNvIWdcR0ksvkjNwb57nIjnvmUri4LNb3N+F725y1tMHn2oSp29BpXk5Oe3qJgc8B8h592sEGlxyzHMTqfa8QeZ61pJ5cK/f1UbOeLaQP8Pnevg8Bp9j9DVyzLsI1nyGbGP0tpC49wVGO+55G9aE77zF8P1H+Gwh++HzRfgc8LwKvxeTXZ4jZJ+rGNZ8hcyH60fchWSn51lynv6FPAhyaeQb5G26hMbo5+nLrjzXItdh14/cle4O90H38/Df256AZ7XnRs89nn/1vJmXnzcnrzdvKO8n3oB3nVf1vp+/Ov9w/jcK8gu6C+4p+HHB2JSGKfdOeWbK3wp7Cx8p/Gnhn4uqipJFtxZ9vehXTKOtZDue5HCNT/h3BU2kr79Cz4gxJSWu+8XYRfJdT4uxm0x32WLsIUHQNx/nkVr3F8TYC9cviXE++aTnK2JcQPx5s8V4CqnIC4lxYeHsqa+LMSByZoMY+8ismcfF2O9+uW6bGBeT6Q27gBPqmQKMnmZc4ZiSK1zDYuwixa7HxdhN2l1fF2MPudJ9hRjnkT73DWLsheuvinE+Oe0JinEBuSyvUIynkLq8FjEuDG7PGxXjIlI/0+HBR3pndouxP//Rmc+IcTFpb7iKrCQ6SZJRYgACBsggsYhMPg+fJqhRGshCGM1L/1oEo7UwLwHPWPBMkqhwZTWJkxDphhpVJiPsv3roH3Jn1ZMw/IrDt0xWwN0YfGdWNNkvFb5V+B6GvxE2sx/uauxuFJ5OMN5MGEVhNEIU9owMVBVYRRbrycCLKugl4a8OtFKwOtKsY7PxigY0tPS1CFslDFzpjIcIXNPhWRnoGUA9AVejjDdD3B2BJyzgTgfaFps3yFZVyR62KspisnkGm2nBlQT8VuAu52oYxjG2TvQjtVpPyEo9OWpoA4OW/Hm5qaFhoTwPvxbJa7WEbo0mVXl1PNRdJ4+MjNTHxKX6sB6vl1fEYjJ70JQN1VSNYTVSL/cPaqYc1ROWbOpRa0QxVDmujMrwnBxSYV7S0COpsBqpk+N6RItqOIpoZjimm2pE1g3ZMpSEGVUNA36OaNagnrJka1CV1T1JWMWURwzNstSErCSB1LASk/VoLqsgUifpIX0gZR/TmMU00A9/NzDdkM6ePrlP3WPJa/vlDQZc2AjzBkDXMWZ1slEdSMUUGDSCfjg2FwMFpLkeRpy6Qxspc7rzxtNprAdFLsbz4cWwJK64th/Wm5em/7EpTf74FgYaE4yrM/Nns7uBbIIrOMar+N0EVwcZCMJs/rB4ogE+zeCKZItqmJqekDnbGzbJDQ2N9Q0NTYsHdSusJ4bhRkN988L/Ntsb4LYKE8y0J3H0I871LLRPFjvwmTCMHJGjaU/iz2Q8mftWBK7GGTNDzD8sdl0D7KeyqHDf0Jgfm+gTG2KqYiJcAYiypTMAZvzEVMMWKiqKcIU7DO6A24gaV4whWbEsQwul2BTApRZWTSD54T5IcuA72cxOxhdqAbndBHdSLKroWc92qqY2kJA3WamIpk/mAjzUKUw1nHAUfoWF2hRgRgPDjLKZGJKS8O0EpBC77ig5zOxrMpbCYj6GQVMol4ee1cyocRbgZBagBthMlV3X2G+ZGcgRzWTh0uG8EVqmVvgrky42F0PoIHsyyuRR2KoyWZcOgbFxc3g6GGJyoNxrQGEhFs6Rewz+PJwPCB65lCjzMNOWwyOXm8MVU4MuNMbh8gBcGWTXEkyLKtPzLqEPmV3h9LnfRZgunETgSGHkeM4DjC8O7kzg53NzuYoL/XPXURgXKnA03qZOSuEuNCwSxgh8Z6fJKxn4HGfjNDsYT2HQ4xym0S72a3Dc07LQaJLR0Rh1i9lCZRIMM7kwKVrsr0muhqu58QKt3wP3FZbgw+y3o5+VE3RXxyzmIClXK5x3SyAxASvEmUaNdEp0AkUut2oW/jKek6tJrpUmFjsnm839LMkksj40Bd/LZm1gklvsXorZEuWMsQCZCXP1k6bwQYZijmBuTRNoYAGAfDr60ISMYYFHneHREOWDg4mM1ji6J/pgtr64Z/DI0Qhl20KWQ7g1w4wXi/FQl6Y8KvgdZs+E2DzOCS+ZOMqTLOA7aODPOtFjmHFdl8N1duxwZMr1I24x1NNQWiNOysDkEGG0uJY5VnI9wikTVTY/xPDGo4OSlT5mCH3NYLqxBGbNrLXuYyE8xWiGRTRBrCfYfI0FdI60i2x+H3suDlc5z1jiboFPHTnOeBxk/jGYRptjv9yYO56+msVRz6Qxe1Oae9QeamdvlqT14jlu9Way4ENXHk+H4zrOvIjHalVEIothhcfCFENAYlL8KTlymhPoZxL/+JKAF/L8ee6LFsPfIPMnLMoH0ljFPBFlxbsTfSKM5wTTM7+fsbsTm0JMjzy3meNQk41RmbUVZjqG8FYildUUJCZokq+qMk3JWZkyszpvE3h2yo50uXyEJ9H/CKNhpTMR0lcEdVNk6Wjai1G+oZy4IrNogb4WSUuT8eYY80QstXBUl5ZFSfsXt9SIsGF2tOf2ykTbie1WRrZRwlusCMk0aZqQK5HGRjYicm0yuS2yowSPPRbDgMqilhMJHX51QdsQeLMEXhBHCovno4Q3fZp4mq+C0c5gqDdF6ckzibPiIKtqOKrq0pFTSdt7op84CDPTWUERDbEuqOYibDSNu2xsZTSmA0VeImdqG0fqXH/hVjByMhfnWks3zmFBJTunaiLaq8x6KYYNxyrI4xCb7+SxEdGO6+max7FqkkmqCnxnvH2AcZkUMXPyrOFINN7aDtqdXJ4toT7BxyKMqpauO4ZJbn/G+ZnMZhkvGmAy6ROQiZxhdsx4a0LETAexIeEJE6XTxOoZjIbZigkR+x2rcv2qDC/cX3VmH76hMbGmGGE6QL5H2KyJvsX9NsU0kp1F+gUnmfgsZ+ER65iQyAuyWD0q5idE1e1INb7+4nVVBgdOpTMovIHHwaRYNXuzZXJ/0kX7qYkKIcO9KWJoRo4Ikz5ji8n6jfG4dlaevGrPVOqZuOqgims0JrwD52BNilFnXroKw+gySngPEmGehvyvEt6tifpAEVqtE9HC2XrinjheJ/eKehJpZHuQowUebTCmOVHYweuAiGXZXV6mbnbqWUNg09Flps9xaJsMlTyHoJ54V+Joykpv6zmbeSrL3w52nS44wbKJY5Hx9frkUicZjxaTYJDFRidWIw/rsiJqlGRXK5nIymtaK+25k9c6hsjZKZFlnYrXEFuCXOt1JLcWDLP1nRyYwViSzY+KuDXedovTnGoMFeP1P8iycSTdRViTzBmPhhCzszVp58I1+f+vy8/WlxO5ne3X8TsXubWVw8NH1cmOlTIRnGc7p2J2bKvAX65r1M0uoWueHzZl9UsftS/jxIDsGJrpoUzhX7zD45VFJs9mUKJNqCJHs3TkoIPXHGa6PstGmSYs152D8Mm91tke//D6yfGITPbJ1VF23ad9LJqT7zeNt4SWrtHHr5+d/UZJ9UdGo0x3bbHKNSbiMK9STYZoBw08Zjtc/v26g1d0KYGCzF7ERNk457yyGEhny6F0JuS9Aa8ljazKxeEoxfCX2+ly/WT2qbC/dQ4cMqiZDG31WVvomikrMm5ARpWwKkeVuBYblbWEmdRwAz80yjZIwzHFNLUwXI+kTMvQlJi8WjXiSkJWEwNaQlUNLTEgR9gOplknI/HGltZGuSsxYIYHDS1qyUoiIq/Dnf+YuFIvrxjSDEVeo4eUUcUc1OSQOgAUYUlDHdZMpAhrm6psjegycmeODOrs//dlyruADTmuwvSwnoioCTx7wBUMvkcdUqO6wY4c4KIgFAfuLR2ETagjjpx4PiGb6rCakEdUfhJy5Vq2RQwzO2JKeGhOvdylhAfFbRnYTJpACAgaqioPK4amWppqXi2L3fE6ucdSYlq4jrGz0mGuTg6higQrQB0myYlUPKQaeP6BG9CCrCqnTSOYBFaaGuvlbIslFcPKPjcx5Q0xxdKAICwZi/Ht7frMscqgYoJ2QUozlUzGRpENDRYMgxb1uGqYXBGMM9B12nycLbAEIKNx0cKGepAyrCas2GgdTh4FusMqEA4DETmOGk/qSdQC3EVsDKugD0aaQwNXEhYCuRRzCBnBTXglEtGQZVCKsAMeRKmyEgohFhS2FT8D+JohmxYo1mRPdaopC8AE0vckTEuzUqCyk4bcpxvxFBBW67fUw/KDGpgPdIbSCdA601VGpicD6k1IXDEi2l6Fa7AnAYI3L8h+2JkDmo7HEdAqIMiyYoDAVBLYTGtP4Wuaznx2yuAcOSiGCvfBhJYaHkzoMX0AdWoo0SjDTiSuJTRgikuOUAqlwA6qKRTD9SmP4Bo6Hsyl2OlbwmESHlVVgCv6I3t8UIcZAnGCRjjN/4iSsNCBZFOB6SZ4cxQNrCWGOFLkET0Vi+AyzMgxdUALxdQ6XEVBa4FQIyAhxzzIxTCbPipkq43KES3CThHBC9VEJK0IIUmWFBwQgB1LM9W4ihBEujrMhht41dLCSgwQpIP3Mc6TKSOpmyoI1oegg5kxUFUdQlNBudM2QYWZ6AjwvKzDVKGwUdQd1xZjTB9JiEiDSwu7gAgGdy0grVmMelzETA1Aryb01MAgihJXhlTmYSMKUhYHUEklBkBRmdkHDCU5iCTTjoELOWKj2tHF+YK6Y7GINqBh4BgWB31AJyMZM9GAjoJwZSoRPWmJuMgUC5E1sxwEG67RsJ5KAPpRVOBXjcXArnpMi2jRdJwY0Y1YZESLpK0Ftk1ZwkWAMYPhWWZ6NFMh8AVgNRqF6xA52FJO8DJlpgKMOIMqBu84hDJxUJxlJjAsxEolxqiD/UbYEpEIFyKTMRxV48NZYZ0FdAZV1BTwCQwBE02NpjUP41fKGIXkEdGUenkVWBuyHfhoGACtxPC8GmzocAIxUje4eZADAE1S17izJAYAY3WZsIwx1gBdIpMs3eBsM4b+ERuFLII8WXi4jufqaoLpFnNvQo+gHE5Iz6ycVEyrDhx3BCFdL69jKI3ymMKQCkHWknPgjUyGIQyymAvMoKadEBhWEuh+TF9J1YgCsBzhFiNRzUizj/9fbZMRcq44WgipplWflXY+VqbnbCGw8XUBp6YQkQop5MZjlIiBG1wOgzIKqwwA04a+C5gGX9jEMlJuCYPm5+isE2WDAqkOAgXzV6YRLZH2duQItQFRw8RYxjWmgWzdXN9ZhsXXH3JiE9qBuY7giMc9beLMrHLJEUJLZD3PXW+0OhdELFFbihbT0TNUM6miGgDWSHJC3IAgB3bSWPmQXg2IQ6AYUJm1TWTNhAhpsMCChFKJsEi3wA+rpZQQvqfBVJNRG9SJg6xpS5KryXz47++9v0MGLSt59fz54981+UfpzE8fB0wsuj9sjfmYX9NqIexdj35oC1bBZyVZwcbrWZOwHq7J7H2QldC09kF710XwoHk12QijLmhV8Wo/8ZNC9rmWldXZB2A6295SxJGBs8nx999FUtNbVQbJ3Yx0Cn2Dyf9Rb/xk3j3SWSuRoZd9RDx+5Uj6AMR5dyK7vdaZHB921FkrtuQ0sS3Ft6axNXY09PHexMo0yvztphRrWWKiLTbFcdLHeedJJpvhnrOxLsOM8RZyNumdVi/3iD3T9jlb37nSyaxN48c2znGB0xAmiJXejHLWnfwoMvsNtrr07NxNCWeb6eNqD/nkh0Bq1uZXhjLf0h0S24IT37PJzHQOBjgvqFMH5+PfmAsT/h6Pg7zJsPTxpOAHkNFJLea0rLvhuiq2c5ytEX4o7BxpZuvemMR2ltg64VpPTnhbaZhtLo2QzLbSx7G+wzH3WPTkYZK7AZ29YThebsdTVjN6KkNS7CN5zz0icLYNct+KDBPnxRe+sczlcjZs+dbj34u0uRxMxqkqXmjgPrmXXd/L1nSswY+5VYEnznUfQ8Zecc8UehtMb89pxHkdhG+wqeJZKx3N/qucb0gjI8mijMkwW8vocD+Ij9t64y/28O3HhPBxWcgcFmg2hEaRUkps3WvpbXzuZRGGEH4kzTcZVWblCHFej3B45thEBKUYJVxrb3o1kx0nOZrg0hvE2Yq2iHNwEfpv6emjckwushwdKCxXZfB1dVYGUNnhCr4UNJe0kEXkStJA5pAFpJG0kSa42kIWwmcefBrxZcW+9f09q3pWrujvWd8nr18lr+1Z2dW3qUtesXpjV9e6rr5+f6G/8Fo9xfcY9BAURAlWWU94PVXVWDHFeyWsbgw9nvtGKXstVR9Q2Ty+5+M8HMEuG1/244WpnlCz91VqoV/RwriDA70lMjTJ27Gs+hxWYikF60jFNFVr4iut8uYEdqTyqCMQ9q1Y3ok9KVbkYYsplpOVAWjgsfnFii9hYbeAz2ZtlPA3d+vwsqiZo5NpR0MRoM9XWZfBJkM7N2Ty9o3VlOwidrxApV5GnTtv/Ib1JHbZWVqaZIl6uSeaEQxLyN0paBNY2W2oA7idwrk30tKB7HFgPem8pTmsQfWOTcFE8ZEwGFbVhkWbyBsgZ200ymoVKj7QSA510fZiESzecQ7j5iK0hLAW9m/WhDei5wsCGaLQDatgyb1qYm9IRTFSiQEozqEnkvtS1l74ZQJvg9i4aLjTB50JlP9o2o8mvgGVkYylTDlSqyXABnHRpoR16GyMBFgcGmX8hVtAMCkFPaxmcpNFUnJMH4DeSI1BGwAtDFIGbQ6rKQ343YuPmakYMgHLG9gtWthChz6ap1yPEcpCDpQw63etq5kDqLH6q+W5LYuubJizoLGtSW5Z2DKvpXHhP17h50alD63qBYvk/wHPPMGmCmVuZHN0cmVhbQplbmRvYmoKMTYgMCBvYmoKOTc5NQplbmRvYmoKMTQgMCBvYmoKPDwgL1R5cGUgL0ZvbnQKL1N1YnR5cGUgL0NJREZvbnRUeXBlMgovQmFzZUZvbnQgL0RJTk5leHRMVFByby1SZWd1bGFyCi9DSURTeXN0ZW1JbmZvIDw8IC9SZWdpc3RyeSAoQWRvYmUpIC9PcmRlcmluZyAoSWRlbnRpdHkpIC9TdXBwbGVtZW50IDAgPj4KL0ZvbnREZXNjcmlwdG9yIDEyIDAgUgovQ0lEVG9HSURNYXAgL0lkZW50aXR5Ci9XIFswIFs0NzMgNjE0IDUzNSA1MTUgNTQwIDMxMyAyNDYgNDczIDYxOCA1MDggNDg2IDQ2OCA0MDcgNTM0IDUxMiAyMzggNjM0IDI4MyA1NTggNDc2IDIzNCA1NTggNjAyIDUzMyAyODMgMjc1IDUzOCA1MzggNTM4IDUzOCAyMjggNzcyIDU4NiA1MzQgNTM4IDgzOCA1MzQgNjEyIDUzNCA2NDkgNjExIDUzOCA1MzggNTM4IDU5OSA1MjUgNTYxIDI1NSA0NzMgNTM4IDM3NyA1ODcgMjQyIF0KXQo+PgplbmRvYmoKMTUgMCBvYmoKPDwgL0xlbmd0aCA3MjggPj4Kc3RyZWFtCi9DSURJbml0IC9Qcm9jU2V0IGZpbmRyZXNvdXJjZSBiZWdpbgoxMiBkaWN0IGJlZ2luCmJlZ2luY21hcAovQ0lEU3lzdGVtSW5mbyA8PCAvUmVnaXN0cnkgKEFkb2JlKSAvT3JkZXJpbmcgKFVDUykgL1N1cHBsZW1lbnQgMCA+PiBkZWYKL0NNYXBOYW1lIC9BZG9iZS1JZGVudGl0eS1VQ1MgZGVmCi9DTWFwVHlwZSAyIGRlZgoxIGJlZ2luY29kZXNwYWNlcmFuZ2UKPDAwMDA+IDxGRkZGPgplbmRjb2Rlc3BhY2VyYW5nZQoyIGJlZ2luYmZyYW5nZQo8MDAwMD4gPDAwMDA+IDwwMDAwPgo8MDAwMT4gPDAwMzQ+IFs8MDA1MT4gPDAwNzU+IDwwMDYxPiA8MDA2RT4gPDAwNzQ+IDwwMDY5PiA8MDA3OT4gPDAwNDQ+IDwwMDY1PiA8MDA3Mz4gPDAwNjM+IDwwMDcyPiA8MDA3MD4gPDAwNkY+IDwwMDIwPiA8MDA1NT4gPDAwMjg+IDwwMDQ1PiA8MDA3OD4gPDAwMkU+IDwwMDU2PiA8MDA0MT4gPDAwNTQ+IDwwMDI5PiA8MDA2Qz4gPDAwMzE+IDwyMEFDPiA8MDAzMj4gPDAwMzA+IDwwMDJDPiA8MDAyNT4gPDAwNTM+IDwwMDYyPiA8MDAzND4gPDAwNkQ+IDwwMDY0PiA8MDA1Mj4gPDAwNzE+IDwwMDRFPiA8MDA0Qj4gPDAwMzg+IDwwMDM3PiA8MDAzNj4gPDAwNDI+IDwwMDY3PiA8MDA0Mz4gPDAwNDk+IDwwMDc2PiA8MDAzMz4gPDAwMkQ+IDwwMDUwPiA8MDAzQT4gXQplbmRiZnJhbmdlCmVuZGNtYXAKQ01hcE5hbWUgY3VycmVudGRpY3QgL0NNYXAgZGVmaW5lcmVzb3VyY2UgcG9wCmVuZAplbmQKCmVuZHN0cmVhbQplbmRvYmoKNiAwIG9iago8PCAvVHlwZSAvRm9udAovU3VidHlwZSAvVHlwZTAKL0Jhc2VGb250IC9ESU5OZXh0TFRQcm8tUmVndWxhcgovRW5jb2RpbmcgL0lkZW50aXR5LUgKL0Rlc2NlbmRhbnRGb250cyBbMTQgMCBSXQovVG9Vbmljb2RlIDE1IDAgUj4+CmVuZG9iagoyIDAgb2JqCjw8Ci9UeXBlIC9QYWdlcwovS2lkcyAKWwo1IDAgUgpdCi9Db3VudCAxCi9Qcm9jU2V0IFsvUERGIC9UZXh0IC9JbWFnZUIgL0ltYWdlQ10KPj4KZW5kb2JqCnhyZWYKMCAxNwowMDAwMDAwMDAwIDY1NTM1IGYgCjAwMDAwMDAwMDkgMDAwMDAgbiAKMDAwMDAxNDAzMCAwMDAwMCBuIAowMDAwMDAwMTg1IDAwMDAwIG4gCjAwMDAwMDAyODAgMDAwMDAgbiAKMDAwMDAwMDM2NiAwMDAwMCBuIAowMDAwMDEzODg0IDAwMDAwIG4gCjAwMDAwMDAzMTcgMDAwMDAgbiAKMDAwMDAwMDY3MiAwMDAwMCBuIAowMDAwMDAyNTMwIDAwMDAwIG4gCjAwMDAwMDA0ODYgMDAwMDAgbiAKMDAwMDAwMDY1MiAwMDAwMCBuIAowMDAwMDAyNTUwIDAwMDAwIG4gCjAwMDAwMDI3NjQgMDAwMDAgbiAKMDAwMDAxMjY3MiAwMDAwMCBuIAowMDAwMDEzMTA0IDAwMDAwIG4gCjAwMDAwMTI2NTEgMDAwMDAgbiAKdHJhaWxlcgo8PAovU2l6ZSAxNwovSW5mbyAxIDAgUgovUm9vdCA3IDAgUgo+PgpzdGFydHhyZWYKMTQxMjgKJSVFT0YK";
function _A({
  partnerId: e
}) {
  const n = `dls-authentication/v2/authentication/invfin/third-party/${e}/tokens`;
  return bt.post({
    path: n
  });
}
function MA(e = !0) {
  const {
    actions: n
  } = ue(), [t, r] = K(!1), [o, s] = K();
  return W(() => {
    if (!e)
      return;
    (async () => {
      if (!kn)
        throw new Error("Partner ID needs to be set to be able to continue");
      n({
        type: "set_is_loading",
        page: "authentication",
        payload: !0
      });
      try {
        const i = await _A({
          partnerId: kn
        }), {
          token: c,
          caseId: l
        } = i.data;
        Z1(i.headers["x-state-correlation-id"]), m6(c), h5(l), n({
          type: "set_case_id",
          payload: l
        }), r(!0);
      } catch (i) {
        const c = un(i);
        s(c);
      } finally {
        n({
          type: "set_is_loading",
          page: "authentication",
          payload: !1
        });
      }
    })();
  }, [e]), {
    isFinished: t,
    error: o
  };
}
const kA = () => {
  const [e, n] = K(!1);
  return W(() => {
    const t = (s) => (Z1(s.headers["x-state-correlation-id"]), s), r = (s) => {
      var a;
      return n(((a = s.response) == null ? void 0 : a.status) === 401), Promise.reject(s);
    }, o = Ze.interceptors.response.use(t, r);
    return () => Ze.interceptors.response.eject(o);
  }, []), {
    tokenExpired: e,
    setTokenExpired: n
  };
};
function AA() {
  const e = dt(), {
    t: n
  } = pe(), {
    state: t
  } = ue(), {
    flowFinished: r
  } = t, o = () => {
    ht(r);
  };
  return /* @__PURE__ */ P(he.div, {
    className: "flex flex-col items-center gap-4 p-4 text-center",
    layout: "position",
    children: [/* @__PURE__ */ g(Ee, {
      element: "h2",
      size: "lg",
      children: n("text_6600cda50861cc0108cb6c9a")
    }), /* @__PURE__ */ g(oe, {
      weight: "light",
      size: "sm",
      children: n("text_6600cda50861cc0108cb6c9b")
    }), /* @__PURE__ */ g(Re, {
      name: "start_new_session",
      className: "mt-2 w-fit",
      onClick: o,
      isLoading: e,
      children: n("text_6600cda50861cc0108cb6c9c")
    })]
  });
}
function NA({
  children: e
}) {
  const {
    state: n
  } = ue(), {
    flowFinished: t
  } = n, {
    tokenExpired: r,
    setTokenExpired: o
  } = kA(), {
    isFinished: s
  } = MA();
  return W(() => {
    s && _s("start");
  }, [s]), W(() => () => {
    ht(t);
  }, []), /* @__PURE__ */ P(Zo, {
    children: [e, /* @__PURE__ */ g(qr, {
      onOpenChange: o,
      open: r,
      children: /* @__PURE__ */ g(Gr, {
        onInteractOutside: (a) => a.preventDefault(),
        children: /* @__PURE__ */ g(AA, {})
      })
    })]
  });
}
const LA = {
  drawer: {
    initial: {
      opacity: 0,
      x: "100%"
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: "100%"
    }
  },
  base: {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }
};
function TA({
  kvkNumber: e,
  contactDetails: n,
  mode: t = "sandbox",
  campaignId: r,
  isModal: o,
  invoices: s
}) {
  const {
    onTransitionEnd: a
  } = Ui(), {
    state: i,
    actions: c
  } = ue(), {
    activePage: l
  } = i, u = t4.includes(l), d = Jk[l], f = _g(t), p = l === "faq", h = Math.max(vl.indexOf(l), 0) / (vl.length - 1) * 100, y = p ? "drawer" : "base", C = dt(["transition"]), v = Et(() => s == null ? void 0 : s.map((w) => {
    const x = kn === "EXACT", {
      invoiceId: D,
      filename: k
    } = w, _ = x ? EA : w.invoiceUrl, M = x ? `exact_${D}.pdf` : k;
    if (!M)
      return w;
    const N = H6(M).replace(/\s+/g, "_");
    return {
      ...w,
      filename: `${N}`,
      invoiceUrl: _
    };
  }), []);
  return W(() => {
    if (Wy(t === "production" ? "https://api.fund-r.nl" : "https://api.fundrstruck.nl"), m5(!1), m6(), Z1(), n) {
      const x = {
        email: n == null ? void 0 : n.email,
        phoneNumber: n == null ? void 0 : n.phone,
        name: n == null ? void 0 : n.name,
        surname: n == null ? void 0 : n.surname
      };
      c({
        type: "set_requester",
        payload: x
      });
    }
    r && c({
      type: "set_campaign_id",
      payload: r
    });
  }, []), f ? /* @__PURE__ */ P(NA, {
    children: [/* @__PURE__ */ g(rA, {
      kvkNumber: e
    }), /* @__PURE__ */ g(iA, {
      invoices: v
    }), /* @__PURE__ */ g(nA, {}), /* @__PURE__ */ g(fA, {
      showCross: p,
      showCloseButton: o,
      children: /* @__PURE__ */ P(kt, {
        mode: "wait",
        children: [u && /* @__PURE__ */ g(he.div, {
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          exit: {
            opacity: 0
          },
          transition: Ce,
          children: /* @__PURE__ */ g(DA, {
            value: h
          })
        }), !u && /* @__PURE__ */ g(he.div, {
          className: "hidden",
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          exit: {
            opacity: 0
          },
          transition: Ce
        }, l)]
      })
    }), /* @__PURE__ */ g(kt, {
      mode: "wait",
      children: /* @__PURE__ */ g(he.div, {
        className: "flex justify-center w-full flex-1 overflow-auto scrollbar-hide",
        variants: LA[y],
        initial: "initial",
        animate: "animate",
        exit: "exit",
        layoutId: C ? void 0 : l,
        transition: Ce,
        onAnimationComplete: a,
        children: /* @__PURE__ */ g(d, {})
      }, l)
    })]
  }) : /* @__PURE__ */ g("div", {
    children: "...loading"
  });
}
function PA(e) {
  return s4(["https://fonts.cdnfonts.com/css/manrope"]), /* @__PURE__ */ g(e4, {
    i18n: ot,
    children: /* @__PURE__ */ g(o4, {
      children: /* @__PURE__ */ g(Rm, {
        children: /* @__PURE__ */ g(TA, {
          ...e
        })
      })
    })
  });
}
const OA = "rabobank-ff", RA = N5(PA, {
  props: {
    mode: "string",
    contactDetails: "json",
    kvkNumber: "string",
    campaignId: "string",
    invoices: "json",
    isModal: "boolean"
  }
});
customElements.define(OA, RA);
function hN({
  identifier: e,
  partner: n
}) {
  g5(e), y5(n);
}
export {
  Ga as a,
  pN as b,
  fN as c,
  hN as i,
  Co as r,
  jA as s,
  YA as u
};
